/**
 * React v15.6.1
 */
(function (f) { if (typeof exports === "object" && typeof module !== "undefined") { module.exports = f() } else if (typeof define === "function" && define.amd) { define([], f) } else { var g; if (typeof window !== "undefined") { g = window } else if (typeof global !== "undefined") { g = global } else if (typeof self !== "undefined") { g = self } else { g = this } g.React = f() } })(function () {
    var define, module, exports; return (function e(t, n, r) { function s(o, u) { if (!n[o]) { if (!t[o]) { var a = typeof require == "function" && require; if (!u && a) return a(o, !0); if (i) return i(o, !0); var f = new Error("Cannot find module '" + o + "'"); throw f.code = "MODULE_NOT_FOUND", f } var l = n[o] = { exports: {} }; t[o][0].call(l.exports, function (e) { var n = t[o][1][e]; return s(n ? n : e) }, l, l.exports, e, t, n, r) } return n[o].exports } var i = typeof require == "function" && require; for (var o = 0; o < r.length; o++)s(r[o]); return s })({
        1: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            /**
             * Escape and wrap key so it is safe to use as a reactid
             *
             * @param {string} key to be escaped.
             * @return {string} the escaped key.
             */

            function escape(key) {
                var escapeRegex = /[=:]/g;
                var escaperLookup = {
                    '=': '=0',
                    ':': '=2'
                };
                var escapedString = ('' + key).replace(escapeRegex, function (match) {
                    return escaperLookup[match];
                });

                return '$' + escapedString;
            }

            /**
             * Unescape and unwrap key for human-readable display
             *
             * @param {string} key to unescape.
             * @return {string} the unescaped key.
             */
            function unescape(key) {
                var unescapeRegex = /(=0|=2)/g;
                var unescaperLookup = {
                    '=0': '=',
                    '=2': ':'
                };
                var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

                return ('' + keySubstring).replace(unescapeRegex, function (match) {
                    return unescaperLookup[match];
                });
            }

            var KeyEscapeUtils = {
                escape: escape,
                unescape: unescape
            };

            module.exports = KeyEscapeUtils;
        }, {}], 2: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            var _prodInvariant = _dereq_(25);

            var invariant = _dereq_(30);

            /**
             * Static poolers. Several custom versions for each potential number of
             * arguments. A completely generic pooler is easy to implement, but would
             * require accessing the `arguments` object. In each of these, `this` refers to
             * the Class itself, not an instance. If any others are needed, simply add them
             * here, or in their own files.
             */
            var oneArgumentPooler = function (copyFieldsFrom) {
                var Klass = this;
                if (Klass.instancePool.length) {
                    var instance = Klass.instancePool.pop();
                    Klass.call(instance, copyFieldsFrom);
                    return instance;
                } else {
                    return new Klass(copyFieldsFrom);
                }
            };

            var twoArgumentPooler = function (a1, a2) {
                var Klass = this;
                if (Klass.instancePool.length) {
                    var instance = Klass.instancePool.pop();
                    Klass.call(instance, a1, a2);
                    return instance;
                } else {
                    return new Klass(a1, a2);
                }
            };

            var threeArgumentPooler = function (a1, a2, a3) {
                var Klass = this;
                if (Klass.instancePool.length) {
                    var instance = Klass.instancePool.pop();
                    Klass.call(instance, a1, a2, a3);
                    return instance;
                } else {
                    return new Klass(a1, a2, a3);
                }
            };

            var fourArgumentPooler = function (a1, a2, a3, a4) {
                var Klass = this;
                if (Klass.instancePool.length) {
                    var instance = Klass.instancePool.pop();
                    Klass.call(instance, a1, a2, a3, a4);
                    return instance;
                } else {
                    return new Klass(a1, a2, a3, a4);
                }
            };

            var standardReleaser = function (instance) {
                var Klass = this;
                !(instance instanceof Klass) ? "development" !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
                instance.destructor();
                if (Klass.instancePool.length < Klass.poolSize) {
                    Klass.instancePool.push(instance);
                }
            };

            var DEFAULT_POOL_SIZE = 10;
            var DEFAULT_POOLER = oneArgumentPooler;

            /**
             * Augments `CopyConstructor` to be a poolable class, augmenting only the class
             * itself (statically) not adding any prototypical fields. Any CopyConstructor
             * you give this may have a `poolSize` property, and will look for a
             * prototypical `destructor` on instances.
             *
             * @param {Function} CopyConstructor Constructor that can be used to reset.
             * @param {Function} pooler Customizable pooler.
             */
            var addPoolingTo = function (CopyConstructor, pooler) {
                // Casting as any so that flow ignores the actual implementation and trusts
                // it to match the type we declared
                var NewKlass = CopyConstructor;
                NewKlass.instancePool = [];
                NewKlass.getPooled = pooler || DEFAULT_POOLER;
                if (!NewKlass.poolSize) {
                    NewKlass.poolSize = DEFAULT_POOL_SIZE;
                }
                NewKlass.release = standardReleaser;
                return NewKlass;
            };

            var PooledClass = {
                addPoolingTo: addPoolingTo,
                oneArgumentPooler: oneArgumentPooler,
                twoArgumentPooler: twoArgumentPooler,
                threeArgumentPooler: threeArgumentPooler,
                fourArgumentPooler: fourArgumentPooler
            };

            module.exports = PooledClass;
        }, { "25": 25, "30": 30 }], 3: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _assign = _dereq_(32);

            var ReactBaseClasses = _dereq_(4);
            var ReactChildren = _dereq_(5);
            var ReactDOMFactories = _dereq_(8);
            var ReactElement = _dereq_(9);
            var ReactPropTypes = _dereq_(14);
            var ReactVersion = _dereq_(17);

            var createReactClass = _dereq_(20);
            var onlyChild = _dereq_(24);

            var createElement = ReactElement.createElement;
            var createFactory = ReactElement.createFactory;
            var cloneElement = ReactElement.cloneElement;

            if ("development" !== 'production') {
                var lowPriorityWarning = _dereq_(23);
                var canDefineProperty = _dereq_(18);
                var ReactElementValidator = _dereq_(11);
                var didWarnPropTypesDeprecated = false;
                createElement = ReactElementValidator.createElement;
                createFactory = ReactElementValidator.createFactory;
                cloneElement = ReactElementValidator.cloneElement;
            }

            var __spread = _assign;
            var createMixin = function (mixin) {
                return mixin;
            };

            if ("development" !== 'production') {
                var warnedForSpread = false;
                var warnedForCreateMixin = false;
                __spread = function () {
                    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
                    warnedForSpread = true;
                    return _assign.apply(null, arguments);
                };

                createMixin = function (mixin) {
                    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
                    warnedForCreateMixin = true;
                    return mixin;
                };
            }

            var React = {
                // Modern

                Children: {
                    map: ReactChildren.map,
                    forEach: ReactChildren.forEach,
                    count: ReactChildren.count,
                    toArray: ReactChildren.toArray,
                    only: onlyChild
                },

                Component: ReactBaseClasses.Component,
                PureComponent: ReactBaseClasses.PureComponent,

                createElement: createElement,
                cloneElement: cloneElement,
                isValidElement: ReactElement.isValidElement,

                // Classic

                PropTypes: ReactPropTypes,
                createClass: createReactClass,
                createFactory: createFactory,
                createMixin: createMixin,

                // This looks DOM specific but these are actually isomorphic helpers
                // since they are just generating DOM strings.
                DOM: ReactDOMFactories,

                version: ReactVersion,

                // Deprecated hook for JSX spread, don't use this for anything.
                __spread: __spread
            };

            if ("development" !== 'production') {
                var warnedForCreateClass = false;
                if (canDefineProperty) {
                    Object.defineProperty(React, 'PropTypes', {
                        get: function () {
                            lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
                            didWarnPropTypesDeprecated = true;
                            return ReactPropTypes;
                        }
                    });

                    Object.defineProperty(React, 'createClass', {
                        get: function () {
                            lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
                            warnedForCreateClass = true;
                            return createReactClass;
                        }
                    });
                }

                // React.DOM factories are deprecated. Wrap these methods so that
                // invocations of the React.DOM namespace and alert users to switch
                // to the `react-dom-factories` package.
                React.DOM = {};
                var warnedForFactories = false;
                Object.keys(ReactDOMFactories).forEach(function (factory) {
                    React.DOM[factory] = function () {
                        if (!warnedForFactories) {
                            lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
                            warnedForFactories = true;
                        }
                        return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
                    };
                });
            }

            module.exports = React;
        }, { "11": 11, "14": 14, "17": 17, "18": 18, "20": 20, "23": 23, "24": 24, "32": 32, "4": 4, "5": 5, "8": 8, "9": 9 }], 4: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _prodInvariant = _dereq_(25),
                _assign = _dereq_(32);

            var ReactNoopUpdateQueue = _dereq_(12);

            var canDefineProperty = _dereq_(18);
            var emptyObject = _dereq_(29);
            var invariant = _dereq_(30);
            var lowPriorityWarning = _dereq_(23);

            /**
             * Base class helpers for the updating state of a component.
             */
            function ReactComponent(props, context, updater) {
                this.props = props;
                this.context = context;
                this.refs = emptyObject;
                // We initialize the default updater but the real one gets injected by the
                // renderer.
                this.updater = updater || ReactNoopUpdateQueue;
            }

            ReactComponent.prototype.isReactComponent = {};

            /**
             * Sets a subset of the state. Always use this to mutate
             * state. You should treat `this.state` as immutable.
             *
             * There is no guarantee that `this.state` will be immediately updated, so
             * accessing `this.state` after calling this method may return the old value.
             *
             * There is no guarantee that calls to `setState` will run synchronously,
             * as they may eventually be batched together.  You can provide an optional
             * callback that will be executed when the call to setState is actually
             * completed.
             *
             * When a function is provided to setState, it will be called at some point in
             * the future (not synchronously). It will be called with the up to date
             * component arguments (state, props, context). These values can be different
             * from this.* because your function may be called after receiveProps but before
             * shouldComponentUpdate, and this new state, props, and context will not yet be
             * assigned to this.
             *
             * @param {object|function} partialState Next partial state or function to
             *        produce next partial state to be merged with current state.
             * @param {?function} callback Called after state is updated.
             * @final
             * @protected
             */
            ReactComponent.prototype.setState = function (partialState, callback) {
                !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? "development" !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
                this.updater.enqueueSetState(this, partialState);
                if (callback) {
                    this.updater.enqueueCallback(this, callback, 'setState');
                }
            };

            /**
             * Forces an update. This should only be invoked when it is known with
             * certainty that we are **not** in a DOM transaction.
             *
             * You may want to call this when you know that some deeper aspect of the
             * component's state has changed but `setState` was not called.
             *
             * This will not invoke `shouldComponentUpdate`, but it will invoke
             * `componentWillUpdate` and `componentDidUpdate`.
             *
             * @param {?function} callback Called after update is complete.
             * @final
             * @protected
             */
            ReactComponent.prototype.forceUpdate = function (callback) {
                this.updater.enqueueForceUpdate(this);
                if (callback) {
                    this.updater.enqueueCallback(this, callback, 'forceUpdate');
                }
            };

            /**
             * Deprecated APIs. These APIs used to exist on classic React classes but since
             * we would like to deprecate them, we're not going to move them over to this
             * modern base class. Instead, we define a getter that warns if it's accessed.
             */
            if ("development" !== 'production') {
                var deprecatedAPIs = {
                    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
                    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
                };
                var defineDeprecationWarning = function (methodName, info) {
                    if (canDefineProperty) {
                        Object.defineProperty(ReactComponent.prototype, methodName, {
                            get: function () {
                                lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                                return undefined;
                            }
                        });
                    }
                };
                for (var fnName in deprecatedAPIs) {
                    if (deprecatedAPIs.hasOwnProperty(fnName)) {
                        defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
                    }
                }
            }

            /**
             * Base class helpers for the updating state of a component.
             */
            function ReactPureComponent(props, context, updater) {
                // Duplicated from ReactComponent.
                this.props = props;
                this.context = context;
                this.refs = emptyObject;
                // We initialize the default updater but the real one gets injected by the
                // renderer.
                this.updater = updater || ReactNoopUpdateQueue;
            }

            function ComponentDummy() { }
            ComponentDummy.prototype = ReactComponent.prototype;
            ReactPureComponent.prototype = new ComponentDummy();
            ReactPureComponent.prototype.constructor = ReactPureComponent;
            // Avoid an extra prototype jump for these methods.
            _assign(ReactPureComponent.prototype, ReactComponent.prototype);
            ReactPureComponent.prototype.isPureReactComponent = true;

            module.exports = {
                Component: ReactComponent,
                PureComponent: ReactPureComponent
            };
        }, { "12": 12, "18": 18, "23": 23, "25": 25, "29": 29, "30": 30, "32": 32 }], 5: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var PooledClass = _dereq_(2);
            var ReactElement = _dereq_(9);

            var emptyFunction = _dereq_(28);
            var traverseAllChildren = _dereq_(26);

            var twoArgumentPooler = PooledClass.twoArgumentPooler;
            var fourArgumentPooler = PooledClass.fourArgumentPooler;

            var userProvidedKeyEscapeRegex = /\/+/g;
            function escapeUserProvidedKey(text) {
                return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
            }

            /**
             * PooledClass representing the bookkeeping associated with performing a child
             * traversal. Allows avoiding binding callbacks.
             *
             * @constructor ForEachBookKeeping
             * @param {!function} forEachFunction Function to perform traversal with.
             * @param {?*} forEachContext Context to perform context with.
             */
            function ForEachBookKeeping(forEachFunction, forEachContext) {
                this.func = forEachFunction;
                this.context = forEachContext;
                this.count = 0;
            }
            ForEachBookKeeping.prototype.destructor = function () {
                this.func = null;
                this.context = null;
                this.count = 0;
            };
            PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

            function forEachSingleChild(bookKeeping, child, name) {
                var func = bookKeeping.func,
                    context = bookKeeping.context;

                func.call(context, child, bookKeeping.count++);
            }

            /**
             * Iterates through children that are typically specified as `props.children`.
             *
             * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
             *
             * The provided forEachFunc(child, index) will be called for each
             * leaf child.
             *
             * @param {?*} children Children tree container.
             * @param {function(*, int)} forEachFunc
             * @param {*} forEachContext Context for forEachContext.
             */
            function forEachChildren(children, forEachFunc, forEachContext) {
                if (children == null) {
                    return children;
                }
                var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
                traverseAllChildren(children, forEachSingleChild, traverseContext);
                ForEachBookKeeping.release(traverseContext);
            }

            /**
             * PooledClass representing the bookkeeping associated with performing a child
             * mapping. Allows avoiding binding callbacks.
             *
             * @constructor MapBookKeeping
             * @param {!*} mapResult Object containing the ordered map of results.
             * @param {!function} mapFunction Function to perform mapping with.
             * @param {?*} mapContext Context to perform mapping with.
             */
            function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
                this.result = mapResult;
                this.keyPrefix = keyPrefix;
                this.func = mapFunction;
                this.context = mapContext;
                this.count = 0;
            }
            MapBookKeeping.prototype.destructor = function () {
                this.result = null;
                this.keyPrefix = null;
                this.func = null;
                this.context = null;
                this.count = 0;
            };
            PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

            function mapSingleChildIntoContext(bookKeeping, child, childKey) {
                var result = bookKeeping.result,
                    keyPrefix = bookKeeping.keyPrefix,
                    func = bookKeeping.func,
                    context = bookKeeping.context;


                var mappedChild = func.call(context, child, bookKeeping.count++);
                if (Array.isArray(mappedChild)) {
                    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
                } else if (mappedChild != null) {
                    if (ReactElement.isValidElement(mappedChild)) {
                        mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
                            // Keep both the (mapped) and old keys if they differ, just as
                            // traverseAllChildren used to do for objects as children
                            keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
                    }
                    result.push(mappedChild);
                }
            }

            function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
                var escapedPrefix = '';
                if (prefix != null) {
                    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
                }
                var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
                traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
                MapBookKeeping.release(traverseContext);
            }

            /**
             * Maps children that are typically specified as `props.children`.
             *
             * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
             *
             * The provided mapFunction(child, key, index) will be called for each
             * leaf child.
             *
             * @param {?*} children Children tree container.
             * @param {function(*, int)} func The map function.
             * @param {*} context Context for mapFunction.
             * @return {object} Object containing the ordered map of results.
             */
            function mapChildren(children, func, context) {
                if (children == null) {
                    return children;
                }
                var result = [];
                mapIntoWithKeyPrefixInternal(children, result, null, func, context);
                return result;
            }

            function forEachSingleChildDummy(traverseContext, child, name) {
                return null;
            }

            /**
             * Count the number of children that are typically specified as
             * `props.children`.
             *
             * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
             *
             * @param {?*} children Children tree container.
             * @return {number} The number of children.
             */
            function countChildren(children, context) {
                return traverseAllChildren(children, forEachSingleChildDummy, null);
            }

            /**
             * Flatten a children object (typically specified as `props.children`) and
             * return an array with appropriately re-keyed children.
             *
             * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
             */
            function toArray(children) {
                var result = [];
                mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
                return result;
            }

            var ReactChildren = {
                forEach: forEachChildren,
                map: mapChildren,
                mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
                count: countChildren,
                toArray: toArray
            };

            module.exports = ReactChildren;
        }, { "2": 2, "26": 26, "28": 28, "9": 9 }], 6: [function (_dereq_, module, exports) {
            /**
             * Copyright 2016-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            var _prodInvariant = _dereq_(25);

            var ReactCurrentOwner = _dereq_(7);

            var invariant = _dereq_(30);
            var warning = _dereq_(31);

            function isNative(fn) {
                // Based on isNative() from Lodash
                var funcToString = Function.prototype.toString;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var reIsNative = RegExp('^' + funcToString
                    // Take an example native function source for comparison
                    .call(hasOwnProperty
                    // Strip regex characters so we can use it for regex
                    ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
                    // Remove hasOwnProperty from the template to make it generic
                    ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
                try {
                    var source = funcToString.call(fn);
                    return reIsNative.test(source);
                } catch (err) {
                    return false;
                }
            }

            var canUseCollections =
                // Array.from
                typeof Array.from === 'function' &&
                // Map
                typeof Map === 'function' && isNative(Map) &&
                // Map.prototype.keys
                Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
                // Set
                typeof Set === 'function' && isNative(Set) &&
                // Set.prototype.keys
                Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

            var setItem;
            var getItem;
            var removeItem;
            var getItemIDs;
            var addRoot;
            var removeRoot;
            var getRootIDs;

            if (canUseCollections) {
                var itemMap = new Map();
                var rootIDSet = new Set();

                setItem = function (id, item) {
                    itemMap.set(id, item);
                };
                getItem = function (id) {
                    return itemMap.get(id);
                };
                removeItem = function (id) {
                    itemMap['delete'](id);
                };
                getItemIDs = function () {
                    return Array.from(itemMap.keys());
                };

                addRoot = function (id) {
                    rootIDSet.add(id);
                };
                removeRoot = function (id) {
                    rootIDSet['delete'](id);
                };
                getRootIDs = function () {
                    return Array.from(rootIDSet.keys());
                };
            } else {
                var itemByKey = {};
                var rootByKey = {};

                // Use non-numeric keys to prevent V8 performance issues:
                // https://github.com/facebook/react/pull/7232
                var getKeyFromID = function (id) {
                    return '.' + id;
                };
                var getIDFromKey = function (key) {
                    return parseInt(key.substr(1), 10);
                };

                setItem = function (id, item) {
                    var key = getKeyFromID(id);
                    itemByKey[key] = item;
                };
                getItem = function (id) {
                    var key = getKeyFromID(id);
                    return itemByKey[key];
                };
                removeItem = function (id) {
                    var key = getKeyFromID(id);
                    delete itemByKey[key];
                };
                getItemIDs = function () {
                    return Object.keys(itemByKey).map(getIDFromKey);
                };

                addRoot = function (id) {
                    var key = getKeyFromID(id);
                    rootByKey[key] = true;
                };
                removeRoot = function (id) {
                    var key = getKeyFromID(id);
                    delete rootByKey[key];
                };
                getRootIDs = function () {
                    return Object.keys(rootByKey).map(getIDFromKey);
                };
            }

            var unmountedIDs = [];

            function purgeDeep(id) {
                var item = getItem(id);
                if (item) {
                    var childIDs = item.childIDs;

                    removeItem(id);
                    childIDs.forEach(purgeDeep);
                }
            }

            function describeComponentFrame(name, source, ownerName) {
                return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
            }

            function getDisplayName(element) {
                if (element == null) {
                    return '#empty';
                } else if (typeof element === 'string' || typeof element === 'number') {
                    return '#text';
                } else if (typeof element.type === 'string') {
                    return element.type;
                } else {
                    return element.type.displayName || element.type.name || 'Unknown';
                }
            }

            function describeID(id) {
                var name = ReactComponentTreeHook.getDisplayName(id);
                var element = ReactComponentTreeHook.getElement(id);
                var ownerID = ReactComponentTreeHook.getOwnerID(id);
                var ownerName;
                if (ownerID) {
                    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
                }
                "development" !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
                return describeComponentFrame(name, element && element._source, ownerName);
            }

            var ReactComponentTreeHook = {
                onSetChildren: function (id, nextChildIDs) {
                    var item = getItem(id);
                    !item ? "development" !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
                    item.childIDs = nextChildIDs;

                    for (var i = 0; i < nextChildIDs.length; i++) {
                        var nextChildID = nextChildIDs[i];
                        var nextChild = getItem(nextChildID);
                        !nextChild ? "development" !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
                        !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? "development" !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
                        !nextChild.isMounted ? "development" !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
                        if (nextChild.parentID == null) {
                            nextChild.parentID = id;
                            // TODO: This shouldn't be necessary but mounting a new root during in
                            // componentWillMount currently causes not-yet-mounted components to
                            // be purged from our tree data so their parent id is missing.
                        }
                        !(nextChild.parentID === id) ? "development" !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
                    }
                },
                onBeforeMountComponent: function (id, element, parentID) {
                    var item = {
                        element: element,
                        parentID: parentID,
                        text: null,
                        childIDs: [],
                        isMounted: false,
                        updateCount: 0
                    };
                    setItem(id, item);
                },
                onBeforeUpdateComponent: function (id, element) {
                    var item = getItem(id);
                    if (!item || !item.isMounted) {
                        // We may end up here as a result of setState() in componentWillUnmount().
                        // In this case, ignore the element.
                        return;
                    }
                    item.element = element;
                },
                onMountComponent: function (id) {
                    var item = getItem(id);
                    !item ? "development" !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
                    item.isMounted = true;
                    var isRoot = item.parentID === 0;
                    if (isRoot) {
                        addRoot(id);
                    }
                },
                onUpdateComponent: function (id) {
                    var item = getItem(id);
                    if (!item || !item.isMounted) {
                        // We may end up here as a result of setState() in componentWillUnmount().
                        // In this case, ignore the element.
                        return;
                    }
                    item.updateCount++;
                },
                onUnmountComponent: function (id) {
                    var item = getItem(id);
                    if (item) {
                        // We need to check if it exists.
                        // `item` might not exist if it is inside an error boundary, and a sibling
                        // error boundary child threw while mounting. Then this instance never
                        // got a chance to mount, but it still gets an unmounting event during
                        // the error boundary cleanup.
                        item.isMounted = false;
                        var isRoot = item.parentID === 0;
                        if (isRoot) {
                            removeRoot(id);
                        }
                    }
                    unmountedIDs.push(id);
                },
                purgeUnmountedComponents: function () {
                    if (ReactComponentTreeHook._preventPurging) {
                        // Should only be used for testing.
                        return;
                    }

                    for (var i = 0; i < unmountedIDs.length; i++) {
                        var id = unmountedIDs[i];
                        purgeDeep(id);
                    }
                    unmountedIDs.length = 0;
                },
                isMounted: function (id) {
                    var item = getItem(id);
                    return item ? item.isMounted : false;
                },
                getCurrentStackAddendum: function (topElement) {
                    var info = '';
                    if (topElement) {
                        var name = getDisplayName(topElement);
                        var owner = topElement._owner;
                        info += describeComponentFrame(name, topElement._source, owner && owner.getName());
                    }

                    var currentOwner = ReactCurrentOwner.current;
                    var id = currentOwner && currentOwner._debugID;

                    info += ReactComponentTreeHook.getStackAddendumByID(id);
                    return info;
                },
                getStackAddendumByID: function (id) {
                    var info = '';
                    while (id) {
                        info += describeID(id);
                        id = ReactComponentTreeHook.getParentID(id);
                    }
                    return info;
                },
                getChildIDs: function (id) {
                    var item = getItem(id);
                    return item ? item.childIDs : [];
                },
                getDisplayName: function (id) {
                    var element = ReactComponentTreeHook.getElement(id);
                    if (!element) {
                        return null;
                    }
                    return getDisplayName(element);
                },
                getElement: function (id) {
                    var item = getItem(id);
                    return item ? item.element : null;
                },
                getOwnerID: function (id) {
                    var element = ReactComponentTreeHook.getElement(id);
                    if (!element || !element._owner) {
                        return null;
                    }
                    return element._owner._debugID;
                },
                getParentID: function (id) {
                    var item = getItem(id);
                    return item ? item.parentID : null;
                },
                getSource: function (id) {
                    var item = getItem(id);
                    var element = item ? item.element : null;
                    var source = element != null ? element._source : null;
                    return source;
                },
                getText: function (id) {
                    var element = ReactComponentTreeHook.getElement(id);
                    if (typeof element === 'string') {
                        return element;
                    } else if (typeof element === 'number') {
                        return '' + element;
                    } else {
                        return null;
                    }
                },
                getUpdateCount: function (id) {
                    var item = getItem(id);
                    return item ? item.updateCount : 0;
                },


                getRootIDs: getRootIDs,
                getRegisteredIDs: getItemIDs,

                pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
                    if (typeof console.reactStack !== 'function') {
                        return;
                    }

                    var stack = [];
                    var currentOwner = ReactCurrentOwner.current;
                    var id = currentOwner && currentOwner._debugID;

                    try {
                        if (isCreatingElement) {
                            stack.push({
                                name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
                                fileName: currentSource ? currentSource.fileName : null,
                                lineNumber: currentSource ? currentSource.lineNumber : null
                            });
                        }

                        while (id) {
                            var element = ReactComponentTreeHook.getElement(id);
                            var parentID = ReactComponentTreeHook.getParentID(id);
                            var ownerID = ReactComponentTreeHook.getOwnerID(id);
                            var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
                            var source = element && element._source;
                            stack.push({
                                name: ownerName,
                                fileName: source ? source.fileName : null,
                                lineNumber: source ? source.lineNumber : null
                            });
                            id = parentID;
                        }
                    } catch (err) {
                        // Internal state is messed up.
                        // Stop building the stack (it's just a nice to have).
                    }

                    console.reactStack(stack);
                },
                popNonStandardWarningStack: function () {
                    if (typeof console.reactStackEnd !== 'function') {
                        return;
                    }
                    console.reactStackEnd();
                }
            };

            module.exports = ReactComponentTreeHook;
        }, { "25": 25, "30": 30, "31": 31, "7": 7 }], 7: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            /**
             * Keeps track of the current owner.
             *
             * The current owner is the component who should own any components that are
             * currently being constructed.
             */
            var ReactCurrentOwner = {
                /**
                 * @internal
                 * @type {ReactComponent}
                 */
                current: null
            };

            module.exports = ReactCurrentOwner;
        }, {}], 8: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var ReactElement = _dereq_(9);

            /**
             * Create a factory that creates HTML tag elements.
             *
             * @private
             */
            var createDOMFactory = ReactElement.createFactory;
            if ("development" !== 'production') {
                var ReactElementValidator = _dereq_(11);
                createDOMFactory = ReactElementValidator.createFactory;
            }

            /**
             * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
             *
             * @public
             */
            var ReactDOMFactories = {
                a: createDOMFactory('a'),
                abbr: createDOMFactory('abbr'),
                address: createDOMFactory('address'),
                area: createDOMFactory('area'),
                article: createDOMFactory('article'),
                aside: createDOMFactory('aside'),
                audio: createDOMFactory('audio'),
                b: createDOMFactory('b'),
                base: createDOMFactory('base'),
                bdi: createDOMFactory('bdi'),
                bdo: createDOMFactory('bdo'),
                big: createDOMFactory('big'),
                blockquote: createDOMFactory('blockquote'),
                body: createDOMFactory('body'),
                br: createDOMFactory('br'),
                button: createDOMFactory('button'),
                canvas: createDOMFactory('canvas'),
                caption: createDOMFactory('caption'),
                cite: createDOMFactory('cite'),
                code: createDOMFactory('code'),
                col: createDOMFactory('col'),
                colgroup: createDOMFactory('colgroup'),
                data: createDOMFactory('data'),
                datalist: createDOMFactory('datalist'),
                dd: createDOMFactory('dd'),
                del: createDOMFactory('del'),
                details: createDOMFactory('details'),
                dfn: createDOMFactory('dfn'),
                dialog: createDOMFactory('dialog'),
                div: createDOMFactory('div'),
                dl: createDOMFactory('dl'),
                dt: createDOMFactory('dt'),
                em: createDOMFactory('em'),
                embed: createDOMFactory('embed'),
                fieldset: createDOMFactory('fieldset'),
                figcaption: createDOMFactory('figcaption'),
                figure: createDOMFactory('figure'),
                footer: createDOMFactory('footer'),
                form: createDOMFactory('form'),
                h1: createDOMFactory('h1'),
                h2: createDOMFactory('h2'),
                h3: createDOMFactory('h3'),
                h4: createDOMFactory('h4'),
                h5: createDOMFactory('h5'),
                h6: createDOMFactory('h6'),
                head: createDOMFactory('head'),
                header: createDOMFactory('header'),
                hgroup: createDOMFactory('hgroup'),
                hr: createDOMFactory('hr'),
                html: createDOMFactory('html'),
                i: createDOMFactory('i'),
                iframe: createDOMFactory('iframe'),
                img: createDOMFactory('img'),
                input: createDOMFactory('input'),
                ins: createDOMFactory('ins'),
                kbd: createDOMFactory('kbd'),
                keygen: createDOMFactory('keygen'),
                label: createDOMFactory('label'),
                legend: createDOMFactory('legend'),
                li: createDOMFactory('li'),
                link: createDOMFactory('link'),
                main: createDOMFactory('main'),
                map: createDOMFactory('map'),
                mark: createDOMFactory('mark'),
                menu: createDOMFactory('menu'),
                menuitem: createDOMFactory('menuitem'),
                meta: createDOMFactory('meta'),
                meter: createDOMFactory('meter'),
                nav: createDOMFactory('nav'),
                noscript: createDOMFactory('noscript'),
                object: createDOMFactory('object'),
                ol: createDOMFactory('ol'),
                optgroup: createDOMFactory('optgroup'),
                option: createDOMFactory('option'),
                output: createDOMFactory('output'),
                p: createDOMFactory('p'),
                param: createDOMFactory('param'),
                picture: createDOMFactory('picture'),
                pre: createDOMFactory('pre'),
                progress: createDOMFactory('progress'),
                q: createDOMFactory('q'),
                rp: createDOMFactory('rp'),
                rt: createDOMFactory('rt'),
                ruby: createDOMFactory('ruby'),
                s: createDOMFactory('s'),
                samp: createDOMFactory('samp'),
                script: createDOMFactory('script'),
                section: createDOMFactory('section'),
                select: createDOMFactory('select'),
                small: createDOMFactory('small'),
                source: createDOMFactory('source'),
                span: createDOMFactory('span'),
                strong: createDOMFactory('strong'),
                style: createDOMFactory('style'),
                sub: createDOMFactory('sub'),
                summary: createDOMFactory('summary'),
                sup: createDOMFactory('sup'),
                table: createDOMFactory('table'),
                tbody: createDOMFactory('tbody'),
                td: createDOMFactory('td'),
                textarea: createDOMFactory('textarea'),
                tfoot: createDOMFactory('tfoot'),
                th: createDOMFactory('th'),
                thead: createDOMFactory('thead'),
                time: createDOMFactory('time'),
                title: createDOMFactory('title'),
                tr: createDOMFactory('tr'),
                track: createDOMFactory('track'),
                u: createDOMFactory('u'),
                ul: createDOMFactory('ul'),
                'var': createDOMFactory('var'),
                video: createDOMFactory('video'),
                wbr: createDOMFactory('wbr'),

                // SVG
                circle: createDOMFactory('circle'),
                clipPath: createDOMFactory('clipPath'),
                defs: createDOMFactory('defs'),
                ellipse: createDOMFactory('ellipse'),
                g: createDOMFactory('g'),
                image: createDOMFactory('image'),
                line: createDOMFactory('line'),
                linearGradient: createDOMFactory('linearGradient'),
                mask: createDOMFactory('mask'),
                path: createDOMFactory('path'),
                pattern: createDOMFactory('pattern'),
                polygon: createDOMFactory('polygon'),
                polyline: createDOMFactory('polyline'),
                radialGradient: createDOMFactory('radialGradient'),
                rect: createDOMFactory('rect'),
                stop: createDOMFactory('stop'),
                svg: createDOMFactory('svg'),
                text: createDOMFactory('text'),
                tspan: createDOMFactory('tspan')
            };

            module.exports = ReactDOMFactories;
        }, { "11": 11, "9": 9 }], 9: [function (_dereq_, module, exports) {
            /**
             * Copyright 2014-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _assign = _dereq_(32);

            var ReactCurrentOwner = _dereq_(7);

            var warning = _dereq_(31);
            var canDefineProperty = _dereq_(18);
            var hasOwnProperty = Object.prototype.hasOwnProperty;

            var REACT_ELEMENT_TYPE = _dereq_(10);

            var RESERVED_PROPS = {
                key: true,
                ref: true,
                __self: true,
                __source: true
            };

            var specialPropKeyWarningShown, specialPropRefWarningShown;

            function hasValidRef(config) {
                if ("development" !== 'production') {
                    if (hasOwnProperty.call(config, 'ref')) {
                        var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
                        if (getter && getter.isReactWarning) {
                            return false;
                        }
                    }
                }
                return config.ref !== undefined;
            }

            function hasValidKey(config) {
                if ("development" !== 'production') {
                    if (hasOwnProperty.call(config, 'key')) {
                        var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
                        if (getter && getter.isReactWarning) {
                            return false;
                        }
                    }
                }
                return config.key !== undefined;
            }

            function defineKeyPropWarningGetter(props, displayName) {
                var warnAboutAccessingKey = function () {
                    if (!specialPropKeyWarningShown) {
                        specialPropKeyWarningShown = true;
                        "development" !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
                    }
                };
                warnAboutAccessingKey.isReactWarning = true;
                Object.defineProperty(props, 'key', {
                    get: warnAboutAccessingKey,
                    configurable: true
                });
            }

            function defineRefPropWarningGetter(props, displayName) {
                var warnAboutAccessingRef = function () {
                    if (!specialPropRefWarningShown) {
                        specialPropRefWarningShown = true;
                        "development" !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
                    }
                };
                warnAboutAccessingRef.isReactWarning = true;
                Object.defineProperty(props, 'ref', {
                    get: warnAboutAccessingRef,
                    configurable: true
                });
            }

            /**
             * Factory method to create a new React element. This no longer adheres to
             * the class pattern, so do not use new to call it. Also, no instanceof check
             * will work. Instead test $$typeof field against Symbol.for('react.element') to check
             * if something is a React Element.
             *
             * @param {*} type
             * @param {*} key
             * @param {string|object} ref
             * @param {*} self A *temporary* helper to detect places where `this` is
             * different from the `owner` when React.createElement is called, so that we
             * can warn. We want to get rid of owner and replace string `ref`s with arrow
             * functions, and as long as `this` and owner are the same, there will be no
             * change in behavior.
             * @param {*} source An annotation object (added by a transpiler or otherwise)
             * indicating filename, line number, and/or other information.
             * @param {*} owner
             * @param {*} props
             * @internal
             */
            var ReactElement = function (type, key, ref, self, source, owner, props) {
                var element = {
                    // This tag allow us to uniquely identify this as a React Element
                    $$typeof: REACT_ELEMENT_TYPE,

                    // Built-in properties that belong on the element
                    type: type,
                    key: key,
                    ref: ref,
                    props: props,

                    // Record the component responsible for creating this element.
                    _owner: owner
                };

                if ("development" !== 'production') {
                    // The validation flag is currently mutative. We put it on
                    // an external backing store so that we can freeze the whole object.
                    // This can be replaced with a WeakMap once they are implemented in
                    // commonly used development environments.
                    element._store = {};

                    // To make comparing ReactElements easier for testing purposes, we make
                    // the validation flag non-enumerable (where possible, which should
                    // include every environment we run tests in), so the test framework
                    // ignores it.
                    if (canDefineProperty) {
                        Object.defineProperty(element._store, 'validated', {
                            configurable: false,
                            enumerable: false,
                            writable: true,
                            value: false
                        });
                        // self and source are DEV only properties.
                        Object.defineProperty(element, '_self', {
                            configurable: false,
                            enumerable: false,
                            writable: false,
                            value: self
                        });
                        // Two elements created in two different places should be considered
                        // equal for testing purposes and therefore we hide it from enumeration.
                        Object.defineProperty(element, '_source', {
                            configurable: false,
                            enumerable: false,
                            writable: false,
                            value: source
                        });
                    } else {
                        element._store.validated = false;
                        element._self = self;
                        element._source = source;
                    }
                    if (Object.freeze) {
                        Object.freeze(element.props);
                        Object.freeze(element);
                    }
                }

                return element;
            };

            /**
             * Create and return a new ReactElement of the given type.
             * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
             */
            ReactElement.createElement = function (type, config, children) {
                var propName;

                // Reserved names are extracted
                var props = {};

                var key = null;
                var ref = null;
                var self = null;
                var source = null;

                if (config != null) {
                    if (hasValidRef(config)) {
                        ref = config.ref;
                    }
                    if (hasValidKey(config)) {
                        key = '' + config.key;
                    }

                    self = config.__self === undefined ? null : config.__self;
                    source = config.__source === undefined ? null : config.__source;
                    // Remaining properties are added to a new props object
                    for (propName in config) {
                        if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                            props[propName] = config[propName];
                        }
                    }
                }

                // Children can be more than one argument, and those are transferred onto
                // the newly allocated props object.
                var childrenLength = arguments.length - 2;
                if (childrenLength === 1) {
                    props.children = children;
                } else if (childrenLength > 1) {
                    var childArray = Array(childrenLength);
                    for (var i = 0; i < childrenLength; i++) {
                        childArray[i] = arguments[i + 2];
                    }
                    if ("development" !== 'production') {
                        if (Object.freeze) {
                            Object.freeze(childArray);
                        }
                    }
                    props.children = childArray;
                }

                // Resolve default props
                if (type && type.defaultProps) {
                    var defaultProps = type.defaultProps;
                    for (propName in defaultProps) {
                        if (props[propName] === undefined) {
                            props[propName] = defaultProps[propName];
                        }
                    }
                }
                if ("development" !== 'production') {
                    if (key || ref) {
                        if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
                            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
                            if (key) {
                                defineKeyPropWarningGetter(props, displayName);
                            }
                            if (ref) {
                                defineRefPropWarningGetter(props, displayName);
                            }
                        }
                    }
                }
                return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
            };

            /**
             * Return a function that produces ReactElements of a given type.
             * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
             */
            ReactElement.createFactory = function (type) {
                var factory = ReactElement.createElement.bind(null, type);
                // Expose the type on the factory and the prototype so that it can be
                // easily accessed on elements. E.g. `<Foo />.type === Foo`.
                // This should not be named `constructor` since this may not be the function
                // that created the element, and it may not even be a constructor.
                // Legacy hook TODO: Warn if this is accessed
                factory.type = type;
                return factory;
            };

            ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
                var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

                return newElement;
            };

            /**
             * Clone and return a new ReactElement using element as the starting point.
             * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
             */
            ReactElement.cloneElement = function (element, config, children) {
                var propName;

                // Original props are copied
                var props = _assign({}, element.props);

                // Reserved names are extracted
                var key = element.key;
                var ref = element.ref;
                // Self is preserved since the owner is preserved.
                var self = element._self;
                // Source is preserved since cloneElement is unlikely to be targeted by a
                // transpiler, and the original source is probably a better indicator of the
                // true owner.
                var source = element._source;

                // Owner will be preserved, unless ref is overridden
                var owner = element._owner;

                if (config != null) {
                    if (hasValidRef(config)) {
                        // Silently steal the ref from the parent.
                        ref = config.ref;
                        owner = ReactCurrentOwner.current;
                    }
                    if (hasValidKey(config)) {
                        key = '' + config.key;
                    }

                    // Remaining properties override existing props
                    var defaultProps;
                    if (element.type && element.type.defaultProps) {
                        defaultProps = element.type.defaultProps;
                    }
                    for (propName in config) {
                        if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                            if (config[propName] === undefined && defaultProps !== undefined) {
                                // Resolve default props
                                props[propName] = defaultProps[propName];
                            } else {
                                props[propName] = config[propName];
                            }
                        }
                    }
                }

                // Children can be more than one argument, and those are transferred onto
                // the newly allocated props object.
                var childrenLength = arguments.length - 2;
                if (childrenLength === 1) {
                    props.children = children;
                } else if (childrenLength > 1) {
                    var childArray = Array(childrenLength);
                    for (var i = 0; i < childrenLength; i++) {
                        childArray[i] = arguments[i + 2];
                    }
                    props.children = childArray;
                }

                return ReactElement(element.type, key, ref, self, source, owner, props);
            };

            /**
             * Verifies the object is a ReactElement.
             * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
             * @param {?object} object
             * @return {boolean} True if `object` is a valid component.
             * @final
             */
            ReactElement.isValidElement = function (object) {
                return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            };

            module.exports = ReactElement;
        }, { "10": 10, "18": 18, "31": 31, "32": 32, "7": 7 }], 10: [function (_dereq_, module, exports) {
            /**
             * Copyright 2014-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            // The Symbol used to tag the ReactElement type. If there is no native Symbol
            // nor polyfill, then a plain number is used for performance.

            var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

            module.exports = REACT_ELEMENT_TYPE;
        }, {}], 11: [function (_dereq_, module, exports) {
            /**
             * Copyright 2014-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            /**
             * ReactElementValidator provides a wrapper around a element factory
             * which validates the props passed to the element. This is intended to be
             * used only in DEV and could be replaced by a static type checker for languages
             * that support it.
             */

            'use strict';

            var ReactCurrentOwner = _dereq_(7);
            var ReactComponentTreeHook = _dereq_(6);
            var ReactElement = _dereq_(9);

            var checkReactTypeSpec = _dereq_(19);

            var canDefineProperty = _dereq_(18);
            var getIteratorFn = _dereq_(21);
            var warning = _dereq_(31);
            var lowPriorityWarning = _dereq_(23);

            function getDeclarationErrorAddendum() {
                if (ReactCurrentOwner.current) {
                    var name = ReactCurrentOwner.current.getName();
                    if (name) {
                        return ' Check the render method of `' + name + '`.';
                    }
                }
                return '';
            }

            function getSourceInfoErrorAddendum(elementProps) {
                if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
                    var source = elementProps.__source;
                    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
                    var lineNumber = source.lineNumber;
                    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
                }
                return '';
            }

            /**
             * Warn if there's no key explicitly set on dynamic arrays of children or
             * object keys are not valid. This allows us to keep track of children between
             * updates.
             */
            var ownerHasKeyUseWarning = {};

            function getCurrentComponentErrorInfo(parentType) {
                var info = getDeclarationErrorAddendum();

                if (!info) {
                    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
                    if (parentName) {
                        info = ' Check the top-level render call using <' + parentName + '>.';
                    }
                }
                return info;
            }

            /**
             * Warn if the element doesn't have an explicit key assigned to it.
             * This element is in an array. The array could grow and shrink or be
             * reordered. All children that haven't already been validated are required to
             * have a "key" property assigned to it. Error statuses are cached so a warning
             * will only be shown once.
             *
             * @internal
             * @param {ReactElement} element Element that requires a key.
             * @param {*} parentType element's parent's type.
             */
            function validateExplicitKey(element, parentType) {
                if (!element._store || element._store.validated || element.key != null) {
                    return;
                }
                element._store.validated = true;

                var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});

                var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
                if (memoizer[currentComponentErrorInfo]) {
                    return;
                }
                memoizer[currentComponentErrorInfo] = true;

                // Usually the current owner is the offender, but if it accepts children as a
                // property, it may be the creator of the child that's responsible for
                // assigning it a key.
                var childOwner = '';
                if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
                    // Give the component that originally created this child.
                    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
                }

                "development" !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
            }

            /**
             * Ensure that every element either is passed in a static location, in an
             * array with an explicit keys property defined, or in an object literal
             * with valid key property.
             *
             * @internal
             * @param {ReactNode} node Statically passed child of any type.
             * @param {*} parentType node's parent's type.
             */
            function validateChildKeys(node, parentType) {
                if (typeof node !== 'object') {
                    return;
                }
                if (Array.isArray(node)) {
                    for (var i = 0; i < node.length; i++) {
                        var child = node[i];
                        if (ReactElement.isValidElement(child)) {
                            validateExplicitKey(child, parentType);
                        }
                    }
                } else if (ReactElement.isValidElement(node)) {
                    // This element was passed in a valid location.
                    if (node._store) {
                        node._store.validated = true;
                    }
                } else if (node) {
                    var iteratorFn = getIteratorFn(node);
                    // Entry iterators provide implicit keys.
                    if (iteratorFn) {
                        if (iteratorFn !== node.entries) {
                            var iterator = iteratorFn.call(node);
                            var step;
                            while (!(step = iterator.next()).done) {
                                if (ReactElement.isValidElement(step.value)) {
                                    validateExplicitKey(step.value, parentType);
                                }
                            }
                        }
                    }
                }
            }

            /**
             * Given an element, validate that its props follow the propTypes definition,
             * provided by the type.
             *
             * @param {ReactElement} element
             */
            function validatePropTypes(element) {
                var componentClass = element.type;
                if (typeof componentClass !== 'function') {
                    return;
                }
                var name = componentClass.displayName || componentClass.name;
                if (componentClass.propTypes) {
                    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
                }
                if (typeof componentClass.getDefaultProps === 'function') {
                    "development" !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
                }
            }

            var ReactElementValidator = {
                createElement: function (type, props, children) {
                    var validType = typeof type === 'string' || typeof type === 'function';
                    // We warn in this case but don't throw. We expect the element creation to
                    // succeed and there will likely be errors in render.
                    if (!validType) {
                        if (typeof type !== 'function' && typeof type !== 'string') {
                            var info = '';
                            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                                info += ' You likely forgot to export your component from the file ' + "it's defined in.";
                            }

                            var sourceInfo = getSourceInfoErrorAddendum(props);
                            if (sourceInfo) {
                                info += sourceInfo;
                            } else {
                                info += getDeclarationErrorAddendum();
                            }

                            info += ReactComponentTreeHook.getCurrentStackAddendum();

                            var currentSource = props !== null && props !== undefined && props.__source !== undefined ? props.__source : null;
                            ReactComponentTreeHook.pushNonStandardWarningStack(true, currentSource);
                            "development" !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
                            ReactComponentTreeHook.popNonStandardWarningStack();
                        }
                    }

                    var element = ReactElement.createElement.apply(this, arguments);

                    // The result can be nullish if a mock or a custom function is used.
                    // TODO: Drop this when these are no longer allowed as the type argument.
                    if (element == null) {
                        return element;
                    }

                    // Skip key warning if the type isn't valid since our key validation logic
                    // doesn't expect a non-string/function type and can throw confusing errors.
                    // We don't want exception behavior to differ between dev and prod.
                    // (Rendering will throw with a helpful message and as soon as the type is
                    // fixed, the key warnings will appear.)
                    if (validType) {
                        for (var i = 2; i < arguments.length; i++) {
                            validateChildKeys(arguments[i], type);
                        }
                    }

                    validatePropTypes(element);

                    return element;
                },

                createFactory: function (type) {
                    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
                    // Legacy hook TODO: Warn if this is accessed
                    validatedFactory.type = type;

                    if ("development" !== 'production') {
                        if (canDefineProperty) {
                            Object.defineProperty(validatedFactory, 'type', {
                                enumerable: false,
                                get: function () {
                                    lowPriorityWarning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
                                    Object.defineProperty(this, 'type', {
                                        value: type
                                    });
                                    return type;
                                }
                            });
                        }
                    }

                    return validatedFactory;
                },

                cloneElement: function (element, props, children) {
                    var newElement = ReactElement.cloneElement.apply(this, arguments);
                    for (var i = 2; i < arguments.length; i++) {
                        validateChildKeys(arguments[i], newElement.type);
                    }
                    validatePropTypes(newElement);
                    return newElement;
                }
            };

            module.exports = ReactElementValidator;
        }, { "18": 18, "19": 19, "21": 21, "23": 23, "31": 31, "6": 6, "7": 7, "9": 9 }], 12: [function (_dereq_, module, exports) {
            /**
             * Copyright 2015-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var warning = _dereq_(31);

            function warnNoop(publicInstance, callerName) {
                if ("development" !== 'production') {
                    var constructor = publicInstance.constructor;
                    "development" !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
                }
            }

            /**
             * This is the abstract API for an update queue.
             */
            var ReactNoopUpdateQueue = {
                /**
                 * Checks whether or not this composite component is mounted.
                 * @param {ReactClass} publicInstance The instance we want to test.
                 * @return {boolean} True if mounted, false otherwise.
                 * @protected
                 * @final
                 */
                isMounted: function (publicInstance) {
                    return false;
                },

                /**
                 * Enqueue a callback that will be executed after all the pending updates
                 * have processed.
                 *
                 * @param {ReactClass} publicInstance The instance to use as `this` context.
                 * @param {?function} callback Called after state is updated.
                 * @internal
                 */
                enqueueCallback: function (publicInstance, callback) { },

                /**
                 * Forces an update. This should only be invoked when it is known with
                 * certainty that we are **not** in a DOM transaction.
                 *
                 * You may want to call this when you know that some deeper aspect of the
                 * component's state has changed but `setState` was not called.
                 *
                 * This will not invoke `shouldComponentUpdate`, but it will invoke
                 * `componentWillUpdate` and `componentDidUpdate`.
                 *
                 * @param {ReactClass} publicInstance The instance that should rerender.
                 * @internal
                 */
                enqueueForceUpdate: function (publicInstance) {
                    warnNoop(publicInstance, 'forceUpdate');
                },

                /**
                 * Replaces all of the state. Always use this or `setState` to mutate state.
                 * You should treat `this.state` as immutable.
                 *
                 * There is no guarantee that `this.state` will be immediately updated, so
                 * accessing `this.state` after calling this method may return the old value.
                 *
                 * @param {ReactClass} publicInstance The instance that should rerender.
                 * @param {object} completeState Next state.
                 * @internal
                 */
                enqueueReplaceState: function (publicInstance, completeState) {
                    warnNoop(publicInstance, 'replaceState');
                },

                /**
                 * Sets a subset of the state. This only exists because _pendingState is
                 * internal. This provides a merging strategy that is not available to deep
                 * properties which is confusing. TODO: Expose pendingState or don't use it
                 * during the merge.
                 *
                 * @param {ReactClass} publicInstance The instance that should rerender.
                 * @param {object} partialState Next partial state to be merged with state.
                 * @internal
                 */
                enqueueSetState: function (publicInstance, partialState) {
                    warnNoop(publicInstance, 'setState');
                }
            };

            module.exports = ReactNoopUpdateQueue;
        }, { "31": 31 }], 13: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            var ReactPropTypeLocationNames = {};

            if ("development" !== 'production') {
                ReactPropTypeLocationNames = {
                    prop: 'prop',
                    context: 'context',
                    childContext: 'child context'
                };
            }

            module.exports = ReactPropTypeLocationNames;
        }, {}], 14: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _require = _dereq_(9),
                isValidElement = _require.isValidElement;

            var factory = _dereq_(34);

            module.exports = factory(isValidElement);
        }, { "34": 34, "9": 9 }], 15: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

            module.exports = ReactPropTypesSecret;
        }, {}], 16: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _assign = _dereq_(32);

            var React = _dereq_(3);

            // `version` will be added here by the React module.
            var ReactUMDEntry = _assign(React, {
                __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
                    ReactCurrentOwner: _dereq_(7)
                }
            });

            if ("development" !== 'production') {
                _assign(ReactUMDEntry.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, {
                    // ReactComponentTreeHook should not be included in production.
                    ReactComponentTreeHook: _dereq_(6),
                    getNextDebugID: _dereq_(22)
                });
            }

            module.exports = ReactUMDEntry;
        }, { "22": 22, "3": 3, "32": 32, "6": 6, "7": 7 }], 17: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            module.exports = '15.6.1';
        }, {}], 18: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            var canDefineProperty = false;
            if ("development" !== 'production') {
                try {
                    // $FlowFixMe https://github.com/facebook/flow/issues/285
                    Object.defineProperty({}, 'x', { get: function () { } });
                    canDefineProperty = true;
                } catch (x) {
                    // IE will fail on defineProperty
                }
            }

            module.exports = canDefineProperty;
        }, {}], 19: [function (_dereq_, module, exports) {
            (function (process) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(25);

                var ReactPropTypeLocationNames = _dereq_(13);
                var ReactPropTypesSecret = _dereq_(15);

                var invariant = _dereq_(30);
                var warning = _dereq_(31);

                var ReactComponentTreeHook;

                if (typeof process !== 'undefined' && process.env && "development" === 'test') {
                    // Temporary hack.
                    // Inline requires don't work well with Jest:
                    // https://github.com/facebook/react/issues/7240
                    // Remove the inline requires when we don't need them anymore:
                    // https://github.com/facebook/react/pull/7178
                    ReactComponentTreeHook = _dereq_(6);
                }

                var loggedTypeFailures = {};

                /**
                 * Assert that the values match with the type specs.
                 * Error messages are memorized and will only be shown once.
                 *
                 * @param {object} typeSpecs Map of name to a ReactPropType
                 * @param {object} values Runtime values that need to be type-checked
                 * @param {string} location e.g. "prop", "context", "child context"
                 * @param {string} componentName Name of the component for error messages.
                 * @param {?object} element The React element that is being type-checked
                 * @param {?number} debugID The React component instance that is being type-checked
                 * @private
                 */
                function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
                    for (var typeSpecName in typeSpecs) {
                        if (typeSpecs.hasOwnProperty(typeSpecName)) {
                            var error;
                            // Prop type validation may throw. In case they do, we don't want to
                            // fail the render phase where it didn't fail before. So we log it.
                            // After these have been cleaned up, we'll let them throw.
                            try {
                                // This is intentionally an invariant that gets caught. It's the same
                                // behavior as without this statement except with a better message.
                                !(typeof typeSpecs[typeSpecName] === 'function') ? "development" !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
                                error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                            } catch (ex) {
                                error = ex;
                            }
                            "development" !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
                            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                                // Only monitor this failure once because there tends to be a lot of the
                                // same error.
                                loggedTypeFailures[error.message] = true;

                                var componentStackInfo = '';

                                if ("development" !== 'production') {
                                    if (!ReactComponentTreeHook) {
                                        ReactComponentTreeHook = _dereq_(6);
                                    }
                                    if (debugID !== null) {
                                        componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
                                    } else if (element !== null) {
                                        componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
                                    }
                                }

                                "development" !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
                            }
                        }
                    }
                }

                module.exports = checkReactTypeSpec;
            }).call(this, undefined)
        }, { "13": 13, "15": 15, "25": 25, "30": 30, "31": 31, "6": 6 }], 20: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _require = _dereq_(4),
                Component = _require.Component;

            var _require2 = _dereq_(9),
                isValidElement = _require2.isValidElement;

            var ReactNoopUpdateQueue = _dereq_(12);
            var factory = _dereq_(27);

            module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);
        }, { "12": 12, "27": 27, "4": 4, "9": 9 }], 21: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            /* global Symbol */

            var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
            var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

            /**
             * Returns the iterator method function contained on the iterable object.
             *
             * Be sure to invoke the function with the iterable as context:
             *
             *     var iteratorFn = getIteratorFn(myIterable);
             *     if (iteratorFn) {
             *       var iterator = iteratorFn.call(myIterable);
             *       ...
             *     }
             *
             * @param {?object} maybeIterable
             * @return {?function}
             */
            function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if (typeof iteratorFn === 'function') {
                    return iteratorFn;
                }
            }

            module.exports = getIteratorFn;
        }, {}], 22: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            'use strict';

            var nextDebugID = 1;

            function getNextDebugID() {
                return nextDebugID++;
            }

            module.exports = getNextDebugID;
        }, {}], 23: [function (_dereq_, module, exports) {
            /**
             * Copyright 2014-2015, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            /**
             * Forked from fbjs/warning:
             * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
             *
             * Only change is we use console.warn instead of console.error,
             * and do nothing when 'console' is not supported.
             * This really simplifies the code.
             * ---
             * Similar to invariant but only logs a warning if the condition is not met.
             * This can be used to log issues in development environments in critical
             * paths. Removing the logging code for production environments will keep the
             * same logic and follow the same code paths.
             */

            var lowPriorityWarning = function () { };

            if ("development" !== 'production') {
                var printWarning = function (format) {
                    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }

                    var argIndex = 0;
                    var message = 'Warning: ' + format.replace(/%s/g, function () {
                        return args[argIndex++];
                    });
                    if (typeof console !== 'undefined') {
                        console.warn(message);
                    }
                    try {
                        // --- Welcome to debugging React ---
                        // This error was thrown as a convenience so that you can use this stack
                        // to find the callsite that caused this warning to fire.
                        throw new Error(message);
                    } catch (x) { }
                };

                lowPriorityWarning = function (condition, format) {
                    if (format === undefined) {
                        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
                    }
                    if (!condition) {
                        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                            args[_key2 - 2] = arguments[_key2];
                        }

                        printWarning.apply(undefined, [format].concat(args));
                    }
                };
            }

            module.exports = lowPriorityWarning;
        }, {}], 24: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */
            'use strict';

            var _prodInvariant = _dereq_(25);

            var ReactElement = _dereq_(9);

            var invariant = _dereq_(30);

            /**
             * Returns the first child in a collection of children and verifies that there
             * is only one child in the collection.
             *
             * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
             *
             * The current implementation of this function assumes that a single child gets
             * passed without a wrapper, but the purpose of this helper function is to
             * abstract away the particular structure of children.
             *
             * @param {?object} children Child collection structure.
             * @return {ReactElement} The first and only `ReactElement` contained in the
             * structure.
             */
            function onlyChild(children) {
                !ReactElement.isValidElement(children) ? "development" !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
                return children;
            }

            module.exports = onlyChild;
        }, { "25": 25, "30": 30, "9": 9 }], 25: [function (_dereq_, module, exports) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */
            'use strict';

            /**
             * WARNING: DO NOT manually require this module.
             * This is a replacement for `invariant(...)` used by the error code system
             * and will _only_ be required by the corresponding babel pass.
             * It always throws.
             */

            function reactProdInvariant(code) {
                var argCount = arguments.length - 1;

                var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

                for (var argIdx = 0; argIdx < argCount; argIdx++) {
                    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
                }

                message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

                var error = new Error(message);
                error.name = 'Invariant Violation';
                error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

                throw error;
            }

            module.exports = reactProdInvariant;
        }, {}], 26: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _prodInvariant = _dereq_(25);

            var ReactCurrentOwner = _dereq_(7);
            var REACT_ELEMENT_TYPE = _dereq_(10);

            var getIteratorFn = _dereq_(21);
            var invariant = _dereq_(30);
            var KeyEscapeUtils = _dereq_(1);
            var warning = _dereq_(31);

            var SEPARATOR = '.';
            var SUBSEPARATOR = ':';

            /**
             * This is inlined from ReactElement since this file is shared between
             * isomorphic and renderers. We could extract this to a
             *
             */

            /**
             * TODO: Test that a single child and an array with one item have the same key
             * pattern.
             */

            var didWarnAboutMaps = false;

            /**
             * Generate a key string that identifies a component within a set.
             *
             * @param {*} component A component that could contain a manual key.
             * @param {number} index Index that is used if a manual key is not provided.
             * @return {string}
             */
            function getComponentKey(component, index) {
                // Do some typechecking here since we call this blindly. We want to ensure
                // that we don't block potential future ES APIs.
                if (component && typeof component === 'object' && component.key != null) {
                    // Explicit key
                    return KeyEscapeUtils.escape(component.key);
                }
                // Implicit key determined by the index in the set
                return index.toString(36);
            }

            /**
             * @param {?*} children Children tree container.
             * @param {!string} nameSoFar Name of the key path so far.
             * @param {!function} callback Callback to invoke with each child found.
             * @param {?*} traverseContext Used to pass information throughout the traversal
             * process.
             * @return {!number} The number of children in this subtree.
             */
            function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
                var type = typeof children;

                if (type === 'undefined' || type === 'boolean') {
                    // All of the above are perceived as null.
                    children = null;
                }

                if (children === null || type === 'string' || type === 'number' ||
                    // The following is inlined from ReactElement. This means we can optimize
                    // some checks. React Fiber also inlines this logic for similar purposes.
                    type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
                    callback(traverseContext, children,
                        // If it's the only child, treat the name as if it was wrapped in an array
                        // so that it's consistent if the number of children grows.
                        nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
                    return 1;
                }

                var child;
                var nextName;
                var subtreeCount = 0; // Count of children found in the current subtree.
                var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

                if (Array.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                        child = children[i];
                        nextName = nextNamePrefix + getComponentKey(child, i);
                        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                    }
                } else {
                    var iteratorFn = getIteratorFn(children);
                    if (iteratorFn) {
                        var iterator = iteratorFn.call(children);
                        var step;
                        if (iteratorFn !== children.entries) {
                            var ii = 0;
                            while (!(step = iterator.next()).done) {
                                child = step.value;
                                nextName = nextNamePrefix + getComponentKey(child, ii++);
                                subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                            }
                        } else {
                            if ("development" !== 'production') {
                                var mapsAsChildrenAddendum = '';
                                if (ReactCurrentOwner.current) {
                                    var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
                                    if (mapsAsChildrenOwnerName) {
                                        mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
                                    }
                                }
                                "development" !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
                                didWarnAboutMaps = true;
                            }
                            // Iterator will provide entry [k,v] tuples rather than values.
                            while (!(step = iterator.next()).done) {
                                var entry = step.value;
                                if (entry) {
                                    child = entry[1];
                                    nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
                                    subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                                }
                            }
                        }
                    } else if (type === 'object') {
                        var addendum = '';
                        if ("development" !== 'production') {
                            addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
                            if (children._isReactElement) {
                                addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
                            }
                            if (ReactCurrentOwner.current) {
                                var name = ReactCurrentOwner.current.getName();
                                if (name) {
                                    addendum += ' Check the render method of `' + name + '`.';
                                }
                            }
                        }
                        var childrenString = String(children);
                        !false ? "development" !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
                    }
                }

                return subtreeCount;
            }

            /**
             * Traverses children that are typically specified as `props.children`, but
             * might also be specified through attributes:
             *
             * - `traverseAllChildren(this.props.children, ...)`
             * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
             *
             * The `traverseContext` is an optional argument that is passed through the
             * entire traversal. It can be used to store accumulations or anything else that
             * the callback might find relevant.
             *
             * @param {?*} children Children tree object.
             * @param {!function} callback To invoke upon traversing each child.
             * @param {?*} traverseContext Context for traversal.
             * @return {!number} The number of children in this subtree.
             */
            function traverseAllChildren(children, callback, traverseContext) {
                if (children == null) {
                    return 0;
                }

                return traverseAllChildrenImpl(children, '', callback, traverseContext);
            }

            module.exports = traverseAllChildren;
        }, { "1": 1, "10": 10, "21": 21, "25": 25, "30": 30, "31": 31, "7": 7 }], 27: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var _assign = _dereq_(32);

            var emptyObject = _dereq_(29);
            var _invariant = _dereq_(30);

            if ("development" !== 'production') {
                var warning = _dereq_(31);
            }

            var MIXINS_KEY = 'mixins';

            // Helper function to allow the creation of anonymous functions which do not
            // have .name set to the name of the variable being assigned to.
            function identity(fn) {
                return fn;
            }

            var ReactPropTypeLocationNames;
            if ("development" !== 'production') {
                ReactPropTypeLocationNames = {
                    prop: 'prop',
                    context: 'context',
                    childContext: 'child context'
                };
            } else {
                ReactPropTypeLocationNames = {};
            }

            function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
                /**
                 * Policies that describe methods in `ReactClassInterface`.
                 */

                var injectedMixins = [];

                /**
                 * Composite components are higher-level components that compose other composite
                 * or host components.
                 *
                 * To create a new type of `ReactClass`, pass a specification of
                 * your new class to `React.createClass`. The only requirement of your class
                 * specification is that you implement a `render` method.
                 *
                 *   var MyComponent = React.createClass({
                 *     render: function() {
                 *       return <div>Hello World</div>;
                 *     }
                 *   });
                 *
                 * The class specification supports a specific protocol of methods that have
                 * special meaning (e.g. `render`). See `ReactClassInterface` for
                 * more the comprehensive protocol. Any other properties and methods in the
                 * class specification will be available on the prototype.
                 *
                 * @interface ReactClassInterface
                 * @internal
                 */
                var ReactClassInterface = {
                    /**
                     * An array of Mixin objects to include when defining your component.
                     *
                     * @type {array}
                     * @optional
                     */
                    mixins: 'DEFINE_MANY',

                    /**
                     * An object containing properties and methods that should be defined on
                     * the component's constructor instead of its prototype (static methods).
                     *
                     * @type {object}
                     * @optional
                     */
                    statics: 'DEFINE_MANY',

                    /**
                     * Definition of prop types for this component.
                     *
                     * @type {object}
                     * @optional
                     */
                    propTypes: 'DEFINE_MANY',

                    /**
                     * Definition of context types for this component.
                     *
                     * @type {object}
                     * @optional
                     */
                    contextTypes: 'DEFINE_MANY',

                    /**
                     * Definition of context types this component sets for its children.
                     *
                     * @type {object}
                     * @optional
                     */
                    childContextTypes: 'DEFINE_MANY',

                    // ==== Definition methods ====

                    /**
                     * Invoked when the component is mounted. Values in the mapping will be set on
                     * `this.props` if that prop is not specified (i.e. using an `in` check).
                     *
                     * This method is invoked before `getInitialState` and therefore cannot rely
                     * on `this.state` or use `this.setState`.
                     *
                     * @return {object}
                     * @optional
                     */
                    getDefaultProps: 'DEFINE_MANY_MERGED',

                    /**
                     * Invoked once before the component is mounted. The return value will be used
                     * as the initial value of `this.state`.
                     *
                     *   getInitialState: function() {
                     *     return {
                     *       isOn: false,
                     *       fooBaz: new BazFoo()
                     *     }
                     *   }
                     *
                     * @return {object}
                     * @optional
                     */
                    getInitialState: 'DEFINE_MANY_MERGED',

                    /**
                     * @return {object}
                     * @optional
                     */
                    getChildContext: 'DEFINE_MANY_MERGED',

                    /**
                     * Uses props from `this.props` and state from `this.state` to render the
                     * structure of the component.
                     *
                     * No guarantees are made about when or how often this method is invoked, so
                     * it must not have side effects.
                     *
                     *   render: function() {
                     *     var name = this.props.name;
                     *     return <div>Hello, {name}!</div>;
                     *   }
                     *
                     * @return {ReactComponent}
                     * @required
                     */
                    render: 'DEFINE_ONCE',

                    // ==== Delegate methods ====

                    /**
                     * Invoked when the component is initially created and about to be mounted.
                     * This may have side effects, but any external subscriptions or data created
                     * by this method must be cleaned up in `componentWillUnmount`.
                     *
                     * @optional
                     */
                    componentWillMount: 'DEFINE_MANY',

                    /**
                     * Invoked when the component has been mounted and has a DOM representation.
                     * However, there is no guarantee that the DOM node is in the document.
                     *
                     * Use this as an opportunity to operate on the DOM when the component has
                     * been mounted (initialized and rendered) for the first time.
                     *
                     * @param {DOMElement} rootNode DOM element representing the component.
                     * @optional
                     */
                    componentDidMount: 'DEFINE_MANY',

                    /**
                     * Invoked before the component receives new props.
                     *
                     * Use this as an opportunity to react to a prop transition by updating the
                     * state using `this.setState`. Current props are accessed via `this.props`.
                     *
                     *   componentWillReceiveProps: function(nextProps, nextContext) {
                     *     this.setState({
                     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
                     *     });
                     *   }
                     *
                     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
                     * transition may cause a state change, but the opposite is not true. If you
                     * need it, you are probably looking for `componentWillUpdate`.
                     *
                     * @param {object} nextProps
                     * @optional
                     */
                    componentWillReceiveProps: 'DEFINE_MANY',

                    /**
                     * Invoked while deciding if the component should be updated as a result of
                     * receiving new props, state and/or context.
                     *
                     * Use this as an opportunity to `return false` when you're certain that the
                     * transition to the new props/state/context will not require a component
                     * update.
                     *
                     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
                     *     return !equal(nextProps, this.props) ||
                     *       !equal(nextState, this.state) ||
                     *       !equal(nextContext, this.context);
                     *   }
                     *
                     * @param {object} nextProps
                     * @param {?object} nextState
                     * @param {?object} nextContext
                     * @return {boolean} True if the component should update.
                     * @optional
                     */
                    shouldComponentUpdate: 'DEFINE_ONCE',

                    /**
                     * Invoked when the component is about to update due to a transition from
                     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
                     * and `nextContext`.
                     *
                     * Use this as an opportunity to perform preparation before an update occurs.
                     *
                     * NOTE: You **cannot** use `this.setState()` in this method.
                     *
                     * @param {object} nextProps
                     * @param {?object} nextState
                     * @param {?object} nextContext
                     * @param {ReactReconcileTransaction} transaction
                     * @optional
                     */
                    componentWillUpdate: 'DEFINE_MANY',

                    /**
                     * Invoked when the component's DOM representation has been updated.
                     *
                     * Use this as an opportunity to operate on the DOM when the component has
                     * been updated.
                     *
                     * @param {object} prevProps
                     * @param {?object} prevState
                     * @param {?object} prevContext
                     * @param {DOMElement} rootNode DOM element representing the component.
                     * @optional
                     */
                    componentDidUpdate: 'DEFINE_MANY',

                    /**
                     * Invoked when the component is about to be removed from its parent and have
                     * its DOM representation destroyed.
                     *
                     * Use this as an opportunity to deallocate any external resources.
                     *
                     * NOTE: There is no `componentDidUnmount` since your component will have been
                     * destroyed by that point.
                     *
                     * @optional
                     */
                    componentWillUnmount: 'DEFINE_MANY',

                    // ==== Advanced methods ====

                    /**
                     * Updates the component's currently mounted DOM representation.
                     *
                     * By default, this implements React's rendering and reconciliation algorithm.
                     * Sophisticated clients may wish to override this.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     * @overridable
                     */
                    updateComponent: 'OVERRIDE_BASE'
                };

                /**
                 * Mapping from class specification keys to special processing functions.
                 *
                 * Although these are declared like instance properties in the specification
                 * when defining classes using `React.createClass`, they are actually static
                 * and are accessible on the constructor instead of the prototype. Despite
                 * being static, they must be defined outside of the "statics" key under
                 * which all other static methods are defined.
                 */
                var RESERVED_SPEC_KEYS = {
                    displayName: function (Constructor, displayName) {
                        Constructor.displayName = displayName;
                    },
                    mixins: function (Constructor, mixins) {
                        if (mixins) {
                            for (var i = 0; i < mixins.length; i++) {
                                mixSpecIntoComponent(Constructor, mixins[i]);
                            }
                        }
                    },
                    childContextTypes: function (Constructor, childContextTypes) {
                        if ("development" !== 'production') {
                            validateTypeDef(Constructor, childContextTypes, 'childContext');
                        }
                        Constructor.childContextTypes = _assign(
                            {},
                            Constructor.childContextTypes,
                            childContextTypes
                        );
                    },
                    contextTypes: function (Constructor, contextTypes) {
                        if ("development" !== 'production') {
                            validateTypeDef(Constructor, contextTypes, 'context');
                        }
                        Constructor.contextTypes = _assign(
                            {},
                            Constructor.contextTypes,
                            contextTypes
                        );
                    },
                    /**
                     * Special case getDefaultProps which should move into statics but requires
                     * automatic merging.
                     */
                    getDefaultProps: function (Constructor, getDefaultProps) {
                        if (Constructor.getDefaultProps) {
                            Constructor.getDefaultProps = createMergedResultFunction(
                                Constructor.getDefaultProps,
                                getDefaultProps
                            );
                        } else {
                            Constructor.getDefaultProps = getDefaultProps;
                        }
                    },
                    propTypes: function (Constructor, propTypes) {
                        if ("development" !== 'production') {
                            validateTypeDef(Constructor, propTypes, 'prop');
                        }
                        Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
                    },
                    statics: function (Constructor, statics) {
                        mixStaticSpecIntoComponent(Constructor, statics);
                    },
                    autobind: function () { }
                };

                function validateTypeDef(Constructor, typeDef, location) {
                    for (var propName in typeDef) {
                        if (typeDef.hasOwnProperty(propName)) {
                            // use a warning instead of an _invariant so components
                            // don't show up in prod but only in __DEV__
                            if ("development" !== 'production') {
                                warning(
                                    typeof typeDef[propName] === 'function',
                                    '%s: %s type `%s` is invalid; it must be a function, usually from ' +
                                    'React.PropTypes.',
                                    Constructor.displayName || 'ReactClass',
                                    ReactPropTypeLocationNames[location],
                                    propName
                                );
                            }
                        }
                    }
                }

                function validateMethodOverride(isAlreadyDefined, name) {
                    var specPolicy = ReactClassInterface.hasOwnProperty(name)
                        ? ReactClassInterface[name]
                        : null;

                    // Disallow overriding of base class methods unless explicitly allowed.
                    if (ReactClassMixin.hasOwnProperty(name)) {
                        _invariant(
                            specPolicy === 'OVERRIDE_BASE',
                            'ReactClassInterface: You are attempting to override ' +
                            '`%s` from your class specification. Ensure that your method names ' +
                            'do not overlap with React methods.',
                            name
                        );
                    }

                    // Disallow defining methods more than once unless explicitly allowed.
                    if (isAlreadyDefined) {
                        _invariant(
                            specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
                            'ReactClassInterface: You are attempting to define ' +
                            '`%s` on your component more than once. This conflict may be due ' +
                            'to a mixin.',
                            name
                        );
                    }
                }

                /**
                 * Mixin helper which handles policy validation and reserved
                 * specification keys when building React classes.
                 */
                function mixSpecIntoComponent(Constructor, spec) {
                    if (!spec) {
                        if ("development" !== 'production') {
                            var typeofSpec = typeof spec;
                            var isMixinValid = typeofSpec === 'object' && spec !== null;

                            if ("development" !== 'production') {
                                warning(
                                    isMixinValid,
                                    "%s: You're attempting to include a mixin that is either null " +
                                    'or not an object. Check the mixins included by the component, ' +
                                    'as well as any mixins they include themselves. ' +
                                    'Expected object but got %s.',
                                    Constructor.displayName || 'ReactClass',
                                    spec === null ? null : typeofSpec
                                );
                            }
                        }

                        return;
                    }

                    _invariant(
                        typeof spec !== 'function',
                        "ReactClass: You're attempting to " +
                        'use a component class or function as a mixin. Instead, just use a ' +
                        'regular object.'
                    );
                    _invariant(
                        !isValidElement(spec),
                        "ReactClass: You're attempting to " +
                        'use a component as a mixin. Instead, just use a regular object.'
                    );

                    var proto = Constructor.prototype;
                    var autoBindPairs = proto.__reactAutoBindPairs;

                    // By handling mixins before any other properties, we ensure the same
                    // chaining order is applied to methods with DEFINE_MANY policy, whether
                    // mixins are listed before or after these methods in the spec.
                    if (spec.hasOwnProperty(MIXINS_KEY)) {
                        RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
                    }

                    for (var name in spec) {
                        if (!spec.hasOwnProperty(name)) {
                            continue;
                        }

                        if (name === MIXINS_KEY) {
                            // We have already handled mixins in a special case above.
                            continue;
                        }

                        var property = spec[name];
                        var isAlreadyDefined = proto.hasOwnProperty(name);
                        validateMethodOverride(isAlreadyDefined, name);

                        if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
                            RESERVED_SPEC_KEYS[name](Constructor, property);
                        } else {
                            // Setup methods on prototype:
                            // The following member methods should not be automatically bound:
                            // 1. Expected ReactClass methods (in the "interface").
                            // 2. Overridden methods (that were mixed in).
                            var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                            var isFunction = typeof property === 'function';
                            var shouldAutoBind =
                                isFunction &&
                                !isReactClassMethod &&
                                !isAlreadyDefined &&
                                spec.autobind !== false;

                            if (shouldAutoBind) {
                                autoBindPairs.push(name, property);
                                proto[name] = property;
                            } else {
                                if (isAlreadyDefined) {
                                    var specPolicy = ReactClassInterface[name];

                                    // These cases should already be caught by validateMethodOverride.
                                    _invariant(
                                        isReactClassMethod &&
                                        (specPolicy === 'DEFINE_MANY_MERGED' ||
                                            specPolicy === 'DEFINE_MANY'),
                                        'ReactClass: Unexpected spec policy %s for key %s ' +
                                        'when mixing in component specs.',
                                        specPolicy,
                                        name
                                    );

                                    // For methods which are defined more than once, call the existing
                                    // methods before calling the new property, merging if appropriate.
                                    if (specPolicy === 'DEFINE_MANY_MERGED') {
                                        proto[name] = createMergedResultFunction(proto[name], property);
                                    } else if (specPolicy === 'DEFINE_MANY') {
                                        proto[name] = createChainedFunction(proto[name], property);
                                    }
                                } else {
                                    proto[name] = property;
                                    if ("development" !== 'production') {
                                        // Add verbose displayName to the function, which helps when looking
                                        // at profiling tools.
                                        if (typeof property === 'function' && spec.displayName) {
                                            proto[name].displayName = spec.displayName + '_' + name;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                function mixStaticSpecIntoComponent(Constructor, statics) {
                    if (!statics) {
                        return;
                    }
                    for (var name in statics) {
                        var property = statics[name];
                        if (!statics.hasOwnProperty(name)) {
                            continue;
                        }

                        var isReserved = name in RESERVED_SPEC_KEYS;
                        _invariant(
                            !isReserved,
                            'ReactClass: You are attempting to define a reserved ' +
                            'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
                            'as an instance property instead; it will still be accessible on the ' +
                            'constructor.',
                            name
                        );

                        var isInherited = name in Constructor;
                        _invariant(
                            !isInherited,
                            'ReactClass: You are attempting to define ' +
                            '`%s` on your component more than once. This conflict may be ' +
                            'due to a mixin.',
                            name
                        );
                        Constructor[name] = property;
                    }
                }

                /**
                 * Merge two objects, but throw if both contain the same key.
                 *
                 * @param {object} one The first object, which is mutated.
                 * @param {object} two The second object
                 * @return {object} one after it has been mutated to contain everything in two.
                 */
                function mergeIntoWithNoDuplicateKeys(one, two) {
                    _invariant(
                        one && two && typeof one === 'object' && typeof two === 'object',
                        'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
                    );

                    for (var key in two) {
                        if (two.hasOwnProperty(key)) {
                            _invariant(
                                one[key] === undefined,
                                'mergeIntoWithNoDuplicateKeys(): ' +
                                'Tried to merge two objects with the same key: `%s`. This conflict ' +
                                'may be due to a mixin; in particular, this may be caused by two ' +
                                'getInitialState() or getDefaultProps() methods returning objects ' +
                                'with clashing keys.',
                                key
                            );
                            one[key] = two[key];
                        }
                    }
                    return one;
                }

                /**
                 * Creates a function that invokes two functions and merges their return values.
                 *
                 * @param {function} one Function to invoke first.
                 * @param {function} two Function to invoke second.
                 * @return {function} Function that invokes the two argument functions.
                 * @private
                 */
                function createMergedResultFunction(one, two) {
                    return function mergedResult() {
                        var a = one.apply(this, arguments);
                        var b = two.apply(this, arguments);
                        if (a == null) {
                            return b;
                        } else if (b == null) {
                            return a;
                        }
                        var c = {};
                        mergeIntoWithNoDuplicateKeys(c, a);
                        mergeIntoWithNoDuplicateKeys(c, b);
                        return c;
                    };
                }

                /**
                 * Creates a function that invokes two functions and ignores their return vales.
                 *
                 * @param {function} one Function to invoke first.
                 * @param {function} two Function to invoke second.
                 * @return {function} Function that invokes the two argument functions.
                 * @private
                 */
                function createChainedFunction(one, two) {
                    return function chainedFunction() {
                        one.apply(this, arguments);
                        two.apply(this, arguments);
                    };
                }

                /**
                 * Binds a method to the component.
                 *
                 * @param {object} component Component whose method is going to be bound.
                 * @param {function} method Method to be bound.
                 * @return {function} The bound method.
                 */
                function bindAutoBindMethod(component, method) {
                    var boundMethod = method.bind(component);
                    if ("development" !== 'production') {
                        boundMethod.__reactBoundContext = component;
                        boundMethod.__reactBoundMethod = method;
                        boundMethod.__reactBoundArguments = null;
                        var componentName = component.constructor.displayName;
                        var _bind = boundMethod.bind;
                        boundMethod.bind = function (newThis) {
                            for (
                                var _len = arguments.length,
                                args = Array(_len > 1 ? _len - 1 : 0),
                                _key = 1;
                                _key < _len;
                                _key++
                            ) {
                                args[_key - 1] = arguments[_key];
                            }

                            // User is trying to bind() an autobound method; we effectively will
                            // ignore the value of "this" that the user is trying to use, so
                            // let's warn.
                            if (newThis !== component && newThis !== null) {
                                if ("development" !== 'production') {
                                    warning(
                                        false,
                                        'bind(): React component methods may only be bound to the ' +
                                        'component instance. See %s',
                                        componentName
                                    );
                                }
                            } else if (!args.length) {
                                if ("development" !== 'production') {
                                    warning(
                                        false,
                                        'bind(): You are binding a component method to the component. ' +
                                        'React does this for you automatically in a high-performance ' +
                                        'way, so you can safely remove this call. See %s',
                                        componentName
                                    );
                                }
                                return boundMethod;
                            }
                            var reboundMethod = _bind.apply(boundMethod, arguments);
                            reboundMethod.__reactBoundContext = component;
                            reboundMethod.__reactBoundMethod = method;
                            reboundMethod.__reactBoundArguments = args;
                            return reboundMethod;
                        };
                    }
                    return boundMethod;
                }

                /**
                 * Binds all auto-bound methods in a component.
                 *
                 * @param {object} component Component whose method is going to be bound.
                 */
                function bindAutoBindMethods(component) {
                    var pairs = component.__reactAutoBindPairs;
                    for (var i = 0; i < pairs.length; i += 2) {
                        var autoBindKey = pairs[i];
                        var method = pairs[i + 1];
                        component[autoBindKey] = bindAutoBindMethod(component, method);
                    }
                }

                var IsMountedPreMixin = {
                    componentDidMount: function () {
                        this.__isMounted = true;
                    }
                };

                var IsMountedPostMixin = {
                    componentWillUnmount: function () {
                        this.__isMounted = false;
                    }
                };

                /**
                 * Add more to the ReactClass base class. These are all legacy features and
                 * therefore not already part of the modern ReactComponent.
                 */
                var ReactClassMixin = {
                    /**
                     * TODO: This will be deprecated because state should always keep a consistent
                     * type signature and the only use case for this, is to avoid that.
                     */
                    replaceState: function (newState, callback) {
                        this.updater.enqueueReplaceState(this, newState, callback);
                    },

                    /**
                     * Checks whether or not this composite component is mounted.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */
                    isMounted: function () {
                        if ("development" !== 'production') {
                            warning(
                                this.__didWarnIsMounted,
                                '%s: isMounted is deprecated. Instead, make sure to clean up ' +
                                'subscriptions and pending requests in componentWillUnmount to ' +
                                'prevent memory leaks.',
                                (this.constructor && this.constructor.displayName) ||
                                this.name ||
                                'Component'
                            );
                            this.__didWarnIsMounted = true;
                        }
                        return !!this.__isMounted;
                    }
                };

                var ReactClassComponent = function () { };
                _assign(
                    ReactClassComponent.prototype,
                    ReactComponent.prototype,
                    ReactClassMixin
                );

                /**
                 * Creates a composite component class given a class specification.
                 * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
                 *
                 * @param {object} spec Class specification (which must define `render`).
                 * @return {function} Component constructor function.
                 * @public
                 */
                function createClass(spec) {
                    // To keep our warnings more understandable, we'll use a little hack here to
                    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
                    // unnecessarily identify a class without displayName as 'Constructor'.
                    var Constructor = identity(function (props, context, updater) {
                        // This constructor gets overridden by mocks. The argument is used
                        // by mocks to assert on what gets mounted.

                        if ("development" !== 'production') {
                            warning(
                                this instanceof Constructor,
                                'Something is calling a React component directly. Use a factory or ' +
                                'JSX instead. See: https://fb.me/react-legacyfactory'
                            );
                        }

                        // Wire up auto-binding
                        if (this.__reactAutoBindPairs.length) {
                            bindAutoBindMethods(this);
                        }

                        this.props = props;
                        this.context = context;
                        this.refs = emptyObject;
                        this.updater = updater || ReactNoopUpdateQueue;

                        this.state = null;

                        // ReactClasses doesn't have constructors. Instead, they use the
                        // getInitialState and componentWillMount methods for initialization.

                        var initialState = this.getInitialState ? this.getInitialState() : null;
                        if ("development" !== 'production') {
                            // We allow auto-mocks to proceed as if they're returning null.
                            if (
                                initialState === undefined &&
                                this.getInitialState._isMockFunction
                            ) {
                                // This is probably bad practice. Consider warning here and
                                // deprecating this convenience.
                                initialState = null;
                            }
                        }
                        _invariant(
                            typeof initialState === 'object' && !Array.isArray(initialState),
                            '%s.getInitialState(): must return an object or null',
                            Constructor.displayName || 'ReactCompositeComponent'
                        );

                        this.state = initialState;
                    });
                    Constructor.prototype = new ReactClassComponent();
                    Constructor.prototype.constructor = Constructor;
                    Constructor.prototype.__reactAutoBindPairs = [];

                    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

                    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
                    mixSpecIntoComponent(Constructor, spec);
                    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

                    // Initialize the defaultProps property after all mixins have been merged.
                    if (Constructor.getDefaultProps) {
                        Constructor.defaultProps = Constructor.getDefaultProps();
                    }

                    if ("development" !== 'production') {
                        // This is a tag to indicate that the use of these method names is ok,
                        // since it's used with createClass. If it's not, then it's likely a
                        // mistake so we'll warn you to use the static property, property
                        // initializer or constructor respectively.
                        if (Constructor.getDefaultProps) {
                            Constructor.getDefaultProps.isReactClassApproved = {};
                        }
                        if (Constructor.prototype.getInitialState) {
                            Constructor.prototype.getInitialState.isReactClassApproved = {};
                        }
                    }

                    _invariant(
                        Constructor.prototype.render,
                        'createClass(...): Class specification must implement a `render` method.'
                    );

                    if ("development" !== 'production') {
                        warning(
                            !Constructor.prototype.componentShouldUpdate,
                            '%s has a method called ' +
                            'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
                            'The name is phrased as a question because the function is ' +
                            'expected to return a value.',
                            spec.displayName || 'A component'
                        );
                        warning(
                            !Constructor.prototype.componentWillRecieveProps,
                            '%s has a method called ' +
                            'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
                            spec.displayName || 'A component'
                        );
                    }

                    // Reduce time spent doing lookups by setting these on the prototype.
                    for (var methodName in ReactClassInterface) {
                        if (!Constructor.prototype[methodName]) {
                            Constructor.prototype[methodName] = null;
                        }
                    }

                    return Constructor;
                }

                return createClass;
            }

            module.exports = factory;

        }, { "29": 29, "30": 30, "31": 31, "32": 32 }], 28: [function (_dereq_, module, exports) {
            "use strict";

            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             * 
             */

            function makeEmptyFunction(arg) {
                return function () {
                    return arg;
                };
            }

            /**
             * This function accepts and discards inputs; it has no side effects. This is
             * primarily useful idiomatically for overridable function endpoints which
             * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
             */
            var emptyFunction = function emptyFunction() { };

            emptyFunction.thatReturns = makeEmptyFunction;
            emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
            emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
            emptyFunction.thatReturnsNull = makeEmptyFunction(null);
            emptyFunction.thatReturnsThis = function () {
                return this;
            };
            emptyFunction.thatReturnsArgument = function (arg) {
                return arg;
            };

            module.exports = emptyFunction;
        }, {}], 29: [function (_dereq_, module, exports) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var emptyObject = {};

            if ("development" !== 'production') {
                Object.freeze(emptyObject);
            }

            module.exports = emptyObject;
        }, {}], 30: [function (_dereq_, module, exports) {
            /**
             * Copyright (c) 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            /**
             * Use invariant() to assert state which your program assumes to be true.
             *
             * Provide sprintf-style format (only %s is supported) and arguments
             * to provide information about what broke and what you were
             * expecting.
             *
             * The invariant message will be stripped in production, but the invariant
             * will remain to ensure logic does not differ in production.
             */

            var validateFormat = function validateFormat(format) { };

            if ("development" !== 'production') {
                validateFormat = function validateFormat(format) {
                    if (format === undefined) {
                        throw new Error('invariant requires an error message argument');
                    }
                };
            }

            function invariant(condition, format, a, b, c, d, e, f) {
                validateFormat(format);

                if (!condition) {
                    var error;
                    if (format === undefined) {
                        error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
                    } else {
                        var args = [a, b, c, d, e, f];
                        var argIndex = 0;
                        error = new Error(format.replace(/%s/g, function () {
                            return args[argIndex++];
                        }));
                        error.name = 'Invariant Violation';
                    }

                    error.framesToPop = 1; // we don't care about invariant's own frame
                    throw error;
                }
            }

            module.exports = invariant;
        }, {}], 31: [function (_dereq_, module, exports) {
            /**
             * Copyright 2014-2015, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             *
             */

            'use strict';

            var emptyFunction = _dereq_(28);

            /**
             * Similar to invariant but only logs a warning if the condition is not met.
             * This can be used to log issues in development environments in critical
             * paths. Removing the logging code for production environments will keep the
             * same logic and follow the same code paths.
             */

            var warning = emptyFunction;

            if ("development" !== 'production') {
                (function () {
                    var printWarning = function printWarning(format) {
                        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                            args[_key - 1] = arguments[_key];
                        }

                        var argIndex = 0;
                        var message = 'Warning: ' + format.replace(/%s/g, function () {
                            return args[argIndex++];
                        });
                        if (typeof console !== 'undefined') {
                            console.error(message);
                        }
                        try {
                            // --- Welcome to debugging React ---
                            // This error was thrown as a convenience so that you can use this stack
                            // to find the callsite that caused this warning to fire.
                            throw new Error(message);
                        } catch (x) { }
                    };

                    warning = function warning(condition, format) {
                        if (format === undefined) {
                            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
                        }

                        if (format.indexOf('Failed Composite propType: ') === 0) {
                            return; // Ignore CompositeComponent proptype check.
                        }

                        if (!condition) {
                            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                                args[_key2 - 2] = arguments[_key2];
                            }

                            printWarning.apply(undefined, [format].concat(args));
                        }
                    };
                })();
            }

            module.exports = warning;
        }, { "28": 28 }], 32: [function (_dereq_, module, exports) {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */

            'use strict';
            /* eslint-disable no-unused-vars */
            var getOwnPropertySymbols = Object.getOwnPropertySymbols;
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            var propIsEnumerable = Object.prototype.propertyIsEnumerable;

            function toObject(val) {
                if (val === null || val === undefined) {
                    throw new TypeError('Object.assign cannot be called with null or undefined');
                }

                return Object(val);
            }

            function shouldUseNative() {
                try {
                    if (!Object.assign) {
                        return false;
                    }

                    // Detect buggy property enumeration order in older V8 versions.

                    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                    var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
                    test1[5] = 'de';
                    if (Object.getOwnPropertyNames(test1)[0] === '5') {
                        return false;
                    }

                    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                    var test2 = {};
                    for (var i = 0; i < 10; i++) {
                        test2['_' + String.fromCharCode(i)] = i;
                    }
                    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                        return test2[n];
                    });
                    if (order2.join('') !== '0123456789') {
                        return false;
                    }

                    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                    var test3 = {};
                    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                        test3[letter] = letter;
                    });
                    if (Object.keys(Object.assign({}, test3)).join('') !==
                        'abcdefghijklmnopqrst') {
                        return false;
                    }

                    return true;
                } catch (err) {
                    // We don't expect any of the above to throw, but better to be safe.
                    return false;
                }
            }

            module.exports = shouldUseNative() ? Object.assign : function (target, source) {
                var from;
                var to = toObject(target);
                var symbols;

                for (var s = 1; s < arguments.length; s++) {
                    from = Object(arguments[s]);

                    for (var key in from) {
                        if (hasOwnProperty.call(from, key)) {
                            to[key] = from[key];
                        }
                    }

                    if (getOwnPropertySymbols) {
                        symbols = getOwnPropertySymbols(from);
                        for (var i = 0; i < symbols.length; i++) {
                            if (propIsEnumerable.call(from, symbols[i])) {
                                to[symbols[i]] = from[symbols[i]];
                            }
                        }
                    }
                }

                return to;
            };

        }, {}], 33: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             */

            'use strict';

            if ("development" !== 'production') {
                var invariant = _dereq_(30);
                var warning = _dereq_(31);
                var ReactPropTypesSecret = _dereq_(36);
                var loggedTypeFailures = {};
            }

            /**
             * Assert that the values match with the type specs.
             * Error messages are memorized and will only be shown once.
             *
             * @param {object} typeSpecs Map of name to a ReactPropType
             * @param {object} values Runtime values that need to be type-checked
             * @param {string} location e.g. "prop", "context", "child context"
             * @param {string} componentName Name of the component for error messages.
             * @param {?Function} getStack Returns the component stack.
             * @private
             */
            function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                if ("development" !== 'production') {
                    for (var typeSpecName in typeSpecs) {
                        if (typeSpecs.hasOwnProperty(typeSpecName)) {
                            var error;
                            // Prop type validation may throw. In case they do, we don't want to
                            // fail the render phase where it didn't fail before. So we log it.
                            // After these have been cleaned up, we'll let them throw.
                            try {
                                // This is intentionally an invariant that gets caught. It's the same
                                // behavior as without this statement except with a better message.
                                invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
                                error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                            } catch (ex) {
                                error = ex;
                            }
                            warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
                            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                                // Only monitor this failure once because there tends to be a lot of the
                                // same error.
                                loggedTypeFailures[error.message] = true;

                                var stack = getStack ? getStack() : '';

                                warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
                            }
                        }
                    }
                }
            }

            module.exports = checkPropTypes;

        }, { "30": 30, "31": 31, "36": 36 }], 34: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             */

            'use strict';

            // React 15.5 references this module, and assumes PropTypes are still callable in production.
            // Therefore we re-export development-only version with all the PropTypes checks here.
            // However if one is migrating to the `prop-types` npm library, they will go through the
            // `index.js` entry point, and it will branch depending on the environment.
            var factory = _dereq_(35);
            module.exports = function (isValidElement) {
                // It is still allowed in 15.5.
                var throwOnDirectAccess = false;
                return factory(isValidElement, throwOnDirectAccess);
            };

        }, { "35": 35 }], 35: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             */

            'use strict';

            var emptyFunction = _dereq_(28);
            var invariant = _dereq_(30);
            var warning = _dereq_(31);

            var ReactPropTypesSecret = _dereq_(36);
            var checkPropTypes = _dereq_(33);

            module.exports = function (isValidElement, throwOnDirectAccess) {
                /* global Symbol */
                var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

                /**
                 * Returns the iterator method function contained on the iterable object.
                 *
                 * Be sure to invoke the function with the iterable as context:
                 *
                 *     var iteratorFn = getIteratorFn(myIterable);
                 *     if (iteratorFn) {
                 *       var iterator = iteratorFn.call(myIterable);
                 *       ...
                 *     }
                 *
                 * @param {?object} maybeIterable
                 * @return {?function}
                 */
                function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === 'function') {
                        return iteratorFn;
                    }
                }

                /**
                 * Collection of methods that allow declaration and validation of props that are
                 * supplied to React components. Example usage:
                 *
                 *   var Props = require('ReactPropTypes');
                 *   var MyArticle = React.createClass({
                 *     propTypes: {
                 *       // An optional string prop named "description".
                 *       description: Props.string,
                 *
                 *       // A required enum prop named "category".
                 *       category: Props.oneOf(['News','Photos']).isRequired,
                 *
                 *       // A prop named "dialog" that requires an instance of Dialog.
                 *       dialog: Props.instanceOf(Dialog).isRequired
                 *     },
                 *     render: function() { ... }
                 *   });
                 *
                 * A more formal specification of how these methods are used:
                 *
                 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
                 *   decl := ReactPropTypes.{type}(.isRequired)?
                 *
                 * Each and every declaration produces a function with the same signature. This
                 * allows the creation of custom validation functions. For example:
                 *
                 *  var MyLink = React.createClass({
                 *    propTypes: {
                 *      // An optional string or URI prop named "href".
                 *      href: function(props, propName, componentName) {
                 *        var propValue = props[propName];
                 *        if (propValue != null && typeof propValue !== 'string' &&
                 *            !(propValue instanceof URI)) {
                 *          return new Error(
                 *            'Expected a string or an URI for ' + propName + ' in ' +
                 *            componentName
                 *          );
                 *        }
                 *      }
                 *    },
                 *    render: function() {...}
                 *  });
                 *
                 * @internal
                 */

                var ANONYMOUS = '<<anonymous>>';

                // Important!
                // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                var ReactPropTypes = {
                    array: createPrimitiveTypeChecker('array'),
                    bool: createPrimitiveTypeChecker('boolean'),
                    func: createPrimitiveTypeChecker('function'),
                    number: createPrimitiveTypeChecker('number'),
                    object: createPrimitiveTypeChecker('object'),
                    string: createPrimitiveTypeChecker('string'),
                    symbol: createPrimitiveTypeChecker('symbol'),

                    any: createAnyTypeChecker(),
                    arrayOf: createArrayOfTypeChecker,
                    element: createElementTypeChecker(),
                    instanceOf: createInstanceTypeChecker,
                    node: createNodeChecker(),
                    objectOf: createObjectOfTypeChecker,
                    oneOf: createEnumTypeChecker,
                    oneOfType: createUnionTypeChecker,
                    shape: createShapeTypeChecker
                };

                /**
                 * inlined Object.is polyfill to avoid requiring consumers ship their own
                 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
                 */
                /*eslint-disable no-self-compare*/
                function is(x, y) {
                    // SameValue algorithm
                    if (x === y) {
                        // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        return x !== 0 || 1 / x === 1 / y;
                    } else {
                        // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                }
                /*eslint-enable no-self-compare*/

                /**
                 * We use an Error-like object for backward compatibility as people may call
                 * PropTypes directly and inspect their output. However, we don't use real
                 * Errors anymore. We don't inspect their stack anyway, and creating them
                 * is prohibitively expensive if they are created too often, such as what
                 * happens in oneOfType() for any type before the one that matched.
                 */
                function PropTypeError(message) {
                    this.message = message;
                    this.stack = '';
                }
                // Make `instanceof Error` still work for returned errors.
                PropTypeError.prototype = Error.prototype;

                function createChainableTypeChecker(validate) {
                    if ("development" !== 'production') {
                        var manualPropTypeCallCache = {};
                        var manualPropTypeWarningCount = 0;
                    }
                    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                        componentName = componentName || ANONYMOUS;
                        propFullName = propFullName || propName;

                        if (secret !== ReactPropTypesSecret) {
                            if (throwOnDirectAccess) {
                                // New behavior only for users of `prop-types` package
                                invariant(
                                    false,
                                    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
                                    'Use `PropTypes.checkPropTypes()` to call them. ' +
                                    'Read more at http://fb.me/use-check-prop-types'
                                );
                            } else if ("development" !== 'production' && typeof console !== 'undefined') {
                                // Old behavior for people using React.PropTypes
                                var cacheKey = componentName + ':' + propName;
                                if (
                                    !manualPropTypeCallCache[cacheKey] &&
                                    // Avoid spamming the console because they are often not actionable except for lib authors
                                    manualPropTypeWarningCount < 3
                                ) {
                                    warning(
                                        false,
                                        'You are manually calling a React.PropTypes validation ' +
                                        'function for the `%s` prop on `%s`. This is deprecated ' +
                                        'and will throw in the standalone `prop-types` package. ' +
                                        'You may be seeing this warning due to a third-party PropTypes ' +
                                        'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                                        propFullName,
                                        componentName
                                    );
                                    manualPropTypeCallCache[cacheKey] = true;
                                    manualPropTypeWarningCount++;
                                }
                            }
                        }
                        if (props[propName] == null) {
                            if (isRequired) {
                                if (props[propName] === null) {
                                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                                }
                                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                            }
                            return null;
                        } else {
                            return validate(props, propName, componentName, location, propFullName);
                        }
                    }

                    var chainedCheckType = checkType.bind(null, false);
                    chainedCheckType.isRequired = checkType.bind(null, true);

                    return chainedCheckType;
                }

                function createPrimitiveTypeChecker(expectedType) {
                    function validate(props, propName, componentName, location, propFullName, secret) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== expectedType) {
                            // `propValue` being instance of, say, date/regexp, pass the 'object'
                            // check, but we can offer a more precise error message here rather than
                            // 'of type `object`'.
                            var preciseType = getPreciseType(propValue);

                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createAnyTypeChecker() {
                    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
                }

                function createArrayOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== 'function') {
                            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
                        }
                        var propValue = props[propName];
                        if (!Array.isArray(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
                        }
                        for (var i = 0; i < propValue.length; i++) {
                            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                            if (error instanceof Error) {
                                return error;
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createElementTypeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            var propType = getPropType(propValue);
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createInstanceTypeChecker(expectedClass) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!(props[propName] instanceof expectedClass)) {
                            var expectedClassName = expectedClass.name || ANONYMOUS;
                            var actualClassName = getClassName(props[propName]);
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createEnumTypeChecker(expectedValues) {
                    if (!Array.isArray(expectedValues)) {
                        "development" !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
                        return emptyFunction.thatReturnsNull;
                    }

                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        for (var i = 0; i < expectedValues.length; i++) {
                            if (is(propValue, expectedValues[i])) {
                                return null;
                            }
                        }

                        var valuesString = JSON.stringify(expectedValues);
                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
                    }
                    return createChainableTypeChecker(validate);
                }

                function createObjectOfTypeChecker(typeChecker) {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (typeof typeChecker !== 'function') {
                            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
                        }
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== 'object') {
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
                        }
                        for (var key in propValue) {
                            if (propValue.hasOwnProperty(key)) {
                                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                                if (error instanceof Error) {
                                    return error;
                                }
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createUnionTypeChecker(arrayOfTypeCheckers) {
                    if (!Array.isArray(arrayOfTypeCheckers)) {
                        "development" !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
                        return emptyFunction.thatReturnsNull;
                    }

                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                        var checker = arrayOfTypeCheckers[i];
                        if (typeof checker !== 'function') {
                            warning(
                                false,
                                'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
                                'received %s at index %s.',
                                getPostfixForTypeWarning(checker),
                                i
                            );
                            return emptyFunction.thatReturnsNull;
                        }
                    }

                    function validate(props, propName, componentName, location, propFullName) {
                        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                            var checker = arrayOfTypeCheckers[i];
                            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                                return null;
                            }
                        }

                        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
                    }
                    return createChainableTypeChecker(validate);
                }

                function createNodeChecker() {
                    function validate(props, propName, componentName, location, propFullName) {
                        if (!isNode(props[propName])) {
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function createShapeTypeChecker(shapeTypes) {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        var propType = getPropType(propValue);
                        if (propType !== 'object') {
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                        }
                        for (var key in shapeTypes) {
                            var checker = shapeTypes[key];
                            if (!checker) {
                                continue;
                            }
                            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                            if (error) {
                                return error;
                            }
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }

                function isNode(propValue) {
                    switch (typeof propValue) {
                        case 'number':
                        case 'string':
                        case 'undefined':
                            return true;
                        case 'boolean':
                            return !propValue;
                        case 'object':
                            if (Array.isArray(propValue)) {
                                return propValue.every(isNode);
                            }
                            if (propValue === null || isValidElement(propValue)) {
                                return true;
                            }

                            var iteratorFn = getIteratorFn(propValue);
                            if (iteratorFn) {
                                var iterator = iteratorFn.call(propValue);
                                var step;
                                if (iteratorFn !== propValue.entries) {
                                    while (!(step = iterator.next()).done) {
                                        if (!isNode(step.value)) {
                                            return false;
                                        }
                                    }
                                } else {
                                    // Iterator will provide entry [k,v] tuples rather than values.
                                    while (!(step = iterator.next()).done) {
                                        var entry = step.value;
                                        if (entry) {
                                            if (!isNode(entry[1])) {
                                                return false;
                                            }
                                        }
                                    }
                                }
                            } else {
                                return false;
                            }

                            return true;
                        default:
                            return false;
                    }
                }

                function isSymbol(propType, propValue) {
                    // Native Symbol.
                    if (propType === 'symbol') {
                        return true;
                    }

                    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                    if (propValue['@@toStringTag'] === 'Symbol') {
                        return true;
                    }

                    // Fallback for non-spec compliant Symbols which are polyfilled.
                    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
                        return true;
                    }

                    return false;
                }

                // Equivalent of `typeof` but with special handling for array and regexp.
                function getPropType(propValue) {
                    var propType = typeof propValue;
                    if (Array.isArray(propValue)) {
                        return 'array';
                    }
                    if (propValue instanceof RegExp) {
                        // Old webkits (at least until Android 4.0) return 'function' rather than
                        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                        // passes PropTypes.object.
                        return 'object';
                    }
                    if (isSymbol(propType, propValue)) {
                        return 'symbol';
                    }
                    return propType;
                }

                // This handles more types than `getPropType`. Only used for error messages.
                // See `createPrimitiveTypeChecker`.
                function getPreciseType(propValue) {
                    if (typeof propValue === 'undefined' || propValue === null) {
                        return '' + propValue;
                    }
                    var propType = getPropType(propValue);
                    if (propType === 'object') {
                        if (propValue instanceof Date) {
                            return 'date';
                        } else if (propValue instanceof RegExp) {
                            return 'regexp';
                        }
                    }
                    return propType;
                }

                // Returns a string that is postfixed to a warning about an invalid type.
                // For example, "undefined" or "of type array"
                function getPostfixForTypeWarning(value) {
                    var type = getPreciseType(value);
                    switch (type) {
                        case 'array':
                        case 'object':
                            return 'an ' + type;
                        case 'boolean':
                        case 'date':
                        case 'regexp':
                            return 'a ' + type;
                        default:
                            return type;
                    }
                }

                // Returns class name of the object, if any.
                function getClassName(propValue) {
                    if (!propValue.constructor || !propValue.constructor.name) {
                        return ANONYMOUS;
                    }
                    return propValue.constructor.name;
                }

                ReactPropTypes.checkPropTypes = checkPropTypes;
                ReactPropTypes.PropTypes = ReactPropTypes;

                return ReactPropTypes;
            };

        }, { "28": 28, "30": 30, "31": 31, "33": 33, "36": 36 }], 36: [function (_dereq_, module, exports) {
            /**
             * Copyright 2013-present, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             */

            'use strict';

            var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

            module.exports = ReactPropTypesSecret;

        }, {}]
    }, {}, [16])(16)
});
/**
 * ReactDOM v15.6.1
 */

; (function (f) {
    // CommonJS
    if (typeof exports === "object" && typeof module !== "undefined") {
        module.exports = f(require('react'));

        // RequireJS
    } else if (typeof define === "function" && define.amd) {
        define(['react'], f);

        // <script>
    } else {
        var g;
        if (typeof window !== "undefined") {
            g = window;
        } else if (typeof global !== "undefined") {
            g = global;
        } else if (typeof self !== "undefined") {
            g = self;
        } else {
            // works providing we're not in "use strict";
            // needed for Java 8 Nashorn
            // see https://github.com/facebook/react/issues/3037
            g = this;
        }
        g.ReactDOM = f(g.React);
    }
})(function (React) {
    return (function (f) { return f() })(function () {
        var define, module, exports; return (function e(t, n, r) { function s(o, u) { if (!n[o]) { if (!t[o]) { var a = typeof require == "function" && require; if (!u && a) return a(o, !0); if (i) return i(o, !0); var f = new Error("Cannot find module '" + o + "'"); throw f.code = "MODULE_NOT_FOUND", f } var l = n[o] = { exports: {} }; t[o][0].call(l.exports, function (e) { var n = t[o][1][e]; return s(n ? n : e) }, l, l.exports, e, t, n, r) } return n[o].exports } var i = typeof require == "function" && require; for (var o = 0; o < r.length; o++)s(r[o]); return s })({
            1: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ARIADOMPropertyConfig = {
                    Properties: {
                        // Global States and Properties
                        'aria-current': 0, // state
                        'aria-details': 0,
                        'aria-disabled': 0, // state
                        'aria-hidden': 0, // state
                        'aria-invalid': 0, // state
                        'aria-keyshortcuts': 0,
                        'aria-label': 0,
                        'aria-roledescription': 0,
                        // Widget Attributes
                        'aria-autocomplete': 0,
                        'aria-checked': 0,
                        'aria-expanded': 0,
                        'aria-haspopup': 0,
                        'aria-level': 0,
                        'aria-modal': 0,
                        'aria-multiline': 0,
                        'aria-multiselectable': 0,
                        'aria-orientation': 0,
                        'aria-placeholder': 0,
                        'aria-pressed': 0,
                        'aria-readonly': 0,
                        'aria-required': 0,
                        'aria-selected': 0,
                        'aria-sort': 0,
                        'aria-valuemax': 0,
                        'aria-valuemin': 0,
                        'aria-valuenow': 0,
                        'aria-valuetext': 0,
                        // Live Region Attributes
                        'aria-atomic': 0,
                        'aria-busy': 0,
                        'aria-live': 0,
                        'aria-relevant': 0,
                        // Drag-and-Drop Attributes
                        'aria-dropeffect': 0,
                        'aria-grabbed': 0,
                        // Relationship Attributes
                        'aria-activedescendant': 0,
                        'aria-colcount': 0,
                        'aria-colindex': 0,
                        'aria-colspan': 0,
                        'aria-controls': 0,
                        'aria-describedby': 0,
                        'aria-errormessage': 0,
                        'aria-flowto': 0,
                        'aria-labelledby': 0,
                        'aria-owns': 0,
                        'aria-posinset': 0,
                        'aria-rowcount': 0,
                        'aria-rowindex': 0,
                        'aria-rowspan': 0,
                        'aria-setsize': 0
                    },
                    DOMAttributeNames: {},
                    DOMPropertyNames: {}
                };

                module.exports = ARIADOMPropertyConfig;
            }, {}], 2: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactDOMComponentTree = _dereq_(34);

                var focusNode = _dereq_(146);

                var AutoFocusUtils = {
                    focusDOMComponent: function () {
                        focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
                    }
                };

                module.exports = AutoFocusUtils;
            }, { "146": 146, "34": 34 }], 3: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var EventPropagators = _dereq_(20);
                var ExecutionEnvironment = _dereq_(138);
                var FallbackCompositionState = _dereq_(21);
                var SyntheticCompositionEvent = _dereq_(89);
                var SyntheticInputEvent = _dereq_(93);

                var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
                var START_KEYCODE = 229;

                var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

                var documentMode = null;
                if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
                    documentMode = document.documentMode;
                }

                // Webkit offers a very useful `textInput` event that can be used to
                // directly represent `beforeInput`. The IE `textinput` event is not as
                // useful, so we don't use it.
                var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

                // In IE9+, we have access to composition events, but the data supplied
                // by the native compositionend event may be incorrect. Japanese ideographic
                // spaces, for instance (\u3000) are not recorded correctly.
                var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

                /**
                 * Opera <= 12 includes TextEvent in window, but does not fire
                 * text input events. Rely on keypress instead.
                 */
                function isPresto() {
                    var opera = window.opera;
                    return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
                }

                var SPACEBAR_CODE = 32;
                var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

                // Events and their corresponding property names.
                var eventTypes = {
                    beforeInput: {
                        phasedRegistrationNames: {
                            bubbled: 'onBeforeInput',
                            captured: 'onBeforeInputCapture'
                        },
                        dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
                    },
                    compositionEnd: {
                        phasedRegistrationNames: {
                            bubbled: 'onCompositionEnd',
                            captured: 'onCompositionEndCapture'
                        },
                        dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
                    },
                    compositionStart: {
                        phasedRegistrationNames: {
                            bubbled: 'onCompositionStart',
                            captured: 'onCompositionStartCapture'
                        },
                        dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
                    },
                    compositionUpdate: {
                        phasedRegistrationNames: {
                            bubbled: 'onCompositionUpdate',
                            captured: 'onCompositionUpdateCapture'
                        },
                        dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
                    }
                };

                // Track whether we've ever handled a keypress on the space key.
                var hasSpaceKeypress = false;

                /**
                 * Return whether a native keypress event is assumed to be a command.
                 * This is required because Firefox fires `keypress` events for key commands
                 * (cut, copy, select-all, etc.) even though no character is inserted.
                 */
                function isKeypressCommand(nativeEvent) {
                    return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
                        // ctrlKey && altKey is equivalent to AltGr, and is not a command.
                        !(nativeEvent.ctrlKey && nativeEvent.altKey);
                }

                /**
                 * Translate native top level events into event types.
                 *
                 * @param {string} topLevelType
                 * @return {object}
                 */
                function getCompositionEventType(topLevelType) {
                    switch (topLevelType) {
                        case 'topCompositionStart':
                            return eventTypes.compositionStart;
                        case 'topCompositionEnd':
                            return eventTypes.compositionEnd;
                        case 'topCompositionUpdate':
                            return eventTypes.compositionUpdate;
                    }
                }

                /**
                 * Does our fallback best-guess model think this event signifies that
                 * composition has begun?
                 *
                 * @param {string} topLevelType
                 * @param {object} nativeEvent
                 * @return {boolean}
                 */
                function isFallbackCompositionStart(topLevelType, nativeEvent) {
                    return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
                }

                /**
                 * Does our fallback mode think that this event is the end of composition?
                 *
                 * @param {string} topLevelType
                 * @param {object} nativeEvent
                 * @return {boolean}
                 */
                function isFallbackCompositionEnd(topLevelType, nativeEvent) {
                    switch (topLevelType) {
                        case 'topKeyUp':
                            // Command keys insert or clear IME input.
                            return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
                        case 'topKeyDown':
                            // Expect IME keyCode on each keydown. If we get any other
                            // code we must have exited earlier.
                            return nativeEvent.keyCode !== START_KEYCODE;
                        case 'topKeyPress':
                        case 'topMouseDown':
                        case 'topBlur':
                            // Events are not possible without cancelling IME.
                            return true;
                        default:
                            return false;
                    }
                }

                /**
                 * Google Input Tools provides composition data via a CustomEvent,
                 * with the `data` property populated in the `detail` object. If this
                 * is available on the event object, use it. If not, this is a plain
                 * composition event and we have nothing special to extract.
                 *
                 * @param {object} nativeEvent
                 * @return {?string}
                 */
                function getDataFromCustomEvent(nativeEvent) {
                    var detail = nativeEvent.detail;
                    if (typeof detail === 'object' && 'data' in detail) {
                        return detail.data;
                    }
                    return null;
                }

                // Track the current IME composition fallback object, if any.
                var currentComposition = null;

                /**
                 * @return {?object} A SyntheticCompositionEvent.
                 */
                function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                    var eventType;
                    var fallbackData;

                    if (canUseCompositionEvent) {
                        eventType = getCompositionEventType(topLevelType);
                    } else if (!currentComposition) {
                        if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
                            eventType = eventTypes.compositionStart;
                        }
                    } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
                        eventType = eventTypes.compositionEnd;
                    }

                    if (!eventType) {
                        return null;
                    }

                    if (useFallbackCompositionData) {
                        // The current composition is stored statically and must not be
                        // overwritten while composition continues.
                        if (!currentComposition && eventType === eventTypes.compositionStart) {
                            currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
                        } else if (eventType === eventTypes.compositionEnd) {
                            if (currentComposition) {
                                fallbackData = currentComposition.getData();
                            }
                        }
                    }

                    var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

                    if (fallbackData) {
                        // Inject data generated from fallback path into the synthetic event.
                        // This matches the property of native CompositionEventInterface.
                        event.data = fallbackData;
                    } else {
                        var customData = getDataFromCustomEvent(nativeEvent);
                        if (customData !== null) {
                            event.data = customData;
                        }
                    }

                    EventPropagators.accumulateTwoPhaseDispatches(event);
                    return event;
                }

                /**
                 * @param {string} topLevelType Record from `EventConstants`.
                 * @param {object} nativeEvent Native browser event.
                 * @return {?string} The string corresponding to this `beforeInput` event.
                 */
                function getNativeBeforeInputChars(topLevelType, nativeEvent) {
                    switch (topLevelType) {
                        case 'topCompositionEnd':
                            return getDataFromCustomEvent(nativeEvent);
                        case 'topKeyPress':
                            /**
                             * If native `textInput` events are available, our goal is to make
                             * use of them. However, there is a special case: the spacebar key.
                             * In Webkit, preventing default on a spacebar `textInput` event
                             * cancels character insertion, but it *also* causes the browser
                             * to fall back to its default spacebar behavior of scrolling the
                             * page.
                             *
                             * Tracking at:
                             * https://code.google.com/p/chromium/issues/detail?id=355103
                             *
                             * To avoid this issue, use the keypress event as if no `textInput`
                             * event is available.
                             */
                            var which = nativeEvent.which;
                            if (which !== SPACEBAR_CODE) {
                                return null;
                            }

                            hasSpaceKeypress = true;
                            return SPACEBAR_CHAR;

                        case 'topTextInput':
                            // Record the characters to be added to the DOM.
                            var chars = nativeEvent.data;

                            // If it's a spacebar character, assume that we have already handled
                            // it at the keypress level and bail immediately. Android Chrome
                            // doesn't give us keycodes, so we need to blacklist it.
                            if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                                return null;
                            }

                            return chars;

                        default:
                            // For other native event types, do nothing.
                            return null;
                    }
                }

                /**
                 * For browsers that do not provide the `textInput` event, extract the
                 * appropriate string to use for SyntheticInputEvent.
                 *
                 * @param {string} topLevelType Record from `EventConstants`.
                 * @param {object} nativeEvent Native browser event.
                 * @return {?string} The fallback string for this `beforeInput` event.
                 */
                function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
                    // If we are currently composing (IME) and using a fallback to do so,
                    // try to extract the composed characters from the fallback object.
                    // If composition event is available, we extract a string only at
                    // compositionevent, otherwise extract it at fallback events.
                    if (currentComposition) {
                        if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
                            var chars = currentComposition.getData();
                            FallbackCompositionState.release(currentComposition);
                            currentComposition = null;
                            return chars;
                        }
                        return null;
                    }

                    switch (topLevelType) {
                        case 'topPaste':
                            // If a paste event occurs after a keypress, throw out the input
                            // chars. Paste events should not lead to BeforeInput events.
                            return null;
                        case 'topKeyPress':
                            /**
                             * As of v27, Firefox may fire keypress events even when no character
                             * will be inserted. A few possibilities:
                             *
                             * - `which` is `0`. Arrow keys, Esc key, etc.
                             *
                             * - `which` is the pressed key code, but no char is available.
                             *   Ex: 'AltGr + d` in Polish. There is no modified character for
                             *   this key combination and no character is inserted into the
                             *   document, but FF fires the keypress for char code `100` anyway.
                             *   No `input` event will occur.
                             *
                             * - `which` is the pressed key code, but a command combination is
                             *   being used. Ex: `Cmd+C`. No character is inserted, and no
                             *   `input` event will occur.
                             */
                            if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
                                return String.fromCharCode(nativeEvent.which);
                            }
                            return null;
                        case 'topCompositionEnd':
                            return useFallbackCompositionData ? null : nativeEvent.data;
                        default:
                            return null;
                    }
                }

                /**
                 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
                 * `textInput` or fallback behavior.
                 *
                 * @return {?object} A SyntheticInputEvent.
                 */
                function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                    var chars;

                    if (canUseTextInputEvent) {
                        chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
                    } else {
                        chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
                    }

                    // If no characters are being inserted, no BeforeInput event should
                    // be fired.
                    if (!chars) {
                        return null;
                    }

                    var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

                    event.data = chars;
                    EventPropagators.accumulateTwoPhaseDispatches(event);
                    return event;
                }

                /**
                 * Create an `onBeforeInput` event to match
                 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
                 *
                 * This event plugin is based on the native `textInput` event
                 * available in Chrome, Safari, Opera, and IE. This event fires after
                 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
                 *
                 * `beforeInput` is spec'd but not implemented in any browsers, and
                 * the `input` event does not provide any useful information about what has
                 * actually been added, contrary to the spec. Thus, `textInput` is the best
                 * available event to identify the characters that have actually been inserted
                 * into the target node.
                 *
                 * This plugin is also responsible for emitting `composition` events, thus
                 * allowing us to share composition fallback code for both `beforeInput` and
                 * `composition` event types.
                 */
                var BeforeInputEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
                    }
                };

                module.exports = BeforeInputEventPlugin;
            }, { "138": 138, "20": 20, "21": 21, "89": 89, "93": 93 }], 4: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * CSS properties which accept numbers but are not in units of "px".
                 */

                var isUnitlessNumber = {
                    animationIterationCount: true,
                    borderImageOutset: true,
                    borderImageSlice: true,
                    borderImageWidth: true,
                    boxFlex: true,
                    boxFlexGroup: true,
                    boxOrdinalGroup: true,
                    columnCount: true,
                    flex: true,
                    flexGrow: true,
                    flexPositive: true,
                    flexShrink: true,
                    flexNegative: true,
                    flexOrder: true,
                    gridRow: true,
                    gridRowEnd: true,
                    gridRowSpan: true,
                    gridRowStart: true,
                    gridColumn: true,
                    gridColumnEnd: true,
                    gridColumnSpan: true,
                    gridColumnStart: true,
                    fontWeight: true,
                    lineClamp: true,
                    lineHeight: true,
                    opacity: true,
                    order: true,
                    orphans: true,
                    tabSize: true,
                    widows: true,
                    zIndex: true,
                    zoom: true,

                    // SVG-related properties
                    fillOpacity: true,
                    floodOpacity: true,
                    stopOpacity: true,
                    strokeDasharray: true,
                    strokeDashoffset: true,
                    strokeMiterlimit: true,
                    strokeOpacity: true,
                    strokeWidth: true
                };

                /**
                 * @param {string} prefix vendor-specific prefix, eg: Webkit
                 * @param {string} key style name, eg: transitionDuration
                 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
                 * WebkitTransitionDuration
                 */
                function prefixKey(prefix, key) {
                    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
                }

                /**
                 * Support style names that may come passed in prefixed by adding permutations
                 * of vendor prefixes.
                 */
                var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

                // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
                // infinite loop, because it iterates over the newly added props too.
                Object.keys(isUnitlessNumber).forEach(function (prop) {
                    prefixes.forEach(function (prefix) {
                        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
                    });
                });

                /**
                 * Most style properties can be unset by doing .style[prop] = '' but IE8
                 * doesn't like doing that with shorthand properties so for the properties that
                 * IE8 breaks on, which are listed here, we instead unset each of the
                 * individual properties. See http://bugs.jquery.com/ticket/12385.
                 * The 4-value 'clock' properties like margin, padding, border-width seem to
                 * behave without any problems. Curiously, list-style works too without any
                 * special prodding.
                 */
                var shorthandPropertyExpansions = {
                    background: {
                        backgroundAttachment: true,
                        backgroundColor: true,
                        backgroundImage: true,
                        backgroundPositionX: true,
                        backgroundPositionY: true,
                        backgroundRepeat: true
                    },
                    backgroundPosition: {
                        backgroundPositionX: true,
                        backgroundPositionY: true
                    },
                    border: {
                        borderWidth: true,
                        borderStyle: true,
                        borderColor: true
                    },
                    borderBottom: {
                        borderBottomWidth: true,
                        borderBottomStyle: true,
                        borderBottomColor: true
                    },
                    borderLeft: {
                        borderLeftWidth: true,
                        borderLeftStyle: true,
                        borderLeftColor: true
                    },
                    borderRight: {
                        borderRightWidth: true,
                        borderRightStyle: true,
                        borderRightColor: true
                    },
                    borderTop: {
                        borderTopWidth: true,
                        borderTopStyle: true,
                        borderTopColor: true
                    },
                    font: {
                        fontStyle: true,
                        fontVariant: true,
                        fontWeight: true,
                        fontSize: true,
                        lineHeight: true,
                        fontFamily: true
                    },
                    outline: {
                        outlineWidth: true,
                        outlineStyle: true,
                        outlineColor: true
                    }
                };

                var CSSProperty = {
                    isUnitlessNumber: isUnitlessNumber,
                    shorthandPropertyExpansions: shorthandPropertyExpansions
                };

                module.exports = CSSProperty;
            }, {}], 5: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var CSSProperty = _dereq_(4);
                var ExecutionEnvironment = _dereq_(138);
                var ReactInstrumentation = _dereq_(64);

                var camelizeStyleName = _dereq_(140);
                var dangerousStyleValue = _dereq_(106);
                var hyphenateStyleName = _dereq_(151);
                var memoizeStringOnly = _dereq_(155);
                var warning = _dereq_(159);

                var processStyleName = memoizeStringOnly(function (styleName) {
                    return hyphenateStyleName(styleName);
                });

                var hasShorthandPropertyBug = false;
                var styleFloatAccessor = 'cssFloat';
                if (ExecutionEnvironment.canUseDOM) {
                    var tempStyle = document.createElement('div').style;
                    try {
                        // IE8 throws "Invalid argument." if resetting shorthand style properties.
                        tempStyle.font = '';
                    } catch (e) {
                        hasShorthandPropertyBug = true;
                    }
                    // IE8 only supports accessing cssFloat (standard) as styleFloat
                    if (document.documentElement.style.cssFloat === undefined) {
                        styleFloatAccessor = 'styleFloat';
                    }
                }

                if ("development" !== 'production') {
                    // 'msTransform' is correct, but the other prefixes should be capitalized
                    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

                    // style values shouldn't contain a semicolon
                    var badStyleValueWithSemicolonPattern = /;\s*$/;

                    var warnedStyleNames = {};
                    var warnedStyleValues = {};
                    var warnedForNaNValue = false;

                    var warnHyphenatedStyleName = function (name, owner) {
                        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
                            return;
                        }

                        warnedStyleNames[name] = true;
                        "development" !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
                    };

                    var warnBadVendoredStyleName = function (name, owner) {
                        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
                            return;
                        }

                        warnedStyleNames[name] = true;
                        "development" !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
                    };

                    var warnStyleValueWithSemicolon = function (name, value, owner) {
                        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
                            return;
                        }

                        warnedStyleValues[value] = true;
                        "development" !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
                    };

                    var warnStyleValueIsNaN = function (name, value, owner) {
                        if (warnedForNaNValue) {
                            return;
                        }

                        warnedForNaNValue = true;
                        "development" !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
                    };

                    var checkRenderMessage = function (owner) {
                        if (owner) {
                            var name = owner.getName();
                            if (name) {
                                return ' Check the render method of `' + name + '`.';
                            }
                        }
                        return '';
                    };

                    /**
                     * @param {string} name
                     * @param {*} value
                     * @param {ReactDOMComponent} component
                     */
                    var warnValidStyle = function (name, value, component) {
                        var owner;
                        if (component) {
                            owner = component._currentElement._owner;
                        }
                        if (name.indexOf('-') > -1) {
                            warnHyphenatedStyleName(name, owner);
                        } else if (badVendoredStyleNamePattern.test(name)) {
                            warnBadVendoredStyleName(name, owner);
                        } else if (badStyleValueWithSemicolonPattern.test(value)) {
                            warnStyleValueWithSemicolon(name, value, owner);
                        }

                        if (typeof value === 'number' && isNaN(value)) {
                            warnStyleValueIsNaN(name, value, owner);
                        }
                    };
                }

                /**
                 * Operations for dealing with CSS properties.
                 */
                var CSSPropertyOperations = {
                    /**
                     * Serializes a mapping of style properties for use as inline styles:
                     *
                     *   > createMarkupForStyles({width: '200px', height: 0})
                     *   "width:200px;height:0;"
                     *
                     * Undefined values are ignored so that declarative programming is easier.
                     * The result should be HTML-escaped before insertion into the DOM.
                     *
                     * @param {object} styles
                     * @param {ReactDOMComponent} component
                     * @return {?string}
                     */
                    createMarkupForStyles: function (styles, component) {
                        var serialized = '';
                        for (var styleName in styles) {
                            if (!styles.hasOwnProperty(styleName)) {
                                continue;
                            }
                            var isCustomProperty = styleName.indexOf('--') === 0;
                            var styleValue = styles[styleName];
                            if ("development" !== 'production') {
                                if (!isCustomProperty) {
                                    warnValidStyle(styleName, styleValue, component);
                                }
                            }
                            if (styleValue != null) {
                                serialized += processStyleName(styleName) + ':';
                                serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
                            }
                        }
                        return serialized || null;
                    },

                    /**
                     * Sets the value for multiple styles on a node.  If a value is specified as
                     * '' (empty string), the corresponding style property will be unset.
                     *
                     * @param {DOMElement} node
                     * @param {object} styles
                     * @param {ReactDOMComponent} component
                     */
                    setValueForStyles: function (node, styles, component) {
                        if ("development" !== 'production') {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: component._debugID,
                                type: 'update styles',
                                payload: styles
                            });
                        }

                        var style = node.style;
                        for (var styleName in styles) {
                            if (!styles.hasOwnProperty(styleName)) {
                                continue;
                            }
                            var isCustomProperty = styleName.indexOf('--') === 0;
                            if ("development" !== 'production') {
                                if (!isCustomProperty) {
                                    warnValidStyle(styleName, styles[styleName], component);
                                }
                            }
                            var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
                            if (styleName === 'float' || styleName === 'cssFloat') {
                                styleName = styleFloatAccessor;
                            }
                            if (isCustomProperty) {
                                style.setProperty(styleName, styleValue);
                            } else if (styleValue) {
                                style[styleName] = styleValue;
                            } else {
                                var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
                                if (expansion) {
                                    // Shorthand property that IE8 won't like unsetting, so unset each
                                    // component to placate it
                                    for (var individualStyleName in expansion) {
                                        style[individualStyleName] = '';
                                    }
                                } else {
                                    style[styleName] = '';
                                }
                            }
                        }
                    }
                };

                module.exports = CSSPropertyOperations;
            }, { "106": 106, "138": 138, "140": 140, "151": 151, "155": 155, "159": 159, "4": 4, "64": 64 }], 6: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                var PooledClass = _dereq_(25);

                var invariant = _dereq_(152);

                /**
                 * A specialized pseudo-event module to help keep track of components waiting to
                 * be notified when their DOM representations are available for use.
                 *
                 * This implements `PooledClass`, so you should never need to instantiate this.
                 * Instead, use `CallbackQueue.getPooled()`.
                 *
                 * @class ReactMountReady
                 * @implements PooledClass
                 * @internal
                 */

                var CallbackQueue = function () {
                    function CallbackQueue(arg) {
                        _classCallCheck(this, CallbackQueue);

                        this._callbacks = null;
                        this._contexts = null;
                        this._arg = arg;
                    }

                    /**
                     * Enqueues a callback to be invoked when `notifyAll` is invoked.
                     *
                     * @param {function} callback Invoked when `notifyAll` is invoked.
                     * @param {?object} context Context to call `callback` with.
                     * @internal
                     */


                    CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
                        this._callbacks = this._callbacks || [];
                        this._callbacks.push(callback);
                        this._contexts = this._contexts || [];
                        this._contexts.push(context);
                    };

                    /**
                     * Invokes all enqueued callbacks and clears the queue. This is invoked after
                     * the DOM representation of a component has been created or updated.
                     *
                     * @internal
                     */


                    CallbackQueue.prototype.notifyAll = function notifyAll() {
                        var callbacks = this._callbacks;
                        var contexts = this._contexts;
                        var arg = this._arg;
                        if (callbacks && contexts) {
                            !(callbacks.length === contexts.length) ? "development" !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
                            this._callbacks = null;
                            this._contexts = null;
                            for (var i = 0; i < callbacks.length; i++) {
                                callbacks[i].call(contexts[i], arg);
                            }
                            callbacks.length = 0;
                            contexts.length = 0;
                        }
                    };

                    CallbackQueue.prototype.checkpoint = function checkpoint() {
                        return this._callbacks ? this._callbacks.length : 0;
                    };

                    CallbackQueue.prototype.rollback = function rollback(len) {
                        if (this._callbacks && this._contexts) {
                            this._callbacks.length = len;
                            this._contexts.length = len;
                        }
                    };

                    /**
                     * Resets the internal queue.
                     *
                     * @internal
                     */


                    CallbackQueue.prototype.reset = function reset() {
                        this._callbacks = null;
                        this._contexts = null;
                    };

                    /**
                     * `PooledClass` looks for this.
                     */


                    CallbackQueue.prototype.destructor = function destructor() {
                        this.reset();
                    };

                    return CallbackQueue;
                }();

                module.exports = PooledClass.addPoolingTo(CallbackQueue);
            }, { "126": 126, "152": 152, "25": 25 }], 7: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var EventPluginHub = _dereq_(17);
                var EventPropagators = _dereq_(20);
                var ExecutionEnvironment = _dereq_(138);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactUpdates = _dereq_(82);
                var SyntheticEvent = _dereq_(91);

                var inputValueTracking = _dereq_(120);
                var getEventTarget = _dereq_(114);
                var isEventSupported = _dereq_(122);
                var isTextInputElement = _dereq_(123);

                var eventTypes = {
                    change: {
                        phasedRegistrationNames: {
                            bubbled: 'onChange',
                            captured: 'onChangeCapture'
                        },
                        dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
                    }
                };

                function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
                    var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
                    event.type = 'change';
                    EventPropagators.accumulateTwoPhaseDispatches(event);
                    return event;
                }
                /**
                 * For IE shims
                 */
                var activeElement = null;
                var activeElementInst = null;

                /**
                 * SECTION: handle `change` event
                 */
                function shouldUseChangeEvent(elem) {
                    var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
                    return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
                }

                var doesChangeEventBubble = false;
                if (ExecutionEnvironment.canUseDOM) {
                    // See `handleChange` comment below
                    doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
                }

                function manualDispatchChangeEvent(nativeEvent) {
                    var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

                    // If change and propertychange bubbled, we'd just bind to it like all the
                    // other events and have it go through ReactBrowserEventEmitter. Since it
                    // doesn't, we manually listen for the events and so we have to enqueue and
                    // process the abstract event manually.
                    //
                    // Batching is necessary here in order to ensure that all event handlers run
                    // before the next rerender (including event handlers attached to ancestor
                    // elements instead of directly on the input). Without this, controlled
                    // components don't work properly in conjunction with event bubbling because
                    // the component is rerendered and the value reverted before all the event
                    // handlers can run. See https://github.com/facebook/react/issues/708.
                    ReactUpdates.batchedUpdates(runEventInBatch, event);
                }

                function runEventInBatch(event) {
                    EventPluginHub.enqueueEvents(event);
                    EventPluginHub.processEventQueue(false);
                }

                function startWatchingForChangeEventIE8(target, targetInst) {
                    activeElement = target;
                    activeElementInst = targetInst;
                    activeElement.attachEvent('onchange', manualDispatchChangeEvent);
                }

                function stopWatchingForChangeEventIE8() {
                    if (!activeElement) {
                        return;
                    }
                    activeElement.detachEvent('onchange', manualDispatchChangeEvent);
                    activeElement = null;
                    activeElementInst = null;
                }

                function getInstIfValueChanged(targetInst, nativeEvent) {
                    var updated = inputValueTracking.updateValueIfChanged(targetInst);
                    var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

                    if (updated || simulated) {
                        return targetInst;
                    }
                }

                function getTargetInstForChangeEvent(topLevelType, targetInst) {
                    if (topLevelType === 'topChange') {
                        return targetInst;
                    }
                }

                function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
                    if (topLevelType === 'topFocus') {
                        // stopWatching() should be a noop here but we call it just in case we
                        // missed a blur event somehow.
                        stopWatchingForChangeEventIE8();
                        startWatchingForChangeEventIE8(target, targetInst);
                    } else if (topLevelType === 'topBlur') {
                        stopWatchingForChangeEventIE8();
                    }
                }

                /**
                 * SECTION: handle `input` event
                 */
                var isInputEventSupported = false;
                if (ExecutionEnvironment.canUseDOM) {
                    // IE9 claims to support the input event but fails to trigger it when
                    // deleting text, so we ignore its input events.

                    isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
                }

                /**
                 * (For IE <=9) Starts tracking propertychange events on the passed-in element
                 * and override the value property so that we can distinguish user events from
                 * value changes in JS.
                 */
                function startWatchingForValueChange(target, targetInst) {
                    activeElement = target;
                    activeElementInst = targetInst;
                    activeElement.attachEvent('onpropertychange', handlePropertyChange);
                }

                /**
                 * (For IE <=9) Removes the event listeners from the currently-tracked element,
                 * if any exists.
                 */
                function stopWatchingForValueChange() {
                    if (!activeElement) {
                        return;
                    }
                    activeElement.detachEvent('onpropertychange', handlePropertyChange);

                    activeElement = null;
                    activeElementInst = null;
                }

                /**
                 * (For IE <=9) Handles a propertychange event, sending a `change` event if
                 * the value of the active element has changed.
                 */
                function handlePropertyChange(nativeEvent) {
                    if (nativeEvent.propertyName !== 'value') {
                        return;
                    }
                    if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
                        manualDispatchChangeEvent(nativeEvent);
                    }
                }

                function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
                    if (topLevelType === 'topFocus') {
                        // In IE8, we can capture almost all .value changes by adding a
                        // propertychange handler and looking for events with propertyName
                        // equal to 'value'
                        // In IE9, propertychange fires for most input events but is buggy and
                        // doesn't fire when text is deleted, but conveniently, selectionchange
                        // appears to fire in all of the remaining cases so we catch those and
                        // forward the event if the value has changed
                        // In either case, we don't want to call the event handler if the value
                        // is changed from JS so we redefine a setter for `.value` that updates
                        // our activeElementValue variable, allowing us to ignore those changes
                        //
                        // stopWatching() should be a noop here but we call it just in case we
                        // missed a blur event somehow.
                        stopWatchingForValueChange();
                        startWatchingForValueChange(target, targetInst);
                    } else if (topLevelType === 'topBlur') {
                        stopWatchingForValueChange();
                    }
                }

                // For IE8 and IE9.
                function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
                    if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
                        // On the selectionchange event, the target is just document which isn't
                        // helpful for us so just check activeElement instead.
                        //
                        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
                        // propertychange on the first input event after setting `value` from a
                        // script and fires only keydown, keypress, keyup. Catching keyup usually
                        // gets it and catching keydown lets us fire an event for the first
                        // keystroke if user does a key repeat (it'll be a little delayed: right
                        // before the second keystroke). Other input methods (e.g., paste) seem to
                        // fire selectionchange normally.
                        return getInstIfValueChanged(activeElementInst, nativeEvent);
                    }
                }

                /**
                 * SECTION: handle `click` event
                 */
                function shouldUseClickEvent(elem) {
                    // Use the `click` event to detect changes to checkbox and radio inputs.
                    // This approach works across all browsers, whereas `change` does not fire
                    // until `blur` in IE8.
                    var nodeName = elem.nodeName;
                    return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
                }

                function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
                    if (topLevelType === 'topClick') {
                        return getInstIfValueChanged(targetInst, nativeEvent);
                    }
                }

                function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
                    if (topLevelType === 'topInput' || topLevelType === 'topChange') {
                        return getInstIfValueChanged(targetInst, nativeEvent);
                    }
                }

                function handleControlledInputBlur(inst, node) {
                    // TODO: In IE, inst is occasionally null. Why?
                    if (inst == null) {
                        return;
                    }

                    // Fiber and ReactDOM keep wrapper state in separate places
                    var state = inst._wrapperState || node._wrapperState;

                    if (!state || !state.controlled || node.type !== 'number') {
                        return;
                    }

                    // If controlled, assign the value attribute to the current value on blur
                    var value = '' + node.value;
                    if (node.getAttribute('value') !== value) {
                        node.setAttribute('value', value);
                    }
                }

                /**
                 * This plugin creates an `onChange` event that normalizes change events
                 * across form elements. This event fires at a time when it's possible to
                 * change the element's value without seeing a flicker.
                 *
                 * Supported elements are:
                 * - input (see `isTextInputElement`)
                 * - textarea
                 * - select
                 */
                var ChangeEventPlugin = {
                    eventTypes: eventTypes,

                    _allowSimulatedPassThrough: true,
                    _isInputEventSupported: isInputEventSupported,

                    extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

                        var getTargetInstFunc, handleEventFunc;
                        if (shouldUseChangeEvent(targetNode)) {
                            if (doesChangeEventBubble) {
                                getTargetInstFunc = getTargetInstForChangeEvent;
                            } else {
                                handleEventFunc = handleEventsForChangeEventIE8;
                            }
                        } else if (isTextInputElement(targetNode)) {
                            if (isInputEventSupported) {
                                getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                            } else {
                                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                                handleEventFunc = handleEventsForInputEventPolyfill;
                            }
                        } else if (shouldUseClickEvent(targetNode)) {
                            getTargetInstFunc = getTargetInstForClickEvent;
                        }

                        if (getTargetInstFunc) {
                            var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
                            if (inst) {
                                var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
                                return event;
                            }
                        }

                        if (handleEventFunc) {
                            handleEventFunc(topLevelType, targetNode, targetInst);
                        }

                        // When blurring, set the value attribute for number inputs
                        if (topLevelType === 'topBlur') {
                            handleControlledInputBlur(targetInst, targetNode);
                        }
                    }
                };

                module.exports = ChangeEventPlugin;
            }, { "114": 114, "120": 120, "122": 122, "123": 123, "138": 138, "17": 17, "20": 20, "34": 34, "82": 82, "91": 91 }], 8: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMLazyTree = _dereq_(9);
                var Danger = _dereq_(13);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactInstrumentation = _dereq_(64);

                var createMicrosoftUnsafeLocalFunction = _dereq_(105);
                var setInnerHTML = _dereq_(128);
                var setTextContent = _dereq_(129);

                function getNodeAfter(parentNode, node) {
                    // Special case for text components, which return [open, close] comments
                    // from getHostNode.
                    if (Array.isArray(node)) {
                        node = node[1];
                    }
                    return node ? node.nextSibling : parentNode.firstChild;
                }

                /**
                 * Inserts `childNode` as a child of `parentNode` at the `index`.
                 *
                 * @param {DOMElement} parentNode Parent node in which to insert.
                 * @param {DOMElement} childNode Child node to insert.
                 * @param {number} index Index at which to insert the child.
                 * @internal
                 */
                var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
                    // We rely exclusively on `insertBefore(node, null)` instead of also using
                    // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
                    // we are careful to use `null`.)
                    parentNode.insertBefore(childNode, referenceNode);
                });

                function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
                    DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
                }

                function moveChild(parentNode, childNode, referenceNode) {
                    if (Array.isArray(childNode)) {
                        moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
                    } else {
                        insertChildAt(parentNode, childNode, referenceNode);
                    }
                }

                function removeChild(parentNode, childNode) {
                    if (Array.isArray(childNode)) {
                        var closingComment = childNode[1];
                        childNode = childNode[0];
                        removeDelimitedText(parentNode, childNode, closingComment);
                        parentNode.removeChild(closingComment);
                    }
                    parentNode.removeChild(childNode);
                }

                function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
                    var node = openingComment;
                    while (true) {
                        var nextNode = node.nextSibling;
                        insertChildAt(parentNode, node, referenceNode);
                        if (node === closingComment) {
                            break;
                        }
                        node = nextNode;
                    }
                }

                function removeDelimitedText(parentNode, startNode, closingComment) {
                    while (true) {
                        var node = startNode.nextSibling;
                        if (node === closingComment) {
                            // The closing comment is removed by ReactMultiChild.
                            break;
                        } else {
                            parentNode.removeChild(node);
                        }
                    }
                }

                function replaceDelimitedText(openingComment, closingComment, stringText) {
                    var parentNode = openingComment.parentNode;
                    var nodeAfterComment = openingComment.nextSibling;
                    if (nodeAfterComment === closingComment) {
                        // There are no text nodes between the opening and closing comments; insert
                        // a new one if stringText isn't empty.
                        if (stringText) {
                            insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
                        }
                    } else {
                        if (stringText) {
                            // Set the text content of the first node after the opening comment, and
                            // remove all following nodes up until the closing comment.
                            setTextContent(nodeAfterComment, stringText);
                            removeDelimitedText(parentNode, nodeAfterComment, closingComment);
                        } else {
                            removeDelimitedText(parentNode, openingComment, closingComment);
                        }
                    }

                    if ("development" !== 'production') {
                        ReactInstrumentation.debugTool.onHostOperation({
                            instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
                            type: 'replace text',
                            payload: stringText
                        });
                    }
                }

                var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
                if ("development" !== 'production') {
                    dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
                        Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
                        if (prevInstance._debugID !== 0) {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: prevInstance._debugID,
                                type: 'replace with',
                                payload: markup.toString()
                            });
                        } else {
                            var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
                            if (nextInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onHostOperation({
                                    instanceID: nextInstance._debugID,
                                    type: 'mount',
                                    payload: markup.toString()
                                });
                            }
                        }
                    };
                }

                /**
                 * Operations for updating with DOM children.
                 */
                var DOMChildrenOperations = {
                    dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

                    replaceDelimitedText: replaceDelimitedText,

                    /**
                     * Updates a component's children by processing a series of updates. The
                     * update configurations are each expected to have a `parentNode` property.
                     *
                     * @param {array<object>} updates List of update configurations.
                     * @internal
                     */
                    processUpdates: function (parentNode, updates) {
                        if ("development" !== 'production') {
                            var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
                        }

                        for (var k = 0; k < updates.length; k++) {
                            var update = updates[k];
                            switch (update.type) {
                                case 'INSERT_MARKUP':
                                    insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
                                    if ("development" !== 'production') {
                                        ReactInstrumentation.debugTool.onHostOperation({
                                            instanceID: parentNodeDebugID,
                                            type: 'insert child',
                                            payload: {
                                                toIndex: update.toIndex,
                                                content: update.content.toString()
                                            }
                                        });
                                    }
                                    break;
                                case 'MOVE_EXISTING':
                                    moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
                                    if ("development" !== 'production') {
                                        ReactInstrumentation.debugTool.onHostOperation({
                                            instanceID: parentNodeDebugID,
                                            type: 'move child',
                                            payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
                                        });
                                    }
                                    break;
                                case 'SET_MARKUP':
                                    setInnerHTML(parentNode, update.content);
                                    if ("development" !== 'production') {
                                        ReactInstrumentation.debugTool.onHostOperation({
                                            instanceID: parentNodeDebugID,
                                            type: 'replace children',
                                            payload: update.content.toString()
                                        });
                                    }
                                    break;
                                case 'TEXT_CONTENT':
                                    setTextContent(parentNode, update.content);
                                    if ("development" !== 'production') {
                                        ReactInstrumentation.debugTool.onHostOperation({
                                            instanceID: parentNodeDebugID,
                                            type: 'replace text',
                                            payload: update.content.toString()
                                        });
                                    }
                                    break;
                                case 'REMOVE_NODE':
                                    removeChild(parentNode, update.fromNode);
                                    if ("development" !== 'production') {
                                        ReactInstrumentation.debugTool.onHostOperation({
                                            instanceID: parentNodeDebugID,
                                            type: 'remove child',
                                            payload: { fromIndex: update.fromIndex }
                                        });
                                    }
                                    break;
                            }
                        }
                    }
                };

                module.exports = DOMChildrenOperations;
            }, { "105": 105, "128": 128, "129": 129, "13": 13, "34": 34, "64": 64, "9": 9 }], 9: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMNamespaces = _dereq_(10);
                var setInnerHTML = _dereq_(128);

                var createMicrosoftUnsafeLocalFunction = _dereq_(105);
                var setTextContent = _dereq_(129);

                var ELEMENT_NODE_TYPE = 1;
                var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

                /**
                 * In IE (8-11) and Edge, appending nodes with no children is dramatically
                 * faster than appending a full subtree, so we essentially queue up the
                 * .appendChild calls here and apply them so each node is added to its parent
                 * before any children are added.
                 *
                 * In other browsers, doing so is slower or neutral compared to the other order
                 * (in Firefox, twice as slow) so we only do this inversion in IE.
                 *
                 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
                 */
                var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

                function insertTreeChildren(tree) {
                    if (!enableLazy) {
                        return;
                    }
                    var node = tree.node;
                    var children = tree.children;
                    if (children.length) {
                        for (var i = 0; i < children.length; i++) {
                            insertTreeBefore(node, children[i], null);
                        }
                    } else if (tree.html != null) {
                        setInnerHTML(node, tree.html);
                    } else if (tree.text != null) {
                        setTextContent(node, tree.text);
                    }
                }

                var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
                    // DocumentFragments aren't actually part of the DOM after insertion so
                    // appending children won't update the DOM. We need to ensure the fragment
                    // is properly populated first, breaking out of our lazy approach for just
                    // this level. Also, some <object> plugins (like Flash Player) will read
                    // <param> nodes immediately upon insertion into the DOM, so <object>
                    // must also be populated prior to insertion into the DOM.
                    if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
                        insertTreeChildren(tree);
                        parentNode.insertBefore(tree.node, referenceNode);
                    } else {
                        parentNode.insertBefore(tree.node, referenceNode);
                        insertTreeChildren(tree);
                    }
                });

                function replaceChildWithTree(oldNode, newTree) {
                    oldNode.parentNode.replaceChild(newTree.node, oldNode);
                    insertTreeChildren(newTree);
                }

                function queueChild(parentTree, childTree) {
                    if (enableLazy) {
                        parentTree.children.push(childTree);
                    } else {
                        parentTree.node.appendChild(childTree.node);
                    }
                }

                function queueHTML(tree, html) {
                    if (enableLazy) {
                        tree.html = html;
                    } else {
                        setInnerHTML(tree.node, html);
                    }
                }

                function queueText(tree, text) {
                    if (enableLazy) {
                        tree.text = text;
                    } else {
                        setTextContent(tree.node, text);
                    }
                }

                function toString() {
                    return this.node.nodeName;
                }

                function DOMLazyTree(node) {
                    return {
                        node: node,
                        children: [],
                        html: null,
                        text: null,
                        toString: toString
                    };
                }

                DOMLazyTree.insertTreeBefore = insertTreeBefore;
                DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
                DOMLazyTree.queueChild = queueChild;
                DOMLazyTree.queueHTML = queueHTML;
                DOMLazyTree.queueText = queueText;

                module.exports = DOMLazyTree;
            }, { "10": 10, "105": 105, "128": 128, "129": 129 }], 10: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMNamespaces = {
                    html: 'http://www.w3.org/1999/xhtml',
                    mathml: 'http://www.w3.org/1998/Math/MathML',
                    svg: 'http://www.w3.org/2000/svg'
                };

                module.exports = DOMNamespaces;
            }, {}], 11: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                function checkMask(value, bitmask) {
                    return (value & bitmask) === bitmask;
                }

                var DOMPropertyInjection = {
                    /**
                     * Mapping from normalized, camelcased property names to a configuration that
                     * specifies how the associated DOM property should be accessed or rendered.
                     */
                    MUST_USE_PROPERTY: 0x1,
                    HAS_BOOLEAN_VALUE: 0x4,
                    HAS_NUMERIC_VALUE: 0x8,
                    HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
                    HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

                    /**
                     * Inject some specialized knowledge about the DOM. This takes a config object
                     * with the following properties:
                     *
                     * isCustomAttribute: function that given an attribute name will return true
                     * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
                     * attributes where it's impossible to enumerate all of the possible
                     * attribute names,
                     *
                     * Properties: object mapping DOM property name to one of the
                     * DOMPropertyInjection constants or null. If your attribute isn't in here,
                     * it won't get written to the DOM.
                     *
                     * DOMAttributeNames: object mapping React attribute name to the DOM
                     * attribute name. Attribute names not specified use the **lowercase**
                     * normalized name.
                     *
                     * DOMAttributeNamespaces: object mapping React attribute name to the DOM
                     * attribute namespace URL. (Attribute names not specified use no namespace.)
                     *
                     * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
                     * Property names not specified use the normalized name.
                     *
                     * DOMMutationMethods: Properties that require special mutation methods. If
                     * `value` is undefined, the mutation method should unset the property.
                     *
                     * @param {object} domPropertyConfig the config as described above.
                     */
                    injectDOMPropertyConfig: function (domPropertyConfig) {
                        var Injection = DOMPropertyInjection;
                        var Properties = domPropertyConfig.Properties || {};
                        var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
                        var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
                        var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
                        var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

                        if (domPropertyConfig.isCustomAttribute) {
                            DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
                        }

                        for (var propName in Properties) {
                            !!DOMProperty.properties.hasOwnProperty(propName) ? "development" !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

                            var lowerCased = propName.toLowerCase();
                            var propConfig = Properties[propName];

                            var propertyInfo = {
                                attributeName: lowerCased,
                                attributeNamespace: null,
                                propertyName: propName,
                                mutationMethod: null,

                                mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
                                hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
                                hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
                                hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
                                hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
                            };
                            !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? "development" !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

                            if ("development" !== 'production') {
                                DOMProperty.getPossibleStandardName[lowerCased] = propName;
                            }

                            if (DOMAttributeNames.hasOwnProperty(propName)) {
                                var attributeName = DOMAttributeNames[propName];
                                propertyInfo.attributeName = attributeName;
                                if ("development" !== 'production') {
                                    DOMProperty.getPossibleStandardName[attributeName] = propName;
                                }
                            }

                            if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
                                propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
                            }

                            if (DOMPropertyNames.hasOwnProperty(propName)) {
                                propertyInfo.propertyName = DOMPropertyNames[propName];
                            }

                            if (DOMMutationMethods.hasOwnProperty(propName)) {
                                propertyInfo.mutationMethod = DOMMutationMethods[propName];
                            }

                            DOMProperty.properties[propName] = propertyInfo;
                        }
                    }
                };

                /* eslint-disable max-len */
                var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
                /* eslint-enable max-len */

                /**
                 * DOMProperty exports lookup objects that can be used like functions:
                 *
                 *   > DOMProperty.isValid['id']
                 *   true
                 *   > DOMProperty.isValid['foobar']
                 *   undefined
                 *
                 * Although this may be confusing, it performs better in general.
                 *
                 * @see http://jsperf.com/key-exists
                 * @see http://jsperf.com/key-missing
                 */
                var DOMProperty = {
                    ID_ATTRIBUTE_NAME: 'data-reactid',
                    ROOT_ATTRIBUTE_NAME: 'data-reactroot',

                    ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
                    ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

                    /**
                     * Map from property "standard name" to an object with info about how to set
                     * the property in the DOM. Each object contains:
                     *
                     * attributeName:
                     *   Used when rendering markup or with `*Attribute()`.
                     * attributeNamespace
                     * propertyName:
                     *   Used on DOM node instances. (This includes properties that mutate due to
                     *   external factors.)
                     * mutationMethod:
                     *   If non-null, used instead of the property or `setAttribute()` after
                     *   initial render.
                     * mustUseProperty:
                     *   Whether the property must be accessed and mutated as an object property.
                     * hasBooleanValue:
                     *   Whether the property should be removed when set to a falsey value.
                     * hasNumericValue:
                     *   Whether the property must be numeric or parse as a numeric and should be
                     *   removed when set to a falsey value.
                     * hasPositiveNumericValue:
                     *   Whether the property must be positive numeric or parse as a positive
                     *   numeric and should be removed when set to a falsey value.
                     * hasOverloadedBooleanValue:
                     *   Whether the property can be used as a flag as well as with a value.
                     *   Removed when strictly equal to false; present without a value when
                     *   strictly equal to true; present with a value otherwise.
                     */
                    properties: {},

                    /**
                     * Mapping from lowercase property names to the properly cased version, used
                     * to warn in the case of missing properties. Available only in __DEV__.
                     *
                     * autofocus is predefined, because adding it to the property whitelist
                     * causes unintended side effects.
                     *
                     * @type {Object}
                     */
                    getPossibleStandardName: "development" !== 'production' ? { autofocus: 'autoFocus' } : null,

                    /**
                     * All of the isCustomAttribute() functions that have been injected.
                     */
                    _isCustomAttributeFunctions: [],

                    /**
                     * Checks whether a property name is a custom attribute.
                     * @method
                     */
                    isCustomAttribute: function (attributeName) {
                        for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
                            var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
                            if (isCustomAttributeFn(attributeName)) {
                                return true;
                            }
                        }
                        return false;
                    },

                    injection: DOMPropertyInjection
                };

                module.exports = DOMProperty;
            }, { "126": 126, "152": 152 }], 12: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMProperty = _dereq_(11);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactInstrumentation = _dereq_(64);

                var quoteAttributeValueForBrowser = _dereq_(125);
                var warning = _dereq_(159);

                var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
                var illegalAttributeNameCache = {};
                var validatedAttributeNameCache = {};

                function isAttributeNameSafe(attributeName) {
                    if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
                        return true;
                    }
                    if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
                        return false;
                    }
                    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
                        validatedAttributeNameCache[attributeName] = true;
                        return true;
                    }
                    illegalAttributeNameCache[attributeName] = true;
                    "development" !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
                    return false;
                }

                function shouldIgnoreValue(propertyInfo, value) {
                    return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
                }

                /**
                 * Operations for dealing with DOM properties.
                 */
                var DOMPropertyOperations = {
                    /**
                     * Creates markup for the ID property.
                     *
                     * @param {string} id Unescaped ID.
                     * @return {string} Markup string.
                     */
                    createMarkupForID: function (id) {
                        return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
                    },

                    setAttributeForID: function (node, id) {
                        node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
                    },

                    createMarkupForRoot: function () {
                        return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
                    },

                    setAttributeForRoot: function (node) {
                        node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
                    },

                    /**
                     * Creates markup for a property.
                     *
                     * @param {string} name
                     * @param {*} value
                     * @return {?string} Markup string, or null if the property was invalid.
                     */
                    createMarkupForProperty: function (name, value) {
                        var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
                        if (propertyInfo) {
                            if (shouldIgnoreValue(propertyInfo, value)) {
                                return '';
                            }
                            var attributeName = propertyInfo.attributeName;
                            if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
                                return attributeName + '=""';
                            }
                            return attributeName + '=' + quoteAttributeValueForBrowser(value);
                        } else if (DOMProperty.isCustomAttribute(name)) {
                            if (value == null) {
                                return '';
                            }
                            return name + '=' + quoteAttributeValueForBrowser(value);
                        }
                        return null;
                    },

                    /**
                     * Creates markup for a custom property.
                     *
                     * @param {string} name
                     * @param {*} value
                     * @return {string} Markup string, or empty string if the property was invalid.
                     */
                    createMarkupForCustomAttribute: function (name, value) {
                        if (!isAttributeNameSafe(name) || value == null) {
                            return '';
                        }
                        return name + '=' + quoteAttributeValueForBrowser(value);
                    },

                    /**
                     * Sets the value for a property on a node.
                     *
                     * @param {DOMElement} node
                     * @param {string} name
                     * @param {*} value
                     */
                    setValueForProperty: function (node, name, value) {
                        var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
                        if (propertyInfo) {
                            var mutationMethod = propertyInfo.mutationMethod;
                            if (mutationMethod) {
                                mutationMethod(node, value);
                            } else if (shouldIgnoreValue(propertyInfo, value)) {
                                this.deleteValueForProperty(node, name);
                                return;
                            } else if (propertyInfo.mustUseProperty) {
                                // Contrary to `setAttribute`, object properties are properly
                                // `toString`ed by IE8/9.
                                node[propertyInfo.propertyName] = value;
                            } else {
                                var attributeName = propertyInfo.attributeName;
                                var namespace = propertyInfo.attributeNamespace;
                                // `setAttribute` with objects becomes only `[object]` in IE8/9,
                                // ('' + value) makes it output the correct toString()-value.
                                if (namespace) {
                                    node.setAttributeNS(namespace, attributeName, '' + value);
                                } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
                                    node.setAttribute(attributeName, '');
                                } else {
                                    node.setAttribute(attributeName, '' + value);
                                }
                            }
                        } else if (DOMProperty.isCustomAttribute(name)) {
                            DOMPropertyOperations.setValueForAttribute(node, name, value);
                            return;
                        }

                        if ("development" !== 'production') {
                            var payload = {};
                            payload[name] = value;
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
                                type: 'update attribute',
                                payload: payload
                            });
                        }
                    },

                    setValueForAttribute: function (node, name, value) {
                        if (!isAttributeNameSafe(name)) {
                            return;
                        }
                        if (value == null) {
                            node.removeAttribute(name);
                        } else {
                            node.setAttribute(name, '' + value);
                        }

                        if ("development" !== 'production') {
                            var payload = {};
                            payload[name] = value;
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
                                type: 'update attribute',
                                payload: payload
                            });
                        }
                    },

                    /**
                     * Deletes an attributes from a node.
                     *
                     * @param {DOMElement} node
                     * @param {string} name
                     */
                    deleteValueForAttribute: function (node, name) {
                        node.removeAttribute(name);
                        if ("development" !== 'production') {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
                                type: 'remove attribute',
                                payload: name
                            });
                        }
                    },

                    /**
                     * Deletes the value for a property on a node.
                     *
                     * @param {DOMElement} node
                     * @param {string} name
                     */
                    deleteValueForProperty: function (node, name) {
                        var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
                        if (propertyInfo) {
                            var mutationMethod = propertyInfo.mutationMethod;
                            if (mutationMethod) {
                                mutationMethod(node, undefined);
                            } else if (propertyInfo.mustUseProperty) {
                                var propName = propertyInfo.propertyName;
                                if (propertyInfo.hasBooleanValue) {
                                    node[propName] = false;
                                } else {
                                    node[propName] = '';
                                }
                            } else {
                                node.removeAttribute(propertyInfo.attributeName);
                            }
                        } else if (DOMProperty.isCustomAttribute(name)) {
                            node.removeAttribute(name);
                        }

                        if ("development" !== 'production') {
                            ReactInstrumentation.debugTool.onHostOperation({
                                instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
                                type: 'remove attribute',
                                payload: name
                            });
                        }
                    }
                };

                module.exports = DOMPropertyOperations;
            }, { "11": 11, "125": 125, "159": 159, "34": 34, "64": 64 }], 13: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var DOMLazyTree = _dereq_(9);
                var ExecutionEnvironment = _dereq_(138);

                var createNodesFromMarkup = _dereq_(143);
                var emptyFunction = _dereq_(144);
                var invariant = _dereq_(152);

                var Danger = {
                    /**
                     * Replaces a node with a string of markup at its current position within its
                     * parent. The markup must render into a single root node.
                     *
                     * @param {DOMElement} oldChild Child node to replace.
                     * @param {string} markup Markup to render in place of the child node.
                     * @internal
                     */
                    dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
                        !ExecutionEnvironment.canUseDOM ? "development" !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
                        !markup ? "development" !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
                        !(oldChild.nodeName !== 'HTML') ? "development" !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

                        if (typeof markup === 'string') {
                            var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
                            oldChild.parentNode.replaceChild(newChild, oldChild);
                        } else {
                            DOMLazyTree.replaceChildWithTree(oldChild, markup);
                        }
                    }
                };

                module.exports = Danger;
            }, { "126": 126, "138": 138, "143": 143, "144": 144, "152": 152, "9": 9 }], 14: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Module that is injectable into `EventPluginHub`, that specifies a
                 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
                 * plugins, without having to package every one of them. This is better than
                 * having plugins be ordered in the same order that they are injected because
                 * that ordering would be influenced by the packaging order.
                 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
                 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
                 */

                var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

                module.exports = DefaultEventPluginOrder;
            }, {}], 15: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var EventPropagators = _dereq_(20);
                var ReactDOMComponentTree = _dereq_(34);
                var SyntheticMouseEvent = _dereq_(95);

                var eventTypes = {
                    mouseEnter: {
                        registrationName: 'onMouseEnter',
                        dependencies: ['topMouseOut', 'topMouseOver']
                    },
                    mouseLeave: {
                        registrationName: 'onMouseLeave',
                        dependencies: ['topMouseOut', 'topMouseOver']
                    }
                };

                var EnterLeaveEventPlugin = {
                    eventTypes: eventTypes,

                    /**
                     * For almost every interaction we care about, there will be both a top-level
                     * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
                     * we do not extract duplicate events. However, moving the mouse into the
                     * browser from outside will not fire a `mouseout` event. In this case, we use
                     * the `mouseover` top-level event.
                     */
                    extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
                            return null;
                        }
                        if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
                            // Must not be a mouse in or mouse out - ignoring.
                            return null;
                        }

                        var win;
                        if (nativeEventTarget.window === nativeEventTarget) {
                            // `nativeEventTarget` is probably a window object.
                            win = nativeEventTarget;
                        } else {
                            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
                            var doc = nativeEventTarget.ownerDocument;
                            if (doc) {
                                win = doc.defaultView || doc.parentWindow;
                            } else {
                                win = window;
                            }
                        }

                        var from;
                        var to;
                        if (topLevelType === 'topMouseOut') {
                            from = targetInst;
                            var related = nativeEvent.relatedTarget || nativeEvent.toElement;
                            to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
                        } else {
                            // Moving to a node from outside the window.
                            from = null;
                            to = targetInst;
                        }

                        if (from === to) {
                            // Nothing pertains to our managed components.
                            return null;
                        }

                        var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
                        var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

                        var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
                        leave.type = 'mouseleave';
                        leave.target = fromNode;
                        leave.relatedTarget = toNode;

                        var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
                        enter.type = 'mouseenter';
                        enter.target = toNode;
                        enter.relatedTarget = fromNode;

                        EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

                        return [leave, enter];
                    }
                };

                module.exports = EnterLeaveEventPlugin;
            }, { "20": 20, "34": 34, "95": 95 }], 16: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Types of raw signals from the browser caught at the top level.
                 */
                var topLevelTypes = {
                    topAbort: null,
                    topAnimationEnd: null,
                    topAnimationIteration: null,
                    topAnimationStart: null,
                    topBlur: null,
                    topCanPlay: null,
                    topCanPlayThrough: null,
                    topChange: null,
                    topClick: null,
                    topCompositionEnd: null,
                    topCompositionStart: null,
                    topCompositionUpdate: null,
                    topContextMenu: null,
                    topCopy: null,
                    topCut: null,
                    topDoubleClick: null,
                    topDrag: null,
                    topDragEnd: null,
                    topDragEnter: null,
                    topDragExit: null,
                    topDragLeave: null,
                    topDragOver: null,
                    topDragStart: null,
                    topDrop: null,
                    topDurationChange: null,
                    topEmptied: null,
                    topEncrypted: null,
                    topEnded: null,
                    topError: null,
                    topFocus: null,
                    topInput: null,
                    topInvalid: null,
                    topKeyDown: null,
                    topKeyPress: null,
                    topKeyUp: null,
                    topLoad: null,
                    topLoadedData: null,
                    topLoadedMetadata: null,
                    topLoadStart: null,
                    topMouseDown: null,
                    topMouseMove: null,
                    topMouseOut: null,
                    topMouseOver: null,
                    topMouseUp: null,
                    topPaste: null,
                    topPause: null,
                    topPlay: null,
                    topPlaying: null,
                    topProgress: null,
                    topRateChange: null,
                    topReset: null,
                    topScroll: null,
                    topSeeked: null,
                    topSeeking: null,
                    topSelectionChange: null,
                    topStalled: null,
                    topSubmit: null,
                    topSuspend: null,
                    topTextInput: null,
                    topTimeUpdate: null,
                    topTouchCancel: null,
                    topTouchEnd: null,
                    topTouchMove: null,
                    topTouchStart: null,
                    topTransitionEnd: null,
                    topVolumeChange: null,
                    topWaiting: null,
                    topWheel: null
                };

                var EventConstants = {
                    topLevelTypes: topLevelTypes
                };

                module.exports = EventConstants;
            }, {}], 17: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var EventPluginRegistry = _dereq_(18);
                var EventPluginUtils = _dereq_(19);
                var ReactErrorUtils = _dereq_(55);

                var accumulateInto = _dereq_(102);
                var forEachAccumulated = _dereq_(110);
                var invariant = _dereq_(152);

                /**
                 * Internal store for event listeners
                 */
                var listenerBank = {};

                /**
                 * Internal queue of events that have accumulated their dispatches and are
                 * waiting to have their dispatches executed.
                 */
                var eventQueue = null;

                /**
                 * Dispatches an event and releases it back into the pool, unless persistent.
                 *
                 * @param {?object} event Synthetic event to be dispatched.
                 * @param {boolean} simulated If the event is simulated (changes exn behavior)
                 * @private
                 */
                var executeDispatchesAndRelease = function (event, simulated) {
                    if (event) {
                        EventPluginUtils.executeDispatchesInOrder(event, simulated);

                        if (!event.isPersistent()) {
                            event.constructor.release(event);
                        }
                    }
                };
                var executeDispatchesAndReleaseSimulated = function (e) {
                    return executeDispatchesAndRelease(e, true);
                };
                var executeDispatchesAndReleaseTopLevel = function (e) {
                    return executeDispatchesAndRelease(e, false);
                };

                var getDictionaryKey = function (inst) {
                    // Prevents V8 performance issue:
                    // https://github.com/facebook/react/pull/7232
                    return '.' + inst._rootNodeID;
                };

                function isInteractive(tag) {
                    return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
                }

                function shouldPreventMouseEvent(name, type, props) {
                    switch (name) {
                        case 'onClick':
                        case 'onClickCapture':
                        case 'onDoubleClick':
                        case 'onDoubleClickCapture':
                        case 'onMouseDown':
                        case 'onMouseDownCapture':
                        case 'onMouseMove':
                        case 'onMouseMoveCapture':
                        case 'onMouseUp':
                        case 'onMouseUpCapture':
                            return !!(props.disabled && isInteractive(type));
                        default:
                            return false;
                    }
                }

                /**
                 * This is a unified interface for event plugins to be installed and configured.
                 *
                 * Event plugins can implement the following properties:
                 *
                 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
                 *     Required. When a top-level event is fired, this method is expected to
                 *     extract synthetic events that will in turn be queued and dispatched.
                 *
                 *   `eventTypes` {object}
                 *     Optional, plugins that fire events must publish a mapping of registration
                 *     names that are used to register listeners. Values of this mapping must
                 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
                 *
                 *   `executeDispatch` {function(object, function, string)}
                 *     Optional, allows plugins to override how an event gets dispatched. By
                 *     default, the listener is simply invoked.
                 *
                 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
                 *
                 * @public
                 */
                var EventPluginHub = {
                    /**
                     * Methods for injecting dependencies.
                     */
                    injection: {
                        /**
                         * @param {array} InjectedEventPluginOrder
                         * @public
                         */
                        injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

                        /**
                         * @param {object} injectedNamesToPlugins Map from names to plugin modules.
                         */
                        injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
                    },

                    /**
                     * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
                     *
                     * @param {object} inst The instance, which is the source of events.
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     * @param {function} listener The callback to store.
                     */
                    putListener: function (inst, registrationName, listener) {
                        !(typeof listener === 'function') ? "development" !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

                        var key = getDictionaryKey(inst);
                        var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
                        bankForRegistrationName[key] = listener;

                        var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
                        if (PluginModule && PluginModule.didPutListener) {
                            PluginModule.didPutListener(inst, registrationName, listener);
                        }
                    },

                    /**
                     * @param {object} inst The instance, which is the source of events.
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     * @return {?function} The stored callback.
                     */
                    getListener: function (inst, registrationName) {
                        // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
                        // live here; needs to be moved to a better place soon
                        var bankForRegistrationName = listenerBank[registrationName];
                        if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
                            return null;
                        }
                        var key = getDictionaryKey(inst);
                        return bankForRegistrationName && bankForRegistrationName[key];
                    },

                    /**
                     * Deletes a listener from the registration bank.
                     *
                     * @param {object} inst The instance, which is the source of events.
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     */
                    deleteListener: function (inst, registrationName) {
                        var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
                        if (PluginModule && PluginModule.willDeleteListener) {
                            PluginModule.willDeleteListener(inst, registrationName);
                        }

                        var bankForRegistrationName = listenerBank[registrationName];
                        // TODO: This should never be null -- when is it?
                        if (bankForRegistrationName) {
                            var key = getDictionaryKey(inst);
                            delete bankForRegistrationName[key];
                        }
                    },

                    /**
                     * Deletes all listeners for the DOM element with the supplied ID.
                     *
                     * @param {object} inst The instance, which is the source of events.
                     */
                    deleteAllListeners: function (inst) {
                        var key = getDictionaryKey(inst);
                        for (var registrationName in listenerBank) {
                            if (!listenerBank.hasOwnProperty(registrationName)) {
                                continue;
                            }

                            if (!listenerBank[registrationName][key]) {
                                continue;
                            }

                            var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
                            if (PluginModule && PluginModule.willDeleteListener) {
                                PluginModule.willDeleteListener(inst, registrationName);
                            }

                            delete listenerBank[registrationName][key];
                        }
                    },

                    /**
                     * Allows registered plugins an opportunity to extract events from top-level
                     * native browser events.
                     *
                     * @return {*} An accumulation of synthetic events.
                     * @internal
                     */
                    extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        var events;
                        var plugins = EventPluginRegistry.plugins;
                        for (var i = 0; i < plugins.length; i++) {
                            // Not every plugin in the ordering may be loaded at runtime.
                            var possiblePlugin = plugins[i];
                            if (possiblePlugin) {
                                var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
                                if (extractedEvents) {
                                    events = accumulateInto(events, extractedEvents);
                                }
                            }
                        }
                        return events;
                    },

                    /**
                     * Enqueues a synthetic event that should be dispatched when
                     * `processEventQueue` is invoked.
                     *
                     * @param {*} events An accumulation of synthetic events.
                     * @internal
                     */
                    enqueueEvents: function (events) {
                        if (events) {
                            eventQueue = accumulateInto(eventQueue, events);
                        }
                    },

                    /**
                     * Dispatches all synthetic events on the event queue.
                     *
                     * @internal
                     */
                    processEventQueue: function (simulated) {
                        // Set `eventQueue` to null before processing it so that we can tell if more
                        // events get enqueued while processing.
                        var processingEventQueue = eventQueue;
                        eventQueue = null;
                        if (simulated) {
                            forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
                        } else {
                            forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
                        }
                        !!eventQueue ? "development" !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
                        // This would be a good time to rethrow if any of the event handlers threw.
                        ReactErrorUtils.rethrowCaughtError();
                    },

                    /**
                     * These are needed for tests only. Do not use!
                     */
                    __purge: function () {
                        listenerBank = {};
                    },

                    __getListenerBank: function () {
                        return listenerBank;
                    }
                };

                module.exports = EventPluginHub;
            }, { "102": 102, "110": 110, "126": 126, "152": 152, "18": 18, "19": 19, "55": 55 }], 18: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                /**
                 * Injectable ordering of event plugins.
                 */
                var eventPluginOrder = null;

                /**
                 * Injectable mapping from names to event plugin modules.
                 */
                var namesToPlugins = {};

                /**
                 * Recomputes the plugin list using the injected plugins and plugin ordering.
                 *
                 * @private
                 */
                function recomputePluginOrdering() {
                    if (!eventPluginOrder) {
                        // Wait until an `eventPluginOrder` is injected.
                        return;
                    }
                    for (var pluginName in namesToPlugins) {
                        var pluginModule = namesToPlugins[pluginName];
                        var pluginIndex = eventPluginOrder.indexOf(pluginName);
                        !(pluginIndex > -1) ? "development" !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
                        if (EventPluginRegistry.plugins[pluginIndex]) {
                            continue;
                        }
                        !pluginModule.extractEvents ? "development" !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
                        EventPluginRegistry.plugins[pluginIndex] = pluginModule;
                        var publishedEvents = pluginModule.eventTypes;
                        for (var eventName in publishedEvents) {
                            !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ? "development" !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
                        }
                    }
                }

                /**
                 * Publishes an event so that it can be dispatched by the supplied plugin.
                 *
                 * @param {object} dispatchConfig Dispatch configuration for the event.
                 * @param {object} PluginModule Plugin publishing the event.
                 * @return {boolean} True if the event was successfully published.
                 * @private
                 */
                function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
                    !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? "development" !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
                    EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

                    var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
                    if (phasedRegistrationNames) {
                        for (var phaseName in phasedRegistrationNames) {
                            if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
                                var phasedRegistrationName = phasedRegistrationNames[phaseName];
                                publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
                            }
                        }
                        return true;
                    } else if (dispatchConfig.registrationName) {
                        publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
                        return true;
                    }
                    return false;
                }

                /**
                 * Publishes a registration name that is used to identify dispatched events and
                 * can be used with `EventPluginHub.putListener` to register listeners.
                 *
                 * @param {string} registrationName Registration name to add.
                 * @param {object} PluginModule Plugin publishing the event.
                 * @private
                 */
                function publishRegistrationName(registrationName, pluginModule, eventName) {
                    !!EventPluginRegistry.registrationNameModules[registrationName] ? "development" !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
                    EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
                    EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

                    if ("development" !== 'production') {
                        var lowerCasedName = registrationName.toLowerCase();
                        EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

                        if (registrationName === 'onDoubleClick') {
                            EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
                        }
                    }
                }

                /**
                 * Registers plugins so that they can extract and dispatch events.
                 *
                 * @see {EventPluginHub}
                 */
                var EventPluginRegistry = {
                    /**
                     * Ordered list of injected plugins.
                     */
                    plugins: [],

                    /**
                     * Mapping from event name to dispatch config
                     */
                    eventNameDispatchConfigs: {},

                    /**
                     * Mapping from registration name to plugin module
                     */
                    registrationNameModules: {},

                    /**
                     * Mapping from registration name to event name
                     */
                    registrationNameDependencies: {},

                    /**
                     * Mapping from lowercase registration names to the properly cased version,
                     * used to warn in the case of missing event handlers. Available
                     * only in __DEV__.
                     * @type {Object}
                     */
                    possibleRegistrationNames: "development" !== 'production' ? {} : null,
                    // Trust the developer to only use possibleRegistrationNames in __DEV__

                    /**
                     * Injects an ordering of plugins (by plugin name). This allows the ordering
                     * to be decoupled from injection of the actual plugins so that ordering is
                     * always deterministic regardless of packaging, on-the-fly injection, etc.
                     *
                     * @param {array} InjectedEventPluginOrder
                     * @internal
                     * @see {EventPluginHub.injection.injectEventPluginOrder}
                     */
                    injectEventPluginOrder: function (injectedEventPluginOrder) {
                        !!eventPluginOrder ? "development" !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
                        // Clone the ordering so it cannot be dynamically mutated.
                        eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
                        recomputePluginOrdering();
                    },

                    /**
                     * Injects plugins to be used by `EventPluginHub`. The plugin names must be
                     * in the ordering injected by `injectEventPluginOrder`.
                     *
                     * Plugins can be injected as part of page initialization or on-the-fly.
                     *
                     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
                     * @internal
                     * @see {EventPluginHub.injection.injectEventPluginsByName}
                     */
                    injectEventPluginsByName: function (injectedNamesToPlugins) {
                        var isOrderingDirty = false;
                        for (var pluginName in injectedNamesToPlugins) {
                            if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
                                continue;
                            }
                            var pluginModule = injectedNamesToPlugins[pluginName];
                            if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
                                !!namesToPlugins[pluginName] ? "development" !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
                                namesToPlugins[pluginName] = pluginModule;
                                isOrderingDirty = true;
                            }
                        }
                        if (isOrderingDirty) {
                            recomputePluginOrdering();
                        }
                    },

                    /**
                     * Looks up the plugin for the supplied event.
                     *
                     * @param {object} event A synthetic event.
                     * @return {?object} The plugin that created the supplied event.
                     * @internal
                     */
                    getPluginModuleForEvent: function (event) {
                        var dispatchConfig = event.dispatchConfig;
                        if (dispatchConfig.registrationName) {
                            return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
                        }
                        if (dispatchConfig.phasedRegistrationNames !== undefined) {
                            // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
                            // that it is not undefined.
                            var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

                            for (var phase in phasedRegistrationNames) {
                                if (!phasedRegistrationNames.hasOwnProperty(phase)) {
                                    continue;
                                }
                                var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
                                if (pluginModule) {
                                    return pluginModule;
                                }
                            }
                        }
                        return null;
                    },

                    /**
                     * Exposed for unit testing.
                     * @private
                     */
                    _resetEventPlugins: function () {
                        eventPluginOrder = null;
                        for (var pluginName in namesToPlugins) {
                            if (namesToPlugins.hasOwnProperty(pluginName)) {
                                delete namesToPlugins[pluginName];
                            }
                        }
                        EventPluginRegistry.plugins.length = 0;

                        var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
                        for (var eventName in eventNameDispatchConfigs) {
                            if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
                                delete eventNameDispatchConfigs[eventName];
                            }
                        }

                        var registrationNameModules = EventPluginRegistry.registrationNameModules;
                        for (var registrationName in registrationNameModules) {
                            if (registrationNameModules.hasOwnProperty(registrationName)) {
                                delete registrationNameModules[registrationName];
                            }
                        }

                        if ("development" !== 'production') {
                            var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
                            for (var lowerCasedName in possibleRegistrationNames) {
                                if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
                                    delete possibleRegistrationNames[lowerCasedName];
                                }
                            }
                        }
                    }
                };

                module.exports = EventPluginRegistry;
            }, { "126": 126, "152": 152 }], 19: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var ReactErrorUtils = _dereq_(55);

                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                /**
                 * Injected dependencies:
                 */

                /**
                 * - `ComponentTree`: [required] Module that can convert between React instances
                 *   and actual node references.
                 */
                var ComponentTree;
                var TreeTraversal;
                var injection = {
                    injectComponentTree: function (Injected) {
                        ComponentTree = Injected;
                        if ("development" !== 'production') {
                            "development" !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
                        }
                    },
                    injectTreeTraversal: function (Injected) {
                        TreeTraversal = Injected;
                        if ("development" !== 'production') {
                            "development" !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
                        }
                    }
                };

                function isEndish(topLevelType) {
                    return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
                }

                function isMoveish(topLevelType) {
                    return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
                }
                function isStartish(topLevelType) {
                    return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
                }

                var validateEventDispatches;
                if ("development" !== 'production') {
                    validateEventDispatches = function (event) {
                        var dispatchListeners = event._dispatchListeners;
                        var dispatchInstances = event._dispatchInstances;

                        var listenersIsArr = Array.isArray(dispatchListeners);
                        var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

                        var instancesIsArr = Array.isArray(dispatchInstances);
                        var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

                        "development" !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
                    };
                }

                /**
                 * Dispatch the event to the listener.
                 * @param {SyntheticEvent} event SyntheticEvent to handle
                 * @param {boolean} simulated If the event is simulated (changes exn behavior)
                 * @param {function} listener Application-level callback
                 * @param {*} inst Internal component instance
                 */
                function executeDispatch(event, simulated, listener, inst) {
                    var type = event.type || 'unknown-event';
                    event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
                    if (simulated) {
                        ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
                    } else {
                        ReactErrorUtils.invokeGuardedCallback(type, listener, event);
                    }
                    event.currentTarget = null;
                }

                /**
                 * Standard/simple iteration through an event's collected dispatches.
                 */
                function executeDispatchesInOrder(event, simulated) {
                    var dispatchListeners = event._dispatchListeners;
                    var dispatchInstances = event._dispatchInstances;
                    if ("development" !== 'production') {
                        validateEventDispatches(event);
                    }
                    if (Array.isArray(dispatchListeners)) {
                        for (var i = 0; i < dispatchListeners.length; i++) {
                            if (event.isPropagationStopped()) {
                                break;
                            }
                            // Listeners and Instances are two parallel arrays that are always in sync.
                            executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
                        }
                    } else if (dispatchListeners) {
                        executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
                    }
                    event._dispatchListeners = null;
                    event._dispatchInstances = null;
                }

                /**
                 * Standard/simple iteration through an event's collected dispatches, but stops
                 * at the first dispatch execution returning true, and returns that id.
                 *
                 * @return {?string} id of the first dispatch execution who's listener returns
                 * true, or null if no listener returned true.
                 */
                function executeDispatchesInOrderStopAtTrueImpl(event) {
                    var dispatchListeners = event._dispatchListeners;
                    var dispatchInstances = event._dispatchInstances;
                    if ("development" !== 'production') {
                        validateEventDispatches(event);
                    }
                    if (Array.isArray(dispatchListeners)) {
                        for (var i = 0; i < dispatchListeners.length; i++) {
                            if (event.isPropagationStopped()) {
                                break;
                            }
                            // Listeners and Instances are two parallel arrays that are always in sync.
                            if (dispatchListeners[i](event, dispatchInstances[i])) {
                                return dispatchInstances[i];
                            }
                        }
                    } else if (dispatchListeners) {
                        if (dispatchListeners(event, dispatchInstances)) {
                            return dispatchInstances;
                        }
                    }
                    return null;
                }

                /**
                 * @see executeDispatchesInOrderStopAtTrueImpl
                 */
                function executeDispatchesInOrderStopAtTrue(event) {
                    var ret = executeDispatchesInOrderStopAtTrueImpl(event);
                    event._dispatchInstances = null;
                    event._dispatchListeners = null;
                    return ret;
                }

                /**
                 * Execution of a "direct" dispatch - there must be at most one dispatch
                 * accumulated on the event or it is considered an error. It doesn't really make
                 * sense for an event with multiple dispatches (bubbled) to keep track of the
                 * return values at each dispatch execution, but it does tend to make sense when
                 * dealing with "direct" dispatches.
                 *
                 * @return {*} The return value of executing the single dispatch.
                 */
                function executeDirectDispatch(event) {
                    if ("development" !== 'production') {
                        validateEventDispatches(event);
                    }
                    var dispatchListener = event._dispatchListeners;
                    var dispatchInstance = event._dispatchInstances;
                    !!Array.isArray(dispatchListener) ? "development" !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
                    event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
                    var res = dispatchListener ? dispatchListener(event) : null;
                    event.currentTarget = null;
                    event._dispatchListeners = null;
                    event._dispatchInstances = null;
                    return res;
                }

                /**
                 * @param {SyntheticEvent} event
                 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
                 */
                function hasDispatches(event) {
                    return !!event._dispatchListeners;
                }

                /**
                 * General utilities that are useful in creating custom Event Plugins.
                 */
                var EventPluginUtils = {
                    isEndish: isEndish,
                    isMoveish: isMoveish,
                    isStartish: isStartish,

                    executeDirectDispatch: executeDirectDispatch,
                    executeDispatchesInOrder: executeDispatchesInOrder,
                    executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
                    hasDispatches: hasDispatches,

                    getInstanceFromNode: function (node) {
                        return ComponentTree.getInstanceFromNode(node);
                    },
                    getNodeFromInstance: function (node) {
                        return ComponentTree.getNodeFromInstance(node);
                    },
                    isAncestor: function (a, b) {
                        return TreeTraversal.isAncestor(a, b);
                    },
                    getLowestCommonAncestor: function (a, b) {
                        return TreeTraversal.getLowestCommonAncestor(a, b);
                    },
                    getParentInstance: function (inst) {
                        return TreeTraversal.getParentInstance(inst);
                    },
                    traverseTwoPhase: function (target, fn, arg) {
                        return TreeTraversal.traverseTwoPhase(target, fn, arg);
                    },
                    traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
                        return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
                    },

                    injection: injection
                };

                module.exports = EventPluginUtils;
            }, { "126": 126, "152": 152, "159": 159, "55": 55 }], 20: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var EventPluginHub = _dereq_(17);
                var EventPluginUtils = _dereq_(19);

                var accumulateInto = _dereq_(102);
                var forEachAccumulated = _dereq_(110);
                var warning = _dereq_(159);

                var getListener = EventPluginHub.getListener;

                /**
                 * Some event types have a notion of different registration names for different
                 * "phases" of propagation. This finds listeners by a given phase.
                 */
                function listenerAtPhase(inst, event, propagationPhase) {
                    var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
                    return getListener(inst, registrationName);
                }

                /**
                 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
                 * here, allows us to not have to bind or create functions for each event.
                 * Mutating the event's members allows us to not have to create a wrapping
                 * "dispatch" object that pairs the event with the listener.
                 */
                function accumulateDirectionalDispatches(inst, phase, event) {
                    if ("development" !== 'production') {
                        "development" !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
                    }
                    var listener = listenerAtPhase(inst, event, phase);
                    if (listener) {
                        event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
                        event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
                    }
                }

                /**
                 * Collect dispatches (must be entirely collected before dispatching - see unit
                 * tests). Lazily allocate the array to conserve memory.  We must loop through
                 * each event and perform the traversal for each one. We cannot perform a
                 * single traversal for the entire collection of events because each event may
                 * have a different target.
                 */
                function accumulateTwoPhaseDispatchesSingle(event) {
                    if (event && event.dispatchConfig.phasedRegistrationNames) {
                        EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
                    }
                }

                /**
                 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
                 */
                function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
                    if (event && event.dispatchConfig.phasedRegistrationNames) {
                        var targetInst = event._targetInst;
                        var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
                        EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
                    }
                }

                /**
                 * Accumulates without regard to direction, does not look for phased
                 * registration names. Same as `accumulateDirectDispatchesSingle` but without
                 * requiring that the `dispatchMarker` be the same as the dispatched ID.
                 */
                function accumulateDispatches(inst, ignoredDirection, event) {
                    if (event && event.dispatchConfig.registrationName) {
                        var registrationName = event.dispatchConfig.registrationName;
                        var listener = getListener(inst, registrationName);
                        if (listener) {
                            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
                            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
                        }
                    }
                }

                /**
                 * Accumulates dispatches on an `SyntheticEvent`, but only for the
                 * `dispatchMarker`.
                 * @param {SyntheticEvent} event
                 */
                function accumulateDirectDispatchesSingle(event) {
                    if (event && event.dispatchConfig.registrationName) {
                        accumulateDispatches(event._targetInst, null, event);
                    }
                }

                function accumulateTwoPhaseDispatches(events) {
                    forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
                }

                function accumulateTwoPhaseDispatchesSkipTarget(events) {
                    forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
                }

                function accumulateEnterLeaveDispatches(leave, enter, from, to) {
                    EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
                }

                function accumulateDirectDispatches(events) {
                    forEachAccumulated(events, accumulateDirectDispatchesSingle);
                }

                /**
                 * A small set of propagation patterns, each of which will accept a small amount
                 * of information, and generate a set of "dispatch ready event objects" - which
                 * are sets of events that have already been annotated with a set of dispatched
                 * listener functions/ids. The API is designed this way to discourage these
                 * propagation strategies from actually executing the dispatches, since we
                 * always want to collect the entire set of dispatches before executing event a
                 * single one.
                 *
                 * @constructor EventPropagators
                 */
                var EventPropagators = {
                    accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
                    accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
                    accumulateDirectDispatches: accumulateDirectDispatches,
                    accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
                };

                module.exports = EventPropagators;
            }, { "102": 102, "110": 110, "159": 159, "17": 17, "19": 19 }], 21: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var PooledClass = _dereq_(25);

                var getTextContentAccessor = _dereq_(118);

                /**
                 * This helper class stores information about text content of a target node,
                 * allowing comparison of content before and after a given event.
                 *
                 * Identify the node where selection currently begins, then observe
                 * both its text content and its current position in the DOM. Since the
                 * browser may natively replace the target node during composition, we can
                 * use its position to find its replacement.
                 *
                 * @param {DOMEventTarget} root
                 */
                function FallbackCompositionState(root) {
                    this._root = root;
                    this._startText = this.getText();
                    this._fallbackText = null;
                }

                _assign(FallbackCompositionState.prototype, {
                    destructor: function () {
                        this._root = null;
                        this._startText = null;
                        this._fallbackText = null;
                    },

                    /**
                     * Get current text of input.
                     *
                     * @return {string}
                     */
                    getText: function () {
                        if ('value' in this._root) {
                            return this._root.value;
                        }
                        return this._root[getTextContentAccessor()];
                    },

                    /**
                     * Determine the differing substring between the initially stored
                     * text content and the current content.
                     *
                     * @return {string}
                     */
                    getData: function () {
                        if (this._fallbackText) {
                            return this._fallbackText;
                        }

                        var start;
                        var startValue = this._startText;
                        var startLength = startValue.length;
                        var end;
                        var endValue = this.getText();
                        var endLength = endValue.length;

                        for (start = 0; start < startLength; start++) {
                            if (startValue[start] !== endValue[start]) {
                                break;
                            }
                        }

                        var minEnd = startLength - start;
                        for (end = 1; end <= minEnd; end++) {
                            if (startValue[startLength - end] !== endValue[endLength - end]) {
                                break;
                            }
                        }

                        var sliceTail = end > 1 ? 1 - end : undefined;
                        this._fallbackText = endValue.slice(start, sliceTail);
                        return this._fallbackText;
                    }
                });

                PooledClass.addPoolingTo(FallbackCompositionState);

                module.exports = FallbackCompositionState;
            }, { "118": 118, "160": 160, "25": 25 }], 22: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMProperty = _dereq_(11);

                var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
                var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
                var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
                var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
                var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

                var HTMLDOMPropertyConfig = {
                    isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
                    Properties: {
                        /**
                         * Standard Properties
                         */
                        accept: 0,
                        acceptCharset: 0,
                        accessKey: 0,
                        action: 0,
                        allowFullScreen: HAS_BOOLEAN_VALUE,
                        allowTransparency: 0,
                        alt: 0,
                        // specifies target context for links with `preload` type
                        as: 0,
                        async: HAS_BOOLEAN_VALUE,
                        autoComplete: 0,
                        // autoFocus is polyfilled/normalized by AutoFocusUtils
                        // autoFocus: HAS_BOOLEAN_VALUE,
                        autoPlay: HAS_BOOLEAN_VALUE,
                        capture: HAS_BOOLEAN_VALUE,
                        cellPadding: 0,
                        cellSpacing: 0,
                        charSet: 0,
                        challenge: 0,
                        checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        cite: 0,
                        classID: 0,
                        className: 0,
                        cols: HAS_POSITIVE_NUMERIC_VALUE,
                        colSpan: 0,
                        content: 0,
                        contentEditable: 0,
                        contextMenu: 0,
                        controls: HAS_BOOLEAN_VALUE,
                        coords: 0,
                        crossOrigin: 0,
                        data: 0, // For `<object />` acts as `src`.
                        dateTime: 0,
                        'default': HAS_BOOLEAN_VALUE,
                        defer: HAS_BOOLEAN_VALUE,
                        dir: 0,
                        disabled: HAS_BOOLEAN_VALUE,
                        download: HAS_OVERLOADED_BOOLEAN_VALUE,
                        draggable: 0,
                        encType: 0,
                        form: 0,
                        formAction: 0,
                        formEncType: 0,
                        formMethod: 0,
                        formNoValidate: HAS_BOOLEAN_VALUE,
                        formTarget: 0,
                        frameBorder: 0,
                        headers: 0,
                        height: 0,
                        hidden: HAS_BOOLEAN_VALUE,
                        high: 0,
                        href: 0,
                        hrefLang: 0,
                        htmlFor: 0,
                        httpEquiv: 0,
                        icon: 0,
                        id: 0,
                        inputMode: 0,
                        integrity: 0,
                        is: 0,
                        keyParams: 0,
                        keyType: 0,
                        kind: 0,
                        label: 0,
                        lang: 0,
                        list: 0,
                        loop: HAS_BOOLEAN_VALUE,
                        low: 0,
                        manifest: 0,
                        marginHeight: 0,
                        marginWidth: 0,
                        max: 0,
                        maxLength: 0,
                        media: 0,
                        mediaGroup: 0,
                        method: 0,
                        min: 0,
                        minLength: 0,
                        // Caution; `option.selected` is not updated if `select.multiple` is
                        // disabled with `removeAttribute`.
                        multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        name: 0,
                        nonce: 0,
                        noValidate: HAS_BOOLEAN_VALUE,
                        open: HAS_BOOLEAN_VALUE,
                        optimum: 0,
                        pattern: 0,
                        placeholder: 0,
                        playsInline: HAS_BOOLEAN_VALUE,
                        poster: 0,
                        preload: 0,
                        profile: 0,
                        radioGroup: 0,
                        readOnly: HAS_BOOLEAN_VALUE,
                        referrerPolicy: 0,
                        rel: 0,
                        required: HAS_BOOLEAN_VALUE,
                        reversed: HAS_BOOLEAN_VALUE,
                        role: 0,
                        rows: HAS_POSITIVE_NUMERIC_VALUE,
                        rowSpan: HAS_NUMERIC_VALUE,
                        sandbox: 0,
                        scope: 0,
                        scoped: HAS_BOOLEAN_VALUE,
                        scrolling: 0,
                        seamless: HAS_BOOLEAN_VALUE,
                        selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
                        shape: 0,
                        size: HAS_POSITIVE_NUMERIC_VALUE,
                        sizes: 0,
                        span: HAS_POSITIVE_NUMERIC_VALUE,
                        spellCheck: 0,
                        src: 0,
                        srcDoc: 0,
                        srcLang: 0,
                        srcSet: 0,
                        start: HAS_NUMERIC_VALUE,
                        step: 0,
                        style: 0,
                        summary: 0,
                        tabIndex: 0,
                        target: 0,
                        title: 0,
                        // Setting .type throws on non-<input> tags
                        type: 0,
                        useMap: 0,
                        value: 0,
                        width: 0,
                        wmode: 0,
                        wrap: 0,

                        /**
                         * RDFa Properties
                         */
                        about: 0,
                        datatype: 0,
                        inlist: 0,
                        prefix: 0,
                        // property is also supported for OpenGraph in meta tags.
                        property: 0,
                        resource: 0,
                        'typeof': 0,
                        vocab: 0,

                        /**
                         * Non-standard Properties
                         */
                        // autoCapitalize and autoCorrect are supported in Mobile Safari for
                        // keyboard hints.
                        autoCapitalize: 0,
                        autoCorrect: 0,
                        // autoSave allows WebKit/Blink to persist values of input fields on page reloads
                        autoSave: 0,
                        // color is for Safari mask-icon link
                        color: 0,
                        // itemProp, itemScope, itemType are for
                        // Microdata support. See http://schema.org/docs/gs.html
                        itemProp: 0,
                        itemScope: HAS_BOOLEAN_VALUE,
                        itemType: 0,
                        // itemID and itemRef are for Microdata support as well but
                        // only specified in the WHATWG spec document. See
                        // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
                        itemID: 0,
                        itemRef: 0,
                        // results show looking glass icon and recent searches on input
                        // search fields in WebKit/Blink
                        results: 0,
                        // IE-only attribute that specifies security restrictions on an iframe
                        // as an alternative to the sandbox attribute on IE<10
                        security: 0,
                        // IE-only attribute that controls focus behavior
                        unselectable: 0
                    },
                    DOMAttributeNames: {
                        acceptCharset: 'accept-charset',
                        className: 'class',
                        htmlFor: 'for',
                        httpEquiv: 'http-equiv'
                    },
                    DOMPropertyNames: {},
                    DOMMutationMethods: {
                        value: function (node, value) {
                            if (value == null) {
                                return node.removeAttribute('value');
                            }

                            // Number inputs get special treatment due to some edge cases in
                            // Chrome. Let everything else assign the value attribute as normal.
                            // https://github.com/facebook/react/issues/7253#issuecomment-236074326
                            if (node.type !== 'number' || node.hasAttribute('value') === false) {
                                node.setAttribute('value', '' + value);
                            } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
                                // Don't assign an attribute if validation reports bad
                                // input. Chrome will clear the value. Additionally, don't
                                // operate on inputs that have focus, otherwise Chrome might
                                // strip off trailing decimal places and cause the user's
                                // cursor position to jump to the beginning of the input.
                                //
                                // In ReactDOMInput, we have an onBlur event that will trigger
                                // this function again when focus is lost.
                                node.setAttribute('value', '' + value);
                            }
                        }
                    }
                };

                module.exports = HTMLDOMPropertyConfig;
            }, { "11": 11 }], 23: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                /**
                 * Escape and wrap key so it is safe to use as a reactid
                 *
                 * @param {string} key to be escaped.
                 * @return {string} the escaped key.
                 */

                function escape(key) {
                    var escapeRegex = /[=:]/g;
                    var escaperLookup = {
                        '=': '=0',
                        ':': '=2'
                    };
                    var escapedString = ('' + key).replace(escapeRegex, function (match) {
                        return escaperLookup[match];
                    });

                    return '$' + escapedString;
                }

                /**
                 * Unescape and unwrap key for human-readable display
                 *
                 * @param {string} key to unescape.
                 * @return {string} the unescaped key.
                 */
                function unescape(key) {
                    var unescapeRegex = /(=0|=2)/g;
                    var unescaperLookup = {
                        '=0': '=',
                        '=2': ':'
                    };
                    var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

                    return ('' + keySubstring).replace(unescapeRegex, function (match) {
                        return unescaperLookup[match];
                    });
                }

                var KeyEscapeUtils = {
                    escape: escape,
                    unescape: unescape
                };

                module.exports = KeyEscapeUtils;
            }, {}], 24: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var ReactPropTypesSecret = _dereq_(73);
                var propTypesFactory = _dereq_(162);

                var React = _dereq_(135);
                var PropTypes = propTypesFactory(React.isValidElement);

                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                var hasReadOnlyValue = {
                    button: true,
                    checkbox: true,
                    image: true,
                    hidden: true,
                    radio: true,
                    reset: true,
                    submit: true
                };

                function _assertSingleLink(inputProps) {
                    !(inputProps.checkedLink == null || inputProps.valueLink == null) ? "development" !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
                }
                function _assertValueLink(inputProps) {
                    _assertSingleLink(inputProps);
                    !(inputProps.value == null && inputProps.onChange == null) ? "development" !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
                }

                function _assertCheckedLink(inputProps) {
                    _assertSingleLink(inputProps);
                    !(inputProps.checked == null && inputProps.onChange == null) ? "development" !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
                }

                var propTypes = {
                    value: function (props, propName, componentName) {
                        if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
                            return null;
                        }
                        return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
                    },
                    checked: function (props, propName, componentName) {
                        if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
                            return null;
                        }
                        return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
                    },
                    onChange: PropTypes.func
                };

                var loggedTypeFailures = {};
                function getDeclarationErrorAddendum(owner) {
                    if (owner) {
                        var name = owner.getName();
                        if (name) {
                            return ' Check the render method of `' + name + '`.';
                        }
                    }
                    return '';
                }

                /**
                 * Provide a linked `value` attribute for controlled forms. You should not use
                 * this outside of the ReactDOM controlled form components.
                 */
                var LinkedValueUtils = {
                    checkPropTypes: function (tagName, props, owner) {
                        for (var propName in propTypes) {
                            if (propTypes.hasOwnProperty(propName)) {
                                var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
                            }
                            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                                // Only monitor this failure once because there tends to be a lot of the
                                // same error.
                                loggedTypeFailures[error.message] = true;

                                var addendum = getDeclarationErrorAddendum(owner);
                                "development" !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
                            }
                        }
                    },

                    /**
                     * @param {object} inputProps Props for form component
                     * @return {*} current value of the input either from value prop or link.
                     */
                    getValue: function (inputProps) {
                        if (inputProps.valueLink) {
                            _assertValueLink(inputProps);
                            return inputProps.valueLink.value;
                        }
                        return inputProps.value;
                    },

                    /**
                     * @param {object} inputProps Props for form component
                     * @return {*} current checked status of the input either from checked prop
                     *             or link.
                     */
                    getChecked: function (inputProps) {
                        if (inputProps.checkedLink) {
                            _assertCheckedLink(inputProps);
                            return inputProps.checkedLink.value;
                        }
                        return inputProps.checked;
                    },

                    /**
                     * @param {object} inputProps Props for form component
                     * @param {SyntheticEvent} event change event to handle
                     */
                    executeOnChange: function (inputProps, event) {
                        if (inputProps.valueLink) {
                            _assertValueLink(inputProps);
                            return inputProps.valueLink.requestChange(event.target.value);
                        } else if (inputProps.checkedLink) {
                            _assertCheckedLink(inputProps);
                            return inputProps.checkedLink.requestChange(event.target.checked);
                        } else if (inputProps.onChange) {
                            return inputProps.onChange.call(undefined, event);
                        }
                    }
                };

                module.exports = LinkedValueUtils;
            }, { "126": 126, "135": 135, "152": 152, "159": 159, "162": 162, "73": 73 }], 25: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                /**
                 * Static poolers. Several custom versions for each potential number of
                 * arguments. A completely generic pooler is easy to implement, but would
                 * require accessing the `arguments` object. In each of these, `this` refers to
                 * the Class itself, not an instance. If any others are needed, simply add them
                 * here, or in their own files.
                 */
                var oneArgumentPooler = function (copyFieldsFrom) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, copyFieldsFrom);
                        return instance;
                    } else {
                        return new Klass(copyFieldsFrom);
                    }
                };

                var twoArgumentPooler = function (a1, a2) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2);
                        return instance;
                    } else {
                        return new Klass(a1, a2);
                    }
                };

                var threeArgumentPooler = function (a1, a2, a3) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2, a3);
                        return instance;
                    } else {
                        return new Klass(a1, a2, a3);
                    }
                };

                var fourArgumentPooler = function (a1, a2, a3, a4) {
                    var Klass = this;
                    if (Klass.instancePool.length) {
                        var instance = Klass.instancePool.pop();
                        Klass.call(instance, a1, a2, a3, a4);
                        return instance;
                    } else {
                        return new Klass(a1, a2, a3, a4);
                    }
                };

                var standardReleaser = function (instance) {
                    var Klass = this;
                    !(instance instanceof Klass) ? "development" !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
                    instance.destructor();
                    if (Klass.instancePool.length < Klass.poolSize) {
                        Klass.instancePool.push(instance);
                    }
                };

                var DEFAULT_POOL_SIZE = 10;
                var DEFAULT_POOLER = oneArgumentPooler;

                /**
                 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
                 * itself (statically) not adding any prototypical fields. Any CopyConstructor
                 * you give this may have a `poolSize` property, and will look for a
                 * prototypical `destructor` on instances.
                 *
                 * @param {Function} CopyConstructor Constructor that can be used to reset.
                 * @param {Function} pooler Customizable pooler.
                 */
                var addPoolingTo = function (CopyConstructor, pooler) {
                    // Casting as any so that flow ignores the actual implementation and trusts
                    // it to match the type we declared
                    var NewKlass = CopyConstructor;
                    NewKlass.instancePool = [];
                    NewKlass.getPooled = pooler || DEFAULT_POOLER;
                    if (!NewKlass.poolSize) {
                        NewKlass.poolSize = DEFAULT_POOL_SIZE;
                    }
                    NewKlass.release = standardReleaser;
                    return NewKlass;
                };

                var PooledClass = {
                    addPoolingTo: addPoolingTo,
                    oneArgumentPooler: oneArgumentPooler,
                    twoArgumentPooler: twoArgumentPooler,
                    threeArgumentPooler: threeArgumentPooler,
                    fourArgumentPooler: fourArgumentPooler
                };

                module.exports = PooledClass;
            }, { "126": 126, "152": 152 }], 26: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var EventPluginRegistry = _dereq_(18);
                var ReactEventEmitterMixin = _dereq_(56);
                var ViewportMetrics = _dereq_(101);

                var getVendorPrefixedEventName = _dereq_(119);
                var isEventSupported = _dereq_(122);

                /**
                 * Summary of `ReactBrowserEventEmitter` event handling:
                 *
                 *  - Top-level delegation is used to trap most native browser events. This
                 *    may only occur in the main thread and is the responsibility of
                 *    ReactEventListener, which is injected and can therefore support pluggable
                 *    event sources. This is the only work that occurs in the main thread.
                 *
                 *  - We normalize and de-duplicate events to account for browser quirks. This
                 *    may be done in the worker thread.
                 *
                 *  - Forward these native events (with the associated top-level type used to
                 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
                 *    to extract any synthetic events.
                 *
                 *  - The `EventPluginHub` will then process each event by annotating them with
                 *    "dispatches", a sequence of listeners and IDs that care about that event.
                 *
                 *  - The `EventPluginHub` then dispatches the events.
                 *
                 * Overview of React and the event system:
                 *
                 * +------------+    .
                 * |    DOM     |    .
                 * +------------+    .
                 *       |           .
                 *       v           .
                 * +------------+    .
                 * | ReactEvent |    .
                 * |  Listener  |    .
                 * +------------+    .                         +-----------+
                 *       |           .               +--------+|SimpleEvent|
                 *       |           .               |         |Plugin     |
                 * +-----|------+    .               v         +-----------+
                 * |     |      |    .    +--------------+                    +------------+
                 * |     +-----------.--->|EventPluginHub|                    |    Event   |
                 * |            |    .    |              |     +-----------+  | Propagators|
                 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
                 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
                 * |            |    .    |              |     +-----------+  |  utilities |
                 * |     +-----------.--->|              |                    +------------+
                 * |     |      |    .    +--------------+
                 * +-----|------+    .                ^        +-----------+
                 *       |           .                |        |Enter/Leave|
                 *       +           .                +-------+|Plugin     |
                 * +-------------+   .                         +-----------+
                 * | application |   .
                 * |-------------|   .
                 * |             |   .
                 * |             |   .
                 * +-------------+   .
                 *                   .
                 *    React Core     .  General Purpose Event Plugin System
                 */

                var hasEventPageXY;
                var alreadyListeningTo = {};
                var isMonitoringScrollValue = false;
                var reactTopListenersCounter = 0;

                // For events like 'submit' which don't consistently bubble (which we trap at a
                // lower node than `document`), binding at `document` would cause duplicate
                // events so we don't include them here
                var topEventMapping = {
                    topAbort: 'abort',
                    topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
                    topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
                    topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
                    topBlur: 'blur',
                    topCanPlay: 'canplay',
                    topCanPlayThrough: 'canplaythrough',
                    topChange: 'change',
                    topClick: 'click',
                    topCompositionEnd: 'compositionend',
                    topCompositionStart: 'compositionstart',
                    topCompositionUpdate: 'compositionupdate',
                    topContextMenu: 'contextmenu',
                    topCopy: 'copy',
                    topCut: 'cut',
                    topDoubleClick: 'dblclick',
                    topDrag: 'drag',
                    topDragEnd: 'dragend',
                    topDragEnter: 'dragenter',
                    topDragExit: 'dragexit',
                    topDragLeave: 'dragleave',
                    topDragOver: 'dragover',
                    topDragStart: 'dragstart',
                    topDrop: 'drop',
                    topDurationChange: 'durationchange',
                    topEmptied: 'emptied',
                    topEncrypted: 'encrypted',
                    topEnded: 'ended',
                    topError: 'error',
                    topFocus: 'focus',
                    topInput: 'input',
                    topKeyDown: 'keydown',
                    topKeyPress: 'keypress',
                    topKeyUp: 'keyup',
                    topLoadedData: 'loadeddata',
                    topLoadedMetadata: 'loadedmetadata',
                    topLoadStart: 'loadstart',
                    topMouseDown: 'mousedown',
                    topMouseMove: 'mousemove',
                    topMouseOut: 'mouseout',
                    topMouseOver: 'mouseover',
                    topMouseUp: 'mouseup',
                    topPaste: 'paste',
                    topPause: 'pause',
                    topPlay: 'play',
                    topPlaying: 'playing',
                    topProgress: 'progress',
                    topRateChange: 'ratechange',
                    topScroll: 'scroll',
                    topSeeked: 'seeked',
                    topSeeking: 'seeking',
                    topSelectionChange: 'selectionchange',
                    topStalled: 'stalled',
                    topSuspend: 'suspend',
                    topTextInput: 'textInput',
                    topTimeUpdate: 'timeupdate',
                    topTouchCancel: 'touchcancel',
                    topTouchEnd: 'touchend',
                    topTouchMove: 'touchmove',
                    topTouchStart: 'touchstart',
                    topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
                    topVolumeChange: 'volumechange',
                    topWaiting: 'waiting',
                    topWheel: 'wheel'
                };

                /**
                 * To ensure no conflicts with other potential React instances on the page
                 */
                var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

                function getListeningForDocument(mountAt) {
                    // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
                    // directly.
                    if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
                        mountAt[topListenersIDKey] = reactTopListenersCounter++;
                        alreadyListeningTo[mountAt[topListenersIDKey]] = {};
                    }
                    return alreadyListeningTo[mountAt[topListenersIDKey]];
                }

                /**
                 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
                 * example:
                 *
                 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
                 *
                 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
                 *
                 * @internal
                 */
                var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
                    /**
                     * Injectable event backend
                     */
                    ReactEventListener: null,

                    injection: {
                        /**
                         * @param {object} ReactEventListener
                         */
                        injectReactEventListener: function (ReactEventListener) {
                            ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
                            ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
                        }
                    },

                    /**
                     * Sets whether or not any created callbacks should be enabled.
                     *
                     * @param {boolean} enabled True if callbacks should be enabled.
                     */
                    setEnabled: function (enabled) {
                        if (ReactBrowserEventEmitter.ReactEventListener) {
                            ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
                        }
                    },

                    /**
                     * @return {boolean} True if callbacks are enabled.
                     */
                    isEnabled: function () {
                        return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
                    },

                    /**
                     * We listen for bubbled touch events on the document object.
                     *
                     * Firefox v8.01 (and possibly others) exhibited strange behavior when
                     * mounting `onmousemove` events at some node that was not the document
                     * element. The symptoms were that if your mouse is not moving over something
                     * contained within that mount point (for example on the background) the
                     * top-level listeners for `onmousemove` won't be called. However, if you
                     * register the `mousemove` on the document object, then it will of course
                     * catch all `mousemove`s. This along with iOS quirks, justifies restricting
                     * top-level listeners to the document object only, at least for these
                     * movement types of events and possibly all events.
                     *
                     * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
                     *
                     * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
                     * they bubble to document.
                     *
                     * @param {string} registrationName Name of listener (e.g. `onClick`).
                     * @param {object} contentDocumentHandle Document which owns the container
                     */
                    listenTo: function (registrationName, contentDocumentHandle) {
                        var mountAt = contentDocumentHandle;
                        var isListening = getListeningForDocument(mountAt);
                        var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

                        for (var i = 0; i < dependencies.length; i++) {
                            var dependency = dependencies[i];
                            if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
                                if (dependency === 'topWheel') {
                                    if (isEventSupported('wheel')) {
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
                                    } else if (isEventSupported('mousewheel')) {
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
                                    } else {
                                        // Firefox needs to capture a different mouse scroll event.
                                        // @see http://www.quirksmode.org/dom/events/tests/scroll.html
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
                                    }
                                } else if (dependency === 'topScroll') {
                                    if (isEventSupported('scroll', true)) {
                                        ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
                                    } else {
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
                                    }
                                } else if (dependency === 'topFocus' || dependency === 'topBlur') {
                                    if (isEventSupported('focus', true)) {
                                        ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
                                        ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
                                    } else if (isEventSupported('focusin')) {
                                        // IE has `focusin` and `focusout` events which bubble.
                                        // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
                                        ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
                                    }

                                    // to make sure blur and focus event listeners are only attached once
                                    isListening.topBlur = true;
                                    isListening.topFocus = true;
                                } else if (topEventMapping.hasOwnProperty(dependency)) {
                                    ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
                                }

                                isListening[dependency] = true;
                            }
                        }
                    },

                    trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
                        return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
                    },

                    trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
                        return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
                    },

                    /**
                     * Protect against document.createEvent() returning null
                     * Some popup blocker extensions appear to do this:
                     * https://github.com/facebook/react/issues/6887
                     */
                    supportsEventPageXY: function () {
                        if (!document.createEvent) {
                            return false;
                        }
                        var ev = document.createEvent('MouseEvent');
                        return ev != null && 'pageX' in ev;
                    },

                    /**
                     * Listens to window scroll and resize events. We cache scroll values so that
                     * application code can access them without triggering reflows.
                     *
                     * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
                     * pageX/pageY isn't supported (legacy browsers).
                     *
                     * NOTE: Scroll events do not bubble.
                     *
                     * @see http://www.quirksmode.org/dom/events/scroll.html
                     */
                    ensureScrollValueMonitoring: function () {
                        if (hasEventPageXY === undefined) {
                            hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
                        }
                        if (!hasEventPageXY && !isMonitoringScrollValue) {
                            var refresh = ViewportMetrics.refreshScrollValues;
                            ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
                            isMonitoringScrollValue = true;
                        }
                    }
                });

                module.exports = ReactBrowserEventEmitter;
            }, { "101": 101, "119": 119, "122": 122, "160": 160, "18": 18, "56": 56 }], 27: [function (_dereq_, module, exports) {
                (function (process) {
                    /**
                     * Copyright 2014-present, Facebook, Inc.
                     * All rights reserved.
                     *
                     * This source code is licensed under the BSD-style license found in the
                     * LICENSE file in the root directory of this source tree. An additional grant
                     * of patent rights can be found in the PATENTS file in the same directory.
                     *
                     */

                    'use strict';

                    var ReactReconciler = _dereq_(75);

                    var instantiateReactComponent = _dereq_(121);
                    var KeyEscapeUtils = _dereq_(23);
                    var shouldUpdateReactComponent = _dereq_(130);
                    var traverseAllChildren = _dereq_(131);
                    var warning = _dereq_(159);

                    var ReactComponentTreeHook;

                    if (typeof process !== 'undefined' && process.env && "development" === 'test') {
                        // Temporary hack.
                        // Inline requires don't work well with Jest:
                        // https://github.com/facebook/react/issues/7240
                        // Remove the inline requires when we don't need them anymore:
                        // https://github.com/facebook/react/pull/7178
                        ReactComponentTreeHook = _dereq_(133);
                    }

                    function instantiateChild(childInstances, child, name, selfDebugID) {
                        // We found a component instance.
                        var keyUnique = childInstances[name] === undefined;
                        if ("development" !== 'production') {
                            if (!ReactComponentTreeHook) {
                                ReactComponentTreeHook = _dereq_(133);
                            }
                            if (!keyUnique) {
                                "development" !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
                            }
                        }
                        if (child != null && keyUnique) {
                            childInstances[name] = instantiateReactComponent(child, true);
                        }
                    }

                    /**
                     * ReactChildReconciler provides helpers for initializing or updating a set of
                     * children. Its output is suitable for passing it onto ReactMultiChild which
                     * does diffed reordering and insertion.
                     */
                    var ReactChildReconciler = {
                        /**
                         * Generates a "mount image" for each of the supplied children. In the case
                         * of `ReactDOMComponent`, a mount image is a string of markup.
                         *
                         * @param {?object} nestedChildNodes Nested child maps.
                         * @return {?object} A set of child instances.
                         * @internal
                         */
                        instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
                        {
                            if (nestedChildNodes == null) {
                                return null;
                            }
                            var childInstances = {};

                            if ("development" !== 'production') {
                                traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
                                    return instantiateChild(childInsts, child, name, selfDebugID);
                                }, childInstances);
                            } else {
                                traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
                            }
                            return childInstances;
                        },

                        /**
                         * Updates the rendered children and returns a new set of children.
                         *
                         * @param {?object} prevChildren Previously initialized set of children.
                         * @param {?object} nextChildren Flat child element maps.
                         * @param {ReactReconcileTransaction} transaction
                         * @param {object} context
                         * @return {?object} A new set of child instances.
                         * @internal
                         */
                        updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
                        {
                            // We currently don't have a way to track moves here but if we use iterators
                            // instead of for..in we can zip the iterators and check if an item has
                            // moved.
                            // TODO: If nothing has changed, return the prevChildren object so that we
                            // can quickly bailout if nothing has changed.
                            if (!nextChildren && !prevChildren) {
                                return;
                            }
                            var name;
                            var prevChild;
                            for (name in nextChildren) {
                                if (!nextChildren.hasOwnProperty(name)) {
                                    continue;
                                }
                                prevChild = prevChildren && prevChildren[name];
                                var prevElement = prevChild && prevChild._currentElement;
                                var nextElement = nextChildren[name];
                                if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
                                    ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
                                    nextChildren[name] = prevChild;
                                } else {
                                    if (prevChild) {
                                        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
                                        ReactReconciler.unmountComponent(prevChild, false);
                                    }
                                    // The child must be instantiated before it's mounted.
                                    var nextChildInstance = instantiateReactComponent(nextElement, true);
                                    nextChildren[name] = nextChildInstance;
                                    // Creating mount image now ensures refs are resolved in right order
                                    // (see https://github.com/facebook/react/pull/7101 for explanation).
                                    var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
                                    mountImages.push(nextChildMountImage);
                                }
                            }
                            // Unmount children that are no longer present.
                            for (name in prevChildren) {
                                if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
                                    prevChild = prevChildren[name];
                                    removedNodes[name] = ReactReconciler.getHostNode(prevChild);
                                    ReactReconciler.unmountComponent(prevChild, false);
                                }
                            }
                        },

                        /**
                         * Unmounts all rendered children. This should be used to clean up children
                         * when this component is unmounted.
                         *
                         * @param {?object} renderedChildren Previously initialized set of children.
                         * @internal
                         */
                        unmountChildren: function (renderedChildren, safely) {
                            for (var name in renderedChildren) {
                                if (renderedChildren.hasOwnProperty(name)) {
                                    var renderedChild = renderedChildren[name];
                                    ReactReconciler.unmountComponent(renderedChild, safely);
                                }
                            }
                        }
                    };

                    module.exports = ReactChildReconciler;
                }).call(this, undefined)
            }, { "121": 121, "130": 130, "131": 131, "133": 133, "159": 159, "23": 23, "75": 75 }], 28: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMChildrenOperations = _dereq_(8);
                var ReactDOMIDOperations = _dereq_(38);

                /**
                 * Abstracts away all functionality of the reconciler that requires knowledge of
                 * the browser context. TODO: These callers should be refactored to avoid the
                 * need for this injection.
                 */
                var ReactComponentBrowserEnvironment = {
                    processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

                    replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
                };

                module.exports = ReactComponentBrowserEnvironment;
            }, { "38": 38, "8": 8 }], 29: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                var injected = false;

                var ReactComponentEnvironment = {
                    /**
                     * Optionally injectable hook for swapping out mount images in the middle of
                     * the tree.
                     */
                    replaceNodeWithMarkup: null,

                    /**
                     * Optionally injectable hook for processing a queue of child updates. Will
                     * later move into MultiChildComponents.
                     */
                    processChildrenUpdates: null,

                    injection: {
                        injectEnvironment: function (environment) {
                            !!injected ? "development" !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
                            ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
                            ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
                            injected = true;
                        }
                    }
                };

                module.exports = ReactComponentEnvironment;
            }, { "126": 126, "152": 152 }], 30: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var React = _dereq_(135);
                var ReactComponentEnvironment = _dereq_(29);
                var ReactCurrentOwner = _dereq_(134);
                var ReactErrorUtils = _dereq_(55);
                var ReactInstanceMap = _dereq_(63);
                var ReactInstrumentation = _dereq_(64);
                var ReactNodeTypes = _dereq_(69);
                var ReactReconciler = _dereq_(75);

                if ("development" !== 'production') {
                    var checkReactTypeSpec = _dereq_(104);
                }

                var emptyObject = _dereq_(145);
                var invariant = _dereq_(152);
                var shallowEqual = _dereq_(158);
                var shouldUpdateReactComponent = _dereq_(130);
                var warning = _dereq_(159);

                var CompositeTypes = {
                    ImpureClass: 0,
                    PureClass: 1,
                    StatelessFunctional: 2
                };

                function StatelessComponent(Component) { }
                StatelessComponent.prototype.render = function () {
                    var Component = ReactInstanceMap.get(this)._currentElement.type;
                    var element = Component(this.props, this.context, this.updater);
                    warnIfInvalidElement(Component, element);
                    return element;
                };

                function warnIfInvalidElement(Component, element) {
                    if ("development" !== 'production') {
                        "development" !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
                        "development" !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
                    }
                }

                function shouldConstruct(Component) {
                    return !!(Component.prototype && Component.prototype.isReactComponent);
                }

                function isPureComponent(Component) {
                    return !!(Component.prototype && Component.prototype.isPureReactComponent);
                }

                // Separated into a function to contain deoptimizations caused by try/finally.
                function measureLifeCyclePerf(fn, debugID, timerType) {
                    if (debugID === 0) {
                        // Top-level wrappers (see ReactMount) and empty components (see
                        // ReactDOMEmptyComponent) are invisible to hooks and devtools.
                        // Both are implementation details that should go away in the future.
                        return fn();
                    }

                    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
                    try {
                        return fn();
                    } finally {
                        ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
                    }
                }

                /**
                 * ------------------ The Life-Cycle of a Composite Component ------------------
                 *
                 * - constructor: Initialization of state. The instance is now retained.
                 *   - componentWillMount
                 *   - render
                 *   - [children's constructors]
                 *     - [children's componentWillMount and render]
                 *     - [children's componentDidMount]
                 *     - componentDidMount
                 *
                 *       Update Phases:
                 *       - componentWillReceiveProps (only called if parent updated)
                 *       - shouldComponentUpdate
                 *         - componentWillUpdate
                 *           - render
                 *           - [children's constructors or receive props phases]
                 *         - componentDidUpdate
                 *
                 *     - componentWillUnmount
                 *     - [children's componentWillUnmount]
                 *   - [children destroyed]
                 * - (destroyed): The instance is now blank, released by React and ready for GC.
                 *
                 * -----------------------------------------------------------------------------
                 */

                /**
                 * An incrementing ID assigned to each component when it is mounted. This is
                 * used to enforce the order in which `ReactUpdates` updates dirty components.
                 *
                 * @private
                 */
                var nextMountID = 1;

                /**
                 * @lends {ReactCompositeComponent.prototype}
                 */
                var ReactCompositeComponent = {
                    /**
                     * Base constructor for all composite component.
                     *
                     * @param {ReactElement} element
                     * @final
                     * @internal
                     */
                    construct: function (element) {
                        this._currentElement = element;
                        this._rootNodeID = 0;
                        this._compositeType = null;
                        this._instance = null;
                        this._hostParent = null;
                        this._hostContainerInfo = null;

                        // See ReactUpdateQueue
                        this._updateBatchNumber = null;
                        this._pendingElement = null;
                        this._pendingStateQueue = null;
                        this._pendingReplaceState = false;
                        this._pendingForceUpdate = false;

                        this._renderedNodeType = null;
                        this._renderedComponent = null;
                        this._context = null;
                        this._mountOrder = 0;
                        this._topLevelWrapper = null;

                        // See ReactUpdates and ReactUpdateQueue.
                        this._pendingCallbacks = null;

                        // ComponentWillUnmount shall only be called once
                        this._calledComponentWillUnmount = false;

                        if ("development" !== 'production') {
                            this._warnedAboutRefsInRender = false;
                        }
                    },

                    /**
                     * Initializes the component, renders markup, and registers event listeners.
                     *
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {?object} hostParent
                     * @param {?object} hostContainerInfo
                     * @param {?object} context
                     * @return {?string} Rendered markup to be inserted into the DOM.
                     * @final
                     * @internal
                     */
                    mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
                        var _this = this;

                        this._context = context;
                        this._mountOrder = nextMountID++;
                        this._hostParent = hostParent;
                        this._hostContainerInfo = hostContainerInfo;

                        var publicProps = this._currentElement.props;
                        var publicContext = this._processContext(context);

                        var Component = this._currentElement.type;

                        var updateQueue = transaction.getUpdateQueue();

                        // Initialize the public class
                        var doConstruct = shouldConstruct(Component);
                        var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
                        var renderedElement;

                        // Support functional components
                        if (!doConstruct && (inst == null || inst.render == null)) {
                            renderedElement = inst;
                            warnIfInvalidElement(Component, renderedElement);
                            !(inst === null || inst === false || React.isValidElement(inst)) ? "development" !== 'production' ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
                            inst = new StatelessComponent(Component);
                            this._compositeType = CompositeTypes.StatelessFunctional;
                        } else {
                            if (isPureComponent(Component)) {
                                this._compositeType = CompositeTypes.PureClass;
                            } else {
                                this._compositeType = CompositeTypes.ImpureClass;
                            }
                        }

                        if ("development" !== 'production') {
                            // This will throw later in _renderValidatedComponent, but add an early
                            // warning now to help debugging
                            if (inst.render == null) {
                                "development" !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
                            }

                            var propsMutated = inst.props !== publicProps;
                            var componentName = Component.displayName || Component.name || 'Component';

                            "development" !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
                        }

                        // These should be set up in the constructor, but as a convenience for
                        // simpler class abstractions, we set them up after the fact.
                        inst.props = publicProps;
                        inst.context = publicContext;
                        inst.refs = emptyObject;
                        inst.updater = updateQueue;

                        this._instance = inst;

                        // Store a reference from the instance back to the internal representation
                        ReactInstanceMap.set(inst, this);

                        if ("development" !== 'production') {
                            // Since plain JS classes are defined without any special initialization
                            // logic, we can not catch common errors early. Therefore, we have to
                            // catch them here, at initialization time, instead.
                            "development" !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
                            "development" !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
                            "development" !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
                            "development" !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
                            "development" !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
                            "development" !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
                            "development" !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
                        }

                        var initialState = inst.state;
                        if (initialState === undefined) {
                            inst.state = initialState = null;
                        }
                        !(typeof initialState === 'object' && !Array.isArray(initialState)) ? "development" !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

                        this._pendingStateQueue = null;
                        this._pendingReplaceState = false;
                        this._pendingForceUpdate = false;

                        var markup;
                        if (inst.unstable_handleError) {
                            markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
                        } else {
                            markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
                        }

                        if (inst.componentDidMount) {
                            if ("development" !== 'production') {
                                transaction.getReactMountReady().enqueue(function () {
                                    measureLifeCyclePerf(function () {
                                        return inst.componentDidMount();
                                    }, _this._debugID, 'componentDidMount');
                                });
                            } else {
                                transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
                            }
                        }

                        return markup;
                    },

                    _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
                        if ("development" !== 'production') {
                            ReactCurrentOwner.current = this;
                            try {
                                return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
                            } finally {
                                ReactCurrentOwner.current = null;
                            }
                        } else {
                            return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
                        }
                    },

                    _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
                        var Component = this._currentElement.type;

                        if (doConstruct) {
                            if ("development" !== 'production') {
                                return measureLifeCyclePerf(function () {
                                    return new Component(publicProps, publicContext, updateQueue);
                                }, this._debugID, 'ctor');
                            } else {
                                return new Component(publicProps, publicContext, updateQueue);
                            }
                        }

                        // This can still be an instance in case of factory components
                        // but we'll count this as time spent rendering as the more common case.
                        if ("development" !== 'production') {
                            return measureLifeCyclePerf(function () {
                                return Component(publicProps, publicContext, updateQueue);
                            }, this._debugID, 'render');
                        } else {
                            return Component(publicProps, publicContext, updateQueue);
                        }
                    },

                    performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
                        var markup;
                        var checkpoint = transaction.checkpoint();
                        try {
                            markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
                        } catch (e) {
                            // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
                            transaction.rollback(checkpoint);
                            this._instance.unstable_handleError(e);
                            if (this._pendingStateQueue) {
                                this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
                            }
                            checkpoint = transaction.checkpoint();

                            this._renderedComponent.unmountComponent(true);
                            transaction.rollback(checkpoint);

                            // Try again - we've informed the component about the error, so they can render an error message this time.
                            // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
                            markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
                        }
                        return markup;
                    },

                    performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
                        var inst = this._instance;

                        var debugID = 0;
                        if ("development" !== 'production') {
                            debugID = this._debugID;
                        }

                        if (inst.componentWillMount) {
                            if ("development" !== 'production') {
                                measureLifeCyclePerf(function () {
                                    return inst.componentWillMount();
                                }, debugID, 'componentWillMount');
                            } else {
                                inst.componentWillMount();
                            }
                            // When mounting, calls to `setState` by `componentWillMount` will set
                            // `this._pendingStateQueue` without triggering a re-render.
                            if (this._pendingStateQueue) {
                                inst.state = this._processPendingState(inst.props, inst.context);
                            }
                        }

                        // If not a stateless component, we now render
                        if (renderedElement === undefined) {
                            renderedElement = this._renderValidatedComponent();
                        }

                        var nodeType = ReactNodeTypes.getType(renderedElement);
                        this._renderedNodeType = nodeType;
                        var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
                        );
                        this._renderedComponent = child;

                        var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

                        if ("development" !== 'production') {
                            if (debugID !== 0) {
                                var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
                                ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
                            }
                        }

                        return markup;
                    },

                    getHostNode: function () {
                        return ReactReconciler.getHostNode(this._renderedComponent);
                    },

                    /**
                     * Releases any resources allocated by `mountComponent`.
                     *
                     * @final
                     * @internal
                     */
                    unmountComponent: function (safely) {
                        if (!this._renderedComponent) {
                            return;
                        }

                        var inst = this._instance;

                        if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
                            inst._calledComponentWillUnmount = true;

                            if (safely) {
                                var name = this.getName() + '.componentWillUnmount()';
                                ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
                            } else {
                                if ("development" !== 'production') {
                                    measureLifeCyclePerf(function () {
                                        return inst.componentWillUnmount();
                                    }, this._debugID, 'componentWillUnmount');
                                } else {
                                    inst.componentWillUnmount();
                                }
                            }
                        }

                        if (this._renderedComponent) {
                            ReactReconciler.unmountComponent(this._renderedComponent, safely);
                            this._renderedNodeType = null;
                            this._renderedComponent = null;
                            this._instance = null;
                        }

                        // Reset pending fields
                        // Even if this component is scheduled for another update in ReactUpdates,
                        // it would still be ignored because these fields are reset.
                        this._pendingStateQueue = null;
                        this._pendingReplaceState = false;
                        this._pendingForceUpdate = false;
                        this._pendingCallbacks = null;
                        this._pendingElement = null;

                        // These fields do not really need to be reset since this object is no
                        // longer accessible.
                        this._context = null;
                        this._rootNodeID = 0;
                        this._topLevelWrapper = null;

                        // Delete the reference from the instance to this internal representation
                        // which allow the internals to be properly cleaned up even if the user
                        // leaks a reference to the public instance.
                        ReactInstanceMap.remove(inst);

                        // Some existing components rely on inst.props even after they've been
                        // destroyed (in event handlers).
                        // TODO: inst.props = null;
                        // TODO: inst.state = null;
                        // TODO: inst.context = null;
                    },

                    /**
                     * Filters the context object to only contain keys specified in
                     * `contextTypes`
                     *
                     * @param {object} context
                     * @return {?object}
                     * @private
                     */
                    _maskContext: function (context) {
                        var Component = this._currentElement.type;
                        var contextTypes = Component.contextTypes;
                        if (!contextTypes) {
                            return emptyObject;
                        }
                        var maskedContext = {};
                        for (var contextName in contextTypes) {
                            maskedContext[contextName] = context[contextName];
                        }
                        return maskedContext;
                    },

                    /**
                     * Filters the context object to only contain keys specified in
                     * `contextTypes`, and asserts that they are valid.
                     *
                     * @param {object} context
                     * @return {?object}
                     * @private
                     */
                    _processContext: function (context) {
                        var maskedContext = this._maskContext(context);
                        if ("development" !== 'production') {
                            var Component = this._currentElement.type;
                            if (Component.contextTypes) {
                                this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
                            }
                        }
                        return maskedContext;
                    },

                    /**
                     * @param {object} currentContext
                     * @return {object}
                     * @private
                     */
                    _processChildContext: function (currentContext) {
                        var Component = this._currentElement.type;
                        var inst = this._instance;
                        var childContext;

                        if (inst.getChildContext) {
                            if ("development" !== 'production') {
                                ReactInstrumentation.debugTool.onBeginProcessingChildContext();
                                try {
                                    childContext = inst.getChildContext();
                                } finally {
                                    ReactInstrumentation.debugTool.onEndProcessingChildContext();
                                }
                            } else {
                                childContext = inst.getChildContext();
                            }
                        }

                        if (childContext) {
                            !(typeof Component.childContextTypes === 'object') ? "development" !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
                            if ("development" !== 'production') {
                                this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
                            }
                            for (var name in childContext) {
                                !(name in Component.childContextTypes) ? "development" !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
                            }
                            return _assign({}, currentContext, childContext);
                        }
                        return currentContext;
                    },

                    /**
                     * Assert that the context types are valid
                     *
                     * @param {object} typeSpecs Map of context field to a ReactPropType
                     * @param {object} values Runtime values that need to be type-checked
                     * @param {string} location e.g. "prop", "context", "child context"
                     * @private
                     */
                    _checkContextTypes: function (typeSpecs, values, location) {
                        if ("development" !== 'production') {
                            checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
                        }
                    },

                    receiveComponent: function (nextElement, transaction, nextContext) {
                        var prevElement = this._currentElement;
                        var prevContext = this._context;

                        this._pendingElement = null;

                        this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
                    },

                    /**
                     * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
                     * is set, update the component.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    performUpdateIfNecessary: function (transaction) {
                        if (this._pendingElement != null) {
                            ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
                        } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
                            this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
                        } else {
                            this._updateBatchNumber = null;
                        }
                    },

                    /**
                     * Perform an update to a mounted component. The componentWillReceiveProps and
                     * shouldComponentUpdate methods are called, then (assuming the update isn't
                     * skipped) the remaining update lifecycle methods are called and the DOM
                     * representation is updated.
                     *
                     * By default, this implements React's rendering and reconciliation algorithm.
                     * Sophisticated clients may wish to override this.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @param {ReactElement} prevParentElement
                     * @param {ReactElement} nextParentElement
                     * @internal
                     * @overridable
                     */
                    updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
                        var inst = this._instance;
                        !(inst != null) ? "development" !== 'production' ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

                        var willReceive = false;
                        var nextContext;

                        // Determine if the context has changed or not
                        if (this._context === nextUnmaskedContext) {
                            nextContext = inst.context;
                        } else {
                            nextContext = this._processContext(nextUnmaskedContext);
                            willReceive = true;
                        }

                        var prevProps = prevParentElement.props;
                        var nextProps = nextParentElement.props;

                        // Not a simple state update but a props update
                        if (prevParentElement !== nextParentElement) {
                            willReceive = true;
                        }

                        // An update here will schedule an update but immediately set
                        // _pendingStateQueue which will ensure that any state updates gets
                        // immediately reconciled instead of waiting for the next batch.
                        if (willReceive && inst.componentWillReceiveProps) {
                            if ("development" !== 'production') {
                                measureLifeCyclePerf(function () {
                                    return inst.componentWillReceiveProps(nextProps, nextContext);
                                }, this._debugID, 'componentWillReceiveProps');
                            } else {
                                inst.componentWillReceiveProps(nextProps, nextContext);
                            }
                        }

                        var nextState = this._processPendingState(nextProps, nextContext);
                        var shouldUpdate = true;

                        if (!this._pendingForceUpdate) {
                            if (inst.shouldComponentUpdate) {
                                if ("development" !== 'production') {
                                    shouldUpdate = measureLifeCyclePerf(function () {
                                        return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
                                    }, this._debugID, 'shouldComponentUpdate');
                                } else {
                                    shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
                                }
                            } else {
                                if (this._compositeType === CompositeTypes.PureClass) {
                                    shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
                                }
                            }
                        }

                        if ("development" !== 'production') {
                            "development" !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
                        }

                        this._updateBatchNumber = null;
                        if (shouldUpdate) {
                            this._pendingForceUpdate = false;
                            // Will set `this.props`, `this.state` and `this.context`.
                            this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
                        } else {
                            // If it's determined that a component should not update, we still want
                            // to set props and state but we shortcut the rest of the update.
                            this._currentElement = nextParentElement;
                            this._context = nextUnmaskedContext;
                            inst.props = nextProps;
                            inst.state = nextState;
                            inst.context = nextContext;
                        }
                    },

                    _processPendingState: function (props, context) {
                        var inst = this._instance;
                        var queue = this._pendingStateQueue;
                        var replace = this._pendingReplaceState;
                        this._pendingReplaceState = false;
                        this._pendingStateQueue = null;

                        if (!queue) {
                            return inst.state;
                        }

                        if (replace && queue.length === 1) {
                            return queue[0];
                        }

                        var nextState = _assign({}, replace ? queue[0] : inst.state);
                        for (var i = replace ? 1 : 0; i < queue.length; i++) {
                            var partial = queue[i];
                            _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
                        }

                        return nextState;
                    },

                    /**
                     * Merges new props and state, notifies delegate methods of update and
                     * performs update.
                     *
                     * @param {ReactElement} nextElement Next element
                     * @param {object} nextProps Next public object to set as properties.
                     * @param {?object} nextState Next object to set as state.
                     * @param {?object} nextContext Next public object to set as context.
                     * @param {ReactReconcileTransaction} transaction
                     * @param {?object} unmaskedContext
                     * @private
                     */
                    _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
                        var _this2 = this;

                        var inst = this._instance;

                        var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
                        var prevProps;
                        var prevState;
                        var prevContext;
                        if (hasComponentDidUpdate) {
                            prevProps = inst.props;
                            prevState = inst.state;
                            prevContext = inst.context;
                        }

                        if (inst.componentWillUpdate) {
                            if ("development" !== 'production') {
                                measureLifeCyclePerf(function () {
                                    return inst.componentWillUpdate(nextProps, nextState, nextContext);
                                }, this._debugID, 'componentWillUpdate');
                            } else {
                                inst.componentWillUpdate(nextProps, nextState, nextContext);
                            }
                        }

                        this._currentElement = nextElement;
                        this._context = unmaskedContext;
                        inst.props = nextProps;
                        inst.state = nextState;
                        inst.context = nextContext;

                        this._updateRenderedComponent(transaction, unmaskedContext);

                        if (hasComponentDidUpdate) {
                            if ("development" !== 'production') {
                                transaction.getReactMountReady().enqueue(function () {
                                    measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
                                });
                            } else {
                                transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
                            }
                        }
                    },

                    /**
                     * Call the component's `render` method and update the DOM accordingly.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    _updateRenderedComponent: function (transaction, context) {
                        var prevComponentInstance = this._renderedComponent;
                        var prevRenderedElement = prevComponentInstance._currentElement;
                        var nextRenderedElement = this._renderValidatedComponent();

                        var debugID = 0;
                        if ("development" !== 'production') {
                            debugID = this._debugID;
                        }

                        if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
                            ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
                        } else {
                            var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
                            ReactReconciler.unmountComponent(prevComponentInstance, false);

                            var nodeType = ReactNodeTypes.getType(nextRenderedElement);
                            this._renderedNodeType = nodeType;
                            var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
                            );
                            this._renderedComponent = child;

                            var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

                            if ("development" !== 'production') {
                                if (debugID !== 0) {
                                    var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
                                    ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
                                }
                            }

                            this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
                        }
                    },

                    /**
                     * Overridden in shallow rendering.
                     *
                     * @protected
                     */
                    _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
                        ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
                    },

                    /**
                     * @protected
                     */
                    _renderValidatedComponentWithoutOwnerOrContext: function () {
                        var inst = this._instance;
                        var renderedElement;

                        if ("development" !== 'production') {
                            renderedElement = measureLifeCyclePerf(function () {
                                return inst.render();
                            }, this._debugID, 'render');
                        } else {
                            renderedElement = inst.render();
                        }

                        if ("development" !== 'production') {
                            // We allow auto-mocks to proceed as if they're returning null.
                            if (renderedElement === undefined && inst.render._isMockFunction) {
                                // This is probably bad practice. Consider warning here and
                                // deprecating this convenience.
                                renderedElement = null;
                            }
                        }

                        return renderedElement;
                    },

                    /**
                     * @private
                     */
                    _renderValidatedComponent: function () {
                        var renderedElement;
                        if ("development" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
                            ReactCurrentOwner.current = this;
                            try {
                                renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
                            } finally {
                                ReactCurrentOwner.current = null;
                            }
                        } else {
                            renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
                        }
                        !(
                            // TODO: An `isValidNode` function would probably be more appropriate
                            renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ? "development" !== 'production' ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

                        return renderedElement;
                    },

                    /**
                     * Lazily allocates the refs object and stores `component` as `ref`.
                     *
                     * @param {string} ref Reference name.
                     * @param {component} component Component to store as `ref`.
                     * @final
                     * @private
                     */
                    attachRef: function (ref, component) {
                        var inst = this.getPublicInstance();
                        !(inst != null) ? "development" !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
                        var publicComponentInstance = component.getPublicInstance();
                        if ("development" !== 'production') {
                            var componentName = component && component.getName ? component.getName() : 'a component';
                            "development" !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
                        }
                        var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
                        refs[ref] = publicComponentInstance;
                    },

                    /**
                     * Detaches a reference name.
                     *
                     * @param {string} ref Name to dereference.
                     * @final
                     * @private
                     */
                    detachRef: function (ref) {
                        var refs = this.getPublicInstance().refs;
                        delete refs[ref];
                    },

                    /**
                     * Get a text description of the component that can be used to identify it
                     * in error messages.
                     * @return {string} The name or null.
                     * @internal
                     */
                    getName: function () {
                        var type = this._currentElement.type;
                        var constructor = this._instance && this._instance.constructor;
                        return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
                    },

                    /**
                     * Get the publicly accessible representation of this component - i.e. what
                     * is exposed by refs and returned by render. Can be null for stateless
                     * components.
                     *
                     * @return {ReactComponent} the public component instance.
                     * @internal
                     */
                    getPublicInstance: function () {
                        var inst = this._instance;
                        if (this._compositeType === CompositeTypes.StatelessFunctional) {
                            return null;
                        }
                        return inst;
                    },

                    // Stub
                    _instantiateReactComponent: null
                };

                module.exports = ReactCompositeComponent;
            }, { "104": 104, "126": 126, "130": 130, "134": 134, "135": 135, "145": 145, "152": 152, "158": 158, "159": 159, "160": 160, "29": 29, "55": 55, "63": 63, "64": 64, "69": 69, "75": 75 }], 31: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

                'use strict';

                var ReactDOMComponentTree = _dereq_(34);
                var ReactDefaultInjection = _dereq_(52);
                var ReactMount = _dereq_(67);
                var ReactReconciler = _dereq_(75);
                var ReactUpdates = _dereq_(82);
                var ReactVersion = _dereq_(83);

                var findDOMNode = _dereq_(108);
                var getHostComponentFromComposite = _dereq_(115);
                var renderSubtreeIntoContainer = _dereq_(127);
                var warning = _dereq_(159);

                ReactDefaultInjection.inject();

                var ReactDOM = {
                    findDOMNode: findDOMNode,
                    render: ReactMount.render,
                    unmountComponentAtNode: ReactMount.unmountComponentAtNode,
                    version: ReactVersion,

                    /* eslint-disable camelcase */
                    unstable_batchedUpdates: ReactUpdates.batchedUpdates,
                    unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
                    /* eslint-enable camelcase */
                };

                // Inject the runtime into a devtools global hook regardless of browser.
                // Allows for debugging when the hook is injected on the page.
                if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
                        ComponentTree: {
                            getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
                            getNodeFromInstance: function (inst) {
                                // inst is an internal instance (but could be a composite)
                                if (inst._renderedComponent) {
                                    inst = getHostComponentFromComposite(inst);
                                }
                                if (inst) {
                                    return ReactDOMComponentTree.getNodeFromInstance(inst);
                                } else {
                                    return null;
                                }
                            }
                        },
                        Mount: ReactMount,
                        Reconciler: ReactReconciler
                    });
                }

                if ("development" !== 'production') {
                    var ExecutionEnvironment = _dereq_(138);
                    if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
                        // First check if devtools is not installed
                        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                            // If we're in Chrome or Firefox, provide a download link if not installed.
                            if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
                                // Firefox does not have the issue with devtools loaded over file://
                                var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
                                console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
                            }
                        }

                        var testFunc = function testFn() { };
                        "development" !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

                        // If we're in IE8, check to see if we are in compatibility mode and provide
                        // information on preventing compatibility mode
                        var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

                        "development" !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

                        var expectedFeatures = [
                            // shims
                            Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

                        for (var i = 0; i < expectedFeatures.length; i++) {
                            if (!expectedFeatures[i]) {
                                "development" !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
                                break;
                            }
                        }
                    }
                }

                if ("development" !== 'production') {
                    var ReactInstrumentation = _dereq_(64);
                    var ReactDOMUnknownPropertyHook = _dereq_(49);
                    var ReactDOMNullInputValuePropHook = _dereq_(41);
                    var ReactDOMInvalidARIAHook = _dereq_(40);

                    ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
                    ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
                    ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
                }

                module.exports = ReactDOM;
            }, { "108": 108, "115": 115, "127": 127, "138": 138, "159": 159, "34": 34, "40": 40, "41": 41, "49": 49, "52": 52, "64": 64, "67": 67, "75": 75, "82": 82, "83": 83 }], 32: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* global hasOwnProperty:true */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var AutoFocusUtils = _dereq_(2);
                var CSSPropertyOperations = _dereq_(5);
                var DOMLazyTree = _dereq_(9);
                var DOMNamespaces = _dereq_(10);
                var DOMProperty = _dereq_(11);
                var DOMPropertyOperations = _dereq_(12);
                var EventPluginHub = _dereq_(17);
                var EventPluginRegistry = _dereq_(18);
                var ReactBrowserEventEmitter = _dereq_(26);
                var ReactDOMComponentFlags = _dereq_(33);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactDOMInput = _dereq_(39);
                var ReactDOMOption = _dereq_(42);
                var ReactDOMSelect = _dereq_(43);
                var ReactDOMTextarea = _dereq_(46);
                var ReactInstrumentation = _dereq_(64);
                var ReactMultiChild = _dereq_(68);
                var ReactServerRenderingTransaction = _dereq_(77);

                var emptyFunction = _dereq_(144);
                var escapeTextContentForBrowser = _dereq_(107);
                var invariant = _dereq_(152);
                var isEventSupported = _dereq_(122);
                var shallowEqual = _dereq_(158);
                var inputValueTracking = _dereq_(120);
                var validateDOMNesting = _dereq_(132);
                var warning = _dereq_(159);

                var Flags = ReactDOMComponentFlags;
                var deleteListener = EventPluginHub.deleteListener;
                var getNode = ReactDOMComponentTree.getNodeFromInstance;
                var listenTo = ReactBrowserEventEmitter.listenTo;
                var registrationNameModules = EventPluginRegistry.registrationNameModules;

                // For quickly matching children type, to test if can be treated as content.
                var CONTENT_TYPES = { string: true, number: true };

                var STYLE = 'style';
                var HTML = '__html';
                var RESERVED_PROPS = {
                    children: null,
                    dangerouslySetInnerHTML: null,
                    suppressContentEditableWarning: null
                };

                // Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
                var DOC_FRAGMENT_TYPE = 11;

                function getDeclarationErrorAddendum(internalInstance) {
                    if (internalInstance) {
                        var owner = internalInstance._currentElement._owner || null;
                        if (owner) {
                            var name = owner.getName();
                            if (name) {
                                return ' This DOM node was rendered by `' + name + '`.';
                            }
                        }
                    }
                    return '';
                }

                function friendlyStringify(obj) {
                    if (typeof obj === 'object') {
                        if (Array.isArray(obj)) {
                            return '[' + obj.map(friendlyStringify).join(', ') + ']';
                        } else {
                            var pairs = [];
                            for (var key in obj) {
                                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                                    var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
                                    pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
                                }
                            }
                            return '{' + pairs.join(', ') + '}';
                        }
                    } else if (typeof obj === 'string') {
                        return JSON.stringify(obj);
                    } else if (typeof obj === 'function') {
                        return '[function object]';
                    }
                    // Differs from JSON.stringify in that undefined because undefined and that
                    // inf and nan don't become null
                    return String(obj);
                }

                var styleMutationWarning = {};

                function checkAndWarnForMutatedStyle(style1, style2, component) {
                    if (style1 == null || style2 == null) {
                        return;
                    }
                    if (shallowEqual(style1, style2)) {
                        return;
                    }

                    var componentName = component._tag;
                    var owner = component._currentElement._owner;
                    var ownerName;
                    if (owner) {
                        ownerName = owner.getName();
                    }

                    var hash = ownerName + '|' + componentName;

                    if (styleMutationWarning.hasOwnProperty(hash)) {
                        return;
                    }

                    styleMutationWarning[hash] = true;

                    "development" !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
                }

                /**
                 * @param {object} component
                 * @param {?object} props
                 */
                function assertValidProps(component, props) {
                    if (!props) {
                        return;
                    }
                    // Note the use of `==` which checks for null or undefined.
                    if (voidElementTags[component._tag]) {
                        !(props.children == null && props.dangerouslySetInnerHTML == null) ? "development" !== 'production' ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
                    }
                    if (props.dangerouslySetInnerHTML != null) {
                        !(props.children == null) ? "development" !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
                        !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? "development" !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
                    }
                    if ("development" !== 'production') {
                        "development" !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
                        "development" !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
                        "development" !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
                    }
                    !(props.style == null || typeof props.style === 'object') ? "development" !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
                }

                function enqueuePutListener(inst, registrationName, listener, transaction) {
                    if (transaction instanceof ReactServerRenderingTransaction) {
                        return;
                    }
                    if ("development" !== 'production') {
                        // IE8 has no API for event capturing and the `onScroll` event doesn't
                        // bubble.
                        "development" !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
                    }
                    var containerInfo = inst._hostContainerInfo;
                    var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
                    var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
                    listenTo(registrationName, doc);
                    transaction.getReactMountReady().enqueue(putListener, {
                        inst: inst,
                        registrationName: registrationName,
                        listener: listener
                    });
                }

                function putListener() {
                    var listenerToPut = this;
                    EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
                }

                function inputPostMount() {
                    var inst = this;
                    ReactDOMInput.postMountWrapper(inst);
                }

                function textareaPostMount() {
                    var inst = this;
                    ReactDOMTextarea.postMountWrapper(inst);
                }

                function optionPostMount() {
                    var inst = this;
                    ReactDOMOption.postMountWrapper(inst);
                }

                var setAndValidateContentChildDev = emptyFunction;
                if ("development" !== 'production') {
                    setAndValidateContentChildDev = function (content) {
                        var hasExistingContent = this._contentDebugID != null;
                        var debugID = this._debugID;
                        // This ID represents the inlined child that has no backing instance:
                        var contentDebugID = -debugID;

                        if (content == null) {
                            if (hasExistingContent) {
                                ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
                            }
                            this._contentDebugID = null;
                            return;
                        }

                        validateDOMNesting(null, String(content), this, this._ancestorInfo);
                        this._contentDebugID = contentDebugID;
                        if (hasExistingContent) {
                            ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
                            ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
                        } else {
                            ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
                            ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
                            ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
                        }
                    };
                }

                // There are so many media events, it makes sense to just
                // maintain a list rather than create a `trapBubbledEvent` for each
                var mediaEvents = {
                    topAbort: 'abort',
                    topCanPlay: 'canplay',
                    topCanPlayThrough: 'canplaythrough',
                    topDurationChange: 'durationchange',
                    topEmptied: 'emptied',
                    topEncrypted: 'encrypted',
                    topEnded: 'ended',
                    topError: 'error',
                    topLoadedData: 'loadeddata',
                    topLoadedMetadata: 'loadedmetadata',
                    topLoadStart: 'loadstart',
                    topPause: 'pause',
                    topPlay: 'play',
                    topPlaying: 'playing',
                    topProgress: 'progress',
                    topRateChange: 'ratechange',
                    topSeeked: 'seeked',
                    topSeeking: 'seeking',
                    topStalled: 'stalled',
                    topSuspend: 'suspend',
                    topTimeUpdate: 'timeupdate',
                    topVolumeChange: 'volumechange',
                    topWaiting: 'waiting'
                };

                function trackInputValue() {
                    inputValueTracking.track(this);
                }

                function trapBubbledEventsLocal() {
                    var inst = this;
                    // If a component renders to null or if another component fatals and causes
                    // the state of the tree to be corrupted, `node` here can be null.
                    !inst._rootNodeID ? "development" !== 'production' ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
                    var node = getNode(inst);
                    !node ? "development" !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

                    switch (inst._tag) {
                        case 'iframe':
                        case 'object':
                            inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
                            break;
                        case 'video':
                        case 'audio':
                            inst._wrapperState.listeners = [];
                            // Create listener for each media event
                            for (var event in mediaEvents) {
                                if (mediaEvents.hasOwnProperty(event)) {
                                    inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
                                }
                            }
                            break;
                        case 'source':
                            inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
                            break;
                        case 'img':
                            inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
                            break;
                        case 'form':
                            inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
                            break;
                        case 'input':
                        case 'select':
                        case 'textarea':
                            inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
                            break;
                    }
                }

                function postUpdateSelectWrapper() {
                    ReactDOMSelect.postUpdateWrapper(this);
                }

                // For HTML, certain tags should omit their close tag. We keep a whitelist for
                // those special-case tags.

                var omittedCloseTags = {
                    area: true,
                    base: true,
                    br: true,
                    col: true,
                    embed: true,
                    hr: true,
                    img: true,
                    input: true,
                    keygen: true,
                    link: true,
                    meta: true,
                    param: true,
                    source: true,
                    track: true,
                    wbr: true
                    // NOTE: menuitem's close tag should be omitted, but that causes problems.
                };

                var newlineEatingTags = {
                    listing: true,
                    pre: true,
                    textarea: true
                };

                // For HTML, certain tags cannot have children. This has the same purpose as
                // `omittedCloseTags` except that `menuitem` should still have its closing tag.

                var voidElementTags = _assign({
                    menuitem: true
                }, omittedCloseTags);

                // We accept any tag to be rendered but since this gets injected into arbitrary
                // HTML, we want to make sure that it's a safe tag.
                // http://www.w3.org/TR/REC-xml/#NT-Name

                var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
                var validatedTagCache = {};
                var hasOwnProperty = {}.hasOwnProperty;

                function validateDangerousTag(tag) {
                    if (!hasOwnProperty.call(validatedTagCache, tag)) {
                        !VALID_TAG_REGEX.test(tag) ? "development" !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
                        validatedTagCache[tag] = true;
                    }
                }

                function isCustomComponent(tagName, props) {
                    return tagName.indexOf('-') >= 0 || props.is != null;
                }

                var globalIdCounter = 1;

                /**
                 * Creates a new React class that is idempotent and capable of containing other
                 * React components. It accepts event listeners and DOM properties that are
                 * valid according to `DOMProperty`.
                 *
                 *  - Event listeners: `onClick`, `onMouseDown`, etc.
                 *  - DOM properties: `className`, `name`, `title`, etc.
                 *
                 * The `style` property functions differently from the DOM API. It accepts an
                 * object mapping of style properties to values.
                 *
                 * @constructor ReactDOMComponent
                 * @extends ReactMultiChild
                 */
                function ReactDOMComponent(element) {
                    var tag = element.type;
                    validateDangerousTag(tag);
                    this._currentElement = element;
                    this._tag = tag.toLowerCase();
                    this._namespaceURI = null;
                    this._renderedChildren = null;
                    this._previousStyle = null;
                    this._previousStyleCopy = null;
                    this._hostNode = null;
                    this._hostParent = null;
                    this._rootNodeID = 0;
                    this._domID = 0;
                    this._hostContainerInfo = null;
                    this._wrapperState = null;
                    this._topLevelWrapper = null;
                    this._flags = 0;
                    if ("development" !== 'production') {
                        this._ancestorInfo = null;
                        setAndValidateContentChildDev.call(this, null);
                    }
                }

                ReactDOMComponent.displayName = 'ReactDOMComponent';

                ReactDOMComponent.Mixin = {
                    /**
                     * Generates root tag markup then recurses. This method has side effects and
                     * is not idempotent.
                     *
                     * @internal
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {?ReactDOMComponent} the parent component instance
                     * @param {?object} info about the host container
                     * @param {object} context
                     * @return {string} The computed markup.
                     */
                    mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
                        this._rootNodeID = globalIdCounter++;
                        this._domID = hostContainerInfo._idCounter++;
                        this._hostParent = hostParent;
                        this._hostContainerInfo = hostContainerInfo;

                        var props = this._currentElement.props;

                        switch (this._tag) {
                            case 'audio':
                            case 'form':
                            case 'iframe':
                            case 'img':
                            case 'link':
                            case 'object':
                            case 'source':
                            case 'video':
                                this._wrapperState = {
                                    listeners: null
                                };
                                transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
                                break;
                            case 'input':
                                ReactDOMInput.mountWrapper(this, props, hostParent);
                                props = ReactDOMInput.getHostProps(this, props);
                                transaction.getReactMountReady().enqueue(trackInputValue, this);
                                transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
                                break;
                            case 'option':
                                ReactDOMOption.mountWrapper(this, props, hostParent);
                                props = ReactDOMOption.getHostProps(this, props);
                                break;
                            case 'select':
                                ReactDOMSelect.mountWrapper(this, props, hostParent);
                                props = ReactDOMSelect.getHostProps(this, props);
                                transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
                                break;
                            case 'textarea':
                                ReactDOMTextarea.mountWrapper(this, props, hostParent);
                                props = ReactDOMTextarea.getHostProps(this, props);
                                transaction.getReactMountReady().enqueue(trackInputValue, this);
                                transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
                                break;
                        }

                        assertValidProps(this, props);

                        // We create tags in the namespace of their parent container, except HTML
                        // tags get no namespace.
                        var namespaceURI;
                        var parentTag;
                        if (hostParent != null) {
                            namespaceURI = hostParent._namespaceURI;
                            parentTag = hostParent._tag;
                        } else if (hostContainerInfo._tag) {
                            namespaceURI = hostContainerInfo._namespaceURI;
                            parentTag = hostContainerInfo._tag;
                        }
                        if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
                            namespaceURI = DOMNamespaces.html;
                        }
                        if (namespaceURI === DOMNamespaces.html) {
                            if (this._tag === 'svg') {
                                namespaceURI = DOMNamespaces.svg;
                            } else if (this._tag === 'math') {
                                namespaceURI = DOMNamespaces.mathml;
                            }
                        }
                        this._namespaceURI = namespaceURI;

                        if ("development" !== 'production') {
                            var parentInfo;
                            if (hostParent != null) {
                                parentInfo = hostParent._ancestorInfo;
                            } else if (hostContainerInfo._tag) {
                                parentInfo = hostContainerInfo._ancestorInfo;
                            }
                            if (parentInfo) {
                                // parentInfo should always be present except for the top-level
                                // component when server rendering
                                validateDOMNesting(this._tag, null, this, parentInfo);
                            }
                            this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
                        }

                        var mountImage;
                        if (transaction.useCreateElement) {
                            var ownerDocument = hostContainerInfo._ownerDocument;
                            var el;
                            if (namespaceURI === DOMNamespaces.html) {
                                if (this._tag === 'script') {
                                    // Create the script via .innerHTML so its "parser-inserted" flag is
                                    // set to true and it does not execute
                                    var div = ownerDocument.createElement('div');
                                    var type = this._currentElement.type;
                                    div.innerHTML = '<' + type + '></' + type + '>';
                                    el = div.removeChild(div.firstChild);
                                } else if (props.is) {
                                    el = ownerDocument.createElement(this._currentElement.type, props.is);
                                } else {
                                    // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
                                    // See discussion in https://github.com/facebook/react/pull/6896
                                    // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                                    el = ownerDocument.createElement(this._currentElement.type);
                                }
                            } else {
                                el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
                            }
                            ReactDOMComponentTree.precacheNode(this, el);
                            this._flags |= Flags.hasCachedChildNodes;
                            if (!this._hostParent) {
                                DOMPropertyOperations.setAttributeForRoot(el);
                            }
                            this._updateDOMProperties(null, props, transaction);
                            var lazyTree = DOMLazyTree(el);
                            this._createInitialChildren(transaction, props, context, lazyTree);
                            mountImage = lazyTree;
                        } else {
                            var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
                            var tagContent = this._createContentMarkup(transaction, props, context);
                            if (!tagContent && omittedCloseTags[this._tag]) {
                                mountImage = tagOpen + '/>';
                            } else {
                                mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
                            }
                        }

                        switch (this._tag) {
                            case 'input':
                                transaction.getReactMountReady().enqueue(inputPostMount, this);
                                if (props.autoFocus) {
                                    transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
                                }
                                break;
                            case 'textarea':
                                transaction.getReactMountReady().enqueue(textareaPostMount, this);
                                if (props.autoFocus) {
                                    transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
                                }
                                break;
                            case 'select':
                                if (props.autoFocus) {
                                    transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
                                }
                                break;
                            case 'button':
                                if (props.autoFocus) {
                                    transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
                                }
                                break;
                            case 'option':
                                transaction.getReactMountReady().enqueue(optionPostMount, this);
                                break;
                        }

                        return mountImage;
                    },

                    /**
                     * Creates markup for the open tag and all attributes.
                     *
                     * This method has side effects because events get registered.
                     *
                     * Iterating over object properties is faster than iterating over arrays.
                     * @see http://jsperf.com/obj-vs-arr-iteration
                     *
                     * @private
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {object} props
                     * @return {string} Markup of opening tag.
                     */
                    _createOpenTagMarkupAndPutListeners: function (transaction, props) {
                        var ret = '<' + this._currentElement.type;

                        for (var propKey in props) {
                            if (!props.hasOwnProperty(propKey)) {
                                continue;
                            }
                            var propValue = props[propKey];
                            if (propValue == null) {
                                continue;
                            }
                            if (registrationNameModules.hasOwnProperty(propKey)) {
                                if (propValue) {
                                    enqueuePutListener(this, propKey, propValue, transaction);
                                }
                            } else {
                                if (propKey === STYLE) {
                                    if (propValue) {
                                        if ("development" !== 'production') {
                                            // See `_updateDOMProperties`. style block
                                            this._previousStyle = propValue;
                                        }
                                        propValue = this._previousStyleCopy = _assign({}, props.style);
                                    }
                                    propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
                                }
                                var markup = null;
                                if (this._tag != null && isCustomComponent(this._tag, props)) {
                                    if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
                                        markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
                                    }
                                } else {
                                    markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
                                }
                                if (markup) {
                                    ret += ' ' + markup;
                                }
                            }
                        }

                        // For static pages, no need to put React ID and checksum. Saves lots of
                        // bytes.
                        if (transaction.renderToStaticMarkup) {
                            return ret;
                        }

                        if (!this._hostParent) {
                            ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
                        }
                        ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
                        return ret;
                    },

                    /**
                     * Creates markup for the content between the tags.
                     *
                     * @private
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {object} props
                     * @param {object} context
                     * @return {string} Content markup.
                     */
                    _createContentMarkup: function (transaction, props, context) {
                        var ret = '';

                        // Intentional use of != to avoid catching zero/false.
                        var innerHTML = props.dangerouslySetInnerHTML;
                        if (innerHTML != null) {
                            if (innerHTML.__html != null) {
                                ret = innerHTML.__html;
                            }
                        } else {
                            var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
                            var childrenToUse = contentToUse != null ? null : props.children;
                            if (contentToUse != null) {
                                // TODO: Validate that text is allowed as a child of this node
                                ret = escapeTextContentForBrowser(contentToUse);
                                if ("development" !== 'production') {
                                    setAndValidateContentChildDev.call(this, contentToUse);
                                }
                            } else if (childrenToUse != null) {
                                var mountImages = this.mountChildren(childrenToUse, transaction, context);
                                ret = mountImages.join('');
                            }
                        }
                        if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
                            // text/html ignores the first character in these tags if it's a newline
                            // Prefer to break application/xml over text/html (for now) by adding
                            // a newline specifically to get eaten by the parser. (Alternately for
                            // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
                            // \r is normalized out by HTMLTextAreaElement#value.)
                            // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
                            // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
                            // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
                            // See: Parsing of "textarea" "listing" and "pre" elements
                            //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
                            return '\n' + ret;
                        } else {
                            return ret;
                        }
                    },

                    _createInitialChildren: function (transaction, props, context, lazyTree) {
                        // Intentional use of != to avoid catching zero/false.
                        var innerHTML = props.dangerouslySetInnerHTML;
                        if (innerHTML != null) {
                            if (innerHTML.__html != null) {
                                DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
                            }
                        } else {
                            var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
                            var childrenToUse = contentToUse != null ? null : props.children;
                            // TODO: Validate that text is allowed as a child of this node
                            if (contentToUse != null) {
                                // Avoid setting textContent when the text is empty. In IE11 setting
                                // textContent on a text area will cause the placeholder to not
                                // show within the textarea until it has been focused and blurred again.
                                // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                                if (contentToUse !== '') {
                                    if ("development" !== 'production') {
                                        setAndValidateContentChildDev.call(this, contentToUse);
                                    }
                                    DOMLazyTree.queueText(lazyTree, contentToUse);
                                }
                            } else if (childrenToUse != null) {
                                var mountImages = this.mountChildren(childrenToUse, transaction, context);
                                for (var i = 0; i < mountImages.length; i++) {
                                    DOMLazyTree.queueChild(lazyTree, mountImages[i]);
                                }
                            }
                        }
                    },

                    /**
                     * Receives a next element and updates the component.
                     *
                     * @internal
                     * @param {ReactElement} nextElement
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {object} context
                     */
                    receiveComponent: function (nextElement, transaction, context) {
                        var prevElement = this._currentElement;
                        this._currentElement = nextElement;
                        this.updateComponent(transaction, prevElement, nextElement, context);
                    },

                    /**
                     * Updates a DOM component after it has already been allocated and
                     * attached to the DOM. Reconciles the root DOM node, then recurses.
                     *
                     * @param {ReactReconcileTransaction} transaction
                     * @param {ReactElement} prevElement
                     * @param {ReactElement} nextElement
                     * @internal
                     * @overridable
                     */
                    updateComponent: function (transaction, prevElement, nextElement, context) {
                        var lastProps = prevElement.props;
                        var nextProps = this._currentElement.props;

                        switch (this._tag) {
                            case 'input':
                                lastProps = ReactDOMInput.getHostProps(this, lastProps);
                                nextProps = ReactDOMInput.getHostProps(this, nextProps);
                                break;
                            case 'option':
                                lastProps = ReactDOMOption.getHostProps(this, lastProps);
                                nextProps = ReactDOMOption.getHostProps(this, nextProps);
                                break;
                            case 'select':
                                lastProps = ReactDOMSelect.getHostProps(this, lastProps);
                                nextProps = ReactDOMSelect.getHostProps(this, nextProps);
                                break;
                            case 'textarea':
                                lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
                                nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
                                break;
                        }

                        assertValidProps(this, nextProps);
                        this._updateDOMProperties(lastProps, nextProps, transaction);
                        this._updateDOMChildren(lastProps, nextProps, transaction, context);

                        switch (this._tag) {
                            case 'input':
                                // Update the wrapper around inputs *after* updating props. This has to
                                // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
                                // raise warnings and prevent the new value from being assigned.
                                ReactDOMInput.updateWrapper(this);
                                break;
                            case 'textarea':
                                ReactDOMTextarea.updateWrapper(this);
                                break;
                            case 'select':
                                // <select> value update needs to occur after <option> children
                                // reconciliation
                                transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
                                break;
                        }
                    },

                    /**
                     * Reconciles the properties by detecting differences in property values and
                     * updating the DOM as necessary. This function is probably the single most
                     * critical path for performance optimization.
                     *
                     * TODO: Benchmark whether checking for changed values in memory actually
                     *       improves performance (especially statically positioned elements).
                     * TODO: Benchmark the effects of putting this at the top since 99% of props
                     *       do not change for a given reconciliation.
                     * TODO: Benchmark areas that can be improved with caching.
                     *
                     * @private
                     * @param {object} lastProps
                     * @param {object} nextProps
                     * @param {?DOMElement} node
                     */
                    _updateDOMProperties: function (lastProps, nextProps, transaction) {
                        var propKey;
                        var styleName;
                        var styleUpdates;
                        for (propKey in lastProps) {
                            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
                                continue;
                            }
                            if (propKey === STYLE) {
                                var lastStyle = this._previousStyleCopy;
                                for (styleName in lastStyle) {
                                    if (lastStyle.hasOwnProperty(styleName)) {
                                        styleUpdates = styleUpdates || {};
                                        styleUpdates[styleName] = '';
                                    }
                                }
                                this._previousStyleCopy = null;
                            } else if (registrationNameModules.hasOwnProperty(propKey)) {
                                if (lastProps[propKey]) {
                                    // Only call deleteListener if there was a listener previously or
                                    // else willDeleteListener gets called when there wasn't actually a
                                    // listener (e.g., onClick={null})
                                    deleteListener(this, propKey);
                                }
                            } else if (isCustomComponent(this._tag, lastProps)) {
                                if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
                                    DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
                                }
                            } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
                                DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
                            }
                        }
                        for (propKey in nextProps) {
                            var nextProp = nextProps[propKey];
                            var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
                            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
                                continue;
                            }
                            if (propKey === STYLE) {
                                if (nextProp) {
                                    if ("development" !== 'production') {
                                        checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
                                        this._previousStyle = nextProp;
                                    }
                                    nextProp = this._previousStyleCopy = _assign({}, nextProp);
                                } else {
                                    this._previousStyleCopy = null;
                                }
                                if (lastProp) {
                                    // Unset styles on `lastProp` but not on `nextProp`.
                                    for (styleName in lastProp) {
                                        if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                                            styleUpdates = styleUpdates || {};
                                            styleUpdates[styleName] = '';
                                        }
                                    }
                                    // Update styles that changed since `lastProp`.
                                    for (styleName in nextProp) {
                                        if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                                            styleUpdates = styleUpdates || {};
                                            styleUpdates[styleName] = nextProp[styleName];
                                        }
                                    }
                                } else {
                                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                                    styleUpdates = nextProp;
                                }
                            } else if (registrationNameModules.hasOwnProperty(propKey)) {
                                if (nextProp) {
                                    enqueuePutListener(this, propKey, nextProp, transaction);
                                } else if (lastProp) {
                                    deleteListener(this, propKey);
                                }
                            } else if (isCustomComponent(this._tag, nextProps)) {
                                if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
                                    DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
                                }
                            } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
                                var node = getNode(this);
                                // If we're updating to null or undefined, we should remove the property
                                // from the DOM node instead of inadvertently setting to a string. This
                                // brings us in line with the same behavior we have on initial render.
                                if (nextProp != null) {
                                    DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
                                } else {
                                    DOMPropertyOperations.deleteValueForProperty(node, propKey);
                                }
                            }
                        }
                        if (styleUpdates) {
                            CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
                        }
                    },

                    /**
                     * Reconciles the children with the various properties that affect the
                     * children content.
                     *
                     * @param {object} lastProps
                     * @param {object} nextProps
                     * @param {ReactReconcileTransaction} transaction
                     * @param {object} context
                     */
                    _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
                        var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
                        var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

                        var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
                        var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

                        // Note the use of `!=` which checks for null or undefined.
                        var lastChildren = lastContent != null ? null : lastProps.children;
                        var nextChildren = nextContent != null ? null : nextProps.children;

                        // If we're switching from children to content/html or vice versa, remove
                        // the old content
                        var lastHasContentOrHtml = lastContent != null || lastHtml != null;
                        var nextHasContentOrHtml = nextContent != null || nextHtml != null;
                        if (lastChildren != null && nextChildren == null) {
                            this.updateChildren(null, transaction, context);
                        } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
                            this.updateTextContent('');
                            if ("development" !== 'production') {
                                ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
                            }
                        }

                        if (nextContent != null) {
                            if (lastContent !== nextContent) {
                                this.updateTextContent('' + nextContent);
                                if ("development" !== 'production') {
                                    setAndValidateContentChildDev.call(this, nextContent);
                                }
                            }
                        } else if (nextHtml != null) {
                            if (lastHtml !== nextHtml) {
                                this.updateMarkup('' + nextHtml);
                            }
                            if ("development" !== 'production') {
                                ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
                            }
                        } else if (nextChildren != null) {
                            if ("development" !== 'production') {
                                setAndValidateContentChildDev.call(this, null);
                            }

                            this.updateChildren(nextChildren, transaction, context);
                        }
                    },

                    getHostNode: function () {
                        return getNode(this);
                    },

                    /**
                     * Destroys all event registrations for this instance. Does not remove from
                     * the DOM. That must be done by the parent.
                     *
                     * @internal
                     */
                    unmountComponent: function (safely) {
                        switch (this._tag) {
                            case 'audio':
                            case 'form':
                            case 'iframe':
                            case 'img':
                            case 'link':
                            case 'object':
                            case 'source':
                            case 'video':
                                var listeners = this._wrapperState.listeners;
                                if (listeners) {
                                    for (var i = 0; i < listeners.length; i++) {
                                        listeners[i].remove();
                                    }
                                }
                                break;
                            case 'input':
                            case 'textarea':
                                inputValueTracking.stopTracking(this);
                                break;
                            case 'html':
                            case 'head':
                            case 'body':
                                /**
                                 * Components like <html> <head> and <body> can't be removed or added
                                 * easily in a cross-browser way, however it's valuable to be able to
                                 * take advantage of React's reconciliation for styling and <title>
                                 * management. So we just document it and throw in dangerous cases.
                                 */
                                !false ? "development" !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
                                break;
                        }

                        this.unmountChildren(safely);
                        ReactDOMComponentTree.uncacheNode(this);
                        EventPluginHub.deleteAllListeners(this);
                        this._rootNodeID = 0;
                        this._domID = 0;
                        this._wrapperState = null;

                        if ("development" !== 'production') {
                            setAndValidateContentChildDev.call(this, null);
                        }
                    },

                    getPublicInstance: function () {
                        return getNode(this);
                    }
                };

                _assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

                module.exports = ReactDOMComponent;
            }, { "10": 10, "107": 107, "11": 11, "12": 12, "120": 120, "122": 122, "126": 126, "132": 132, "144": 144, "152": 152, "158": 158, "159": 159, "160": 160, "17": 17, "18": 18, "2": 2, "26": 26, "33": 33, "34": 34, "39": 39, "42": 42, "43": 43, "46": 46, "5": 5, "64": 64, "68": 68, "77": 77, "9": 9 }], 33: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactDOMComponentFlags = {
                    hasCachedChildNodes: 1 << 0
                };

                module.exports = ReactDOMComponentFlags;
            }, {}], 34: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var DOMProperty = _dereq_(11);
                var ReactDOMComponentFlags = _dereq_(33);

                var invariant = _dereq_(152);

                var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
                var Flags = ReactDOMComponentFlags;

                var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

                /**
                 * Check if a given node should be cached.
                 */
                function shouldPrecacheNode(node, nodeID) {
                    return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
                }

                /**
                 * Drill down (through composites and empty components) until we get a host or
                 * host text component.
                 *
                 * This is pretty polymorphic but unavoidable with the current structure we have
                 * for `_renderedChildren`.
                 */
                function getRenderedHostOrTextFromComponent(component) {
                    var rendered;
                    while (rendered = component._renderedComponent) {
                        component = rendered;
                    }
                    return component;
                }

                /**
                 * Populate `_hostNode` on the rendered host/text component with the given
                 * DOM node. The passed `inst` can be a composite.
                 */
                function precacheNode(inst, node) {
                    var hostInst = getRenderedHostOrTextFromComponent(inst);
                    hostInst._hostNode = node;
                    node[internalInstanceKey] = hostInst;
                }

                function uncacheNode(inst) {
                    var node = inst._hostNode;
                    if (node) {
                        delete node[internalInstanceKey];
                        inst._hostNode = null;
                    }
                }

                /**
                 * Populate `_hostNode` on each child of `inst`, assuming that the children
                 * match up with the DOM (element) children of `node`.
                 *
                 * We cache entire levels at once to avoid an n^2 problem where we access the
                 * children of a node sequentially and have to walk from the start to our target
                 * node every time.
                 *
                 * Since we update `_renderedChildren` and the actual DOM at (slightly)
                 * different times, we could race here and see a newer `_renderedChildren` than
                 * the DOM nodes we see. To avoid this, ReactMultiChild calls
                 * `prepareToManageChildren` before we change `_renderedChildren`, at which
                 * time the container's child nodes are always cached (until it unmounts).
                 */
                function precacheChildNodes(inst, node) {
                    if (inst._flags & Flags.hasCachedChildNodes) {
                        return;
                    }
                    var children = inst._renderedChildren;
                    var childNode = node.firstChild;
                    outer: for (var name in children) {
                        if (!children.hasOwnProperty(name)) {
                            continue;
                        }
                        var childInst = children[name];
                        var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
                        if (childID === 0) {
                            // We're currently unmounting this child in ReactMultiChild; skip it.
                            continue;
                        }
                        // We assume the child nodes are in the same order as the child instances.
                        for (; childNode !== null; childNode = childNode.nextSibling) {
                            if (shouldPrecacheNode(childNode, childID)) {
                                precacheNode(childInst, childNode);
                                continue outer;
                            }
                        }
                        // We reached the end of the DOM children without finding an ID match.
                        !false ? "development" !== 'production' ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
                    }
                    inst._flags |= Flags.hasCachedChildNodes;
                }

                /**
                 * Given a DOM node, return the closest ReactDOMComponent or
                 * ReactDOMTextComponent instance ancestor.
                 */
                function getClosestInstanceFromNode(node) {
                    if (node && node[internalInstanceKey]) {
                        return node[internalInstanceKey];
                    }

                    // Walk up the tree until we find an ancestor whose instance we have cached.
                    var parents = [];
                    while (node && !node[internalInstanceKey]) {
                        parents.push(node);
                        if (node.parentNode) {
                            node = node.parentNode;
                        } else {
                            // Top of the tree. This node must not be part of a React tree (or is
                            // unmounted, potentially).
                            return null;
                        }
                    }

                    var closest;
                    var inst;
                    for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
                        closest = inst;
                        if (parents.length) {
                            precacheChildNodes(inst, node);
                        }
                    }

                    return closest;
                }

                /**
                 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
                 * instance, or null if the node was not rendered by this React.
                 */
                function getInstanceFromNode(node) {
                    var inst = getClosestInstanceFromNode(node);
                    if (inst != null && inst._hostNode === node) {
                        return inst;
                    } else {
                        return null;
                    }
                }

                /**
                 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
                 * DOM node.
                 */
                function getNodeFromInstance(inst) {
                    // Without this first invariant, passing a non-DOM-component triggers the next
                    // invariant for a missing parent, which is super confusing.
                    !(inst._hostNode !== undefined) ? "development" !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

                    if (inst._hostNode) {
                        return inst._hostNode;
                    }

                    // Walk up the tree until we find an ancestor whose DOM node we have cached.
                    var parents = [];
                    while (!inst._hostNode) {
                        parents.push(inst);
                        !inst._hostParent ? "development" !== 'production' ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
                        inst = inst._hostParent;
                    }

                    // Now parents contains each ancestor that does *not* have a cached native
                    // node, and `inst` is the deepest ancestor that does.
                    for (; parents.length; inst = parents.pop()) {
                        precacheChildNodes(inst, inst._hostNode);
                    }

                    return inst._hostNode;
                }

                var ReactDOMComponentTree = {
                    getClosestInstanceFromNode: getClosestInstanceFromNode,
                    getInstanceFromNode: getInstanceFromNode,
                    getNodeFromInstance: getNodeFromInstance,
                    precacheChildNodes: precacheChildNodes,
                    precacheNode: precacheNode,
                    uncacheNode: uncacheNode
                };

                module.exports = ReactDOMComponentTree;
            }, { "11": 11, "126": 126, "152": 152, "33": 33 }], 35: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var validateDOMNesting = _dereq_(132);

                var DOC_NODE_TYPE = 9;

                function ReactDOMContainerInfo(topLevelWrapper, node) {
                    var info = {
                        _topLevelWrapper: topLevelWrapper,
                        _idCounter: 1,
                        _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
                        _node: node,
                        _tag: node ? node.nodeName.toLowerCase() : null,
                        _namespaceURI: node ? node.namespaceURI : null
                    };
                    if ("development" !== 'production') {
                        info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
                    }
                    return info;
                }

                module.exports = ReactDOMContainerInfo;
            }, { "132": 132 }], 36: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var DOMLazyTree = _dereq_(9);
                var ReactDOMComponentTree = _dereq_(34);

                var ReactDOMEmptyComponent = function (instantiate) {
                    // ReactCompositeComponent uses this:
                    this._currentElement = null;
                    // ReactDOMComponentTree uses these:
                    this._hostNode = null;
                    this._hostParent = null;
                    this._hostContainerInfo = null;
                    this._domID = 0;
                };
                _assign(ReactDOMEmptyComponent.prototype, {
                    mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
                        var domID = hostContainerInfo._idCounter++;
                        this._domID = domID;
                        this._hostParent = hostParent;
                        this._hostContainerInfo = hostContainerInfo;

                        var nodeValue = ' react-empty: ' + this._domID + ' ';
                        if (transaction.useCreateElement) {
                            var ownerDocument = hostContainerInfo._ownerDocument;
                            var node = ownerDocument.createComment(nodeValue);
                            ReactDOMComponentTree.precacheNode(this, node);
                            return DOMLazyTree(node);
                        } else {
                            if (transaction.renderToStaticMarkup) {
                                // Normally we'd insert a comment node, but since this is a situation
                                // where React won't take over (static pages), we can simply return
                                // nothing.
                                return '';
                            }
                            return '<!--' + nodeValue + '-->';
                        }
                    },
                    receiveComponent: function () { },
                    getHostNode: function () {
                        return ReactDOMComponentTree.getNodeFromInstance(this);
                    },
                    unmountComponent: function () {
                        ReactDOMComponentTree.uncacheNode(this);
                    }
                });

                module.exports = ReactDOMEmptyComponent;
            }, { "160": 160, "34": 34, "9": 9 }], 37: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactDOMFeatureFlags = {
                    useCreateElement: true,
                    useFiber: false
                };

                module.exports = ReactDOMFeatureFlags;
            }, {}], 38: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMChildrenOperations = _dereq_(8);
                var ReactDOMComponentTree = _dereq_(34);

                /**
                 * Operations used to process updates to DOM nodes.
                 */
                var ReactDOMIDOperations = {
                    /**
                     * Updates a component's children by processing a series of updates.
                     *
                     * @param {array<object>} updates List of update configurations.
                     * @internal
                     */
                    dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
                        var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
                        DOMChildrenOperations.processUpdates(node, updates);
                    }
                };

                module.exports = ReactDOMIDOperations;
            }, { "34": 34, "8": 8 }], 39: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var DOMPropertyOperations = _dereq_(12);
                var LinkedValueUtils = _dereq_(24);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactUpdates = _dereq_(82);

                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                var didWarnValueLink = false;
                var didWarnCheckedLink = false;
                var didWarnValueDefaultValue = false;
                var didWarnCheckedDefaultChecked = false;
                var didWarnControlledToUncontrolled = false;
                var didWarnUncontrolledToControlled = false;

                function forceUpdateIfMounted() {
                    if (this._rootNodeID) {
                        // DOM component is still mounted; update
                        ReactDOMInput.updateWrapper(this);
                    }
                }

                function isControlled(props) {
                    var usesChecked = props.type === 'checkbox' || props.type === 'radio';
                    return usesChecked ? props.checked != null : props.value != null;
                }

                /**
                 * Implements an <input> host component that allows setting these optional
                 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
                 *
                 * If `checked` or `value` are not supplied (or null/undefined), user actions
                 * that affect the checked state or value will trigger updates to the element.
                 *
                 * If they are supplied (and not null/undefined), the rendered element will not
                 * trigger updates to the element. Instead, the props must change in order for
                 * the rendered element to be updated.
                 *
                 * The rendered element will be initialized as unchecked (or `defaultChecked`)
                 * with an empty value (or `defaultValue`).
                 *
                 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
                 */
                var ReactDOMInput = {
                    getHostProps: function (inst, props) {
                        var value = LinkedValueUtils.getValue(props);
                        var checked = LinkedValueUtils.getChecked(props);

                        var hostProps = _assign({
                            // Make sure we set .type before any other properties (setting .value
                            // before .type means .value is lost in IE11 and below)
                            type: undefined,
                            // Make sure we set .step before .value (setting .value before .step
                            // means .value is rounded on mount, based upon step precision)
                            step: undefined,
                            // Make sure we set .min & .max before .value (to ensure proper order
                            // in corner cases such as min or max deriving from value, e.g. Issue #7170)
                            min: undefined,
                            max: undefined
                        }, props, {
                                defaultChecked: undefined,
                                defaultValue: undefined,
                                value: value != null ? value : inst._wrapperState.initialValue,
                                checked: checked != null ? checked : inst._wrapperState.initialChecked,
                                onChange: inst._wrapperState.onChange
                            });

                        return hostProps;
                    },

                    mountWrapper: function (inst, props) {
                        if ("development" !== 'production') {
                            LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

                            var owner = inst._currentElement._owner;

                            if (props.valueLink !== undefined && !didWarnValueLink) {
                                "development" !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
                                didWarnValueLink = true;
                            }
                            if (props.checkedLink !== undefined && !didWarnCheckedLink) {
                                "development" !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
                                didWarnCheckedLink = true;
                            }
                            if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
                                "development" !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
                                didWarnCheckedDefaultChecked = true;
                            }
                            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
                                "development" !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
                                didWarnValueDefaultValue = true;
                            }
                        }

                        var defaultValue = props.defaultValue;
                        inst._wrapperState = {
                            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
                            initialValue: props.value != null ? props.value : defaultValue,
                            listeners: null,
                            onChange: _handleChange.bind(inst),
                            controlled: isControlled(props)
                        };
                    },

                    updateWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        if ("development" !== 'production') {
                            var controlled = isControlled(props);
                            var owner = inst._currentElement._owner;

                            if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
                                "development" !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
                                didWarnUncontrolledToControlled = true;
                            }
                            if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
                                "development" !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
                                didWarnControlledToUncontrolled = true;
                            }
                        }

                        // TODO: Shouldn't this be getChecked(props)?
                        var checked = props.checked;
                        if (checked != null) {
                            DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
                        }

                        var node = ReactDOMComponentTree.getNodeFromInstance(inst);
                        var value = LinkedValueUtils.getValue(props);
                        if (value != null) {
                            if (value === 0 && node.value === '') {
                                node.value = '0';
                                // Note: IE9 reports a number inputs as 'text', so check props instead.
                            } else if (props.type === 'number') {
                                // Simulate `input.valueAsNumber`. IE9 does not support it
                                var valueAsNumber = parseFloat(node.value, 10) || 0;

                                if (
                                    // eslint-disable-next-line
                                    value != valueAsNumber ||
                                    // eslint-disable-next-line
                                    value == valueAsNumber && node.value != value) {
                                    // Cast `value` to a string to ensure the value is set correctly. While
                                    // browsers typically do this as necessary, jsdom doesn't.
                                    node.value = '' + value;
                                }
                            } else if (node.value !== '' + value) {
                                // Cast `value` to a string to ensure the value is set correctly. While
                                // browsers typically do this as necessary, jsdom doesn't.
                                node.value = '' + value;
                            }
                        } else {
                            if (props.value == null && props.defaultValue != null) {
                                // In Chrome, assigning defaultValue to certain input types triggers input validation.
                                // For number inputs, the display value loses trailing decimal points. For email inputs,
                                // Chrome raises "The specified value <x> is not a valid email address".
                                //
                                // Here we check to see if the defaultValue has actually changed, avoiding these problems
                                // when the user is inputting text
                                //
                                // https://github.com/facebook/react/issues/7253
                                if (node.defaultValue !== '' + props.defaultValue) {
                                    node.defaultValue = '' + props.defaultValue;
                                }
                            }
                            if (props.checked == null && props.defaultChecked != null) {
                                node.defaultChecked = !!props.defaultChecked;
                            }
                        }
                    },

                    postMountWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        // This is in postMount because we need access to the DOM node, which is not
                        // available until after the component has mounted.
                        var node = ReactDOMComponentTree.getNodeFromInstance(inst);

                        // Detach value from defaultValue. We won't do anything if we're working on
                        // submit or reset inputs as those values & defaultValues are linked. They
                        // are not resetable nodes so this operation doesn't matter and actually
                        // removes browser-default values (eg "Submit Query") when no value is
                        // provided.

                        switch (props.type) {
                            case 'submit':
                            case 'reset':
                                break;
                            case 'color':
                            case 'date':
                            case 'datetime':
                            case 'datetime-local':
                            case 'month':
                            case 'time':
                            case 'week':
                                // This fixes the no-show issue on iOS Safari and Android Chrome:
                                // https://github.com/facebook/react/issues/7233
                                node.value = '';
                                node.value = node.defaultValue;
                                break;
                            default:
                                node.value = node.value;
                                break;
                        }

                        // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
                        // this is needed to work around a chrome bug where setting defaultChecked
                        // will sometimes influence the value of checked (even after detachment).
                        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
                        // We need to temporarily unset name to avoid disrupting radio button groups.
                        var name = node.name;
                        if (name !== '') {
                            node.name = '';
                        }
                        node.defaultChecked = !node.defaultChecked;
                        node.defaultChecked = !node.defaultChecked;
                        if (name !== '') {
                            node.name = name;
                        }
                    }
                };

                function _handleChange(event) {
                    var props = this._currentElement.props;

                    var returnValue = LinkedValueUtils.executeOnChange(props, event);

                    // Here we use asap to wait until all updates have propagated, which
                    // is important when using controlled components within layers:
                    // https://github.com/facebook/react/issues/1698
                    ReactUpdates.asap(forceUpdateIfMounted, this);

                    var name = props.name;
                    if (props.type === 'radio' && name != null) {
                        var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
                        var queryRoot = rootNode;

                        while (queryRoot.parentNode) {
                            queryRoot = queryRoot.parentNode;
                        }

                        // If `rootNode.form` was non-null, then we could try `form.elements`,
                        // but that sometimes behaves strangely in IE8. We could also try using
                        // `form.getElementsByName`, but that will only return direct children
                        // and won't include inputs that use the HTML5 `form=` attribute. Since
                        // the input might not even be in a form, let's just use the global
                        // `querySelectorAll` to ensure we don't miss anything.
                        var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

                        for (var i = 0; i < group.length; i++) {
                            var otherNode = group[i];
                            if (otherNode === rootNode || otherNode.form !== rootNode.form) {
                                continue;
                            }
                            // This will throw if radio buttons rendered by different copies of React
                            // and the same name are rendered into the same form (same as #1939).
                            // That's probably okay; we don't support it just as we don't support
                            // mixing React radio buttons with non-React ones.
                            var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
                            !otherInstance ? "development" !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
                            // If this is a controlled radio button group, forcing the input that
                            // was previously checked to update will cause it to be come re-checked
                            // as appropriate.
                            ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
                        }
                    }

                    return returnValue;
                }

                module.exports = ReactDOMInput;
            }, { "12": 12, "126": 126, "152": 152, "159": 159, "160": 160, "24": 24, "34": 34, "82": 82 }], 40: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMProperty = _dereq_(11);
                var ReactComponentTreeHook = _dereq_(133);

                var warning = _dereq_(159);

                var warnedProperties = {};
                var rARIA = new RegExp('^(aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');

                function validateProperty(tagName, name, debugID) {
                    if (warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
                        return true;
                    }

                    if (rARIA.test(name)) {
                        var lowerCasedName = name.toLowerCase();
                        var standardName = DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;

                        // If this is an aria-* attribute, but is not listed in the known DOM
                        // DOM properties, then it is an invalid aria-* attribute.
                        if (standardName == null) {
                            warnedProperties[name] = true;
                            return false;
                        }
                        // aria-* attributes should be lowercase; suggest the lowercase version.
                        if (name !== standardName) {
                            "development" !== 'production' ? warning(false, 'Unknown ARIA attribute %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                            warnedProperties[name] = true;
                            return true;
                        }
                    }

                    return true;
                }

                function warnInvalidARIAProps(debugID, element) {
                    var invalidProps = [];

                    for (var key in element.props) {
                        var isValid = validateProperty(element.type, key, debugID);
                        if (!isValid) {
                            invalidProps.push(key);
                        }
                    }

                    var unknownPropString = invalidProps.map(function (prop) {
                        return '`' + prop + '`';
                    }).join(', ');

                    if (invalidProps.length === 1) {
                        "development" !== 'production' ? warning(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                    } else if (invalidProps.length > 1) {
                        "development" !== 'production' ? warning(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                    }
                }

                function handleElement(debugID, element) {
                    if (element == null || typeof element.type !== 'string') {
                        return;
                    }
                    if (element.type.indexOf('-') >= 0 || element.props.is) {
                        return;
                    }

                    warnInvalidARIAProps(debugID, element);
                }

                var ReactDOMInvalidARIAHook = {
                    onBeforeMountComponent: function (debugID, element) {
                        if ("development" !== 'production') {
                            handleElement(debugID, element);
                        }
                    },
                    onBeforeUpdateComponent: function (debugID, element) {
                        if ("development" !== 'production') {
                            handleElement(debugID, element);
                        }
                    }
                };

                module.exports = ReactDOMInvalidARIAHook;
            }, { "11": 11, "133": 133, "159": 159 }], 41: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactComponentTreeHook = _dereq_(133);

                var warning = _dereq_(159);

                var didWarnValueNull = false;

                function handleElement(debugID, element) {
                    if (element == null) {
                        return;
                    }
                    if (element.type !== 'input' && element.type !== 'textarea' && element.type !== 'select') {
                        return;
                    }
                    if (element.props != null && element.props.value === null && !didWarnValueNull) {
                        "development" !== 'production' ? warning(false, '`value` prop on `%s` should not be null. ' + 'Consider using the empty string to clear the component or `undefined` ' + 'for uncontrolled components.%s', element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;

                        didWarnValueNull = true;
                    }
                }

                var ReactDOMNullInputValuePropHook = {
                    onBeforeMountComponent: function (debugID, element) {
                        handleElement(debugID, element);
                    },
                    onBeforeUpdateComponent: function (debugID, element) {
                        handleElement(debugID, element);
                    }
                };

                module.exports = ReactDOMNullInputValuePropHook;
            }, { "133": 133, "159": 159 }], 42: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var React = _dereq_(135);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactDOMSelect = _dereq_(43);

                var warning = _dereq_(159);
                var didWarnInvalidOptionChildren = false;

                function flattenChildren(children) {
                    var content = '';

                    // Flatten children and warn if they aren't strings or numbers;
                    // invalid types are ignored.
                    React.Children.forEach(children, function (child) {
                        if (child == null) {
                            return;
                        }
                        if (typeof child === 'string' || typeof child === 'number') {
                            content += child;
                        } else if (!didWarnInvalidOptionChildren) {
                            didWarnInvalidOptionChildren = true;
                            "development" !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
                        }
                    });

                    return content;
                }

                /**
                 * Implements an <option> host component that warns when `selected` is set.
                 */
                var ReactDOMOption = {
                    mountWrapper: function (inst, props, hostParent) {
                        // TODO (yungsters): Remove support for `selected` in <option>.
                        if ("development" !== 'production') {
                            "development" !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
                        }

                        // Look up whether this option is 'selected'
                        var selectValue = null;
                        if (hostParent != null) {
                            var selectParent = hostParent;

                            if (selectParent._tag === 'optgroup') {
                                selectParent = selectParent._hostParent;
                            }

                            if (selectParent != null && selectParent._tag === 'select') {
                                selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
                            }
                        }

                        // If the value is null (e.g., no specified value or after initial mount)
                        // or missing (e.g., for <datalist>), we don't change props.selected
                        var selected = null;
                        if (selectValue != null) {
                            var value;
                            if (props.value != null) {
                                value = props.value + '';
                            } else {
                                value = flattenChildren(props.children);
                            }
                            selected = false;
                            if (Array.isArray(selectValue)) {
                                // multiple
                                for (var i = 0; i < selectValue.length; i++) {
                                    if ('' + selectValue[i] === value) {
                                        selected = true;
                                        break;
                                    }
                                }
                            } else {
                                selected = '' + selectValue === value;
                            }
                        }

                        inst._wrapperState = { selected: selected };
                    },

                    postMountWrapper: function (inst) {
                        // value="" should make a value attribute (#6219)
                        var props = inst._currentElement.props;
                        if (props.value != null) {
                            var node = ReactDOMComponentTree.getNodeFromInstance(inst);
                            node.setAttribute('value', props.value);
                        }
                    },

                    getHostProps: function (inst, props) {
                        var hostProps = _assign({ selected: undefined, children: undefined }, props);

                        // Read state only from initial mount because <select> updates value
                        // manually; we need the initial state only for server rendering
                        if (inst._wrapperState.selected != null) {
                            hostProps.selected = inst._wrapperState.selected;
                        }

                        var content = flattenChildren(props.children);

                        if (content) {
                            hostProps.children = content;
                        }

                        return hostProps;
                    }
                };

                module.exports = ReactDOMOption;
            }, { "135": 135, "159": 159, "160": 160, "34": 34, "43": 43 }], 43: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var LinkedValueUtils = _dereq_(24);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactUpdates = _dereq_(82);

                var warning = _dereq_(159);

                var didWarnValueLink = false;
                var didWarnValueDefaultValue = false;

                function updateOptionsIfPendingUpdateAndMounted() {
                    if (this._rootNodeID && this._wrapperState.pendingUpdate) {
                        this._wrapperState.pendingUpdate = false;

                        var props = this._currentElement.props;
                        var value = LinkedValueUtils.getValue(props);

                        if (value != null) {
                            updateOptions(this, Boolean(props.multiple), value);
                        }
                    }
                }

                function getDeclarationErrorAddendum(owner) {
                    if (owner) {
                        var name = owner.getName();
                        if (name) {
                            return ' Check the render method of `' + name + '`.';
                        }
                    }
                    return '';
                }

                var valuePropNames = ['value', 'defaultValue'];

                /**
                 * Validation function for `value` and `defaultValue`.
                 * @private
                 */
                function checkSelectPropTypes(inst, props) {
                    var owner = inst._currentElement._owner;
                    LinkedValueUtils.checkPropTypes('select', props, owner);

                    if (props.valueLink !== undefined && !didWarnValueLink) {
                        "development" !== 'production' ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
                        didWarnValueLink = true;
                    }

                    for (var i = 0; i < valuePropNames.length; i++) {
                        var propName = valuePropNames[i];
                        if (props[propName] == null) {
                            continue;
                        }
                        var isArray = Array.isArray(props[propName]);
                        if (props.multiple && !isArray) {
                            "development" !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
                        } else if (!props.multiple && isArray) {
                            "development" !== 'production' ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
                        }
                    }
                }

                /**
                 * @param {ReactDOMComponent} inst
                 * @param {boolean} multiple
                 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
                 * @private
                 */
                function updateOptions(inst, multiple, propValue) {
                    var selectedValue, i;
                    var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

                    if (multiple) {
                        selectedValue = {};
                        for (i = 0; i < propValue.length; i++) {
                            selectedValue['' + propValue[i]] = true;
                        }
                        for (i = 0; i < options.length; i++) {
                            var selected = selectedValue.hasOwnProperty(options[i].value);
                            if (options[i].selected !== selected) {
                                options[i].selected = selected;
                            }
                        }
                    } else {
                        // Do not set `select.value` as exact behavior isn't consistent across all
                        // browsers for all cases.
                        selectedValue = '' + propValue;
                        for (i = 0; i < options.length; i++) {
                            if (options[i].value === selectedValue) {
                                options[i].selected = true;
                                return;
                            }
                        }
                        if (options.length) {
                            options[0].selected = true;
                        }
                    }
                }

                /**
                 * Implements a <select> host component that allows optionally setting the
                 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
                 * stringable. If `multiple` is true, the prop must be an array of stringables.
                 *
                 * If `value` is not supplied (or null/undefined), user actions that change the
                 * selected option will trigger updates to the rendered options.
                 *
                 * If it is supplied (and not null/undefined), the rendered options will not
                 * update in response to user actions. Instead, the `value` prop must change in
                 * order for the rendered options to update.
                 *
                 * If `defaultValue` is provided, any options with the supplied values will be
                 * selected.
                 */
                var ReactDOMSelect = {
                    getHostProps: function (inst, props) {
                        return _assign({}, props, {
                            onChange: inst._wrapperState.onChange,
                            value: undefined
                        });
                    },

                    mountWrapper: function (inst, props) {
                        if ("development" !== 'production') {
                            checkSelectPropTypes(inst, props);
                        }

                        var value = LinkedValueUtils.getValue(props);
                        inst._wrapperState = {
                            pendingUpdate: false,
                            initialValue: value != null ? value : props.defaultValue,
                            listeners: null,
                            onChange: _handleChange.bind(inst),
                            wasMultiple: Boolean(props.multiple)
                        };

                        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
                            "development" !== 'production' ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
                            didWarnValueDefaultValue = true;
                        }
                    },

                    getSelectValueContext: function (inst) {
                        // ReactDOMOption looks at this initial value so the initial generated
                        // markup has correct `selected` attributes
                        return inst._wrapperState.initialValue;
                    },

                    postUpdateWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        // After the initial mount, we control selected-ness manually so don't pass
                        // this value down
                        inst._wrapperState.initialValue = undefined;

                        var wasMultiple = inst._wrapperState.wasMultiple;
                        inst._wrapperState.wasMultiple = Boolean(props.multiple);

                        var value = LinkedValueUtils.getValue(props);
                        if (value != null) {
                            inst._wrapperState.pendingUpdate = false;
                            updateOptions(inst, Boolean(props.multiple), value);
                        } else if (wasMultiple !== Boolean(props.multiple)) {
                            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
                            if (props.defaultValue != null) {
                                updateOptions(inst, Boolean(props.multiple), props.defaultValue);
                            } else {
                                // Revert the select back to its default unselected state.
                                updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
                            }
                        }
                    }
                };

                function _handleChange(event) {
                    var props = this._currentElement.props;
                    var returnValue = LinkedValueUtils.executeOnChange(props, event);

                    if (this._rootNodeID) {
                        this._wrapperState.pendingUpdate = true;
                    }
                    ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
                    return returnValue;
                }

                module.exports = ReactDOMSelect;
            }, { "159": 159, "160": 160, "24": 24, "34": 34, "82": 82 }], 44: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);

                var getNodeForCharacterOffset = _dereq_(117);
                var getTextContentAccessor = _dereq_(118);

                /**
                 * While `isCollapsed` is available on the Selection object and `collapsed`
                 * is available on the Range object, IE11 sometimes gets them wrong.
                 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
                 */
                function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
                    return anchorNode === focusNode && anchorOffset === focusOffset;
                }

                /**
                 * Get the appropriate anchor and focus node/offset pairs for IE.
                 *
                 * The catch here is that IE's selection API doesn't provide information
                 * about whether the selection is forward or backward, so we have to
                 * behave as though it's always forward.
                 *
                 * IE text differs from modern selection in that it behaves as though
                 * block elements end with a new line. This means character offsets will
                 * differ between the two APIs.
                 *
                 * @param {DOMElement} node
                 * @return {object}
                 */
                function getIEOffsets(node) {
                    var selection = document.selection;
                    var selectedRange = selection.createRange();
                    var selectedLength = selectedRange.text.length;

                    // Duplicate selection so we can move range without breaking user selection.
                    var fromStart = selectedRange.duplicate();
                    fromStart.moveToElementText(node);
                    fromStart.setEndPoint('EndToStart', selectedRange);

                    var startOffset = fromStart.text.length;
                    var endOffset = startOffset + selectedLength;

                    return {
                        start: startOffset,
                        end: endOffset
                    };
                }

                /**
                 * @param {DOMElement} node
                 * @return {?object}
                 */
                function getModernOffsets(node) {
                    var selection = window.getSelection && window.getSelection();

                    if (!selection || selection.rangeCount === 0) {
                        return null;
                    }

                    var anchorNode = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset;
                    var focusNode = selection.focusNode;
                    var focusOffset = selection.focusOffset;

                    var currentRange = selection.getRangeAt(0);

                    // In Firefox, range.startContainer and range.endContainer can be "anonymous
                    // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
                    // divs do not seem to expose properties, triggering a "Permission denied
                    // error" if any of its properties are accessed. The only seemingly possible
                    // way to avoid erroring is to access a property that typically works for
                    // non-anonymous divs and catch any error that may otherwise arise. See
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
                    try {
                        /* eslint-disable no-unused-expressions */
                        currentRange.startContainer.nodeType;
                        currentRange.endContainer.nodeType;
                        /* eslint-enable no-unused-expressions */
                    } catch (e) {
                        return null;
                    }

                    // If the node and offset values are the same, the selection is collapsed.
                    // `Selection.isCollapsed` is available natively, but IE sometimes gets
                    // this value wrong.
                    var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

                    var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

                    var tempRange = currentRange.cloneRange();
                    tempRange.selectNodeContents(node);
                    tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

                    var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

                    var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
                    var end = start + rangeLength;

                    // Detect whether the selection is backward.
                    var detectionRange = document.createRange();
                    detectionRange.setStart(anchorNode, anchorOffset);
                    detectionRange.setEnd(focusNode, focusOffset);
                    var isBackward = detectionRange.collapsed;

                    return {
                        start: isBackward ? end : start,
                        end: isBackward ? start : end
                    };
                }

                /**
                 * @param {DOMElement|DOMTextNode} node
                 * @param {object} offsets
                 */
                function setIEOffsets(node, offsets) {
                    var range = document.selection.createRange().duplicate();
                    var start, end;

                    if (offsets.end === undefined) {
                        start = offsets.start;
                        end = start;
                    } else if (offsets.start > offsets.end) {
                        start = offsets.end;
                        end = offsets.start;
                    } else {
                        start = offsets.start;
                        end = offsets.end;
                    }

                    range.moveToElementText(node);
                    range.moveStart('character', start);
                    range.setEndPoint('EndToStart', range);
                    range.moveEnd('character', end - start);
                    range.select();
                }

                /**
                 * In modern non-IE browsers, we can support both forward and backward
                 * selections.
                 *
                 * Note: IE10+ supports the Selection object, but it does not support
                 * the `extend` method, which means that even in modern IE, it's not possible
                 * to programmatically create a backward selection. Thus, for all IE
                 * versions, we use the old IE API to create our selections.
                 *
                 * @param {DOMElement|DOMTextNode} node
                 * @param {object} offsets
                 */
                function setModernOffsets(node, offsets) {
                    if (!window.getSelection) {
                        return;
                    }

                    var selection = window.getSelection();
                    var length = node[getTextContentAccessor()].length;
                    var start = Math.min(offsets.start, length);
                    var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

                    // IE 11 uses modern selection, but doesn't support the extend method.
                    // Flip backward selections, so we can set with a single range.
                    if (!selection.extend && start > end) {
                        var temp = end;
                        end = start;
                        start = temp;
                    }

                    var startMarker = getNodeForCharacterOffset(node, start);
                    var endMarker = getNodeForCharacterOffset(node, end);

                    if (startMarker && endMarker) {
                        var range = document.createRange();
                        range.setStart(startMarker.node, startMarker.offset);
                        selection.removeAllRanges();

                        if (start > end) {
                            selection.addRange(range);
                            selection.extend(endMarker.node, endMarker.offset);
                        } else {
                            range.setEnd(endMarker.node, endMarker.offset);
                            selection.addRange(range);
                        }
                    }
                }

                var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

                var ReactDOMSelection = {
                    /**
                     * @param {DOMElement} node
                     */
                    getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

                    /**
                     * @param {DOMElement|DOMTextNode} node
                     * @param {object} offsets
                     */
                    setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
                };

                module.exports = ReactDOMSelection;
            }, { "117": 117, "118": 118, "138": 138 }], 45: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var DOMChildrenOperations = _dereq_(8);
                var DOMLazyTree = _dereq_(9);
                var ReactDOMComponentTree = _dereq_(34);

                var escapeTextContentForBrowser = _dereq_(107);
                var invariant = _dereq_(152);
                var validateDOMNesting = _dereq_(132);

                /**
                 * Text nodes violate a couple assumptions that React makes about components:
                 *
                 *  - When mounting text into the DOM, adjacent text nodes are merged.
                 *  - Text nodes cannot be assigned a React root ID.
                 *
                 * This component is used to wrap strings between comment nodes so that they
                 * can undergo the same reconciliation that is applied to elements.
                 *
                 * TODO: Investigate representing React components in the DOM with text nodes.
                 *
                 * @class ReactDOMTextComponent
                 * @extends ReactComponent
                 * @internal
                 */
                var ReactDOMTextComponent = function (text) {
                    // TODO: This is really a ReactText (ReactNode), not a ReactElement
                    this._currentElement = text;
                    this._stringText = '' + text;
                    // ReactDOMComponentTree uses these:
                    this._hostNode = null;
                    this._hostParent = null;

                    // Properties
                    this._domID = 0;
                    this._mountIndex = 0;
                    this._closingComment = null;
                    this._commentNodes = null;
                };

                _assign(ReactDOMTextComponent.prototype, {
                    /**
                     * Creates the markup for this text node. This node is not intended to have
                     * any features besides containing text content.
                     *
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @return {string} Markup for this text node.
                     * @internal
                     */
                    mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
                        if ("development" !== 'production') {
                            var parentInfo;
                            if (hostParent != null) {
                                parentInfo = hostParent._ancestorInfo;
                            } else if (hostContainerInfo != null) {
                                parentInfo = hostContainerInfo._ancestorInfo;
                            }
                            if (parentInfo) {
                                // parentInfo should always be present except for the top-level
                                // component when server rendering
                                validateDOMNesting(null, this._stringText, this, parentInfo);
                            }
                        }

                        var domID = hostContainerInfo._idCounter++;
                        var openingValue = ' react-text: ' + domID + ' ';
                        var closingValue = ' /react-text ';
                        this._domID = domID;
                        this._hostParent = hostParent;
                        if (transaction.useCreateElement) {
                            var ownerDocument = hostContainerInfo._ownerDocument;
                            var openingComment = ownerDocument.createComment(openingValue);
                            var closingComment = ownerDocument.createComment(closingValue);
                            var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
                            DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
                            if (this._stringText) {
                                DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
                            }
                            DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
                            ReactDOMComponentTree.precacheNode(this, openingComment);
                            this._closingComment = closingComment;
                            return lazyTree;
                        } else {
                            var escapedText = escapeTextContentForBrowser(this._stringText);

                            if (transaction.renderToStaticMarkup) {
                                // Normally we'd wrap this between comment nodes for the reasons stated
                                // above, but since this is a situation where React won't take over
                                // (static pages), we can simply return the text as it is.
                                return escapedText;
                            }

                            return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
                        }
                    },

                    /**
                     * Updates this component by updating the text content.
                     *
                     * @param {ReactText} nextText The next text content
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    receiveComponent: function (nextText, transaction) {
                        if (nextText !== this._currentElement) {
                            this._currentElement = nextText;
                            var nextStringText = '' + nextText;
                            if (nextStringText !== this._stringText) {
                                // TODO: Save this as pending props and use performUpdateIfNecessary
                                // and/or updateComponent to do the actual update for consistency with
                                // other component types?
                                this._stringText = nextStringText;
                                var commentNodes = this.getHostNode();
                                DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
                            }
                        }
                    },

                    getHostNode: function () {
                        var hostNode = this._commentNodes;
                        if (hostNode) {
                            return hostNode;
                        }
                        if (!this._closingComment) {
                            var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
                            var node = openingComment.nextSibling;
                            while (true) {
                                !(node != null) ? "development" !== 'production' ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
                                if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
                                    this._closingComment = node;
                                    break;
                                }
                                node = node.nextSibling;
                            }
                        }
                        hostNode = [this._hostNode, this._closingComment];
                        this._commentNodes = hostNode;
                        return hostNode;
                    },

                    unmountComponent: function () {
                        this._closingComment = null;
                        this._commentNodes = null;
                        ReactDOMComponentTree.uncacheNode(this);
                    }
                });

                module.exports = ReactDOMTextComponent;
            }, { "107": 107, "126": 126, "132": 132, "152": 152, "160": 160, "34": 34, "8": 8, "9": 9 }], 46: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var LinkedValueUtils = _dereq_(24);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactUpdates = _dereq_(82);

                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                var didWarnValueLink = false;
                var didWarnValDefaultVal = false;

                function forceUpdateIfMounted() {
                    if (this._rootNodeID) {
                        // DOM component is still mounted; update
                        ReactDOMTextarea.updateWrapper(this);
                    }
                }

                /**
                 * Implements a <textarea> host component that allows setting `value`, and
                 * `defaultValue`. This differs from the traditional DOM API because value is
                 * usually set as PCDATA children.
                 *
                 * If `value` is not supplied (or null/undefined), user actions that affect the
                 * value will trigger updates to the element.
                 *
                 * If `value` is supplied (and not null/undefined), the rendered element will
                 * not trigger updates to the element. Instead, the `value` prop must change in
                 * order for the rendered element to be updated.
                 *
                 * The rendered element will be initialized with an empty value, the prop
                 * `defaultValue` if specified, or the children content (deprecated).
                 */
                var ReactDOMTextarea = {
                    getHostProps: function (inst, props) {
                        !(props.dangerouslySetInnerHTML == null) ? "development" !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

                        // Always set children to the same thing. In IE9, the selection range will
                        // get reset if `textContent` is mutated.  We could add a check in setTextContent
                        // to only set the value if/when the value differs from the node value (which would
                        // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
                        // The value can be a boolean or object so that's why it's forced to be a string.
                        var hostProps = _assign({}, props, {
                            value: undefined,
                            defaultValue: undefined,
                            children: '' + inst._wrapperState.initialValue,
                            onChange: inst._wrapperState.onChange
                        });

                        return hostProps;
                    },

                    mountWrapper: function (inst, props) {
                        if ("development" !== 'production') {
                            LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
                            if (props.valueLink !== undefined && !didWarnValueLink) {
                                "development" !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
                                didWarnValueLink = true;
                            }
                            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
                                "development" !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
                                didWarnValDefaultVal = true;
                            }
                        }

                        var value = LinkedValueUtils.getValue(props);
                        var initialValue = value;

                        // Only bother fetching default value if we're going to use it
                        if (value == null) {
                            var defaultValue = props.defaultValue;
                            // TODO (yungsters): Remove support for children content in <textarea>.
                            var children = props.children;
                            if (children != null) {
                                if ("development" !== 'production') {
                                    "development" !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
                                }
                                !(defaultValue == null) ? "development" !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
                                if (Array.isArray(children)) {
                                    !(children.length <= 1) ? "development" !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
                                    children = children[0];
                                }

                                defaultValue = '' + children;
                            }
                            if (defaultValue == null) {
                                defaultValue = '';
                            }
                            initialValue = defaultValue;
                        }

                        inst._wrapperState = {
                            initialValue: '' + initialValue,
                            listeners: null,
                            onChange: _handleChange.bind(inst)
                        };
                    },

                    updateWrapper: function (inst) {
                        var props = inst._currentElement.props;

                        var node = ReactDOMComponentTree.getNodeFromInstance(inst);
                        var value = LinkedValueUtils.getValue(props);
                        if (value != null) {
                            // Cast `value` to a string to ensure the value is set correctly. While
                            // browsers typically do this as necessary, jsdom doesn't.
                            var newValue = '' + value;

                            // To avoid side effects (such as losing text selection), only set value if changed
                            if (newValue !== node.value) {
                                node.value = newValue;
                            }
                            if (props.defaultValue == null) {
                                node.defaultValue = newValue;
                            }
                        }
                        if (props.defaultValue != null) {
                            node.defaultValue = props.defaultValue;
                        }
                    },

                    postMountWrapper: function (inst) {
                        // This is in postMount because we need access to the DOM node, which is not
                        // available until after the component has mounted.
                        var node = ReactDOMComponentTree.getNodeFromInstance(inst);
                        var textContent = node.textContent;

                        // Only set node.value if textContent is equal to the expected
                        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
                        // will populate textContent as well.
                        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
                        if (textContent === inst._wrapperState.initialValue) {
                            node.value = textContent;
                        }
                    }
                };

                function _handleChange(event) {
                    var props = this._currentElement.props;
                    var returnValue = LinkedValueUtils.executeOnChange(props, event);
                    ReactUpdates.asap(forceUpdateIfMounted, this);
                    return returnValue;
                }

                module.exports = ReactDOMTextarea;
            }, { "126": 126, "152": 152, "159": 159, "160": 160, "24": 24, "34": 34, "82": 82 }], 47: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                /**
                 * Return the lowest common ancestor of A and B, or null if they are in
                 * different trees.
                 */
                function getLowestCommonAncestor(instA, instB) {
                    !('_hostNode' in instA) ? "development" !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
                    !('_hostNode' in instB) ? "development" !== 'production' ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

                    var depthA = 0;
                    for (var tempA = instA; tempA; tempA = tempA._hostParent) {
                        depthA++;
                    }
                    var depthB = 0;
                    for (var tempB = instB; tempB; tempB = tempB._hostParent) {
                        depthB++;
                    }

                    // If A is deeper, crawl up.
                    while (depthA - depthB > 0) {
                        instA = instA._hostParent;
                        depthA--;
                    }

                    // If B is deeper, crawl up.
                    while (depthB - depthA > 0) {
                        instB = instB._hostParent;
                        depthB--;
                    }

                    // Walk in lockstep until we find a match.
                    var depth = depthA;
                    while (depth--) {
                        if (instA === instB) {
                            return instA;
                        }
                        instA = instA._hostParent;
                        instB = instB._hostParent;
                    }
                    return null;
                }

                /**
                 * Return if A is an ancestor of B.
                 */
                function isAncestor(instA, instB) {
                    !('_hostNode' in instA) ? "development" !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
                    !('_hostNode' in instB) ? "development" !== 'production' ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

                    while (instB) {
                        if (instB === instA) {
                            return true;
                        }
                        instB = instB._hostParent;
                    }
                    return false;
                }

                /**
                 * Return the parent instance of the passed-in instance.
                 */
                function getParentInstance(inst) {
                    !('_hostNode' in inst) ? "development" !== 'production' ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

                    return inst._hostParent;
                }

                /**
                 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
                 */
                function traverseTwoPhase(inst, fn, arg) {
                    var path = [];
                    while (inst) {
                        path.push(inst);
                        inst = inst._hostParent;
                    }
                    var i;
                    for (i = path.length; i-- > 0;) {
                        fn(path[i], 'captured', arg);
                    }
                    for (i = 0; i < path.length; i++) {
                        fn(path[i], 'bubbled', arg);
                    }
                }

                /**
                 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
                 * should would receive a `mouseEnter` or `mouseLeave` event.
                 *
                 * Does not invoke the callback on the nearest common ancestor because nothing
                 * "entered" or "left" that element.
                 */
                function traverseEnterLeave(from, to, fn, argFrom, argTo) {
                    var common = from && to ? getLowestCommonAncestor(from, to) : null;
                    var pathFrom = [];
                    while (from && from !== common) {
                        pathFrom.push(from);
                        from = from._hostParent;
                    }
                    var pathTo = [];
                    while (to && to !== common) {
                        pathTo.push(to);
                        to = to._hostParent;
                    }
                    var i;
                    for (i = 0; i < pathFrom.length; i++) {
                        fn(pathFrom[i], 'bubbled', argFrom);
                    }
                    for (i = pathTo.length; i-- > 0;) {
                        fn(pathTo[i], 'captured', argTo);
                    }
                }

                module.exports = {
                    isAncestor: isAncestor,
                    getLowestCommonAncestor: getLowestCommonAncestor,
                    getParentInstance: getParentInstance,
                    traverseTwoPhase: traverseTwoPhase,
                    traverseEnterLeave: traverseEnterLeave
                };
            }, { "126": 126, "152": 152 }], 48: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var React = _dereq_(135);
                var ReactDOM = _dereq_(31);

                var ReactDOMUMDEntry = ReactDOM;

                if ("development" !== 'production') {
                    ReactDOMUMDEntry.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = {
                        // ReactPerf and ReactTestUtils currently only work with the DOM renderer
                        // so we expose them from here, but only in DEV mode.
                        ReactPerf: _dereq_(71),
                        ReactTestUtils: _dereq_(80)
                    };
                }

                // Inject ReactDOM into React for the addons UMD build that depends on ReactDOM (TransitionGroup).
                // We can remove this after we deprecate and remove the addons UMD build.
                if (React.addons) {
                    React.__SECRET_INJECTED_REACT_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMUMDEntry;
                }

                module.exports = ReactDOMUMDEntry;
            }, { "135": 135, "31": 31, "71": 71, "80": 80 }], 49: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMProperty = _dereq_(11);
                var EventPluginRegistry = _dereq_(18);
                var ReactComponentTreeHook = _dereq_(133);

                var warning = _dereq_(159);

                if ("development" !== 'production') {
                    var reactProps = {
                        children: true,
                        dangerouslySetInnerHTML: true,
                        key: true,
                        ref: true,

                        autoFocus: true,
                        defaultValue: true,
                        valueLink: true,
                        defaultChecked: true,
                        checkedLink: true,
                        innerHTML: true,
                        suppressContentEditableWarning: true,
                        onFocusIn: true,
                        onFocusOut: true
                    };
                    var warnedProperties = {};

                    var validateProperty = function (tagName, name, debugID) {
                        if (DOMProperty.properties.hasOwnProperty(name) || DOMProperty.isCustomAttribute(name)) {
                            return true;
                        }
                        if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
                            return true;
                        }
                        if (EventPluginRegistry.registrationNameModules.hasOwnProperty(name)) {
                            return true;
                        }
                        warnedProperties[name] = true;
                        var lowerCasedName = name.toLowerCase();

                        // data-* attributes should be lowercase; suggest the lowercase version
                        var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;

                        var registrationName = EventPluginRegistry.possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? EventPluginRegistry.possibleRegistrationNames[lowerCasedName] : null;

                        if (standardName != null) {
                            "development" !== 'production' ? warning(false, 'Unknown DOM property %s. Did you mean %s?%s', name, standardName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                            return true;
                        } else if (registrationName != null) {
                            "development" !== 'production' ? warning(false, 'Unknown event handler property %s. Did you mean `%s`?%s', name, registrationName, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                            return true;
                        } else {
                            // We were unable to guess which prop the user intended.
                            // It is likely that the user was just blindly spreading/forwarding props
                            // Components should be careful to only render valid props/attributes.
                            // Warning will be invoked in warnUnknownProperties to allow grouping.
                            return false;
                        }
                    };
                }

                var warnUnknownProperties = function (debugID, element) {
                    var unknownProps = [];
                    for (var key in element.props) {
                        var isValid = validateProperty(element.type, key, debugID);
                        if (!isValid) {
                            unknownProps.push(key);
                        }
                    }

                    var unknownPropString = unknownProps.map(function (prop) {
                        return '`' + prop + '`';
                    }).join(', ');

                    if (unknownProps.length === 1) {
                        "development" !== 'production' ? warning(false, 'Unknown prop %s on <%s> tag. Remove this prop from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                    } else if (unknownProps.length > 1) {
                        "development" !== 'production' ? warning(false, 'Unknown props %s on <%s> tag. Remove these props from the element. ' + 'For details, see https://fb.me/react-unknown-prop%s', unknownPropString, element.type, ReactComponentTreeHook.getStackAddendumByID(debugID)) : void 0;
                    }
                };

                function handleElement(debugID, element) {
                    if (element == null || typeof element.type !== 'string') {
                        return;
                    }
                    if (element.type.indexOf('-') >= 0 || element.props.is) {
                        return;
                    }
                    warnUnknownProperties(debugID, element);
                }

                var ReactDOMUnknownPropertyHook = {
                    onBeforeMountComponent: function (debugID, element) {
                        handleElement(debugID, element);
                    },
                    onBeforeUpdateComponent: function (debugID, element) {
                        handleElement(debugID, element);
                    }
                };

                module.exports = ReactDOMUnknownPropertyHook;
            }, { "11": 11, "133": 133, "159": 159, "18": 18 }], 50: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var ReactInvalidSetStateWarningHook = _dereq_(65);
                var ReactHostOperationHistoryHook = _dereq_(60);
                var ReactComponentTreeHook = _dereq_(133);
                var ExecutionEnvironment = _dereq_(138);

                var performanceNow = _dereq_(157);
                var warning = _dereq_(159);

                var hooks = [];
                var didHookThrowForEvent = {};

                function callHook(event, fn, context, arg1, arg2, arg3, arg4, arg5) {
                    try {
                        fn.call(context, arg1, arg2, arg3, arg4, arg5);
                    } catch (e) {
                        "development" !== 'production' ? warning(didHookThrowForEvent[event], 'Exception thrown by hook while handling %s: %s', event, e + '\n' + e.stack) : void 0;
                        didHookThrowForEvent[event] = true;
                    }
                }

                function emitEvent(event, arg1, arg2, arg3, arg4, arg5) {
                    for (var i = 0; i < hooks.length; i++) {
                        var hook = hooks[i];
                        var fn = hook[event];
                        if (fn) {
                            callHook(event, fn, hook, arg1, arg2, arg3, arg4, arg5);
                        }
                    }
                }

                var isProfiling = false;
                var flushHistory = [];
                var lifeCycleTimerStack = [];
                var currentFlushNesting = 0;
                var currentFlushMeasurements = [];
                var currentFlushStartTime = 0;
                var currentTimerDebugID = null;
                var currentTimerStartTime = 0;
                var currentTimerNestedFlushDuration = 0;
                var currentTimerType = null;

                var lifeCycleTimerHasWarned = false;

                function clearHistory() {
                    ReactComponentTreeHook.purgeUnmountedComponents();
                    ReactHostOperationHistoryHook.clearHistory();
                }

                function getTreeSnapshot(registeredIDs) {
                    return registeredIDs.reduce(function (tree, id) {
                        var ownerID = ReactComponentTreeHook.getOwnerID(id);
                        var parentID = ReactComponentTreeHook.getParentID(id);
                        tree[id] = {
                            displayName: ReactComponentTreeHook.getDisplayName(id),
                            text: ReactComponentTreeHook.getText(id),
                            updateCount: ReactComponentTreeHook.getUpdateCount(id),
                            childIDs: ReactComponentTreeHook.getChildIDs(id),
                            // Text nodes don't have owners but this is close enough.
                            ownerID: ownerID || parentID && ReactComponentTreeHook.getOwnerID(parentID) || 0,
                            parentID: parentID
                        };
                        return tree;
                    }, {});
                }

                function resetMeasurements() {
                    var previousStartTime = currentFlushStartTime;
                    var previousMeasurements = currentFlushMeasurements;
                    var previousOperations = ReactHostOperationHistoryHook.getHistory();

                    if (currentFlushNesting === 0) {
                        currentFlushStartTime = 0;
                        currentFlushMeasurements = [];
                        clearHistory();
                        return;
                    }

                    if (previousMeasurements.length || previousOperations.length) {
                        var registeredIDs = ReactComponentTreeHook.getRegisteredIDs();
                        flushHistory.push({
                            duration: performanceNow() - previousStartTime,
                            measurements: previousMeasurements || [],
                            operations: previousOperations || [],
                            treeSnapshot: getTreeSnapshot(registeredIDs)
                        });
                    }

                    clearHistory();
                    currentFlushStartTime = performanceNow();
                    currentFlushMeasurements = [];
                }

                function checkDebugID(debugID) {
                    var allowRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (allowRoot && debugID === 0) {
                        return;
                    }
                    if (!debugID) {
                        "development" !== 'production' ? warning(false, 'ReactDebugTool: debugID may not be empty.') : void 0;
                    }
                }

                function beginLifeCycleTimer(debugID, timerType) {
                    if (currentFlushNesting === 0) {
                        return;
                    }
                    if (currentTimerType && !lifeCycleTimerHasWarned) {
                        "development" !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'Did not expect %s timer to start while %s timer is still in ' + 'progress for %s instance.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
                        lifeCycleTimerHasWarned = true;
                    }
                    currentTimerStartTime = performanceNow();
                    currentTimerNestedFlushDuration = 0;
                    currentTimerDebugID = debugID;
                    currentTimerType = timerType;
                }

                function endLifeCycleTimer(debugID, timerType) {
                    if (currentFlushNesting === 0) {
                        return;
                    }
                    if (currentTimerType !== timerType && !lifeCycleTimerHasWarned) {
                        "development" !== 'production' ? warning(false, 'There is an internal error in the React performance measurement code. ' + 'We did not expect %s timer to stop while %s timer is still in ' + 'progress for %s instance. Please report this as a bug in React.', timerType, currentTimerType || 'no', debugID === currentTimerDebugID ? 'the same' : 'another') : void 0;
                        lifeCycleTimerHasWarned = true;
                    }
                    if (isProfiling) {
                        currentFlushMeasurements.push({
                            timerType: timerType,
                            instanceID: debugID,
                            duration: performanceNow() - currentTimerStartTime - currentTimerNestedFlushDuration
                        });
                    }
                    currentTimerStartTime = 0;
                    currentTimerNestedFlushDuration = 0;
                    currentTimerDebugID = null;
                    currentTimerType = null;
                }

                function pauseCurrentLifeCycleTimer() {
                    var currentTimer = {
                        startTime: currentTimerStartTime,
                        nestedFlushStartTime: performanceNow(),
                        debugID: currentTimerDebugID,
                        timerType: currentTimerType
                    };
                    lifeCycleTimerStack.push(currentTimer);
                    currentTimerStartTime = 0;
                    currentTimerNestedFlushDuration = 0;
                    currentTimerDebugID = null;
                    currentTimerType = null;
                }

                function resumeCurrentLifeCycleTimer() {
                    var _lifeCycleTimerStack$ = lifeCycleTimerStack.pop(),
                        startTime = _lifeCycleTimerStack$.startTime,
                        nestedFlushStartTime = _lifeCycleTimerStack$.nestedFlushStartTime,
                        debugID = _lifeCycleTimerStack$.debugID,
                        timerType = _lifeCycleTimerStack$.timerType;

                    var nestedFlushDuration = performanceNow() - nestedFlushStartTime;
                    currentTimerStartTime = startTime;
                    currentTimerNestedFlushDuration += nestedFlushDuration;
                    currentTimerDebugID = debugID;
                    currentTimerType = timerType;
                }

                var lastMarkTimeStamp = 0;
                var canUsePerformanceMeasure = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function';

                function shouldMark(debugID) {
                    if (!isProfiling || !canUsePerformanceMeasure) {
                        return false;
                    }
                    var element = ReactComponentTreeHook.getElement(debugID);
                    if (element == null || typeof element !== 'object') {
                        return false;
                    }
                    var isHostElement = typeof element.type === 'string';
                    if (isHostElement) {
                        return false;
                    }
                    return true;
                }

                function markBegin(debugID, markType) {
                    if (!shouldMark(debugID)) {
                        return;
                    }

                    var markName = debugID + '::' + markType;
                    lastMarkTimeStamp = performanceNow();
                    performance.mark(markName);
                }

                function markEnd(debugID, markType) {
                    if (!shouldMark(debugID)) {
                        return;
                    }

                    var markName = debugID + '::' + markType;
                    var displayName = ReactComponentTreeHook.getDisplayName(debugID) || 'Unknown';

                    // Chrome has an issue of dropping markers recorded too fast:
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=640652
                    // To work around this, we will not report very small measurements.
                    // I determined the magic number by tweaking it back and forth.
                    // 0.05ms was enough to prevent the issue, but I set it to 0.1ms to be safe.
                    // When the bug is fixed, we can `measure()` unconditionally if we want to.
                    var timeStamp = performanceNow();
                    if (timeStamp - lastMarkTimeStamp > 0.1) {
                        var measurementName = displayName + ' [' + markType + ']';
                        performance.measure(measurementName, markName);
                    }

                    performance.clearMarks(markName);
                    if (measurementName) {
                        performance.clearMeasures(measurementName);
                    }
                }

                var ReactDebugTool = {
                    addHook: function (hook) {
                        hooks.push(hook);
                    },
                    removeHook: function (hook) {
                        for (var i = 0; i < hooks.length; i++) {
                            if (hooks[i] === hook) {
                                hooks.splice(i, 1);
                                i--;
                            }
                        }
                    },
                    isProfiling: function () {
                        return isProfiling;
                    },
                    beginProfiling: function () {
                        if (isProfiling) {
                            return;
                        }

                        isProfiling = true;
                        flushHistory.length = 0;
                        resetMeasurements();
                        ReactDebugTool.addHook(ReactHostOperationHistoryHook);
                    },
                    endProfiling: function () {
                        if (!isProfiling) {
                            return;
                        }

                        isProfiling = false;
                        resetMeasurements();
                        ReactDebugTool.removeHook(ReactHostOperationHistoryHook);
                    },
                    getFlushHistory: function () {
                        return flushHistory;
                    },
                    onBeginFlush: function () {
                        currentFlushNesting++;
                        resetMeasurements();
                        pauseCurrentLifeCycleTimer();
                        emitEvent('onBeginFlush');
                    },
                    onEndFlush: function () {
                        resetMeasurements();
                        currentFlushNesting--;
                        resumeCurrentLifeCycleTimer();
                        emitEvent('onEndFlush');
                    },
                    onBeginLifeCycleTimer: function (debugID, timerType) {
                        checkDebugID(debugID);
                        emitEvent('onBeginLifeCycleTimer', debugID, timerType);
                        markBegin(debugID, timerType);
                        beginLifeCycleTimer(debugID, timerType);
                    },
                    onEndLifeCycleTimer: function (debugID, timerType) {
                        checkDebugID(debugID);
                        endLifeCycleTimer(debugID, timerType);
                        markEnd(debugID, timerType);
                        emitEvent('onEndLifeCycleTimer', debugID, timerType);
                    },
                    onBeginProcessingChildContext: function () {
                        emitEvent('onBeginProcessingChildContext');
                    },
                    onEndProcessingChildContext: function () {
                        emitEvent('onEndProcessingChildContext');
                    },
                    onHostOperation: function (operation) {
                        checkDebugID(operation.instanceID);
                        emitEvent('onHostOperation', operation);
                    },
                    onSetState: function () {
                        emitEvent('onSetState');
                    },
                    onSetChildren: function (debugID, childDebugIDs) {
                        checkDebugID(debugID);
                        childDebugIDs.forEach(checkDebugID);
                        emitEvent('onSetChildren', debugID, childDebugIDs);
                    },
                    onBeforeMountComponent: function (debugID, element, parentDebugID) {
                        checkDebugID(debugID);
                        checkDebugID(parentDebugID, true);
                        emitEvent('onBeforeMountComponent', debugID, element, parentDebugID);
                        markBegin(debugID, 'mount');
                    },
                    onMountComponent: function (debugID) {
                        checkDebugID(debugID);
                        markEnd(debugID, 'mount');
                        emitEvent('onMountComponent', debugID);
                    },
                    onBeforeUpdateComponent: function (debugID, element) {
                        checkDebugID(debugID);
                        emitEvent('onBeforeUpdateComponent', debugID, element);
                        markBegin(debugID, 'update');
                    },
                    onUpdateComponent: function (debugID) {
                        checkDebugID(debugID);
                        markEnd(debugID, 'update');
                        emitEvent('onUpdateComponent', debugID);
                    },
                    onBeforeUnmountComponent: function (debugID) {
                        checkDebugID(debugID);
                        emitEvent('onBeforeUnmountComponent', debugID);
                        markBegin(debugID, 'unmount');
                    },
                    onUnmountComponent: function (debugID) {
                        checkDebugID(debugID);
                        markEnd(debugID, 'unmount');
                        emitEvent('onUnmountComponent', debugID);
                    },
                    onTestEvent: function () {
                        emitEvent('onTestEvent');
                    }
                };

                // TODO remove these when RN/www gets updated
                ReactDebugTool.addDevtool = ReactDebugTool.addHook;
                ReactDebugTool.removeDevtool = ReactDebugTool.removeHook;

                ReactDebugTool.addHook(ReactInvalidSetStateWarningHook);
                ReactDebugTool.addHook(ReactComponentTreeHook);
                var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
                if (/[?&]react_perf\b/.test(url)) {
                    ReactDebugTool.beginProfiling();
                }

                module.exports = ReactDebugTool;
            }, { "133": 133, "138": 138, "157": 157, "159": 159, "60": 60, "65": 65 }], 51: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var ReactUpdates = _dereq_(82);
                var Transaction = _dereq_(100);

                var emptyFunction = _dereq_(144);

                var RESET_BATCHED_UPDATES = {
                    initialize: emptyFunction,
                    close: function () {
                        ReactDefaultBatchingStrategy.isBatchingUpdates = false;
                    }
                };

                var FLUSH_BATCHED_UPDATES = {
                    initialize: emptyFunction,
                    close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
                };

                var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

                function ReactDefaultBatchingStrategyTransaction() {
                    this.reinitializeTransaction();
                }

                _assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    }
                });

                var transaction = new ReactDefaultBatchingStrategyTransaction();

                var ReactDefaultBatchingStrategy = {
                    isBatchingUpdates: false,

                    /**
                     * Call the provided function in a context within which calls to `setState`
                     * and friends are batched such that components aren't updated unnecessarily.
                     */
                    batchedUpdates: function (callback, a, b, c, d, e) {
                        var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

                        ReactDefaultBatchingStrategy.isBatchingUpdates = true;

                        // The code is written this way to avoid extra allocations
                        if (alreadyBatchingUpdates) {
                            return callback(a, b, c, d, e);
                        } else {
                            return transaction.perform(callback, null, a, b, c, d, e);
                        }
                    }
                };

                module.exports = ReactDefaultBatchingStrategy;
            }, { "100": 100, "144": 144, "160": 160, "82": 82 }], 52: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ARIADOMPropertyConfig = _dereq_(1);
                var BeforeInputEventPlugin = _dereq_(3);
                var ChangeEventPlugin = _dereq_(7);
                var DefaultEventPluginOrder = _dereq_(14);
                var EnterLeaveEventPlugin = _dereq_(15);
                var HTMLDOMPropertyConfig = _dereq_(22);
                var ReactComponentBrowserEnvironment = _dereq_(28);
                var ReactDOMComponent = _dereq_(32);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactDOMEmptyComponent = _dereq_(36);
                var ReactDOMTreeTraversal = _dereq_(47);
                var ReactDOMTextComponent = _dereq_(45);
                var ReactDefaultBatchingStrategy = _dereq_(51);
                var ReactEventListener = _dereq_(57);
                var ReactInjection = _dereq_(61);
                var ReactReconcileTransaction = _dereq_(74);
                var SVGDOMPropertyConfig = _dereq_(84);
                var SelectEventPlugin = _dereq_(85);
                var SimpleEventPlugin = _dereq_(86);

                var alreadyInjected = false;

                function inject() {
                    if (alreadyInjected) {
                        // TODO: This is currently true because these injections are shared between
                        // the client and the server package. They should be built independently
                        // and not share any injection state. Then this problem will be solved.
                        return;
                    }
                    alreadyInjected = true;

                    ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

                    /**
                     * Inject modules for resolving DOM hierarchy and plugin ordering.
                     */
                    ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
                    ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
                    ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

                    /**
                     * Some important event plugins included by default (without having to require
                     * them).
                     */
                    ReactInjection.EventPluginHub.injectEventPluginsByName({
                        SimpleEventPlugin: SimpleEventPlugin,
                        EnterLeaveEventPlugin: EnterLeaveEventPlugin,
                        ChangeEventPlugin: ChangeEventPlugin,
                        SelectEventPlugin: SelectEventPlugin,
                        BeforeInputEventPlugin: BeforeInputEventPlugin
                    });

                    ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

                    ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

                    ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
                    ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
                    ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

                    ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
                        return new ReactDOMEmptyComponent(instantiate);
                    });

                    ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
                    ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

                    ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
                }

                module.exports = {
                    inject: inject
                };
            }, { "1": 1, "14": 14, "15": 15, "22": 22, "28": 28, "3": 3, "32": 32, "34": 34, "36": 36, "45": 45, "47": 47, "51": 51, "57": 57, "61": 61, "7": 7, "74": 74, "84": 84, "85": 85, "86": 86 }], 53: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                // The Symbol used to tag the ReactElement type. If there is no native Symbol
                // nor polyfill, then a plain number is used for performance.

                var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

                module.exports = REACT_ELEMENT_TYPE;
            }, {}], 54: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var emptyComponentFactory;

                var ReactEmptyComponentInjection = {
                    injectEmptyComponentFactory: function (factory) {
                        emptyComponentFactory = factory;
                    }
                };

                var ReactEmptyComponent = {
                    create: function (instantiate) {
                        return emptyComponentFactory(instantiate);
                    }
                };

                ReactEmptyComponent.injection = ReactEmptyComponentInjection;

                module.exports = ReactEmptyComponent;
            }, {}], 55: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var caughtError = null;

                /**
                 * Call a function while guarding against errors that happens within it.
                 *
                 * @param {String} name of the guard to use for logging or debugging
                 * @param {Function} func The function to invoke
                 * @param {*} a First argument
                 * @param {*} b Second argument
                 */
                function invokeGuardedCallback(name, func, a) {
                    try {
                        func(a);
                    } catch (x) {
                        if (caughtError === null) {
                            caughtError = x;
                        }
                    }
                }

                var ReactErrorUtils = {
                    invokeGuardedCallback: invokeGuardedCallback,

                    /**
                     * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
                     * handler are sure to be rethrown by rethrowCaughtError.
                     */
                    invokeGuardedCallbackWithCatch: invokeGuardedCallback,

                    /**
                     * During execution of guarded functions we will capture the first error which
                     * we will rethrow to be handled by the top level error handler.
                     */
                    rethrowCaughtError: function () {
                        if (caughtError) {
                            var error = caughtError;
                            caughtError = null;
                            throw error;
                        }
                    }
                };

                if ("development" !== 'production') {
                    /**
                     * To help development we can get better devtools integration by simulating a
                     * real browser event.
                     */
                    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
                        var fakeNode = document.createElement('react');
                        ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
                            var boundFunc = func.bind(null, a);
                            var evtType = 'react-' + name;
                            fakeNode.addEventListener(evtType, boundFunc, false);
                            var evt = document.createEvent('Event');
                            evt.initEvent(evtType, false, false);
                            fakeNode.dispatchEvent(evt);
                            fakeNode.removeEventListener(evtType, boundFunc, false);
                        };
                    }
                }

                module.exports = ReactErrorUtils;
            }, {}], 56: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var EventPluginHub = _dereq_(17);

                function runEventQueueInBatch(events) {
                    EventPluginHub.enqueueEvents(events);
                    EventPluginHub.processEventQueue(false);
                }

                var ReactEventEmitterMixin = {
                    /**
                     * Streams a fired top-level event to `EventPluginHub` where plugins have the
                     * opportunity to create `ReactEvent`s to be dispatched.
                     */
                    handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
                        runEventQueueInBatch(events);
                    }
                };

                module.exports = ReactEventEmitterMixin;
            }, { "17": 17 }], 57: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var EventListener = _dereq_(137);
                var ExecutionEnvironment = _dereq_(138);
                var PooledClass = _dereq_(25);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactUpdates = _dereq_(82);

                var getEventTarget = _dereq_(114);
                var getUnboundedScrollPosition = _dereq_(149);

                /**
                 * Find the deepest React component completely containing the root of the
                 * passed-in instance (for use when entire React trees are nested within each
                 * other). If React trees are not nested, returns null.
                 */
                function findParent(inst) {
                    // TODO: It may be a good idea to cache this to prevent unnecessary DOM
                    // traversal, but caching is difficult to do correctly without using a
                    // mutation observer to listen for all DOM changes.
                    while (inst._hostParent) {
                        inst = inst._hostParent;
                    }
                    var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
                    var container = rootNode.parentNode;
                    return ReactDOMComponentTree.getClosestInstanceFromNode(container);
                }

                // Used to store ancestor hierarchy in top level callback
                function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
                    this.topLevelType = topLevelType;
                    this.nativeEvent = nativeEvent;
                    this.ancestors = [];
                }
                _assign(TopLevelCallbackBookKeeping.prototype, {
                    destructor: function () {
                        this.topLevelType = null;
                        this.nativeEvent = null;
                        this.ancestors.length = 0;
                    }
                });
                PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

                function handleTopLevelImpl(bookKeeping) {
                    var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
                    var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

                    // Loop through the hierarchy, in case there's any nested components.
                    // It's important that we build the array of ancestors before calling any
                    // event handlers, because event handlers can modify the DOM, leading to
                    // inconsistencies with ReactMount's node cache. See #1105.
                    var ancestor = targetInst;
                    do {
                        bookKeeping.ancestors.push(ancestor);
                        ancestor = ancestor && findParent(ancestor);
                    } while (ancestor);

                    for (var i = 0; i < bookKeeping.ancestors.length; i++) {
                        targetInst = bookKeeping.ancestors[i];
                        ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
                    }
                }

                function scrollValueMonitor(cb) {
                    var scrollPosition = getUnboundedScrollPosition(window);
                    cb(scrollPosition);
                }

                var ReactEventListener = {
                    _enabled: true,
                    _handleTopLevel: null,

                    WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

                    setHandleTopLevel: function (handleTopLevel) {
                        ReactEventListener._handleTopLevel = handleTopLevel;
                    },

                    setEnabled: function (enabled) {
                        ReactEventListener._enabled = !!enabled;
                    },

                    isEnabled: function () {
                        return ReactEventListener._enabled;
                    },

                    /**
                     * Traps top-level events by using event bubbling.
                     *
                     * @param {string} topLevelType Record from `EventConstants`.
                     * @param {string} handlerBaseName Event name (e.g. "click").
                     * @param {object} element Element on which to attach listener.
                     * @return {?object} An object with a remove function which will forcefully
                     *                  remove the listener.
                     * @internal
                     */
                    trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
                        if (!element) {
                            return null;
                        }
                        return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
                    },

                    /**
                     * Traps a top-level event by using event capturing.
                     *
                     * @param {string} topLevelType Record from `EventConstants`.
                     * @param {string} handlerBaseName Event name (e.g. "click").
                     * @param {object} element Element on which to attach listener.
                     * @return {?object} An object with a remove function which will forcefully
                     *                  remove the listener.
                     * @internal
                     */
                    trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
                        if (!element) {
                            return null;
                        }
                        return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
                    },

                    monitorScrollValue: function (refresh) {
                        var callback = scrollValueMonitor.bind(null, refresh);
                        EventListener.listen(window, 'scroll', callback);
                    },

                    dispatchEvent: function (topLevelType, nativeEvent) {
                        if (!ReactEventListener._enabled) {
                            return;
                        }

                        var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
                        try {
                            // Event queue being processed in the same cycle allows
                            // `preventDefault`.
                            ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
                        } finally {
                            TopLevelCallbackBookKeeping.release(bookKeeping);
                        }
                    }
                };

                module.exports = ReactEventListener;
            }, { "114": 114, "137": 137, "138": 138, "149": 149, "160": 160, "25": 25, "34": 34, "82": 82 }], 58: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var ReactFeatureFlags = {
                    // When true, call console.time() before and .timeEnd() after each top-level
                    // render (both initial renders and updates). Useful when looking at prod-mode
                    // timeline profiles in Chrome, for example.
                    logTopLevelRenders: false
                };

                module.exports = ReactFeatureFlags;
            }, {}], 59: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                var genericComponentClass = null;
                var textComponentClass = null;

                var ReactHostComponentInjection = {
                    // This accepts a class that receives the tag string. This is a catch all
                    // that can render any kind of tag.
                    injectGenericComponentClass: function (componentClass) {
                        genericComponentClass = componentClass;
                    },
                    // This accepts a text component class that takes the text string to be
                    // rendered as props.
                    injectTextComponentClass: function (componentClass) {
                        textComponentClass = componentClass;
                    }
                };

                /**
                 * Get a host internal component class for a specific tag.
                 *
                 * @param {ReactElement} element The element to create.
                 * @return {function} The internal class constructor function.
                 */
                function createInternalComponent(element) {
                    !genericComponentClass ? "development" !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
                    return new genericComponentClass(element);
                }

                /**
                 * @param {ReactText} text
                 * @return {ReactComponent}
                 */
                function createInstanceForText(text) {
                    return new textComponentClass(text);
                }

                /**
                 * @param {ReactComponent} component
                 * @return {boolean}
                 */
                function isTextComponent(component) {
                    return component instanceof textComponentClass;
                }

                var ReactHostComponent = {
                    createInternalComponent: createInternalComponent,
                    createInstanceForText: createInstanceForText,
                    isTextComponent: isTextComponent,
                    injection: ReactHostComponentInjection
                };

                module.exports = ReactHostComponent;
            }, { "126": 126, "152": 152 }], 60: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var history = [];

                var ReactHostOperationHistoryHook = {
                    onHostOperation: function (operation) {
                        history.push(operation);
                    },
                    clearHistory: function () {
                        if (ReactHostOperationHistoryHook._preventClearing) {
                            // Should only be used for tests.
                            return;
                        }

                        history = [];
                    },
                    getHistory: function () {
                        return history;
                    }
                };

                module.exports = ReactHostOperationHistoryHook;
            }, {}], 61: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var DOMProperty = _dereq_(11);
                var EventPluginHub = _dereq_(17);
                var EventPluginUtils = _dereq_(19);
                var ReactComponentEnvironment = _dereq_(29);
                var ReactEmptyComponent = _dereq_(54);
                var ReactBrowserEventEmitter = _dereq_(26);
                var ReactHostComponent = _dereq_(59);
                var ReactUpdates = _dereq_(82);

                var ReactInjection = {
                    Component: ReactComponentEnvironment.injection,
                    DOMProperty: DOMProperty.injection,
                    EmptyComponent: ReactEmptyComponent.injection,
                    EventPluginHub: EventPluginHub.injection,
                    EventPluginUtils: EventPluginUtils.injection,
                    EventEmitter: ReactBrowserEventEmitter.injection,
                    HostComponent: ReactHostComponent.injection,
                    Updates: ReactUpdates.injection
                };

                module.exports = ReactInjection;
            }, { "11": 11, "17": 17, "19": 19, "26": 26, "29": 29, "54": 54, "59": 59, "82": 82 }], 62: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactDOMSelection = _dereq_(44);

                var containsNode = _dereq_(141);
                var focusNode = _dereq_(146);
                var getActiveElement = _dereq_(147);

                function isInDocument(node) {
                    return containsNode(document.documentElement, node);
                }

                /**
                 * @ReactInputSelection: React input selection module. Based on Selection.js,
                 * but modified to be suitable for react and has a couple of bug fixes (doesn't
                 * assume buttons have range selections allowed).
                 * Input selection module for React.
                 */
                var ReactInputSelection = {
                    hasSelectionCapabilities: function (elem) {
                        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
                        return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
                    },

                    getSelectionInformation: function () {
                        var focusedElem = getActiveElement();
                        return {
                            focusedElem: focusedElem,
                            selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
                        };
                    },

                    /**
                     * @restoreSelection: If any selection information was potentially lost,
                     * restore it. This is useful when performing operations that could remove dom
                     * nodes and place them back in, resulting in focus being lost.
                     */
                    restoreSelection: function (priorSelectionInformation) {
                        var curFocusedElem = getActiveElement();
                        var priorFocusedElem = priorSelectionInformation.focusedElem;
                        var priorSelectionRange = priorSelectionInformation.selectionRange;
                        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
                            if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
                                ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
                            }
                            focusNode(priorFocusedElem);
                        }
                    },

                    /**
                     * @getSelection: Gets the selection bounds of a focused textarea, input or
                     * contentEditable node.
                     * -@input: Look up selection bounds of this input
                     * -@return {start: selectionStart, end: selectionEnd}
                     */
                    getSelection: function (input) {
                        var selection;

                        if ('selectionStart' in input) {
                            // Modern browser with input or textarea.
                            selection = {
                                start: input.selectionStart,
                                end: input.selectionEnd
                            };
                        } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
                            // IE8 input.
                            var range = document.selection.createRange();
                            // There can only be one selection per document in IE, so it must
                            // be in our element.
                            if (range.parentElement() === input) {
                                selection = {
                                    start: -range.moveStart('character', -input.value.length),
                                    end: -range.moveEnd('character', -input.value.length)
                                };
                            }
                        } else {
                            // Content editable or old IE textarea.
                            selection = ReactDOMSelection.getOffsets(input);
                        }

                        return selection || { start: 0, end: 0 };
                    },

                    /**
                     * @setSelection: Sets the selection bounds of a textarea or input and focuses
                     * the input.
                     * -@input     Set selection bounds of this input or textarea
                     * -@offsets   Object of same form that is returned from get*
                     */
                    setSelection: function (input, offsets) {
                        var start = offsets.start;
                        var end = offsets.end;
                        if (end === undefined) {
                            end = start;
                        }

                        if ('selectionStart' in input) {
                            input.selectionStart = start;
                            input.selectionEnd = Math.min(end, input.value.length);
                        } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
                            var range = input.createTextRange();
                            range.collapse(true);
                            range.moveStart('character', start);
                            range.moveEnd('character', end - start);
                            range.select();
                        } else {
                            ReactDOMSelection.setOffsets(input, offsets);
                        }
                    }
                };

                module.exports = ReactInputSelection;
            }, { "141": 141, "146": 146, "147": 147, "44": 44 }], 63: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * `ReactInstanceMap` maintains a mapping from a public facing stateful
                 * instance (key) and the internal representation (value). This allows public
                 * methods to accept the user facing instance as an argument and map them back
                 * to internal methods.
                 */

                // TODO: Replace this with ES6: var ReactInstanceMap = new Map();

                var ReactInstanceMap = {
                    /**
                     * This API should be called `delete` but we'd have to make sure to always
                     * transform these to strings for IE support. When this transform is fully
                     * supported we can rename it.
                     */
                    remove: function (key) {
                        key._reactInternalInstance = undefined;
                    },

                    get: function (key) {
                        return key._reactInternalInstance;
                    },

                    has: function (key) {
                        return key._reactInternalInstance !== undefined;
                    },

                    set: function (key, value) {
                        key._reactInternalInstance = value;
                    }
                };

                module.exports = ReactInstanceMap;
            }, {}], 64: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                // Trust the developer to only use ReactInstrumentation with a __DEV__ check

                var debugTool = null;

                if ("development" !== 'production') {
                    var ReactDebugTool = _dereq_(50);
                    debugTool = ReactDebugTool;
                }

                module.exports = { debugTool: debugTool };
            }, { "50": 50 }], 65: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var warning = _dereq_(159);

                if ("development" !== 'production') {
                    var processingChildContext = false;

                    var warnInvalidSetState = function () {
                        "development" !== 'production' ? warning(!processingChildContext, 'setState(...): Cannot call setState() inside getChildContext()') : void 0;
                    };
                }

                var ReactInvalidSetStateWarningHook = {
                    onBeginProcessingChildContext: function () {
                        processingChildContext = true;
                    },
                    onEndProcessingChildContext: function () {
                        processingChildContext = false;
                    },
                    onSetState: function () {
                        warnInvalidSetState();
                    }
                };

                module.exports = ReactInvalidSetStateWarningHook;
            }, { "159": 159 }], 66: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var adler32 = _dereq_(103);

                var TAG_END = /\/?>/;
                var COMMENT_START = /^<\!\-\-/;

                var ReactMarkupChecksum = {
                    CHECKSUM_ATTR_NAME: 'data-react-checksum',

                    /**
                     * @param {string} markup Markup string
                     * @return {string} Markup string with checksum attribute attached
                     */
                    addChecksumToMarkup: function (markup) {
                        var checksum = adler32(markup);

                        // Add checksum (handle both parent tags, comments and self-closing tags)
                        if (COMMENT_START.test(markup)) {
                            return markup;
                        } else {
                            return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
                        }
                    },

                    /**
                     * @param {string} markup to use
                     * @param {DOMElement} element root React element
                     * @returns {boolean} whether or not the markup is the same
                     */
                    canReuseMarkup: function (markup, element) {
                        var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
                        existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
                        var markupChecksum = adler32(markup);
                        return markupChecksum === existingChecksum;
                    }
                };

                module.exports = ReactMarkupChecksum;
            }, { "103": 103 }], 67: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var DOMLazyTree = _dereq_(9);
                var DOMProperty = _dereq_(11);
                var React = _dereq_(135);
                var ReactBrowserEventEmitter = _dereq_(26);
                var ReactCurrentOwner = _dereq_(134);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactDOMContainerInfo = _dereq_(35);
                var ReactDOMFeatureFlags = _dereq_(37);
                var ReactFeatureFlags = _dereq_(58);
                var ReactInstanceMap = _dereq_(63);
                var ReactInstrumentation = _dereq_(64);
                var ReactMarkupChecksum = _dereq_(66);
                var ReactReconciler = _dereq_(75);
                var ReactUpdateQueue = _dereq_(81);
                var ReactUpdates = _dereq_(82);

                var emptyObject = _dereq_(145);
                var instantiateReactComponent = _dereq_(121);
                var invariant = _dereq_(152);
                var setInnerHTML = _dereq_(128);
                var shouldUpdateReactComponent = _dereq_(130);
                var warning = _dereq_(159);

                var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
                var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

                var ELEMENT_NODE_TYPE = 1;
                var DOC_NODE_TYPE = 9;
                var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

                var instancesByReactRootID = {};

                /**
                 * Finds the index of the first character
                 * that's not common between the two given strings.
                 *
                 * @return {number} the index of the character where the strings diverge
                 */
                function firstDifferenceIndex(string1, string2) {
                    var minLen = Math.min(string1.length, string2.length);
                    for (var i = 0; i < minLen; i++) {
                        if (string1.charAt(i) !== string2.charAt(i)) {
                            return i;
                        }
                    }
                    return string1.length === string2.length ? -1 : minLen;
                }

                /**
                 * @param {DOMElement|DOMDocument} container DOM element that may contain
                 * a React component
                 * @return {?*} DOM element that may have the reactRoot ID, or null.
                 */
                function getReactRootElementInContainer(container) {
                    if (!container) {
                        return null;
                    }

                    if (container.nodeType === DOC_NODE_TYPE) {
                        return container.documentElement;
                    } else {
                        return container.firstChild;
                    }
                }

                function internalGetID(node) {
                    // If node is something like a window, document, or text node, none of
                    // which support attributes or a .getAttribute method, gracefully return
                    // the empty string, as if the attribute were missing.
                    return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
                }

                /**
                 * Mounts this component and inserts it into the DOM.
                 *
                 * @param {ReactComponent} componentInstance The instance to mount.
                 * @param {DOMElement} container DOM element to mount into.
                 * @param {ReactReconcileTransaction} transaction
                 * @param {boolean} shouldReuseMarkup If true, do not insert markup
                 */
                function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
                    var markerName;
                    if (ReactFeatureFlags.logTopLevelRenders) {
                        var wrappedElement = wrapperInstance._currentElement.props.child;
                        var type = wrappedElement.type;
                        markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
                        console.time(markerName);
                    }

                    var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
                    );

                    if (markerName) {
                        console.timeEnd(markerName);
                    }

                    wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
                    ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
                }

                /**
                 * Batched mount.
                 *
                 * @param {ReactComponent} componentInstance The instance to mount.
                 * @param {DOMElement} container DOM element to mount into.
                 * @param {boolean} shouldReuseMarkup If true, do not insert markup
                 */
                function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
                    var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
                        /* useCreateElement */
                        !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
                    transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
                    ReactUpdates.ReactReconcileTransaction.release(transaction);
                }

                /**
                 * Unmounts a component and removes it from the DOM.
                 *
                 * @param {ReactComponent} instance React component instance.
                 * @param {DOMElement} container DOM element to unmount from.
                 * @final
                 * @internal
                 * @see {ReactMount.unmountComponentAtNode}
                 */
                function unmountComponentFromNode(instance, container, safely) {
                    if ("development" !== 'production') {
                        ReactInstrumentation.debugTool.onBeginFlush();
                    }
                    ReactReconciler.unmountComponent(instance, safely);
                    if ("development" !== 'production') {
                        ReactInstrumentation.debugTool.onEndFlush();
                    }

                    if (container.nodeType === DOC_NODE_TYPE) {
                        container = container.documentElement;
                    }

                    // http://jsperf.com/emptying-a-node
                    while (container.lastChild) {
                        container.removeChild(container.lastChild);
                    }
                }

                /**
                 * True if the supplied DOM node has a direct React-rendered child that is
                 * not a React root element. Useful for warning in `render`,
                 * `unmountComponentAtNode`, etc.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM element contains a direct child that was
                 * rendered by React but is not a root element.
                 * @internal
                 */
                function hasNonRootReactChild(container) {
                    var rootEl = getReactRootElementInContainer(container);
                    if (rootEl) {
                        var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
                        return !!(inst && inst._hostParent);
                    }
                }

                /**
                 * True if the supplied DOM node is a React DOM element and
                 * it has been rendered by another copy of React.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM has been rendered by another copy of React
                 * @internal
                 */
                function nodeIsRenderedByOtherInstance(container) {
                    var rootEl = getReactRootElementInContainer(container);
                    return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
                }

                /**
                 * True if the supplied DOM node is a valid node element.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM is a valid DOM node.
                 * @internal
                 */
                function isValidContainer(node) {
                    return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
                }

                /**
                 * True if the supplied DOM node is a valid React node element.
                 *
                 * @param {?DOMElement} node The candidate DOM node.
                 * @return {boolean} True if the DOM is a valid React DOM node.
                 * @internal
                 */
                function isReactNode(node) {
                    return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
                }

                function getHostRootInstanceInContainer(container) {
                    var rootEl = getReactRootElementInContainer(container);
                    var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
                    return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
                }

                function getTopLevelWrapperInContainer(container) {
                    var root = getHostRootInstanceInContainer(container);
                    return root ? root._hostContainerInfo._topLevelWrapper : null;
                }

                /**
                 * Temporary (?) hack so that we can store all top-level pending updates on
                 * composites instead of having to worry about different types of components
                 * here.
                 */
                var topLevelRootCounter = 1;
                var TopLevelWrapper = function () {
                    this.rootID = topLevelRootCounter++;
                };
                TopLevelWrapper.prototype.isReactComponent = {};
                if ("development" !== 'production') {
                    TopLevelWrapper.displayName = 'TopLevelWrapper';
                }
                TopLevelWrapper.prototype.render = function () {
                    return this.props.child;
                };
                TopLevelWrapper.isReactTopLevelWrapper = true;

                /**
                 * Mounting is the process of initializing a React component by creating its
                 * representative DOM elements and inserting them into a supplied `container`.
                 * Any prior content inside `container` is destroyed in the process.
                 *
                 *   ReactMount.render(
                 *     component,
                 *     document.getElementById('container')
                 *   );
                 *
                 *   <div id="container">                   <-- Supplied `container`.
                 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
                 *       // ...                                 component.
                 *     </div>
                 *   </div>
                 *
                 * Inside of `container`, the first element rendered is the "reactRoot".
                 */
                var ReactMount = {
                    TopLevelWrapper: TopLevelWrapper,

                    /**
                     * Used by devtools. The keys are not important.
                     */
                    _instancesByReactRootID: instancesByReactRootID,

                    /**
                     * This is a hook provided to support rendering React components while
                     * ensuring that the apparent scroll position of its `container` does not
                     * change.
                     *
                     * @param {DOMElement} container The `container` being rendered into.
                     * @param {function} renderCallback This must be called once to do the render.
                     */
                    scrollMonitor: function (container, renderCallback) {
                        renderCallback();
                    },

                    /**
                     * Take a component that's already mounted into the DOM and replace its props
                     * @param {ReactComponent} prevComponent component instance already in the DOM
                     * @param {ReactElement} nextElement component instance to render
                     * @param {DOMElement} container container to render into
                     * @param {?function} callback function triggered on completion
                     */
                    _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
                        ReactMount.scrollMonitor(container, function () {
                            ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
                            if (callback) {
                                ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
                            }
                        });

                        return prevComponent;
                    },

                    /**
                     * Render a new component into the DOM. Hooked by hooks!
                     *
                     * @param {ReactElement} nextElement element to render
                     * @param {DOMElement} container container to render into
                     * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
                     * @return {ReactComponent} nextComponent
                     */
                    _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
                        // Various parts of our code (such as ReactCompositeComponent's
                        // _renderValidatedComponent) assume that calls to render aren't nested;
                        // verify that that's the case.
                        "development" !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

                        !isValidContainer(container) ? "development" !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

                        ReactBrowserEventEmitter.ensureScrollValueMonitoring();
                        var componentInstance = instantiateReactComponent(nextElement, false);

                        // The initial render is synchronous but any updates that happen during
                        // rendering, in componentWillMount or componentDidMount, will be batched
                        // according to the current batching strategy.

                        ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

                        var wrapperID = componentInstance._instance.rootID;
                        instancesByReactRootID[wrapperID] = componentInstance;

                        return componentInstance;
                    },

                    /**
                     * Renders a React component into the DOM in the supplied `container`.
                     *
                     * If the React component was previously rendered into `container`, this will
                     * perform an update on it and only mutate the DOM as necessary to reflect the
                     * latest React component.
                     *
                     * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
                     * @param {ReactElement} nextElement Component element to render.
                     * @param {DOMElement} container DOM element to render into.
                     * @param {?function} callback function triggered on completion
                     * @return {ReactComponent} Component instance rendered in `container`.
                     */
                    renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
                        !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ? "development" !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
                        return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
                    },

                    _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
                        ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
                        !React.isValidElement(nextElement) ? "development" !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
                            nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

                        "development" !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

                        var nextWrappedElement = React.createElement(TopLevelWrapper, {
                            child: nextElement
                        });

                        var nextContext;
                        if (parentComponent) {
                            var parentInst = ReactInstanceMap.get(parentComponent);
                            nextContext = parentInst._processChildContext(parentInst._context);
                        } else {
                            nextContext = emptyObject;
                        }

                        var prevComponent = getTopLevelWrapperInContainer(container);

                        if (prevComponent) {
                            var prevWrappedElement = prevComponent._currentElement;
                            var prevElement = prevWrappedElement.props.child;
                            if (shouldUpdateReactComponent(prevElement, nextElement)) {
                                var publicInst = prevComponent._renderedComponent.getPublicInstance();
                                var updatedCallback = callback && function () {
                                    callback.call(publicInst);
                                };
                                ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
                                return publicInst;
                            } else {
                                ReactMount.unmountComponentAtNode(container);
                            }
                        }

                        var reactRootElement = getReactRootElementInContainer(container);
                        var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
                        var containerHasNonRootReactChild = hasNonRootReactChild(container);

                        if ("development" !== 'production') {
                            "development" !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

                            if (!containerHasReactMarkup || reactRootElement.nextSibling) {
                                var rootElementSibling = reactRootElement;
                                while (rootElementSibling) {
                                    if (internalGetID(rootElementSibling)) {
                                        "development" !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
                                        break;
                                    }
                                    rootElementSibling = rootElementSibling.nextSibling;
                                }
                            }
                        }

                        var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
                        var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
                        if (callback) {
                            callback.call(component);
                        }
                        return component;
                    },

                    /**
                     * Renders a React component into the DOM in the supplied `container`.
                     * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
                     *
                     * If the React component was previously rendered into `container`, this will
                     * perform an update on it and only mutate the DOM as necessary to reflect the
                     * latest React component.
                     *
                     * @param {ReactElement} nextElement Component element to render.
                     * @param {DOMElement} container DOM element to render into.
                     * @param {?function} callback function triggered on completion
                     * @return {ReactComponent} Component instance rendered in `container`.
                     */
                    render: function (nextElement, container, callback) {
                        return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
                    },

                    /**
                     * Unmounts and destroys the React component rendered in the `container`.
                     * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
                     *
                     * @param {DOMElement} container DOM element containing a React component.
                     * @return {boolean} True if a component was found in and unmounted from
                     *                   `container`
                     */
                    unmountComponentAtNode: function (container) {
                        // Various parts of our code (such as ReactCompositeComponent's
                        // _renderValidatedComponent) assume that calls to render aren't nested;
                        // verify that that's the case. (Strictly speaking, unmounting won't cause a
                        // render but we still don't expect to be in a render call here.)
                        "development" !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

                        !isValidContainer(container) ? "development" !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

                        if ("development" !== 'production') {
                            "development" !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
                        }

                        var prevComponent = getTopLevelWrapperInContainer(container);
                        if (!prevComponent) {
                            // Check if the node being unmounted was rendered by React, but isn't a
                            // root node.
                            var containerHasNonRootReactChild = hasNonRootReactChild(container);

                            // Check if the container itself is a React root node.
                            var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

                            if ("development" !== 'production') {
                                "development" !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
                            }

                            return false;
                        }
                        delete instancesByReactRootID[prevComponent._instance.rootID];
                        ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
                        return true;
                    },

                    _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
                        !isValidContainer(container) ? "development" !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

                        if (shouldReuseMarkup) {
                            var rootElement = getReactRootElementInContainer(container);
                            if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
                                ReactDOMComponentTree.precacheNode(instance, rootElement);
                                return;
                            } else {
                                var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
                                rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

                                var rootMarkup = rootElement.outerHTML;
                                rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

                                var normalizedMarkup = markup;
                                if ("development" !== 'production') {
                                    // because rootMarkup is retrieved from the DOM, various normalizations
                                    // will have occurred which will not be present in `markup`. Here,
                                    // insert markup into a <div> or <iframe> depending on the container
                                    // type to perform the same normalizations before comparing.
                                    var normalizer;
                                    if (container.nodeType === ELEMENT_NODE_TYPE) {
                                        normalizer = document.createElement('div');
                                        normalizer.innerHTML = markup;
                                        normalizedMarkup = normalizer.innerHTML;
                                    } else {
                                        normalizer = document.createElement('iframe');
                                        document.body.appendChild(normalizer);
                                        normalizer.contentDocument.write(markup);
                                        normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
                                        document.body.removeChild(normalizer);
                                    }
                                }

                                var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
                                var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

                                !(container.nodeType !== DOC_NODE_TYPE) ? "development" !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

                                if ("development" !== 'production') {
                                    "development" !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
                                }
                            }
                        }

                        !(container.nodeType !== DOC_NODE_TYPE) ? "development" !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

                        if (transaction.useCreateElement) {
                            while (container.lastChild) {
                                container.removeChild(container.lastChild);
                            }
                            DOMLazyTree.insertTreeBefore(container, markup, null);
                        } else {
                            setInnerHTML(container, markup);
                            ReactDOMComponentTree.precacheNode(instance, container.firstChild);
                        }

                        if ("development" !== 'production') {
                            var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
                            if (hostNode._debugID !== 0) {
                                ReactInstrumentation.debugTool.onHostOperation({
                                    instanceID: hostNode._debugID,
                                    type: 'mount',
                                    payload: markup.toString()
                                });
                            }
                        }
                    }
                };

                module.exports = ReactMount;
            }, { "11": 11, "121": 121, "126": 126, "128": 128, "130": 130, "134": 134, "135": 135, "145": 145, "152": 152, "159": 159, "26": 26, "34": 34, "35": 35, "37": 37, "58": 58, "63": 63, "64": 64, "66": 66, "75": 75, "81": 81, "82": 82, "9": 9 }], 68: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var ReactComponentEnvironment = _dereq_(29);
                var ReactInstanceMap = _dereq_(63);
                var ReactInstrumentation = _dereq_(64);

                var ReactCurrentOwner = _dereq_(134);
                var ReactReconciler = _dereq_(75);
                var ReactChildReconciler = _dereq_(27);

                var emptyFunction = _dereq_(144);
                var flattenChildren = _dereq_(109);
                var invariant = _dereq_(152);

                /**
                 * Make an update for markup to be rendered and inserted at a supplied index.
                 *
                 * @param {string} markup Markup that renders into an element.
                 * @param {number} toIndex Destination index.
                 * @private
                 */
                function makeInsertMarkup(markup, afterNode, toIndex) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: 'INSERT_MARKUP',
                        content: markup,
                        fromIndex: null,
                        fromNode: null,
                        toIndex: toIndex,
                        afterNode: afterNode
                    };
                }

                /**
                 * Make an update for moving an existing element to another index.
                 *
                 * @param {number} fromIndex Source index of the existing element.
                 * @param {number} toIndex Destination index of the element.
                 * @private
                 */
                function makeMove(child, afterNode, toIndex) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: 'MOVE_EXISTING',
                        content: null,
                        fromIndex: child._mountIndex,
                        fromNode: ReactReconciler.getHostNode(child),
                        toIndex: toIndex,
                        afterNode: afterNode
                    };
                }

                /**
                 * Make an update for removing an element at an index.
                 *
                 * @param {number} fromIndex Index of the element to remove.
                 * @private
                 */
                function makeRemove(child, node) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: 'REMOVE_NODE',
                        content: null,
                        fromIndex: child._mountIndex,
                        fromNode: node,
                        toIndex: null,
                        afterNode: null
                    };
                }

                /**
                 * Make an update for setting the markup of a node.
                 *
                 * @param {string} markup Markup that renders into an element.
                 * @private
                 */
                function makeSetMarkup(markup) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: 'SET_MARKUP',
                        content: markup,
                        fromIndex: null,
                        fromNode: null,
                        toIndex: null,
                        afterNode: null
                    };
                }

                /**
                 * Make an update for setting the text content.
                 *
                 * @param {string} textContent Text content to set.
                 * @private
                 */
                function makeTextContent(textContent) {
                    // NOTE: Null values reduce hidden classes.
                    return {
                        type: 'TEXT_CONTENT',
                        content: textContent,
                        fromIndex: null,
                        fromNode: null,
                        toIndex: null,
                        afterNode: null
                    };
                }

                /**
                 * Push an update, if any, onto the queue. Creates a new queue if none is
                 * passed and always returns the queue. Mutative.
                 */
                function enqueue(queue, update) {
                    if (update) {
                        queue = queue || [];
                        queue.push(update);
                    }
                    return queue;
                }

                /**
                 * Processes any enqueued updates.
                 *
                 * @private
                 */
                function processQueue(inst, updateQueue) {
                    ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
                }

                var setChildrenForInstrumentation = emptyFunction;
                if ("development" !== 'production') {
                    var getDebugID = function (inst) {
                        if (!inst._debugID) {
                            // Check for ART-like instances. TODO: This is silly/gross.
                            var internal;
                            if (internal = ReactInstanceMap.get(inst)) {
                                inst = internal;
                            }
                        }
                        return inst._debugID;
                    };
                    setChildrenForInstrumentation = function (children) {
                        var debugID = getDebugID(this);
                        // TODO: React Native empty components are also multichild.
                        // This means they still get into this method but don't have _debugID.
                        if (debugID !== 0) {
                            ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
                                return children[key]._debugID;
                            }) : []);
                        }
                    };
                }

                /**
                 * ReactMultiChild are capable of reconciling multiple children.
                 *
                 * @class ReactMultiChild
                 * @internal
                 */
                var ReactMultiChild = {
                    /**
                     * Provides common functionality for components that must reconcile multiple
                     * children. This is used by `ReactDOMComponent` to mount, update, and
                     * unmount child components.
                     *
                     * @lends {ReactMultiChild.prototype}
                     */
                    Mixin: {
                        _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
                            if ("development" !== 'production') {
                                var selfDebugID = getDebugID(this);
                                if (this._currentElement) {
                                    try {
                                        ReactCurrentOwner.current = this._currentElement._owner;
                                        return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
                                    } finally {
                                        ReactCurrentOwner.current = null;
                                    }
                                }
                            }
                            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
                        },

                        _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
                            var nextChildren;
                            var selfDebugID = 0;
                            if ("development" !== 'production') {
                                selfDebugID = getDebugID(this);
                                if (this._currentElement) {
                                    try {
                                        ReactCurrentOwner.current = this._currentElement._owner;
                                        nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
                                    } finally {
                                        ReactCurrentOwner.current = null;
                                    }
                                    ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
                                    return nextChildren;
                                }
                            }
                            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
                            ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
                            return nextChildren;
                        },

                        /**
                         * Generates a "mount image" for each of the supplied children. In the case
                         * of `ReactDOMComponent`, a mount image is a string of markup.
                         *
                         * @param {?object} nestedChildren Nested child maps.
                         * @return {array} An array of mounted representations.
                         * @internal
                         */
                        mountChildren: function (nestedChildren, transaction, context) {
                            var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
                            this._renderedChildren = children;

                            var mountImages = [];
                            var index = 0;
                            for (var name in children) {
                                if (children.hasOwnProperty(name)) {
                                    var child = children[name];
                                    var selfDebugID = 0;
                                    if ("development" !== 'production') {
                                        selfDebugID = getDebugID(this);
                                    }
                                    var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
                                    child._mountIndex = index++;
                                    mountImages.push(mountImage);
                                }
                            }

                            if ("development" !== 'production') {
                                setChildrenForInstrumentation.call(this, children);
                            }

                            return mountImages;
                        },

                        /**
                         * Replaces any rendered children with a text content string.
                         *
                         * @param {string} nextContent String of content.
                         * @internal
                         */
                        updateTextContent: function (nextContent) {
                            var prevChildren = this._renderedChildren;
                            // Remove any rendered children.
                            ReactChildReconciler.unmountChildren(prevChildren, false);
                            for (var name in prevChildren) {
                                if (prevChildren.hasOwnProperty(name)) {
                                    !false ? "development" !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
                                }
                            }
                            // Set new text content.
                            var updates = [makeTextContent(nextContent)];
                            processQueue(this, updates);
                        },

                        /**
                         * Replaces any rendered children with a markup string.
                         *
                         * @param {string} nextMarkup String of markup.
                         * @internal
                         */
                        updateMarkup: function (nextMarkup) {
                            var prevChildren = this._renderedChildren;
                            // Remove any rendered children.
                            ReactChildReconciler.unmountChildren(prevChildren, false);
                            for (var name in prevChildren) {
                                if (prevChildren.hasOwnProperty(name)) {
                                    !false ? "development" !== 'production' ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
                                }
                            }
                            var updates = [makeSetMarkup(nextMarkup)];
                            processQueue(this, updates);
                        },

                        /**
                         * Updates the rendered children with new children.
                         *
                         * @param {?object} nextNestedChildrenElements Nested child element maps.
                         * @param {ReactReconcileTransaction} transaction
                         * @internal
                         */
                        updateChildren: function (nextNestedChildrenElements, transaction, context) {
                            // Hook used by React ART
                            this._updateChildren(nextNestedChildrenElements, transaction, context);
                        },

                        /**
                         * @param {?object} nextNestedChildrenElements Nested child element maps.
                         * @param {ReactReconcileTransaction} transaction
                         * @final
                         * @protected
                         */
                        _updateChildren: function (nextNestedChildrenElements, transaction, context) {
                            var prevChildren = this._renderedChildren;
                            var removedNodes = {};
                            var mountImages = [];
                            var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
                            if (!nextChildren && !prevChildren) {
                                return;
                            }
                            var updates = null;
                            var name;
                            // `nextIndex` will increment for each child in `nextChildren`, but
                            // `lastIndex` will be the last index visited in `prevChildren`.
                            var nextIndex = 0;
                            var lastIndex = 0;
                            // `nextMountIndex` will increment for each newly mounted child.
                            var nextMountIndex = 0;
                            var lastPlacedNode = null;
                            for (name in nextChildren) {
                                if (!nextChildren.hasOwnProperty(name)) {
                                    continue;
                                }
                                var prevChild = prevChildren && prevChildren[name];
                                var nextChild = nextChildren[name];
                                if (prevChild === nextChild) {
                                    updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
                                    lastIndex = Math.max(prevChild._mountIndex, lastIndex);
                                    prevChild._mountIndex = nextIndex;
                                } else {
                                    if (prevChild) {
                                        // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
                                        lastIndex = Math.max(prevChild._mountIndex, lastIndex);
                                        // The `removedNodes` loop below will actually remove the child.
                                    }
                                    // The child must be instantiated before it's mounted.
                                    updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
                                    nextMountIndex++;
                                }
                                nextIndex++;
                                lastPlacedNode = ReactReconciler.getHostNode(nextChild);
                            }
                            // Remove children that are no longer present.
                            for (name in removedNodes) {
                                if (removedNodes.hasOwnProperty(name)) {
                                    updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
                                }
                            }
                            if (updates) {
                                processQueue(this, updates);
                            }
                            this._renderedChildren = nextChildren;

                            if ("development" !== 'production') {
                                setChildrenForInstrumentation.call(this, nextChildren);
                            }
                        },

                        /**
                         * Unmounts all rendered children. This should be used to clean up children
                         * when this component is unmounted. It does not actually perform any
                         * backend operations.
                         *
                         * @internal
                         */
                        unmountChildren: function (safely) {
                            var renderedChildren = this._renderedChildren;
                            ReactChildReconciler.unmountChildren(renderedChildren, safely);
                            this._renderedChildren = null;
                        },

                        /**
                         * Moves a child component to the supplied index.
                         *
                         * @param {ReactComponent} child Component to move.
                         * @param {number} toIndex Destination index of the element.
                         * @param {number} lastIndex Last index visited of the siblings of `child`.
                         * @protected
                         */
                        moveChild: function (child, afterNode, toIndex, lastIndex) {
                            // If the index of `child` is less than `lastIndex`, then it needs to
                            // be moved. Otherwise, we do not need to move it because a child will be
                            // inserted or moved before `child`.
                            if (child._mountIndex < lastIndex) {
                                return makeMove(child, afterNode, toIndex);
                            }
                        },

                        /**
                         * Creates a child component.
                         *
                         * @param {ReactComponent} child Component to create.
                         * @param {string} mountImage Markup to insert.
                         * @protected
                         */
                        createChild: function (child, afterNode, mountImage) {
                            return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
                        },

                        /**
                         * Removes a child component.
                         *
                         * @param {ReactComponent} child Child to remove.
                         * @protected
                         */
                        removeChild: function (child, node) {
                            return makeRemove(child, node);
                        },

                        /**
                         * Mounts a child with the supplied name.
                         *
                         * NOTE: This is part of `updateChildren` and is here for readability.
                         *
                         * @param {ReactComponent} child Component to mount.
                         * @param {string} name Name of the child.
                         * @param {number} index Index at which to insert the child.
                         * @param {ReactReconcileTransaction} transaction
                         * @private
                         */
                        _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
                            child._mountIndex = index;
                            return this.createChild(child, afterNode, mountImage);
                        },

                        /**
                         * Unmounts a rendered child.
                         *
                         * NOTE: This is part of `updateChildren` and is here for readability.
                         *
                         * @param {ReactComponent} child Component to unmount.
                         * @private
                         */
                        _unmountChild: function (child, node) {
                            var update = this.removeChild(child, node);
                            child._mountIndex = null;
                            return update;
                        }
                    }
                };

                module.exports = ReactMultiChild;
            }, { "109": 109, "126": 126, "134": 134, "144": 144, "152": 152, "27": 27, "29": 29, "63": 63, "64": 64, "75": 75 }], 69: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var React = _dereq_(135);

                var invariant = _dereq_(152);

                var ReactNodeTypes = {
                    HOST: 0,
                    COMPOSITE: 1,
                    EMPTY: 2,

                    getType: function (node) {
                        if (node === null || node === false) {
                            return ReactNodeTypes.EMPTY;
                        } else if (React.isValidElement(node)) {
                            if (typeof node.type === 'function') {
                                return ReactNodeTypes.COMPOSITE;
                            } else {
                                return ReactNodeTypes.HOST;
                            }
                        }
                        !false ? "development" !== 'production' ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
                    }
                };

                module.exports = ReactNodeTypes;
            }, { "126": 126, "135": 135, "152": 152 }], 70: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                /**
                 * @param {?object} object
                 * @return {boolean} True if `object` is a valid owner.
                 * @final
                 */
                function isValidOwner(object) {
                    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
                }

                /**
                 * ReactOwners are capable of storing references to owned components.
                 *
                 * All components are capable of //being// referenced by owner components, but
                 * only ReactOwner components are capable of //referencing// owned components.
                 * The named reference is known as a "ref".
                 *
                 * Refs are available when mounted and updated during reconciliation.
                 *
                 *   var MyComponent = React.createClass({
                 *     render: function() {
                 *       return (
                 *         <div onClick={this.handleClick}>
                 *           <CustomComponent ref="custom" />
                 *         </div>
                 *       );
                 *     },
                 *     handleClick: function() {
                 *       this.refs.custom.handleClick();
                 *     },
                 *     componentDidMount: function() {
                 *       this.refs.custom.initialize();
                 *     }
                 *   });
                 *
                 * Refs should rarely be used. When refs are used, they should only be done to
                 * control data that is not handled by React's data flow.
                 *
                 * @class ReactOwner
                 */
                var ReactOwner = {
                    /**
                     * Adds a component by ref to an owner component.
                     *
                     * @param {ReactComponent} component Component to reference.
                     * @param {string} ref Name by which to refer to the component.
                     * @param {ReactOwner} owner Component on which to record the ref.
                     * @final
                     * @internal
                     */
                    addComponentAsRefTo: function (component, ref, owner) {
                        !isValidOwner(owner) ? "development" !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
                        owner.attachRef(ref, component);
                    },

                    /**
                     * Removes a component by ref from an owner component.
                     *
                     * @param {ReactComponent} component Component to dereference.
                     * @param {string} ref Name of the ref to remove.
                     * @param {ReactOwner} owner Component on which the ref is recorded.
                     * @final
                     * @internal
                     */
                    removeComponentAsRefFrom: function (component, ref, owner) {
                        !isValidOwner(owner) ? "development" !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
                        var ownerPublicInstance = owner.getPublicInstance();
                        // Check that `component`'s owner is still alive and that `component` is still the current ref
                        // because we do not want to detach the ref if another component stole it.
                        if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
                            owner.detachRef(ref);
                        }
                    }
                };

                module.exports = ReactOwner;
            }, { "126": 126, "152": 152 }], 71: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _assign = _dereq_(160);

                var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

                var ReactDebugTool = _dereq_(50);
                var lowPriorityWarning = _dereq_(124);
                var alreadyWarned = false;

                function roundFloat(val) {
                    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

                    var n = Math.pow(10, base);
                    return Math.floor(val * n) / n;
                }

                // Flow type definition of console.table is too strict right now, see
                // https://github.com/facebook/flow/pull/2353 for updates
                function consoleTable(table) {
                    console.table(table);
                }

                function warnInProduction() {
                    if (alreadyWarned) {
                        return;
                    }
                    alreadyWarned = true;
                    if (typeof console !== 'undefined') {
                        console.error('ReactPerf is not supported in the production builds of React. ' + 'To collect measurements, please use the development build of React instead.');
                    }
                }

                function getLastMeasurements() {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return [];
                    }

                    return ReactDebugTool.getFlushHistory();
                }

                function getExclusive() {
                    var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return [];
                    }

                    var aggregatedStats = {};
                    var affectedIDs = {};

                    function updateAggregatedStats(treeSnapshot, instanceID, timerType, applyUpdate) {
                        var displayName = treeSnapshot[instanceID].displayName;

                        var key = displayName;
                        var stats = aggregatedStats[key];
                        if (!stats) {
                            affectedIDs[key] = {};
                            stats = aggregatedStats[key] = {
                                key: key,
                                instanceCount: 0,
                                counts: {},
                                durations: {},
                                totalDuration: 0
                            };
                        }
                        if (!stats.durations[timerType]) {
                            stats.durations[timerType] = 0;
                        }
                        if (!stats.counts[timerType]) {
                            stats.counts[timerType] = 0;
                        }
                        affectedIDs[key][instanceID] = true;
                        applyUpdate(stats);
                    }

                    flushHistory.forEach(function (flush) {
                        var measurements = flush.measurements,
                            treeSnapshot = flush.treeSnapshot;

                        measurements.forEach(function (measurement) {
                            var duration = measurement.duration,
                                instanceID = measurement.instanceID,
                                timerType = measurement.timerType;

                            updateAggregatedStats(treeSnapshot, instanceID, timerType, function (stats) {
                                stats.totalDuration += duration;
                                stats.durations[timerType] += duration;
                                stats.counts[timerType]++;
                            });
                        });
                    });

                    return Object.keys(aggregatedStats).map(function (key) {
                        return _extends({}, aggregatedStats[key], {
                            instanceCount: Object.keys(affectedIDs[key]).length
                        });
                    }).sort(function (a, b) {
                        return b.totalDuration - a.totalDuration;
                    });
                }

                function getInclusive() {
                    var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return [];
                    }

                    var aggregatedStats = {};
                    var affectedIDs = {};

                    function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
                        var _treeSnapshot$instanc = treeSnapshot[instanceID],
                            displayName = _treeSnapshot$instanc.displayName,
                            ownerID = _treeSnapshot$instanc.ownerID;

                        var owner = treeSnapshot[ownerID];
                        var key = (owner ? owner.displayName + ' > ' : '') + displayName;
                        var stats = aggregatedStats[key];
                        if (!stats) {
                            affectedIDs[key] = {};
                            stats = aggregatedStats[key] = {
                                key: key,
                                instanceCount: 0,
                                inclusiveRenderDuration: 0,
                                renderCount: 0
                            };
                        }
                        affectedIDs[key][instanceID] = true;
                        applyUpdate(stats);
                    }

                    var isCompositeByID = {};
                    flushHistory.forEach(function (flush) {
                        var measurements = flush.measurements;

                        measurements.forEach(function (measurement) {
                            var instanceID = measurement.instanceID,
                                timerType = measurement.timerType;

                            if (timerType !== 'render') {
                                return;
                            }
                            isCompositeByID[instanceID] = true;
                        });
                    });

                    flushHistory.forEach(function (flush) {
                        var measurements = flush.measurements,
                            treeSnapshot = flush.treeSnapshot;

                        measurements.forEach(function (measurement) {
                            var duration = measurement.duration,
                                instanceID = measurement.instanceID,
                                timerType = measurement.timerType;

                            if (timerType !== 'render') {
                                return;
                            }
                            updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
                                stats.renderCount++;
                            });
                            var nextParentID = instanceID;
                            while (nextParentID) {
                                // As we traverse parents, only count inclusive time towards composites.
                                // We know something is a composite if its render() was called.
                                if (isCompositeByID[nextParentID]) {
                                    updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
                                        stats.inclusiveRenderDuration += duration;
                                    });
                                }
                                nextParentID = treeSnapshot[nextParentID].parentID;
                            }
                        });
                    });

                    return Object.keys(aggregatedStats).map(function (key) {
                        return _extends({}, aggregatedStats[key], {
                            instanceCount: Object.keys(affectedIDs[key]).length
                        });
                    }).sort(function (a, b) {
                        return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
                    });
                }

                function getWasted() {
                    var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return [];
                    }

                    var aggregatedStats = {};
                    var affectedIDs = {};

                    function updateAggregatedStats(treeSnapshot, instanceID, applyUpdate) {
                        var _treeSnapshot$instanc2 = treeSnapshot[instanceID],
                            displayName = _treeSnapshot$instanc2.displayName,
                            ownerID = _treeSnapshot$instanc2.ownerID;

                        var owner = treeSnapshot[ownerID];
                        var key = (owner ? owner.displayName + ' > ' : '') + displayName;
                        var stats = aggregatedStats[key];
                        if (!stats) {
                            affectedIDs[key] = {};
                            stats = aggregatedStats[key] = {
                                key: key,
                                instanceCount: 0,
                                inclusiveRenderDuration: 0,
                                renderCount: 0
                            };
                        }
                        affectedIDs[key][instanceID] = true;
                        applyUpdate(stats);
                    }

                    flushHistory.forEach(function (flush) {
                        var measurements = flush.measurements,
                            treeSnapshot = flush.treeSnapshot,
                            operations = flush.operations;

                        var isDefinitelyNotWastedByID = {};

                        // Find host components associated with an operation in this batch.
                        // Mark all components in their parent tree as definitely not wasted.
                        operations.forEach(function (operation) {
                            var instanceID = operation.instanceID;

                            var nextParentID = instanceID;
                            while (nextParentID) {
                                isDefinitelyNotWastedByID[nextParentID] = true;
                                nextParentID = treeSnapshot[nextParentID].parentID;
                            }
                        });

                        // Find composite components that rendered in this batch.
                        // These are potential candidates for being wasted renders.
                        var renderedCompositeIDs = {};
                        measurements.forEach(function (measurement) {
                            var instanceID = measurement.instanceID,
                                timerType = measurement.timerType;

                            if (timerType !== 'render') {
                                return;
                            }
                            renderedCompositeIDs[instanceID] = true;
                        });

                        measurements.forEach(function (measurement) {
                            var duration = measurement.duration,
                                instanceID = measurement.instanceID,
                                timerType = measurement.timerType;

                            if (timerType !== 'render') {
                                return;
                            }

                            // If there was a DOM update below this component, or it has just been
                            // mounted, its render() is not considered wasted.
                            var updateCount = treeSnapshot[instanceID].updateCount;

                            if (isDefinitelyNotWastedByID[instanceID] || updateCount === 0) {
                                return;
                            }

                            // We consider this render() wasted.
                            updateAggregatedStats(treeSnapshot, instanceID, function (stats) {
                                stats.renderCount++;
                            });

                            var nextParentID = instanceID;
                            while (nextParentID) {
                                // Any parents rendered during this batch are considered wasted
                                // unless we previously marked them as dirty.
                                var isWasted = renderedCompositeIDs[nextParentID] && !isDefinitelyNotWastedByID[nextParentID];
                                if (isWasted) {
                                    updateAggregatedStats(treeSnapshot, nextParentID, function (stats) {
                                        stats.inclusiveRenderDuration += duration;
                                    });
                                }
                                nextParentID = treeSnapshot[nextParentID].parentID;
                            }
                        });
                    });

                    return Object.keys(aggregatedStats).map(function (key) {
                        return _extends({}, aggregatedStats[key], {
                            instanceCount: Object.keys(affectedIDs[key]).length
                        });
                    }).sort(function (a, b) {
                        return b.inclusiveRenderDuration - a.inclusiveRenderDuration;
                    });
                }

                function getOperations() {
                    var flushHistory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastMeasurements();

                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return [];
                    }

                    var stats = [];
                    flushHistory.forEach(function (flush, flushIndex) {
                        var operations = flush.operations,
                            treeSnapshot = flush.treeSnapshot;

                        operations.forEach(function (operation) {
                            var instanceID = operation.instanceID,
                                type = operation.type,
                                payload = operation.payload;
                            var _treeSnapshot$instanc3 = treeSnapshot[instanceID],
                                displayName = _treeSnapshot$instanc3.displayName,
                                ownerID = _treeSnapshot$instanc3.ownerID;

                            var owner = treeSnapshot[ownerID];
                            var key = (owner ? owner.displayName + ' > ' : '') + displayName;

                            stats.push({
                                flushIndex: flushIndex,
                                instanceID: instanceID,
                                key: key,
                                type: type,
                                ownerID: ownerID,
                                payload: payload
                            });
                        });
                    });
                    return stats;
                }

                function printExclusive(flushHistory) {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return;
                    }

                    var stats = getExclusive(flushHistory);
                    var table = stats.map(function (item) {
                        var key = item.key,
                            instanceCount = item.instanceCount,
                            totalDuration = item.totalDuration;

                        var renderCount = item.counts.render || 0;
                        var renderDuration = item.durations.render || 0;
                        return {
                            Component: key,
                            'Total time (ms)': roundFloat(totalDuration),
                            'Instance count': instanceCount,
                            'Total render time (ms)': roundFloat(renderDuration),
                            'Average render time (ms)': renderCount ? roundFloat(renderDuration / renderCount) : undefined,
                            'Render count': renderCount,
                            'Total lifecycle time (ms)': roundFloat(totalDuration - renderDuration)
                        };
                    });
                    consoleTable(table);
                }

                function printInclusive(flushHistory) {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return;
                    }

                    var stats = getInclusive(flushHistory);
                    var table = stats.map(function (item) {
                        var key = item.key,
                            instanceCount = item.instanceCount,
                            inclusiveRenderDuration = item.inclusiveRenderDuration,
                            renderCount = item.renderCount;

                        return {
                            'Owner > Component': key,
                            'Inclusive render time (ms)': roundFloat(inclusiveRenderDuration),
                            'Instance count': instanceCount,
                            'Render count': renderCount
                        };
                    });
                    consoleTable(table);
                }

                function printWasted(flushHistory) {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return;
                    }

                    var stats = getWasted(flushHistory);
                    var table = stats.map(function (item) {
                        var key = item.key,
                            instanceCount = item.instanceCount,
                            inclusiveRenderDuration = item.inclusiveRenderDuration,
                            renderCount = item.renderCount;

                        return {
                            'Owner > Component': key,
                            'Inclusive wasted time (ms)': roundFloat(inclusiveRenderDuration),
                            'Instance count': instanceCount,
                            'Render count': renderCount
                        };
                    });
                    consoleTable(table);
                }

                function printOperations(flushHistory) {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return;
                    }

                    var stats = getOperations(flushHistory);
                    var table = stats.map(function (stat) {
                        return {
                            'Owner > Node': stat.key,
                            Operation: stat.type,
                            Payload: typeof stat.payload === 'object' ? JSON.stringify(stat.payload) : stat.payload,
                            'Flush index': stat.flushIndex,
                            'Owner Component ID': stat.ownerID,
                            'DOM Component ID': stat.instanceID
                        };
                    });
                    consoleTable(table);
                }

                var warnedAboutPrintDOM = false;
                function printDOM(measurements) {
                    lowPriorityWarning(warnedAboutPrintDOM, '`ReactPerf.printDOM(...)` is deprecated. Use ' + '`ReactPerf.printOperations(...)` instead.');
                    warnedAboutPrintDOM = true;
                    return printOperations(measurements);
                }

                var warnedAboutGetMeasurementsSummaryMap = false;
                function getMeasurementsSummaryMap(measurements) {
                    lowPriorityWarning(warnedAboutGetMeasurementsSummaryMap, '`ReactPerf.getMeasurementsSummaryMap(...)` is deprecated. Use ' + '`ReactPerf.getWasted(...)` instead.');
                    warnedAboutGetMeasurementsSummaryMap = true;
                    return getWasted(measurements);
                }

                function start() {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return;
                    }

                    ReactDebugTool.beginProfiling();
                }

                function stop() {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return;
                    }

                    ReactDebugTool.endProfiling();
                }

                function isRunning() {
                    if (!("development" !== 'production')) {
                        warnInProduction();
                        return false;
                    }

                    return ReactDebugTool.isProfiling();
                }

                var ReactPerfAnalysis = {
                    getLastMeasurements: getLastMeasurements,
                    getExclusive: getExclusive,
                    getInclusive: getInclusive,
                    getWasted: getWasted,
                    getOperations: getOperations,
                    printExclusive: printExclusive,
                    printInclusive: printInclusive,
                    printWasted: printWasted,
                    printOperations: printOperations,
                    start: start,
                    stop: stop,
                    isRunning: isRunning,
                    // Deprecated:
                    printDOM: printDOM,
                    getMeasurementsSummaryMap: getMeasurementsSummaryMap
                };

                module.exports = ReactPerfAnalysis;
            }, { "124": 124, "160": 160, "50": 50 }], 72: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var ReactPropTypeLocationNames = {};

                if ("development" !== 'production') {
                    ReactPropTypeLocationNames = {
                        prop: 'prop',
                        context: 'context',
                        childContext: 'child context'
                    };
                }

                module.exports = ReactPropTypeLocationNames;
            }, {}], 73: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

                module.exports = ReactPropTypesSecret;
            }, {}], 74: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var CallbackQueue = _dereq_(6);
                var PooledClass = _dereq_(25);
                var ReactBrowserEventEmitter = _dereq_(26);
                var ReactInputSelection = _dereq_(62);
                var ReactInstrumentation = _dereq_(64);
                var Transaction = _dereq_(100);
                var ReactUpdateQueue = _dereq_(81);

                /**
                 * Ensures that, when possible, the selection range (currently selected text
                 * input) is not disturbed by performing the transaction.
                 */
                var SELECTION_RESTORATION = {
                    /**
                     * @return {Selection} Selection information.
                     */
                    initialize: ReactInputSelection.getSelectionInformation,
                    /**
                     * @param {Selection} sel Selection information returned from `initialize`.
                     */
                    close: ReactInputSelection.restoreSelection
                };

                /**
                 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
                 * high level DOM manipulations (like temporarily removing a text input from the
                 * DOM).
                 */
                var EVENT_SUPPRESSION = {
                    /**
                     * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
                     * the reconciliation.
                     */
                    initialize: function () {
                        var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
                        ReactBrowserEventEmitter.setEnabled(false);
                        return currentlyEnabled;
                    },

                    /**
                     * @param {boolean} previouslyEnabled Enabled status of
                     *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
                     *   restores the previous value.
                     */
                    close: function (previouslyEnabled) {
                        ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
                    }
                };

                /**
                 * Provides a queue for collecting `componentDidMount` and
                 * `componentDidUpdate` callbacks during the transaction.
                 */
                var ON_DOM_READY_QUEUEING = {
                    /**
                     * Initializes the internal `onDOMReady` queue.
                     */
                    initialize: function () {
                        this.reactMountReady.reset();
                    },

                    /**
                     * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
                     */
                    close: function () {
                        this.reactMountReady.notifyAll();
                    }
                };

                /**
                 * Executed within the scope of the `Transaction` instance. Consider these as
                 * being member methods, but with an implied ordering while being isolated from
                 * each other.
                 */
                var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

                if ("development" !== 'production') {
                    TRANSACTION_WRAPPERS.push({
                        initialize: ReactInstrumentation.debugTool.onBeginFlush,
                        close: ReactInstrumentation.debugTool.onEndFlush
                    });
                }

                /**
                 * Currently:
                 * - The order that these are listed in the transaction is critical:
                 * - Suppresses events.
                 * - Restores selection range.
                 *
                 * Future:
                 * - Restore document/overflow scroll positions that were unintentionally
                 *   modified via DOM insertions above the top viewport boundary.
                 * - Implement/integrate with customized constraint based layout system and keep
                 *   track of which dimensions must be remeasured.
                 *
                 * @class ReactReconcileTransaction
                 */
                function ReactReconcileTransaction(useCreateElement) {
                    this.reinitializeTransaction();
                    // Only server-side rendering really needs this option (see
                    // `ReactServerRendering`), but server-side uses
                    // `ReactServerRenderingTransaction` instead. This option is here so that it's
                    // accessible and defaults to false when `ReactDOMComponent` and
                    // `ReactDOMTextComponent` checks it in `mountComponent`.`
                    this.renderToStaticMarkup = false;
                    this.reactMountReady = CallbackQueue.getPooled(null);
                    this.useCreateElement = useCreateElement;
                }

                var Mixin = {
                    /**
                     * @see Transaction
                     * @abstract
                     * @final
                     * @return {array<object>} List of operation wrap procedures.
                     *   TODO: convert to array<TransactionWrapper>
                     */
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    },

                    /**
                     * @return {object} The queue to collect `onDOMReady` callbacks with.
                     */
                    getReactMountReady: function () {
                        return this.reactMountReady;
                    },

                    /**
                     * @return {object} The queue to collect React async events.
                     */
                    getUpdateQueue: function () {
                        return ReactUpdateQueue;
                    },

                    /**
                     * Save current transaction state -- if the return value from this method is
                     * passed to `rollback`, the transaction will be reset to that state.
                     */
                    checkpoint: function () {
                        // reactMountReady is the our only stateful wrapper
                        return this.reactMountReady.checkpoint();
                    },

                    rollback: function (checkpoint) {
                        this.reactMountReady.rollback(checkpoint);
                    },

                    /**
                     * `PooledClass` looks for this, and will invoke this before allowing this
                     * instance to be reused.
                     */
                    destructor: function () {
                        CallbackQueue.release(this.reactMountReady);
                        this.reactMountReady = null;
                    }
                };

                _assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

                PooledClass.addPoolingTo(ReactReconcileTransaction);

                module.exports = ReactReconcileTransaction;
            }, { "100": 100, "160": 160, "25": 25, "26": 26, "6": 6, "62": 62, "64": 64, "81": 81 }], 75: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactRef = _dereq_(76);
                var ReactInstrumentation = _dereq_(64);

                var warning = _dereq_(159);

                /**
                 * Helper to call ReactRef.attachRefs with this composite component, split out
                 * to avoid allocations in the transaction mount-ready queue.
                 */
                function attachRefs() {
                    ReactRef.attachRefs(this, this._currentElement);
                }

                var ReactReconciler = {
                    /**
                     * Initializes the component, renders markup, and registers event listeners.
                     *
                     * @param {ReactComponent} internalInstance
                     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
                     * @param {?object} the containing host component instance
                     * @param {?object} info about the host container
                     * @return {?string} Rendered markup to be inserted into the DOM.
                     * @final
                     * @internal
                     */
                    mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
                    {
                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
                            }
                        }
                        var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
                        if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
                            transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
                        }
                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
                            }
                        }
                        return markup;
                    },

                    /**
                     * Returns a value that can be passed to
                     * ReactComponentEnvironment.replaceNodeWithMarkup.
                     */
                    getHostNode: function (internalInstance) {
                        return internalInstance.getHostNode();
                    },

                    /**
                     * Releases any resources allocated by `mountComponent`.
                     *
                     * @final
                     * @internal
                     */
                    unmountComponent: function (internalInstance, safely) {
                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
                            }
                        }
                        ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
                        internalInstance.unmountComponent(safely);
                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
                            }
                        }
                    },

                    /**
                     * Update a component using a new element.
                     *
                     * @param {ReactComponent} internalInstance
                     * @param {ReactElement} nextElement
                     * @param {ReactReconcileTransaction} transaction
                     * @param {object} context
                     * @internal
                     */
                    receiveComponent: function (internalInstance, nextElement, transaction, context) {
                        var prevElement = internalInstance._currentElement;

                        if (nextElement === prevElement && context === internalInstance._context) {
                            // Since elements are immutable after the owner is rendered,
                            // we can do a cheap identity compare here to determine if this is a
                            // superfluous reconcile. It's possible for state to be mutable but such
                            // change should trigger an update of the owner which would recreate
                            // the element. We explicitly check for the existence of an owner since
                            // it's possible for an element created outside a composite to be
                            // deeply mutated and reused.

                            // TODO: Bailing out early is just a perf optimization right?
                            // TODO: Removing the return statement should affect correctness?
                            return;
                        }

                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
                            }
                        }

                        var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

                        if (refsChanged) {
                            ReactRef.detachRefs(internalInstance, prevElement);
                        }

                        internalInstance.receiveComponent(nextElement, transaction, context);

                        if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
                            transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
                        }

                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
                            }
                        }
                    },

                    /**
                     * Flush any dirty changes in a component.
                     *
                     * @param {ReactComponent} internalInstance
                     * @param {ReactReconcileTransaction} transaction
                     * @internal
                     */
                    performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
                        if (internalInstance._updateBatchNumber !== updateBatchNumber) {
                            // The component's enqueued batch number should always be the current
                            // batch or the following one.
                            "development" !== 'production' ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
                            return;
                        }
                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
                            }
                        }
                        internalInstance.performUpdateIfNecessary(transaction);
                        if ("development" !== 'production') {
                            if (internalInstance._debugID !== 0) {
                                ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
                            }
                        }
                    }
                };

                module.exports = ReactReconciler;
            }, { "159": 159, "64": 64, "76": 76 }], 76: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var ReactOwner = _dereq_(70);

                var ReactRef = {};

                function attachRef(ref, component, owner) {
                    if (typeof ref === 'function') {
                        ref(component.getPublicInstance());
                    } else {
                        // Legacy ref
                        ReactOwner.addComponentAsRefTo(component, ref, owner);
                    }
                }

                function detachRef(ref, component, owner) {
                    if (typeof ref === 'function') {
                        ref(null);
                    } else {
                        // Legacy ref
                        ReactOwner.removeComponentAsRefFrom(component, ref, owner);
                    }
                }

                ReactRef.attachRefs = function (instance, element) {
                    if (element === null || typeof element !== 'object') {
                        return;
                    }
                    var ref = element.ref;
                    if (ref != null) {
                        attachRef(ref, instance, element._owner);
                    }
                };

                ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
                    // If either the owner or a `ref` has changed, make sure the newest owner
                    // has stored a reference to `this`, and the previous owner (if different)
                    // has forgotten the reference to `this`. We use the element instead
                    // of the public this.props because the post processing cannot determine
                    // a ref. The ref conceptually lives on the element.

                    // TODO: Should this even be possible? The owner cannot change because
                    // it's forbidden by shouldUpdateReactComponent. The ref can change
                    // if you swap the keys of but not the refs. Reconsider where this check
                    // is made. It probably belongs where the key checking and
                    // instantiateReactComponent is done.

                    var prevRef = null;
                    var prevOwner = null;
                    if (prevElement !== null && typeof prevElement === 'object') {
                        prevRef = prevElement.ref;
                        prevOwner = prevElement._owner;
                    }

                    var nextRef = null;
                    var nextOwner = null;
                    if (nextElement !== null && typeof nextElement === 'object') {
                        nextRef = nextElement.ref;
                        nextOwner = nextElement._owner;
                    }

                    return prevRef !== nextRef ||
                        // If owner changes but we have an unchanged function ref, don't update refs
                        typeof nextRef === 'string' && nextOwner !== prevOwner;
                };

                ReactRef.detachRefs = function (instance, element) {
                    if (element === null || typeof element !== 'object') {
                        return;
                    }
                    var ref = element.ref;
                    if (ref != null) {
                        detachRef(ref, instance, element._owner);
                    }
                };

                module.exports = ReactRef;
            }, { "70": 70 }], 77: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var PooledClass = _dereq_(25);
                var Transaction = _dereq_(100);
                var ReactInstrumentation = _dereq_(64);
                var ReactServerUpdateQueue = _dereq_(78);

                /**
                 * Executed within the scope of the `Transaction` instance. Consider these as
                 * being member methods, but with an implied ordering while being isolated from
                 * each other.
                 */
                var TRANSACTION_WRAPPERS = [];

                if ("development" !== 'production') {
                    TRANSACTION_WRAPPERS.push({
                        initialize: ReactInstrumentation.debugTool.onBeginFlush,
                        close: ReactInstrumentation.debugTool.onEndFlush
                    });
                }

                var noopCallbackQueue = {
                    enqueue: function () { }
                };

                /**
                 * @class ReactServerRenderingTransaction
                 * @param {boolean} renderToStaticMarkup
                 */
                function ReactServerRenderingTransaction(renderToStaticMarkup) {
                    this.reinitializeTransaction();
                    this.renderToStaticMarkup = renderToStaticMarkup;
                    this.useCreateElement = false;
                    this.updateQueue = new ReactServerUpdateQueue(this);
                }

                var Mixin = {
                    /**
                     * @see Transaction
                     * @abstract
                     * @final
                     * @return {array} Empty list of operation wrap procedures.
                     */
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    },

                    /**
                     * @return {object} The queue to collect `onDOMReady` callbacks with.
                     */
                    getReactMountReady: function () {
                        return noopCallbackQueue;
                    },

                    /**
                     * @return {object} The queue to collect React async events.
                     */
                    getUpdateQueue: function () {
                        return this.updateQueue;
                    },

                    /**
                     * `PooledClass` looks for this, and will invoke this before allowing this
                     * instance to be reused.
                     */
                    destructor: function () { },

                    checkpoint: function () { },

                    rollback: function () { }
                };

                _assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

                PooledClass.addPoolingTo(ReactServerRenderingTransaction);

                module.exports = ReactServerRenderingTransaction;
            }, { "100": 100, "160": 160, "25": 25, "64": 64, "78": 78 }], 78: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                var ReactUpdateQueue = _dereq_(81);

                var warning = _dereq_(159);

                function warnNoop(publicInstance, callerName) {
                    if ("development" !== 'production') {
                        var constructor = publicInstance.constructor;
                        "development" !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
                    }
                }

                /**
                 * This is the update queue used for server rendering.
                 * It delegates to ReactUpdateQueue while server rendering is in progress and
                 * switches to ReactNoopUpdateQueue after the transaction has completed.
                 * @class ReactServerUpdateQueue
                 * @param {Transaction} transaction
                 */

                var ReactServerUpdateQueue = function () {
                    function ReactServerUpdateQueue(transaction) {
                        _classCallCheck(this, ReactServerUpdateQueue);

                        this.transaction = transaction;
                    }

                    /**
                     * Checks whether or not this composite component is mounted.
                     * @param {ReactClass} publicInstance The instance we want to test.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */


                    ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
                        return false;
                    };

                    /**
                     * Enqueue a callback that will be executed after all the pending updates
                     * have processed.
                     *
                     * @param {ReactClass} publicInstance The instance to use as `this` context.
                     * @param {?function} callback Called after state is updated.
                     * @internal
                     */


                    ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
                        if (this.transaction.isInTransaction()) {
                            ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
                        }
                    };

                    /**
                     * Forces an update. This should only be invoked when it is known with
                     * certainty that we are **not** in a DOM transaction.
                     *
                     * You may want to call this when you know that some deeper aspect of the
                     * component's state has changed but `setState` was not called.
                     *
                     * This will not invoke `shouldComponentUpdate`, but it will invoke
                     * `componentWillUpdate` and `componentDidUpdate`.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @internal
                     */


                    ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
                        if (this.transaction.isInTransaction()) {
                            ReactUpdateQueue.enqueueForceUpdate(publicInstance);
                        } else {
                            warnNoop(publicInstance, 'forceUpdate');
                        }
                    };

                    /**
                     * Replaces all of the state. Always use this or `setState` to mutate state.
                     * You should treat `this.state` as immutable.
                     *
                     * There is no guarantee that `this.state` will be immediately updated, so
                     * accessing `this.state` after calling this method may return the old value.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object|function} completeState Next state.
                     * @internal
                     */


                    ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
                        if (this.transaction.isInTransaction()) {
                            ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
                        } else {
                            warnNoop(publicInstance, 'replaceState');
                        }
                    };

                    /**
                     * Sets a subset of the state. This only exists because _pendingState is
                     * internal. This provides a merging strategy that is not available to deep
                     * properties which is confusing. TODO: Expose pendingState or don't use it
                     * during the merge.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object|function} partialState Next partial state to be merged with state.
                     * @internal
                     */


                    ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
                        if (this.transaction.isInTransaction()) {
                            ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
                        } else {
                            warnNoop(publicInstance, 'setState');
                        }
                    };

                    return ReactServerUpdateQueue;
                }();

                module.exports = ReactServerUpdateQueue;
            }, { "159": 159, "81": 81 }], 79: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                var React = _dereq_(135);
                var ReactCompositeComponent = _dereq_(30);
                var ReactDefaultBatchingStrategy = _dereq_(51);
                var ReactReconciler = _dereq_(75);
                var ReactReconcileTransaction = _dereq_(74);
                var ReactUpdates = _dereq_(82);

                var emptyObject = _dereq_(145);
                var getNextDebugID = _dereq_(136);
                var invariant = _dereq_(152);

                function injectDefaults() {
                    ReactUpdates.injection.injectReconcileTransaction(ReactReconcileTransaction);
                    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
                }

                var NoopInternalComponent = function () {
                    function NoopInternalComponent(element) {
                        _classCallCheck(this, NoopInternalComponent);

                        this._renderedOutput = element;
                        this._currentElement = element;

                        if ("development" !== 'production') {
                            this._debugID = getNextDebugID();
                        }
                    }

                    NoopInternalComponent.prototype.mountComponent = function mountComponent() { };

                    NoopInternalComponent.prototype.receiveComponent = function receiveComponent(element) {
                        this._renderedOutput = element;
                        this._currentElement = element;
                    };

                    NoopInternalComponent.prototype.unmountComponent = function unmountComponent() { };

                    NoopInternalComponent.prototype.getHostNode = function getHostNode() {
                        return undefined;
                    };

                    NoopInternalComponent.prototype.getPublicInstance = function getPublicInstance() {
                        return null;
                    };

                    return NoopInternalComponent;
                }();

                var ShallowComponentWrapper = function (element) {
                    // TODO: Consolidate with instantiateReactComponent
                    if ("development" !== 'production') {
                        this._debugID = getNextDebugID();
                    }

                    this.construct(element);
                };
                _assign(ShallowComponentWrapper.prototype, ReactCompositeComponent, {
                    _constructComponent: ReactCompositeComponent._constructComponentWithoutOwner,
                    _instantiateReactComponent: function (element) {
                        return new NoopInternalComponent(element);
                    },
                    _replaceNodeWithMarkup: function () { },
                    _renderValidatedComponent: ReactCompositeComponent._renderValidatedComponentWithoutOwnerOrContext
                });

                function _batchedRender(renderer, element, context) {
                    var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(true);
                    renderer._render(element, transaction, context);
                    ReactUpdates.ReactReconcileTransaction.release(transaction);
                }

                var ReactShallowRenderer = function () {
                    function ReactShallowRenderer() {
                        _classCallCheck(this, ReactShallowRenderer);

                        this._instance = null;
                    }

                    ReactShallowRenderer.prototype.getMountedInstance = function getMountedInstance() {
                        return this._instance ? this._instance._instance : null;
                    };

                    ReactShallowRenderer.prototype.render = function render(element, context) {
                        // Ensure we've done the default injections. This might not be true in the
                        // case of a simple test that only requires React and the TestUtils in
                        // conjunction with an inline-requires transform.
                        injectDefaults();

                        !React.isValidElement(element) ? "development" !== 'production' ? invariant(false, 'ReactShallowRenderer render(): Invalid component element.%s', typeof element === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' : '') : _prodInvariant('12', typeof element === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' : '') : void 0;
                        !(typeof element.type !== 'string') ? "development" !== 'production' ? invariant(false, 'ReactShallowRenderer render(): Shallow rendering works only with custom components, not primitives (%s). Instead of calling `.render(el)` and inspecting the rendered output, look at `el.props` directly instead.', element.type) : _prodInvariant('13', element.type) : void 0;

                        if (!context) {
                            context = emptyObject;
                        }
                        ReactUpdates.batchedUpdates(_batchedRender, this, element, context);

                        return this.getRenderOutput();
                    };

                    ReactShallowRenderer.prototype.getRenderOutput = function getRenderOutput() {
                        return this._instance && this._instance._renderedComponent && this._instance._renderedComponent._renderedOutput || null;
                    };

                    ReactShallowRenderer.prototype.unmount = function unmount() {
                        if (this._instance) {
                            ReactReconciler.unmountComponent(this._instance, false);
                        }
                    };

                    ReactShallowRenderer.prototype.unstable_batchedUpdates = function unstable_batchedUpdates(callback, bookkeeping) {
                        // This is used by Enzyme for fake-simulating events in shallow mode.
                        injectDefaults();
                        return ReactUpdates.batchedUpdates(callback, bookkeeping);
                    };

                    ReactShallowRenderer.prototype._render = function _render(element, transaction, context) {
                        if (this._instance) {
                            ReactReconciler.receiveComponent(this._instance, element, transaction, context);
                        } else {
                            var instance = new ShallowComponentWrapper(element);
                            ReactReconciler.mountComponent(instance, transaction, null, null, context, 0);
                            this._instance = instance;
                        }
                    };

                    return ReactShallowRenderer;
                }();

                ReactShallowRenderer.createRenderer = function () {
                    return new ReactShallowRenderer();
                };

                module.exports = ReactShallowRenderer;
            }, { "126": 126, "135": 135, "136": 136, "145": 145, "152": 152, "160": 160, "30": 30, "51": 51, "74": 74, "75": 75, "82": 82 }], 80: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var EventConstants = _dereq_(16);
                var EventPluginHub = _dereq_(17);
                var EventPluginRegistry = _dereq_(18);
                var EventPropagators = _dereq_(20);
                var React = _dereq_(135);
                var ReactDOM = _dereq_(31);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactBrowserEventEmitter = _dereq_(26);
                var ReactInstanceMap = _dereq_(63);
                var ReactUpdates = _dereq_(82);
                var SyntheticEvent = _dereq_(91);
                var ReactShallowRenderer = _dereq_(79);

                var findDOMNode = _dereq_(108);
                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                var topLevelTypes = EventConstants.topLevelTypes;

                function Event(suffix) { }

                // In react 16+ shallowRenderer will not be accessible via ReactTestUtils.createRenderer()
                // Instead it will be available via react-test-renderer/shallow
                // Maintain backwards compat for 15.5.0 release, but warn about using the deprecated method
                var hasWarnedAboutCreateRenderer = false;
                function createRendererWithWarning() {
                    "development" !== 'production' ? warning(hasWarnedAboutCreateRenderer, 'Shallow renderer has been moved to react-test-renderer/shallow. ' + 'Update references to remove this warning.') : void 0;
                    hasWarnedAboutCreateRenderer = true;

                    return new ReactShallowRenderer();
                }

                /**
                 * @class ReactTestUtils
                 */

                function findAllInRenderedTreeInternal(inst, test) {
                    if (!inst || !inst.getPublicInstance) {
                        return [];
                    }
                    var publicInst = inst.getPublicInstance();
                    var ret = test(publicInst) ? [publicInst] : [];
                    var currentElement = inst._currentElement;
                    if (ReactTestUtils.isDOMComponent(publicInst)) {
                        var renderedChildren = inst._renderedChildren;
                        var key;
                        for (key in renderedChildren) {
                            if (!renderedChildren.hasOwnProperty(key)) {
                                continue;
                            }
                            ret = ret.concat(findAllInRenderedTreeInternal(renderedChildren[key], test));
                        }
                    } else if (React.isValidElement(currentElement) && typeof currentElement.type === 'function') {
                        ret = ret.concat(findAllInRenderedTreeInternal(inst._renderedComponent, test));
                    }
                    return ret;
                }

                /**
                 * Utilities for making it easy to test React components.
                 *
                 * See https://facebook.github.io/react/docs/test-utils.html
                 *
                 * Todo: Support the entire DOM.scry query syntax. For now, these simple
                 * utilities will suffice for testing purposes.
                 * @lends ReactTestUtils
                 */
                var ReactTestUtils = {
                    renderIntoDocument: function (element) {
                        var div = document.createElement('div');
                        // None of our tests actually require attaching the container to the
                        // DOM, and doing so creates a mess that we rely on test isolation to
                        // clean up, so we're going to stop honoring the name of this method
                        // (and probably rename it eventually) if no problems arise.
                        // document.documentElement.appendChild(div);
                        return ReactDOM.render(element, div);
                    },

                    isElement: function (element) {
                        return React.isValidElement(element);
                    },

                    isElementOfType: function (inst, convenienceConstructor) {
                        return React.isValidElement(inst) && inst.type === convenienceConstructor;
                    },

                    isDOMComponent: function (inst) {
                        return !!(inst && inst.nodeType === 1 && inst.tagName);
                    },

                    isDOMComponentElement: function (inst) {
                        return !!(inst && React.isValidElement(inst) && !!inst.tagName);
                    },

                    isCompositeComponent: function (inst) {
                        if (ReactTestUtils.isDOMComponent(inst)) {
                            // Accessing inst.setState warns; just return false as that'll be what
                            // this returns when we have DOM nodes as refs directly
                            return false;
                        }
                        return inst != null && typeof inst.render === 'function' && typeof inst.setState === 'function';
                    },

                    isCompositeComponentWithType: function (inst, type) {
                        if (!ReactTestUtils.isCompositeComponent(inst)) {
                            return false;
                        }
                        var internalInstance = ReactInstanceMap.get(inst);
                        var constructor = internalInstance._currentElement.type;

                        return constructor === type;
                    },

                    isCompositeComponentElement: function (inst) {
                        if (!React.isValidElement(inst)) {
                            return false;
                        }
                        // We check the prototype of the type that will get mounted, not the
                        // instance itself. This is a future proof way of duck typing.
                        var prototype = inst.type.prototype;
                        return typeof prototype.render === 'function' && typeof prototype.setState === 'function';
                    },

                    isCompositeComponentElementWithType: function (inst, type) {
                        var internalInstance = ReactInstanceMap.get(inst);
                        var constructor = internalInstance._currentElement.type;

                        return !!(ReactTestUtils.isCompositeComponentElement(inst) && constructor === type);
                    },

                    getRenderedChildOfCompositeComponent: function (inst) {
                        if (!ReactTestUtils.isCompositeComponent(inst)) {
                            return null;
                        }
                        var internalInstance = ReactInstanceMap.get(inst);
                        return internalInstance._renderedComponent.getPublicInstance();
                    },

                    findAllInRenderedTree: function (inst, test) {
                        if (!inst) {
                            return [];
                        }
                        !ReactTestUtils.isCompositeComponent(inst) ? "development" !== 'production' ? invariant(false, 'findAllInRenderedTree(...): instance must be a composite component') : _prodInvariant('10') : void 0;
                        return findAllInRenderedTreeInternal(ReactInstanceMap.get(inst), test);
                    },

                    /**
                     * Finds all instance of components in the rendered tree that are DOM
                     * components with the class name matching `className`.
                     * @return {array} an array of all the matches.
                     */
                    scryRenderedDOMComponentsWithClass: function (root, classNames) {
                        return ReactTestUtils.findAllInRenderedTree(root, function (inst) {
                            if (ReactTestUtils.isDOMComponent(inst)) {
                                var className = inst.className;
                                if (typeof className !== 'string') {
                                    // SVG, probably.
                                    className = inst.getAttribute('class') || '';
                                }
                                var classList = className.split(/\s+/);

                                if (!Array.isArray(classNames)) {
                                    !(classNames !== undefined) ? "development" !== 'production' ? invariant(false, 'TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.') : _prodInvariant('11') : void 0;
                                    classNames = classNames.split(/\s+/);
                                }
                                return classNames.every(function (name) {
                                    return classList.indexOf(name) !== -1;
                                });
                            }
                            return false;
                        });
                    },

                    /**
                     * Like scryRenderedDOMComponentsWithClass but expects there to be one result,
                     * and returns that one result, or throws exception if there is any other
                     * number of matches besides one.
                     * @return {!ReactDOMComponent} The one match.
                     */
                    findRenderedDOMComponentWithClass: function (root, className) {
                        var all = ReactTestUtils.scryRenderedDOMComponentsWithClass(root, className);
                        if (all.length !== 1) {
                            throw new Error('Did not find exactly one match (found: ' + all.length + ') ' + 'for class:' + className);
                        }
                        return all[0];
                    },

                    /**
                     * Finds all instance of components in the rendered tree that are DOM
                     * components with the tag name matching `tagName`.
                     * @return {array} an array of all the matches.
                     */
                    scryRenderedDOMComponentsWithTag: function (root, tagName) {
                        return ReactTestUtils.findAllInRenderedTree(root, function (inst) {
                            return ReactTestUtils.isDOMComponent(inst) && inst.tagName.toUpperCase() === tagName.toUpperCase();
                        });
                    },

                    /**
                     * Like scryRenderedDOMComponentsWithTag but expects there to be one result,
                     * and returns that one result, or throws exception if there is any other
                     * number of matches besides one.
                     * @return {!ReactDOMComponent} The one match.
                     */
                    findRenderedDOMComponentWithTag: function (root, tagName) {
                        var all = ReactTestUtils.scryRenderedDOMComponentsWithTag(root, tagName);
                        if (all.length !== 1) {
                            throw new Error('Did not find exactly one match (found: ' + all.length + ') ' + 'for tag:' + tagName);
                        }
                        return all[0];
                    },

                    /**
                     * Finds all instances of components with type equal to `componentType`.
                     * @return {array} an array of all the matches.
                     */
                    scryRenderedComponentsWithType: function (root, componentType) {
                        return ReactTestUtils.findAllInRenderedTree(root, function (inst) {
                            return ReactTestUtils.isCompositeComponentWithType(inst, componentType);
                        });
                    },

                    /**
                     * Same as `scryRenderedComponentsWithType` but expects there to be one result
                     * and returns that one result, or throws exception if there is any other
                     * number of matches besides one.
                     * @return {!ReactComponent} The one match.
                     */
                    findRenderedComponentWithType: function (root, componentType) {
                        var all = ReactTestUtils.scryRenderedComponentsWithType(root, componentType);
                        if (all.length !== 1) {
                            throw new Error('Did not find exactly one match (found: ' + all.length + ') ' + 'for componentType:' + componentType);
                        }
                        return all[0];
                    },

                    /**
                     * Pass a mocked component module to this method to augment it with
                     * useful methods that allow it to be used as a dummy React component.
                     * Instead of rendering as usual, the component will become a simple
                     * <div> containing any provided children.
                     *
                     * @param {object} module the mock function object exported from a
                     *                        module that defines the component to be mocked
                     * @param {?string} mockTagName optional dummy root tag name to return
                     *                              from render method (overrides
                     *                              module.mockTagName if provided)
                     * @return {object} the ReactTestUtils object (for chaining)
                     */
                    mockComponent: function (module, mockTagName) {
                        mockTagName = mockTagName || module.mockTagName || 'div';

                        module.prototype.render.mockImplementation(function () {
                            return React.createElement(mockTagName, null, this.props.children);
                        });

                        return this;
                    },

                    /**
                     * Simulates a top level event being dispatched from a raw event that occurred
                     * on an `Element` node.
                     * @param {Object} topLevelType A type from `EventConstants.topLevelTypes`
                     * @param {!Element} node The dom to simulate an event occurring on.
                     * @param {?Event} fakeNativeEvent Fake native event to use in SyntheticEvent.
                     */
                    simulateNativeEventOnNode: function (topLevelType, node, fakeNativeEvent) {
                        fakeNativeEvent.target = node;
                        fakeNativeEvent.simulated = true;
                        ReactBrowserEventEmitter.ReactEventListener.dispatchEvent(topLevelType, fakeNativeEvent);
                    },

                    /**
                     * Simulates a top level event being dispatched from a raw event that occurred
                     * on the `ReactDOMComponent` `comp`.
                     * @param {Object} topLevelType A type from `EventConstants.topLevelTypes`.
                     * @param {!ReactDOMComponent} comp
                     * @param {?Event} fakeNativeEvent Fake native event to use in SyntheticEvent.
                     */
                    simulateNativeEventOnDOMComponent: function (topLevelType, comp, fakeNativeEvent) {
                        ReactTestUtils.simulateNativeEventOnNode(topLevelType, findDOMNode(comp), fakeNativeEvent);
                    },

                    nativeTouchData: function (x, y) {
                        return {
                            touches: [{ pageX: x, pageY: y }]
                        };
                    },

                    createRenderer: createRendererWithWarning,

                    Simulate: null,
                    SimulateNative: {}
                };

                /**
                 * Exports:
                 *
                 * - `ReactTestUtils.Simulate.click(Element/ReactDOMComponent)`
                 * - `ReactTestUtils.Simulate.mouseMove(Element/ReactDOMComponent)`
                 * - `ReactTestUtils.Simulate.change(Element/ReactDOMComponent)`
                 * - ... (All keys from event plugin `eventTypes` objects)
                 */
                function makeSimulator(eventType) {
                    return function (domComponentOrNode, eventData) {
                        var node;
                        !!React.isValidElement(domComponentOrNode) ? "development" !== 'production' ? invariant(false, 'TestUtils.Simulate expects a component instance and not a ReactElement.TestUtils.Simulate will not work if you are using shallow rendering.') : _prodInvariant('14') : void 0;
                        if (ReactTestUtils.isDOMComponent(domComponentOrNode)) {
                            node = findDOMNode(domComponentOrNode);
                        } else if (domComponentOrNode.tagName) {
                            node = domComponentOrNode;
                        }

                        var dispatchConfig = EventPluginRegistry.eventNameDispatchConfigs[eventType];

                        var fakeNativeEvent = new Event();
                        fakeNativeEvent.target = node;
                        fakeNativeEvent.type = eventType.toLowerCase();

                        // We don't use SyntheticEvent.getPooled in order to not have to worry about
                        // properly destroying any properties assigned from `eventData` upon release
                        var event = new SyntheticEvent(dispatchConfig, ReactDOMComponentTree.getInstanceFromNode(node), fakeNativeEvent, node);
                        // Since we aren't using pooling, always persist the event. This will make
                        // sure it's marked and won't warn when setting additional properties.
                        event.persist();
                        _assign(event, eventData);

                        if (dispatchConfig.phasedRegistrationNames) {
                            EventPropagators.accumulateTwoPhaseDispatches(event);
                        } else {
                            EventPropagators.accumulateDirectDispatches(event);
                        }

                        ReactUpdates.batchedUpdates(function () {
                            EventPluginHub.enqueueEvents(event);
                            EventPluginHub.processEventQueue(true);
                        });
                    };
                }

                function buildSimulators() {
                    ReactTestUtils.Simulate = {};

                    var eventType;
                    for (eventType in EventPluginRegistry.eventNameDispatchConfigs) {
                        /**
                         * @param {!Element|ReactDOMComponent} domComponentOrNode
                         * @param {?object} eventData Fake event data to use in SyntheticEvent.
                         */
                        ReactTestUtils.Simulate[eventType] = makeSimulator(eventType);
                    }
                }

                // Rebuild ReactTestUtils.Simulate whenever event plugins are injected
                var oldInjectEventPluginOrder = EventPluginHub.injection.injectEventPluginOrder;
                EventPluginHub.injection.injectEventPluginOrder = function () {
                    oldInjectEventPluginOrder.apply(this, arguments);
                    buildSimulators();
                };
                var oldInjectEventPlugins = EventPluginHub.injection.injectEventPluginsByName;
                EventPluginHub.injection.injectEventPluginsByName = function () {
                    oldInjectEventPlugins.apply(this, arguments);
                    buildSimulators();
                };

                buildSimulators();

                /**
                 * Exports:
                 *
                 * - `ReactTestUtils.SimulateNative.click(Element/ReactDOMComponent)`
                 * - `ReactTestUtils.SimulateNative.mouseMove(Element/ReactDOMComponent)`
                 * - `ReactTestUtils.SimulateNative.mouseIn/ReactDOMComponent)`
                 * - `ReactTestUtils.SimulateNative.mouseOut(Element/ReactDOMComponent)`
                 * - ... (All keys from `EventConstants.topLevelTypes`)
                 *
                 * Note: Top level event types are a subset of the entire set of handler types
                 * (which include a broader set of "synthetic" events). For example, onDragDone
                 * is a synthetic event. Except when testing an event plugin or React's event
                 * handling code specifically, you probably want to use ReactTestUtils.Simulate
                 * to dispatch synthetic events.
                 */

                function makeNativeSimulator(eventType) {
                    return function (domComponentOrNode, nativeEventData) {
                        var fakeNativeEvent = new Event(eventType);
                        _assign(fakeNativeEvent, nativeEventData);
                        if (ReactTestUtils.isDOMComponent(domComponentOrNode)) {
                            ReactTestUtils.simulateNativeEventOnDOMComponent(eventType, domComponentOrNode, fakeNativeEvent);
                        } else if (domComponentOrNode.tagName) {
                            // Will allow on actual dom nodes.
                            ReactTestUtils.simulateNativeEventOnNode(eventType, domComponentOrNode, fakeNativeEvent);
                        }
                    };
                }

                Object.keys(topLevelTypes).forEach(function (eventType) {
                    // Event type is stored as 'topClick' - we transform that to 'click'
                    var convenienceName = eventType.indexOf('top') === 0 ? eventType.charAt(3).toLowerCase() + eventType.substr(4) : eventType;
                    /**
                     * @param {!Element|ReactDOMComponent} domComponentOrNode
                     * @param {?Event} nativeEventData Fake native event to use in SyntheticEvent.
                     */
                    ReactTestUtils.SimulateNative[convenienceName] = makeNativeSimulator(eventType);
                });

                module.exports = ReactTestUtils;
            }, { "108": 108, "126": 126, "135": 135, "152": 152, "159": 159, "16": 16, "160": 160, "17": 17, "18": 18, "20": 20, "26": 26, "31": 31, "34": 34, "63": 63, "79": 79, "82": 82, "91": 91 }], 81: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var ReactCurrentOwner = _dereq_(134);
                var ReactInstanceMap = _dereq_(63);
                var ReactInstrumentation = _dereq_(64);
                var ReactUpdates = _dereq_(82);

                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                function enqueueUpdate(internalInstance) {
                    ReactUpdates.enqueueUpdate(internalInstance);
                }

                function formatUnexpectedArgument(arg) {
                    var type = typeof arg;
                    if (type !== 'object') {
                        return type;
                    }
                    var displayName = arg.constructor && arg.constructor.name || type;
                    var keys = Object.keys(arg);
                    if (keys.length > 0 && keys.length < 20) {
                        return displayName + ' (keys: ' + keys.join(', ') + ')';
                    }
                    return displayName;
                }

                function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
                    var internalInstance = ReactInstanceMap.get(publicInstance);
                    if (!internalInstance) {
                        if ("development" !== 'production') {
                            var ctor = publicInstance.constructor;
                            // Only warn when we have a callerName. Otherwise we should be silent.
                            // We're probably calling from enqueueCallback. We don't want to warn
                            // there because we already warned for the corresponding lifecycle method.
                            "development" !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
                        }
                        return null;
                    }

                    if ("development" !== 'production') {
                        "development" !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
                    }

                    return internalInstance;
                }

                /**
                 * ReactUpdateQueue allows for state updates to be scheduled into a later
                 * reconciliation step.
                 */
                var ReactUpdateQueue = {
                    /**
                     * Checks whether or not this composite component is mounted.
                     * @param {ReactClass} publicInstance The instance we want to test.
                     * @return {boolean} True if mounted, false otherwise.
                     * @protected
                     * @final
                     */
                    isMounted: function (publicInstance) {
                        if ("development" !== 'production') {
                            var owner = ReactCurrentOwner.current;
                            if (owner !== null) {
                                "development" !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
                                owner._warnedAboutRefsInRender = true;
                            }
                        }
                        var internalInstance = ReactInstanceMap.get(publicInstance);
                        if (internalInstance) {
                            // During componentWillMount and render this will still be null but after
                            // that will always render to something. At least for now. So we can use
                            // this hack.
                            return !!internalInstance._renderedComponent;
                        } else {
                            return false;
                        }
                    },

                    /**
                     * Enqueue a callback that will be executed after all the pending updates
                     * have processed.
                     *
                     * @param {ReactClass} publicInstance The instance to use as `this` context.
                     * @param {?function} callback Called after state is updated.
                     * @param {string} callerName Name of the calling function in the public API.
                     * @internal
                     */
                    enqueueCallback: function (publicInstance, callback, callerName) {
                        ReactUpdateQueue.validateCallback(callback, callerName);
                        var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

                        // Previously we would throw an error if we didn't have an internal
                        // instance. Since we want to make it a no-op instead, we mirror the same
                        // behavior we have in other enqueue* methods.
                        // We also need to ignore callbacks in componentWillMount. See
                        // enqueueUpdates.
                        if (!internalInstance) {
                            return null;
                        }

                        if (internalInstance._pendingCallbacks) {
                            internalInstance._pendingCallbacks.push(callback);
                        } else {
                            internalInstance._pendingCallbacks = [callback];
                        }
                        // TODO: The callback here is ignored when setState is called from
                        // componentWillMount. Either fix it or disallow doing so completely in
                        // favor of getInitialState. Alternatively, we can disallow
                        // componentWillMount during server-side rendering.
                        enqueueUpdate(internalInstance);
                    },

                    enqueueCallbackInternal: function (internalInstance, callback) {
                        if (internalInstance._pendingCallbacks) {
                            internalInstance._pendingCallbacks.push(callback);
                        } else {
                            internalInstance._pendingCallbacks = [callback];
                        }
                        enqueueUpdate(internalInstance);
                    },

                    /**
                     * Forces an update. This should only be invoked when it is known with
                     * certainty that we are **not** in a DOM transaction.
                     *
                     * You may want to call this when you know that some deeper aspect of the
                     * component's state has changed but `setState` was not called.
                     *
                     * This will not invoke `shouldComponentUpdate`, but it will invoke
                     * `componentWillUpdate` and `componentDidUpdate`.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @internal
                     */
                    enqueueForceUpdate: function (publicInstance) {
                        var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

                        if (!internalInstance) {
                            return;
                        }

                        internalInstance._pendingForceUpdate = true;

                        enqueueUpdate(internalInstance);
                    },

                    /**
                     * Replaces all of the state. Always use this or `setState` to mutate state.
                     * You should treat `this.state` as immutable.
                     *
                     * There is no guarantee that `this.state` will be immediately updated, so
                     * accessing `this.state` after calling this method may return the old value.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object} completeState Next state.
                     * @internal
                     */
                    enqueueReplaceState: function (publicInstance, completeState, callback) {
                        var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

                        if (!internalInstance) {
                            return;
                        }

                        internalInstance._pendingStateQueue = [completeState];
                        internalInstance._pendingReplaceState = true;

                        // Future-proof 15.5
                        if (callback !== undefined && callback !== null) {
                            ReactUpdateQueue.validateCallback(callback, 'replaceState');
                            if (internalInstance._pendingCallbacks) {
                                internalInstance._pendingCallbacks.push(callback);
                            } else {
                                internalInstance._pendingCallbacks = [callback];
                            }
                        }

                        enqueueUpdate(internalInstance);
                    },

                    /**
                     * Sets a subset of the state. This only exists because _pendingState is
                     * internal. This provides a merging strategy that is not available to deep
                     * properties which is confusing. TODO: Expose pendingState or don't use it
                     * during the merge.
                     *
                     * @param {ReactClass} publicInstance The instance that should rerender.
                     * @param {object} partialState Next partial state to be merged with state.
                     * @internal
                     */
                    enqueueSetState: function (publicInstance, partialState) {
                        if ("development" !== 'production') {
                            ReactInstrumentation.debugTool.onSetState();
                            "development" !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
                        }

                        var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

                        if (!internalInstance) {
                            return;
                        }

                        var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
                        queue.push(partialState);

                        enqueueUpdate(internalInstance);
                    },

                    enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
                        internalInstance._pendingElement = nextElement;
                        // TODO: introduce _pendingContext instead of setting it directly.
                        internalInstance._context = nextContext;
                        enqueueUpdate(internalInstance);
                    },

                    validateCallback: function (callback, callerName) {
                        !(!callback || typeof callback === 'function') ? "development" !== 'production' ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
                    }
                };

                module.exports = ReactUpdateQueue;
            }, { "126": 126, "134": 134, "152": 152, "159": 159, "63": 63, "64": 64, "82": 82 }], 82: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var CallbackQueue = _dereq_(6);
                var PooledClass = _dereq_(25);
                var ReactFeatureFlags = _dereq_(58);
                var ReactReconciler = _dereq_(75);
                var Transaction = _dereq_(100);

                var invariant = _dereq_(152);

                var dirtyComponents = [];
                var updateBatchNumber = 0;
                var asapCallbackQueue = CallbackQueue.getPooled();
                var asapEnqueued = false;

                var batchingStrategy = null;

                function ensureInjected() {
                    !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? "development" !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
                }

                var NESTED_UPDATES = {
                    initialize: function () {
                        this.dirtyComponentsLength = dirtyComponents.length;
                    },
                    close: function () {
                        if (this.dirtyComponentsLength !== dirtyComponents.length) {
                            // Additional updates were enqueued by componentDidUpdate handlers or
                            // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
                            // these new updates so that if A's componentDidUpdate calls setState on
                            // B, B will update before the callback A's updater provided when calling
                            // setState.
                            dirtyComponents.splice(0, this.dirtyComponentsLength);
                            flushBatchedUpdates();
                        } else {
                            dirtyComponents.length = 0;
                        }
                    }
                };

                var UPDATE_QUEUEING = {
                    initialize: function () {
                        this.callbackQueue.reset();
                    },
                    close: function () {
                        this.callbackQueue.notifyAll();
                    }
                };

                var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

                function ReactUpdatesFlushTransaction() {
                    this.reinitializeTransaction();
                    this.dirtyComponentsLength = null;
                    this.callbackQueue = CallbackQueue.getPooled();
                    this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
                }

                _assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
                    getTransactionWrappers: function () {
                        return TRANSACTION_WRAPPERS;
                    },

                    destructor: function () {
                        this.dirtyComponentsLength = null;
                        CallbackQueue.release(this.callbackQueue);
                        this.callbackQueue = null;
                        ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
                        this.reconcileTransaction = null;
                    },

                    perform: function (method, scope, a) {
                        // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
                        // with this transaction's wrappers around it.
                        return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
                    }
                });

                PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

                function batchedUpdates(callback, a, b, c, d, e) {
                    ensureInjected();
                    return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
                }

                /**
                 * Array comparator for ReactComponents by mount ordering.
                 *
                 * @param {ReactComponent} c1 first component you're comparing
                 * @param {ReactComponent} c2 second component you're comparing
                 * @return {number} Return value usable by Array.prototype.sort().
                 */
                function mountOrderComparator(c1, c2) {
                    return c1._mountOrder - c2._mountOrder;
                }

                function runBatchedUpdates(transaction) {
                    var len = transaction.dirtyComponentsLength;
                    !(len === dirtyComponents.length) ? "development" !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

                    // Since reconciling a component higher in the owner hierarchy usually (not
                    // always -- see shouldComponentUpdate()) will reconcile children, reconcile
                    // them before their children by sorting the array.
                    dirtyComponents.sort(mountOrderComparator);

                    // Any updates enqueued while reconciling must be performed after this entire
                    // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
                    // C, B could update twice in a single batch if C's render enqueues an update
                    // to B (since B would have already updated, we should skip it, and the only
                    // way we can know to do so is by checking the batch counter).
                    updateBatchNumber++;

                    for (var i = 0; i < len; i++) {
                        // If a component is unmounted before pending changes apply, it will still
                        // be here, but we assume that it has cleared its _pendingCallbacks and
                        // that performUpdateIfNecessary is a noop.
                        var component = dirtyComponents[i];

                        // If performUpdateIfNecessary happens to enqueue any new updates, we
                        // shouldn't execute the callbacks until the next render happens, so
                        // stash the callbacks first
                        var callbacks = component._pendingCallbacks;
                        component._pendingCallbacks = null;

                        var markerName;
                        if (ReactFeatureFlags.logTopLevelRenders) {
                            var namedComponent = component;
                            // Duck type TopLevelWrapper. This is probably always true.
                            if (component._currentElement.type.isReactTopLevelWrapper) {
                                namedComponent = component._renderedComponent;
                            }
                            markerName = 'React update: ' + namedComponent.getName();
                            console.time(markerName);
                        }

                        ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

                        if (markerName) {
                            console.timeEnd(markerName);
                        }

                        if (callbacks) {
                            for (var j = 0; j < callbacks.length; j++) {
                                transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
                            }
                        }
                    }
                }

                var flushBatchedUpdates = function () {
                    // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
                    // array and perform any updates enqueued by mount-ready handlers (i.e.,
                    // componentDidUpdate) but we need to check here too in order to catch
                    // updates enqueued by setState callbacks and asap calls.
                    while (dirtyComponents.length || asapEnqueued) {
                        if (dirtyComponents.length) {
                            var transaction = ReactUpdatesFlushTransaction.getPooled();
                            transaction.perform(runBatchedUpdates, null, transaction);
                            ReactUpdatesFlushTransaction.release(transaction);
                        }

                        if (asapEnqueued) {
                            asapEnqueued = false;
                            var queue = asapCallbackQueue;
                            asapCallbackQueue = CallbackQueue.getPooled();
                            queue.notifyAll();
                            CallbackQueue.release(queue);
                        }
                    }
                };

                /**
                 * Mark a component as needing a rerender, adding an optional callback to a
                 * list of functions which will be executed once the rerender occurs.
                 */
                function enqueueUpdate(component) {
                    ensureInjected();

                    // Various parts of our code (such as ReactCompositeComponent's
                    // _renderValidatedComponent) assume that calls to render aren't nested;
                    // verify that that's the case. (This is called by each top-level update
                    // function, like setState, forceUpdate, etc.; creation and
                    // destruction of top-level components is guarded in ReactMount.)

                    if (!batchingStrategy.isBatchingUpdates) {
                        batchingStrategy.batchedUpdates(enqueueUpdate, component);
                        return;
                    }

                    dirtyComponents.push(component);
                    if (component._updateBatchNumber == null) {
                        component._updateBatchNumber = updateBatchNumber + 1;
                    }
                }

                /**
                 * Enqueue a callback to be run at the end of the current batching cycle. Throws
                 * if no updates are currently being performed.
                 */
                function asap(callback, context) {
                    !batchingStrategy.isBatchingUpdates ? "development" !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
                    asapCallbackQueue.enqueue(callback, context);
                    asapEnqueued = true;
                }

                var ReactUpdatesInjection = {
                    injectReconcileTransaction: function (ReconcileTransaction) {
                        !ReconcileTransaction ? "development" !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
                        ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
                    },

                    injectBatchingStrategy: function (_batchingStrategy) {
                        !_batchingStrategy ? "development" !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
                        !(typeof _batchingStrategy.batchedUpdates === 'function') ? "development" !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
                        !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? "development" !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
                        batchingStrategy = _batchingStrategy;
                    }
                };

                var ReactUpdates = {
                    /**
                     * React references `ReactReconcileTransaction` using this property in order
                     * to allow dependency injection.
                     *
                     * @internal
                     */
                    ReactReconcileTransaction: null,

                    batchedUpdates: batchedUpdates,
                    enqueueUpdate: enqueueUpdate,
                    flushBatchedUpdates: flushBatchedUpdates,
                    injection: ReactUpdatesInjection,
                    asap: asap
                };

                module.exports = ReactUpdates;
            }, { "100": 100, "126": 126, "152": 152, "160": 160, "25": 25, "58": 58, "6": 6, "75": 75 }], 83: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                module.exports = '15.6.1';
            }, {}], 84: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var NS = {
                    xlink: 'http://www.w3.org/1999/xlink',
                    xml: 'http://www.w3.org/XML/1998/namespace'
                };

                // We use attributes for everything SVG so let's avoid some duplication and run
                // code instead.
                // The following are all specified in the HTML config already so we exclude here.
                // - class (as className)
                // - color
                // - height
                // - id
                // - lang
                // - max
                // - media
                // - method
                // - min
                // - name
                // - style
                // - target
                // - type
                // - width
                var ATTRS = {
                    accentHeight: 'accent-height',
                    accumulate: 0,
                    additive: 0,
                    alignmentBaseline: 'alignment-baseline',
                    allowReorder: 'allowReorder',
                    alphabetic: 0,
                    amplitude: 0,
                    arabicForm: 'arabic-form',
                    ascent: 0,
                    attributeName: 'attributeName',
                    attributeType: 'attributeType',
                    autoReverse: 'autoReverse',
                    azimuth: 0,
                    baseFrequency: 'baseFrequency',
                    baseProfile: 'baseProfile',
                    baselineShift: 'baseline-shift',
                    bbox: 0,
                    begin: 0,
                    bias: 0,
                    by: 0,
                    calcMode: 'calcMode',
                    capHeight: 'cap-height',
                    clip: 0,
                    clipPath: 'clip-path',
                    clipRule: 'clip-rule',
                    clipPathUnits: 'clipPathUnits',
                    colorInterpolation: 'color-interpolation',
                    colorInterpolationFilters: 'color-interpolation-filters',
                    colorProfile: 'color-profile',
                    colorRendering: 'color-rendering',
                    contentScriptType: 'contentScriptType',
                    contentStyleType: 'contentStyleType',
                    cursor: 0,
                    cx: 0,
                    cy: 0,
                    d: 0,
                    decelerate: 0,
                    descent: 0,
                    diffuseConstant: 'diffuseConstant',
                    direction: 0,
                    display: 0,
                    divisor: 0,
                    dominantBaseline: 'dominant-baseline',
                    dur: 0,
                    dx: 0,
                    dy: 0,
                    edgeMode: 'edgeMode',
                    elevation: 0,
                    enableBackground: 'enable-background',
                    end: 0,
                    exponent: 0,
                    externalResourcesRequired: 'externalResourcesRequired',
                    fill: 0,
                    fillOpacity: 'fill-opacity',
                    fillRule: 'fill-rule',
                    filter: 0,
                    filterRes: 'filterRes',
                    filterUnits: 'filterUnits',
                    floodColor: 'flood-color',
                    floodOpacity: 'flood-opacity',
                    focusable: 0,
                    fontFamily: 'font-family',
                    fontSize: 'font-size',
                    fontSizeAdjust: 'font-size-adjust',
                    fontStretch: 'font-stretch',
                    fontStyle: 'font-style',
                    fontVariant: 'font-variant',
                    fontWeight: 'font-weight',
                    format: 0,
                    from: 0,
                    fx: 0,
                    fy: 0,
                    g1: 0,
                    g2: 0,
                    glyphName: 'glyph-name',
                    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
                    glyphOrientationVertical: 'glyph-orientation-vertical',
                    glyphRef: 'glyphRef',
                    gradientTransform: 'gradientTransform',
                    gradientUnits: 'gradientUnits',
                    hanging: 0,
                    horizAdvX: 'horiz-adv-x',
                    horizOriginX: 'horiz-origin-x',
                    ideographic: 0,
                    imageRendering: 'image-rendering',
                    'in': 0,
                    in2: 0,
                    intercept: 0,
                    k: 0,
                    k1: 0,
                    k2: 0,
                    k3: 0,
                    k4: 0,
                    kernelMatrix: 'kernelMatrix',
                    kernelUnitLength: 'kernelUnitLength',
                    kerning: 0,
                    keyPoints: 'keyPoints',
                    keySplines: 'keySplines',
                    keyTimes: 'keyTimes',
                    lengthAdjust: 'lengthAdjust',
                    letterSpacing: 'letter-spacing',
                    lightingColor: 'lighting-color',
                    limitingConeAngle: 'limitingConeAngle',
                    local: 0,
                    markerEnd: 'marker-end',
                    markerMid: 'marker-mid',
                    markerStart: 'marker-start',
                    markerHeight: 'markerHeight',
                    markerUnits: 'markerUnits',
                    markerWidth: 'markerWidth',
                    mask: 0,
                    maskContentUnits: 'maskContentUnits',
                    maskUnits: 'maskUnits',
                    mathematical: 0,
                    mode: 0,
                    numOctaves: 'numOctaves',
                    offset: 0,
                    opacity: 0,
                    operator: 0,
                    order: 0,
                    orient: 0,
                    orientation: 0,
                    origin: 0,
                    overflow: 0,
                    overlinePosition: 'overline-position',
                    overlineThickness: 'overline-thickness',
                    paintOrder: 'paint-order',
                    panose1: 'panose-1',
                    pathLength: 'pathLength',
                    patternContentUnits: 'patternContentUnits',
                    patternTransform: 'patternTransform',
                    patternUnits: 'patternUnits',
                    pointerEvents: 'pointer-events',
                    points: 0,
                    pointsAtX: 'pointsAtX',
                    pointsAtY: 'pointsAtY',
                    pointsAtZ: 'pointsAtZ',
                    preserveAlpha: 'preserveAlpha',
                    preserveAspectRatio: 'preserveAspectRatio',
                    primitiveUnits: 'primitiveUnits',
                    r: 0,
                    radius: 0,
                    refX: 'refX',
                    refY: 'refY',
                    renderingIntent: 'rendering-intent',
                    repeatCount: 'repeatCount',
                    repeatDur: 'repeatDur',
                    requiredExtensions: 'requiredExtensions',
                    requiredFeatures: 'requiredFeatures',
                    restart: 0,
                    result: 0,
                    rotate: 0,
                    rx: 0,
                    ry: 0,
                    scale: 0,
                    seed: 0,
                    shapeRendering: 'shape-rendering',
                    slope: 0,
                    spacing: 0,
                    specularConstant: 'specularConstant',
                    specularExponent: 'specularExponent',
                    speed: 0,
                    spreadMethod: 'spreadMethod',
                    startOffset: 'startOffset',
                    stdDeviation: 'stdDeviation',
                    stemh: 0,
                    stemv: 0,
                    stitchTiles: 'stitchTiles',
                    stopColor: 'stop-color',
                    stopOpacity: 'stop-opacity',
                    strikethroughPosition: 'strikethrough-position',
                    strikethroughThickness: 'strikethrough-thickness',
                    string: 0,
                    stroke: 0,
                    strokeDasharray: 'stroke-dasharray',
                    strokeDashoffset: 'stroke-dashoffset',
                    strokeLinecap: 'stroke-linecap',
                    strokeLinejoin: 'stroke-linejoin',
                    strokeMiterlimit: 'stroke-miterlimit',
                    strokeOpacity: 'stroke-opacity',
                    strokeWidth: 'stroke-width',
                    surfaceScale: 'surfaceScale',
                    systemLanguage: 'systemLanguage',
                    tableValues: 'tableValues',
                    targetX: 'targetX',
                    targetY: 'targetY',
                    textAnchor: 'text-anchor',
                    textDecoration: 'text-decoration',
                    textRendering: 'text-rendering',
                    textLength: 'textLength',
                    to: 0,
                    transform: 0,
                    u1: 0,
                    u2: 0,
                    underlinePosition: 'underline-position',
                    underlineThickness: 'underline-thickness',
                    unicode: 0,
                    unicodeBidi: 'unicode-bidi',
                    unicodeRange: 'unicode-range',
                    unitsPerEm: 'units-per-em',
                    vAlphabetic: 'v-alphabetic',
                    vHanging: 'v-hanging',
                    vIdeographic: 'v-ideographic',
                    vMathematical: 'v-mathematical',
                    values: 0,
                    vectorEffect: 'vector-effect',
                    version: 0,
                    vertAdvY: 'vert-adv-y',
                    vertOriginX: 'vert-origin-x',
                    vertOriginY: 'vert-origin-y',
                    viewBox: 'viewBox',
                    viewTarget: 'viewTarget',
                    visibility: 0,
                    widths: 0,
                    wordSpacing: 'word-spacing',
                    writingMode: 'writing-mode',
                    x: 0,
                    xHeight: 'x-height',
                    x1: 0,
                    x2: 0,
                    xChannelSelector: 'xChannelSelector',
                    xlinkActuate: 'xlink:actuate',
                    xlinkArcrole: 'xlink:arcrole',
                    xlinkHref: 'xlink:href',
                    xlinkRole: 'xlink:role',
                    xlinkShow: 'xlink:show',
                    xlinkTitle: 'xlink:title',
                    xlinkType: 'xlink:type',
                    xmlBase: 'xml:base',
                    xmlns: 0,
                    xmlnsXlink: 'xmlns:xlink',
                    xmlLang: 'xml:lang',
                    xmlSpace: 'xml:space',
                    y: 0,
                    y1: 0,
                    y2: 0,
                    yChannelSelector: 'yChannelSelector',
                    z: 0,
                    zoomAndPan: 'zoomAndPan'
                };

                var SVGDOMPropertyConfig = {
                    Properties: {},
                    DOMAttributeNamespaces: {
                        xlinkActuate: NS.xlink,
                        xlinkArcrole: NS.xlink,
                        xlinkHref: NS.xlink,
                        xlinkRole: NS.xlink,
                        xlinkShow: NS.xlink,
                        xlinkTitle: NS.xlink,
                        xlinkType: NS.xlink,
                        xmlBase: NS.xml,
                        xmlLang: NS.xml,
                        xmlSpace: NS.xml
                    },
                    DOMAttributeNames: {}
                };

                Object.keys(ATTRS).forEach(function (key) {
                    SVGDOMPropertyConfig.Properties[key] = 0;
                    if (ATTRS[key]) {
                        SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
                    }
                });

                module.exports = SVGDOMPropertyConfig;
            }, {}], 85: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var EventPropagators = _dereq_(20);
                var ExecutionEnvironment = _dereq_(138);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactInputSelection = _dereq_(62);
                var SyntheticEvent = _dereq_(91);

                var getActiveElement = _dereq_(147);
                var isTextInputElement = _dereq_(123);
                var shallowEqual = _dereq_(158);

                var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

                var eventTypes = {
                    select: {
                        phasedRegistrationNames: {
                            bubbled: 'onSelect',
                            captured: 'onSelectCapture'
                        },
                        dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
                    }
                };

                var activeElement = null;
                var activeElementInst = null;
                var lastSelection = null;
                var mouseDown = false;

                // Track whether a listener exists for this plugin. If none exist, we do
                // not extract events. See #3639.
                var hasListener = false;

                /**
                 * Get an object which is a unique representation of the current selection.
                 *
                 * The return value will not be consistent across nodes or browsers, but
                 * two identical selections on the same node will return identical objects.
                 *
                 * @param {DOMElement} node
                 * @return {object}
                 */
                function getSelection(node) {
                    if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
                        return {
                            start: node.selectionStart,
                            end: node.selectionEnd
                        };
                    } else if (window.getSelection) {
                        var selection = window.getSelection();
                        return {
                            anchorNode: selection.anchorNode,
                            anchorOffset: selection.anchorOffset,
                            focusNode: selection.focusNode,
                            focusOffset: selection.focusOffset
                        };
                    } else if (document.selection) {
                        var range = document.selection.createRange();
                        return {
                            parentElement: range.parentElement(),
                            text: range.text,
                            top: range.boundingTop,
                            left: range.boundingLeft
                        };
                    }
                }

                /**
                 * Poll selection to see whether it's changed.
                 *
                 * @param {object} nativeEvent
                 * @return {?SyntheticEvent}
                 */
                function constructSelectEvent(nativeEvent, nativeEventTarget) {
                    // Ensure we have the right element, and that the user is not dragging a
                    // selection (this matches native `select` event behavior). In HTML5, select
                    // fires only on input and textarea thus if there's no focused element we
                    // won't dispatch.
                    if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
                        return null;
                    }

                    // Only fire when selection has actually changed.
                    var currentSelection = getSelection(activeElement);
                    if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
                        lastSelection = currentSelection;

                        var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

                        syntheticEvent.type = 'select';
                        syntheticEvent.target = activeElement;

                        EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

                        return syntheticEvent;
                    }

                    return null;
                }

                /**
                 * This plugin creates an `onSelect` event that normalizes select events
                 * across form elements.
                 *
                 * Supported elements are:
                 * - input (see `isTextInputElement`)
                 * - textarea
                 * - contentEditable
                 *
                 * This differs from native browser implementations in the following ways:
                 * - Fires on contentEditable fields as well as inputs.
                 * - Fires for collapsed selection.
                 * - Fires after user input.
                 */
                var SelectEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        if (!hasListener) {
                            return null;
                        }

                        var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

                        switch (topLevelType) {
                            // Track the input node that has focus.
                            case 'topFocus':
                                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                                    activeElement = targetNode;
                                    activeElementInst = targetInst;
                                    lastSelection = null;
                                }
                                break;
                            case 'topBlur':
                                activeElement = null;
                                activeElementInst = null;
                                lastSelection = null;
                                break;
                            // Don't fire the event while the user is dragging. This matches the
                            // semantics of the native select event.
                            case 'topMouseDown':
                                mouseDown = true;
                                break;
                            case 'topContextMenu':
                            case 'topMouseUp':
                                mouseDown = false;
                                return constructSelectEvent(nativeEvent, nativeEventTarget);
                            // Chrome and IE fire non-standard event when selection is changed (and
                            // sometimes when it hasn't). IE's event fires out of order with respect
                            // to key and input events on deletion, so we discard it.
                            //
                            // Firefox doesn't support selectionchange, so check selection status
                            // after each key entry. The selection changes after keydown and before
                            // keyup, but we check on keydown as well in the case of holding down a
                            // key, when multiple keydown events are fired but only one keyup is.
                            // This is also our approach for IE handling, for the reason above.
                            case 'topSelectionChange':
                                if (skipSelectionChangeEvent) {
                                    break;
                                }
                            // falls through
                            case 'topKeyDown':
                            case 'topKeyUp':
                                return constructSelectEvent(nativeEvent, nativeEventTarget);
                        }

                        return null;
                    },

                    didPutListener: function (inst, registrationName, listener) {
                        if (registrationName === 'onSelect') {
                            hasListener = true;
                        }
                    }
                };

                module.exports = SelectEventPlugin;
            }, { "123": 123, "138": 138, "147": 147, "158": 158, "20": 20, "34": 34, "62": 62, "91": 91 }], 86: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var EventListener = _dereq_(137);
                var EventPropagators = _dereq_(20);
                var ReactDOMComponentTree = _dereq_(34);
                var SyntheticAnimationEvent = _dereq_(87);
                var SyntheticClipboardEvent = _dereq_(88);
                var SyntheticEvent = _dereq_(91);
                var SyntheticFocusEvent = _dereq_(92);
                var SyntheticKeyboardEvent = _dereq_(94);
                var SyntheticMouseEvent = _dereq_(95);
                var SyntheticDragEvent = _dereq_(90);
                var SyntheticTouchEvent = _dereq_(96);
                var SyntheticTransitionEvent = _dereq_(97);
                var SyntheticUIEvent = _dereq_(98);
                var SyntheticWheelEvent = _dereq_(99);

                var emptyFunction = _dereq_(144);
                var getEventCharCode = _dereq_(111);
                var invariant = _dereq_(152);

                /**
                 * Turns
                 * ['abort', ...]
                 * into
                 * eventTypes = {
                 *   'abort': {
                 *     phasedRegistrationNames: {
                 *       bubbled: 'onAbort',
                 *       captured: 'onAbortCapture',
                 *     },
                 *     dependencies: ['topAbort'],
                 *   },
                 *   ...
                 * };
                 * topLevelEventsToDispatchConfig = {
                 *   'topAbort': { sameConfig }
                 * };
                 */
                var eventTypes = {};
                var topLevelEventsToDispatchConfig = {};
                ['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
                    var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
                    var onEvent = 'on' + capitalizedEvent;
                    var topEvent = 'top' + capitalizedEvent;

                    var type = {
                        phasedRegistrationNames: {
                            bubbled: onEvent,
                            captured: onEvent + 'Capture'
                        },
                        dependencies: [topEvent]
                    };
                    eventTypes[event] = type;
                    topLevelEventsToDispatchConfig[topEvent] = type;
                });

                var onClickListeners = {};

                function getDictionaryKey(inst) {
                    // Prevents V8 performance issue:
                    // https://github.com/facebook/react/pull/7232
                    return '.' + inst._rootNodeID;
                }

                function isInteractive(tag) {
                    return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
                }

                var SimpleEventPlugin = {
                    eventTypes: eventTypes,

                    extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
                        var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
                        if (!dispatchConfig) {
                            return null;
                        }
                        var EventConstructor;
                        switch (topLevelType) {
                            case 'topAbort':
                            case 'topCanPlay':
                            case 'topCanPlayThrough':
                            case 'topDurationChange':
                            case 'topEmptied':
                            case 'topEncrypted':
                            case 'topEnded':
                            case 'topError':
                            case 'topInput':
                            case 'topInvalid':
                            case 'topLoad':
                            case 'topLoadedData':
                            case 'topLoadedMetadata':
                            case 'topLoadStart':
                            case 'topPause':
                            case 'topPlay':
                            case 'topPlaying':
                            case 'topProgress':
                            case 'topRateChange':
                            case 'topReset':
                            case 'topSeeked':
                            case 'topSeeking':
                            case 'topStalled':
                            case 'topSubmit':
                            case 'topSuspend':
                            case 'topTimeUpdate':
                            case 'topVolumeChange':
                            case 'topWaiting':
                                // HTML Events
                                // @see http://www.w3.org/TR/html5/index.html#events-0
                                EventConstructor = SyntheticEvent;
                                break;
                            case 'topKeyPress':
                                // Firefox creates a keypress event for function keys too. This removes
                                // the unwanted keypress events. Enter is however both printable and
                                // non-printable. One would expect Tab to be as well (but it isn't).
                                if (getEventCharCode(nativeEvent) === 0) {
                                    return null;
                                }
                            /* falls through */
                            case 'topKeyDown':
                            case 'topKeyUp':
                                EventConstructor = SyntheticKeyboardEvent;
                                break;
                            case 'topBlur':
                            case 'topFocus':
                                EventConstructor = SyntheticFocusEvent;
                                break;
                            case 'topClick':
                                // Firefox creates a click event on right mouse clicks. This removes the
                                // unwanted click events.
                                if (nativeEvent.button === 2) {
                                    return null;
                                }
                            /* falls through */
                            case 'topDoubleClick':
                            case 'topMouseDown':
                            case 'topMouseMove':
                            case 'topMouseUp':
                            // TODO: Disabled elements should not respond to mouse events
                            /* falls through */
                            case 'topMouseOut':
                            case 'topMouseOver':
                            case 'topContextMenu':
                                EventConstructor = SyntheticMouseEvent;
                                break;
                            case 'topDrag':
                            case 'topDragEnd':
                            case 'topDragEnter':
                            case 'topDragExit':
                            case 'topDragLeave':
                            case 'topDragOver':
                            case 'topDragStart':
                            case 'topDrop':
                                EventConstructor = SyntheticDragEvent;
                                break;
                            case 'topTouchCancel':
                            case 'topTouchEnd':
                            case 'topTouchMove':
                            case 'topTouchStart':
                                EventConstructor = SyntheticTouchEvent;
                                break;
                            case 'topAnimationEnd':
                            case 'topAnimationIteration':
                            case 'topAnimationStart':
                                EventConstructor = SyntheticAnimationEvent;
                                break;
                            case 'topTransitionEnd':
                                EventConstructor = SyntheticTransitionEvent;
                                break;
                            case 'topScroll':
                                EventConstructor = SyntheticUIEvent;
                                break;
                            case 'topWheel':
                                EventConstructor = SyntheticWheelEvent;
                                break;
                            case 'topCopy':
                            case 'topCut':
                            case 'topPaste':
                                EventConstructor = SyntheticClipboardEvent;
                                break;
                        }
                        !EventConstructor ? "development" !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
                        var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
                        EventPropagators.accumulateTwoPhaseDispatches(event);
                        return event;
                    },

                    didPutListener: function (inst, registrationName, listener) {
                        // Mobile Safari does not fire properly bubble click events on
                        // non-interactive elements, which means delegated click listeners do not
                        // fire. The workaround for this bug involves attaching an empty click
                        // listener on the target node.
                        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
                        if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
                            var key = getDictionaryKey(inst);
                            var node = ReactDOMComponentTree.getNodeFromInstance(inst);
                            if (!onClickListeners[key]) {
                                onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
                            }
                        }
                    },

                    willDeleteListener: function (inst, registrationName) {
                        if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
                            var key = getDictionaryKey(inst);
                            onClickListeners[key].remove();
                            delete onClickListeners[key];
                        }
                    }
                };

                module.exports = SimpleEventPlugin;
            }, { "111": 111, "126": 126, "137": 137, "144": 144, "152": 152, "20": 20, "34": 34, "87": 87, "88": 88, "90": 90, "91": 91, "92": 92, "94": 94, "95": 95, "96": 96, "97": 97, "98": 98, "99": 99 }], 87: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticEvent = _dereq_(91);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
                 */
                var AnimationEventInterface = {
                    animationName: null,
                    elapsedTime: null,
                    pseudoElement: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticEvent}
                 */
                function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

                module.exports = SyntheticAnimationEvent;
            }, { "91": 91 }], 88: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticEvent = _dereq_(91);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/clipboard-apis/
                 */
                var ClipboardEventInterface = {
                    clipboardData: function (event) {
                        return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
                    }
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

                module.exports = SyntheticClipboardEvent;
            }, { "91": 91 }], 89: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticEvent = _dereq_(91);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
                 */
                var CompositionEventInterface = {
                    data: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

                module.exports = SyntheticCompositionEvent;
            }, { "91": 91 }], 90: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticMouseEvent = _dereq_(95);

                /**
                 * @interface DragEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var DragEventInterface = {
                    dataTransfer: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

                module.exports = SyntheticDragEvent;
            }, { "95": 95 }], 91: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var PooledClass = _dereq_(25);

                var emptyFunction = _dereq_(144);
                var warning = _dereq_(159);

                var didWarnForAddedNewProperty = false;
                var isProxySupported = typeof Proxy === 'function';

                var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var EventInterface = {
                    type: null,
                    target: null,
                    // currentTarget is set when dispatching; no use in copying it here
                    currentTarget: emptyFunction.thatReturnsNull,
                    eventPhase: null,
                    bubbles: null,
                    cancelable: null,
                    timeStamp: function (event) {
                        return event.timeStamp || Date.now();
                    },
                    defaultPrevented: null,
                    isTrusted: null
                };

                /**
                 * Synthetic events are dispatched by event plugins, typically in response to a
                 * top-level event delegation handler.
                 *
                 * These systems should generally use pooling to reduce the frequency of garbage
                 * collection. The system should check `isPersistent` to determine whether the
                 * event should be released into the pool after being dispatched. Users that
                 * need a persisted event should invoke `persist`.
                 *
                 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
                 * normalizing browser quirks. Subclasses do not necessarily have to implement a
                 * DOM interface; custom application-specific events can also subclass this.
                 *
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {*} targetInst Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @param {DOMEventTarget} nativeEventTarget Target node.
                 */
                function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
                    if ("development" !== 'production') {
                        // these have a getter/setter for warnings
                        delete this.nativeEvent;
                        delete this.preventDefault;
                        delete this.stopPropagation;
                    }

                    this.dispatchConfig = dispatchConfig;
                    this._targetInst = targetInst;
                    this.nativeEvent = nativeEvent;

                    var Interface = this.constructor.Interface;
                    for (var propName in Interface) {
                        if (!Interface.hasOwnProperty(propName)) {
                            continue;
                        }
                        if ("development" !== 'production') {
                            delete this[propName]; // this has a getter/setter for warnings
                        }
                        var normalize = Interface[propName];
                        if (normalize) {
                            this[propName] = normalize(nativeEvent);
                        } else {
                            if (propName === 'target') {
                                this.target = nativeEventTarget;
                            } else {
                                this[propName] = nativeEvent[propName];
                            }
                        }
                    }

                    var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
                    if (defaultPrevented) {
                        this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
                    } else {
                        this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
                    }
                    this.isPropagationStopped = emptyFunction.thatReturnsFalse;
                    return this;
                }

                _assign(SyntheticEvent.prototype, {
                    preventDefault: function () {
                        this.defaultPrevented = true;
                        var event = this.nativeEvent;
                        if (!event) {
                            return;
                        }

                        if (event.preventDefault) {
                            event.preventDefault();
                            // eslint-disable-next-line valid-typeof
                        } else if (typeof event.returnValue !== 'unknown') {
                            event.returnValue = false;
                        }
                        this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
                    },

                    stopPropagation: function () {
                        var event = this.nativeEvent;
                        if (!event) {
                            return;
                        }

                        if (event.stopPropagation) {
                            event.stopPropagation();
                            // eslint-disable-next-line valid-typeof
                        } else if (typeof event.cancelBubble !== 'unknown') {
                            // The ChangeEventPlugin registers a "propertychange" event for
                            // IE. This event does not support bubbling or cancelling, and
                            // any references to cancelBubble throw "Member not found".  A
                            // typeof check of "unknown" circumvents this issue (and is also
                            // IE specific).
                            event.cancelBubble = true;
                        }

                        this.isPropagationStopped = emptyFunction.thatReturnsTrue;
                    },

                    /**
                     * We release all dispatched `SyntheticEvent`s after each event loop, adding
                     * them back into the pool. This allows a way to hold onto a reference that
                     * won't be added back into the pool.
                     */
                    persist: function () {
                        this.isPersistent = emptyFunction.thatReturnsTrue;
                    },

                    /**
                     * Checks if this event should be released back into the pool.
                     *
                     * @return {boolean} True if this should not be released, false otherwise.
                     */
                    isPersistent: emptyFunction.thatReturnsFalse,

                    /**
                     * `PooledClass` looks for `destructor` on each instance it releases.
                     */
                    destructor: function () {
                        var Interface = this.constructor.Interface;
                        for (var propName in Interface) {
                            if ("development" !== 'production') {
                                Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
                            } else {
                                this[propName] = null;
                            }
                        }
                        for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
                            this[shouldBeReleasedProperties[i]] = null;
                        }
                        if ("development" !== 'production') {
                            Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
                            Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
                            Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
                        }
                    }
                });

                SyntheticEvent.Interface = EventInterface;

                if ("development" !== 'production') {
                    if (isProxySupported) {
                        /*eslint-disable no-func-assign */
                        SyntheticEvent = new Proxy(SyntheticEvent, {
                            construct: function (target, args) {
                                return this.apply(target, Object.create(target.prototype), args);
                            },
                            apply: function (constructor, that, args) {
                                return new Proxy(constructor.apply(that, args), {
                                    set: function (target, prop, value) {
                                        if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
                                            "development" !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
                                            didWarnForAddedNewProperty = true;
                                        }
                                        target[prop] = value;
                                        return true;
                                    }
                                });
                            }
                        });
                        /*eslint-enable no-func-assign */
                    }
                }
                /**
                 * Helper to reduce boilerplate when creating subclasses.
                 *
                 * @param {function} Class
                 * @param {?object} Interface
                 */
                SyntheticEvent.augmentClass = function (Class, Interface) {
                    var Super = this;

                    var E = function () { };
                    E.prototype = Super.prototype;
                    var prototype = new E();

                    _assign(prototype, Class.prototype);
                    Class.prototype = prototype;
                    Class.prototype.constructor = Class;

                    Class.Interface = _assign({}, Super.Interface, Interface);
                    Class.augmentClass = Super.augmentClass;

                    PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
                };

                PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

                module.exports = SyntheticEvent;

                /**
                  * Helper to nullify syntheticEvent instance properties when destructing
                  *
                  * @param {object} SyntheticEvent
                  * @param {String} propName
                  * @return {object} defineProperty object
                  */
                function getPooledWarningPropertyDefinition(propName, getVal) {
                    var isFunction = typeof getVal === 'function';
                    return {
                        configurable: true,
                        set: set,
                        get: get
                    };

                    function set(val) {
                        var action = isFunction ? 'setting the method' : 'setting the property';
                        warn(action, 'This is effectively a no-op');
                        return val;
                    }

                    function get() {
                        var action = isFunction ? 'accessing the method' : 'accessing the property';
                        var result = isFunction ? 'This is a no-op function' : 'This is set to null';
                        warn(action, result);
                        return getVal;
                    }

                    function warn(action, result) {
                        var warningCondition = false;
                        "development" !== 'production' ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
                    }
                }
            }, { "144": 144, "159": 159, "160": 160, "25": 25 }], 92: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticUIEvent = _dereq_(98);

                /**
                 * @interface FocusEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var FocusEventInterface = {
                    relatedTarget: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

                module.exports = SyntheticFocusEvent;
            }, { "98": 98 }], 93: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticEvent = _dereq_(91);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
                 *      /#events-inputevents
                 */
                var InputEventInterface = {
                    data: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

                module.exports = SyntheticInputEvent;
            }, { "91": 91 }], 94: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticUIEvent = _dereq_(98);

                var getEventCharCode = _dereq_(111);
                var getEventKey = _dereq_(112);
                var getEventModifierState = _dereq_(113);

                /**
                 * @interface KeyboardEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var KeyboardEventInterface = {
                    key: getEventKey,
                    location: null,
                    ctrlKey: null,
                    shiftKey: null,
                    altKey: null,
                    metaKey: null,
                    repeat: null,
                    locale: null,
                    getModifierState: getEventModifierState,
                    // Legacy Interface
                    charCode: function (event) {
                        // `charCode` is the result of a KeyPress event and represents the value of
                        // the actual printable character.

                        // KeyPress is deprecated, but its replacement is not yet final and not
                        // implemented in any major browser. Only KeyPress has charCode.
                        if (event.type === 'keypress') {
                            return getEventCharCode(event);
                        }
                        return 0;
                    },
                    keyCode: function (event) {
                        // `keyCode` is the result of a KeyDown/Up event and represents the value of
                        // physical keyboard key.

                        // The actual meaning of the value depends on the users' keyboard layout
                        // which cannot be detected. Assuming that it is a US keyboard layout
                        // provides a surprisingly accurate mapping for US and European users.
                        // Due to this, it is left to the user to implement at this time.
                        if (event.type === 'keydown' || event.type === 'keyup') {
                            return event.keyCode;
                        }
                        return 0;
                    },
                    which: function (event) {
                        // `which` is an alias for either `keyCode` or `charCode` depending on the
                        // type of the event.
                        if (event.type === 'keypress') {
                            return getEventCharCode(event);
                        }
                        if (event.type === 'keydown' || event.type === 'keyup') {
                            return event.keyCode;
                        }
                        return 0;
                    }
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

                module.exports = SyntheticKeyboardEvent;
            }, { "111": 111, "112": 112, "113": 113, "98": 98 }], 95: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticUIEvent = _dereq_(98);
                var ViewportMetrics = _dereq_(101);

                var getEventModifierState = _dereq_(113);

                /**
                 * @interface MouseEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var MouseEventInterface = {
                    screenX: null,
                    screenY: null,
                    clientX: null,
                    clientY: null,
                    ctrlKey: null,
                    shiftKey: null,
                    altKey: null,
                    metaKey: null,
                    getModifierState: getEventModifierState,
                    button: function (event) {
                        // Webkit, Firefox, IE9+
                        // which:  1 2 3
                        // button: 0 1 2 (standard)
                        var button = event.button;
                        if ('which' in event) {
                            return button;
                        }
                        // IE<9
                        // which:  undefined
                        // button: 0 0 0
                        // button: 1 4 2 (onmouseup)
                        return button === 2 ? 2 : button === 4 ? 1 : 0;
                    },
                    buttons: null,
                    relatedTarget: function (event) {
                        return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
                    },
                    // "Proprietary" Interface.
                    pageX: function (event) {
                        return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
                    },
                    pageY: function (event) {
                        return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
                    }
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

                module.exports = SyntheticMouseEvent;
            }, { "101": 101, "113": 113, "98": 98 }], 96: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticUIEvent = _dereq_(98);

                var getEventModifierState = _dereq_(113);

                /**
                 * @interface TouchEvent
                 * @see http://www.w3.org/TR/touch-events/
                 */
                var TouchEventInterface = {
                    touches: null,
                    targetTouches: null,
                    changedTouches: null,
                    altKey: null,
                    metaKey: null,
                    ctrlKey: null,
                    shiftKey: null,
                    getModifierState: getEventModifierState
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticUIEvent}
                 */
                function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

                module.exports = SyntheticTouchEvent;
            }, { "113": 113, "98": 98 }], 97: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticEvent = _dereq_(91);

                /**
                 * @interface Event
                 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
                 */
                var TransitionEventInterface = {
                    propertyName: null,
                    elapsedTime: null,
                    pseudoElement: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticEvent}
                 */
                function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

                module.exports = SyntheticTransitionEvent;
            }, { "91": 91 }], 98: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticEvent = _dereq_(91);

                var getEventTarget = _dereq_(114);

                /**
                 * @interface UIEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var UIEventInterface = {
                    view: function (event) {
                        if (event.view) {
                            return event.view;
                        }

                        var target = getEventTarget(event);
                        if (target.window === target) {
                            // target is a window object
                            return target;
                        }

                        var doc = target.ownerDocument;
                        // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
                        if (doc) {
                            return doc.defaultView || doc.parentWindow;
                        } else {
                            return window;
                        }
                    },
                    detail: function (event) {
                        return event.detail || 0;
                    }
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticEvent}
                 */
                function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

                module.exports = SyntheticUIEvent;
            }, { "114": 114, "91": 91 }], 99: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var SyntheticMouseEvent = _dereq_(95);

                /**
                 * @interface WheelEvent
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/
                 */
                var WheelEventInterface = {
                    deltaX: function (event) {
                        return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
                            'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
                    },
                    deltaY: function (event) {
                        return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
                            'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
                                'wheelDelta' in event ? -event.wheelDelta : 0;
                    },
                    deltaZ: null,

                    // Browsers without "deltaMode" is reporting in raw wheel delta where one
                    // notch on the scroll is always +/- 120, roughly equivalent to pixels.
                    // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
                    // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
                    deltaMode: null
                };

                /**
                 * @param {object} dispatchConfig Configuration used to dispatch this event.
                 * @param {string} dispatchMarker Marker identifying the event target.
                 * @param {object} nativeEvent Native browser event.
                 * @extends {SyntheticMouseEvent}
                 */
                function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
                    return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
                }

                SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

                module.exports = SyntheticWheelEvent;
            }, { "95": 95 }], 100: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                var OBSERVED_ERROR = {};

                /**
                 * `Transaction` creates a black box that is able to wrap any method such that
                 * certain invariants are maintained before and after the method is invoked
                 * (Even if an exception is thrown while invoking the wrapped method). Whoever
                 * instantiates a transaction can provide enforcers of the invariants at
                 * creation time. The `Transaction` class itself will supply one additional
                 * automatic invariant for you - the invariant that any transaction instance
                 * should not be run while it is already being run. You would typically create a
                 * single instance of a `Transaction` for reuse multiple times, that potentially
                 * is used to wrap several different methods. Wrappers are extremely simple -
                 * they only require implementing two methods.
                 *
                 * <pre>
                 *                       wrappers (injected at creation time)
                 *                                      +        +
                 *                                      |        |
                 *                    +-----------------|--------|--------------+
                 *                    |                 v        |              |
                 *                    |      +---------------+   |              |
                 *                    |   +--|    wrapper1   |---|----+         |
                 *                    |   |  +---------------+   v    |         |
                 *                    |   |          +-------------+  |         |
                 *                    |   |     +----|   wrapper2  |--------+   |
                 *                    |   |     |    +-------------+  |     |   |
                 *                    |   |     |                     |     |   |
                 *                    |   v     v                     v     v   | wrapper
                 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
                 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
                 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
                 *                    | |   | |   |   |         |   |   | |   | |
                 *                    | |   | |   |   |         |   |   | |   | |
                 *                    | |   | |   |   |         |   |   | |   | |
                 *                    | +---+ +---+   +---------+   +---+ +---+ |
                 *                    |  initialize                    close    |
                 *                    +-----------------------------------------+
                 * </pre>
                 *
                 * Use cases:
                 * - Preserving the input selection ranges before/after reconciliation.
                 *   Restoring selection even in the event of an unexpected error.
                 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
                 *   while guaranteeing that afterwards, the event system is reactivated.
                 * - Flushing a queue of collected DOM mutations to the main UI thread after a
                 *   reconciliation takes place in a worker thread.
                 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
                 *   content.
                 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
                 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
                 * - (Future use case): Layout calculations before and after DOM updates.
                 *
                 * Transactional plugin API:
                 * - A module that has an `initialize` method that returns any precomputation.
                 * - and a `close` method that accepts the precomputation. `close` is invoked
                 *   when the wrapped process is completed, or has failed.
                 *
                 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
                 * that implement `initialize` and `close`.
                 * @return {Transaction} Single transaction for reuse in thread.
                 *
                 * @class Transaction
                 */
                var TransactionImpl = {
                    /**
                     * Sets up this instance so that it is prepared for collecting metrics. Does
                     * so such that this setup method may be used on an instance that is already
                     * initialized, in a way that does not consume additional memory upon reuse.
                     * That can be useful if you decide to make your subclass of this mixin a
                     * "PooledClass".
                     */
                    reinitializeTransaction: function () {
                        this.transactionWrappers = this.getTransactionWrappers();
                        if (this.wrapperInitData) {
                            this.wrapperInitData.length = 0;
                        } else {
                            this.wrapperInitData = [];
                        }
                        this._isInTransaction = false;
                    },

                    _isInTransaction: false,

                    /**
                     * @abstract
                     * @return {Array<TransactionWrapper>} Array of transaction wrappers.
                     */
                    getTransactionWrappers: null,

                    isInTransaction: function () {
                        return !!this._isInTransaction;
                    },

                    /* eslint-disable space-before-function-paren */

                    /**
                     * Executes the function within a safety window. Use this for the top level
                     * methods that result in large amounts of computation/mutations that would
                     * need to be safety checked. The optional arguments helps prevent the need
                     * to bind in many cases.
                     *
                     * @param {function} method Member of scope to call.
                     * @param {Object} scope Scope to invoke from.
                     * @param {Object?=} a Argument to pass to the method.
                     * @param {Object?=} b Argument to pass to the method.
                     * @param {Object?=} c Argument to pass to the method.
                     * @param {Object?=} d Argument to pass to the method.
                     * @param {Object?=} e Argument to pass to the method.
                     * @param {Object?=} f Argument to pass to the method.
                     *
                     * @return {*} Return value from `method`.
                     */
                    perform: function (method, scope, a, b, c, d, e, f) {
                        /* eslint-enable space-before-function-paren */
                        !!this.isInTransaction() ? "development" !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
                        var errorThrown;
                        var ret;
                        try {
                            this._isInTransaction = true;
                            // Catching errors makes debugging more difficult, so we start with
                            // errorThrown set to true before setting it to false after calling
                            // close -- if it's still set to true in the finally block, it means
                            // one of these calls threw.
                            errorThrown = true;
                            this.initializeAll(0);
                            ret = method.call(scope, a, b, c, d, e, f);
                            errorThrown = false;
                        } finally {
                            try {
                                if (errorThrown) {
                                    // If `method` throws, prefer to show that stack trace over any thrown
                                    // by invoking `closeAll`.
                                    try {
                                        this.closeAll(0);
                                    } catch (err) { }
                                } else {
                                    // Since `method` didn't throw, we don't want to silence the exception
                                    // here.
                                    this.closeAll(0);
                                }
                            } finally {
                                this._isInTransaction = false;
                            }
                        }
                        return ret;
                    },

                    initializeAll: function (startIndex) {
                        var transactionWrappers = this.transactionWrappers;
                        for (var i = startIndex; i < transactionWrappers.length; i++) {
                            var wrapper = transactionWrappers[i];
                            try {
                                // Catching errors makes debugging more difficult, so we start with the
                                // OBSERVED_ERROR state before overwriting it with the real return value
                                // of initialize -- if it's still set to OBSERVED_ERROR in the finally
                                // block, it means wrapper.initialize threw.
                                this.wrapperInitData[i] = OBSERVED_ERROR;
                                this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
                            } finally {
                                if (this.wrapperInitData[i] === OBSERVED_ERROR) {
                                    // The initializer for wrapper i threw an error; initialize the
                                    // remaining wrappers but silence any exceptions from them to ensure
                                    // that the first error is the one to bubble up.
                                    try {
                                        this.initializeAll(i + 1);
                                    } catch (err) { }
                                }
                            }
                        }
                    },

                    /**
                     * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
                     * them the respective return values of `this.transactionWrappers.init[i]`
                     * (`close`rs that correspond to initializers that failed will not be
                     * invoked).
                     */
                    closeAll: function (startIndex) {
                        !this.isInTransaction() ? "development" !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
                        var transactionWrappers = this.transactionWrappers;
                        for (var i = startIndex; i < transactionWrappers.length; i++) {
                            var wrapper = transactionWrappers[i];
                            var initData = this.wrapperInitData[i];
                            var errorThrown;
                            try {
                                // Catching errors makes debugging more difficult, so we start with
                                // errorThrown set to true before setting it to false after calling
                                // close -- if it's still set to true in the finally block, it means
                                // wrapper.close threw.
                                errorThrown = true;
                                if (initData !== OBSERVED_ERROR && wrapper.close) {
                                    wrapper.close.call(this, initData);
                                }
                                errorThrown = false;
                            } finally {
                                if (errorThrown) {
                                    // The closer for wrapper i threw an error; close the remaining
                                    // wrappers but silence any exceptions from them to ensure that the
                                    // first error is the one to bubble up.
                                    try {
                                        this.closeAll(i + 1);
                                    } catch (e) { }
                                }
                            }
                        }
                        this.wrapperInitData.length = 0;
                    }
                };

                module.exports = TransactionImpl;
            }, { "126": 126, "152": 152 }], 101: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ViewportMetrics = {
                    currentScrollLeft: 0,

                    currentScrollTop: 0,

                    refreshScrollValues: function (scrollPosition) {
                        ViewportMetrics.currentScrollLeft = scrollPosition.x;
                        ViewportMetrics.currentScrollTop = scrollPosition.y;
                    }
                };

                module.exports = ViewportMetrics;
            }, {}], 102: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var invariant = _dereq_(152);

                /**
                 * Accumulates items that must not be null or undefined into the first one. This
                 * is used to conserve memory by avoiding array allocations, and thus sacrifices
                 * API cleanness. Since `current` can be null before being passed in and not
                 * null after this function, make sure to assign it back to `current`:
                 *
                 * `a = accumulateInto(a, b);`
                 *
                 * This API should be sparingly used. Try `accumulate` for something cleaner.
                 *
                 * @return {*|array<*>} An accumulation of items.
                 */

                function accumulateInto(current, next) {
                    !(next != null) ? "development" !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

                    if (current == null) {
                        return next;
                    }

                    // Both are not empty. Warning: Never call x.concat(y) when you are not
                    // certain that x is an Array (x could be a string with concat method).
                    if (Array.isArray(current)) {
                        if (Array.isArray(next)) {
                            current.push.apply(current, next);
                            return current;
                        }
                        current.push(next);
                        return current;
                    }

                    if (Array.isArray(next)) {
                        // A bit too dangerous to mutate `next`.
                        return [current].concat(next);
                    }

                    return [current, next];
                }

                module.exports = accumulateInto;
            }, { "126": 126, "152": 152 }], 103: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                var MOD = 65521;

                // adler32 is not cryptographically strong, and is only used to sanity check that
                // markup generated on the server matches the markup generated on the client.
                // This implementation (a modified version of the SheetJS version) has been optimized
                // for our use case, at the expense of conforming to the adler32 specification
                // for non-ascii inputs.
                function adler32(data) {
                    var a = 1;
                    var b = 0;
                    var i = 0;
                    var l = data.length;
                    var m = l & ~0x3;
                    while (i < m) {
                        var n = Math.min(i + 4096, m);
                        for (; i < n; i += 4) {
                            b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
                        }
                        a %= MOD;
                        b %= MOD;
                    }
                    for (; i < l; i++) {
                        b += a += data.charCodeAt(i);
                    }
                    a %= MOD;
                    b %= MOD;
                    return a | b << 16;
                }

                module.exports = adler32;
            }, {}], 104: [function (_dereq_, module, exports) {
                (function (process) {
                    /**
                     * Copyright 2013-present, Facebook, Inc.
                     * All rights reserved.
                     *
                     * This source code is licensed under the BSD-style license found in the
                     * LICENSE file in the root directory of this source tree. An additional grant
                     * of patent rights can be found in the PATENTS file in the same directory.
                     *
                     */

                    'use strict';

                    var _prodInvariant = _dereq_(126);

                    var ReactPropTypeLocationNames = _dereq_(72);
                    var ReactPropTypesSecret = _dereq_(73);

                    var invariant = _dereq_(152);
                    var warning = _dereq_(159);

                    var ReactComponentTreeHook;

                    if (typeof process !== 'undefined' && process.env && "development" === 'test') {
                        // Temporary hack.
                        // Inline requires don't work well with Jest:
                        // https://github.com/facebook/react/issues/7240
                        // Remove the inline requires when we don't need them anymore:
                        // https://github.com/facebook/react/pull/7178
                        ReactComponentTreeHook = _dereq_(133);
                    }

                    var loggedTypeFailures = {};

                    /**
                     * Assert that the values match with the type specs.
                     * Error messages are memorized and will only be shown once.
                     *
                     * @param {object} typeSpecs Map of name to a ReactPropType
                     * @param {object} values Runtime values that need to be type-checked
                     * @param {string} location e.g. "prop", "context", "child context"
                     * @param {string} componentName Name of the component for error messages.
                     * @param {?object} element The React element that is being type-checked
                     * @param {?number} debugID The React component instance that is being type-checked
                     * @private
                     */
                    function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
                        for (var typeSpecName in typeSpecs) {
                            if (typeSpecs.hasOwnProperty(typeSpecName)) {
                                var error;
                                // Prop type validation may throw. In case they do, we don't want to
                                // fail the render phase where it didn't fail before. So we log it.
                                // After these have been cleaned up, we'll let them throw.
                                try {
                                    // This is intentionally an invariant that gets caught. It's the same
                                    // behavior as without this statement except with a better message.
                                    !(typeof typeSpecs[typeSpecName] === 'function') ? "development" !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
                                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                                } catch (ex) {
                                    error = ex;
                                }
                                "development" !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
                                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                                    // Only monitor this failure once because there tends to be a lot of the
                                    // same error.
                                    loggedTypeFailures[error.message] = true;

                                    var componentStackInfo = '';

                                    if ("development" !== 'production') {
                                        if (!ReactComponentTreeHook) {
                                            ReactComponentTreeHook = _dereq_(133);
                                        }
                                        if (debugID !== null) {
                                            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
                                        } else if (element !== null) {
                                            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
                                        }
                                    }

                                    "development" !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
                                }
                            }
                        }
                    }

                    module.exports = checkReactTypeSpec;
                }).call(this, undefined)
            }, { "126": 126, "133": 133, "152": 152, "159": 159, "72": 72, "73": 73 }], 105: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals MSApp */

                'use strict';

                /**
                 * Create a function which has 'unsafe' privileges (required by windows8 apps)
                 */

                var createMicrosoftUnsafeLocalFunction = function (func) {
                    if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
                        return function (arg0, arg1, arg2, arg3) {
                            MSApp.execUnsafeLocalFunction(function () {
                                return func(arg0, arg1, arg2, arg3);
                            });
                        };
                    } else {
                        return func;
                    }
                };

                module.exports = createMicrosoftUnsafeLocalFunction;
            }, {}], 106: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var CSSProperty = _dereq_(4);
                var warning = _dereq_(159);

                var isUnitlessNumber = CSSProperty.isUnitlessNumber;
                var styleWarnings = {};

                /**
                 * Convert a value into the proper css writable value. The style name `name`
                 * should be logical (no hyphens), as specified
                 * in `CSSProperty.isUnitlessNumber`.
                 *
                 * @param {string} name CSS property name such as `topMargin`.
                 * @param {*} value CSS property value such as `10px`.
                 * @param {ReactDOMComponent} component
                 * @return {string} Normalized style value with dimensions applied.
                 */
                function dangerousStyleValue(name, value, component, isCustomProperty) {
                    // Note that we've removed escapeTextForBrowser() calls here since the
                    // whole string will be escaped when the attribute is injected into
                    // the markup. If you provide unsafe user data here they can inject
                    // arbitrary CSS which may be problematic (I couldn't repro this):
                    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
                    // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
                    // This is not an XSS hole but instead a potential CSS injection issue
                    // which has lead to a greater discussion about how we're going to
                    // trust URLs moving forward. See #2115901

                    var isEmpty = value == null || typeof value === 'boolean' || value === '';
                    if (isEmpty) {
                        return '';
                    }

                    var isNonNumeric = isNaN(value);
                    if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
                        return '' + value; // cast to string
                    }

                    if (typeof value === 'string') {
                        if ("development" !== 'production') {
                            // Allow '0' to pass through without warning. 0 is already special and
                            // doesn't require units, so we don't need to warn about it.
                            if (component && value !== '0') {
                                var owner = component._currentElement._owner;
                                var ownerName = owner ? owner.getName() : null;
                                if (ownerName && !styleWarnings[ownerName]) {
                                    styleWarnings[ownerName] = {};
                                }
                                var warned = false;
                                if (ownerName) {
                                    var warnings = styleWarnings[ownerName];
                                    warned = warnings[name];
                                    if (!warned) {
                                        warnings[name] = true;
                                    }
                                }
                                if (!warned) {
                                    "development" !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
                                }
                            }
                        }
                        value = value.trim();
                    }
                    return value + 'px';
                }

                module.exports = dangerousStyleValue;
            }, { "159": 159, "4": 4 }], 107: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2016-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * Based on the escape-html library, which is used under the MIT License below:
                 *
                 * Copyright (c) 2012-2013 TJ Holowaychuk
                 * Copyright (c) 2015 Andreas Lubbe
                 * Copyright (c) 2015 Tiancheng "Timothy" Gu
                 *
                 * Permission is hereby granted, free of charge, to any person obtaining
                 * a copy of this software and associated documentation files (the
                 * 'Software'), to deal in the Software without restriction, including
                 * without limitation the rights to use, copy, modify, merge, publish,
                 * distribute, sublicense, and/or sell copies of the Software, and to
                 * permit persons to whom the Software is furnished to do so, subject to
                 * the following conditions:
                 *
                 * The above copyright notice and this permission notice shall be
                 * included in all copies or substantial portions of the Software.
                 *
                 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
                 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
                 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
                 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
                 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
                 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                 *
                 */

                'use strict';

                // code copied and modified from escape-html
                /**
                 * Module variables.
                 * @private
                 */

                var matchHtmlRegExp = /["'&<>]/;

                /**
                 * Escape special characters in the given string of html.
                 *
                 * @param  {string} string The string to escape for inserting into HTML
                 * @return {string}
                 * @public
                 */

                function escapeHtml(string) {
                    var str = '' + string;
                    var match = matchHtmlRegExp.exec(str);

                    if (!match) {
                        return str;
                    }

                    var escape;
                    var html = '';
                    var index = 0;
                    var lastIndex = 0;

                    for (index = match.index; index < str.length; index++) {
                        switch (str.charCodeAt(index)) {
                            case 34:
                                // "
                                escape = '&quot;';
                                break;
                            case 38:
                                // &
                                escape = '&amp;';
                                break;
                            case 39:
                                // '
                                escape = '&#x27;'; // modified from escape-html; used to be '&#39'
                                break;
                            case 60:
                                // <
                                escape = '&lt;';
                                break;
                            case 62:
                                // >
                                escape = '&gt;';
                                break;
                            default:
                                continue;
                        }

                        if (lastIndex !== index) {
                            html += str.substring(lastIndex, index);
                        }

                        lastIndex = index + 1;
                        html += escape;
                    }

                    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
                }
                // end code copied and modified from escape-html

                /**
                 * Escapes text to prevent scripting attacks.
                 *
                 * @param {*} text Text value to escape.
                 * @return {string} An escaped string.
                 */
                function escapeTextContentForBrowser(text) {
                    if (typeof text === 'boolean' || typeof text === 'number') {
                        // this shortcircuit helps perf for types that we know will never have
                        // special characters, especially given that this function is used often
                        // for numeric dom ids.
                        return '' + text;
                    }
                    return escapeHtml(text);
                }

                module.exports = escapeTextContentForBrowser;
            }, {}], 108: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var ReactCurrentOwner = _dereq_(134);
                var ReactDOMComponentTree = _dereq_(34);
                var ReactInstanceMap = _dereq_(63);

                var getHostComponentFromComposite = _dereq_(115);
                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                /**
                 * Returns the DOM node rendered by this element.
                 *
                 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
                 *
                 * @param {ReactComponent|DOMElement} componentOrElement
                 * @return {?DOMElement} The root node of this element.
                 */
                function findDOMNode(componentOrElement) {
                    if ("development" !== 'production') {
                        var owner = ReactCurrentOwner.current;
                        if (owner !== null) {
                            "development" !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
                            owner._warnedAboutRefsInRender = true;
                        }
                    }
                    if (componentOrElement == null) {
                        return null;
                    }
                    if (componentOrElement.nodeType === 1) {
                        return componentOrElement;
                    }

                    var inst = ReactInstanceMap.get(componentOrElement);
                    if (inst) {
                        inst = getHostComponentFromComposite(inst);
                        return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
                    }

                    if (typeof componentOrElement.render === 'function') {
                        !false ? "development" !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
                    } else {
                        !false ? "development" !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
                    }
                }

                module.exports = findDOMNode;
            }, { "115": 115, "126": 126, "134": 134, "152": 152, "159": 159, "34": 34, "63": 63 }], 109: [function (_dereq_, module, exports) {
                (function (process) {
                    /**
                     * Copyright 2013-present, Facebook, Inc.
                     * All rights reserved.
                     *
                     * This source code is licensed under the BSD-style license found in the
                     * LICENSE file in the root directory of this source tree. An additional grant
                     * of patent rights can be found in the PATENTS file in the same directory.
                     *
                     * 
                     */

                    'use strict';

                    var KeyEscapeUtils = _dereq_(23);
                    var traverseAllChildren = _dereq_(131);
                    var warning = _dereq_(159);

                    var ReactComponentTreeHook;

                    if (typeof process !== 'undefined' && process.env && "development" === 'test') {
                        // Temporary hack.
                        // Inline requires don't work well with Jest:
                        // https://github.com/facebook/react/issues/7240
                        // Remove the inline requires when we don't need them anymore:
                        // https://github.com/facebook/react/pull/7178
                        ReactComponentTreeHook = _dereq_(133);
                    }

                    /**
                     * @param {function} traverseContext Context passed through traversal.
                     * @param {?ReactComponent} child React child component.
                     * @param {!string} name String name of key path to child.
                     * @param {number=} selfDebugID Optional debugID of the current internal instance.
                     */
                    function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
                        // We found a component instance.
                        if (traverseContext && typeof traverseContext === 'object') {
                            var result = traverseContext;
                            var keyUnique = result[name] === undefined;
                            if ("development" !== 'production') {
                                if (!ReactComponentTreeHook) {
                                    ReactComponentTreeHook = _dereq_(133);
                                }
                                if (!keyUnique) {
                                    "development" !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
                                }
                            }
                            if (keyUnique && child != null) {
                                result[name] = child;
                            }
                        }
                    }

                    /**
                     * Flattens children that are typically specified as `props.children`. Any null
                     * children will not be included in the resulting object.
                     * @return {!object} flattened children keyed by name.
                     */
                    function flattenChildren(children, selfDebugID) {
                        if (children == null) {
                            return children;
                        }
                        var result = {};

                        if ("development" !== 'production') {
                            traverseAllChildren(children, function (traverseContext, child, name) {
                                return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
                            }, result);
                        } else {
                            traverseAllChildren(children, flattenSingleChildIntoContext, result);
                        }
                        return result;
                    }

                    module.exports = flattenChildren;
                }).call(this, undefined)
            }, { "131": 131, "133": 133, "159": 159, "23": 23 }], 110: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                /**
                 * @param {array} arr an "accumulation" of items which is either an Array or
                 * a single item. Useful when paired with the `accumulate` module. This is a
                 * simple utility that allows us to reason about a collection of items, but
                 * handling the case when there is exactly one item (and we do not need to
                 * allocate an array).
                 */

                function forEachAccumulated(arr, cb, scope) {
                    if (Array.isArray(arr)) {
                        arr.forEach(cb, scope);
                    } else if (arr) {
                        cb.call(scope, arr);
                    }
                }

                module.exports = forEachAccumulated;
            }, {}], 111: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * `charCode` represents the actual "character code" and is safe to use with
                 * `String.fromCharCode`. As such, only keys that correspond to printable
                 * characters produce a valid `charCode`, the only exception to this is Enter.
                 * The Tab-key is considered non-printable and does not have a `charCode`,
                 * presumably because it does not produce a tab-character in browsers.
                 *
                 * @param {object} nativeEvent Native browser event.
                 * @return {number} Normalized `charCode` property.
                 */

                function getEventCharCode(nativeEvent) {
                    var charCode;
                    var keyCode = nativeEvent.keyCode;

                    if ('charCode' in nativeEvent) {
                        charCode = nativeEvent.charCode;

                        // FF does not set `charCode` for the Enter-key, check against `keyCode`.
                        if (charCode === 0 && keyCode === 13) {
                            charCode = 13;
                        }
                    } else {
                        // IE8 does not implement `charCode`, but `keyCode` has the correct value.
                        charCode = keyCode;
                    }

                    // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
                    // Must not discard the (non-)printable Enter-key.
                    if (charCode >= 32 || charCode === 13) {
                        return charCode;
                    }

                    return 0;
                }

                module.exports = getEventCharCode;
            }, {}], 112: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var getEventCharCode = _dereq_(111);

                /**
                 * Normalization of deprecated HTML5 `key` values
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
                 */
                var normalizeKey = {
                    Esc: 'Escape',
                    Spacebar: ' ',
                    Left: 'ArrowLeft',
                    Up: 'ArrowUp',
                    Right: 'ArrowRight',
                    Down: 'ArrowDown',
                    Del: 'Delete',
                    Win: 'OS',
                    Menu: 'ContextMenu',
                    Apps: 'ContextMenu',
                    Scroll: 'ScrollLock',
                    MozPrintableKey: 'Unidentified'
                };

                /**
                 * Translation from legacy `keyCode` to HTML5 `key`
                 * Only special keys supported, all others depend on keyboard layout or browser
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
                 */
                var translateToKey = {
                    8: 'Backspace',
                    9: 'Tab',
                    12: 'Clear',
                    13: 'Enter',
                    16: 'Shift',
                    17: 'Control',
                    18: 'Alt',
                    19: 'Pause',
                    20: 'CapsLock',
                    27: 'Escape',
                    32: ' ',
                    33: 'PageUp',
                    34: 'PageDown',
                    35: 'End',
                    36: 'Home',
                    37: 'ArrowLeft',
                    38: 'ArrowUp',
                    39: 'ArrowRight',
                    40: 'ArrowDown',
                    45: 'Insert',
                    46: 'Delete',
                    112: 'F1',
                    113: 'F2',
                    114: 'F3',
                    115: 'F4',
                    116: 'F5',
                    117: 'F6',
                    118: 'F7',
                    119: 'F8',
                    120: 'F9',
                    121: 'F10',
                    122: 'F11',
                    123: 'F12',
                    144: 'NumLock',
                    145: 'ScrollLock',
                    224: 'Meta'
                };

                /**
                 * @param {object} nativeEvent Native browser event.
                 * @return {string} Normalized `key` property.
                 */
                function getEventKey(nativeEvent) {
                    if (nativeEvent.key) {
                        // Normalize inconsistent values reported by browsers due to
                        // implementations of a working draft specification.

                        // FireFox implements `key` but returns `MozPrintableKey` for all
                        // printable characters (normalized to `Unidentified`), ignore it.
                        var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                        if (key !== 'Unidentified') {
                            return key;
                        }
                    }

                    // Browser does not implement `key`, polyfill as much of it as we can.
                    if (nativeEvent.type === 'keypress') {
                        var charCode = getEventCharCode(nativeEvent);

                        // The enter-key is technically both printable and non-printable and can
                        // thus be captured by `keypress`, no other non-printable key should.
                        return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
                    }
                    if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
                        // While user keyboard layout determines the actual meaning of each
                        // `keyCode` value, almost all function keys have a universal value.
                        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
                    }
                    return '';
                }

                module.exports = getEventKey;
            }, { "111": 111 }], 113: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Translation from modifier key to the associated property in the event.
                 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
                 */

                var modifierKeyToProp = {
                    Alt: 'altKey',
                    Control: 'ctrlKey',
                    Meta: 'metaKey',
                    Shift: 'shiftKey'
                };

                // IE8 does not implement getModifierState so we simply map it to the only
                // modifier keys exposed by the event itself, does not support Lock-keys.
                // Currently, all major browsers except Chrome seems to support Lock-keys.
                function modifierStateGetter(keyArg) {
                    var syntheticEvent = this;
                    var nativeEvent = syntheticEvent.nativeEvent;
                    if (nativeEvent.getModifierState) {
                        return nativeEvent.getModifierState(keyArg);
                    }
                    var keyProp = modifierKeyToProp[keyArg];
                    return keyProp ? !!nativeEvent[keyProp] : false;
                }

                function getEventModifierState(nativeEvent) {
                    return modifierStateGetter;
                }

                module.exports = getEventModifierState;
            }, {}], 114: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Gets the target node from a native browser event by accounting for
                 * inconsistencies in browser DOM APIs.
                 *
                 * @param {object} nativeEvent Native browser event.
                 * @return {DOMEventTarget} Target node.
                 */

                function getEventTarget(nativeEvent) {
                    var target = nativeEvent.target || nativeEvent.srcElement || window;

                    // Normalize SVG <use> element events #4963
                    if (target.correspondingUseElement) {
                        target = target.correspondingUseElement;
                    }

                    // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
                    // @see http://www.quirksmode.org/js/events_properties.html
                    return target.nodeType === 3 ? target.parentNode : target;
                }

                module.exports = getEventTarget;
            }, {}], 115: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactNodeTypes = _dereq_(69);

                function getHostComponentFromComposite(inst) {
                    var type;

                    while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
                        inst = inst._renderedComponent;
                    }

                    if (type === ReactNodeTypes.HOST) {
                        return inst._renderedComponent;
                    } else if (type === ReactNodeTypes.EMPTY) {
                        return null;
                    }
                }

                module.exports = getHostComponentFromComposite;
            }, { "69": 69 }], 116: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                /* global Symbol */

                var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

                /**
                 * Returns the iterator method function contained on the iterable object.
                 *
                 * Be sure to invoke the function with the iterable as context:
                 *
                 *     var iteratorFn = getIteratorFn(myIterable);
                 *     if (iteratorFn) {
                 *       var iterator = iteratorFn.call(myIterable);
                 *       ...
                 *     }
                 *
                 * @param {?object} maybeIterable
                 * @return {?function}
                 */
                function getIteratorFn(maybeIterable) {
                    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                    if (typeof iteratorFn === 'function') {
                        return iteratorFn;
                    }
                }

                module.exports = getIteratorFn;
            }, {}], 117: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Given any node return the first leaf node without children.
                 *
                 * @param {DOMElement|DOMTextNode} node
                 * @return {DOMElement|DOMTextNode}
                 */

                function getLeafNode(node) {
                    while (node && node.firstChild) {
                        node = node.firstChild;
                    }
                    return node;
                }

                /**
                 * Get the next sibling within a container. This will walk up the
                 * DOM if a node's siblings have been exhausted.
                 *
                 * @param {DOMElement|DOMTextNode} node
                 * @return {?DOMElement|DOMTextNode}
                 */
                function getSiblingNode(node) {
                    while (node) {
                        if (node.nextSibling) {
                            return node.nextSibling;
                        }
                        node = node.parentNode;
                    }
                }

                /**
                 * Get object describing the nodes which contain characters at offset.
                 *
                 * @param {DOMElement|DOMTextNode} root
                 * @param {number} offset
                 * @return {?object}
                 */
                function getNodeForCharacterOffset(root, offset) {
                    var node = getLeafNode(root);
                    var nodeStart = 0;
                    var nodeEnd = 0;

                    while (node) {
                        if (node.nodeType === 3) {
                            nodeEnd = nodeStart + node.textContent.length;

                            if (nodeStart <= offset && nodeEnd >= offset) {
                                return {
                                    node: node,
                                    offset: offset - nodeStart
                                };
                            }

                            nodeStart = nodeEnd;
                        }

                        node = getLeafNode(getSiblingNode(node));
                    }
                }

                module.exports = getNodeForCharacterOffset;
            }, {}], 118: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);

                var contentKey = null;

                /**
                 * Gets the key used to access text content on a DOM node.
                 *
                 * @return {?string} Key used to access text content.
                 * @internal
                 */
                function getTextContentAccessor() {
                    if (!contentKey && ExecutionEnvironment.canUseDOM) {
                        // Prefer textContent to innerText because many browsers support both but
                        // SVG <text> elements don't support innerText even when <div> does.
                        contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
                    }
                    return contentKey;
                }

                module.exports = getTextContentAccessor;
            }, { "138": 138 }], 119: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);

                /**
                 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
                 *
                 * @param {string} styleProp
                 * @param {string} eventName
                 * @returns {object}
                 */
                function makePrefixMap(styleProp, eventName) {
                    var prefixes = {};

                    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
                    prefixes['Webkit' + styleProp] = 'webkit' + eventName;
                    prefixes['Moz' + styleProp] = 'moz' + eventName;
                    prefixes['ms' + styleProp] = 'MS' + eventName;
                    prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

                    return prefixes;
                }

                /**
                 * A list of event names to a configurable list of vendor prefixes.
                 */
                var vendorPrefixes = {
                    animationend: makePrefixMap('Animation', 'AnimationEnd'),
                    animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
                    animationstart: makePrefixMap('Animation', 'AnimationStart'),
                    transitionend: makePrefixMap('Transition', 'TransitionEnd')
                };

                /**
                 * Event names that have already been detected and prefixed (if applicable).
                 */
                var prefixedEventNames = {};

                /**
                 * Element to check for prefixes on.
                 */
                var style = {};

                /**
                 * Bootstrap if a DOM exists.
                 */
                if (ExecutionEnvironment.canUseDOM) {
                    style = document.createElement('div').style;

                    // On some platforms, in particular some releases of Android 4.x,
                    // the un-prefixed "animation" and "transition" properties are defined on the
                    // style object but the events that fire will still be prefixed, so we need
                    // to check if the un-prefixed events are usable, and if not remove them from the map.
                    if (!('AnimationEvent' in window)) {
                        delete vendorPrefixes.animationend.animation;
                        delete vendorPrefixes.animationiteration.animation;
                        delete vendorPrefixes.animationstart.animation;
                    }

                    // Same as above
                    if (!('TransitionEvent' in window)) {
                        delete vendorPrefixes.transitionend.transition;
                    }
                }

                /**
                 * Attempts to determine the correct vendor prefixed event name.
                 *
                 * @param {string} eventName
                 * @returns {string}
                 */
                function getVendorPrefixedEventName(eventName) {
                    if (prefixedEventNames[eventName]) {
                        return prefixedEventNames[eventName];
                    } else if (!vendorPrefixes[eventName]) {
                        return eventName;
                    }

                    var prefixMap = vendorPrefixes[eventName];

                    for (var styleProp in prefixMap) {
                        if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
                            return prefixedEventNames[eventName] = prefixMap[styleProp];
                        }
                    }

                    return '';
                }

                module.exports = getVendorPrefixedEventName;
            }, { "138": 138 }], 120: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactDOMComponentTree = _dereq_(34);

                function isCheckable(elem) {
                    var type = elem.type;
                    var nodeName = elem.nodeName;
                    return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
                }

                function getTracker(inst) {
                    return inst._wrapperState.valueTracker;
                }

                function attachTracker(inst, tracker) {
                    inst._wrapperState.valueTracker = tracker;
                }

                function detachTracker(inst) {
                    delete inst._wrapperState.valueTracker;
                }

                function getValueFromNode(node) {
                    var value;
                    if (node) {
                        value = isCheckable(node) ? '' + node.checked : node.value;
                    }
                    return value;
                }

                var inputValueTracking = {
                    // exposed for testing
                    _getTrackerFromNode: function (node) {
                        return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
                    },


                    track: function (inst) {
                        if (getTracker(inst)) {
                            return;
                        }

                        var node = ReactDOMComponentTree.getNodeFromInstance(inst);
                        var valueField = isCheckable(node) ? 'checked' : 'value';
                        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

                        var currentValue = '' + node[valueField];

                        // if someone has already defined a value or Safari, then bail
                        // and don't track value will cause over reporting of changes,
                        // but it's better then a hard failure
                        // (needed for certain tests that spyOn input values and Safari)
                        if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
                            return;
                        }

                        Object.defineProperty(node, valueField, {
                            enumerable: descriptor.enumerable,
                            configurable: true,
                            get: function () {
                                return descriptor.get.call(this);
                            },
                            set: function (value) {
                                currentValue = '' + value;
                                descriptor.set.call(this, value);
                            }
                        });

                        attachTracker(inst, {
                            getValue: function () {
                                return currentValue;
                            },
                            setValue: function (value) {
                                currentValue = '' + value;
                            },
                            stopTracking: function () {
                                detachTracker(inst);
                                delete node[valueField];
                            }
                        });
                    },

                    updateValueIfChanged: function (inst) {
                        if (!inst) {
                            return false;
                        }
                        var tracker = getTracker(inst);

                        if (!tracker) {
                            inputValueTracking.track(inst);
                            return true;
                        }

                        var lastValue = tracker.getValue();
                        var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

                        if (nextValue !== lastValue) {
                            tracker.setValue(nextValue);
                            return true;
                        }

                        return false;
                    },
                    stopTracking: function (inst) {
                        var tracker = getTracker(inst);
                        if (tracker) {
                            tracker.stopTracking();
                        }
                    }
                };

                module.exports = inputValueTracking;
            }, { "34": 34 }], 121: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126),
                    _assign = _dereq_(160);

                var ReactCompositeComponent = _dereq_(30);
                var ReactEmptyComponent = _dereq_(54);
                var ReactHostComponent = _dereq_(59);

                var getNextDebugID = _dereq_(136);
                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                // To avoid a cyclic dependency, we create the final class in this module
                var ReactCompositeComponentWrapper = function (element) {
                    this.construct(element);
                };

                function getDeclarationErrorAddendum(owner) {
                    if (owner) {
                        var name = owner.getName();
                        if (name) {
                            return ' Check the render method of `' + name + '`.';
                        }
                    }
                    return '';
                }

                /**
                 * Check if the type reference is a known internal type. I.e. not a user
                 * provided composite type.
                 *
                 * @param {function} type
                 * @return {boolean} Returns true if this is a valid internal type.
                 */
                function isInternalComponentType(type) {
                    return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
                }

                /**
                 * Given a ReactNode, create an instance that will actually be mounted.
                 *
                 * @param {ReactNode} node
                 * @param {boolean} shouldHaveDebugID
                 * @return {object} A new instance of the element's constructor.
                 * @protected
                 */
                function instantiateReactComponent(node, shouldHaveDebugID) {
                    var instance;

                    if (node === null || node === false) {
                        instance = ReactEmptyComponent.create(instantiateReactComponent);
                    } else if (typeof node === 'object') {
                        var element = node;
                        var type = element.type;
                        if (typeof type !== 'function' && typeof type !== 'string') {
                            var info = '';
                            if ("development" !== 'production') {
                                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                                    info += ' You likely forgot to export your component from the file ' + "it's defined in.";
                                }
                            }
                            info += getDeclarationErrorAddendum(element._owner);
                            !false ? "development" !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
                        }

                        // Special case string values
                        if (typeof element.type === 'string') {
                            instance = ReactHostComponent.createInternalComponent(element);
                        } else if (isInternalComponentType(element.type)) {
                            // This is temporarily available for custom components that are not string
                            // representations. I.e. ART. Once those are updated to use the string
                            // representation, we can drop this code path.
                            instance = new element.type(element);

                            // We renamed this. Allow the old name for compat. :(
                            if (!instance.getHostNode) {
                                instance.getHostNode = instance.getNativeNode;
                            }
                        } else {
                            instance = new ReactCompositeComponentWrapper(element);
                        }
                    } else if (typeof node === 'string' || typeof node === 'number') {
                        instance = ReactHostComponent.createInstanceForText(node);
                    } else {
                        !false ? "development" !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
                    }

                    if ("development" !== 'production') {
                        "development" !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
                    }

                    // These two fields are used by the DOM and ART diffing algorithms
                    // respectively. Instead of using expandos on components, we should be
                    // storing the state needed by the diffing algorithms elsewhere.
                    instance._mountIndex = 0;
                    instance._mountImage = null;

                    if ("development" !== 'production') {
                        instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
                    }

                    // Internal instances should fully constructed at this point, so they should
                    // not get any new fields added to them at this point.
                    if ("development" !== 'production') {
                        if (Object.preventExtensions) {
                            Object.preventExtensions(instance);
                        }
                    }

                    return instance;
                }

                _assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
                    _instantiateReactComponent: instantiateReactComponent
                });

                module.exports = instantiateReactComponent;
            }, { "126": 126, "136": 136, "152": 152, "159": 159, "160": 160, "30": 30, "54": 54, "59": 59 }], 122: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);

                var useHasFeature;
                if (ExecutionEnvironment.canUseDOM) {
                    useHasFeature = document.implementation && document.implementation.hasFeature &&
                        // always returns true in newer browsers as per the standard.
                        // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
                        document.implementation.hasFeature('', '') !== true;
                }

                /**
                 * Checks if an event is supported in the current execution environment.
                 *
                 * NOTE: This will not work correctly for non-generic events such as `change`,
                 * `reset`, `load`, `error`, and `select`.
                 *
                 * Borrows from Modernizr.
                 *
                 * @param {string} eventNameSuffix Event name, e.g. "click".
                 * @param {?boolean} capture Check if the capture phase is supported.
                 * @return {boolean} True if the event is supported.
                 * @internal
                 * @license Modernizr 3.0.0pre (Custom Build) | MIT
                 */
                function isEventSupported(eventNameSuffix, capture) {
                    if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
                        return false;
                    }

                    var eventName = 'on' + eventNameSuffix;
                    var isSupported = eventName in document;

                    if (!isSupported) {
                        var element = document.createElement('div');
                        element.setAttribute(eventName, 'return;');
                        isSupported = typeof element[eventName] === 'function';
                    }

                    if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
                        // This is the only way to test support for the `wheel` event in IE9+.
                        isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
                    }

                    return isSupported;
                }

                module.exports = isEventSupported;
            }, { "138": 138 }], 123: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                'use strict';

                /**
                 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
                 */

                var supportedInputTypes = {
                    color: true,
                    date: true,
                    datetime: true,
                    'datetime-local': true,
                    email: true,
                    month: true,
                    number: true,
                    password: true,
                    range: true,
                    search: true,
                    tel: true,
                    text: true,
                    time: true,
                    url: true,
                    week: true
                };

                function isTextInputElement(elem) {
                    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

                    if (nodeName === 'input') {
                        return !!supportedInputTypes[elem.type];
                    }

                    if (nodeName === 'textarea') {
                        return true;
                    }

                    return false;
                }

                module.exports = isTextInputElement;
            }, {}], 124: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-2015, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Forked from fbjs/warning:
                 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
                 *
                 * Only change is we use console.warn instead of console.error,
                 * and do nothing when 'console' is not supported.
                 * This really simplifies the code.
                 * ---
                 * Similar to invariant but only logs a warning if the condition is not met.
                 * This can be used to log issues in development environments in critical
                 * paths. Removing the logging code for production environments will keep the
                 * same logic and follow the same code paths.
                 */

                var lowPriorityWarning = function () { };

                if ("development" !== 'production') {
                    var printWarning = function (format) {
                        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                            args[_key - 1] = arguments[_key];
                        }

                        var argIndex = 0;
                        var message = 'Warning: ' + format.replace(/%s/g, function () {
                            return args[argIndex++];
                        });
                        if (typeof console !== 'undefined') {
                            console.warn(message);
                        }
                        try {
                            // --- Welcome to debugging React ---
                            // This error was thrown as a convenience so that you can use this stack
                            // to find the callsite that caused this warning to fire.
                            throw new Error(message);
                        } catch (x) { }
                    };

                    lowPriorityWarning = function (condition, format) {
                        if (format === undefined) {
                            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
                        }
                        if (!condition) {
                            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                                args[_key2 - 2] = arguments[_key2];
                            }

                            printWarning.apply(undefined, [format].concat(args));
                        }
                    };
                }

                module.exports = lowPriorityWarning;
            }, {}], 125: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var escapeTextContentForBrowser = _dereq_(107);

                /**
                 * Escapes attribute value to prevent scripting attacks.
                 *
                 * @param {*} value Value to escape.
                 * @return {string} An escaped string.
                 */
                function quoteAttributeValueForBrowser(value) {
                    return '"' + escapeTextContentForBrowser(value) + '"';
                }

                module.exports = quoteAttributeValueForBrowser;
            }, { "107": 107 }], 126: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */
                'use strict';

                /**
                 * WARNING: DO NOT manually require this module.
                 * This is a replacement for `invariant(...)` used by the error code system
                 * and will _only_ be required by the corresponding babel pass.
                 * It always throws.
                 */

                function reactProdInvariant(code) {
                    var argCount = arguments.length - 1;

                    var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

                    for (var argIdx = 0; argIdx < argCount; argIdx++) {
                        message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
                    }

                    message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

                    var error = new Error(message);
                    error.name = 'Invariant Violation';
                    error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

                    throw error;
                }

                module.exports = reactProdInvariant;
            }, {}], 127: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ReactMount = _dereq_(67);

                module.exports = ReactMount.renderSubtreeIntoContainer;
            }, { "67": 67 }], 128: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);
                var DOMNamespaces = _dereq_(10);

                var WHITESPACE_TEST = /^[ \r\n\t\f]/;
                var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

                var createMicrosoftUnsafeLocalFunction = _dereq_(105);

                // SVG temp container for IE lacking innerHTML
                var reusableSVGContainer;

                /**
                 * Set the innerHTML property of a node, ensuring that whitespace is preserved
                 * even in IE8.
                 *
                 * @param {DOMElement} node
                 * @param {string} html
                 * @internal
                 */
                var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
                    // IE does not have innerHTML for SVG nodes, so instead we inject the
                    // new markup in a temp node and then move the child nodes across into
                    // the target node
                    if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
                        reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                        reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
                        var svgNode = reusableSVGContainer.firstChild;
                        while (svgNode.firstChild) {
                            node.appendChild(svgNode.firstChild);
                        }
                    } else {
                        node.innerHTML = html;
                    }
                });

                if (ExecutionEnvironment.canUseDOM) {
                    // IE8: When updating a just created node with innerHTML only leading
                    // whitespace is removed. When updating an existing node with innerHTML
                    // whitespace in root TextNodes is also collapsed.
                    // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

                    // Feature detection; only IE8 is known to behave improperly like this.
                    var testElement = document.createElement('div');
                    testElement.innerHTML = ' ';
                    if (testElement.innerHTML === '') {
                        setInnerHTML = function (node, html) {
                            // Magic theory: IE8 supposedly differentiates between added and updated
                            // nodes when processing innerHTML, innerHTML on updated nodes suffers
                            // from worse whitespace behavior. Re-adding a node like this triggers
                            // the initial and more favorable whitespace behavior.
                            // TODO: What to do on a detached node?
                            if (node.parentNode) {
                                node.parentNode.replaceChild(node, node);
                            }

                            // We also implement a workaround for non-visible tags disappearing into
                            // thin air on IE8, this only happens if there is no visible text
                            // in-front of the non-visible tags. Piggyback on the whitespace fix
                            // and simply check if any non-visible tags appear in the source.
                            if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
                                // Recover leading whitespace by temporarily prepending any character.
                                // \uFEFF has the potential advantage of being zero-width/invisible.
                                // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
                                // in hopes that this is preserved even if "\uFEFF" is transformed to
                                // the actual Unicode character (by Babel, for example).
                                // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
                                node.innerHTML = String.fromCharCode(0xfeff) + html;

                                // deleteData leaves an empty `TextNode` which offsets the index of all
                                // children. Definitely want to avoid this.
                                var textNode = node.firstChild;
                                if (textNode.data.length === 1) {
                                    node.removeChild(textNode);
                                } else {
                                    textNode.deleteData(0, 1);
                                }
                            } else {
                                node.innerHTML = html;
                            }
                        };
                    }
                    testElement = null;
                }

                module.exports = setInnerHTML;
            }, { "10": 10, "105": 105, "138": 138 }], 129: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);
                var escapeTextContentForBrowser = _dereq_(107);
                var setInnerHTML = _dereq_(128);

                /**
                 * Set the textContent property of a node, ensuring that whitespace is preserved
                 * even in IE8. innerText is a poor substitute for textContent and, among many
                 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
                 * as it should.
                 *
                 * @param {DOMElement} node
                 * @param {string} text
                 * @internal
                 */
                var setTextContent = function (node, text) {
                    if (text) {
                        var firstChild = node.firstChild;

                        if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
                            firstChild.nodeValue = text;
                            return;
                        }
                    }
                    node.textContent = text;
                };

                if (ExecutionEnvironment.canUseDOM) {
                    if (!('textContent' in document.documentElement)) {
                        setTextContent = function (node, text) {
                            if (node.nodeType === 3) {
                                node.nodeValue = text;
                                return;
                            }
                            setInnerHTML(node, escapeTextContentForBrowser(text));
                        };
                    }
                }

                module.exports = setTextContent;
            }, { "107": 107, "128": 128, "138": 138 }], 130: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Given a `prevElement` and `nextElement`, determines if the existing
                 * instance should be updated as opposed to being destroyed or replaced by a new
                 * instance. Both arguments are elements. This ensures that this logic can
                 * operate on stateless trees without any backing instance.
                 *
                 * @param {?object} prevElement
                 * @param {?object} nextElement
                 * @return {boolean} True if the existing instance should be updated.
                 * @protected
                 */

                function shouldUpdateReactComponent(prevElement, nextElement) {
                    var prevEmpty = prevElement === null || prevElement === false;
                    var nextEmpty = nextElement === null || nextElement === false;
                    if (prevEmpty || nextEmpty) {
                        return prevEmpty === nextEmpty;
                    }

                    var prevType = typeof prevElement;
                    var nextType = typeof nextElement;
                    if (prevType === 'string' || prevType === 'number') {
                        return nextType === 'string' || nextType === 'number';
                    } else {
                        return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
                    }
                }

                module.exports = shouldUpdateReactComponent;
            }, {}], 131: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _prodInvariant = _dereq_(126);

                var ReactCurrentOwner = _dereq_(134);
                var REACT_ELEMENT_TYPE = _dereq_(53);

                var getIteratorFn = _dereq_(116);
                var invariant = _dereq_(152);
                var KeyEscapeUtils = _dereq_(23);
                var warning = _dereq_(159);

                var SEPARATOR = '.';
                var SUBSEPARATOR = ':';

                /**
                 * This is inlined from ReactElement since this file is shared between
                 * isomorphic and renderers. We could extract this to a
                 *
                 */

                /**
                 * TODO: Test that a single child and an array with one item have the same key
                 * pattern.
                 */

                var didWarnAboutMaps = false;

                /**
                 * Generate a key string that identifies a component within a set.
                 *
                 * @param {*} component A component that could contain a manual key.
                 * @param {number} index Index that is used if a manual key is not provided.
                 * @return {string}
                 */
                function getComponentKey(component, index) {
                    // Do some typechecking here since we call this blindly. We want to ensure
                    // that we don't block potential future ES APIs.
                    if (component && typeof component === 'object' && component.key != null) {
                        // Explicit key
                        return KeyEscapeUtils.escape(component.key);
                    }
                    // Implicit key determined by the index in the set
                    return index.toString(36);
                }

                /**
                 * @param {?*} children Children tree container.
                 * @param {!string} nameSoFar Name of the key path so far.
                 * @param {!function} callback Callback to invoke with each child found.
                 * @param {?*} traverseContext Used to pass information throughout the traversal
                 * process.
                 * @return {!number} The number of children in this subtree.
                 */
                function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
                    var type = typeof children;

                    if (type === 'undefined' || type === 'boolean') {
                        // All of the above are perceived as null.
                        children = null;
                    }

                    if (children === null || type === 'string' || type === 'number' ||
                        // The following is inlined from ReactElement. This means we can optimize
                        // some checks. React Fiber also inlines this logic for similar purposes.
                        type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
                        callback(traverseContext, children,
                            // If it's the only child, treat the name as if it was wrapped in an array
                            // so that it's consistent if the number of children grows.
                            nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
                        return 1;
                    }

                    var child;
                    var nextName;
                    var subtreeCount = 0; // Count of children found in the current subtree.
                    var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

                    if (Array.isArray(children)) {
                        for (var i = 0; i < children.length; i++) {
                            child = children[i];
                            nextName = nextNamePrefix + getComponentKey(child, i);
                            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                        }
                    } else {
                        var iteratorFn = getIteratorFn(children);
                        if (iteratorFn) {
                            var iterator = iteratorFn.call(children);
                            var step;
                            if (iteratorFn !== children.entries) {
                                var ii = 0;
                                while (!(step = iterator.next()).done) {
                                    child = step.value;
                                    nextName = nextNamePrefix + getComponentKey(child, ii++);
                                    subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                                }
                            } else {
                                if ("development" !== 'production') {
                                    var mapsAsChildrenAddendum = '';
                                    if (ReactCurrentOwner.current) {
                                        var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
                                        if (mapsAsChildrenOwnerName) {
                                            mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
                                        }
                                    }
                                    "development" !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
                                    didWarnAboutMaps = true;
                                }
                                // Iterator will provide entry [k,v] tuples rather than values.
                                while (!(step = iterator.next()).done) {
                                    var entry = step.value;
                                    if (entry) {
                                        child = entry[1];
                                        nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
                                        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
                                    }
                                }
                            }
                        } else if (type === 'object') {
                            var addendum = '';
                            if ("development" !== 'production') {
                                addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
                                if (children._isReactElement) {
                                    addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
                                }
                                if (ReactCurrentOwner.current) {
                                    var name = ReactCurrentOwner.current.getName();
                                    if (name) {
                                        addendum += ' Check the render method of `' + name + '`.';
                                    }
                                }
                            }
                            var childrenString = String(children);
                            !false ? "development" !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
                        }
                    }

                    return subtreeCount;
                }

                /**
                 * Traverses children that are typically specified as `props.children`, but
                 * might also be specified through attributes:
                 *
                 * - `traverseAllChildren(this.props.children, ...)`
                 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
                 *
                 * The `traverseContext` is an optional argument that is passed through the
                 * entire traversal. It can be used to store accumulations or anything else that
                 * the callback might find relevant.
                 *
                 * @param {?*} children Children tree object.
                 * @param {!function} callback To invoke upon traversing each child.
                 * @param {?*} traverseContext Context for traversal.
                 * @return {!number} The number of children in this subtree.
                 */
                function traverseAllChildren(children, callback, traverseContext) {
                    if (children == null) {
                        return 0;
                    }

                    return traverseAllChildrenImpl(children, '', callback, traverseContext);
                }

                module.exports = traverseAllChildren;
            }, { "116": 116, "126": 126, "134": 134, "152": 152, "159": 159, "23": 23, "53": 53 }], 132: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2015-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var _assign = _dereq_(160);

                var emptyFunction = _dereq_(144);
                var warning = _dereq_(159);

                var validateDOMNesting = emptyFunction;

                if ("development" !== 'production') {
                    // This validation code was written based on the HTML5 parsing spec:
                    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
                    //
                    // Note: this does not catch all invalid nesting, nor does it try to (as it's
                    // not clear what practical benefit doing so provides); instead, we warn only
                    // for cases where the parser will give a parse tree differing from what React
                    // intended. For example, <b><div></div></b> is invalid but we don't warn
                    // because it still parses correctly; we do warn for other cases like nested
                    // <p> tags where the beginning of the second element implicitly closes the
                    // first, causing a confusing mess.

                    // https://html.spec.whatwg.org/multipage/syntax.html#special
                    var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

                    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
                    var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

                        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
                        // TODO: Distinguish by namespace here -- for <title>, including it here
                        // errs on the side of fewer warnings
                        'foreignObject', 'desc', 'title'];

                    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
                    var buttonScopeTags = inScopeTags.concat(['button']);

                    // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
                    var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

                    var emptyAncestorInfo = {
                        current: null,

                        formTag: null,
                        aTagInScope: null,
                        buttonTagInScope: null,
                        nobrTagInScope: null,
                        pTagInButtonScope: null,

                        listItemTagAutoclosing: null,
                        dlItemTagAutoclosing: null
                    };

                    var updatedAncestorInfo = function (oldInfo, tag, instance) {
                        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
                        var info = { tag: tag, instance: instance };

                        if (inScopeTags.indexOf(tag) !== -1) {
                            ancestorInfo.aTagInScope = null;
                            ancestorInfo.buttonTagInScope = null;
                            ancestorInfo.nobrTagInScope = null;
                        }
                        if (buttonScopeTags.indexOf(tag) !== -1) {
                            ancestorInfo.pTagInButtonScope = null;
                        }

                        // See rules for 'li', 'dd', 'dt' start tags in
                        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
                        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
                            ancestorInfo.listItemTagAutoclosing = null;
                            ancestorInfo.dlItemTagAutoclosing = null;
                        }

                        ancestorInfo.current = info;

                        if (tag === 'form') {
                            ancestorInfo.formTag = info;
                        }
                        if (tag === 'a') {
                            ancestorInfo.aTagInScope = info;
                        }
                        if (tag === 'button') {
                            ancestorInfo.buttonTagInScope = info;
                        }
                        if (tag === 'nobr') {
                            ancestorInfo.nobrTagInScope = info;
                        }
                        if (tag === 'p') {
                            ancestorInfo.pTagInButtonScope = info;
                        }
                        if (tag === 'li') {
                            ancestorInfo.listItemTagAutoclosing = info;
                        }
                        if (tag === 'dd' || tag === 'dt') {
                            ancestorInfo.dlItemTagAutoclosing = info;
                        }

                        return ancestorInfo;
                    };

                    /**
                     * Returns whether
                     */
                    var isTagValidWithParent = function (tag, parentTag) {
                        // First, let's check if we're in an unusual parsing mode...
                        switch (parentTag) {
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
                            case 'select':
                                return tag === 'option' || tag === 'optgroup' || tag === '#text';
                            case 'optgroup':
                                return tag === 'option' || tag === '#text';
                            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
                            // but
                            case 'option':
                                return tag === '#text';
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
                            // No special behavior since these rules fall back to "in body" mode for
                            // all except special table nodes which cause bad parsing behavior anyway.

                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
                            case 'tr':
                                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
                            case 'tbody':
                            case 'thead':
                            case 'tfoot':
                                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
                            case 'colgroup':
                                return tag === 'col' || tag === 'template';
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
                            case 'table':
                                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
                            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
                            case 'head':
                                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
                            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
                            case 'html':
                                return tag === 'head' || tag === 'body';
                            case '#document':
                                return tag === 'html';
                        }

                        // Probably in the "in body" parsing mode, so we outlaw only tag combos
                        // where the parsing rules cause implicit opens or closes to be added.
                        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
                        switch (tag) {
                            case 'h1':
                            case 'h2':
                            case 'h3':
                            case 'h4':
                            case 'h5':
                            case 'h6':
                                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

                            case 'rp':
                            case 'rt':
                                return impliedEndTags.indexOf(parentTag) === -1;

                            case 'body':
                            case 'caption':
                            case 'col':
                            case 'colgroup':
                            case 'frame':
                            case 'head':
                            case 'html':
                            case 'tbody':
                            case 'td':
                            case 'tfoot':
                            case 'th':
                            case 'thead':
                            case 'tr':
                                // These tags are only valid with a few parents that have special child
                                // parsing rules -- if we're down here, then none of those matched and
                                // so we allow it only if we don't know what the parent is, as all other
                                // cases are invalid.
                                return parentTag == null;
                        }

                        return true;
                    };

                    /**
                     * Returns whether
                     */
                    var findInvalidAncestorForTag = function (tag, ancestorInfo) {
                        switch (tag) {
                            case 'address':
                            case 'article':
                            case 'aside':
                            case 'blockquote':
                            case 'center':
                            case 'details':
                            case 'dialog':
                            case 'dir':
                            case 'div':
                            case 'dl':
                            case 'fieldset':
                            case 'figcaption':
                            case 'figure':
                            case 'footer':
                            case 'header':
                            case 'hgroup':
                            case 'main':
                            case 'menu':
                            case 'nav':
                            case 'ol':
                            case 'p':
                            case 'section':
                            case 'summary':
                            case 'ul':
                            case 'pre':
                            case 'listing':
                            case 'table':
                            case 'hr':
                            case 'xmp':
                            case 'h1':
                            case 'h2':
                            case 'h3':
                            case 'h4':
                            case 'h5':
                            case 'h6':
                                return ancestorInfo.pTagInButtonScope;

                            case 'form':
                                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

                            case 'li':
                                return ancestorInfo.listItemTagAutoclosing;

                            case 'dd':
                            case 'dt':
                                return ancestorInfo.dlItemTagAutoclosing;

                            case 'button':
                                return ancestorInfo.buttonTagInScope;

                            case 'a':
                                // Spec says something about storing a list of markers, but it sounds
                                // equivalent to this check.
                                return ancestorInfo.aTagInScope;

                            case 'nobr':
                                return ancestorInfo.nobrTagInScope;
                        }

                        return null;
                    };

                    /**
                     * Given a ReactCompositeComponent instance, return a list of its recursive
                     * owners, starting at the root and ending with the instance itself.
                     */
                    var findOwnerStack = function (instance) {
                        if (!instance) {
                            return [];
                        }

                        var stack = [];
                        do {
                            stack.push(instance);
                        } while (instance = instance._currentElement._owner);
                        stack.reverse();
                        return stack;
                    };

                    var didWarn = {};

                    validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
                        ancestorInfo = ancestorInfo || emptyAncestorInfo;
                        var parentInfo = ancestorInfo.current;
                        var parentTag = parentInfo && parentInfo.tag;

                        if (childText != null) {
                            "development" !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
                            childTag = '#text';
                        }

                        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
                        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
                        var problematic = invalidParent || invalidAncestor;

                        if (problematic) {
                            var ancestorTag = problematic.tag;
                            var ancestorInstance = problematic.instance;

                            var childOwner = childInstance && childInstance._currentElement._owner;
                            var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

                            var childOwners = findOwnerStack(childOwner);
                            var ancestorOwners = findOwnerStack(ancestorOwner);

                            var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
                            var i;

                            var deepestCommon = -1;
                            for (i = 0; i < minStackLen; i++) {
                                if (childOwners[i] === ancestorOwners[i]) {
                                    deepestCommon = i;
                                } else {
                                    break;
                                }
                            }

                            var UNKNOWN = '(unknown)';
                            var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
                                return inst.getName() || UNKNOWN;
                            });
                            var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
                                return inst.getName() || UNKNOWN;
                            });
                            var ownerInfo = [].concat(
                                // If the parent and child instances have a common owner ancestor, start
                                // with that -- otherwise we just start with the parent's owners.
                                deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
                                // If we're warning about an invalid (non-parent) ancestry, add '...'
                                invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

                            var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
                            if (didWarn[warnKey]) {
                                return;
                            }
                            didWarn[warnKey] = true;

                            var tagDisplayName = childTag;
                            var whitespaceInfo = '';
                            if (childTag === '#text') {
                                if (/\S/.test(childText)) {
                                    tagDisplayName = 'Text nodes';
                                } else {
                                    tagDisplayName = 'Whitespace text nodes';
                                    whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
                                }
                            } else {
                                tagDisplayName = '<' + childTag + '>';
                            }

                            if (invalidParent) {
                                var info = '';
                                if (ancestorTag === 'table' && childTag === 'tr') {
                                    info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
                                }
                                "development" !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
                            } else {
                                "development" !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
                            }
                        }
                    };

                    validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

                    // For testing
                    validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
                        ancestorInfo = ancestorInfo || emptyAncestorInfo;
                        var parentInfo = ancestorInfo.current;
                        var parentTag = parentInfo && parentInfo.tag;
                        return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
                    };
                }

                module.exports = validateDOMNesting;
            }, { "144": 144, "159": 159, "160": 160 }], 133: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals React */

                'use strict';

                var ReactInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

                module.exports = ReactInternals.ReactComponentTreeHook;
            }, {}], 134: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals React */

                'use strict';

                var ReactInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

                module.exports = ReactInternals.ReactCurrentOwner;
            }, {}], 135: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals React */

                'use strict';

                module.exports = React;
            }, {}], 136: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /* globals React */

                'use strict';

                var ReactInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

                module.exports = ReactInternals.getNextDebugID;
            }, {}], 137: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 *
                 * Licensed under the Apache License, Version 2.0 (the "License");
                 * you may not use this file except in compliance with the License.
                 * You may obtain a copy of the License at
                 *
                 * http://www.apache.org/licenses/LICENSE-2.0
                 *
                 * Unless required by applicable law or agreed to in writing, software
                 * distributed under the License is distributed on an "AS IS" BASIS,
                 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                 * See the License for the specific language governing permissions and
                 * limitations under the License.
                 *
                 * @typechecks
                 */

                var emptyFunction = _dereq_(144);

                /**
                 * Upstream version of event listener. Does not take into account specific
                 * nature of platform.
                 */
                var EventListener = {
                    /**
                     * Listen to DOM events during the bubble phase.
                     *
                     * @param {DOMEventTarget} target DOM element to register listener on.
                     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
                     * @param {function} callback Callback function.
                     * @return {object} Object with a `remove` method.
                     */
                    listen: function listen(target, eventType, callback) {
                        if (target.addEventListener) {
                            target.addEventListener(eventType, callback, false);
                            return {
                                remove: function remove() {
                                    target.removeEventListener(eventType, callback, false);
                                }
                            };
                        } else if (target.attachEvent) {
                            target.attachEvent('on' + eventType, callback);
                            return {
                                remove: function remove() {
                                    target.detachEvent('on' + eventType, callback);
                                }
                            };
                        }
                    },

                    /**
                     * Listen to DOM events during the capture phase.
                     *
                     * @param {DOMEventTarget} target DOM element to register listener on.
                     * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
                     * @param {function} callback Callback function.
                     * @return {object} Object with a `remove` method.
                     */
                    capture: function capture(target, eventType, callback) {
                        if (target.addEventListener) {
                            target.addEventListener(eventType, callback, true);
                            return {
                                remove: function remove() {
                                    target.removeEventListener(eventType, callback, true);
                                }
                            };
                        } else {
                            if ("development" !== 'production') {
                                console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
                            }
                            return {
                                remove: emptyFunction
                            };
                        }
                    },

                    registerDefault: function registerDefault() { }
                };

                module.exports = EventListener;
            }, { "144": 144 }], 138: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

                /**
                 * Simple, lightweight module assisting with the detection and context of
                 * Worker. Helps avoid circular dependencies and allows code to reason about
                 * whether or not they are in a Worker, even if they never include the main
                 * `ReactWorker` dependency.
                 */
                var ExecutionEnvironment = {

                    canUseDOM: canUseDOM,

                    canUseWorkers: typeof Worker !== 'undefined',

                    canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

                    canUseViewport: canUseDOM && !!window.screen,

                    isInWorker: !canUseDOM // For now, this is true - might change in the future.

                };

                module.exports = ExecutionEnvironment;
            }, {}], 139: [function (_dereq_, module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var _hyphenPattern = /-(.)/g;

                /**
                 * Camelcases a hyphenated string, for example:
                 *
                 *   > camelize('background-color')
                 *   < "backgroundColor"
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function camelize(string) {
                    return string.replace(_hyphenPattern, function (_, character) {
                        return character.toUpperCase();
                    });
                }

                module.exports = camelize;
            }, {}], 140: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                'use strict';

                var camelize = _dereq_(139);

                var msPattern = /^-ms-/;

                /**
                 * Camelcases a hyphenated CSS property name, for example:
                 *
                 *   > camelizeStyleName('background-color')
                 *   < "backgroundColor"
                 *   > camelizeStyleName('-moz-transition')
                 *   < "MozTransition"
                 *   > camelizeStyleName('-ms-transition')
                 *   < "msTransition"
                 *
                 * As Andi Smith suggests
                 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
                 * is converted to lowercase `ms`.
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function camelizeStyleName(string) {
                    return camelize(string.replace(msPattern, 'ms-'));
                }

                module.exports = camelizeStyleName;
            }, { "139": 139 }], 141: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                var isTextNode = _dereq_(154);

                /*eslint-disable no-bitwise */

                /**
                 * Checks if a given DOM node contains or is another DOM node.
                 */
                function containsNode(outerNode, innerNode) {
                    if (!outerNode || !innerNode) {
                        return false;
                    } else if (outerNode === innerNode) {
                        return true;
                    } else if (isTextNode(outerNode)) {
                        return false;
                    } else if (isTextNode(innerNode)) {
                        return containsNode(outerNode, innerNode.parentNode);
                    } else if ('contains' in outerNode) {
                        return outerNode.contains(innerNode);
                    } else if (outerNode.compareDocumentPosition) {
                        return !!(outerNode.compareDocumentPosition(innerNode) & 16);
                    } else {
                        return false;
                    }
                }

                module.exports = containsNode;
            }, { "154": 154 }], 142: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var invariant = _dereq_(152);

                /**
                 * Convert array-like objects to arrays.
                 *
                 * This API assumes the caller knows the contents of the data type. For less
                 * well defined inputs use createArrayFromMixed.
                 *
                 * @param {object|function|filelist} obj
                 * @return {array}
                 */
                function toArray(obj) {
                    var length = obj.length;

                    // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
                    // in old versions of Safari).
                    !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? "development" !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

                    !(typeof length === 'number') ? "development" !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

                    !(length === 0 || length - 1 in obj) ? "development" !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

                    !(typeof obj.callee !== 'function') ? "development" !== 'production' ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

                    // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
                    // without method will throw during the slice call and skip straight to the
                    // fallback.
                    if (obj.hasOwnProperty) {
                        try {
                            return Array.prototype.slice.call(obj);
                        } catch (e) {
                            // IE < 9 does not support Array#slice on collections objects
                        }
                    }

                    // Fall back to copying key by key. This assumes all keys have a value,
                    // so will not preserve sparsely populated inputs.
                    var ret = Array(length);
                    for (var ii = 0; ii < length; ii++) {
                        ret[ii] = obj[ii];
                    }
                    return ret;
                }

                /**
                 * Perform a heuristic test to determine if an object is "array-like".
                 *
                 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
                 *   Joshu replied: "Mu."
                 *
                 * This function determines if its argument has "array nature": it returns
                 * true if the argument is an actual array, an `arguments' object, or an
                 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
                 *
                 * It will return false for other array-like objects like Filelist.
                 *
                 * @param {*} obj
                 * @return {boolean}
                 */
                function hasArrayNature(obj) {
                    return (
                        // not null/false
                        !!obj && (
                            // arrays are objects, NodeLists are functions in Safari
                            typeof obj == 'object' || typeof obj == 'function') &&
                        // quacks like an array
                        'length' in obj &&
                        // not window
                        !('setInterval' in obj) &&
                        // no DOM node should be considered an array-like
                        // a 'select' element has 'length' and 'item' properties on IE8
                        typeof obj.nodeType != 'number' && (
                            // a real array
                            Array.isArray(obj) ||
                            // arguments
                            'callee' in obj ||
                            // HTMLCollection/NodeList
                            'item' in obj)
                    );
                }

                /**
                 * Ensure that the argument is an array by wrapping it in an array if it is not.
                 * Creates a copy of the argument if it is already an array.
                 *
                 * This is mostly useful idiomatically:
                 *
                 *   var createArrayFromMixed = require('createArrayFromMixed');
                 *
                 *   function takesOneOrMoreThings(things) {
                 *     things = createArrayFromMixed(things);
                 *     ...
                 *   }
                 *
                 * This allows you to treat `things' as an array, but accept scalars in the API.
                 *
                 * If you need to convert an array-like object, like `arguments`, into an array
                 * use toArray instead.
                 *
                 * @param {*} obj
                 * @return {array}
                 */
                function createArrayFromMixed(obj) {
                    if (!hasArrayNature(obj)) {
                        return [obj];
                    } else if (Array.isArray(obj)) {
                        return obj.slice();
                    } else {
                        return toArray(obj);
                    }
                }

                module.exports = createArrayFromMixed;
            }, { "152": 152 }], 143: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                /*eslint-disable fb-www/unsafe-html*/

                var ExecutionEnvironment = _dereq_(138);

                var createArrayFromMixed = _dereq_(142);
                var getMarkupWrap = _dereq_(148);
                var invariant = _dereq_(152);

                /**
                 * Dummy container used to render all markup.
                 */
                var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

                /**
                 * Pattern used by `getNodeName`.
                 */
                var nodeNamePattern = /^\s*<(\w+)/;

                /**
                 * Extracts the `nodeName` of the first element in a string of markup.
                 *
                 * @param {string} markup String of markup.
                 * @return {?string} Node name of the supplied markup.
                 */
                function getNodeName(markup) {
                    var nodeNameMatch = markup.match(nodeNamePattern);
                    return nodeNameMatch && nodeNameMatch[1].toLowerCase();
                }

                /**
                 * Creates an array containing the nodes rendered from the supplied markup. The
                 * optionally supplied `handleScript` function will be invoked once for each
                 * <script> element that is rendered. If no `handleScript` function is supplied,
                 * an exception is thrown if any <script> elements are rendered.
                 *
                 * @param {string} markup A string of valid HTML markup.
                 * @param {?function} handleScript Invoked once for each rendered <script>.
                 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
                 */
                function createNodesFromMarkup(markup, handleScript) {
                    var node = dummyNode;
                    !!!dummyNode ? "development" !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
                    var nodeName = getNodeName(markup);

                    var wrap = nodeName && getMarkupWrap(nodeName);
                    if (wrap) {
                        node.innerHTML = wrap[1] + markup + wrap[2];

                        var wrapDepth = wrap[0];
                        while (wrapDepth--) {
                            node = node.lastChild;
                        }
                    } else {
                        node.innerHTML = markup;
                    }

                    var scripts = node.getElementsByTagName('script');
                    if (scripts.length) {
                        !handleScript ? "development" !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
                        createArrayFromMixed(scripts).forEach(handleScript);
                    }

                    var nodes = Array.from(node.childNodes);
                    while (node.lastChild) {
                        node.removeChild(node.lastChild);
                    }
                    return nodes;
                }

                module.exports = createNodesFromMarkup;
            }, { "138": 138, "142": 142, "148": 148, "152": 152 }], 144: [function (_dereq_, module, exports) {
                "use strict";

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 */

                function makeEmptyFunction(arg) {
                    return function () {
                        return arg;
                    };
                }

                /**
                 * This function accepts and discards inputs; it has no side effects. This is
                 * primarily useful idiomatically for overridable function endpoints which
                 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
                 */
                var emptyFunction = function emptyFunction() { };

                emptyFunction.thatReturns = makeEmptyFunction;
                emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
                emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
                emptyFunction.thatReturnsNull = makeEmptyFunction(null);
                emptyFunction.thatReturnsThis = function () {
                    return this;
                };
                emptyFunction.thatReturnsArgument = function (arg) {
                    return arg;
                };

                module.exports = emptyFunction;
            }, {}], 145: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var emptyObject = {};

                if ("development" !== 'production') {
                    Object.freeze(emptyObject);
                }

                module.exports = emptyObject;
            }, {}], 146: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * @param {DOMElement} node input/textarea to focus
                 */

                function focusNode(node) {
                    // IE8 can throw "Can't move focus to the control because it is invisible,
                    // not enabled, or of a type that does not accept the focus." for all kinds of
                    // reasons that are too expensive and fragile to test.
                    try {
                        node.focus();
                    } catch (e) { }
                }

                module.exports = focusNode;
            }, {}], 147: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                /* eslint-disable fb-www/typeof-undefined */

                /**
                 * Same as document.activeElement but wraps in a try-catch block. In IE it is
                 * not safe to call document.activeElement if there is nothing focused.
                 *
                 * The activeElement will be null only if the document or document body is not
                 * yet defined.
                 *
                 * @param {?DOMDocument} doc Defaults to current document.
                 * @return {?DOMElement}
                 */
                function getActiveElement(doc) /*?DOMElement*/ {
                    doc = doc || (typeof document !== 'undefined' ? document : undefined);
                    if (typeof doc === 'undefined') {
                        return null;
                    }
                    try {
                        return doc.activeElement || doc.body;
                    } catch (e) {
                        return doc.body;
                    }
                }

                module.exports = getActiveElement;
            }, {}], 148: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                /*eslint-disable fb-www/unsafe-html */

                var ExecutionEnvironment = _dereq_(138);

                var invariant = _dereq_(152);

                /**
                 * Dummy container used to detect which wraps are necessary.
                 */
                var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

                /**
                 * Some browsers cannot use `innerHTML` to render certain elements standalone,
                 * so we wrap them, render the wrapped nodes, then extract the desired node.
                 *
                 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
                 */

                var shouldWrap = {};

                var selectWrap = [1, '<select multiple="true">', '</select>'];
                var tableWrap = [1, '<table>', '</table>'];
                var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

                var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

                var markupWrap = {
                    '*': [1, '?<div>', '</div>'],

                    'area': [1, '<map>', '</map>'],
                    'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
                    'legend': [1, '<fieldset>', '</fieldset>'],
                    'param': [1, '<object>', '</object>'],
                    'tr': [2, '<table><tbody>', '</tbody></table>'],

                    'optgroup': selectWrap,
                    'option': selectWrap,

                    'caption': tableWrap,
                    'colgroup': tableWrap,
                    'tbody': tableWrap,
                    'tfoot': tableWrap,
                    'thead': tableWrap,

                    'td': trWrap,
                    'th': trWrap
                };

                // Initialize the SVG elements since we know they'll always need to be wrapped
                // consistently. If they are created inside a <div> they will be initialized in
                // the wrong namespace (and will not display).
                var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
                svgElements.forEach(function (nodeName) {
                    markupWrap[nodeName] = svgWrap;
                    shouldWrap[nodeName] = true;
                });

                /**
                 * Gets the markup wrap configuration for the supplied `nodeName`.
                 *
                 * NOTE: This lazily detects which wraps are necessary for the current browser.
                 *
                 * @param {string} nodeName Lowercase `nodeName`.
                 * @return {?array} Markup wrap configuration, if applicable.
                 */
                function getMarkupWrap(nodeName) {
                    !!!dummyNode ? "development" !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
                    if (!markupWrap.hasOwnProperty(nodeName)) {
                        nodeName = '*';
                    }
                    if (!shouldWrap.hasOwnProperty(nodeName)) {
                        if (nodeName === '*') {
                            dummyNode.innerHTML = '<link />';
                        } else {
                            dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
                        }
                        shouldWrap[nodeName] = !dummyNode.firstChild;
                    }
                    return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
                }

                module.exports = getMarkupWrap;
            }, { "138": 138, "152": 152 }], 149: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                'use strict';

                /**
                 * Gets the scroll position of the supplied element or window.
                 *
                 * The return values are unbounded, unlike `getScrollPosition`. This means they
                 * may be negative or exceed the element boundaries (which is possible using
                 * inertial scrolling).
                 *
                 * @param {DOMWindow|DOMElement} scrollable
                 * @return {object} Map with `x` and `y` keys.
                 */

                function getUnboundedScrollPosition(scrollable) {
                    if (scrollable.Window && scrollable instanceof scrollable.Window) {
                        return {
                            x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
                            y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
                        };
                    }
                    return {
                        x: scrollable.scrollLeft,
                        y: scrollable.scrollTop
                    };
                }

                module.exports = getUnboundedScrollPosition;
            }, {}], 150: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var _uppercasePattern = /([A-Z])/g;

                /**
                 * Hyphenates a camelcased string, for example:
                 *
                 *   > hyphenate('backgroundColor')
                 *   < "background-color"
                 *
                 * For CSS style names, use `hyphenateStyleName` instead which works properly
                 * with all vendor prefixes, including `ms`.
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function hyphenate(string) {
                    return string.replace(_uppercasePattern, '-$1').toLowerCase();
                }

                module.exports = hyphenate;
            }, {}], 151: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                'use strict';

                var hyphenate = _dereq_(150);

                var msPattern = /^ms-/;

                /**
                 * Hyphenates a camelcased CSS property name, for example:
                 *
                 *   > hyphenateStyleName('backgroundColor')
                 *   < "background-color"
                 *   > hyphenateStyleName('MozTransition')
                 *   < "-moz-transition"
                 *   > hyphenateStyleName('msTransition')
                 *   < "-ms-transition"
                 *
                 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
                 * is converted to `-ms-`.
                 *
                 * @param {string} string
                 * @return {string}
                 */
                function hyphenateStyleName(string) {
                    return hyphenate(string).replace(msPattern, '-ms-');
                }

                module.exports = hyphenateStyleName;
            }, { "150": 150 }], 152: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                /**
                 * Use invariant() to assert state which your program assumes to be true.
                 *
                 * Provide sprintf-style format (only %s is supported) and arguments
                 * to provide information about what broke and what you were
                 * expecting.
                 *
                 * The invariant message will be stripped in production, but the invariant
                 * will remain to ensure logic does not differ in production.
                 */

                var validateFormat = function validateFormat(format) { };

                if ("development" !== 'production') {
                    validateFormat = function validateFormat(format) {
                        if (format === undefined) {
                            throw new Error('invariant requires an error message argument');
                        }
                    };
                }

                function invariant(condition, format, a, b, c, d, e, f) {
                    validateFormat(format);

                    if (!condition) {
                        var error;
                        if (format === undefined) {
                            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
                        } else {
                            var args = [a, b, c, d, e, f];
                            var argIndex = 0;
                            error = new Error(format.replace(/%s/g, function () {
                                return args[argIndex++];
                            }));
                            error.name = 'Invariant Violation';
                        }

                        error.framesToPop = 1; // we don't care about invariant's own frame
                        throw error;
                    }
                }

                module.exports = invariant;
            }, {}], 153: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                /**
                 * @param {*} object The object to check.
                 * @return {boolean} Whether or not the object is a DOM node.
                 */
                function isNode(object) {
                    var doc = object ? object.ownerDocument || object : document;
                    var defaultView = doc.defaultView || window;
                    return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
                }

                module.exports = isNode;
            }, {}], 154: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var isNode = _dereq_(153);

                /**
                 * @param {*} object The object to check.
                 * @return {boolean} Whether or not the object is a DOM text node.
                 */
                function isTextNode(object) {
                    return isNode(object) && object.nodeType == 3;
                }

                module.exports = isTextNode;
            }, { "153": 153 }], 155: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * 
                 * @typechecks static-only
                 */

                'use strict';

                /**
                 * Memoizes the return value of a function that accepts one string argument.
                 */

                function memoizeStringOnly(callback) {
                    var cache = {};
                    return function (string) {
                        if (!cache.hasOwnProperty(string)) {
                            cache[string] = callback.call(this, string);
                        }
                        return cache[string];
                    };
                }

                module.exports = memoizeStringOnly;
            }, {}], 156: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                'use strict';

                var ExecutionEnvironment = _dereq_(138);

                var performance;

                if (ExecutionEnvironment.canUseDOM) {
                    performance = window.performance || window.msPerformance || window.webkitPerformance;
                }

                module.exports = performance || {};
            }, { "138": 138 }], 157: [function (_dereq_, module, exports) {
                'use strict';

                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 */

                var performance = _dereq_(156);

                var performanceNow;

                /**
                 * Detect if we can use `window.performance.now()` and gracefully fallback to
                 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
                 * because of Facebook's testing infrastructure.
                 */
                if (performance.now) {
                    performanceNow = function performanceNow() {
                        return performance.now();
                    };
                } else {
                    performanceNow = function performanceNow() {
                        return Date.now();
                    };
                }

                module.exports = performanceNow;
            }, { "156": 156 }], 158: [function (_dereq_, module, exports) {
                /**
                 * Copyright (c) 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 * @typechecks
                 * 
                 */

                /*eslint-disable no-self-compare */

                'use strict';

                var hasOwnProperty = Object.prototype.hasOwnProperty;

                /**
                 * inlined Object.is polyfill to avoid requiring consumers ship their own
                 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
                 */
                function is(x, y) {
                    // SameValue algorithm
                    if (x === y) {
                        // Steps 1-5, 7-10
                        // Steps 6.b-6.e: +0 != -0
                        // Added the nonzero y check to make Flow happy, but it is redundant
                        return x !== 0 || y !== 0 || 1 / x === 1 / y;
                    } else {
                        // Step 6.a: NaN == NaN
                        return x !== x && y !== y;
                    }
                }

                /**
                 * Performs equality by iterating through keys on an object and returning false
                 * when any key has values which are not strictly equal between the arguments.
                 * Returns true when the values of all keys are strictly equal.
                 */
                function shallowEqual(objA, objB) {
                    if (is(objA, objB)) {
                        return true;
                    }

                    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
                        return false;
                    }

                    var keysA = Object.keys(objA);
                    var keysB = Object.keys(objB);

                    if (keysA.length !== keysB.length) {
                        return false;
                    }

                    // Test for A's keys different from B.
                    for (var i = 0; i < keysA.length; i++) {
                        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
                            return false;
                        }
                    }

                    return true;
                }

                module.exports = shallowEqual;
            }, {}], 159: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2014-2015, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 *
                 */

                'use strict';

                var emptyFunction = _dereq_(144);

                /**
                 * Similar to invariant but only logs a warning if the condition is not met.
                 * This can be used to log issues in development environments in critical
                 * paths. Removing the logging code for production environments will keep the
                 * same logic and follow the same code paths.
                 */

                var warning = emptyFunction;

                if ("development" !== 'production') {
                    (function () {
                        var printWarning = function printWarning(format) {
                            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                                args[_key - 1] = arguments[_key];
                            }

                            var argIndex = 0;
                            var message = 'Warning: ' + format.replace(/%s/g, function () {
                                return args[argIndex++];
                            });
                            if (typeof console !== 'undefined') {
                                console.error(message);
                            }
                            try {
                                // --- Welcome to debugging React ---
                                // This error was thrown as a convenience so that you can use this stack
                                // to find the callsite that caused this warning to fire.
                                throw new Error(message);
                            } catch (x) { }
                        };

                        warning = function warning(condition, format) {
                            if (format === undefined) {
                                throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
                            }

                            if (format.indexOf('Failed Composite propType: ') === 0) {
                                return; // Ignore CompositeComponent proptype check.
                            }

                            if (!condition) {
                                for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                                    args[_key2 - 2] = arguments[_key2];
                                }

                                printWarning.apply(undefined, [format].concat(args));
                            }
                        };
                    })();
                }

                module.exports = warning;
            }, { "144": 144 }], 160: [function (_dereq_, module, exports) {
                /*
                object-assign
                (c) Sindre Sorhus
                @license MIT
                */

                'use strict';
                /* eslint-disable no-unused-vars */
                var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;

                function toObject(val) {
                    if (val === null || val === undefined) {
                        throw new TypeError('Object.assign cannot be called with null or undefined');
                    }

                    return Object(val);
                }

                function shouldUseNative() {
                    try {
                        if (!Object.assign) {
                            return false;
                        }

                        // Detect buggy property enumeration order in older V8 versions.

                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
                        test1[5] = 'de';
                        if (Object.getOwnPropertyNames(test1)[0] === '5') {
                            return false;
                        }

                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for (var i = 0; i < 10; i++) {
                            test2['_' + String.fromCharCode(i)] = i;
                        }
                        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                            return test2[n];
                        });
                        if (order2.join('') !== '0123456789') {
                            return false;
                        }

                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join('') !==
                            'abcdefghijklmnopqrst') {
                            return false;
                        }

                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }

                module.exports = shouldUseNative() ? Object.assign : function (target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;

                    for (var s = 1; s < arguments.length; s++) {
                        from = Object(arguments[s]);

                        for (var key in from) {
                            if (hasOwnProperty.call(from, key)) {
                                to[key] = from[key];
                            }
                        }

                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for (var i = 0; i < symbols.length; i++) {
                                if (propIsEnumerable.call(from, symbols[i])) {
                                    to[symbols[i]] = from[symbols[i]];
                                }
                            }
                        }
                    }

                    return to;
                };

            }, {}], 161: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 */

                'use strict';

                if ("development" !== 'production') {
                    var invariant = _dereq_(152);
                    var warning = _dereq_(159);
                    var ReactPropTypesSecret = _dereq_(164);
                    var loggedTypeFailures = {};
                }

                /**
                 * Assert that the values match with the type specs.
                 * Error messages are memorized and will only be shown once.
                 *
                 * @param {object} typeSpecs Map of name to a ReactPropType
                 * @param {object} values Runtime values that need to be type-checked
                 * @param {string} location e.g. "prop", "context", "child context"
                 * @param {string} componentName Name of the component for error messages.
                 * @param {?Function} getStack Returns the component stack.
                 * @private
                 */
                function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
                    if ("development" !== 'production') {
                        for (var typeSpecName in typeSpecs) {
                            if (typeSpecs.hasOwnProperty(typeSpecName)) {
                                var error;
                                // Prop type validation may throw. In case they do, we don't want to
                                // fail the render phase where it didn't fail before. So we log it.
                                // After these have been cleaned up, we'll let them throw.
                                try {
                                    // This is intentionally an invariant that gets caught. It's the same
                                    // behavior as without this statement except with a better message.
                                    invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
                                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                                } catch (ex) {
                                    error = ex;
                                }
                                warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
                                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                                    // Only monitor this failure once because there tends to be a lot of the
                                    // same error.
                                    loggedTypeFailures[error.message] = true;

                                    var stack = getStack ? getStack() : '';

                                    warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
                                }
                            }
                        }
                    }
                }

                module.exports = checkPropTypes;

            }, { "152": 152, "159": 159, "164": 164 }], 162: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 */

                'use strict';

                // React 15.5 references this module, and assumes PropTypes are still callable in production.
                // Therefore we re-export development-only version with all the PropTypes checks here.
                // However if one is migrating to the `prop-types` npm library, they will go through the
                // `index.js` entry point, and it will branch depending on the environment.
                var factory = _dereq_(163);
                module.exports = function (isValidElement) {
                    // It is still allowed in 15.5.
                    var throwOnDirectAccess = false;
                    return factory(isValidElement, throwOnDirectAccess);
                };

            }, { "163": 163 }], 163: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 */

                'use strict';

                var emptyFunction = _dereq_(144);
                var invariant = _dereq_(152);
                var warning = _dereq_(159);

                var ReactPropTypesSecret = _dereq_(164);
                var checkPropTypes = _dereq_(161);

                module.exports = function (isValidElement, throwOnDirectAccess) {
                    /* global Symbol */
                    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
                    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

                    /**
                     * Returns the iterator method function contained on the iterable object.
                     *
                     * Be sure to invoke the function with the iterable as context:
                     *
                     *     var iteratorFn = getIteratorFn(myIterable);
                     *     if (iteratorFn) {
                     *       var iterator = iteratorFn.call(myIterable);
                     *       ...
                     *     }
                     *
                     * @param {?object} maybeIterable
                     * @return {?function}
                     */
                    function getIteratorFn(maybeIterable) {
                        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                        if (typeof iteratorFn === 'function') {
                            return iteratorFn;
                        }
                    }

                    /**
                     * Collection of methods that allow declaration and validation of props that are
                     * supplied to React components. Example usage:
                     *
                     *   var Props = require('ReactPropTypes');
                     *   var MyArticle = React.createClass({
                     *     propTypes: {
                     *       // An optional string prop named "description".
                     *       description: Props.string,
                     *
                     *       // A required enum prop named "category".
                     *       category: Props.oneOf(['News','Photos']).isRequired,
                     *
                     *       // A prop named "dialog" that requires an instance of Dialog.
                     *       dialog: Props.instanceOf(Dialog).isRequired
                     *     },
                     *     render: function() { ... }
                     *   });
                     *
                     * A more formal specification of how these methods are used:
                     *
                     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
                     *   decl := ReactPropTypes.{type}(.isRequired)?
                     *
                     * Each and every declaration produces a function with the same signature. This
                     * allows the creation of custom validation functions. For example:
                     *
                     *  var MyLink = React.createClass({
                     *    propTypes: {
                     *      // An optional string or URI prop named "href".
                     *      href: function(props, propName, componentName) {
                     *        var propValue = props[propName];
                     *        if (propValue != null && typeof propValue !== 'string' &&
                     *            !(propValue instanceof URI)) {
                     *          return new Error(
                     *            'Expected a string or an URI for ' + propName + ' in ' +
                     *            componentName
                     *          );
                     *        }
                     *      }
                     *    },
                     *    render: function() {...}
                     *  });
                     *
                     * @internal
                     */

                    var ANONYMOUS = '<<anonymous>>';

                    // Important!
                    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
                    var ReactPropTypes = {
                        array: createPrimitiveTypeChecker('array'),
                        bool: createPrimitiveTypeChecker('boolean'),
                        func: createPrimitiveTypeChecker('function'),
                        number: createPrimitiveTypeChecker('number'),
                        object: createPrimitiveTypeChecker('object'),
                        string: createPrimitiveTypeChecker('string'),
                        symbol: createPrimitiveTypeChecker('symbol'),

                        any: createAnyTypeChecker(),
                        arrayOf: createArrayOfTypeChecker,
                        element: createElementTypeChecker(),
                        instanceOf: createInstanceTypeChecker,
                        node: createNodeChecker(),
                        objectOf: createObjectOfTypeChecker,
                        oneOf: createEnumTypeChecker,
                        oneOfType: createUnionTypeChecker,
                        shape: createShapeTypeChecker
                    };

                    /**
                     * inlined Object.is polyfill to avoid requiring consumers ship their own
                     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
                     */
                    /*eslint-disable no-self-compare*/
                    function is(x, y) {
                        // SameValue algorithm
                        if (x === y) {
                            // Steps 1-5, 7-10
                            // Steps 6.b-6.e: +0 != -0
                            return x !== 0 || 1 / x === 1 / y;
                        } else {
                            // Step 6.a: NaN == NaN
                            return x !== x && y !== y;
                        }
                    }
                    /*eslint-enable no-self-compare*/

                    /**
                     * We use an Error-like object for backward compatibility as people may call
                     * PropTypes directly and inspect their output. However, we don't use real
                     * Errors anymore. We don't inspect their stack anyway, and creating them
                     * is prohibitively expensive if they are created too often, such as what
                     * happens in oneOfType() for any type before the one that matched.
                     */
                    function PropTypeError(message) {
                        this.message = message;
                        this.stack = '';
                    }
                    // Make `instanceof Error` still work for returned errors.
                    PropTypeError.prototype = Error.prototype;

                    function createChainableTypeChecker(validate) {
                        if ("development" !== 'production') {
                            var manualPropTypeCallCache = {};
                            var manualPropTypeWarningCount = 0;
                        }
                        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                            componentName = componentName || ANONYMOUS;
                            propFullName = propFullName || propName;

                            if (secret !== ReactPropTypesSecret) {
                                if (throwOnDirectAccess) {
                                    // New behavior only for users of `prop-types` package
                                    invariant(
                                        false,
                                        'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
                                        'Use `PropTypes.checkPropTypes()` to call them. ' +
                                        'Read more at http://fb.me/use-check-prop-types'
                                    );
                                } else if ("development" !== 'production' && typeof console !== 'undefined') {
                                    // Old behavior for people using React.PropTypes
                                    var cacheKey = componentName + ':' + propName;
                                    if (
                                        !manualPropTypeCallCache[cacheKey] &&
                                        // Avoid spamming the console because they are often not actionable except for lib authors
                                        manualPropTypeWarningCount < 3
                                    ) {
                                        warning(
                                            false,
                                            'You are manually calling a React.PropTypes validation ' +
                                            'function for the `%s` prop on `%s`. This is deprecated ' +
                                            'and will throw in the standalone `prop-types` package. ' +
                                            'You may be seeing this warning due to a third-party PropTypes ' +
                                            'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
                                            propFullName,
                                            componentName
                                        );
                                        manualPropTypeCallCache[cacheKey] = true;
                                        manualPropTypeWarningCount++;
                                    }
                                }
                            }
                            if (props[propName] == null) {
                                if (isRequired) {
                                    if (props[propName] === null) {
                                        return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                                    }
                                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                                }
                                return null;
                            } else {
                                return validate(props, propName, componentName, location, propFullName);
                            }
                        }

                        var chainedCheckType = checkType.bind(null, false);
                        chainedCheckType.isRequired = checkType.bind(null, true);

                        return chainedCheckType;
                    }

                    function createPrimitiveTypeChecker(expectedType) {
                        function validate(props, propName, componentName, location, propFullName, secret) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== expectedType) {
                                // `propValue` being instance of, say, date/regexp, pass the 'object'
                                // check, but we can offer a more precise error message here rather than
                                // 'of type `object`'.
                                var preciseType = getPreciseType(propValue);

                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createAnyTypeChecker() {
                        return createChainableTypeChecker(emptyFunction.thatReturnsNull);
                    }

                    function createArrayOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== 'function') {
                                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
                            }
                            var propValue = props[propName];
                            if (!Array.isArray(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
                            }
                            for (var i = 0; i < propValue.length; i++) {
                                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                                if (error instanceof Error) {
                                    return error;
                                }
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createElementTypeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            if (!isValidElement(propValue)) {
                                var propType = getPropType(propValue);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createInstanceTypeChecker(expectedClass) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!(props[propName] instanceof expectedClass)) {
                                var expectedClassName = expectedClass.name || ANONYMOUS;
                                var actualClassName = getClassName(props[propName]);
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createEnumTypeChecker(expectedValues) {
                        if (!Array.isArray(expectedValues)) {
                            "development" !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
                            return emptyFunction.thatReturnsNull;
                        }

                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            for (var i = 0; i < expectedValues.length; i++) {
                                if (is(propValue, expectedValues[i])) {
                                    return null;
                                }
                            }

                            var valuesString = JSON.stringify(expectedValues);
                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createObjectOfTypeChecker(typeChecker) {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (typeof typeChecker !== 'function') {
                                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
                            }
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== 'object') {
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
                            }
                            for (var key in propValue) {
                                if (propValue.hasOwnProperty(key)) {
                                    var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                                    if (error instanceof Error) {
                                        return error;
                                    }
                                }
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createUnionTypeChecker(arrayOfTypeCheckers) {
                        if (!Array.isArray(arrayOfTypeCheckers)) {
                            "development" !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
                            return emptyFunction.thatReturnsNull;
                        }

                        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                            var checker = arrayOfTypeCheckers[i];
                            if (typeof checker !== 'function') {
                                warning(
                                    false,
                                    'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
                                    'received %s at index %s.',
                                    getPostfixForTypeWarning(checker),
                                    i
                                );
                                return emptyFunction.thatReturnsNull;
                            }
                        }

                        function validate(props, propName, componentName, location, propFullName) {
                            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                                var checker = arrayOfTypeCheckers[i];
                                if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                                    return null;
                                }
                            }

                            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createNodeChecker() {
                        function validate(props, propName, componentName, location, propFullName) {
                            if (!isNode(props[propName])) {
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function createShapeTypeChecker(shapeTypes) {
                        function validate(props, propName, componentName, location, propFullName) {
                            var propValue = props[propName];
                            var propType = getPropType(propValue);
                            if (propType !== 'object') {
                                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
                            }
                            for (var key in shapeTypes) {
                                var checker = shapeTypes[key];
                                if (!checker) {
                                    continue;
                                }
                                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                                if (error) {
                                    return error;
                                }
                            }
                            return null;
                        }
                        return createChainableTypeChecker(validate);
                    }

                    function isNode(propValue) {
                        switch (typeof propValue) {
                            case 'number':
                            case 'string':
                            case 'undefined':
                                return true;
                            case 'boolean':
                                return !propValue;
                            case 'object':
                                if (Array.isArray(propValue)) {
                                    return propValue.every(isNode);
                                }
                                if (propValue === null || isValidElement(propValue)) {
                                    return true;
                                }

                                var iteratorFn = getIteratorFn(propValue);
                                if (iteratorFn) {
                                    var iterator = iteratorFn.call(propValue);
                                    var step;
                                    if (iteratorFn !== propValue.entries) {
                                        while (!(step = iterator.next()).done) {
                                            if (!isNode(step.value)) {
                                                return false;
                                            }
                                        }
                                    } else {
                                        // Iterator will provide entry [k,v] tuples rather than values.
                                        while (!(step = iterator.next()).done) {
                                            var entry = step.value;
                                            if (entry) {
                                                if (!isNode(entry[1])) {
                                                    return false;
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    return false;
                                }

                                return true;
                            default:
                                return false;
                        }
                    }

                    function isSymbol(propType, propValue) {
                        // Native Symbol.
                        if (propType === 'symbol') {
                            return true;
                        }

                        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
                        if (propValue['@@toStringTag'] === 'Symbol') {
                            return true;
                        }

                        // Fallback for non-spec compliant Symbols which are polyfilled.
                        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
                            return true;
                        }

                        return false;
                    }

                    // Equivalent of `typeof` but with special handling for array and regexp.
                    function getPropType(propValue) {
                        var propType = typeof propValue;
                        if (Array.isArray(propValue)) {
                            return 'array';
                        }
                        if (propValue instanceof RegExp) {
                            // Old webkits (at least until Android 4.0) return 'function' rather than
                            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
                            // passes PropTypes.object.
                            return 'object';
                        }
                        if (isSymbol(propType, propValue)) {
                            return 'symbol';
                        }
                        return propType;
                    }

                    // This handles more types than `getPropType`. Only used for error messages.
                    // See `createPrimitiveTypeChecker`.
                    function getPreciseType(propValue) {
                        if (typeof propValue === 'undefined' || propValue === null) {
                            return '' + propValue;
                        }
                        var propType = getPropType(propValue);
                        if (propType === 'object') {
                            if (propValue instanceof Date) {
                                return 'date';
                            } else if (propValue instanceof RegExp) {
                                return 'regexp';
                            }
                        }
                        return propType;
                    }

                    // Returns a string that is postfixed to a warning about an invalid type.
                    // For example, "undefined" or "of type array"
                    function getPostfixForTypeWarning(value) {
                        var type = getPreciseType(value);
                        switch (type) {
                            case 'array':
                            case 'object':
                                return 'an ' + type;
                            case 'boolean':
                            case 'date':
                            case 'regexp':
                                return 'a ' + type;
                            default:
                                return type;
                        }
                    }

                    // Returns class name of the object, if any.
                    function getClassName(propValue) {
                        if (!propValue.constructor || !propValue.constructor.name) {
                            return ANONYMOUS;
                        }
                        return propValue.constructor.name;
                    }

                    ReactPropTypes.checkPropTypes = checkPropTypes;
                    ReactPropTypes.PropTypes = ReactPropTypes;

                    return ReactPropTypes;
                };

            }, { "144": 144, "152": 152, "159": 159, "161": 161, "164": 164 }], 164: [function (_dereq_, module, exports) {
                /**
                 * Copyright 2013-present, Facebook, Inc.
                 * All rights reserved.
                 *
                 * This source code is licensed under the BSD-style license found in the
                 * LICENSE file in the root directory of this source tree. An additional grant
                 * of patent rights can be found in the PATENTS file in the same directory.
                 */

                'use strict';

                var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

                module.exports = ReactPropTypesSecret;

            }, {}]
        }, {}, [48])(48)
    });
});

(function(e,t){'object'==typeof exports&&'object'==typeof module?module.exports=t():'function'==typeof define&&define.amd?define([],t):'object'==typeof exports?exports.PhotoEditorSDK=t():e.PhotoEditorSDK=t()})(this,function(){var e=Math.pow,t=Math.sin,o=Math.cos,r=Math.PI,a=String.fromCharCode,n=Math.sqrt,i=Math.abs,l=Math.ceil,d=Math.floor,p=Math.min,u=Math.max,s=Math.round;return function(e){function t(r){if(o[r])return o[r].exports;var a=o[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var o={};return t.m=e,t.c=o,t.d=function(e,o,r){t.o(e,o)||Object.defineProperty(e,o,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var o=e&&e.__esModule?function(){return e['default']}:function(){return e};return t.d(o,'a',o),o},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p='',t(t.s=100)}([function(e,t){'use strict';t.__esModule=!0,t.default=function(e,t){if(!(e instanceof t))throw new TypeError('Cannot call a class as a function')}},function(e,t,o){'use strict';t.__esModule=!0;var r=o(23),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t){if(!e)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return t&&('object'===('undefined'==typeof t?'undefined':(0,a.default)(t))||'function'==typeof t)?t:e}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=o(130),i=r(a),n=o(134),l=r(n),s=o(23),d=r(s);t.default=function(e,t){if('function'!=typeof t&&null!==t)throw new TypeError('Super expression must either be null or a function, not '+('undefined'==typeof t?'undefined':(0,d.default)(t)));e.prototype=(0,l.default)(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(i.default?(0,i.default)(e,t):e.__proto__=t)}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0}),t.LicenseChecker=t.Base64=t.GLUtils=t.Promise=t.Log=t.Constants=t.Color=t.Configurable=t.Utils=t.EventEmitter=t.Engine=t.cancelAnimationFrame=t.requestAnimationFrame=void 0;var a=o(137);Object.defineProperty(t,'requestAnimationFrame',{enumerable:!0,get:function(){return a.requestAnimationFrame}}),Object.defineProperty(t,'cancelAnimationFrame',{enumerable:!0,get:function(){return a.cancelAnimationFrame}});var i=o(76);Object.keys(i).forEach(function(e){'default'===e||'__esModule'===e||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}})});var n=o(11),l=r(n),s=o(10),d=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(s),p=o(31),u=r(p),_=o(30),f=r(_),c=o(26),g=r(c),y=o(16),h=r(y),m=o(12),x=r(m),T=o(22),v=r(T),b=o(7),C=r(b),R=o(81),O=r(R),E=o(171),S=r(E);t.Engine=l.default,t.EventEmitter=f.default,t.Utils=g.default,t.Configurable=h.default,t.Color=x.default,t.Constants=d,t.Log=v.default,t.Promise=C.default,t.GLUtils=O.default,t.Base64=u.default,t.LicenseChecker=S.default},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(183),_=r(u),f=o(16),c=r(f),g=p.Constants.OptionType,y=function(e){function t(){var o=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this,o,{intensity:{type:g.NUMBER,default:1,setter:function(e){return this._stack&&this._stack.setIntensity(e),e}},dirty:{type:g.BOOLEAN,default:!0}}));return r._stack=new _.default(r._options.intensity),r}return(0,d.default)(t,e),t.prototype.render=function(e,t,o){var r=this;return this._stack.render(e,t,o).then(function(e){return r.setDirty(!1),e})},t.prototype.setDirtyForRenderer=function(e,t){this._stack.setDirtyForRenderer(e,t)},t.prototype.disposeRenderTextures=function(){this._stack.disposeRenderTextures()},t.prototype.dispose=function(){this._stack.dispose()},t}(c.default);y.identifier=null,y.isIdentity=!1,y.displayName=null,y.PrimitivesStack=_.default,t.default=y},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(223);Object.defineProperty(t,'Brightness',{enumerable:!0,get:function(){return r(a).default}});var i=o(225);Object.defineProperty(t,'Contrast',{enumerable:!0,get:function(){return r(i).default}});var n=o(227);Object.defineProperty(t,'ColorMatrixPrimitive',{enumerable:!0,get:function(){return r(n).default}});var l=o(229);Object.defineProperty(t,'Desaturation',{enumerable:!0,get:function(){return r(l).default}});var s=o(231);Object.defineProperty(t,'Gamma',{enumerable:!0,get:function(){return r(s).default}});var d=o(233);Object.defineProperty(t,'Glow',{enumerable:!0,get:function(){return r(d).default}});var p=o(235);Object.defineProperty(t,'Gobblin',{enumerable:!0,get:function(){return r(p).default}});var u=o(237);Object.defineProperty(t,'Grayscale',{enumerable:!0,get:function(){return r(u).default}});var _=o(99);Object.defineProperty(t,'LookupTable',{enumerable:!0,get:function(){return r(_).default}});var f=o(240);Object.defineProperty(t,'LookupTableImage',{enumerable:!0,get:function(){return r(f).default}});var c=o(242);Object.defineProperty(t,'Saturation',{enumerable:!0,get:function(){return r(c).default}});var g=o(244);Object.defineProperty(t,'SoftColorOverlay',{enumerable:!0,get:function(){return r(g).default}});var y=o(246);Object.defineProperty(t,'ToneCurve',{enumerable:!0,get:function(){return r(y).default}});var h=o(247);Object.defineProperty(t,'X400',{enumerable:!0,get:function(){return r(h).default}});var m=o(249);Object.defineProperty(t,'ThreeDLookupTableImage',{enumerable:!0,get:function(){return r(m).default}})},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0}),t.GLUtils=t.Constants=t.Utils=t.Log=t.EventEmitter=t.Rectangle=t.Vector2=t.Matrix=t.Color=t.VERTEX_BYTE_SIZE=t.VERTEX_SIZE=t.BATCH_SIZE=void 0;var a=o(22),i=r(a),n=o(12),l=r(n),s=o(79),d=r(s),p=o(78),u=r(p),_=o(21),f=r(_),c=o(30),g=r(c),y=o(26),h=r(y),m=o(81),x=r(m),T=o(10),v=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(T),b=5;t.BATCH_SIZE=2e3,t.VERTEX_SIZE=b,t.VERTEX_BYTE_SIZE=4*b,t.Color=l.default,t.Matrix=d.default,t.Vector2=f.default,t.Rectangle=u.default,t.EventEmitter=g.default,t.Log=i.default,t.Utils=h.default,t.Constants=v,t.GLUtils=x.default},function(e,t,o){'use strict';(function(e,r){/*!
 * Native Promise Only
 * v0.8.0-a (c) Kyle Simpson
 * MIT License: http://getify.mit-license.org
 */Object.defineProperty(t,'__esModule',{value:!0});var a=o(23),i=function(e){return e&&e.__esModule?e:{default:e}}(a),n='undefined'==typeof r?window:r,l='undefined'==typeof Promise?function(){function t(e,t){y.add(e,t),g||(g=f(y.drain))}function o(e){var t='undefined'==typeof e?'undefined':(0,i.default)(e),r;return null!=e&&('object'==t||'function'==t)&&(r=e.then),'function'==typeof r&&r}function r(){for(var e=0;e<this.chain.length;e++)a(this,1===this.state?this.chain[e].success:this.chain[e].failure,this.chain[e]);this.chain.length=0}function a(e,t,r){var a,i;try{!1===t?r.reject(e.msg):(a=!0===t?e.msg:t.call(void 0,e.msg),a===r.promise?r.reject(TypeError('Promise-chain cycle')):(i=o(a))?i.call(a,r.resolve,r.reject):r.resolve(a))}catch(e){r.reject(e)}}function n(e){var a=this,i;if(!a.triggered){a.triggered=!0,a.def&&(a=a.def);try{(i=o(e))?t(function(){var t=new d(a);try{i.call(e,function(){n.apply(t,arguments)},function(){l.apply(t,arguments)})}catch(e){l.call(t,e)}}):(a.msg=e,a.state=1,0<a.chain.length&&t(r,a))}catch(e){l.call(new d(a),e)}}}function l(e){var o=this;o.triggered||(o.triggered=!0,o.def&&(o=o.def),o.msg=e,o.state=2,0<o.chain.length&&t(r,o))}function s(e,t,o,r){for(var a=0;a<t.length;a++)(function(a){e.resolve(t[a]).then(function(e){o(a,e)},r)})(a)}function d(e){this.def=e,this.triggered=!1}function p(e){this.promise=e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function u(e){if('function'!=typeof e)throw TypeError('Not a function');if(0!==this.__NPO__)throw TypeError('Not a promise');this.__NPO__=1;var a=new p(this);this.then=function(e,i){var n={success:'function'!=typeof e||e,failure:'function'==typeof i&&i};return n.promise=new this.constructor(function(e,t){if('function'!=typeof e||'function'!=typeof t)throw TypeError('Not a function');n.resolve=e,n.reject=t}),a.chain.push(n),0!==a.state&&t(r,a),n.promise},this['catch']=function(e){return this.then(void 0,e)};try{e.call(void 0,function(e){n.call(a,e)},function(e){l.call(a,e)})}catch(e){l.call(a,e)}}var _=Object.prototype.toString,f='undefined'==typeof e?setTimeout:function(t){return e(t)},c,g,y;try{Object.defineProperty({},'x',{}),c=function(e,t,o,r){return Object.defineProperty(e,t,{value:o,writable:!0,configurable:!1!==r})}}catch(e){c=function(e,t,o){return e[t]=o,e}}y=function(){function e(e,t){this.fn=e,this.self=t,this.next=void 0}var t,o,r;return{add:function(a,i){r=new e(a,i),o?o.next=r:t=r,o=r,r=void 0},drain:function(){var e=t;for(t=o=g=void 0;e;)e.fn.call(e.self),e=e.next}}}();var h=c({},'constructor',u,!1);return u.prototype=h,c(h,'__NPO__',0,!1),c(u,'resolve',function(e){var t=this;return e&&'object'==('undefined'==typeof e?'undefined':(0,i.default)(e))&&1===e.__NPO__?e:new t(function(t,o){if('function'!=typeof t||'function'!=typeof o)throw TypeError('Not a function');t(e)})}),c(u,'reject',function(e){return new this(function(t,o){if('function'!=typeof t||'function'!=typeof o)throw TypeError('Not a function');o(e)})}),c(u,'all',function(e){var t=this;return'[object Array]'==_.call(e)?0===e.length?t.resolve([]):new t(function(o,r){if('function'!=typeof o||'function'!=typeof r)throw TypeError('Not a function');var a=e.length,i=Array(a),n=0;s(t,e,function(e,t){i[e]=t,++n===a&&o(i)},r)}):t.reject(TypeError('Not an array'))}),c(u,'race',function(e){var t=this;return'[object Array]'==_.call(e)?new t(function(o,r){if('function'!=typeof o||'function'!=typeof r)throw TypeError('Not a function');s(t,e,function(e,t){o(t)},r)}):t.reject(TypeError('Not an array'))}),u}():Promise;n.Promise=n.Promise||l,t.default=l}).call(t,o(160).setImmediate,o(39))},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(10),u=o(7),_=r(u),f=o(22),c=r(f),g=o(11),y=r(g),h=o(16),m=r(h),x=o(91),T=r(x),v=function(e){function t(o){var r=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};(0,i.default)(this,t);var a=(0,l.default)(this,e.call(this,r,{enabled:{type:p.OptionType.BOOLEAN,default:!0,serializable:!1}}));return a._sdk=o,a._cacheEnabled=!1,a._dirtiness={},a._sprite=new y.default.Sprite,a._container=new y.default.Container,a._container.addChild(a._sprite),a}return(0,d.default)(t,e),t.prototype._onOptionsChange=function(){this.setDirty(!0)},t.prototype.render=function(e){var t=this;if(!this.getEnabled())return c.default.info(this.constructor.name,'Disabled - skipping'),_.default.resolve(e);if(!this._renderTexture){var o=this._sdk.getSprite().getTexture().getFrame();this._renderTexture=new y.default.RenderTexture(this._sdk.getRenderer(),o.width,o.height)}var r=this._sdk.getRenderer(),a,i;if(c.default.canLog('info')&&(i=new T.default(this.constructor.name,'Rendering')),this.isDirtyForRenderer(r)){this._sprite.setTexture(e);var n=this.getNewDimensions(e.getDimensions()).floor();this._renderTexture.resizeTo(n),this._renderTexture.clear(),a=this._render(e).then(function(){return t.setDirtyForRenderer(!1,r),t._renderTexture})}else c.default.info(this.constructor.name,'Rendering from cache'),a=_.default.resolve(this._renderTexture);return a.then(function(e){return i&&i.stop(),e})},t.prototype._render=function(e){var t;return t=this._sdk.getRenderer().isOfType(p.RendererType.WEBGL)?this._renderWebGL.bind(this):this._renderCanvas.bind(this),t(e)},t.prototype._renderWebGL=function(){throw new Error('Operation#_renderWebGL is abstract and not implemented in inherited class.')},t.prototype._renderCanvas=function(){throw new Error('Operation#_renderCanvas is abstract and not implemented in inherited class.')},t.prototype.getNewDimensions=function(e){return e.clone()},t.prototype.reset=function(){this._dirty=!0,this._glslPrograms={}},t.prototype.isDirtyForRenderer=function(e){var t=this._dirtiness[e.id];return'undefined'==typeof t||t},t.prototype.setDirtyForRenderer=function(e,t){2<arguments.length&&void 0!==arguments[2]&&arguments[2];this._dirtiness[t.id]=e},t.prototype.setDirty=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];for(var o in this._dirtiness)this.setDirtyForRenderer(e,{id:o},t)},t.prototype.getSDK=function(){return this._sdk},t.prototype.getInputDimensions=function(){var e=this,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:!0,o=this._sdk.getInputDimensions();t&&o.multiply(this._sdk.getZoom()).floor();var r;return this._sdk.getOperationsStack().forEach(function(t){return r?void 0:t===e?void(r=!0):void(o=t.getNewDimensions(o))}),o.floor()},t.prototype.clone=function(){var e=this.constructor;return new e(this._sdk,this.serializeOptions())},t.prototype.disposeRenderTextures=function(){this._renderTexture&&this._renderTexture.dispose(),this._renderTexture=null},t.prototype.dispose=function(){this.disposeRenderTextures(),this._sprite.dispose()},t}(m.default);v.identifier=null,t.default=v},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(16),u=r(p),_=function(e){function t(){return(0,i.default)(this,t),(0,l.default)(this,e.apply(this,arguments))}return(0,d.default)(t,e),t.prototype.update=function(){},t.prototype.getFilter=function(){return this._filter},t.prototype.dispose=function(){this._filter&&(this._filter.dispose(),this._filter=null)},t}(u.default);t.default=_},function(e,t){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var o=t.RenderType={IMAGE:'image',DATAURL:'data-url',BUFFER:'buffer',BLOB:'blob',MSBLOB:'ms-blob'},r=t.ImageFormat={PNG:'image/png',JPEG:'image/jpeg'},a=t.Events={OPERATION_UPDATED:'operation:update'},i=t.OptionType={NUMBER:'number',VECTOR2:'vector2',COLOR_MATRIX:'color-matrix',COLOR:'color',ARRAY:'array',OBJECT:'object',STRING:'string',BOOLEAN:'boolean',CONFIGURABLE:'configurable',IMAGE:'image',FUNCTION:'function',TEXTURE:'texture',ALL:'*'},n=t.UniformType={SAMPLER2D:'sampler2d',INT:'i',INT1:'1i',FLOAT:'f',FLOAT1:'1f',FLOAT2:'2f',FLOAT_VECTOR2:'2fv',FLOAT3:'3f',FLOAT4:'4f',MAT3:'mat3',MAT3FV:'mat3fv',MAT4:'mat4'},l=t.RendererType={WEBGL:'webgl',CANVAS:'canvas'}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(148),i=r(a),n=o(150),l=r(n),s=o(61),d=r(s),p=o(65),u=r(p),_=o(64),f=r(_),c=o(88),g=r(c),y=o(32),h=r(y),m=o(89),x=r(m),T=o(156),v=r(T),b=o(42),C=r(b),R=o(41),O=r(R),E=o(157),S=r(E),F=o(159),M=r(F),k=o(63),P=r(k),D=o(33),B=r(D),I=o(162),w=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(I),L=o(87),A=r(L),N={WebGLRenderer:l.default,CanvasRenderer:i.default,WebGLFilterManager:u.default,CanvasFilterManager:d.default,DisplayObject:f.default,Container:g.default,BaseTexture:h.default,Texture:x.default,RenderTexture:v.default,WebGLRenderTarget:C.default,CanvasRenderTarget:O.default,Sprite:S.default,Shaders:M.default,Shader:P.default,Filter:B.default,Filters:w,PixelArrayImage:A.default,autoDetectRenderer:function(e,t){var o=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{};return l.default.isSupported()?new l.default(e,t,o):new i.default(e,t,o)}};t.default=N},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(140),i=r(a),n=o(0),l=r(n),_=o(40),f=r(_),c=function(){function e(t,o,r){var i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:1;(0,l.default)(this,e),this.r=t,this.g=o,this.b=r,this.a=i}return e.prototype.toRGBA=function(){var e=[s(255*this.r),s(255*this.g),s(255*this.b),this.a.toFixed(2)];return'rgba('+e.join(',')+')'},e.prototype.set=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:this.a;return this.r=e,this.g=t,this.b=o,this.a=r,this},e.prototype.toRGB=function(){return[s(255*this.r),s(255*this.g),s(255*this.b)]},e.prototype.toHex=function(){var e=[this._componentToHex(s(255*this.r)),this._componentToHex(s(255*this.g)),this._componentToHex(s(255*this.b))];return'#'+e.join('')},e.prototype.toGLColor=function(){return[this.r,this.g,this.b,this.a]},e.prototype.toArray=function(){return this.toGLColor()},e.prototype.toRGBGLColor=function(){return[this.r,this.g,this.b]},e.prototype.toHSV=function(){var e=u(this.r,this.g,this.b),t=p(this.r,this.g,this.b),o=e-t,r,a;return a=0===e?0:o/e,e===t?r=0:(e===this.r?(r=(this.g-this.b)/o,this.g<this.b&&(r+=6)):e===this.g?r=(this.b-this.r)/o+2:e===this.b?r=(this.r-this.g)/o+4:void 0,r/=6),[r,a,e]},e.prototype.fromHSV=function(t,o,r){return this.copy(e.fromHSV(t,o,r)),this},e.fromHSV=function(o,n,l){var s=3<arguments.length&&void 0!==arguments[3]?arguments[3]:1,a=[],u=a[0],r=a[1],_=a[2],c=d(6*o),i=6*o-c,f=l*(1-n),p=l*(1-i*n),g=l*(1-(1-i)*n);switch(c%6){case 0:u=l,r=g,_=f;break;case 1:u=p,r=l,_=f;break;case 2:u=f,r=l,_=g;break;case 3:u=f,r=p,_=l;break;case 4:u=g,r=f,_=l;break;case 5:u=l,r=f,_=p;}return new e(u,r,_,s)},e.fromArray=function(t){return new e(t[0],t[1],t[2],t[3])},e.fromHex=function(t){var o=t.match(/.{1,2}/g),a=(0,i.default)(o,3),n=a[0],r=a[1],l=a[2];return new e(parseInt(n,16)/255,parseInt(r,16)/255,parseInt(l,16)/255,1)},e.prototype.clone=function(){return new e(this.r,this.g,this.b,this.a)},e.prototype.copy=function(e){return this.r=e.r,this.g=e.g,this.b=e.b,this.a=e.a,this},e.prototype.equals=function(e){return this.r===e.r&&this.g===e.g&&this.b===e.b&&this.a===e.a},e.prototype._componentToHex=function(e){var t=e.toString(16);return 1===t.length?'0'+t:t},e.prototype.toString=function(){return'Color('+this.r+', '+this.g+', '+this.b+', '+this.a+')'},(0,f.default)(e,null,[{key:'TRANSPARENT',get:function(){return new e(0,0,0,0)}},{key:'WHITE',get:function(){return new e(1,1,1,1)}},{key:'BLACK',get:function(){return new e(0,0,0,1)}}]),e}();t.default=c},function(e){var t=e.exports={version:'2.4.0'};'number'==typeof __e&&(__e=t)},function(e,t,o){var r=o(52)('wks'),a=o(38),i=o(15).Symbol,n='function'==typeof i,l=e.exports=function(e){return r[e]||(r[e]=n&&i[e]||(n?i:a)('Symbol.'+e))};l.store=r},function(e){var t=e.exports='undefined'!=typeof window&&window.Math==Math?window:'undefined'!=typeof self&&self.Math==Math?self:Function('return this')();'number'==typeof __g&&(__g=t)},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(23),i=r(a),n=o(82),l=r(n),s=o(0),d=r(s),p=o(1),u=r(p),_=o(2),f=r(_),c=o(7),g=r(c),y=o(22),h=r(y),m=o(30),x=r(m),T=o(21),v=r(T),b=o(12),C=r(b),R=o(26),O=r(R),E=o(59),S=r(E),F=o(10),M;M=window.Image;var k=function(e){function t(){var o=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},r=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};(0,d.default)(this,t);var a=(0,u.default)(this,e.call(this));return a.availableOptions=a.availableOptions||{},a.availableOptions=O.default.extend(a.availableOptions,r),a._onConfigurableUpdate=a._onConfigurableUpdate.bind(a),a._initOptions(o),a}return(0,f.default)(t,e),t.prototype._buildConfigError=function(e){var t='';return this.constructor.name&&(t=this.constructor.name+': '),t+=e,new Error(t)},t.prototype._onOptionsChange=function(){},t.prototype.validateSettings=function(){var e=this;return new g.default(function(t,o){for(var r in e.availableOptions){var a=e.availableOptions[r];if(a.required&&'undefined'==typeof e._options[r])return o(e._buildConfigError('Option `'+r+'` is required.'))}t()})},t.prototype._initOptions=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._options={};var o=this,r,a,i;for(r in this.availableOptions){if(i=r.charAt(0).toUpperCase()+r.slice(1),a=this.availableOptions[r],-1===[F.OptionType.STRING,F.OptionType.NUMBER,F.OptionType.BOOLEAN,F.OptionType.OBJECT,F.OptionType.VECTOR2,F.OptionType.COLOR,F.OptionType.CONFIGURABLE,F.OptionType.COLOR_MATRIX,F.OptionType.ARRAY,F.OptionType.IMAGE,F.OptionType.FUNCTION,F.OptionType.ALL].indexOf(a.type))throw this._buildConfigError('Unknown option type: `'+a.type+'`');var n=function(e){o['set'+i]=function(t,r,a){o.setOption(e,t,r,a)},o['get'+i]=function(){return o.getOption(e)}};if(n(r,a),a.type===F.OptionType.CONFIGURABLE&&(this._options[r]=new t(void 0,a.structure||{}),this._options[r].on('update',this._onConfigurableUpdate)),!(r in e)||'undefined'==typeof e[r])if('undefined'!=typeof a.default){var l=a.default;'function'==typeof a.default&&(l=a.default()),this['set'+i](l,!1,!0)}else a.type!==F.OptionType.CONFIGURABLE&&(this._options[r]=void 0)}for(r in e){if('undefined'==typeof this.availableOptions[r])throw new Error('Invalid option: '+r);'undefined'!=typeof e[r]&&(i=r.charAt(0).toUpperCase()+r.slice(1),this['set'+i](e[r],!1,!0))}},t.prototype.set=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:!0;for(var o in t&&this.emit('update',this,e),e)this.setOption(o,e[o],!1);this._onOptionsChange()},t.prototype.getOption=function(e){return this._options[e]},t.prototype.hasOption=function(e){return!!this.availableOptions[e]},t.prototype.getOptionDefault=function(e){var t=this.availableOptions[e];if(!t)throw new Error('Invalid option: '+e);return t.default},t.prototype.getDefaultOptions=function(){var e={};for(var t in this.availableOptions){var o=this.availableOptions[t].default;'undefined'==typeof o||(e[t]=o)}return e},t.prototype.optionsEqual=function(e){for(var t in e){var o=e[t];if(!this._optionEquals(t,o))return!1}return!0},t.prototype._optionEquals=function(e,t){var o=this.availableOptions[e];if('undefined'==typeof o)throw new Error('Invalid option: '+e);var r=this.availableOptions[e].type,a=this._options[e];return a===t||(r===F.OptionType.STRING||r===F.OptionType.NUMBER||r===F.OptionType.BOOLEAN||r===F.OptionType.OBJECT||r===F.OptionType.FUNCTION||'*'===r?a===t:r===F.OptionType.VECTOR2?a.equals(t):r===F.OptionType.COLOR||r===F.OptionType.COLOR_MATRIX?t.equals(a):r===F.OptionType.CONFIGURABLE?a.optionsEqual(t):r===F.OptionType.ARRAY?this._arrayOptionEquals(e,t):r===F.OptionType.IMAGE?a.src===t.src:void 0)},t.prototype._arrayOptionEquals=function(e,o){for(var r=this._options[e],a=!0,n=0;n<r.length;n++){var i=r[n],l=o[n];if(i instanceof t){if('undefined'==typeof l||!i.optionsEqual(l)){a=!1;break}}else if(l!==i){a=!1;break}}return a},t.prototype.serializeOptions=function(){var e=this,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:Object.keys(this._options),o=1<arguments.length&&void 0!==arguments[1]&&arguments[1],r={};return t.forEach(function(t){return'undefined'==typeof e.availableOptions[t]?h.default.warn('Trying to serialize a key that does not exist: '+t):void(!1===e.availableOptions[t].serializable||(r[t]=e.serializeOption(t,o)))}),r},t.prototype.serializeOption=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1],o=this.availableOptions[e],r=o.type,a=this._options[e];if(!a)return a;if(!1===o.serializable)throw new Error('Option `'+e+'` is not serializable.');return r===F.OptionType.STRING||r===F.OptionType.NUMBER||r===F.OptionType.BOOLEAN||r===F.OptionType.OBJECT||r===F.OptionType.FUNCTION||r===F.OptionType.ALL?a:r===F.OptionType.VECTOR2?t?a.toObject():a.clone():r===F.OptionType.COLOR||r===F.OptionType.COLOR_MATRIX?t?a.toArray():a.clone():r===F.OptionType.CONFIGURABLE?a.serializeOptions(void 0,t):r===F.OptionType.ARRAY?a.slice(0):r===F.OptionType.IMAGE?t?a.src:a:void 0},t.prototype.setOption=function(e,t){var o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0,r=3<arguments.length&&void 0!==arguments[3]&&arguments[3];o&&this.emit('update',this,(0,l.default)({},e,t));var a=this.availableOptions[e];if(!a)throw new Error('Invalid option: '+e);if('undefined'!=typeof a.setter&&(t=a.setter.call(this,t,r)),'undefined'!=typeof a.validation&&a.validation(t),null===t||'undefined'==typeof t){if(a.required)throw this._buildConfigError('Option `'+e+'` is required.');this._options[e]=t}else switch(a.type){case F.OptionType.STRING:if(('undefined'==typeof t?'undefined':(0,i.default)(t))!==F.OptionType.STRING)throw this._buildConfigError('Option `'+e+'` has to be a string.');var n=a.available;if('undefined'!=typeof n&&-1===n.indexOf(t))throw this._buildConfigError('Invalid value for `'+e+'` (valid values are: '+a.available.join(', ')+')');this._options[e]=t;break;case F.OptionType.NUMBER:if(('undefined'==typeof t?'undefined':(0,i.default)(t))!==F.OptionType.NUMBER)throw this._buildConfigError('Option `'+e+'` has to be a number.');this._options[e]=t;break;case F.OptionType.BOOLEAN:if(('undefined'==typeof t?'undefined':(0,i.default)(t))!==F.OptionType.BOOLEAN)throw this._buildConfigError('Option `'+e+'` has to be a boolean.');this._options[e]=t;break;case F.OptionType.VECTOR2:if(!(t instanceof v.default)&&!('object'===('undefined'==typeof t?'undefined':(0,i.default)(t))&&'x'in t&&'y'in t))throw this._buildConfigError('Option `'+e+'` has to be an instance of Vector2 or an Object holding x and y values.');this._options[e]=t instanceof v.default?t.clone():v.default.fromObject(t);break;case F.OptionType.COLOR:if(!(t instanceof C.default))throw this._buildConfigError('Option `'+e+'` has to be an instance of Color.');this._options[e]=t;break;case F.OptionType.COLOR_MATRIX:if(!(t instanceof S.default))throw this._buildConfigError('Option `'+e+'` has to be an instance of ColorMatrix.');this._options[e]=t.clone();break;case F.OptionType.FUNCTION:if('function'!=typeof t)throw this._buildConfigError('Option `'+e+'` has to be a function.');this._options[e]=t;break;case F.OptionType.OBJECT:case'*':this._options[e]=t;break;case F.OptionType.IMAGE:if('string'==typeof t){var s=new M;s.src=t,this._options[e]=s}else if(t instanceof M||'undefined'!=typeof HTMLImageElement&&t instanceof HTMLImageElement)this._options[e]=t;else throw this._buildConfigError('Option `'+e+'` has to be an Image or String.');break;case F.OptionType.CONFIGURABLE:this._options[e].set(t);break;case F.OptionType.ARRAY:if(!(t instanceof Array))throw this._buildConfigError('Option `'+e+'` has to be an Array.');this._options[e]=t.slice(0);break;default:throw this._buildConfigError('Unknown option type: `'+a.type+'`');}o&&(this._onOptionsChange(),this.emit('update',this,(0,l.default)({},e,t)))},t.prototype._onConfigurableUpdate=function(){for(var e=arguments.length,t=Array(e),o=0;o<e;o++)t[o]=arguments[o];this.emit.apply(this,['update'].concat(t))},t}(x.default);t.default=k},function(e,t,o){var r=o(25),a=o(69),i=o(48),n=Object.defineProperty;t.f=o(18)?Object.defineProperty:function(e,t,o){if(r(e),t=i(t,!0),r(o),a)try{return n(e,t,o)}catch(t){}if('get'in o||'set'in o)throw TypeError('Accessors not supported!');return'value'in o&&(e[t]=o.value),e}},function(e,t,o){e.exports=!o(35)(function(){return 7!=Object.defineProperty({},'a',{get:function(){return 7}}).a})},function(e){var t={}.hasOwnProperty;e.exports=function(e,o){return t.call(e,o)}},function(e,t,o){var r=o(109),a=o(46);e.exports=function(e){return r(a(e))}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),d=r(a),_=o(40),f=r(_),c=function(){function e(t,o){(0,d.default)(this,e),this.x=t,this.y=o,'undefined'==typeof this.x&&(this.x=0),'undefined'==typeof this.y&&(this.y=0)}return e.prototype.set=function(e,t){return this.x=e,this.y=t,this},e.prototype.clone=function(){return new e(this.x,this.y)},e.prototype.copy=function(e){return this.x=e.x,this.y=e.y,this},e.prototype.clamp=function(t,o){var r=null!==t&&'undefined'!=typeof t,a=null!==o&&'undefined'!=typeof o;return!(t instanceof e)&&r&&(t=new e(t,t)),!(o instanceof e)&&a&&(o=new e(o,o)),r&&(this.x=u(t.x,this.x),this.y=u(t.y,this.y)),a&&(this.x=p(o.x,this.x),this.y=p(o.y,this.y)),this},e.prototype.divide=function(t,o){return t instanceof e?(this.x/=t.x,this.y/=t.y):(this.x/=t,this.y/='undefined'==typeof o?t:o),this},e.prototype.subtract=function(t,o){return t instanceof e?(this.x-=t.x,this.y-=t.y):(this.x-=t,this.y-='undefined'==typeof o?t:o),this},e.prototype.multiply=function(t,o){return t instanceof e?(this.x*=t.x,this.y*=t.y):(this.x*=t,this.y*='undefined'==typeof o?t:o),this},e.prototype.add=function(t,o){return t instanceof e?(this.x+=t.x,this.y+=t.y):(this.x+=t,this.y+='undefined'==typeof o?t:o),this},e.prototype.equals=function(t,o){return t instanceof e?t.x===this.x&&t.y===this.y:t===this.x&&o===this.y},e.prototype.flip=function(){var e=this.x;return this.x=this.y,this.y=e,this},e.prototype.round=function(){return this.x=s(this.x),this.y=s(this.y),this},e.prototype.ceil=function(){return this.x=l(this.x),this.y=l(this.y),this},e.prototype.floor=function(){return this.x|=0,this.y|=0,this},e.prototype.abs=function(){return this.x=i(this.x),this.y=i(this.y),this},e.prototype.len=function(){return n(this.x*this.x+this.y*this.y)},e.prototype.min=function(){return p(this.x,this.y)},e.prototype.max=function(){return u(this.x,this.y)},e.prototype.toObject=function(){return{x:this.x,y:this.y}},e.prototype.toString=function(){return'Vector2({ x: '+this.x+', y: '+this.y+' })'},e.prototype.roundDecimal=function(e){return this.x=parseFloat(this.x.toFixed(e)),this.y=parseFloat(this.y.toFixed(e)),this},e.fromObject=function(t){return new e(t.x,t.y)},(0,f.default)(e,null,[{key:'NULL',get:function(){return new e(0,0)}}]),e}();t.default=c},function(e,t,o){'use strict';(function(e){Object.defineProperty(t,'__esModule',{value:!0});var o='warn',r=[{type:'trace',background:'#EEEEEE',color:'#AAAAAA'},{type:'info',background:'#BDE5F8',color:'#00529B'},{type:'warn',background:'#FEEFB3',color:'#9F6000'},{type:'error',background:'#FFBABA',color:'#D8000C'},{type:'log',background:'#EEEEEE',color:'#1f4f6b'}],a=r.map(function(e){return e.type}),i={};i.setLevel=function(e){o=e},i.canLog=function(e){if(null===o)return!1;var t=a.indexOf(e),r=a.indexOf(o);return!(t<r)},i.hasColorfulOutput=function(){return(!e||e&&e.browser)&&'undefined'!=typeof navigator&&navigator.userAgent.match(/Gecko|WebKit/i)&&!navigator.userAgent.match(/Trident/)},i.printError=function(t){var e=t.stack.split('\n');e.forEach(function(e){i.error('Error',e)})},r.forEach(function(e){var t=e.type,o=e.background,r=e.color;i[t]=function(e){if('undefined'!=typeof console&&i.canLog(t)){for(var a=arguments.length,n=Array(1<a?a-1:0),l=1;l<a;l++)n[l-1]=arguments[l];var s=n.map(function(e){return'string'==typeof e?e:e.toString()}).join(' ');return i.hasColorfulOutput()?void console.log('%c  %c PhotoEditorSDK %c  %c '+e+' %c  '+s+'  %c  ','background: #2D7BFF; line-height: 20px; padding: 4px 0','background: #2B2B2B; color: white; line-height: 20px; padding: 4px 0','background: #2D7BFF; line-height: 20px; padding: 4px 0','background: '+o+'; color: '+r+'; line-height: 20px; padding: 4px 0; font-weight: bold','background: #2B2B2B; color: white; line-height: 20px; padding: 4px 0','background: #2D7BFF; line-height: 20px; padding: 4px 0'):console.log('PhotoEditorSDK | '+e+' | '+s)}}}),t.default=i}).call(t,o(60))},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=o(103),i=r(a),n=o(119),l=r(n),s='function'==typeof l.default&&'symbol'==typeof i.default?function(e){return typeof e}:function(e){return e&&'function'==typeof l.default&&e.constructor===l.default&&e!==l.default.prototype?'symbol':typeof e};t.default='function'==typeof l.default&&'symbol'===s(i.default)?function(e){return'undefined'==typeof e?'undefined':s(e)}:function(e){return e&&'function'==typeof l.default&&e.constructor===l.default&&e!==l.default.prototype?'symbol':'undefined'==typeof e?'undefined':s(e)}},function(e,t,o){var r=o(17),a=o(36);e.exports=o(18)?function(e,t,o){return r.f(e,t,a(1,o))}:function(e,t,o){return e[t]=o,e}},function(e,t,o){var r=o(28);e.exports=function(e){if(!r(e))throw TypeError(e+' is not an object!');return e}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(23),n=r(i),l=o(0),s=r(l),d=o(31),_=r(d),f=function(){function e(){(0,s.default)(this,e)}return e.isArray=function(e){return'[object Array]'===Object.prototype.toString.call(e)},e.isMobile=function(){if('undefined'==typeof navigator)return!1;var e=navigator.userAgent||navigator.vendor||window.opera;return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0,4))},e.values=function(e){var t=[];for(var o in e)t.push(e[o]);return t},e.isDOMElement=function(e){return'object'===('undefined'==typeof HTMLElement?'undefined':(0,n.default)(HTMLElement))?e instanceof HTMLElement:e&&'object'===('undefined'==typeof e?'undefined':(0,n.default)(e))&&null!==e&&1===e.nodeType&&'string'==typeof e.nodeName},e.isTouchEvent=function(t){return-1!==t.type.indexOf('touch')},e.resizeVectorToFit=function(e,t){var o=p(t.x/e.x,t.y/e.y),r=e.clone().multiply(o);return r},e.resizeVectorToFill=function(e,t){var o=e.x/e.y,r=t.x/t.y;return o>r?t.clone().set(t.y*o,t.y):t.clone().set(t.x,t.x/o)},e.isExtendable=function(e){return'undefined'!=typeof e&&null!==e&&('object'===('undefined'==typeof e?'undefined':(0,n.default)(e))||'function'==typeof e)},e.defaults=function(e){var t={};for(var o in e)t[o]=e[o];for(var r=arguments.length,a=Array(1<r?r-1:0),n=1;n<r;n++)a[n-1]=arguments[n];for(var l=0,i;l<a.length;l++)for(var s in i=a[l],i)'undefined'==typeof t[s]&&(t[s]=i[s]);return t},e.deepDefaults=function(t){var o={};for(var r in t)o[r]=t[r];for(var a=arguments.length,n=Array(1<a?a-1:0),l=1;l<a;l++)n[l-1]=arguments[l];for(var s=0,i;s<n.length;s++)for(var d in i=n[s],i)e.isExtendable(o[d])&&e.isExtendable(i[d])?o[d]=e.deepDefaults(o[d],i[d]):'undefined'==typeof o[d]&&(o[d]=i[d]);return o},e.deepClone=function(t){var o={};for(var r in t)o[r]=e.isExtendable(t[r])?e.deepClone(t[r]):t[r];return o},e.extend=function(e){var t={};for(var o in e)t[o]=e[o];for(var r=arguments.length,a=Array(1<r?r-1:0),n=1;n<r;n++)a[n-1]=arguments[n];for(var l=0,i;l<a.length;l++)for(var s in i=a[l],i)t[s]=i[s];return t},e.clone=function(e){return this.extend({},e)},e.createBlobURIFromDataURI=function(e){if(!window.Blob||!window.URL||!ArrayBuffer||!Uint8Array)return e;for(var t=_.default.decode(e.split(',')[1]),o=e.split(',')[0].split(':')[1].split(';')[0],r=new ArrayBuffer(t.length),a=new Uint8Array(r),n=0;n<t.length;n++)a[n]=t[n];var i=new window.Blob([r],{type:o});return window.URL.createObjectURL(i)},e.requestAnimationFrame=function(e){var t=function(e){setTimeout(e,1e3/60)};return'undefined'==typeof window?t(e):(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||t)(e)},e.getUUID=function(){return'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(e){var t=0|16*Math.random(),o='x'===e?t:8|3&t;return o.toString(16)})},e.flatten=function(t){return t.reduce(function(t,o){return t.concat(Array.isArray(o)?e.flatten(o):o)},[])},e.createCanvas=function(){return document.createElement('canvas')},e.isPowerOfTwo=function(e){return 0==(e.x&e.x-1)&&0==(e.y&e.y-1)},e.nextLowestPOT=function(e){for(var t=1;32>t;t<<=1)e|=e>>t;return e-(e>>1)},e.nextHighestPOT=function(e){e--;for(var t=1;32>t;t<<=1)e|=e>>t;return e+1},e.moveArrayItem=function(e,t,o){if(o>=e.length)for(var r=o-e.length;r--+1;)e.push(void 0);e.splice(o,0,e.splice(t,1)[0])},e.ensureCanvasDimensions=function(e,t){(e.width!==t.x||e.height!==t.y)&&(e.width=t.x,e.height=t.y)},e.byteArrayToString=function(e){return e.map(function(e){return a(e)}).join('')},e.clamp=function(e,t,o){return u(t,p(e,o))},e.wildCardMatch=function(e,t){return new RegExp('^'+t.split('*').join('.*')+'$').test(e)},e.flipObject=function(e){var t={};for(var o in e)t[e[o]]=o;return t},e.cloneOptions=function(e){var t={};for(var o in e){var r=e[o];Array.isArray(r)?r=r.slice():r.clone&&(r=r.clone()),t[o]=r}return t},e.ISODateString=function(e){function t(e){return 10>e?'0'+e:e}return e.getUTCFullYear()+'-'+t(e.getUTCMonth()+1)+'-'+t(e.getUTCDate())+'T'+t(e.getUTCHours())+':'+t(e.getUTCMinutes())+':'+t(e.getUTCSeconds())+'Z'},e}();t.default=f},function(e,t,o){var r=o(15),a=o(13),i=o(68),n=o(24),l='prototype',s=function(e,t,o){var d=e&s.F,p=e&s.G,u=e&s.S,_=e&s.P,f=e&s.B,c=e&s.W,g=p?a:a[t]||(a[t]={}),y=g[l],h=p?r:u?r[t]:(r[t]||{})[l],m,x,T;for(m in p&&(o=t),o)x=!d&&h&&void 0!==h[m],x&&m in g||(T=x?h[m]:o[m],g[m]=p&&'function'!=typeof h[m]?o[m]:f&&x?i(T,r):c&&h[m]==T?function(e){var t=function(t,o,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,o);}return new e(t,o,r)}return e.apply(this,arguments)};return t[l]=e[l],t}(T):_&&'function'==typeof T?i(Function.call,T):T,_&&((g.virtual||(g.virtual={}))[m]=T,e&s.R&&y&&!y[m]&&n(y,m,T)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,e.exports=s},function(e){e.exports=function(e){return'object'==typeof e?null!==e:'function'==typeof e}},function(e){e.exports={}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(22),l=r(n),s=function(){function e(){(0,i.default)(this,e),this._maxListeners=12,this._events={},this._pipeDestinations=[]}return e.prototype.pipeEvents=function(e){this._pipeDestinations.push(e)},e.prototype.unpipeEvents=function(e){var t=this._pipeDestinations.indexOf(e);-1===t||this._pipeDestinations.splice(t,1)},e.prototype.on=function(e,t){if('undefined'==typeof e)throw new Error('Invalid event type: `'+e+'`');if('function'!=typeof t)throw new TypeError;var o=this._events[e]||(this._events[e]=[]);return-1===o.indexOf(t)?(o.push(t),this._maxListeners&&o.length>this._maxListeners&&(l.default.warn('EventEmitter','Possible memory leak detected, added '+o.length+' `'+e+'` listeners (current limit is '+this._maxListeners+')'),'undefined'!=typeof console&&console.trace()),this):this},e.prototype.once=function(e,t){function o(){r.off(e,o),t.apply(null,arguments)}if('undefined'==typeof e)throw new Error('Invalid event type: `'+e+'`');var r=this;return this.on(e,o)},e.prototype.off=function(e){if('undefined'==typeof e)throw new Error('Invalid event type: `'+e+'`');if(0==(1>=arguments.length?0:arguments.length-1))return this._events[e]=null,this;var t=1>=arguments.length?void 0:arguments[1];if('function'!=typeof t)throw new TypeError;var o=this._events[e];if(!o||!o.length)return this;var r=o.indexOf(t);return-1===r?this:(o.splice(r,1),this)},e.prototype.emit=function(e){for(var t=arguments.length,o=Array(1<t?t-1:0),r=1;r<t;r++)o[r-1]=arguments[r];if('undefined'==typeof e)throw new Error('Invalid event type: `'+e+'`');this._pipeDestinations.forEach(function(t){t.emit.apply(t,[e].concat(o))});var a=this._events[e];return a&&a.length&&(a.forEach(function(e){return e.apply(null,o)}),!0)},e.prototype.setMaxListeners=function(e){if(parseInt(e,10)!==e)throw new TypeError;this._maxListeners=e},e}();t.default=s},function(e,t){'use strict';Object.defineProperty(t,'__esModule',{value:!0});/*
 * Extracted from MinifyJpeg (Copyright (c) 2014 Hiroaki Matoba, MIT License):
 * https://github.com/hMatoba/MinifyJpeg
 * @license
 */var o='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';t.default={encode:function(e){var t='',r=0,a,i,n,l,s,d,p;do a=e[r++],i=e[r++],n=e[r++],l=a>>2,s=(3&a)<<4|i>>4,d=(15&i)<<2|n>>6,p=63&n,isNaN(i)?d=p=64:isNaN(n)&&(p=64),t=t+o.charAt(l)+o.charAt(s)+o.charAt(d)+o.charAt(p),a=i=n='',l=s=d=p='';while(r<e.length);return t},decode:function(e){var t=0,r=[],a=/[^A-Za-z0-9+/=]/g,i,n,l,s,d,p,u;if(a.exec(e))throw new Error('There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, \'+\', \'/\',and \'=\'\nExpect errors in decoding.');e=e.replace(/[^A-Za-z0-9+/=]/g,'');do s=o.indexOf(e.charAt(t++)),d=o.indexOf(e.charAt(t++)),p=o.indexOf(e.charAt(t++)),u=o.indexOf(e.charAt(t++)),i=s<<2|d>>4,n=(15&d)<<4|p>>2,l=(3&p)<<6|u,r.push(i),64!==p&&r.push(n),64!==u&&r.push(l),i=n=l='',s=d=p=u='';while(t<e.length);return r}}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=function(e){function t(o){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r.id=t.id++,r._onSourceLoaded=r._onSourceLoaded.bind(r),r._renderers=[],r._glTextures={},r._source=o,r._dirty=!0,r._glUnit=0,r._mipMapping=!1,r._magFilter=t.DefaultMagFilter,r._minFilter=t.DefaultMinFilter,r._repeatX=t.ClampToEdge,r._repeatY=t.ClampToEdge,r._pixelRatio=1,r._loaded=!1,r._frame=new p.Rectangle(0,0,100,100),o&&r._loadSource(),r}return(0,d.default)(t,e),t.prototype.resizeTo=function(e){this._frame.width===e.x&&this._frame.height===e.y||(this._frame.width=e.x,this._frame.height=e.y,this._dirty=!0)},t.prototype._loadSource=function(){var e=this._source,t=e.complete,o='Canvas'===e.constructor.name||e.tagName&&'CANVAS'===e.tagName.toUpperCase();return t||o?this._onSourceLoaded():void e.addEventListener('load',this._onSourceLoaded)},t.prototype._onSourceLoaded=function(){this._loaded=!0,this.emit('loaded'),this.update()},t.prototype._updateGLFilters=function(){var e=new p.Vector2(this._source.width,this._source.height);p.Utils.isPowerOfTwo(e)?(p.Log.info(this.constructor.name,'Mip-mapping enabled'),this._minFilter=t.TrilinearFilter,this._mipMapping=!0):(this._minFilter=t.LinearFilter,this._mipMapping=!1)},t.prototype.update=function(){(this._frame.width!==this._source.width||this._frame.height!==this._source.height)&&(this._frame=new p.Rectangle(0,0,this._source.width,this._source.height),this._dirty=!0),this._updateGLFilters(),this.emit('update')},t.prototype.getGLFilter=function(e,t){return'min'===t?this.constructor.getGLFilter(e,this._minFilter):'mag'===t?this.constructor.getGLFilter(e,this._magFilter):void 0},t.getGLFilter=function(e,o){return o===t.LinearFilter?e.LINEAR:o===t.NearestFilter?e.NEAREST:o===t.BilinearFilter?e.LINEAR_MIPMAP_NEAREST:o===t.TrilinearFilter?e.LINEAR_MIPMAP_LINEAR:void 0},t.prototype.isLoaded=function(){return this._loaded},t.prototype.setLoaded=function(e){this._loaded=e},t.prototype.getSource=function(){return this._source},t.prototype.setSource=function(e){this._source=e},t.prototype.getGLTextureForRenderer=function(e){return this._glTextures[e.id]},t.prototype.setGLTextureForRenderer=function(e,t){this._renderers[t.id]=t,this._glTextures[t.id]=e},t.prototype.getFrame=function(){return this._frame},t.prototype.setFrame=function(e){this._frame=e},t.prototype.getDimensions=function(){return new p.Vector2(this._frame.width,this._frame.height)},t.prototype.getPixelRatio=function(){return this._pixelRatio},t.prototype.setPixelRatio=function(e){this._pixelRatio=e},t.prototype.getGLUnit=function(){return this._glUnit},t.prototype.setGLUnit=function(e){this._glUnit=e},t.prototype.setMinFilter=function(e){this._minFilter=e},t.prototype.getMinFilter=function(){return this._minFilter},t.prototype.setMagFilter=function(e){this._magFilter=e},t.prototype.getMagFilter=function(){return this._magFilter},t.prototype.setRepeatX=function(e){this._repeatX=e},t.prototype.getRepeatX=function(){return this._repeatX},t.prototype.setRepeatY=function(e){this._repeatY=e},t.prototype.getRepeatY=function(){return this._repeatY},t.prototype.getGLRepeat=function(e,o){var r='x'===o?this.getRepeatX():this.getRepeatY();return r===t.ClampToEdge?e.CLAMP_TO_EDGE:r===t.Repeat?e.REPEAT:r===t.MirroredRepeat?e.MIRRORED_REPEAT:void 0},t.prototype.isDirty=function(){return this._dirty},t.prototype.setDirty=function(e){this._dirty=e},t.prototype.disposeGLTextures=function(){for(var e in this._renderers)this.disposeGLTexturesForRenderer(this._renderers[e])},t.prototype.disposeGLTexturesForRenderer=function(e){if(this._glTextures[e.id]){var t=e.getContext();t.deleteTexture(this._glTextures[e.id]),delete this._glTextures[e.id],this._renderers[e.id]||delete this._renderers[e.id]}},t.prototype.isMipMappingEnabled=function(){return this._mipMapping},t.prototype.setMipMappingEnabled=function(e){this._mipMapping=e},t.prototype.dispose=function(){0<arguments.length&&void 0!==arguments[0]?arguments[0]:null;this.disposeGLTextures()},t}(p.EventEmitter);u.NearestFilter=0,u.LinearFilter=1,u.BilinearFilter=2,u.TrilinearFilter=3,u.DefaultMagFilter=u.NearestFilter,u.DefaultMinFilter=u.LinearFilter,u.ClampToEdge=0,u.Repeat=1,u.MirroredRepeat=2,u.id=0,t.default=u},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(16),_=r(u),f=o(63),c=r(f),g=o(62),y=r(g),h=p.Constants.OptionType,m=p.Constants.UniformType,x=p.Constants.RendererType,T=function(e){function t(){return(0,i.default)(this,t),(0,l.default)(this,e.apply(this,arguments))}return(0,d.default)(t,e),t.prototype._initOptions=function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._shaders=[],this._availableUniforms=y.default.defaultUniforms,this._attributes=y.default.defaultAttributes,this._vertexSource=y.default.defaultVertexSource,this._fragmentSource=y.default.defaultFragmentSource,this._initUniforms(),e.prototype._initOptions.call(this,t)},t.prototype._initUniforms=function(){for(var e in this._uniforms={},this._availableUniforms){var t=this._availableUniforms[e];this._uniforms[e]={type:t.type,value:t.default||null}}for(var o in this.availableOptions){var r=this.availableOptions[o];r.uniformType?this._uniforms['u_'+o]={type:r.uniformType,value:r.default||null}:p.Log.trace(this.constructor.name,'Option `'+o+'` is missing a `uniformType`!')}},t.prototype.setOption=function(t,o){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;e.prototype.setOption.call(this,t,o,r);var a=o,i=this.availableOptions[t];if(i.uniformType){var n='u_'+t;switch(i.type){case h.COLOR:i.uniformType===m.FLOAT4?a=o.toGLColor():i.uniformType===m.FLOAT3&&(a=o.toRGBGLColor());break;case h.VECTOR2:a=[o.x,o.y];break;case h.COLOR_MATRIX:a=[o.a,o.b,o.c,o.d,o.f,o.g,o.h,o.i,o.k,o.l,o.m,o.n,o.p,o.q,o.r,o.s];var l=[o.e,o.j,o.o,o.t];this._uniforms[n+'_vec']={value:l,type:m.FLOAT4};}this.setUniform(n,a)}},t.prototype.setUniform=function(e,t){2<arguments.length&&void 0!==arguments[2]&&arguments[2];this._uniforms[e].value=t},t.prototype.setUniforms=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];for(var o in e)this._uniforms[o].value=e[o],t&&this.syncUniform(o)},t.prototype.syncUniform=function(e){this._shaders.forEach(function(t){t.syncUniform(e)})},t.prototype.syncUniforms=function(){this._shaders.forEach(function(e){e.syncUniforms()})},t.prototype.getShaderForRenderer=function(e){var t=e.getContext(),o=this._shaders[t.id];return o||(o=new c.default(e,this._vertexSource,this._fragmentSource,this._uniforms,this._attributes),this._shaders[t.id]=o),o},t.prototype.apply=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3];e.isOfType(x.WEBGL)?this._applyWebGL(e,t,o,r):e.isOfType(x.CANVAS)&&this._applyCanvas(e,t,o,r)},t.prototype._applyWebGL=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=e.getContext(),i=this.getShaderForRenderer(e);e.setRenderTarget(o),r&&o.clear(),e.setShader(i);var n=e.getCurrentRenderTarget().getProjectionMatrix().toArray();i.setUniform('u_projMatrix',n),i.syncUniforms(),a.activeTexture(a.TEXTURE0),a.bindTexture(a.TEXTURE_2D,t.getTexture()),a.drawElements(a.TRIANGLES,6,a.UNSIGNED_SHORT,0)},t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=o.getContext();p.Log.warn(this.constructor.name,'`_applyCanvas` is not implemented. Just copying image data from `inputTarget` to `outputTarget`.'),i.clearRect(0,0,a.width,a.height),i.drawImage(a,0,0)},t.prototype.dispose=function(){this._shaders.forEach(function(e){return e.dispose()}),this._shaders=[]},t}(_.default);t.default=T},function(e){'use strict';/*!
StackBlur - a fast almost Gaussian Blur For Canvas

Version:  0.5
Author:   Mario Klingemann
Contact:  mario@quasimondo.com
Website:  http://www.quasimondo.com/StackBlurForCanvas
Twitter:  @quasimondo

In case you find this class useful - especially in commercial projects -
I am not totally unhappy for a small donation to my PayPal account
mario@quasimondo.de

Or support me on flattr:
https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

Copyright (c) 2010 Mario Klingemann

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE.
@license
*/function t(){this.r=0,this.g=0,this.b=0,this.a=0,this.next=null}var o=[512,512,456,512,328,456,335,512,405,328,271,456,388,335,292,512,454,405,364,328,298,271,496,456,420,388,360,335,312,292,273,512,482,454,428,405,383,364,345,328,312,298,284,271,259,496,475,456,437,420,404,388,374,360,347,335,323,312,302,292,282,273,265,512,497,482,468,454,441,428,417,405,394,383,373,364,354,345,337,328,320,312,305,298,291,284,278,271,265,259,507,496,485,475,465,456,446,437,428,420,412,404,396,388,381,374,367,360,354,347,341,335,329,323,318,312,307,302,297,292,287,282,278,273,269,265,261,512,505,497,489,482,475,468,461,454,447,441,435,428,422,417,411,405,399,394,389,383,378,373,368,364,359,354,350,345,341,337,332,328,324,320,316,312,309,305,301,298,294,291,287,284,281,278,274,271,268,265,262,259,257,507,501,496,491,485,480,475,470,465,460,456,451,446,442,437,433,428,424,420,416,412,408,404,400,396,392,388,385,381,377,374,370,367,363,360,357,354,350,347,344,341,338,335,332,329,326,323,320,318,315,312,310,307,304,302,299,297,294,292,289,287,285,282,280,278,275,273,271,269,267,265,263,261,259],r=[9,11,12,13,13,14,14,15,15,15,15,16,16,16,16,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24];e.exports={stackBlurCanvasRGBA:function(e,a,n,l,s,d){if(!(isNaN(d)||1>d)){d|=0;var u=e.data,_=d+d+1,f=l-1,c=s-1,g=d+1,h=g*(g+1)/2,m=new t,T=m,v,x,y,i,p,b,C,R,O,E,S,F,M,k,P,D,B,I,w,L,A,N,U,G,z;for(y=1;y<_;y++)T=T.next=new t,y==g&&(z=T);T.next=m;var V=null,j=null;C=b=0;var W=o[d],H=r[d];for(x=0;x<s;x++){for(D=B=I=w=R=O=E=S=0,F=g*(L=u[b]),M=g*(A=u[b+1]),k=g*(N=u[b+2]),P=g*(U=u[b+3]),R+=h*L,O+=h*A,E+=h*N,S+=h*U,T=m,y=0;y<g;y++)T.r=L,T.g=A,T.b=N,T.a=U,T=T.next;for(y=1;y<g;y++)i=b+((f<y?f:y)<<2),R+=(T.r=L=u[i])*(G=g-y),O+=(T.g=A=u[i+1])*G,E+=(T.b=N=u[i+2])*G,S+=(T.a=U=u[i+3])*G,D+=L,B+=A,I+=N,w+=U,T=T.next;for(V=m,j=z,v=0;v<l;v++)u[b+3]=U=S*W>>H,0===U?u[b]=u[b+1]=u[b+2]=0:(U=255/U,u[b]=(R*W>>H)*U,u[b+1]=(O*W>>H)*U,u[b+2]=(E*W>>H)*U),R-=F,O-=M,E-=k,S-=P,F-=V.r,M-=V.g,k-=V.b,P-=V.a,i=C+((i=v+d+1)<f?i:f)<<2,D+=V.r=u[i],B+=V.g=u[i+1],I+=V.b=u[i+2],w+=V.a=u[i+3],R+=D,O+=B,E+=I,S+=w,V=V.next,F+=L=j.r,M+=A=j.g,k+=N=j.b,P+=U=j.a,D-=L,B-=A,I-=N,w-=U,j=j.next,b+=4;C+=l}for(v=0;v<l;v++){for(B=I=w=D=O=E=S=R=0,b=v<<2,F=g*(L=u[b]),M=g*(A=u[b+1]),k=g*(N=u[b+2]),P=g*(U=u[b+3]),R+=h*L,O+=h*A,E+=h*N,S+=h*U,T=m,y=0;y<g;y++)T.r=L,T.g=A,T.b=N,T.a=U,T=T.next;for(p=l,y=1;y<=d;y++)b=p+v<<2,R+=(T.r=L=u[b])*(G=g-y),O+=(T.g=A=u[b+1])*G,E+=(T.b=N=u[b+2])*G,S+=(T.a=U=u[b+3])*G,D+=L,B+=A,I+=N,w+=U,T=T.next,y<c&&(p+=l);for(b=v,V=m,j=z,x=0;x<s;x++)i=b<<2,u[i+3]=U=S*W>>H,0<U?(U=255/U,u[i]=(R*W>>H)*U,u[i+1]=(O*W>>H)*U,u[i+2]=(E*W>>H)*U):u[i]=u[i+1]=u[i+2]=0,R-=F,O-=M,E-=k,S-=P,F-=V.r,M-=V.g,k-=V.b,P-=V.a,i=v+((i=x+g)<c?i:c)*l<<2,R+=D+=V.r=u[i],O+=B+=V.g=u[i+1],E+=I+=V.b=u[i+2],S+=w+=V.a=u[i+3],V=V.next,F+=L=j.r,M+=A=j.g,k+=N=j.b,P+=U=j.a,D-=L,B-=A,I-=N,w-=U,j=j.next,b+=l}}}}},function(e){e.exports=function(e){try{return!!e()}catch(t){return!0}}},function(e){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,o){var r=o(72),a=o(53);e.exports=Object.keys||function(e){return r(e,a)}},function(e){var t=0,o=Math.random();e.exports=function(e){return'Symbol('.concat(e===void 0?'':e,')_',(++t+o).toString(36))}},function(e){var t=function(){return this}();try{t=t||Function('return this')()||(1,eval)('this')}catch(o){'object'==typeof window&&(t=window)}e.exports=t},function(e,t,o){'use strict';t.__esModule=!0;var r=o(77),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(){function e(e,t){for(var o=0,r;o<t.length;o++)r=t[o],r.enumerable=r.enumerable||!1,r.configurable=!0,'value'in r&&(r.writable=!0),(0,a.default)(e,r.key,r)}return function(t,o,r){return o&&e(t.prototype,o),r&&e(t,r),t}}()},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(6),l=o(32),s=r(l),d=function(){function e(t,o,r,a,n){(0,i.default)(this,e),this._width=t,this._height=o,this._pixelRatio=r,this._baseTexture=new s.default,this._canvas=a||this._createCanvas(),this._context=n||this._canvas.getContext('2d'),this._baseTexture.setSource(this._canvas),this._canvas.width=this._width*this._pixelRatio,this._canvas.height=this._height*this._pixelRatio,this._filterStack=[{renderTarget:this,filter:[]}]}return e.prototype._createCanvas=function(){return n.Utils.createCanvas()},e.prototype.clear=function(){var e=this._context;e.setTransform(1,0,0,1,0,0),e.clearRect(0,0,this._width*this._pixelRatio,this._height*this._pixelRatio)},e.prototype.resizeTo=function(e){this._baseTexture.resizeTo(e),this._width!==e.x&&(this._width=e.x,this._canvas.width=this._width*this._pixelRatio),this._height!==e.y&&(this._height=e.y,this._canvas.height=this._height*this._pixelRatio)},e.prototype.getCanvas=function(){return this._canvas},e.prototype.getContext=function(){return this._context},e.prototype.getFilterStack=function(){return this._filterStack},e.prototype.getWidth=function(){return this._width},e.prototype.getHeight=function(){return this._height},e.prototype.getPixelRatio=function(){return this._pixelRatio},e.prototype.setPixelRatio=function(e){this._pixelRatio=e},e.prototype.getDimensions=function(){return new n.Vector2(this._width,this._height)},e.prototype.getBaseTexture=function(){return this._baseTexture},e.prototype.dispose=function(){this._canvas=null,this._context=null},e}();t.default=d},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(6),l=o(32),s=r(l),d=function(){function e(t,o,r,a){var l=4<arguments.length&&void 0!==arguments[4]&&arguments[4];(0,i.default)(this,e),this._renderer=t,this._gl=t.getContext(),this._width=o,this._height=r,this._frame=null,this._pixelRatio=a,this._projectionMatrix=new n.Matrix,this._mipMapping=!1,this._baseTexture=new s.default;var d=this._baseTexture.getFrame();d.width=o,d.height=r,this._baseTexture.setPixelRatio(a),this._baseTexture.setLoaded(!0),this._framebuffer=null,this._isRoot=l,this._filterStack=[{renderTarget:this,filter:[]}],l||this._initFrameBuffer()}return e.prototype.resizeTo=function(e){this._width=0|e.x,this._height=0|e.y,this._baseTexture.resizeTo(e),this._isRoot||this._resizeTexture(),this._baseTexture.setMinFilter(this._getMinFilter()),this._baseTexture.setMagFilter(this._getMagFilter()),this._calculateProjectionMatrix()},e.prototype._getMinFilter=function(){var e=s.default.DefaultMinFilter;return this._mipMapping&&(e=s.default.TrilinearFilter),e},e.prototype._getMagFilter=function(){return s.default.DefaultMagFilter},e.prototype._resizeTexture=function(){var e=this._gl;e.bindTexture(e.TEXTURE_2D,this._texture);var t=this._width*this._pixelRatio,o=this._height*this._pixelRatio;e.texImage2D(e.TEXTURE_2D,0,e.RGBA,t,o,0,e.RGBA,e.UNSIGNED_BYTE,null);var r=new n.Vector2(this._width,this._height);n.Utils.isPowerOfTwo(r)?(n.Log.info('WebGLRenderTarget','Mip-mapping enabled'),this._mipMapping=!0):this._mipMapping=!1,this._baseTexture.setMipMappingEnabled(this._mipMapping)},e.prototype.activate=function(){var e=this._gl;e.bindFramebuffer(e.FRAMEBUFFER,this._framebuffer),this._calculateProjectionMatrix(),e.viewport(0,0,this._width*this._pixelRatio,this._height*this._pixelRatio),e.disable(e.STENCIL_TEST)},e.prototype.clear=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:n.Color.TRANSPARENT,t=this._gl;t.bindFramebuffer(t.FRAMEBUFFER,this._framebuffer),n.GLUtils.checkFramebufferStatus('WebGLRenderTarget#clear',t),t.clearColor.apply(t,e.toGLColor()),t.clear(t.COLOR_BUFFER_BIT)},e.prototype._calculateProjectionMatrix=function(){var e=this._projectionMatrix;e.reset();var t=this._frame||new n.Rectangle(0,0,this._width,this._height),o=t.x,r=t.y;this._isRoot?(e.a=2*(1/this._width),e.d=2*(-1/this._height),e.tx=-1-o*e.a,e.ty=1-r*e.d):(e.a=2*(1/this._width),e.d=2*(1/this._height),e.tx=-1-o*e.a,e.ty=-1-r*e.d)},e.prototype._initFrameBuffer=function(){var e=this._gl;this._framebuffer=e.createFramebuffer(),this._texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this._texture),e.bindFramebuffer(e.FRAMEBUFFER,this._framebuffer),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,this._texture,0),this._baseTexture.setGLTextureForRenderer(this._texture,this._renderer),this.resizeTo(new n.Vector2(this._width,this._height)),n.GLUtils.checkFramebufferStatus('WebGLRenderTarget#_initFramebuffer',e)},e.prototype.getProjectionMatrix=function(){return this._projectionMatrix},e.prototype.getTexture=function(){return this._texture},e.prototype.getFrame=function(){return this._frame},e.prototype.setFrame=function(e){this._frame=e},e.prototype.getFilterStack=function(){return this._filterStack},e.prototype.getPixelRatio=function(){return this._pixelRatio},e.prototype.setPixelRatio=function(e){this._pixelRatio=e,this._isRoot||this._resizeTexture()},e.prototype.getBaseTexture=function(){return this._baseTexture},e.prototype.dispose=function(){var e=this._gl;this._baseTexture.disposeGLTexturesForRenderer(this._renderer),e.deleteTexture(this._texture),e.deleteFramebuffer(this._framebuffer)},e}();t.default=d},function(e,a,i){'use strict';function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(a,'__esModule',{value:!0});var l=i(0),s=n(l),d=i(1),p=n(d),u=i(2),_=n(u),f=i(3),c=f.Constants.RendererType,g=function(e){function a(t,o){(0,s.default)(this,a);var r=(0,p.default)(this,e.call(this,o));return r._operation=t,r._dirtiness={},r.id=f.Utils.getUUID(),r._renderTextures={},r._identitySprite=new f.Engine.Sprite,r._sprite=new f.Engine.Sprite,r._dummyImage={addEventListener:function(){},removeEventListener:function(){}},r._hitTestSprite=new f.Engine.Sprite,r._renderers=[],r}return(0,_.default)(a,e),a.prototype.applyScale=function(){},a.prototype.applyRotation=function(e){var a=this._operation.getInputDimensions(),i=180*this.getRotation()/r;i+=e,this.setRotation(i*r/180);var n=(e+360)%360*r/180,l=o(n),s=t(n),d=this._options.position.clone().subtract(0.5).multiply(a),p=new f.Vector2(d.x*l-d.y*s,d.x*s+d.y*l).divide(a.clone().flip());this.setPosition(new f.Vector2(0.5,0.5).add(p))},a.prototype.applyFlip=function(e){var t=this.getPosition().clone();'horizontal'===e?t.x=1-this._options.position.x:'vertical'===e?t.y=1-this._options.position.y:void 0,this.setPosition(t)},a.prototype.applyTransform=function(e){var t={};t.rotation=e.applyToRotation(this.getRotation()),t.position=e.applyToRelativePoint(this.getPosition()),this._options.dimensions&&(t.dimensions=e.applyToDimensions(this.getDimensions())),this.set(t,!1)},a.prototype.getDisplayObject=function(){return this._sprite},a.prototype.getHitTestDisplayObject=function(){return this._sprite},a.prototype._getTexture=function(){throw new Error('Sprite#_getTexture is abstract and not implemented in child class.')},a.prototype._prepareRenderTexture=function(e){if(!this._renderTexture){var t=this._getTexture();this._renderTextureContainer=new f.Engine.Container,this._renderTextureSprite=new f.Engine.Sprite(t),this._renderTextureContainer.addChild(this._renderTextureSprite),this._renderTexture=this._getRenderTexture(e.getRenderer(),t.getDimensions())}else this._renderTexture.clear()},a.prototype._rendersToRenderTexture=function(e){return e.getOptions().smoothDownscaling&&e.getRenderer().isOfType(c.WEBGL)},a.prototype._optionEquals=function(t,o){return'type'===t||e.prototype._optionEquals.call(this,t,o)},a.prototype.update=function(e,t){this._rendersToRenderTexture(e)&&(this._prepareRenderTexture(e),this._renderToRenderTexture(e)),this._updateSprite(t)},a.prototype._updateSprite=function(e){var t=this,o=[this._sprite,this._hitTestSprite];o.forEach(function(o){if(o.getTexture()){o.setAnchor(t._options.anchor),o.setPosition(t._options.position.clone().multiply(e)),'undefined'!=typeof t._options.alpha&&o.setAlpha(t._options.alpha);var r=t._options.dimensions;r&&(r=r.clone().multiply(t._operation.getSDK().getTextureScale()),o.setWidth(r.x),o.setHeight(r.y)),o.updateTransform();var a=o.getTexture().getFrame(),i=new f.Vector2(a.width,a.height);o.setPivot(t._options.pivot.clone().multiply(i)),o.setRotation(t._options.rotation),o.updateTransform()}})},a.prototype._renderToRenderTexture=function(e){var t=this._getTexture().getDimensions(),o=this._getRenderTexture(e.getRenderer(),t),r=t.clone();if(this._options.smoothDownscaling&&(r.x=f.Utils.nextHighestPOT(r.x),r.y=f.Utils.nextHighestPOT(r.y)),this._renderTexture.resizeTo(r),this._renderTexture.render(this._renderTextureContainer),this._options.smoothDownscaling){var a=r.clone().subtract(t.x,t.y).divide(r),i=o.getUVs().getUVs();i[0].x=i[3].x=0,i[1].x=i[2].x=1-a.x,i[0].y=i[1].y=0,i[2].y=i[3].y=1-a.y}this._sprite.setTexture(o)},a.prototype.isDirtyForRenderer=function(e){return e.id in this._dirtiness||(this._dirtiness[e.id]=!0),this._dirtiness[e.id]},a.prototype.setDirtyForRenderer=function(e,t){this._renderers[t.id]=t,this._dirtiness[t.id]=e},a.prototype.setDirty=function(e){for(var t in this._dirtiness)this.setDirtyForRenderer(e,this._renderers[t])},a.prototype._getRenderTexture=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:new f.Vector2(100,100);return this._renderTextures[e.id]||(this._renderTextures[e.id]=new f.Engine.RenderTexture(e,t.x,t.y,1)),this._renderTextures[e.id]},a.prototype.dispose=function(){for(var e in this._renderTextures)this._renderTextures[e].dispose()},a}(f.Configurable);a.default=g},function(e,t,o){'use strict';var r=o(105)(!0);o(67)(String,'String',function(e){this._t=e+'',this._i=0},function(){var e=this._t,t=this._i,o;return t>=e.length?{value:void 0,done:!0}:(o=r(e,t),this._i+=o.length,{value:o,done:!1})})},function(e){e.exports=function(e){return isNaN(e=+e)?0:(0<e?d:l)(e)}},function(e){e.exports=function(e){if(e==void 0)throw TypeError('Can\'t call method on  '+e);return e}},function(e){e.exports=!0},function(e,t,o){var r=o(28);e.exports=function(e,t){if(!r(e))return e;var o,a;if(t&&'function'==typeof(o=e.toString)&&!r(a=o.call(e)))return a;if('function'==typeof(o=e.valueOf)&&!r(a=o.call(e)))return a;if(!t&&'function'==typeof(o=e.toString)&&!r(a=o.call(e)))return a;throw TypeError('Can\'t convert object to primitive value')}},function(e,t,o){var r=o(25),a=o(108),n=o(53),i=o(51)('IE_PROTO'),l=function(){},s='prototype',d=function(){var e=o(70)('iframe'),t=n.length,r='<',a='>',i;for(e.style.display='none',o(113).appendChild(e),e.src='javascript:',i=e.contentWindow.document,i.open(),i.write(r+'script'+a+'document.F=Object'+r+'/script'+a),i.close(),d=i.F;t--;)delete d[s][n[t]];return d()};e.exports=Object.create||function(e,t){var o;return null===e?o=d():(l[s]=r(e),o=new l,l[s]=null,o[i]=e),void 0===t?o:a(o,t)}},function(e){var t={}.toString;e.exports=function(e){return t.call(e).slice(8,-1)}},function(e,t,o){var r=o(52)('keys'),a=o(38);e.exports=function(e){return r[e]||(r[e]=a(e))}},function(e,t,o){var r=o(15),a='__core-js_shared__',i=r[a]||(r[a]={});e.exports=function(e){return i[e]||(i[e]={})}},function(e){e.exports=['constructor','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','toLocaleString','toString','valueOf']},function(e,t,o){var r=o(17).f,a=o(19),i=o(14)('toStringTag');e.exports=function(e,t,o){e&&!a(e=o?e:e.prototype,i)&&r(e,i,{configurable:!0,value:t})}},function(e,t,o){o(116);for(var r=o(15),a=o(24),n=o(29),l=o(14)('toStringTag'),s=['NodeList','DOMTokenList','MediaList','StyleSheetList','CSSRuleList'],d=0;5>d;d++){var i=s[d],p=r[i],u=p&&p.prototype;u&&!u[l]&&a(u,l,i),n[i]=n.Array}},function(e,t,o){t.f=o(14)},function(e,t,o){var r=o(15),a=o(13),i=o(47),n=o(56),l=o(17).f;e.exports=function(e){var t=a.Symbol||(a.Symbol=i?{}:r.Symbol||{});'_'==e.charAt(0)||e in t||l(t,e,{value:n.f(e)})}},function(e,t){t.f={}.propertyIsEnumerable},function(t,o,r){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(o,'__esModule',{value:!0});var i=r(0),u=a(i),n=r(40),l=a(n),s=r(12),d=a(s),p=function(){function _(){var y=0<arguments.length&&void 0!==arguments[0]?arguments[0]:1,a=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0,x=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,c=3<arguments.length&&void 0!==arguments[3]?arguments[3]:0,d=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,e=5<arguments.length&&void 0!==arguments[5]?arguments[5]:0,f=6<arguments.length&&void 0!==arguments[6]?arguments[6]:1,g=7<arguments.length&&void 0!==arguments[7]?arguments[7]:0,h=8<arguments.length&&void 0!==arguments[8]?arguments[8]:0,i=9<arguments.length&&void 0!==arguments[9]?arguments[9]:0,T=10<arguments.length&&void 0!==arguments[10]?arguments[10]:0,v=11<arguments.length&&void 0!==arguments[11]?arguments[11]:0,l=12<arguments.length&&void 0!==arguments[12]?arguments[12]:1,m=13<arguments.length&&void 0!==arguments[13]?arguments[13]:0,n=14<arguments.length&&void 0!==arguments[14]?arguments[14]:0,o=15<arguments.length&&void 0!==arguments[15]?arguments[15]:0,p=16<arguments.length&&void 0!==arguments[16]?arguments[16]:0,b=17<arguments.length&&void 0!==arguments[17]?arguments[17]:0,r=18<arguments.length&&void 0!==arguments[18]?arguments[18]:1,s=19<arguments.length&&void 0!==arguments[19]?arguments[19]:0;(0,u.default)(this,_),this.set(y,a,x,c,d,e,f,g,h,i,T,v,l,m,n,o,p,b,r,s)}return _.prototype.set=function(u,a,_,c,d,e,f,g,y,i,h,x,l,m,n,o,p,T,r,s){this.a=u,this.b=a,this.c=_,this.d=c,this.e=d,this.f=e,this.g=f,this.h=g,this.i=y,this.j=i,this.k=h,this.l=x,this.m=l,this.n=m,this.o=n,this.p=o,this.q=p,this.r=T,this.s=r,this.t=s},_.prototype.reset=function(){this.a=1,this.b=0,this.c=0,this.d=0,this.e=0,this.f=0,this.g=1,this.h=0,this.i=0,this.j=0,this.k=0,this.l=0,this.m=1,this.n=0,this.o=0,this.p=0,this.q=0,this.r=0,this.s=1,this.t=0},_.prototype.apply=function(e){var t=this.a*e.r+this.b*e.g+this.c*e.b+this.d*e.a+this.e,o=this.f*e.r+this.g*e.g+this.h*e.b+this.i*e.a+this.j,r=this.k*e.r+this.l*e.g+this.m*e.b+this.n*e.a+this.o,i=this.p*e.r+this.q*e.g+this.r*e.b+this.s*e.a+this.t;return new d.default(t,o,r,i)},_.prototype.multiply=function(u){var _=u,y=this,x,a,T,c,d,e,f,g,h,i,v,b,l,m,n,o,p,C,r,s;return x=_.a*y.a+_.b*y.f+_.c*y.k+_.d*y.p,a=_.a*y.b+_.b*y.g+_.c*y.l+_.d*y.q,T=_.a*y.c+_.b*y.h+_.c*y.m+_.d*y.r,c=_.a*y.d+_.b*y.i+_.c*y.n+_.d*y.s,e=_.f*y.a+_.g*y.f+_.h*y.k+_.i*y.p,f=_.f*y.b+_.g*y.g+_.h*y.l+_.i*y.q,g=_.f*y.c+_.g*y.h+_.h*y.m+_.i*y.r,h=_.f*y.d+_.g*y.i+_.h*y.n+_.i*y.s,v=_.k*y.a+_.l*y.f+_.m*y.k+_.n*y.p,b=_.k*y.b+_.l*y.g+_.m*y.l+_.n*y.q,l=_.k*y.c+_.l*y.h+_.m*y.m+_.n*y.r,m=_.k*y.d+_.l*y.i+_.m*y.n+_.n*y.s,o=_.p*y.a+_.q*y.f+_.r*y.k+_.s*y.p,p=_.p*y.b+_.q*y.g+_.r*y.l+_.s*y.q,C=_.p*y.c+_.q*y.h+_.r*y.m+_.s*y.r,r=_.p*y.d+_.q*y.i+_.r*y.n+_.s*y.s,d=_.a*y.e+_.b*y.j+_.c*y.o+_.d*y.t+_.e,i=_.f*y.e+_.g*y.j+_.h*y.o+_.i*y.t+_.j,n=_.k*y.e+_.l*y.j+_.m*y.o+_.n*y.t+_.o,s=_.p*y.e+_.q*y.j+_.r*y.o+_.s*y.t+_.t,this.a=x,this.b=a,this.c=T,this.d=c,this.e=d,this.f=e,this.g=f,this.h=g,this.i=h,this.j=i,this.k=v,this.l=b,this.m=l,this.n=m,this.o=n,this.p=o,this.q=p,this.r=C,this.s=r,this.t=s,this},_.prototype.clone=function(){var e=new _;return e.set(this.a,this.b,this.c,this.d,this.e,this.f,this.g,this.h,this.i,this.j,this.k,this.l,this.m,this.n,this.o,this.p,this.q,this.r,this.s,this.t),e},_.prototype.equals=function(e){return this.a===e.a&&this.b===e.b&&this.c===e.c&&this.d===e.d&&this.e===e.e&&this.f===e.f&&this.g===e.g&&this.h===e.h&&this.i===e.i&&this.j===e.j&&this.k===e.k&&this.l===e.l&&this.m===e.m&&this.n===e.n&&this.o===e.o&&this.p===e.p&&this.q===e.q&&this.r===e.r&&this.s===e.s&&this.t===e.t},_.prototype.getOffsets=function(){return[this.e,this.j,this.o,this.t]},_.prototype.toString=function(){return'ColorMatrix( '+this.a+', '+this.b+', '+this.c+', '+this.d+', '+this.e+',\n      '+this.f+', '+this.g+', '+this.h+', '+this.i+', '+this.j+',\n      '+this.k+', '+this.l+', '+this.m+', '+this.n+', '+this.o+',\n      '+this.p+', '+this.q+', '+this.r+', '+this.s+', '+this.t+' )'},_.prototype.toArray=function(){var e=this;return['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t'].map(function(t){return e[t]})},_.createBrightnessMatrix=function(e){var t=new _;return t.e=e,t.j=e,t.o=e,t},_.createContrastMatrix=function(e){var t=new _;return t.a=t.g=t.m=e,t.e=t.j=t.o=(1-e)/2,t},_.createSaturationMatrix=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:1,t=new _,o=1-e,a=0.213*o,r=0.715*o,i=0.072*o;return t.a=a+e,t.b=r,t.c=i,t.f=a,t.g=r+e,t.h=i,t.k=a,t.l=r,t.m=i+e,t},_.createExposureMatrix=function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0,o=e(2,t);return new _(o,0,0,0,0,0,o,0,0,0,0,0,o,0,0,0,0,0,1,0)},_.createLinearMatrix=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:1,t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0,o=new _;return o.a=o.g=o.m=e,o.e=o.j=o.o=t,o},(0,l.default)(_,null,[{key:'IDENTITY',get:function(){return new _}}]),_}();o.default=p},function(e){function t(){throw new Error('setTimeout has not been defined')}function o(){throw new Error('clearTimeout has not been defined')}function r(e){if(p===setTimeout)return setTimeout(e,0);if((p===t||!p)&&setTimeout)return p=setTimeout,setTimeout(e,0);try{return p(e,0)}catch(t){try{return p.call(null,e,0)}catch(t){return p.call(this,e,0)}}}function a(e){if(u===clearTimeout)return clearTimeout(e);if((u===o||!u)&&clearTimeout)return u=clearTimeout,clearTimeout(e);try{return u(e)}catch(t){try{return u.call(null,e)}catch(t){return u.call(this,e)}}}function i(){f&&g&&(f=!1,g.length?_=g.concat(_):c=-1,_.length&&n())}function n(){if(!f){var e=r(i);f=!0;for(var t=_.length;t;){for(g=_,_=[];++c<t;)g&&g[c].run();c=-1,t=_.length}g=null,f=!1,a(e)}}function l(e,t){this.fun=e,this.array=t}function s(){}var d=e.exports={},p,u;(function(){try{p='function'==typeof setTimeout?setTimeout:t}catch(o){p=t}try{u='function'==typeof clearTimeout?clearTimeout:o}catch(t){u=o}})();var _=[],f=!1,c=-1,g;d.nextTick=function(e){var t=Array(arguments.length-1);if(1<arguments.length)for(var o=1;o<arguments.length;o++)t[o-1]=arguments[o];_.push(new l(e,t)),1!==_.length||f||r(n)},l.prototype.run=function(){this.fun.apply(null,this.array)},d.title='browser',d.browser=!0,d.env={},d.argv=[],d.version='',d.versions={},d.on=s,d.addListener=s,d.once=s,d.off=s,d.removeListener=s,d.removeAllListeners=s,d.emit=s,d.prependListener=s,d.prependOnceListener=s,d.listeners=function(){return[]},d.binding=function(){throw new Error('process.binding is not supported')},d.cwd=function(){return'/'},d.chdir=function(){throw new Error('process.chdir is not supported')},d.umask=function(){return 0}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(6),l=o(41),s=r(l),d=function(){function e(t){(0,i.default)(this,e),this._renderer=t,this._filterStack=[{renderTarget:t.getCurrentRenderTarget(),filters:[]}],this._currentFrame=null,this._textures=[],this._textureFrame=new n.Rectangle(0,0,t.getWidth(),t.getHeight())}return e.prototype.resizeTo=function(e){this._textureFrame.width=e.x,this._textureFrame.height=e.y,this._textures.forEach(function(t){return t.resizeTo(e)})},e.prototype.pushFilters=function(e,t){var o=e.getBounds();this._currentFrame=o;var r=this._getOrCreateRenderTarget();this._renderer.setRenderTarget(r),this._filterStack.push({renderTarget:r,filters:t}),r.clear()},e.prototype.popFilters=function(){var e=this._filterStack.pop(),t=e.filters,o=e.renderTarget,r=this._filterStack[this._filterStack.length-1],a=o,i=r.renderTarget;return 1===t.length?(t[0].apply(this._renderer,a,i),this._textures.push(a)):this._applyFilters(t,a,i),t},e.prototype._applyFilters=function(e,t,o){var r=this,a=t,i=this._getOrCreateRenderTarget(!0),n=e[e.length-1];e.forEach(function(e){if(!(e===n)){e.apply(r._renderer,a,i);var t=a;a=i,i=t}else e.apply(r._renderer,a,o)}),this._textures.push(a),this._textures.push(i)},e.prototype._getOrCreateRenderTarget=function(e){var t=this._textures.pop();return t||(t=new s.default(this._textureFrame.width,this._textureFrame.height,1)),e&&t.clear(),t},e.prototype.setFilterStack=function(e){this._filterStack=e},e.prototype.dispose=function(){},e}();t.default=d},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(63),_=r(u),f=p.Constants.UniformType,c=function(e){function t(o,r,a){return(0,i.default)(this,t),r=r||t.defaultVertexSource,a=a||t.defaultFragmentSource,(0,l.default)(this,e.call(this,o,r,a,t.defaultUniforms,t.defaultAttributes))}return(0,d.default)(t,e),t}(_.default);c.defaultVertexSource=o(152),c.defaultFragmentSource=o(153);var g=new p.Matrix;c.defaultUniforms={u_image:{type:f.SAMPLER2D,value:0},u_projMatrix:{type:f.MAT3,value:g.toArray()}},c.defaultAttributes=['a_position','a_texCoord','a_color'],t.default=c},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o(6),n=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(i),l=o(10),s=n.Log,d=n.Utils,p=function(){function e(t,o,r,i,n){(0,a.default)(this,e),this._renderer=t,this._vertexSource=o,this._fragmentSource=r,this._uniforms=i||{},this._uniformLocations={},this._attributes=n||[],this._attributeLocations={},this._onContextChange=this._onContextChange.bind(this),this._renderer.on('context',this._onContextChange),this._init()}return e.prototype._init=function(){this._compile();var e=this._renderer.getContext();e.useProgram(this._program),this._cacheUniformLocations(),this._cacheAttributeLocations()},e.prototype._onContextChange=function(){this._init()},e.prototype.setupBuffers=function(e,t){var o=this._renderer.getContext();o.bindBuffer(o.ARRAY_BUFFER,e),o.bindBuffer(o.ELEMENT_ARRAY_BUFFER,t),o.vertexAttribPointer(this._attributeLocations.a_position,2,o.FLOAT,!1,n.VERTEX_BYTE_SIZE,0),o.vertexAttribPointer(this._attributeLocations.a_texCoord,2,o.FLOAT,!1,n.VERTEX_BYTE_SIZE,8),o.vertexAttribPointer(this._attributeLocations.a_color,4,o.UNSIGNED_BYTE,!0,n.VERTEX_BYTE_SIZE,16)},e.prototype.syncUniforms=function(){var e=this;Object.keys(this._uniforms).forEach(function(t){e.syncUniform(t)})},e.prototype.syncUniform=function(e){var t=this._renderer.getContext(),o=this._uniforms[e],r=this._uniformLocations[e];switch(o.type){case l.UniformType.SAMPLER2D:t.uniform1i(r,o.value);break;case l.UniformType.INT:case l.UniformType.INT1:t.uniform1i(r,o.value);break;case l.UniformType.FLOAT:case l.UniformType.FLOAT1:t.uniform1f(r,o.value);break;case l.UniformType.FLOAT2:t.uniform2f(r,o.value[0],o.value[1]);break;case l.UniformType.FLOAT3:t.uniform3f(r,o.value[0],o.value[1],o.value[2]);break;case l.UniformType.FLOAT4:t.uniform4f(r,o.value[0],o.value[1],o.value[2],o.value[3]);break;case l.UniformType.FLOAT_VECTOR2:t.uniform2fv(r,o.value);break;case l.UniformType.MAT3:case l.UniformType.MAT3FV:t.uniformMatrix3fv(r,!1,o.value);break;case l.UniformType.MAT4:t.uniformMatrix4fv(r,!1,o.value);break;default:s.warn(this.constructor.name,'Unknown uniform type: '+o.type);}},e.prototype._cacheAttributeLocations=function(){var e=this,t=this._renderer.getContext();this._attributes.forEach(function(o){e._attributeLocations[o]=t.getAttribLocation(e._program,o)})},e.prototype._cacheUniformLocations=function(){var e=this,t=this._renderer.getContext(),o=Object.keys(this._uniforms);o.forEach(function(o){e._uniformLocations[o]=t.getUniformLocation(e._program,o)})},e.prototype._addPrecisionToSource=function(e){var t=this._renderer.getMaxFloatPrecision(),o='mediump';return d.isMobile()&&'highp'===t&&(o='highp'),'precision '+o+' float;\n'+e},e.prototype._compile=function(){var e=this._renderer.getContext(),t=this._compileShader(e.VERTEX_SHADER,this._vertexSource);this._vertexShader=t;var o=this._addPrecisionToSource(this._fragmentSource),r=this._compileShader(e.FRAGMENT_SHADER,o);this._fragmentShader=r;var a=e.createProgram();e.attachShader(a,t),e.attachShader(a,r),e.linkProgram(a);var i=e.getProgramParameter(a,e.LINK_STATUS);if(!i){var n=e.getProgramInfoLog(a);e.isContextLost()&&(n='WebGL context lost'),e.deleteProgram(a),s.error(this.constructor.name,'WebGL program linking error: '+n)}this._program=a},e.prototype._compileShader=function(e,t){var o=this._renderer.getContext(),r=o.createShader(e);o.shaderSource(r,t),o.compileShader(r);var a=o.getShaderParameter(r,o.COMPILE_STATUS);if(!a){var i=o.getShaderInfoLog(r);o.isContextLost()&&(i='WebGL context lost'),o.deleteShader(r),s.error(this.constructor.name,'WebGL shader compilation error: '+i)}return r},e.prototype.setUniform=function(e,t){var o=2<arguments.length&&void 0!==arguments[2]&&arguments[2];this._uniforms[e].value=t,o&&this.syncUniform(e)},e.prototype.setUniforms=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];for(var o in e)this._uniforms[o].value=e[o],t&&this.syncUniform(o)},e.prototype.getUniforms=function(){return this._uniforms},e.prototype.getAttributes=function(){return this._attributes},e.prototype.getAttributeLocations=function(){return this._attributeLocations},e.prototype.getProgram=function(){return this._program},e.prototype.dispose=function(){var e=this._renderer.getContext();e.deleteProgram(this._program),e.deleteShader(this._vertexShader),e.deleteShader(this._fragmentShader),this._uniforms=null,this._uniformLocations=null,this._attributes=null,this._attributeLocations=null,this._renderer.off('context',this._onContextChange)},e}();t.default=p},function(e,r,a){'use strict';Object.defineProperty(r,'__esModule',{value:!0});var i=a(0),n=function(e){return e&&e.__esModule?e:{default:e}}(i),l=a(6),s=function(){function e(){(0,n.default)(this,e),this._position=new l.Vector2(0,0),this._scale=new l.Vector2(1,1),this._pivot=new l.Vector2(0,0),this._rotation=0,this._lastRotation=null,this._alpha=1,this._visible=!0,this._worldTransform=new l.Matrix,this._parent=null,this._shaders=[],this._boundsNeedUpdate=!0,this._bounds=new l.Rectangle(0,0,1,1),this._localBoundsNeedUpdate=!0,this._localBounds=new l.Rectangle(0,0,1,1),this._tint=16777215,this._filterRectangle=new l.Rectangle(0,0,0,0)}return e.prototype.renderWebGL=function(){l.Log.warn(this.constructor.name,'`renderWebGL` is abstract and not implemented in inherited class')},e.prototype.renderCanvas=function(){l.Log.warn(this.constructor.name,'`renderCanvas` is abstract and not implemented in inherited class')},e.prototype.updateTransform=function(){var e=this._parent?this._parent.getWorldTransform():l.Matrix.IDENTITY,r=this._worldTransform,a=this._rotation!==this._lastRotation;a&&(this._sinRotation=t(this._rotation),this._cosRotation=o(this._rotation),this._lastRotation=this._rotation),r.a=this._cosRotation*this._scale.x,r.b=this._sinRotation*this._scale.x,r.c=-this._sinRotation*this._scale.y,r.d=this._cosRotation*this._scale.y,r.tx=this._position.x,r.ty=this._position.y,(this._pivot.x||this._pivot.y)&&(r.tx-=this._pivot.x*r.a+this._pivot.y*r.c,r.ty-=this._pivot.x*r.b+this._pivot.y*r.d),r.tx|=0,r.ty|=0,r.multiply(e),this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},e.prototype.addShader=function(e){this._shaders.push(e)},e.prototype.removeShader=function(e){var t=this._shaders.indexOf(e);return-1!==t&&(this._shaders.splice(t,1),!0)},e.prototype.removeShaderAt=function(e){return!!this._shaders[e]&&(this._shaders.splice(e,1),!0)},e.prototype.getBounds=function(){return this._bounds.clone()},e.prototype.getPosition=function(){return this._position},e.prototype.setPosition=function(e,t){e instanceof l.Vector2?this._position.copy(e):this._position.set(e,t),this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},e.prototype.getScale=function(){return this._scale},e.prototype.setScale=function(e,t){e instanceof l.Vector2?this._scale.copy(e):this._scale.set(e,t),this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},e.prototype.getPivot=function(){return this._pivot},e.prototype.setPivot=function(e,t){e instanceof l.Vector2?this._pivot.copy(e):this._pivot.set(e,t),this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},e.prototype.getRotation=function(){return this._rotation},e.prototype.setRotation=function(e){this._rotation=e,this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},e.prototype.getAlpha=function(){return this._alpha},e.prototype.setAlpha=function(e){this._alpha=e},e.prototype.getWorldAlpha=function(){return this._parent?this._parent.getAlpha()*this._alpha:this._alpha},e.prototype.getWorldTransform=function(){return this._worldTransform},e.prototype.getParent=function(){return this._parent},e.prototype.setParent=function(e){this._parent=e},e.prototype.getFilterRectangle=function(){return this._filterRectangle},e.prototype.setFilterRectangle=function(e){this._filterRectangle.copy(e)},e.prototype.getTint=function(){return this._tint},e.prototype.setTint=function(e){this._tint=e},e.prototype.isVisible=function(){return this._visible},e.prototype.setVisible=function(e){this._visible=e},e}();r.default=s},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(6),l=o(42),s=r(l),d=o(154),p=r(d),u=n.Constants.RendererType,_=function(){function e(t){(0,i.default)(this,e),this._renderer=t,this._filterStack=[{filters:[]}],this._currentFrame=null,this._renderTargets=[],this._textureFrame=new n.Rectangle(0,0,t.getWidth(),t.getHeight()),this._onContextChange=this._onContextChange.bind(this),this._renderer.on('context',this._onContextChange),this._onContextChange()}return e.prototype.resizeTo=function(e){this._textureFrame.width=e.x,this._textureFrame.height=e.y,this._renderTargets.forEach(function(t){return t.resizeTo(e)})},e.prototype.getFilterStack=function(){return this._filterStack},e.prototype.setFilterStack=function(e){this._filterStack=e},e.prototype._getOrCreateRenderTarget=function(e){var t=this._renderTargets.pop();return t||(t=new s.default(this._renderer,this._textureFrame.width,this._textureFrame.height,1)),t.setFrame(this._currentFrame),e&&t.clear(),t},e.prototype.pushFilters=function(e,t){var o=e.getBounds();this._currentFrame=o;var r=e.getFilterRectangle();0<r.width&&0<r.height&&(this._currentFrame=r);var a=this._getOrCreateRenderTarget();this._renderer.setRenderTarget(a),a.clear(),this._filterStack.push({renderTarget:a,filters:t})},e.prototype.popFilters=function(){var e=this._filterStack.pop(),t=e.filters,o=e.renderTarget,r=this._filterStack[this._filterStack.length-1],a=o,i=r.renderTarget;this._quad.map(this._textureFrame,a.getFrame());var n=t[0].getShaderForRenderer(this._renderer),l=this._quad.getVertexBuffer(),s=this._quad.getIndexBuffer(),d=this._renderer.getContext();d.bindBuffer(d.ARRAY_BUFFER,l),d.bindBuffer(d.ELEMENT_ARRAY_BUFFER,s);var p=n.getAttributeLocations();return d.vertexAttribPointer(p.a_position,2,d.FLOAT,!1,0,0),d.vertexAttribPointer(p.a_texCoord,2,d.FLOAT,!1,0,32),d.vertexAttribPointer(p.a_color,4,d.FLOAT,!1,0,64),this._renderer.updateTexture(a.getBaseTexture(),!1),1===t.length?(t[0].apply(this._renderer,a,i),this._renderTargets.push(a)):this._applyFilters(t,a,i),t},e.prototype._applyFilters=function(e,t,o){var r=this,a=t,i=this._getOrCreateRenderTarget(!0);this._renderer.updateTexture(i.getBaseTexture(),!1);var n=e[e.length-1];e.forEach(function(e){if(!(e===n)){e.apply(r._renderer,a,i);var t=a;a=i,i=t}else e.apply(r._renderer,a,o)}),this._renderTargets.push(a),this._renderTargets.push(i)},e.prototype._onContextChange=function(){this._renderTargets.length=0,this._renderer.isOfType(u.WEBGL)&&(this._quad&&this._quad.dispose(),this._quad=new p.default(this._renderer))},e.prototype.dispose=function(){this._renderer.off('context',this._onContextChange),this._quad&&this._quad.dispose(),this._renderTargets.forEach(function(e){e.dispose()})},e}();t.default=_},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(31),l=r(n),s=o(219),d=r(s),p={256:'ImageWidth',257:'ImageHeight',258:'BitsPerSample',259:'Compression',262:'PhotometricInterpretation',270:'ImageDescription',271:'Make',272:'Model',273:'StripOffsets',274:'Orientation',277:'SamplesPerPixel',278:'RowsPerStrip',279:'StripByteCounts',282:'XResolution',283:'YResolution',284:'PlanarConfiguration',296:'ResolutionUnit',301:'TransferFunction',305:'Software',306:'DateTime',315:'Artist',318:'WhitePoint',319:'PrimaryChromaticities',513:'JPEGInterchangeFormat',514:'JPEGInterchangeFormatLength',529:'YCbCrCoefficients',530:'YCbCrSubSampling',531:'YCbCrPositioning',532:'ReferenceBlackWhite',33432:'Copyright',34665:'ExifIFDPointer',34853:'GPSInfoIFDPointer',40965:'InteroperabilityIFDPointer'},u='data:image/jpeg;base64,',_=/^data:image\/jpeg;base64,/i,f=function(){function e(t){(0,i.default)(this,e),this._buf=t,this._stream=new d.default(this._buf),this._stream.setHead(0),this._segments=this._sliceIntoSegments(this._buf),this._exifBuffer=this._getExifBuffer(),this._exifStream=new d.default(this._exifBuffer),this._parseExif()}return e.prototype.restoreExifTags=function(e){var t=e.replace(u,''),o=l.default.decode(t),r=this._sliceIntoSegments(o),a=r[1][0],i=o.slice(0,a),n=o.slice(a),s=i.concat(this._exifBuffer);return s=s.concat(n),u+l.default.encode(s)},e.prototype.setOrientation=function(e){if(this._tagData.Orientation){var t=this._tagData.Orientation.entryOffset;this._exifStream.setHead(t+8),this._exifStream.writeInt16(e)}},e.isJPEG=function(e){return _.test(e)},e.fromBase64String=function(t){var o=t.replace(u,''),r=l.default.decode(o);return new e(r)},e.prototype._parseExif=function(){this._exifStream.setHead(0),this._exifStream.readInt16(),this._exifStream.readInt16();var e=this._exifStream.readString(4);if('Exif'===e){this._exifStream.readInt16();var t=this._exifStream.getHead(),o=!1,r=this._exifStream.readInt16();if(18761===r)o=!1;else if(19789===r)o=!0;else throw new Error('Invalid TIFF data: No endian type found');if(42!==this._exifStream.readInt16(!o))throw new Error('Invalid TIFF data: No 0x002A');var a=this._exifStream.readInt32(!o);if(8>a)throw new Error('Invalid TIFF data: First IFD offset < 8');var i=this._readTags(this._exifStream,t,t+a,o);this._tags=i.tags,this._tagData=i.tagData}},e.prototype._readTags=function(e,t,o,r){e.setHead(o);for(var a=e.readInt16(!r),n={},l=[],s=0,i;s<a;s++){i=o+12*s+2,e.setHead(i);var d=e.readInt16(!r),u=void 0,_=void 0,f=void 0;if(p[d]){d=p[d],u=e.readInt16(!r),_=e.readInt32(!r),f=e.readInt32(!r)+t;var c=null;switch(u){case 1:case 7:if(1===_)c=e.readInt8(!r);else{c=[];for(var g=0;g<_;g++)c.push(e.readInt8(!r))}break;case 2:e.setHead(4<_?f:i+8),c=e.readString(_);break;case 3:if(e.setHead(2<_?f:i+8),1===_)c=e.readInt16(!r);else{c=[];for(var y=0;y<_;y++)c.push(e.readInt16(!r))}break;case 4:case 9:if(e.setHead(1<_?f:i+8),1===_)c=e.readInt32(!r);else{c=[];for(var h=0;h<_;h++)c.push(e.readInt32(!r))}break;case 5:case 10:if(e.setHead(f),1===_){var m=e.readInt32(!r),x=e.readInt32(!r);c=m/x}else{c=[];for(var T=0;T<_;T++){var v=e.readInt32(!r),b=e.readInt32(!r);c.push(v/b)}}}n[d]=c,l[d]={value:c,numValues:_,entryOffset:i,valueOffset:f,type:u}}}return{tags:n,tagData:l}},e.prototype._getExifBuffer=function(){for(var e=this._segments,t=0;t<e.length;t++){var o=e[t][0],r=e[t][1];this._stream.setHead(o);var a=this._stream.peekInt16();if(65505===a)return this._buf.slice(o,r)}return!1},e.prototype._sliceIntoSegments=function(e){for(var t=new d.default(e),o=[],r;t.getHead()<e.length;)if(r=t.readInt16(),65496!==r){if(65498===r)break;if(65280<=r&&65535>=r){var a=t.readInt16(),i=t.getHead()+a-2;o.push([t.getHead()-4,i]),t.setHead(i)}else throw new Error('Invalid marker: 0x'+r.toString(16))}return this._stream.setHead(0),o},e.prototype.getTags=function(){return this._tags},e.prototype.getTagData=function(){return this._tagData},e.prototype.dispose=function(){this._buf=[],this._exifBuffer=[],this._segments=[]},e}();/*
    * Based on https://github.com/exif-js/exif-js by Jacob Seidelin
    * Licensed under MIT
    * @license
    */t.default=f},function(e,t,o){'use strict';var r=o(47),a=o(27),i=o(71),n=o(24),l=o(19),s=o(29),d=o(107),p=o(54),u=o(114),_=o(14)('iterator'),f=!([].keys&&'next'in[].keys()),c='keys',g='values',y=function(){return this};e.exports=function(e,t,o,h,m,x,T){d(o,t,h);var v=function(e){return!f&&e in O?O[e]:e===c?function(){return new o(this,e)}:e===g?function(){return new o(this,e)}:function(){return new o(this,e)}},b=t+' Iterator',C=m==g,R=!1,O=e.prototype,E=O[_]||O['@@iterator']||m&&O[m],S=E||v(m),F=m?C?v('entries'):S:void 0,M='Array'==t?O.entries||E:E,k,P,D;if(M&&(D=u(M.call(new e)),D!==Object.prototype&&(p(D,b,!0),!r&&!l(D,_)&&n(D,_,y))),C&&E&&E.name!==g&&(R=!0,S=function(){return E.call(this)}),(!r||T)&&(f||R||!O[_])&&n(O,_,S),s[t]=S,s[b]=y,m)if(k={values:C?S:v(g),keys:x?S:v(c),entries:F},T)for(P in k)P in O||i(O,P,k[P]);else a(a.P+a.F*(f||R),t,k);return k}},function(e,t,o){var r=o(106);e.exports=function(e,t,o){return(r(e),void 0===t)?e:1===o?function(o){return e.call(t,o)}:2===o?function(o,r){return e.call(t,o,r)}:3===o?function(o,r,a){return e.call(t,o,r,a)}:function(){return e.apply(t,arguments)}}},function(e,t,o){e.exports=!o(18)&&!o(35)(function(){return 7!=Object.defineProperty(o(70)('div'),'a',{get:function(){return 7}}).a})},function(e,t,o){var r=o(28),a=o(15).document,i=r(a)&&r(a.createElement);e.exports=function(e){return i?a.createElement(e):{}}},function(e,t,o){e.exports=o(24)},function(e,t,o){var r=o(19),a=o(20),n=o(110)(!1),i=o(51)('IE_PROTO');e.exports=function(e,t){var o=a(e),l=0,s=[],d;for(d in o)d!=i&&r(o,d)&&s.push(d);for(;t.length>l;)r(o,d=t[l++])&&(~n(s,d)||s.push(d));return s}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,o){var r=o(72),a=o(53).concat('length','prototype');t.f=Object.getOwnPropertyNames||function(e){return r(e,a)}},function(e,t,o){var r=o(58),a=o(36),i=o(20),n=o(48),l=o(19),s=o(69),d=Object.getOwnPropertyDescriptor;t.f=o(18)?d:function(e,t){if(e=i(e),t=n(t,!0),s)try{return d(e,t)}catch(t){}return l(e,t)?a(!r.f.call(e,t),e[t]):void 0}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0}),t.ColorMatrix=t.Matrix=t.Rectangle=t.Vector2=void 0;var a=o(21),i=r(a),n=o(78),l=r(n),s=o(79),d=r(s),p=o(59),u=r(p);t.Vector2=i.default,t.Rectangle=l.default,t.Matrix=d.default,t.ColorMatrix=u.default},function(e,t,o){e.exports={default:o(138),__esModule:!0}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(21),l=r(n),d=function(){function e(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0,o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0,r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,a=3<arguments.length&&void 0!==arguments[3]?arguments[3]:0;(0,i.default)(this,e),this.x=t,this.y=o,this.width=r,this.height=a}return e.prototype.set=function(e,t,o,r){return this.x=e,this.y=t,this.width=o,this.height=r,this},e.prototype.clone=function(){return new e(this.x,this.y,this.width,this.height)},e.prototype.copy=function(e){return this.x=e.x,this.y=e.y,this.width=e.width,this.height=e.height,this},e.prototype.equals=function(t,o,r,a){if(t instanceof e)return t.x===this.x&&t.y===this.y&&t.width===this.width&&t.height===this.height;return t===this.x&&o===this.y&&r===this.width&&a===this.height},e.prototype.round=function(){return this.x=s(this.x),this.y=s(this.y),this.width=s(this.width),this.height=s(this.height),this},e.prototype.getPosition=function(){return new l.default(this.x,this.y)},e.prototype.getSize=function(){return new l.default(this.width,this.height)},e.prototype.toString=function(){return'Rectangle({ x: '+this.x+', y: '+this.y+', width: '+this.width+', height: '+this.height+' })'},e}();t.default=d},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(40),l=r(n),s=o(21),d=r(s),p=function(){function e(){(0,i.default)(this,e),this.reset()}return e.prototype.multiply=function(e){var t,o,r,a,i,n;return t=this.a*e.a+this.b*e.c,o=this.a*e.b+this.b*e.d,r=this.c*e.a+this.d*e.c,a=this.c*e.b+this.d*e.d,i=this.tx*e.a+this.ty*e.c+e.tx,n=this.tx*e.b+this.ty*e.d+e.ty,this.a=t,this.b=o,this.c=r,this.d=a,this.tx=i,this.ty=n,this},e.prototype.applyToVector=function(e){var t=e,o=t.x,r=t.y;return e=e.clone(),e.x=this.a*o+this.c*r+this.tx,e.y=this.b*o+this.d*r+this.tx,e},e.prototype.applyInverseToVector=function(e){var t=1/(this.a*this.d+this.c*-this.b),o=e,r=o.x,a=o.y;return e=e.clone(),e.x=this.d*t*r+-this.c*t*a+(this.ty*this.c-this.tx*this.d)*t,e.y=this.a*t*a+-this.b*t*r+(-this.ty*this.a+this.tx*this.b)*t,e},e.prototype.rectangleToCoordinates=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:new d.default(0,0),o=e.width*(1-t.x),r=e.width*-t.x,a=e.height*(1-t.y),i=e.height*-t.y,n=[];return n.push(new d.default(this.a*r+this.c*i+this.tx,this.d*i+this.b*r+this.ty)),n.push(new d.default(this.a*o+this.c*i+this.tx,this.d*i+this.b*o+this.ty)),n.push(new d.default(this.a*o+this.c*a+this.tx,this.d*a+this.b*o+this.ty)),n.push(new d.default(this.a*r+this.c*a+this.tx,this.d*a+this.b*r+this.ty)),n},e.prototype.reset=function(){this.a=1,this.b=0,this.c=0,this.d=1,this.tx=0,this.ty=0},e.prototype.toArray=function(){var e=[this.a,this.b,0,this.c,this.d,0,this.tx,this.ty,1];return'undefined'==typeof Float32Array?e:new Float32Array(e)},e.prototype.toString=function(){return'Matrix({ a: '+this.a+', b: '+this.b+', c: '+this.c+', d: '+this.d+', tx: '+this.tx+', ty: '+this.ty+' })'},(0,l.default)(e,null,[{key:'IDENTITY',get:function(){return new e}}]),e}();t.default=p},function(e,t,o){var r=o(50),a=o(14)('toStringTag'),i='Arguments'==r(function(){return arguments}()),n=function(e,t){try{return e[t]}catch(t){}};e.exports=function(e){var t,o,l;return e===void 0?'Undefined':null===e?'Null':'string'==typeof(o=n(t=Object(e),a))?o:i?r(t):'Object'==(l=r(t))&&'function'==typeof t.callee?'Arguments':l}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(82),i=r(a),n=o(22),l=r(n);t.default={checkFramebufferStatus:function(e,t){var o=t.checkFramebufferStatus(t.FRAMEBUFFER),r=(a={},(0,i.default)(a,t.FRAMEBUFFER_INCOMPLETE_ATTACHMENT,'Incomplete attachment'),(0,i.default)(a,t.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT,'Missing attachment'),(0,i.default)(a,t.FRAMEBUFFER_INCOMPLETE_DIMENSIONS,'Incomplete dimensions'),(0,i.default)(a,t.FRAMEBUFFER_UNSUPPORTED,'Framebuffer unsupported'),a),a;o!==t.FRAMEBUFFER_COMPLETE&&l.default.warn(e,'Framebuffer incomplete: '+r[o])}}},function(e,t,o){'use strict';t.__esModule=!0;var r=o(77),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t,o){return t in e?(0,a.default)(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e}},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o(6),n='undefined'!=typeof window&&window.performance&&window.performance.now?window.performance.now.bind(window.performance):o(84),l=function(){function e(t){var o=this;(0,a.default)(this,e),this._context=t,this._tracking=!1;var r=this,i=function(e){var a=t[e];'function'==typeof a?o[e]=function(){for(var o=arguments.length,a=Array(o),i=0;i<o;i++)a[i]=arguments[i];var l=t[e];if(!r._tracking)return l.apply(t,a);var s=n(),d=l.apply(t,a),p=n()-s;return r._trackedCalls.push({functionName:e,arguments:a,duration:p}),d}:o._makePropertyWrapper(e)};for(var l in t)i(l)}return e.prototype._makePropertyWrapper=function(e){if(-1===['_context','_trackedCalls','_tracking'].indexOf(e)){var t=this._context;this.__defineGetter__(e,function(){return t[e]}),this.__defineSetter__(e,function(o){t[e]=o})}},e.prototype.startFrame=function(){this._tracking=!0,this._trackedCalls=[]},e.prototype.endFrame=function(){var e='Rendering';i.Log.log(e,'Frame rendering results:'),i.Log.log(e,'Context calls: '+this._trackedCalls.length);var t={};this._trackedCalls.forEach(function(e){var o=e.functionName,r=e.duration;t[o]=t[o]||{totalDuration:0,calls:0},t[o].totalDuration+=r,t[o].calls++});var o=[];for(var r in t){var a=t[r];a.averageDuration=a.totalDuration/a.calls,o.push({functionName:r,data:a})}o.sort(function(e,t){return t.data.totalDuration-e.data.totalDuration}),o=o.slice(0,3),o.forEach(function(t){i.Log.log(e,t.functionName+': '+t.data.calls+' calls, '+t.data.totalDuration.toFixed(2)+'ms')})},e}();t.default=l},function(e,t,o){(function(t){(function(){var o,r,a;'undefined'!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:'undefined'!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(o()-a)/1e6},r=t.hrtime,o=function(){var e;return e=r(),1e9*e[0]+e[1]},a=o()):Date.now?(e.exports=function(){return Date.now()-a},a=Date.now()):(e.exports=function(){return new Date().getTime()-a},a=new Date().getTime())}).call(this)}).call(t,o(60))},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(149),_=r(u),f=function(e){function t(o,r){var a=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};(0,i.default)(this,t);var n=(0,l.default)(this,e.call(this));return n._options=_.default.defaults(a,{pixelRatio:1,transparent:!1,clearColor:p.Color.BLACK,debug:!1}),n.setMaxListeners(0),n._width=o||800,n._height=r||600,n._dimensions=new p.Vector2(n._width,n._height),n._maxTextureSize=null,n._pixelRatio=n._options.pixelRatio,n._clearColor=n._options.transparent?p.Color.TRANSPARENT:n._options.clearColor||p.Color.BLACK,n}return(0,d.default)(t,e),t.prototype.setCanvas=function(e){var t=this._canvas;this._canvas=e,t!==e&&(this._createContext(),this._onBeforeContext(),this._setupContext()),this.resizeTo(new p.Vector2(this._width,this._height))},t.prototype.getCanvas=function(){return this._canvas},t.prototype._onBeforeContext=function(){},t.prototype.resizeTo=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:!0;this._width=e.x*this._pixelRatio,this._height=e.y*this._pixelRatio,t&&(this._canvas.width=this._width,this._canvas.height=this._height,this._canvas.style&&(this._canvas.style.width=this._width/this._pixelRatio+'px',this._canvas.style.height=this._height/this._pixelRatio+'px')),this._dimensions=e.clone()},t.prototype._createContext=function(){p.Log.warn(this.constructor.name,'`_createContext` is abstract and not implemented in inherited class')},t.prototype._setupContext=function(){p.Log.warn(this.constructor.name,'`_setupContext` is abstract and not implemented in inherited class')},t.prototype.render=function(){p.Log.warn(this.constructor.name,'`render` is abstract and not implemented in inherited class')},t.prototype.getMaxDimensions=function(){return null},t.prototype.getContext=function(){return this._context},t.prototype.getWidth=function(){return this._dimensions.x},t.prototype.getHeight=function(){return this._dimensions.y},t.prototype.getDimensions=function(){return this._dimensions},t.prototype.getPixelRatio=function(){return this._pixelRatio},t.prototype.setPixelRatio=function(e){this._pixelRatio=e,this._defaultRenderTarget&&this._defaultRenderTarget.setPixelRatio(e)},t.prototype.getMaxTextureSize=function(){return this._maxTextureSize},t.prototype.getFilterManager=function(){return this._filterManager},t.prototype.setFilterManager=function(e){this._filterManager=e},t.isSupported=function(){return!0},t.prototype.isOfType=function(e){return this._type===e},t.prototype.dispose=function(){p.Log.warn(this.constructor.name,'`dispose` is abstract and not implemented in inherited class')},t}(p.EventEmitter);t.default=f},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){function e(t){(0,a.default)(this,e),this._renderer=t,this._onContextChange=this._onContextChange.bind(this),this._renderer.on('context',this._onContextChange)}return e.prototype._onContextChange=function(){},e.prototype.start=function(){},e.prototype.stop=function(){this.flush()},e.prototype.flush=function(){},e.prototype.dispose=function(){this._renderer.off('context',this._onContextChange),this._renderer=null},e}();t.default=i},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){function e(t,o,r){(0,a.default)(this,e),this.width=t,this.height=o,this.data=r}return e.fromNodeCanvasImage=function(t){var o=new Canvas(t.width,t.height),r=o.getContext('2d');r.drawImage(t,0,0);var a=r.getImageData(0,0,t.width,t.height);return new e(t.width,t.height,a.data)},e}();t.default=i},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(64),_=r(u),f=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._children=[],n._filters=[],n}return(0,d.default)(t,e),t.prototype.addFilter=function(e){this._filters.push(e)},t.prototype.removeFilter=function(e){var t=this._filters.indexOf(e);return-1!==t&&(this._filters.splice(t,1),!0)},t.prototype.setFilters=function(e){this._filters=e},t.prototype.addChild=function(e){var t=e.getParent();null!==t&&t.removeChild(e),e.setParent(this),this._children.push(e)},t.prototype.prependChild=function(e){var t=e.getParent();null!==t&&t.removeChild(e),e.setParent(this),this._children.unshift(e)},t.prototype.hasChild=function(e){var t=this._children.indexOf(e);return-1!==t},t.prototype.removeChild=function(e){var t=this._children.indexOf(e);-1===t?p.Log.info(this.constructor.name,'Tried to remove a child that does not exist'):(this._children.splice(t,1),e.setParent(null))},t.prototype.clearChildren=function(){this._children=[]},t.prototype.renderWebGL=function(e){if(this._visible){var t=e.getFilterManager();this._filters&&this._filters.length&&t.pushFilters(this,this._filters),e.getCurrentObjectRenderer().start(),this._renderWebGL(e),this._children.forEach(function(t){t.renderWebGL(e)}),e.getCurrentObjectRenderer().flush(),this._filters&&this._filters.length&&t.popFilters(),e.getCurrentObjectRenderer().start()}},t.prototype._renderWebGL=function(){},t.prototype.renderCanvas=function(e){if(this._visible){var t=e.getFilterManager();this._filters&&this._filters.length&&t.pushFilters(this,this._filters),this._renderCanvas(e),this._children.forEach(function(t){t.renderCanvas(e)}),this._filters&&this._filters.length&&t.popFilters()}},t.prototype._renderCanvas=function(){},t.prototype.updateTransform=function(){e.prototype.updateTransform.call(this),this._children.forEach(function(e){e.updateTransform()})},t.prototype.getLocalBounds=function(){return this._localBoundsNeedUpdate&&(this._localBoundsNeedUpdate=!1),this._localBounds.clone()},t.prototype.getBounds=function(){return this._boundsNeedUpdate&&(this._boundsNeedUpdate=!1),this._bounds.clone()},t.prototype.getChildren=function(){return this._children},t.prototype.getFilters=function(){return this._filters},t.prototype.dispose=function(){},t}(_.default);t.default=f},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(32),_=r(u),f=o(155),c=r(f),g=function(e){function t(o,r){(0,i.default)(this,t);var a=(0,l.default)(this,e.call(this));if(!(o instanceof _.default))throw new Error('`baseTexture` should be an instance of BaseTexture');return a._uvs=new c.default,a._frame=r?r.clone():null,a._frameLocked=!!r,a._onBaseTextureLoaded=a._onBaseTextureLoaded.bind(a),a._onBaseTextureUpdated=a._onBaseTextureUpdated.bind(a),a._frame||(a._frame=new p.Rectangle(0,0,1,1)),a.setBaseTexture(o),a}return(0,d.default)(t,e),t.fromImage=function(e){var o=new _.default(e);return new t(o)},t.fromCanvas=function(e){var o=new _.default(e);return new t(o)},t.prototype._onBaseTextureLoaded=function(){if(!this._frameLocked){var e=this._baseTexture.getFrame().clone();this.setFrame(e)}this._baseTexture.on('update',this._onBaseTextureUpdated)},t.prototype._onBaseTextureUpdated=function(){var e=this._baseTexture.getFrame(),t=e.width,o=e.height;this._frame.width=t,this._frame.height=o,this.emit('update')},t.prototype._updateUVs=function(){this._uvs.update(this._frame,this._baseTexture.getFrame())},t.prototype.getBaseTexture=function(){return this._baseTexture},t.prototype.setBaseTexture=function(e){if(this._baseTexture=e,!this._baseTexture.isLoaded())this._baseTexture.once('loaded',this._onBaseTextureLoaded);else{var t=e.getFrame(),o=t.width,r=t.height;this._frameLocked||(this._frame=new p.Rectangle(0,0,o,r)),this._onBaseTextureLoaded()}},t.prototype.getFrame=function(){return this._frame},t.prototype.setFrame=function(e){this._frame=e,this._updateUVs()},t.prototype.getWidth=function(){return this._frame.width},t.prototype.getHeight=function(){return this._frame.height},t.prototype.getUVs=function(){return this._uvs},t.prototype.getDimensions=function(){return new p.Vector2(this._frame.width,this._frame.height)},t.prototype.dispose=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:!0;e&&this._baseTexture.dispose()},t}(p.EventEmitter);t.default=g},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(182);Object.defineProperty(t,'FilterOperation',{enumerable:!0,get:function(){return r(a).default}});var i=o(185);Object.defineProperty(t,'TransformOperation',{enumerable:!0,get:function(){return r(i).default}});var n=o(187);Object.defineProperty(t,'OrientationOperation',{enumerable:!0,get:function(){return r(n).default}});var l=o(188);Object.defineProperty(t,'AdjustmentsOperation',{enumerable:!0,get:function(){return r(l).default}});var s=o(192);Object.defineProperty(t,'MirroredFocusOperation',{enumerable:!0,get:function(){return r(s).default}});var d=o(195);Object.defineProperty(t,'RadialFocusOperation',{enumerable:!0,get:function(){return r(d).default}});var p=o(198);Object.defineProperty(t,'LinearFocusOperation',{enumerable:!0,get:function(){return r(p).default}});var u=o(201);Object.defineProperty(t,'FrameOperation',{enumerable:!0,get:function(){return r(u).default}});var _=o(202);Object.defineProperty(t,'SpriteOperation',{enumerable:!0,get:function(){return r(_).default}});var f=o(210);Object.defineProperty(t,'WatermarkOperation',{enumerable:!0,get:function(){return r(f).default}});var c=o(211);Object.defineProperty(t,'ExifOrientationOperation',{enumerable:!0,get:function(){return r(c).default}});var g=o(212);Object.defineProperty(t,'SelectiveBlurOperation',{enumerable:!0,get:function(){return r(g).default}});var y=o(216);Object.defineProperty(t,'BlurOperation',{enumerable:!0,get:function(){return r(y).default}});var h=o(217);Object.defineProperty(t,'OverlayOperation',{enumerable:!0,get:function(){return r(h).default}})},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o(3),n='undefined'!=typeof window&&window.performance&&window.performance.now?window.performance.now.bind(window.performance):o(84),l=function(){function e(t,o){(0,a.default)(this,e),this._tag=t,this._name=o,this._start=n()}return e.prototype.stop=function(){var e=n(),t=e-this._start,o=s(1e3/t);i.Log.info(this._tag,this._name+' took '+t.toFixed(2)+'ms ('+o+' FPS)')},e}();t.default=l},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(4),_=r(u),f=function(e){function t(){return(0,i.default)(this,t),(0,l.default)(this,e.apply(this,arguments))}return(0,d.default)(t,e),t.prototype.render=function(e,t,o){return p.Promise.resolve(o)},t}(_.default);f.isIdentity=!0,f.identifier='identity',t.default=f},function(t,o,r){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(o,'__esModule',{value:!0});var i=r(0),n=a(i),l=r(1),s=a(l),d=r(2),p=a(d),_=r(3),f=_.Constants.UniformType,c=_.Constants.OptionType,g=1e-7,y=function(t){function o(){(0,n.default)(this,o);var e=(0,s.default)(this,t.call(this));return e._fragmentSource=r(189),e}return(0,p.default)(o,t),o.prototype._applyCanvas=function(t,o,r){for(var a=3<arguments.length&&void 0!==arguments[3]&&arguments[3],n=o.getCanvas(),l=o.getContext(),s=r.getContext(),d=l.getImageData(0,0,n.width,n.height),p=this._options,f=p.colorMatrix,c=p.gamma,y=p.shadows,h=p.highlights,m=new _.Color(0,0,0,0),x=0,i;x<n.width*n.height;x++){if(i=4*x,m.r=d.data[i]/255,m.g=d.data[i+1]/255,m.b=d.data[i+2]/255,1!==c&&(m.r=e(m.r,1/u(c,g)),m.g=e(m.g,1/u(c,g)),m.b=e(m.b,1/u(c,g))),0!==y||0!==h){var T=0.2125*m.r+0.7154*m.g+0.0721*m.b,v=0<=y?_.Utils.clamp(e(T,1/(y+1))+-0.76*e(T,2/(y+1))-T,0,u(y,1)):-_.Utils.clamp(e(T,1/(-y+1))+-0.76*e(T,2/(-y+1))-T,0,u(-y,1)),b=0>h?_.Utils.clamp(1-e(1-T,1/(1-h))- -0.8*e(1-T,2/(1-h))-T,-1,0):-_.Utils.clamp(1-e(1-T,1/(1+h))- -0.8*e(1-T,2/(1+h))-T,-1,0),C=v*T*T,R=v-C,O=T+C+b;m.r=_.Utils.clamp(O*((m.r+R)/u(T,g)),0,1),m.g=_.Utils.clamp(O*((m.g+R)/u(T,g)),0,1),m.b=_.Utils.clamp(O*((m.b+R)/u(T,g)),0,1)}m=f.apply(m),d.data[i]=255*m.r,d.data[i+1]=255*m.g,d.data[i+2]=255*m.b}s.putImageData(d,0,0)},o}(_.Engine.Filter);y.prototype.availableOptions={gamma:{type:c.NUMBER,default:1,uniformType:f.FLOAT},shadows:{type:c.NUMBER,default:0,uniformType:f.FLOAT},highlights:{type:c.NUMBER,default:1,uniformType:f.FLOAT},colorMatrix:{type:c.COLOR_MATRIX,default:new _.ColorMatrix,uniformType:f.MAT4},colorOffset:{type:c.ARRAY,default:[],uniformType:f.FLOAT4}},o.default=y},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(207),_=r(u),f=o(43),c=r(f),g=o(95),y=r(g),h=o(209),m=r(h),x=p.Constants.OptionType,T=p.Constants.RendererType,v=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._persistedPaths=[],n._outputCanvasDirty=!0,n._outputCanvas=p.Utils.createCanvas(),n._outputContext=n._outputCanvas.getContext('2d'),n._persistCanvas=p.Utils.createCanvas(),n._persistContext=n._persistCanvas.getContext('2d'),n._nextCanvas=p.Utils.createCanvas(),n._texture=p.Engine.Texture.fromCanvas(n._outputCanvas),n._sprite.setTexture(n._texture),n._onPathUpdate=n._onPathUpdate.bind(n),n}return(0,d.default)(t,e),t.prototype.applyFlip=function(e){this._options.paths.forEach(function(t){t.forEachControlPoint(function(t){var o=t.getPosition().clone();'horizontal'===e?o.x=1-o.x:'vertical'===e?o.y=1-o.y:void 0,t.setPosition(o)}),t.setDirty(!0)}),this._reset()},t.prototype.applyRotation=function(e){this._options.paths.forEach(function(t){t.forEachControlPoint(function(t){var o=t.getPosition().clone();90===e?(o.flip(),o.x=1-o.x):-90===e&&(o.flip(),o.y=1-o.y),t.setPosition(o)}),t.setDirty(!0)}),this._reset()},t.prototype.applyTransform=function(e){var t=null;this._options.paths.forEach(function(o){o.forEachControlPoint(function(t){t.setPosition(e.applyToRelativePoint(t.getPosition()))});var r=o.getBrush();r!==t&&(r.setSize(e.applyToRelativeSize(r.getSize())),t=r),o.setDirty(!0)}),this._reset()},t.prototype.clearCanvas=function(){if(this._outputCanvas){this._outputCanvasDirty=!0;var e=this._outputCanvas,t=e.width,o=e.height;this._outputContext.clearRect(0,0,t,o)}},t.prototype.clearPersistCanvas=function(){if(this._persistCanvas){var e=this._persistCanvas,t=e.width,o=e.height;this._persistContext.clearRect(0,0,t,o)}},t.prototype.serializeOptions=function(t){var o=1<arguments.length&&void 0!==arguments[1]&&arguments[1],r=e.prototype.serializeOptions.call(this,t,o);return t||(r.type='brush'),r},t.prototype.serializeOption=function(t){var o=1<arguments.length&&void 0!==arguments[1]&&arguments[1];return'paths'===t?this._options.paths.map(function(e){return e.serializeOptions(void 0,o)}):e.prototype.serializeOption.call(this,t,o)},t.prototype.createPath=function(e){var t=new _.default(this._operation,{brush:e},this._nextCanvas);return t.on('update',this._onPathUpdate),this._options.paths.push(t),this.setDirty(!0),t},t.prototype._onPathUpdate=function(){this._operation.setDirty(!0),this.setDirty(!0)},t.prototype._onPathPersist=function(e){e.renderToCanvas(this._persistCanvas),this._nextCanvas=e.getCanvas();var t=this._nextCanvas.getContext('2d');t.clearRect(0,0,this._nextCanvas.width,this._nextCanvas.height),this._persistedPaths.push(e)},t.prototype._getTexture=function(){return this._texture},t.prototype.setDirtyForRenderer=function(t,o){var r=2<arguments.length&&void 0!==arguments[2]&&arguments[2];e.prototype.setDirtyForRenderer.call(this,t,o,r),t&&r&&(this._persistedPaths=[],this._options.paths.forEach(function(e){e.setDirty(!0)}))},t.prototype.setDirty=function(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];for(var o in this._dirtiness)this.setDirtyForRenderer(e,this._renderers[o],t)},t.prototype.render=function(e){var t=this,o=this._operation.getSDK().getRenderer();this.isDirtyForRenderer(o)&&(p.Utils.ensureCanvasDimensions(this._outputCanvas,e),p.Utils.ensureCanvasDimensions(this._persistCanvas,e),this._options.paths.forEach(function(o){o.render(e),o.getClosed()&&-1===t._persistedPaths.indexOf(o)&&t._onPathPersist(o)}),this.clearCanvas(),this._outputContext.drawImage(this._persistCanvas,0,0),this._options.paths.forEach(function(e){e.getClosed()||e.renderToCanvas(t._outputCanvas)}),this.setDirtyForRenderer(!1,o))},t.prototype.update=function(t,o){o&&(p.Utils.ensureCanvasDimensions(this._outputCanvas,o),p.Utils.ensureCanvasDimensions(this._persistCanvas,o),this._texture.getBaseTexture().update()),this.render(o);var r=t.getRenderer();r.isOfType(T.WEBGL)&&r.updateTexture(this._texture.getBaseTexture()),e.prototype.update.call(this,t,o)},t.prototype._reset=function(){this._persistedPaths=[],this._operation&&this._operation.setDirty(!0),this.setDirty(!0),this.clearCanvas(),this.clearPersistCanvas()},t.prototype.getCanvas=function(){return this._outputCanvas},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._texture.getBaseTexture().dispose()},t}(c.default);v.prototype.availableOptions={id:{type:x.STRING,default:function(){return p.Utils.getUUID()}},position:{type:x.VECTOR2,default:new p.Vector2(0,0)},scale:{type:x.VECTOR2,default:new p.Vector2(1,1)},anchor:{type:x.VECTOR2,default:new p.Vector2(0,0)},pivot:{type:x.VECTOR2,default:new p.Vector2(0,0)},rotation:{type:x.NUMBER,default:0},paths:{type:x.ARRAY,default:[],setter:function(e){var t=this;return e=e.map(function(e){if(e instanceof _.default)return e;var o=e.brush,r=e.closed,a=new _.default(t._operation,{brush:o,closed:r},t._nextCanvas);return e.controlPoints.forEach(function(e){a.addControlPoint(e)}),a}),this._reset(),e}}},v.type='brush',v.Brush=y.default,v.Path=_.default,v.Brushes={RadialBrush:m.default},t.default=v},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),s=r(n),d=o(2),p=r(d),u=o(3),_=o(16),f=r(_),c=u.Constants.OptionType,g=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,s.default)(this,e.call.apply(e,[this].concat(r)));return n._lastOptions={},n._lastInputDimensions=new u.Vector2(0,0),n._brush=null,n}return(0,p.default)(t,e),t.prototype.getBrushImage=function(e){if(this._brush&&this.optionsEqual(this._lastOptions)&&e.equals(this._lastInputDimensions))return this._brush;var t=this._options,o=t.image,r=t.size;o.width=o.height=l(r*e.min());var a=u.Utils.createCanvas();a.width=o.width,a.height=o.height;var i=a.getContext('2d');i.drawImage(o,0,0,a.width,a.height);var n=this._tintImageData(i.getImageData(0,0,a.width,a.height),a.width,a.height);return i.putImageData(n,0,0),this._lastOptions=this.serializeOptions(['size','color']),this._brush=a,this._lastInputDimensions=e.clone(),a},t.prototype._tintImageData=function(e){for(var t=this._options.color,o=0;o<e.data.length;o+=4)e.data[o]+=(255*t.r-e.data[o])*t.a,e.data[o+1]+=(255*t.g-e.data[o+1])*t.a,e.data[o+2]+=(255*t.b-e.data[o+2])*t.a;return e},t.prototype.clone=function(){var e=this.constructor;return new e(this._options)},t}(f.default);t.default=g,g.prototype.availableOptions={identifier:{type:c.STRING},image:{type:c.IMAGE},size:{type:c.NUMBER,default:0.05},color:{type:c.COLOR,default:u.Color.RED}}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(34),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(213),s._lastBlurRadius=null,s._lastDimensions=new p.Vector2(0,0),s._blurredRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getDimensions(),i=!this._lastDimensions.equals(a);this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()),this._blurredRenderTarget.resizeTo(t.getDimensions()),o.setPixelRatio(t.getPixelRatio()),o.resizeTo(t.getDimensions()),(this._lastBlurRadius!==this._options.blurRadius||i)&&(this._blurImage(t),this._lastBlurRadius=this._options.blurRadius);var n=o.getContext();n.drawImage(this._blurredRenderTarget.getCanvas(),0,0),this._lastDimensions.copy(a)},t.prototype._blurImage=function(e){var t=e.getCanvas(),o=e.getContext(),r=new p.Vector2(t.width,t.height),a=o.getImageData(0,0,t.width,t.height);_.default.stackBlurCanvasRGBA(a,0,0,t.width,t.height,this._options.blurRadius*r.min());var i=this._blurredRenderTarget.getContext();i.putImageData(a,0,0)},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._blurredRenderTarget.dispose()},t}(p.Engine.Filter);g.prototype.availableOptions={blurRadius:{type:f.NUMBER,default:30,uniformType:c.FLOAT},delta:{type:f.VECTOR2,default:new p.Vector2(1,1),uniformType:c.FLOAT2},texSize:{type:f.VECTOR2,default:new p.Vector2(100,100),uniformType:c.FLOAT2}},t.default=g},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(7),_=r(u),f=o(30),c=r(f),g=function(e){function t(){var o=0<arguments.length&&void 0!==arguments[0]?arguments[0]:[];(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._onOperationUpdate=r._onOperationUpdate.bind(r),r._cacheEnabled=!0,r._stack=o,r._stack.forEach(function(e){e.on('update',r._onOperationUpdate)}),r}return(0,d.default)(t,e),t.prototype.clear=function(){var e=this;this.forEach(function(t){return e.remove(t)}),this._stack=[]},t.prototype._onOperationUpdate=function(e,t){this.emit(p.Constants.Events.OPERATION_UPDATED,e,t)},t.prototype.enableCache=function(){this._cacheEnabled=!0},t.prototype.disableCache=function(){this._cacheEnabled=!1},t.prototype.forEach=function(e){return this._stack.filter(function(e){return!!e}).forEach(e)},t.prototype.render=function(e,t){var o=this,r=this._stack.filter(function(e){return!!e}).filter(function(e){return e.getEnabled()});r.reverse();var a=r.filter(function(t){return!t.isDirtyForRenderer(e.getRenderer())})[0],i=r.indexOf(a);r.reverse();var n=0;-1!==i&&(n=r.length-i-1);for(var l=0;l<n;l++)p.Log.info(this.constructor.name,'Skipping '+r[l].constructor.name);for(var s=_.default.resolve(t),d=function(e){var t=r[e],a,i;s=s.then(function(e){return t.render(e).then(function(e){return a&&e!==a&&!o._cacheEnabled&&i.disposeRenderTextures(),a=e,i=t,e})})},u=n;u<r.length;u++)d(u);return s},t.prototype.validateSettings=function(){return _.default.all(this._stack.filter(function(e){return!!e}).map(function(e){return e.validateSettings()}))},t.prototype.setAllToDirty=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0];this.forEach(function(t){return t.setDirty(!0,e)})},t.prototype.updateDirtinessForRenderer=function(e){for(var t=!1,o=0,r;o<this._stack.length;o++)r=this._stack[o],r&&(r.isDirtyForRenderer(e)&&(t=!0),t&&r.setDirtyForRenderer(!0,e))},t.prototype.push=function(e){this._stack.push(e),e.on('update',this._onOperationUpdate)},t.prototype.unshift=function(e){this._stack.unshift(e),e.on('update',this._onOperationUpdate)},t.prototype.clone=function(){return new t(this._stack.slice(0))},t.prototype.get=function(e){return this._stack[e]},t.prototype.set=function(e,t){this._stack[e]&&(this._stack[e].off('update',this._onOperationUpdate),this._stack[e].dispose()),this._stack[e]=t,t.on('update',this._onOperationUpdate)},t.prototype.remove=function(e){var t=this._stack.indexOf(e);-1===t||(this._stack[t]&&(this._stack[t].off('update',this._onOperationUpdate),this._stack[t].dispose()),this._stack.splice(t,1))},t.prototype.removeAt=function(e){this._stack[e]&&(this._stack[e].off('update',this._onOperationUpdate),this._stack[e].dispose()),delete this._stack[e]},t.prototype.getStack=function(){return this._stack},t.prototype.dispose=function(){this.forEach(function(e){e.dispose()})},t}(c.default);t.default=g},function(e){e.exports={name:'photoeditorsdk',version:'4.1.2',description:'The most comprehensive photo editor SDK for HTML5',repository:'http://github.com/imgly/pesdk-html5',author:'PhotoEditor SDK <contact@photoeditorsdk.com>',license:'SEE LICENSE IN LICENSE.md',scripts:{"render-filter-previews":'node scripts/run render-filter-previews',"prerender-desktop-css":'node scripts/run render-desktop-ui-css',"release:public":'cross-env ENV=production PESDK_LINT=true PESDK_PUBLIC=true npm run release && rm -rf build/examples/shared',"release:private":'cross-env ENV=production PESDK_LINT=true npm run release && rm -rf build/examples/shared',"release:test":'cross-env ENV=test PESDK_CLEAN=true PESDK_FULL_BUILD=true webpack && npm run prerender-desktop-css',"release:dev":'cross-env ENV=development npm run release',build:'cross-env PESDK_CLEAN=true PESDK_FULL_BUILD=true webpack',watch:'cross-env PESDK_CLEAN=true PESDK_FULL_BUILD=true PESDK_SERVE=true webpack --watch',rebuild:'cross-env PESDK_COPY_PUBLIC=true webpack',release:'cross-env PESDK_CLEAN=true PESDK_FULL_BUILD=true PESDK_RELEASE=true webpack && cross-env PESDK_MINIFY=true PESDK_RELEASE=true webpack && npm run prerender-desktop-css && rimraf build/examples/qa-* && rimraf build/examples/ci-* && rimraf build/**/dev.*',test:'cross-env ENV=test node_modules/.bin/mocha --require test/sdk/support/modules --require test/sdk/support/helpers test/sdk test/ui',"test:react-ui":'cross-env ENV=test node --stack-size=65500 node_modules/.bin/mocha --require test/react-ui/support/helpers test/shared/run-server.js "test/react-ui/*.test.js" "test/react-ui/**/*.test.js"',"test:desktop-ui":'cross-env ENV=test node --stack-size=65500 node_modules/.bin/mocha --require test/desktop-ui/support/helpers test/shared/run-server.js "test/desktop-ui/*.test.js" "test/desktop-ui/**/*.test.js"',"test:webgl":'cross-env RENDERER=webgl ENV=test node_modules/.bin/mocha --require test/sdk/support/modules --require test/sdk/support/helpers test/sdk',jsdoc:'jsdoc -c config/jsdoc.json -r'},devDependencies:{ajv:'^5.0.0',"babel-core":'^6.23.1',"babel-loader":'^7.1.2',"babel-minify-webpack-plugin":'^0.2.0',"babel-plugin-external-helpers":'^6.22.0',"babel-plugin-transform-adonis-hash":'^0.4.0',"babel-plugin-transform-class-properties":'^6.19.0',"babel-plugin-transform-es2015-classes":'^6.6.4',"babel-plugin-transform-object-rest-spread":'^6.20.2',"babel-plugin-transform-proto-to-assign":'^6.23.0',"babel-plugin-transform-runtime":'^6.6.0',"babel-preset-es2015":'^6.6.0',"babel-preset-minify":'^0.2.0',"babel-preset-react":'^6.5.0',"babel-register":'^6.6.0',"babel-runtime":'^6.6.1',chai:'^3.4.0',"chai-as-promised":'^5.1.0',chromedriver:'^2.23.1',classnames:'^2.1.3',"clean-webpack-plugin":'^0.1.16',"compass-mixins":'^0.12.8',"copy-webpack-plugin":'^4.0.1',"cross-env":'^5.0.5',"css-loader":'^0.28.7',del:'^2.0.0',djv:'^1.1.0',"extract-text-webpack-plugin":'^3.0.0',inquirer:'^0.11.4',"inquirer-path":'^1.0.0-alpha5',"jaguarjs-jsdoc":'git://github.com/imgly/jaguarjs-jsdoc.git#master',jsdoc:'^3.5.3',"json-loader":'^0.5.2',mocha:'^3.2.0',nightwatch:'git://github.com/saschagehlich/nightwatch.git#feature/file-upload-and-multiple-selectors',"node-static":'^0.7.10',"performance-now":'^0.2.0',"preprocess-loader":'^0.2.2',"pretty-error":'^2.0.0',prompt:'^1.0.0',"prop-types":'^15.4.2',"raw-loader":'^0.5.1',react:'^15.4.2',"react-dom":'^15.4.2',rembrandt:'^0.1.0',rimraf:'^2.6.2',"sass-loader":'^6.0.6',"selenium-server-standalone-jar":'3.4.0',should:'^4.3.0',sinon:'^1.17.3',"sinon-chai":'^2.8.0',"standard-loader":'^6.0.1',"stats.js":'^0.16.0',"style-loader":'^0.13.1',"term-img2":'^2.0.1',"transform-loader":'^0.2.2',"uglifyjs-webpack-plugin":'^0.4.6',"vinyl-source-stream":'0.1.1',webpack:'^3.5.6',"webpack-notifier":'^1.2.1'},standard:{globals:['describe','context','before','beforeEach','after','afterEach','it','expect'],parser:'babel-eslint'},dependencies:{adonis:'git://github.com/imgly/adonis.git#feature/v1.0',"babel-eslint":'^7.1.1',"babel-plugin-external-helpers":'^6.22.0',canvas:'^2.0.0-alpha.5',gl:'^4.0.3',"node-sass":'^4.5.3',request:'^2.79.0'}}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(11),u=r(p),_=o(9),f=r(_),c=o(10),g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(239),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var a=3<arguments.length&&void 0!==arguments[3]&&arguments[3],n=t.getCanvas(),l=t.getContext(),s=o.getContext(),d=l.getImageData(0,0,n.width,n.height),p=this._options.lookupTableData,u=0;u<n.width*n.height;u++){var i=4*u,_=d.data[i];d.data[i]=p[4*_];var r=d.data[i+1];d.data[i+1]=p[1+4*r];var f=d.data[i+2];d.data[i+2]=p[2+4*f]}s.putImageData(d,0,0)},t}(u.default.Filter);g.prototype.availableOptions={lookupTable:{type:c.OptionType.NUMBER,default:1,uniformType:c.UniformType.INT},lookupTableData:{type:c.OptionType.ARRAY,default:[]}};var y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new g({lookupTable:n._options.textureGLUnit}),n._textures={},n._renderers={},n}return(0,d.default)(t,e),t.prototype.update=function(e){var t=e.getRenderer();t.isOfType(c.RendererType.WEBGL)?this._updateWebGLTexture(e):t.isOfType(c.RendererType.CANVAS)&&this._filter.setLookupTableData(this._options.data)},t.prototype._updateWebGLTexture=function(e){if('undefined'==typeof this._options.data)throw new Error('LookupTable: No data specified.');var t=new Uint8Array(this._options.data),o=e.getRenderer(),r=o.id;this._renderers[r]=o,this._textures[r]||(this._textures[r]=new u.default.BaseTexture);var a=this._textures[r],i=new u.default.PixelArrayImage(256,1,t);a.setSource(i),a.setGLUnit(this._options.textureGLUnit),o.isOfType(c.RendererType.WEBGL)&&o.updateTexture(a)},t.prototype.dispose=function(){for(var t in e.prototype.dispose.call(this),this._textures)this._textures[t].dispose(),delete this._textures[t];delete this._options.data},t}(f.default);t.default=y},function(e,t,o){'use strict';e.exports=o(101).default},function(e,t,o){'use strict';function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(102),n=a(i),l=o(76),s=r(l),d=o(90),p=r(d),u=o(221),_=r(u),f=o(5),c=r(f),g=o(11),y=a(g),h=o(12),m=a(h),x=o(4),T=a(x),v=o(8),b=a(v),C=o(30),R=a(C),O=o(26),E=a(O),S=o(97),F=a(S),M=o(66),k=a(M),P=o(7),D=a(P),B=o(16),I=a(B),w=o(22),L=a(w),A=o(10),N=o(31),U=a(N);n.default.version=o(98).version,n.default.Math=s,n.default.Operations=p,n.default.Filters=_,n.default.FilterPrimitives=c,n.default.Engine=y.default,n.default.Color=m.default,n.default.Filter=T.default,n.default.Operation=b.default,n.default.EventEmitter=R.default,n.default.Utils=E.default,n.default.OperationsStack=F.default,n.default.EXIF=k.default,n.default.Promise=D.default,n.default.Configurable=I.default,n.default.Log=L.default,n.default.RenderType=A.RenderType,n.default.ImageFormat=A.ImageFormat,n.default.OptionType=A.OptionType,n.default.RendererType=A.RendererType,n.default.Base64=U.default,t.default=n.default},function(e,t,o){'use strict';function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(0),n=a(i),l=o(1),s=a(l),d=o(2),u=a(d),_=o(3),f=r(_),c=o(90),g=r(c),y=o(97),h=a(y),m=o(218),x=a(m),T=o(66),v=a(T),b=o(220),C=a(b),R=o(91),O=a(R),E=f.Rectangle,S=f.Constants,F=f.Engine,M=f.Utils,k=f.EventEmitter,P=f.Vector2,D=f.Log,B=f.Base64,I=function(e){return M.byteArrayToString(B.decode(e))},w=S.RenderType,L=S.ImageFormat,A=S.Events,N=S.RendererType,U=function(e){function t(r){var a=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};(0,n.default)(this,t);var i=(0,s.default)(this,e.call(this));i._onOperationUpdate=i._onOperationUpdate.bind(i),i._onContextRestored=i._onContextRestored.bind(i);var l=o(98),d=l.version;if(i.version=d,i[I('VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=')]=!0,i._preferredRenderer=r,i._options=M.defaults(a,{extensions:{},renderMode:'dynamic',versionCheck:!0,displayWelcomeMessage:!0,image:null,canvas:null,transparent:!1,textureQuality:1,zoom:1,spriteScale:1,rotation:0,smoothDownscaling:!1,smoothUpscaling:!1,logLevel:'warn',pixelRatio:'undefined'!=typeof window&&window.devicePixelRatio||1}),i._options.smoothUpscaling&&(F.BaseTexture.DefaultMagFilter=F.BaseTexture.LinearFilter),i._options.extensions=M.defaults(i._options.extensions,{operations:[],controls:[],languages:[]}),D.setLevel(i._options.logLevel),!i._v())return(0,s.default)(i);var p=f[I('TGljZW5zZUNoZWNrZXI=')];i._l=new p(i[I('X29wdGlvbnM=')][I('bGljZW5zZQ==')]),i._ct(),i._cv(!0),i._defaultRenderMode=i._options.renderMode,i._renderMode=i._options.renderMode,i._textureQuality=i._options.textureQuality,i._offset=new P,i._zoom=i._options.zoom,i._spriteScale=i._options.spriteScale,i._rotation=i._options.rotation,i._operations={},i._operationsStack=null,i.setOperationsStack(new h.default),i._container=new F.Container,i._sprite=new F.Sprite,i._container.addChild(i._sprite),i._inputBaseTexture=null,i._inputTexture=i._options.inputTexture,i._currentInputTexture=null,i._currentTexture=null,i._resizedTexture=null,i._resizedContainer=new F.Container,i._resizedSprite=new F.Sprite,i._resizedContainer.addChild(i._resizedSprite),i.setSmoothDownscaling(i._options.smoothDownscaling),i._checkForUpdates(),i._registerOperations(),i._initRenderer();var u=i._renderer.constructor.type;return i._options.displayWelcomeMessage&&D.log('Version:',i.version+' ('+u+') - https://www.photoeditorsdk.com'),i._options.image&&i.setImage(i._options.image),i}return(0,u.default)(t,e),t.prototype._v=function(){return!!this[I('X29wdGlvbnM=')][I('bGljZW5zZQ==')]||(D.error(I('TGljZW5zaW5n'),I('Tm8gYGxpY2Vuc2VgIG9wdGlvbiBnaXZlbi4=')),D.error(I('TGljZW5zaW5n'),I('SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==')),!1)},t.prototype._ct=function(){if(this._l.exp()){var e=this._l.isExp();e?D.error(I('TGljZW5zaW5n'),I('WW91ciB0cmlhbCBsaWNlbnNlIGhhcyBleHBpcmVkLiBQbGVhc2UgY29udGFjdCB1cyBhdCBzYWxlc0BwaG90b2VkaXRvcnNkay5jb20gdG8gb2J0YWluIGEgbGljZW5zZS4=')):D.warn(I('TGljZW5zaW5n'),I('WW91ciB0cmlhbCBsaWNlbnNlIHdpbGwgZXhwaXJlIGluICVkIGRheXMu').replace('%d',this._l.dl()))}},t.prototype._cv=function(){var t=this,o=0<arguments.length&&void 0!==arguments[0]&&arguments[0];return this._l.c().catch(function(r){throw t[I('VG04Z1lHRndhVXRsZVdBZ2IzQjBhVzl1SUdkcGRtVnU=')]=!1,o&&('ELICEXP'===r.code?D.error(I('TGljZW5zaW5n'),I('WW91ciB0cmlhbCBsaWNlbnNlIGhhcyBleHBpcmVkLiBQbGVhc2UgY29udGFjdCB1cyBhdCBzYWxlc0BwaG90b2VkaXRvcnNkay5jb20gdG8gb2J0YWluIGEgbGljZW5zZS4=')):'ELICINVHOST'===r.code?D.error(I('TGljZW5zaW5n'),I('VGhpcyBsaWNlbnNlIGlzIG5vdCB2YWxpZCBmb3IgdGhlIGhvc3RuYW1lIA==')+window.location.hostname+'.'):(D.error(I('TGljZW5zaW5n'),I('SW52YWxpZCBsaWNlbnNlLg==')),D.error(I('TGljZW5zaW5n'),I('SW4gY2FzZSB5b3UgZG9uJ3QgaGF2ZSBhIGxpY2Vuc2UgeWV0LCBwbGVhc2UgY29udGFjdCBvdXIgc2FsZXMgc3RhZmYgYXQgc2FsZXNAcGhvdG9lZGl0b3JzZGsuY29tIHRvIG9idGFpbiBhIGxpY2Vuc2Ugb3IgbG9nIGluIHRvIHlvdXIgY3VzdG9tZXIgZGFzaGJvYXJkLg==')))),new Error(I('SW52YWxpZCBsaWNlbnNlLg=='))})},t.prototype._t=function(){this._l.t()},t.prototype._onOperationUpdate=function(){for(var e=arguments.length,t=Array(e),o=0;o<e;o++)t[o]=arguments[o];this.emit.apply(this,[A.OPERATION_UPDATED].concat(t))},t.prototype._onContextRestored=function(){D.warn(this.constructor.name,'Trying to re-render after WebGL context has been restored.'),this.setAllOperationsToDirty(),this._operationsStack.forEach(function(e){e.disposeRenderTextures()}),this.render()},t.prototype.export=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:w.DATAURL,t=this,o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:L.PNG,r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0.8;return this._cv().then(function(){t._t();var a=new C.default(t,{renderType:e,imageFormat:o,quality:r});return a.export()})},t.prototype.render=function(){var e=this,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:!0;if(!this._inputTexture)throw new Error('You need to set an image before calling PhotoEditorSDK#render.');var o=this._renderer.getContext();o.startFrame&&o.startFrame();var r;D.canLog('info')&&(r=new O.default('\u26A1\u26A1\u26A1','Frame rendering')),D.info('\u26A1\u26A1\u26A1','Rendering starts');var a=this._operationsStack;return a.updateDirtinessForRenderer(this._renderer),this._prepareTexture().then(function(t){'export'===e._renderMode&&(t=e._inputTexture),e._currentTexture=t,e._sprite.setTexture(t),e._container.updateTransform()}).then(function(){return a.validateSettings()}).then(function(){return a.render(e,e._currentTexture)}).then(function(o){switch(e._currentTexture=o,e._sprite.setTexture(e._currentTexture),e._renderMode){case'dynamic':var r=e._renderer.getDimensions().clone().divide(2).add(e._offset);e._container.setScale(e._zoom/e.getTextureScale(),e._zoom/e.getTextureScale()),e._container.setPosition(r),e._sprite.setAnchor(0.5,0.5),e._sprite.setScale(e._spriteScale,e._spriteScale),e._sprite.setRotation(e._rotation);break;case'export':e._container.setScale(1,1),e._container.setPosition(0,0),e._sprite.setAnchor(0,0),e._sprite.setPosition(0,0),e._sprite.setScale(e._spriteScale,e._spriteScale),e._sprite.setRotation(0);}return t&&e._renderer.render(e._container),o}).then(function(e){return r&&r.stop(),o.endFrame&&o.endFrame(),e})},t.prototype.getTextureScale=function(){return p(1,this._textureQuality*this._options.pixelRatio)},t.prototype._prepareTexture=function(){var e=this;return new Promise(function(t){var o=e.getTextureScale();if(1===e._textureQuality)return t(e._inputTexture);var r=e.getInputDimensions().multiply(o).floor(),a;e._resizedTexture?!e._resizedTexture.getDimensions().equals(r)&&(e._resizedTexture.resizeTo(r),a=!0):(e._resizedTexture=new F.RenderTexture(e._renderer,r.x,r.y),a=!0),a&&(e._resizedSprite.setScale(o,o),e._resizedSprite.setTexture(e._inputTexture),e._resizedTexture.render(e._resizedContainer)),t(e._resizedTexture)})},t.prototype._registerOperations=function(){for(var e in this._operations={},g){var t=g[e];this._operations[t.identifier]=t}this._operations=M.extend(this._operations,this._options.extensions.operations)},t.prototype.setAllOperationsToDirty=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0];this._operationsStack.setAllToDirty(e)},t.prototype.createOperation=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0,r=this._operations[e];if(!r)throw new Error('No operation with identifier `'+e+'` found.');var a=new r(this,t);return o&&this.addOperation(a),a},t.prototype.addOperation=function(e){this._operationsStack.push(e)},t.prototype.removeOperation=function(e){this._operationsStack.remove(e)},t.prototype.getInputDimensions=function(){var e=this._inputTexture.getFrame();return new P(e.width,e.height)},t.prototype.getFinalDimensions=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this.getInputDimensions(),o=this._operationsStack;return o.forEach(function(e){e.getEnabled()&&(t=e.getNewDimensions(t))}),e&&t.multiply(this._spriteScale),t.floor()},t.prototype.getOutputDimensions=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0];return this.getFinalDimensions(e).clone().multiply(this._zoom).floor()},t.prototype.getOutputTextureDimensions=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this.getTextureScale(),o=this.getInputDimensions().multiply(t).floor();return this._operationsStack.forEach(function(e){o=e.getNewDimensions(o)}),o},t.prototype._checkForUpdates=function(){this._l.isENT()||(this._versionChecker=new x.default(this.version))},t.prototype._initRenderer=function(){var e={canvas:this._options.canvas,pixelRatio:this._options.pixelRatio,debug:this._options.debug,transparent:this._options.transparent},t,o;if('dynamic'===this._renderMode&&this._options.canvas){var r=this._options.canvas;t=r.width,o=r.height}else if(this._inputTexture){var a=this.getFinalDimensions();t=a.x,o=a.y}else t=1,o=1;switch(this._preferredRenderer){case N.WEBGL:this._renderer=F.autoDetectRenderer(t,o,e),this._renderer.on('context-restored',this._onContextRestored);break;case N.CANVAS:this._renderer=new F.CanvasRenderer(t,o,e),this._renderer.on('context-restored',this._onContextRestored);break;default:D.warn('PhotoEditorSDK','PhotoEditorSDK Error: Renderer `'+this._preferredRenderer+'` not supported. Falling back to automatically detected renderer.'),this._renderer=F.autoDetectRenderer(t,o,e);}},t.prototype.resizeTo=function(e){this._renderer.resizeTo(e,!0)},t.prototype.reset=function(){this._operationsStack.clear()},t.prototype.parseExif=function(e){if(e){var t=e.src;if(v.default.isJPEG(t)){var o=null;try{o=v.default.fromBase64String(t)}catch(t){}return o?o:void 0}}},t.prototype._handleExifOrientation=function(){var e=this._exif.getTags();if(e&&e.Orientation){var t=1!==e.Orientation&&2!==e.Orientation,o=-1!==[2,4,5,7].indexOf(e.Orientation);(t||o)&&(!this._exifOperation&&(this._exifOperation=this.createOperation('exif-orientation')),this._exifOperation.setTags(e),this._exif.setOrientation(1))}},t.prototype.hasImage=function(){return null!==this._image&&'undefined'!=typeof this._image},t.prototype.getImage=function(){return this._image},t.prototype.setImage=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null,o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;this._exifOperation&&(this.removeOperation(this._exifOperation),this._exifOperation=null),this._options.image=e,this._image=e,this._exif=t||this.parseExif(e),this._exif&&this._handleExifOrientation();var r=new F.BaseTexture(this._image),a=new E(0,0,this._image.naturalWidth||this._image.width,this._image.naturalHeight||this._image.height);o&&(a.width=o.x,a.height=o.y),this._resizedTexture&&this._resizedTexture.dispose(),this._resizedTexture=null,this._inputTexture&&this._inputTexture.getBaseTexture().dispose(),this._inputTexture=new F.Texture(r,a),this._currentTexture=this._inputTexture,this._sprite.setTexture(this._inputTexture),this.setAllOperationsToDirty(!0)},t.prototype.setInputTexture=function(e){this._inputTexture=e},t.prototype.getCanvas=function(){return this._renderer.getCanvas()},t.prototype.setCanvas=function(e){this._renderer.setCanvas(e)},t.prototype.getSprite=function(){return this._sprite},t.prototype.getContainer=function(){return this._container},t.prototype.getOperationsStack=function(){return this._operationsStack},t.prototype.setOperationsStack=function(e){this._operationsStack&&this._operationsStack.off(A.OPERATION_UPDATED,this._onOperationUpdate),this._operationsStack=e,this._operationsStack.on(A.OPERATION_UPDATED,this._onOperationUpdate)},t.prototype.getOperations=function(){return this._operations},t.prototype.getRenderer=function(){return this._renderer},t.prototype.getOffset=function(){return this._offset},t.prototype.setOffset=function(e,t){e instanceof P?this._offset.copy(e):this._offset.set(e,t)},t.prototype.getRenderMode=function(){return this._renderMode},t.prototype.setRenderMode=function(e){this._renderMode=e},t.prototype.getZoom=function(){return this._zoom},t.prototype.setZoom=function(e){this._zoom=e,this._container.setScale(this._zoom,this._zoom),this._container.updateTransform()},t.prototype.getTextureQuality=function(){return'export'===this._renderMode?1:this._textureQuality},t.prototype.setTextureQuality=function(e){e!==this._textureQuality&&this.setAllOperationsToDirty(!0),this._textureQuality=p(1,e),1===this._textureQuality&&this._resizedTexture&&(this._resizedTexture.dispose(),this._resizedTexture=null)},t.prototype.getSpriteScale=function(){return this._spriteScale},t.prototype.setSpriteScale=function(e){this._spriteScale=e,this._sprite.setScale(e,e),this._sprite.updateTransform()},t.prototype.getPixelRatio=function(){return this._options.pixelRatio},t.prototype.getExif=function(){return this._exif},t.prototype.getOptions=function(){return this._options},t.prototype.getInputTexture=function(){return this._inputTexture},t.prototype.setSmoothDownscaling=function(e){this._options.smoothDownscaling=e,this._sprite.setSmoothDownscaling(e),this._resizedSprite.setSmoothDownscaling(e)},t.prototype.setRotation=function(e){this._rotation=e},t.prototype.getRotation=function(){return this._rotation},t.prototype.dispose=function(){this._operationsStack.dispose(),this._renderer.dispose(),this._exif&&this._exif.dispose(),this._resizedTexture&&this._resizedTexture.dispose()},t}(k);/*
 * This file is part of PhotoEditorSDK.
 *
 * Copyright (C) 2016-2017 9elements GmbH <contact@9elements.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, without
 * modification, are permitted provided that the following license agreement
 * is approved and a legal/financial contract was signed by the user.
 * The license agreement can be found under following link:
 *
 * https://www.photoeditorsdk.com/LICENSE.txt
 * @license
 */t.default=U},function(e,t,o){e.exports={default:o(104),__esModule:!0}},function(e,t,o){o(44),o(55),e.exports=o(56).f('iterator')},function(e,t,o){var r=o(45),n=o(46);e.exports=function(e){return function(t,o){var d=n(t)+'',s=r(o),i=d.length,l,a;return 0>s||s>=i?e?'':void 0:(l=d.charCodeAt(s),55296>l||56319<l||s+1===i||56320>(a=d.charCodeAt(s+1))||57343<a?e?d.charAt(s):l:e?d.slice(s,s+2):(l-55296<<10)+(a-56320)+65536)}}},function(e){e.exports=function(e){if('function'!=typeof e)throw TypeError(e+' is not a function!');return e}},function(e,t,o){'use strict';var r=o(49),a=o(36),i=o(54),n={};o(24)(n,o(14)('iterator'),function(){return this}),e.exports=function(e,t,o){e.prototype=r(n,{next:a(1,o)}),i(e,t+' Iterator')}},function(e,t,o){var r=o(17),a=o(25),n=o(37);e.exports=o(18)?Object.defineProperties:function(e,t){a(e);for(var o=n(t),l=o.length,s=0,i;l>s;)r.f(e,i=o[s++],t[i]);return e}},function(e,t,o){var r=o(50);e.exports=Object('z').propertyIsEnumerable(0)?Object:function(e){return'String'==r(e)?e.split(''):Object(e)}},function(e,t,o){var r=o(20),a=o(111),i=o(112);e.exports=function(e){return function(t,o,n){var l=r(t),s=a(l.length),d=i(n,s),p;if(e&&o!=o){for(;s>d;)if(p=l[d++],p!=p)return!0;}else for(;s>d;d++)if((e||d in l)&&l[d]===o)return e||d||0;return!e&&-1}}},function(e,t,o){var r=o(45);e.exports=function(e){return 0<e?p(r(e),9007199254740991):0}},function(e,t,o){var r=o(45);e.exports=function(e,t){return e=r(e),0>e?u(e+t,0):p(e,t)}},function(e,t,o){e.exports=o(15).document&&document.documentElement},function(e,t,o){var r=o(19),a=o(115),i=o(51)('IE_PROTO'),n=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=a(e),r(e,i)?e[i]:'function'==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?n:null}},function(e,t,o){var r=o(46);e.exports=function(e){return Object(r(e))}},function(e,t,o){'use strict';var r=o(117),a=o(118),i=o(29),n=o(20);e.exports=o(67)(Array,'Array',function(e,t){this._t=n(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,o=this._i++;return!e||o>=e.length?(this._t=void 0,a(1)):'keys'==t?a(0,o):'values'==t?a(0,e[o]):a(0,[o,e[o]])},'values'),i.Arguments=i.Array,r('keys'),r('values'),r('entries')},function(e){e.exports=function(){}},function(e){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,o){e.exports={default:o(120),__esModule:!0}},function(e,t,o){o(121),o(127),o(128),o(129),e.exports=o(13).Symbol},function(e,t,o){'use strict';var r=o(15),a=o(19),n=o(18),l=o(27),s=o(71),d=o(122).KEY,p=o(35),u=o(52),_=o(54),f=o(38),c=o(14),g=o(56),y=o(57),h=o(123),m=o(124),x=o(125),T=o(25),v=o(20),b=o(48),C=o(36),R=o(49),O=o(126),E=o(75),S=o(17),F=o(37),M=E.f,k=S.f,P=O.f,D=r.Symbol,B=r.JSON,I=B&&B.stringify,w='prototype',L=c('_hidden'),A=c('toPrimitive'),N={}.propertyIsEnumerable,U=u('symbol-registry'),G=u('symbols'),z=u('op-symbols'),V=Object[w],j='function'==typeof D,W=r.QObject,H=!W||!W[w]||!W[w].findChild,q=n&&p(function(){return 7!=R(k({},'a',{get:function(){return k(this,'a',{value:7}).a}})).a})?function(e,t,o){var r=M(V,t);r&&delete V[t],k(e,t,o),r&&e!==V&&k(V,t,r)}:k,Y=function(e){var t=G[e]=R(D[w]);return t._k=e,t},X=j&&'symbol'==typeof D.iterator?function(e){return'symbol'==typeof e}:function(e){return e instanceof D},Z=function(e,t,o){return e===V&&Z(z,t,o),T(e),t=b(t,!0),T(o),a(G,t)?(o.enumerable?(a(e,L)&&e[L][t]&&(e[L][t]=!1),o=R(o,{enumerable:C(0,!1)})):(!a(e,L)&&k(e,L,C(1,{})),e[L][t]=!0),q(e,t,o)):k(e,t,o)},J=function(e,t){T(e);for(var o=m(t=v(t)),r=0,a=o.length,i;a>r;)Z(e,i=o[r++],t[i]);return e},K=function(e){var t=N.call(this,e=b(e,!0));return this===V&&a(G,e)&&!a(z,e)?!1:t||!a(this,e)||!a(G,e)||a(this,L)&&this[L][e]?t:!0},Q=function(e,t){if(e=v(e),t=b(t,!0),e!==V||!a(G,t)||a(z,t)){var o=M(e,t);return o&&a(G,t)&&!(a(e,L)&&e[L][t])&&(o.enumerable=!0),o}},$=function(e){for(var t=P(v(e)),o=[],r=0,i;t.length>r;)a(G,i=t[r++])||i==L||i==d||o.push(i);return o},ee=function(e){for(var t=e===V,o=P(t?z:v(e)),r=[],n=0,i;o.length>n;)a(G,i=o[n++])&&(!t||a(V,i))&&r.push(G[i]);return r};j||(D=function(){if(this instanceof D)throw TypeError('Symbol is not a constructor!');var e=f(0<arguments.length?arguments[0]:void 0),t=function(o){this===V&&t.call(z,o),a(this,L)&&a(this[L],e)&&(this[L][e]=!1),q(this,e,C(1,o))};return n&&H&&q(V,e,{configurable:!0,set:t}),Y(e)},s(D[w],'toString',function(){return this._k}),E.f=Q,S.f=Z,o(74).f=O.f=$,o(58).f=K,o(73).f=ee,n&&!o(47)&&s(V,'propertyIsEnumerable',K,!0),g.f=function(e){return Y(c(e))}),l(l.G+l.W+l.F*!j,{Symbol:D});for(var te=['hasInstance','isConcatSpreadable','iterator','match','replace','search','species','split','toPrimitive','toStringTag','unscopables'],oe=0;te.length>oe;)c(te[oe++]);for(var te=F(c.store),oe=0;te.length>oe;)y(te[oe++]);l(l.S+l.F*!j,'Symbol',{for:function(e){return a(U,e+='')?U[e]:U[e]=D(e)},keyFor:function(e){if(X(e))return h(U,e);throw TypeError(e+' is not a symbol!')},useSetter:function(){H=!0},useSimple:function(){H=!1}}),l(l.S+l.F*!j,'Object',{create:function(e,t){return t===void 0?R(e):J(R(e),t)},defineProperty:Z,defineProperties:J,getOwnPropertyDescriptor:Q,getOwnPropertyNames:$,getOwnPropertySymbols:ee}),B&&l(l.S+l.F*(!j||p(function(){var e=D();return'[null]'!=I([e])||'{}'!=I({a:e})||'{}'!=I(Object(e))})),'JSON',{stringify:function(e){if(!(void 0===e||X(e))){for(var t=[e],o=1,r,a;arguments.length>o;)t.push(arguments[o++]);return r=t[1],'function'==typeof r&&(a=r),(a||!x(r))&&(r=function(e,t){if(a&&(t=a.call(this,e,t)),!X(t))return t}),t[1]=r,I.apply(B,t)}}}),D[w][A]||o(24)(D[w],A,D[w].valueOf),_(D,'Symbol'),_(Math,'Math',!0),_(r.JSON,'JSON',!0)},function(e,t,o){var r=o(38)('meta'),a=o(28),i=o(19),n=o(17).f,l=0,s=Object.isExtensible||function(){return!0},d=!o(35)(function(){return s(Object.preventExtensions({}))}),p=function(e){n(e,r,{value:{i:'O'+ ++l,w:{}}})},u=e.exports={KEY:r,NEED:!1,fastKey:function(e,t){if(!a(e))return'symbol'==typeof e?e:('string'==typeof e?'S':'P')+e;if(!i(e,r)){if(!s(e))return'F';if(!t)return'E';p(e)}return e[r].i},getWeak:function(e,t){if(!i(e,r)){if(!s(e))return!0;if(!t)return!1;p(e)}return e[r].w},onFreeze:function(e){return d&&u.NEED&&s(e)&&!i(e,r)&&p(e),e}}},function(e,t,o){var r=o(37),a=o(20);e.exports=function(e,t){for(var o=a(e),i=r(o),n=i.length,l=0,s;n>l;)if(o[s=i[l++]]===t)return s}},function(e,t,o){var r=o(37),a=o(73),n=o(58);e.exports=function(e){var t=r(e),o=a.f;if(o)for(var l=o(e),s=n.f,d=0,i;l.length>d;)s.call(e,i=l[d++])&&t.push(i);return t}},function(e,t,o){var r=o(50);e.exports=Array.isArray||function(e){return'Array'==r(e)}},function(e,t,o){var r=o(20),a=o(74).f,i={}.toString,n='object'==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],l=function(e){try{return a(e)}catch(t){return n.slice()}};e.exports.f=function(e){return n&&'[object Window]'==i.call(e)?l(e):a(r(e))}},function(){},function(e,t,o){o(57)('asyncIterator')},function(e,t,o){o(57)('observable')},function(e,t,o){e.exports={default:o(131),__esModule:!0}},function(e,t,o){o(132),e.exports=o(13).Object.setPrototypeOf},function(e,t,o){var r=o(27);r(r.S,'Object',{setPrototypeOf:o(133).set})},function(e,t,o){var r=o(28),a=o(25),i=function(e,t){if(a(e),!r(t)&&null!==t)throw TypeError(t+': can\'t set as prototype!')};e.exports={set:Object.setPrototypeOf||('__proto__'in{}?function(e,t,r){try{r=o(68)(Function.call,o(75).f(Object.prototype,'__proto__').set,2),r(e,[]),t=!(e instanceof Array)}catch(o){t=!0}return function(e,o){return i(e,o),t?e.__proto__=o:r(e,o),e}}({},!1):void 0),check:i}},function(e,t,o){e.exports={default:o(135),__esModule:!0}},function(e,t,o){o(136);var r=o(13).Object;e.exports=function(e,t){return r.create(e,t)}},function(e,t,o){var r=o(27);r(r.S,'Object',{create:o(49)})},function(e,t,o){'use strict';(function(e){Object.defineProperty(t,'__esModule',{value:!0});/*
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
 * MIT license
 * @license
 */for(var o='undefined'==typeof window?e:window,r=o.requestAnimationFrame,a=o.cancelAnimationFrame,i=0,n=['ms','moz','webkit','o'],l=0;l<n.length&&!r;++l)t.requestAnimationFrame=r=o[n[l]+'RequestAnimationFrame'],t.cancelAnimationFrame=a=o[n[l]+'CancelAnimationFrame']||o[n[l]+'CancelRequestAnimationFrame'];r||(t.requestAnimationFrame=r=function(e){var t=new Date().getTime(),o=u(0,16-(t-i)),r=setTimeout(function(){e(t+o)},o);return i=t+o,r}),a||(t.cancelAnimationFrame=a=function(e){clearTimeout(e)}),t.requestAnimationFrame=r,t.cancelAnimationFrame=a}).call(t,o(39))},function(e,t,o){o(139);var r=o(13).Object;e.exports=function(e,t,o){return r.defineProperty(e,t,o)}},function(e,t,o){var r=o(27);r(r.S+r.F*!o(18),'Object',{defineProperty:o(17).f})},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=o(141),n=r(a),i=o(144),l=r(i);t.default=function(){function e(e,t){var o=[],r=!0,a=!1,i;try{for(var n=(0,l.default)(e),s;!(r=(s=n.next()).done)&&(o.push(s.value),!(t&&o.length===t));r=!0);}catch(e){a=!0,i=e}finally{try{!r&&n['return']&&n['return']()}finally{if(a)throw i}}return o}return function(t,o){if(Array.isArray(t))return t;if((0,n.default)(Object(t)))return e(t,o);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}()},function(e,t,o){e.exports={default:o(142),__esModule:!0}},function(e,t,o){o(55),o(44),e.exports=o(143)},function(e,t,o){var r=o(80),a=o(14)('iterator'),i=o(29);e.exports=o(13).isIterable=function(e){var t=Object(e);return t[a]!==void 0||'@@iterator'in t||i.hasOwnProperty(r(t))}},function(e,t,o){e.exports={default:o(145),__esModule:!0}},function(e,t,o){o(55),o(44),e.exports=o(146)},function(e,t,o){var r=o(25),a=o(147);e.exports=o(13).getIterator=function(e){var t=a(e);if('function'!=typeof t)throw TypeError(e+' is not iterable!');return r(t.call(e))}},function(e,t,o){var r=o(80),a=o(14)('iterator'),i=o(29);e.exports=o(13).getIteratorMethod=function(e){if(e!=void 0)return e[a]||e['@@iterator']||i[r(e)]}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(83),_=r(u),f=o(85),c=r(f),g=o(41),y=r(g),h=o(61),m=r(h),x=p.Constants.RendererType,T=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._type=x.CANVAS,n.setCanvas(n._options.canvas||n._createCanvas()),n}return(0,d.default)(t,e),t.prototype._createCanvas=function(){return p.Utils.createCanvas()},t.prototype._createContext=function(){var e=this._canvas,o=e.getContext('2d');return this._options.debug&&(o=new _.default(o)),this.id=o.id=t.contextId++,this._context=o,o.renderer=this,this.emit('context',o),o},t.prototype._setupContext=function(){var e=this._context;'imageSmoothingEnabled'in e?e.imageSmoothingEnabled=!0:['moz','webkit','ms'].forEach(function(t){e[t]&&(e[t]=!0)}),this._defaultRenderTarget=new y.default(this._width,this._height,this._pixelRatio,this._canvas,this._context),this.setRenderTarget(this._defaultRenderTarget),this._filterManager=new m.default(this)},t.prototype.render=function(e){var t=this._renderTarget.getContext(),o=e.getParent();e.setParent(this._fakeObject),e.updateTransform(),e.setParent(o),t.setTransform(1,0,0,1,0,0),t.globalAlpha=1;var r=this._canvas,a=r.width,i=r.height;t.clearRect(0,0,a,i),0!==this._clearColor.a&&(t.save(),t.fillStyle=this._clearColor.toRGBA(),t.fillRect(0,0,a,i),t.restore()),this.renderDisplayObject(e,this._renderTarget)},t.prototype.renderDisplayObject=function(e,t){var o=this._renderTarget;this._filterManager.setFilterStack(t.getFilterStack()),this.setRenderTarget(t),e.renderCanvas(this),this.setRenderTarget(o)},t.prototype.getCurrentRenderTarget=function(){return this._renderTarget},t.prototype.setRenderTarget=function(e){this._renderTarget=e},t.prototype.getContext=function(){return this._renderTarget.getContext()},t.prototype.dispose=function(){this._filterManager.dispose()},t}(c.default);T.contextId=0,T.type='Canvas2D',t.default=T},function(e,t){'use strict';Object.defineProperty(t,'__esModule',{value:!0});t.default={defaults:function(e){for(var t=arguments.length,o=Array(1<t?t-1:0),r=1;r<t;r++)o[r-1]=arguments[r];var a={};for(var n in e)a[n]=e[n];for(var l=0,i;l<o.length;l++)for(var s in i=o[l],i)'undefined'==typeof a[s]&&(a[s]=i[s]);return a},extend:function(e){for(var t=arguments.length,o=Array(1<t?t-1:0),r=1;r<t;r++)o[r-1]=arguments[r];var a={};for(var n in e)a[n]=e[n];for(var l=0,i;l<o.length;l++)for(var s in i=o[l],i)a[s]=i[s];return a}}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(85),_=r(u),f=o(42),c=r(f),g=o(86),y=r(g),h=o(151),m=r(h),x=o(62),T=r(x),v=o(64),b=r(v),C=o(65),R=r(C),O=o(83),E=r(O),S=o(87),F=r(S),M=p.Constants.RendererType,k=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._type=M.WEBGL,n._textures=[],n._fakeObject=new b.default,n._onContextLost=n._onContextLost.bind(n),n._onContextRestored=n._onContextRestored.bind(n),n.setCanvas(n._options.canvas||p.Utils.createCanvas()),n.shaders=n._initShaders(),n.renderers=n._initRenderers(),n}return(0,d.default)(t,e),t.prototype._onContextLost=function(t){t.preventDefault(),p.Log.warn(this.constructor.name,'WebGL context has been lost - trying to restore.')},t.prototype._onContextCreationError=function(t){t.preventDefault(),p.Log.warn(this.constructor.name,'Failed to create WebGL context: '+(t.statusMessage||'Unknown error'))},t.prototype._onContextRestored=function(){var e=this;p.Log.warn(this.constructor.name,'WebGL context has been restored. Clearing all textures.'),this._textures.forEach(function(t){t.disposeGLTexturesForRenderer(e)}),this._createContext(),this._setupContext(),this.emit('context-restored')},t.prototype._onBeforeContext=function(){this._filterManager&&this._filterManager.dispose(),this._filterManager=new R.default(this),this._currentObjectRenderer=new y.default(this)},t.prototype.setShader=function(e){this._currentShader=e,this._context.useProgram(e.getProgram()),this._setAttributesForShader(e)},t.prototype.setCanvas=function(t){this._canvas&&this._removeContextEventListeners(),e.prototype.setCanvas.call(this,t),this._canvas.addEventListener&&this._addContextEventListeners()},t.prototype._addContextEventListeners=function(){this._canvas.addEventListener('webglcontextlost',this._onContextLost),this._canvas.addEventListener('webglcontextrestored',this._onContextRestored),this._canvas.addEventListener('webglcontextcreationerror',this._onContextCreationError)},t.prototype._removeContextEventListeners=function(){this._canvas.removeEventListener('webglcontextlost',this._onContextLost),this._canvas.removeEventListener('webglcontextrestored',this._onContextRestored),this._canvas.removeEventListener('webglcontextcreationerror',this._onContextCreationError)},t.prototype._setAttributesForShader=function(e){var t=this._context,o=e.getAttributes(),r=e.getAttributeLocations();o.forEach(function(e){var o=r[e];t.enableVertexAttribArray(o)})},t.prototype._initShaders=function(){return{default:new T.default(this)}},t.prototype._initRenderers=function(){return{sprite:new m.default(this)}},t.prototype._createContext=function(){var e=this._canvas,o=null,r={preserveDrawingBuffer:!0};if(o=e.getContext('webgl',r)||e.getContext('experimental-webgl',r),'undefined'!=typeof window&&window.WebGLDebugUtils&&this._options.debug){var a=function(e,t){console.error('gl.'+e+'('+window.WebGLDebugUtils.glFunctionArgsToString(e,t)+')')};o=window.WebGLDebugUtils.makeDebugContext(o,null,a)}return this._options.debug&&(o=new E.default(o)),this.id=o.id=t.contextId++,this._context=o,o.renderer=this,this._maxTextureSize=o.getParameter(o.MAX_TEXTURE_SIZE),this.emit('context',o),o},t.prototype._setupContext=function(){var e=this._context;e.disable(e.DEPTH_TEST),e.disable(e.CULL_FACE),e.enable(e.BLEND),e.blendFunc(e.ONE,e.ONE_MINUS_SRC_ALPHA),this._defaultRenderTarget=new c.default(this,this._width,this._height,this._pixelRatio,!0),this.setRenderTarget(this._defaultRenderTarget),this._getMaxPrecision()},t.prototype._getMaxPrecision=function(){var e=this._context,t=e.getShaderPrecisionFormat(e.FRAGMENT_SHADER,e.HIGH_FLOAT);this._maxFloatPrecision=0===t.precision?'mediump':'highp';var o=e.getShaderPrecisionFormat(e.FRAGMENT_SHADER,e.HIGH_INT);this._maxIntPrecision=0===o.rangeMax?'lowp':'highp'},t.prototype.resizeTo=function(t){var o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:!0;e.prototype.resizeTo.call(this,t,o),this._currentRenderTarget&&this._currentRenderTarget.resizeTo(t)},t.prototype.setRenderTarget=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:this._defaultRenderTarget;this._currentRenderTarget=e,this._currentRenderTarget.activate()},t.prototype.setObjectRenderer=function(e){this._currentObjectRenderer.stop(),this._currentObjectRenderer=e,this._currentObjectRenderer.start()},t.prototype.render=function(e){this.setRenderTarget(this._defaultRenderTarget),this._defaultRenderTarget.clear(this._clearColor);var t=e.getParent();e.setParent(this._fakeObject),e.updateTransform(),e.setParent(t),this.renderDisplayObject(e,this._defaultRenderTarget)},t.prototype.renderDisplayObject=function(e,t){this.setRenderTarget(t),this._filterManager.setFilterStack(t.getFilterStack()),e.renderWebGL(this),this._currentObjectRenderer.flush()},t.prototype.clear=function(){var e=this._context;e.clearColor.apply(e,this._clearColor.toGLColor()),e.clear(e.COLOR_BUFFER_BIT)},t.prototype.save=function(){return{renderTarget:this._currentRenderTarget,objectRenderer:this._currentObjectRenderer,filterStack:this._filterManager.getFilterStack()}},t.prototype.restore=function(e){this.setRenderTarget(e.renderTarget),this._filterManager.setFilterStack(e.filterStack),this._currentObjectRenderer=e.objectRenderer},t.prototype.getOrCreateGLTexture=function(e){var t=this._context,o=e.getGLTextureForRenderer(this);return o||(o=t.createTexture(),e.setGLTextureForRenderer(o,this),this._textures.push(e)),o},t.prototype.updateTexture=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:!0,o=e.getSource(),r=this._context,a=e.getGLUnit(),i=this.getOrCreateGLTexture(e);r.activeTexture(r.TEXTURE0+a),r.bindTexture(r.TEXTURE_2D,i),r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL,!0),t&&!!o&&(o instanceof F.default?r.texImage2D(r.TEXTURE_2D,0,r.RGBA,o.width,o.height,0,r.RGBA,r.UNSIGNED_BYTE,o.data):r.texImage2D(r.TEXTURE_2D,0,r.RGBA,r.RGBA,r.UNSIGNED_BYTE,o)),e.isMipMappingEnabled()?r.generateMipmap(r.TEXTURE_2D):(r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,e.getGLRepeat(r,'x')),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,e.getGLRepeat(r,'y'))),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,e.getGLFilter(r,'min')),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MAG_FILTER,e.getGLFilter(r,'mag')),r.activeTexture(r.TEXTURE0)},t.prototype.getMaxDimensions=function(){var e=p.Utils.createCanvas(),t=e.getContext('webgl')||e.getContext('experimental-webgl');if(!t)return null;var o=t.getParameter(t.MAX_TEXTURE_SIZE),r=t.getExtension('WEBGL_lose_context');return r&&r.loseContext(),o},t.prototype.getCurrentRenderTarget=function(){return this._currentRenderTarget},t.prototype.getCurrentObjectRenderer=function(){return this._currentObjectRenderer},t.isSupported=function(){var e=p.Utils.createCanvas();e.addEventListener('webglcontextcreationerror',this.prototype._onContextCreationError);var t=e.getContext('webgl')||e.getContext('experimental-webgl');return e.removeEventListener('webglcontextcreationerror',this.prototype._onContextCreationError),!!t},t.prototype.getMaxFloatPrecision=function(){return this._maxFloatPrecision},t.prototype.getMaxIntPrecision=function(){return this._maxIntPrecision},t.prototype.dispose=function(){var e=this;for(var t in this._filterManager.dispose(),this._currentObjectRenderer.dispose(),this._defaultRenderTarget.dispose(),this._textures.forEach(function(t){t.disposeGLTexturesForRenderer(e)}),this.shaders)this.shaders[t].dispose(),delete this.shaders[t];this._removeContextEventListeners();var o=this._context,r=o.getExtension('WEBGL_lose_context');r&&r.loseContext()},t}(_.default);k.contextId=0,k.type='WebGL',t.default=k},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),n=r(a),i=o(1),l=r(i),s=o(2),d=r(s),p=o(6),u=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(p),_=o(86),f=r(_),c=function(e){function t(){(0,n.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var s=(0,l.default)(this,e.call.apply(e,[this].concat(r)));s._maxBatchSize=u.BATCH_SIZE,s._vertices=new ArrayBuffer(4*u.BATCH_SIZE*u.VERTEX_BYTE_SIZE),s._positions=new Float32Array(s._vertices),s._colors=new Uint32Array(s._vertices),s._indices=new Uint16Array(6*u.BATCH_SIZE);for(var d=0,i=0;d<6*u.BATCH_SIZE;d+=6,i+=4)s._indices[d+0]=i+0,s._indices[d+1]=i+1,s._indices[d+2]=i+2,s._indices[d+3]=i+0,s._indices[d+4]=i+2,s._indices[d+5]=i+3;return s._shaders=[],s._sprites=[],s._currentBatchSize=0,s._currentBaseTexture=null,s._onContextChange(),s}return(0,d.default)(t,e),t.prototype.render=function(e){var t=e.getTexture(),o=t.getFrame(),r=t.getBaseTexture();this._currentBatchSize>=this._maxBatchSize&&(this.flush(),this._currentBaseTexture=r);var a=t.getUVs();if(a){var i=this._currentBatchSize*u.VERTEX_BYTE_SIZE;this._addVertexCoordinates(e,i,o),this._addTextureUVs(e,i,a),this._addColors(e,i),this._sprites[this._currentBatchSize]=e,this._currentBatchSize++}},t.prototype._addColors=function(e,t){var o=this._colors,r=e.getTint(),a=(r>>16)+(65280&r)+((255&r)<<16)+(255*e.getWorldAlpha()<<24);o[t+4]=o[t+9]=o[t+14]=o[t+19]=a},t.prototype._addTextureUVs=function(e,t,o){var r=this._positions,a=o.getUVsAt(0);r[t+2]=a.x,r[t+3]=a.y,a=o.getUVsAt(1),r[t+7]=a.x,r[t+8]=a.y,a=o.getUVsAt(2),r[t+12]=a.x,r[t+13]=a.y,a=o.getUVsAt(3),r[t+17]=a.x,r[t+18]=a.y},t.prototype._addVertexCoordinates=function(e,t,o){for(var r=this._positions,a=e.getWorldTransform(),n=e.getAnchor(),l=a.rectangleToCoordinates(o,n),s=5,d=0;4>d;d++)r[t+d*s]=l[d].x,r[t+d*s+1]=l[d].y},t.prototype._onContextChange=function(){var e=this._renderer.getContext();this._shader=this._renderer.shaders.default,this._vertexBuffer=e.createBuffer(),this._indexBuffer=e.createBuffer(),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,this._indexBuffer),e.bufferData(e.ELEMENT_ARRAY_BUFFER,this._indices,e.STATIC_DRAW),e.bindBuffer(e.ARRAY_BUFFER,this._vertexBuffer),e.bufferData(e.ARRAY_BUFFER,this._vertices,e.DYNAMIC_DRAW)},t.prototype.start=function(){this._shader.setupBuffers(this._vertexBuffer,this._indexBuffer)},t.prototype.flush=function(){var e=this._renderer,t=e.getContext();if(0!==this._currentBatchSize){if(this._currentBatchSize>0.5*u.BATCH_SIZE)t.bufferSubData(t.ARRAY_BUFFER,0,this._vertices);else{var o=this._positions.subarray(0,this._currentBatchSize*u.VERTEX_BYTE_SIZE);t.bufferSubData(t.ARRAY_BUFFER,0,o)}for(var r=0,a=null,n=null,l=null,s=null,d=!1,p=!1,_=null,f=0,c=0,i=this._currentBatchSize;c<i;c++){if(_=this._sprites[c],n=_.getTexture().getBaseTexture(),s=_.getShader()||this._shader,d=l!==s,p=a!==n,(p||d)&&(this._renderBatch(a,r,f),f=c,r=0,a=n,d)){l=s,e.setShader(l);var g=e.getCurrentRenderTarget(),y=g.getProjectionMatrix().toArray();l.setUniform('u_projMatrix',y),l.syncUniforms(),t.activeTexture(t.TEXTURE0)}r++}this._renderBatch(a,r,f),this._currentBatchSize=0,this._sprites=[]}},t.prototype._renderBatch=function(e,t,o){if(0!==t){var r=this._renderer,a=r.getContext(),i=e.getGLTextureForRenderer(r);i||(i=r.getOrCreateGLTexture(e)),e.isDirty()&&(r.updateTexture(e),e.setDirty(!1)),a.activeTexture(a.TEXTURE0+e.getGLUnit()),a.bindTexture(a.TEXTURE_2D,i);a.drawElements(a.TRIANGLES,6*t,a.UNSIGNED_SHORT,2*(6*o))}},t.prototype.dispose=function(){var t=this._renderer,o=t.getContext();o.deleteBuffer(this._vertexBuffer),o.deleteBuffer(this._indexBuffer),this._vertices=null,this._positions=null,this._colors=null,this._indices=null,e.prototype.dispose.call(this)},t}(f.default);t.default=c},function(e){e.exports='attribute vec2 a_position;\nattribute vec2 a_texCoord;\nattribute vec4 a_color;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\nuniform mat3 u_projMatrix;\n\nvoid main() {\n  gl_Position = vec4((u_projMatrix * vec3(a_position, 1)).xy, 0, 1);\n  v_texCoord = a_texCoord;\n  v_color = vec4(a_color.rgb * a_color.a, a_color.a);\n}\n'},function(e){e.exports='uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\n\nvoid main() {\n  gl_FragColor = texture2D(u_image, v_texCoord) * v_color;\n}\n'},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){function e(t){(0,a.default)(this,e),this._renderer=t,this._context=this._renderer.getContext(),this._vertices=new Float32Array([0,0,100,0,100,100,0,100]),this._uvs=new Float32Array([0,0,1,0,1,1,0,1]),this._indices=new Uint16Array([0,1,2,0,3,2]),this._colors=new Float32Array([1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]),this._initBuffers(),this._uploadBuffers()}return e.prototype.map=function(e,t){var o=t.x,r=t.y;this._uvs[2]=t.width/e.width,this._uvs[4]=this._uvs[2],this._uvs[5]=t.height/e.height,this._uvs[7]=this._uvs[5],this._vertices[0]=o,this._vertices[1]=r,this._vertices[2]=o+t.width,this._vertices[3]=r,this._vertices[4]=this._vertices[2],this._vertices[5]=r+t.height,this._vertices[6]=o,this._vertices[7]=this._vertices[5],this._uploadBuffers()},e.prototype._initBuffers=function(){var e=this._context;this._vertexBuffer=e.createBuffer(),e.bindBuffer(e.ARRAY_BUFFER,this._vertexBuffer),e.bufferData(e.ARRAY_BUFFER,128,e.DYNAMIC_DRAW),this._indexBuffer=e.createBuffer(),e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,this._indexBuffer),e.bufferData(e.ELEMENT_ARRAY_BUFFER,this._indices,e.STATIC_DRAW)},e.prototype._uploadBuffers=function(){var e=this._context;e.bindBuffer(e.ARRAY_BUFFER,this._vertexBuffer),e.bufferSubData(e.ARRAY_BUFFER,0,this._vertices),e.bufferSubData(e.ARRAY_BUFFER,32,this._uvs),e.bufferSubData(e.ARRAY_BUFFER,64,this._colors)},e.prototype.getVertexBuffer=function(){return this._vertexBuffer},e.prototype.getIndexBuffer=function(){return this._indexBuffer},e.prototype.dispose=function(){var e=this._context;e.deleteBuffer(this._vertexBuffer),e.deleteBuffer(this._indexBuffer)},e}();t.default=i},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o(6),n=function(){function e(){(0,a.default)(this,e),this._uvs=[new i.Vector2(0,0),new i.Vector2(1,0),new i.Vector2(1,1),new i.Vector2(0,1)]}return e.prototype.update=function(e,t){var o=this._uvs[0];o.x=e.x/t.width,o.y=e.y/t.height,o=this._uvs[1],o.x=(e.x+e.width)/t.width,o.y=e.y/t.height,o=this._uvs[2],o.x=(e.x+e.width)/t.width,o.y=(e.y+e.height)/t.height,o=this._uvs[3],o.x=e.x/t.width,o.y=(e.y+e.height)/t.height},e.prototype.getUVsAt=function(e){return this._uvs[e]},e.prototype.getUVs=function(){return this._uvs},e}();t.default=n},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(89),_=r(u),f=o(32),c=r(f),g=o(42),y=r(g),h=o(41),m=r(h),x=o(65),T=r(x),v=o(61),b=r(v),C=p.Constants.RendererType,R=function(e){function t(o){var r=1<arguments.length&&void 0!==arguments[1]?arguments[1]:100,a=2<arguments.length&&void 0!==arguments[2]?arguments[2]:100,n=3<arguments.length&&void 0!==arguments[3]?arguments[3]:1;(0,i.default)(this,t);var s=(0,l.default)(this,e.call(this,new c.default,new p.Rectangle(0,0,r,a)));return s._loaded=!0,s._width=r,s._height=a,s._pixelRatio=n,s._renderer=o,s._setupFilterManager(),s._setupBuffer(),s.setBaseTexture(s._renderTarget.getBaseTexture()),s._updateUVs(),s}return(0,d.default)(t,e),t.prototype._setupFilterManager=function(){this._renderer.isOfType(C.WEBGL)?this._filterManager=new T.default(this._renderer):this._renderer.isOfType(C.CANVAS)&&(this._filterManager=new b.default(this._renderer)),this._filterManager.resizeTo(new p.Vector2(this._width,this._height))},t.prototype._setupBuffer=function(){this._renderer.isOfType(C.WEBGL)?this._setupWebGLRenderTarget():this._renderer.isOfType(C.CANVAS)&&this._setupCanvasRenderTarget()},t.prototype._setupWebGLRenderTarget=function(){this._renderTarget=new y.default(this._renderer,this._width,this._height,this._pixelRatio)},t.prototype._setupCanvasRenderTarget=function(){this._renderTarget=new m.default(this._width,this._height,this._pixelRatio)},t.prototype.clear=function(e){this._renderTarget.clear(e)},t.prototype.resizeTo=function(e){this._width===e.x&&this._height===e.y||(this._width=e.x,this._height=e.y,this._frame.width=e.x,this._frame.height=e.y,this._renderTarget.resizeTo(e),this._filterManager.resizeTo(e))},t.prototype.render=function(e){if(this._renderer.isOfType(C.WEBGL))this._renderWebGL(e);else if(this._renderer.isOfType(C.CANVAS))this._renderCanvas(e);else throw new Error('RenderTexture does not support rendering via '+this._renderer.constructor.name)},t.prototype._renderWebGL=function(e){this._renderTarget.activate(),e.getWorldTransform().reset(),e.getChildren().forEach(function(e){e.updateTransform()});var t=this._renderer.getFilterManager();this._renderer.setFilterManager(this._filterManager),this._renderer.renderDisplayObject(e,this._renderTarget),this._renderer.setFilterManager(t)},t.prototype._renderCanvas=function(e){e.getWorldTransform().reset(),e.getChildren().forEach(function(e){e.updateTransform()});var t=this._renderer.getFilterManager();this._renderer.setFilterManager(this._filterManager),this._renderer.renderDisplayObject(e,this._renderTarget),this._renderer.setFilterManager(t)},t.prototype.getRenderTarget=function(){return this._renderTarget},t.prototype.dispose=function(){this._renderTarget.dispose(),this._filterManager.dispose()},t}(_.default);t.default=R},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),n=r(a),l=o(1),s=r(l),d=o(2),_=r(d),f=o(6),c=o(88),g=r(c),y=o(158),h=r(y),m=function(e){function t(o){(0,n.default)(this,t);var r=(0,s.default)(this,e.call(this));return r._onTextureUpdate=r._onTextureUpdate.bind(r),r._texture=o,r._shader=null,r._width=0,r._height=0,r._anchor=new f.Vector2(0,0),r.setTexture(o),r}return(0,_.default)(t,e),t.prototype._onTextureUpdate=function(){this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},t.prototype._renderWebGL=function(e){var t=e.save();this._smoothDownscaling&&(!this._potRenderer&&(this._potRenderer=new h.default),this._potRenderer.render(e,this,this._texture)),e.restore(t),e.setObjectRenderer(e.renderers.sprite),e.renderers.sprite.render(this)},t.prototype._renderCanvas=function(e){var t=this._worldTransform,o=this._texture.getFrame(),r=o.width,a=o.height,i=e.getCurrentRenderTarget().getPixelRatio(),n=0|this._anchor.x*-r,l=0|this._anchor.y*-a,s=e.getContext();s.setTransform(t.a,t.b,t.c,t.d,t.tx*i,t.ty*i),s.globalAlpha=this.getWorldAlpha();var d=this._texture.getBaseTexture(),p=d.getPixelRatio(),u=d.getSource();s.drawImage(this._texture.getBaseTexture().getSource(),0,0,(u.naturalWidth||r)*p,(u.naturalHeight||a)*p,n*i,l*i,r*i,a*i)},t.prototype.isAtPosition=function(e){var t=this._worldTransform.applyInverseToVector(e),o=this._texture.getFrame(),r=o.width,a=o.height,i=new f.Vector2(-r,-a);i.multiply(this._anchor);var n=i.clone().add(r,a);return t.x<i.x||t.x>n.x||t.y<i.y||t.y>n.y?!1:!0},t.prototype.getLocalBounds=function(){if(this._localBoundsNeedUpdate){var e=this._localBounds,t=this._texture.getFrame();e.x=-t.width*this._anchor.x,e.y=-t.height*this._anchor.y,e.width=t.width,e.height=t.height,this._localBoundsNeedUpdate=!1}return this._localBounds.clone()},t.prototype.getBounds=function(){if(this._boundsNeedUpdate){var e=this._bounds,t=this._texture.getFrame(),o=this._worldTransform,r=this._anchor,a=o.rectangleToCoordinates(t,r),n=a[0].x,l=a[0].y,s=n,d=l;a.forEach(function(e){var t=e.x,o=e.y;n=p(n,t),l=p(l,o),s=u(s,t),d=u(d,o)}),e.x=n,e.width=i(s-n),e.y=l,e.height=i(d-l),this._boundsNeedUpdate=!1}return this._bounds.clone()},t.prototype.getTexture=function(){return this._texture},t.prototype.setTexture=function(e){e&&(this._texture&&this._texture.off('update',this._onTextureUpdate),this._potRenderer&&this._potRenderer.getRenderTexture().getBaseTexture().setDirty(!0),this._texture=e,e.getBaseTexture().isLoaded()&&this._onTextureUpdate(),e.on('update',this._onTextureUpdate))},t.prototype.getShader=function(){return this._shader},t.prototype.setShader=function(e){this._shader=e},t.prototype.getWidth=function(){return this._width},t.prototype.setWidth=function(e){this._scale.x=e/this._texture.getFrame().width,this._width=e,this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},t.prototype.getHeight=function(){return this._height},t.prototype.setHeight=function(e){this._scale.y=e/this._texture.getFrame().height,this._height=e,this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},t.prototype.getDimensions=function(){return new f.Vector2(this._width,this._height)},t.prototype.getAnchor=function(){return this._anchor},t.prototype.setAnchor=function(e,t){e instanceof f.Vector2?this._anchor.copy(e):this._anchor.set(e,t),this._boundsNeedUpdate=!0,this._localBoundsNeedUpdate=!0},t.prototype.isSmoothDownscaling=function(){return this._smoothDownscaling},t.prototype.setSmoothDownscaling=function(e){this._smoothDownscaling=e},t.prototype.dispose=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=1<arguments.length&&void 0!==arguments[1]&&arguments[1];this._texture&&this._texture.off('update',this._onTextureUpdate),(e||t)&&this._texture.dispose(t),this._potRenderer&&this._potRenderer.dispose()},t}(g.default);t.default=m},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o(3),n=function(){function e(){(0,a.default)(this,e),this._container=new i.Engine.Container,this._sprite=new i.Engine.Sprite,this._container.addChild(this._sprite)}return e.prototype.render=function(e,t,o){var r=o.getDimensions(),a=this._getNextHighestPOT(r);this._renderTexture?this._renderTexture.resizeTo(a):this._renderTexture=new i.Engine.RenderTexture(e,a.x,a.y);var n=this._renderTexture.getDimensions();this._sprite.setTexture(o),this._sprite.updateTransform(),this._renderTexture.render(this._container),this._updateSprite(e,t,r,n)},e.prototype._updateSprite=function(e,t,o){t.setTexture(this._renderTexture),this._renderTexture.setFrame(new i.Rectangle(0,0,o.x,o.y))},e.prototype._getNextHighestPOT=function(e){return new i.Vector2(i.Utils.nextHighestPOT(e.x),i.Utils.nextHighestPOT(e.y))},e.prototype.getRenderTexture=function(){return this._renderTexture},e.prototype.dispose=function(){this._renderTexture.dispose(),this._renderTexture=null},e}();t.default=n},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(62),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default={TextureShader:a.default}},function(e,t,o){function r(e,t){this._id=e,this._clearFn=t}var a=Function.prototype.apply;t.setTimeout=function(){return new r(a.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new r(a.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;0<=t&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},o(161),t.setImmediate=setImmediate,t.clearImmediate=clearImmediate},function(e,t,o){(function(e,t){(function(e){'use strict';function o(e){'function'!=typeof e&&(e=new Function(''+e));for(var t=Array(arguments.length-1),o=0;o<t.length;o++)t[o]=arguments[o+1];var r={callback:e,args:t};return f[_]=r,h(_),_++}function r(e){delete f[e]}function a(e){var t=e.callback,o=e.args;switch(o.length){case 0:t();break;case 1:t(o[0]);break;case 2:t(o[0],o[1]);break;case 3:t(o[0],o[1],o[2]);break;default:t.apply(void 0,o);}}function i(e){if(c)setTimeout(i,0,e);else{var t=f[e];if(t){c=!0;try{a(t)}finally{r(e),c=!1}}}}function n(){h=function(e){t.nextTick(function(){i(e)})}}function l(){if(e.postMessage&&!e.importScripts){var t=!0,o=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage('','*'),e.onmessage=o,t}}function s(){var t='setImmediate$'+Math.random()+'$',o=function(o){o.source===e&&'string'==typeof o.data&&0===o.data.indexOf(t)&&i(+o.data.slice(t.length))};e.addEventListener?e.addEventListener('message',o,!1):e.attachEvent('onmessage',o),h=function(o){e.postMessage(t+o,'*')}}function d(){var e=new MessageChannel;e.port1.onmessage=function(e){var t=e.data;i(t)},h=function(t){e.port2.postMessage(t)}}function p(){var e=g.documentElement;h=function(t){var o=g.createElement('script');o.onreadystatechange=function(){i(t),o.onreadystatechange=null,e.removeChild(o),o=null},e.appendChild(o)}}function u(){h=function(e){setTimeout(i,0,e)}}if(!e.setImmediate){var _=1,f={},c=!1,g=e.document,y=Object.getPrototypeOf&&Object.getPrototypeOf(e),h;y=y&&y.setTimeout?y:e,'[object process]'==={}.toString.call(e.process)?n():l()?s():e.MessageChannel?d():g&&'onreadystatechange'in g.createElement('script')?p():u(),y.setImmediate=o,y.clearImmediate=r}})('undefined'==typeof self?'undefined'==typeof e?this:e:self)}).call(t,o(39),o(60))},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(163);Object.defineProperty(t,'UnpremultiplyFilter',{enumerable:!0,get:function(){return r(a).default}});var i=o(165);Object.defineProperty(t,'ColorOverlayFilter',{enumerable:!0,get:function(){return r(i).default}});var n=o(167);Object.defineProperty(t,'TintFilter',{enumerable:!0,get:function(){return r(n).default}});var l=o(169);Object.defineProperty(t,'OverlayFilter',{enumerable:!0,get:function(){return r(l).default}})},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(33),u=r(p),_=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(164),r}return(0,d.default)(t,e),t}(u.default);t.default=_},function(e){e.exports='uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nvarying vec4 v_color;\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(color.a > 0. ? color.rgb / color.a : vec3(0), color.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(33),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(166),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),n=t.getContext(),l=o.getContext(),s=this._options.color,d=n.getImageData(0,0,a.width,a.height),u=l.getImageData(0,0,a.width,a.height),_=a.width*a.height,f=new p.Color,c=new p.Color,g=0;g<4*_;g+=4){f.set(d.data[g]/255,d.data[g+1]/255,d.data[g+2]/255,d.data[g+3]/255),c.set(u.data[g]/255,u.data[g+1]/255,u.data[g+2]/255,u.data[g+3]/255);var i=c.r+f.a*(f.r-c.r);u.data[g]=255*(i+f.a*(s.r-i));var y=c.g+f.a*(f.g-c.g);u.data[g+1]=255*(y+f.a*(s.g-y));var h=c.b+f.a*(f.b-c.b);u.data[g+2]=255*(h+f.a*(s.b-h))}l.putImageData(u,0,0)},t}(_.default);g.prototype.availableOptions={color:{type:f.COLOR,default:p.Color.WHITE,uniformType:c.FLOAT4}},t.default=g},function(e){e.exports='uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform vec4 u_color;\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(mix(color.rgb, u_color.rgb, u_color.a), color.a) * color.a;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(6),u=o(33),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(168),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,o,n){var l=3<arguments.length&&void 0!==arguments[3]&&arguments[3],s=o.getCanvas(),d=o.getContext(),u=n.getContext(),_=d.getImageData(0,0,s.width,s.height),f=this._options,c=f.mode,y=f.color,h=y.r,r=y.g,g=y.b,m=y.a,a=[0.2125,0.7154,0.0721];switch(c){case t.MODES.SOLID:for(var x=0,i;x<s.width*s.height;x++)i=4*x,_.data[i]+=(255*h-_.data[i])*m,_.data[i+1]+=(255*r-_.data[i+1])*m,_.data[i+2]+=(255*g-_.data[i+2])*m;break;case t.MODES.COLORIZED:for(var T=0;T<s.width*s.height;T++){var v=4*T,b=_.data[v]/255*a[0]+_.data[v+1]/255*a[1]+_.data[v+2]/255*a[2],C=new p.Color(b*h,b*r,b*g);_.data[v]+=(255*C.r-_.data[v])*m,_.data[v+1]+=(255*C.g-_.data[v+1])*m,_.data[v+2]+=(255*C.b-_.data[v+2])*m}}u.putImageData(_,0,0)},t}(_.default);g.MODES={NONE:0,SOLID:1,COLORIZED:2},g.prototype.availableOptions={color:{type:f.COLOR,default:p.Color.WHITE,uniformType:c.FLOAT4},mode:{type:f.NUMBER,default:g.MODES.NONE,uniformType:c.INT}},t.default=g},function(e){e.exports='uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform vec4 u_color;\nuniform int u_mode;\n\nvec3 W = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  if (u_mode == 0) {\n    gl_FragColor = color * color.a;\n  } else if (u_mode == 1) {\n    gl_FragColor = vec4(mix(color.rgb, u_color.rgb, u_color.a), color.a) * color.a;\n  } else if (u_mode == 2) {\n    float luminance = dot(color.rgb, W);\n    vec3 colorized = vec3(luminance) * u_color.rgb;\n    gl_FragColor = vec4(mix(color.rgb, colorized, u_color.a), color.a) * color.a;\n  }\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),l=o(1),s=r(l),d=o(2),_=r(d),f=o(6),c=o(33),g=r(c),y=f.Constants.OptionType,h=f.Constants.UniformType,m=1e-6,x=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var l=(0,s.default)(this,e.call.apply(e,[this].concat(a)));return l._fragmentSource=o(170),l._lastImage=null,l}return(0,_.default)(t,e),t.prototype._applyCanvas=function(e,o,r){for(var a=3<arguments.length&&void 0!==arguments[3]&&arguments[3],l=this._options.overlayTexture.getRenderTarget().getContext(),s=o.getCanvas(),d=o.getContext(),_=r.getContext(),c=d.getImageData(0,0,s.width,s.height),g=l.getImageData(0,0,s.width,s.height),y=this._options,h=y.blendMode,x=y.alpha,T=new f.Color,v=new f.Color,b=new f.Color,C=0;C<4*(s.width*s.height);C+=4){T.set(c.data[C]/255,c.data[C+1]/255,c.data[C+2]/255,c.data[C+3]/255),v.set(g.data[C]/255,g.data[C+1]/255,g.data[C+2]/255,g.data[C+3]/255);var i=void 0,R=void 0,O=void 0,E=void 0,S=void 0,F=void 0,M=void 0,k=void 0,P=void 0;h===t.BLEND_MODES.NORMAL?b.set(T.r+v.a*x*(v.r-T.r),T.g+v.a*x*(v.g-T.g),T.b+v.a*x*(v.b-T.b),T.a):h===t.BLEND_MODES.OVERLAY?(i=1-2*(1-T.r)*(1-v.r),R=2*T.r*v.r,O=i+(0.5>T.r?1:0)*(R-i),E=1-2*(1-T.g)*(1-v.g),S=2*T.g*v.g,F=E+(0.5>T.g?1:0)*(S-E),M=1-2*(1-T.b)*(1-v.b),k=2*T.b*v.b,P=M+(0.5>T.b?1:0)*(k-M),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.HARD_LIGHT?(i=1-2*(1-v.r)*(1-T.r),R=2*v.r*T.r,O=i+(0.5>v.r?1:0)*(R-i),E=1-2*(1-v.g)*(1-T.g),S=2*v.g*T.g,F=E+(0.5>v.g?1:0)*(S-E),M=1-2*(1-v.b)*(1-T.b),k=2*v.b*T.b,P=M+(0.5>v.b?1:0)*(k-M),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.SOFT_LIGHT?(i=2*T.r*(1-v.r)+(2*v.r-1)*n(T.r),R=2*T.r*v.r+T.r*T.r*(1-2*v.r),O=i+(0.5>v.r?1:0)*(R-i),E=2*T.g*(1-v.g)+(2*v.g-1)*n(T.g),S=2*T.g*v.g+T.g*T.g*(1-2*v.g),F=E+(0.5>v.g?1:0)*(S-E),M=2*T.b*(1-v.b)+(2*v.b-1)*n(T.b),k=2*T.b*v.b+T.b*T.b*(1-2*v.b),P=M+(0.5>v.b?1:0)*(k-M),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.MULTIPLY?(O=T.r*v.r,F=T.g*v.g,P=T.b*v.b,b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.DARKEN?(O=p(T.r,v.r),F=p(T.g,v.g),P=p(T.b,v.b),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.LIGHTEN?(O=u(T.r,v.r),F=u(T.g,v.g),P=u(T.b,v.b),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.SCREEN?(O=1-(1-T.r)*(1-v.r),F=1-(1-T.g)*(1-v.g),P=1-(1-T.b)*(1-v.b),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):h===t.BLEND_MODES.COLOR_BURN?(O=u(0,p(1,1-(1-T.r)/u(v.r,m))),F=u(0,p(1,1-(1-T.g)/u(v.g,m))),P=u(0,p(1,1-(1-T.b)/u(v.b,m))),b.set(T.r+v.a*x*(O-T.r),T.g+v.a*x*(F-T.g),T.b+v.a*x*(P-T.b),T.a)):void 0,c.data[C]=255*b.r,c.data[C+1]=255*b.g,c.data[C+2]=255*b.b,c.data[C+3]=255*b.a}_.putImageData(c,0,0)},t}(g.default);x.BLEND_MODES={NORMAL:0,OVERLAY:1,HARD_LIGHT:2,SOFT_LIGHT:3,MULTIPLY:4,DARKEN:5,LIGHTEN:6,SCREEN:7,COLOR_BURN:8},x.prototype.availableOptions={blendMode:{type:y.NUMBER,default:x.BLEND_MODES.NORMAL,uniformType:h.INT},overlayImage:{type:y.NUMBER,required:!0,uniformType:h.SAMPLER2D},overlayTexture:{type:y.OBJECT,required:!0},alpha:{type:y.NUMBER,default:1,uniformType:h.FLOAT}},t.default=x},function(e){e.exports='uniform sampler2D u_image;\nvarying vec2 v_texCoord;\nuniform sampler2D u_overlayImage;\nuniform int u_blendMode;\nuniform float u_alpha;\n\nconst float EPSILON = 0.000001;\n\nvec4 overlay(vec4 a, vec4 b) {\n    vec3 result = mix(\n          1.0 - 2.0 * (1.0 - a.rgb) * (1.0 - b.rgb),\n          2.0 * a.rgb * b.rgb,\n          vec3(a.r < 0.5, a.g < 0.5, a.b < 0.5)\n      );\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 hardLight(vec4 b, vec4 a) {\n    vec3 result = mix(\n          1.0 - 2.0 * (1.0 - a.rgb) * (1.0 - b.rgb),\n          2.0 * a.rgb * b.rgb,\n          vec3(a.r < 0.5, a.g < 0.5, a.b < 0.5)\n      );\n    return mix(b, vec4(result, b.a), u_alpha * a.a);\n}\n\nvec4 softLight(vec4 a, vec4 b) {\n    vec3 result = mix(\n          2.0 * a.rgb * (1.0 - b.rgb) + (2.0 * b.rgb - 1.0) * sqrt(a.rgb),\n          2.0 * a.rgb * b.rgb + a.rgb * a.rgb * (1.0 - 2.0 * b.rgb),\n          vec3(b.r < 0.5, b.g < 0.5, b.b < 0.5)\n      );\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 multiply(vec4 a, vec4 b) {\n    vec3 result = a.rgb * b.rgb;\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 darken(vec4 a, vec4 b) {\n    vec3 result = min(a.rgb, b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 lighten(vec4 a, vec4 b) {\n    vec3 result = max(a.rgb, b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 screen(vec4 a, vec4 b) {\n    vec3 result = 1.0 - (1.0 - a.rgb) * (1.0 - b.rgb);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 colorBurn(vec4 a, vec4 b) {\n    vec3 result = clamp(1.0 - (1.0 - a.rgb) / max(b.rgb, EPSILON), 0.0, 1.0);\n    return mix(a, vec4(result, a.a), u_alpha * b.a);\n}\n\nvec4 normal(vec4 a, vec4 b) {\n    return mix(a, vec4(b.rgb, a.a), 1.0);\n}\n\nvoid main() {\n  vec4 color = texture2D(u_image, v_texCoord);\n  vec4 overlayColor = texture2D(u_overlayImage, v_texCoord);\n\n  vec4 resultColor;\n  if (u_blendMode == 0) {\n    resultColor = normal(color, overlayColor);\n  } else if (u_blendMode == 1) {\n    resultColor = overlay(color, overlayColor);\n  } else if (u_blendMode == 2) {\n    resultColor = hardLight(color, overlayColor);\n  } else if (u_blendMode == 3) {\n    resultColor = softLight(color, overlayColor);\n  } else if (u_blendMode == 4) {\n    resultColor = multiply(color, overlayColor);\n  } else if (u_blendMode == 5) {\n    resultColor = darken(color, overlayColor);\n  } else if (u_blendMode == 6) {\n    resultColor = lighten(color, overlayColor);\n  } else if (u_blendMode == 7) {\n    resultColor = screen(color, overlayColor);\n  } else if (u_blendMode == 8) {\n    resultColor = colorBurn(color, overlayColor);\n  }\n  gl_FragColor = vec4(resultColor.rgb * resultColor.a, resultColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}function a(e){return e.map(function(e){return('0'+(255&e).toString(16)).slice(-2)}).join('')}Object.defineProperty(t,'__esModule',{value:!0});var i=o(0),n=r(i),s=o(26),d=r(s),p=o(172),u=r(p),_=o(31),f=r(_),c=o(173),g=r(c),y=o(181),h=function(e){return d.default.byteArrayToString(f.default.decode(e))},m='YXBwX2lkZW50aWZpZXJz',x='ZXhwaXJlc19hdA==',T='c2lnbmF0dXJl',v=function(){function e(t){(0,n.default)(this,e),this._version='2.0',this._l=t,this._e=this._parseBigInt('65537',10),this._n=this._parseBigInt('681984042382424091378806337544846672160292647422517223678775230983366046720611873368204040735766698395282492937192783016867164773742859209434481353888637963692711665138989982680829529436715362566735813634679619274059040232728883894511099669775400556584329435375723951309340934658571478665059403241851229195311069345899870108307225910988692123234379186643268583453907260879685992156955936561142314233983397819356937109343127504441076920088455337597736475086676246750168976219763398350254797168313954762459542746440628077261880980924552698138857743609502132632199713575442848784271304503226045319991689413234228439044522583790713890093165912455428688507463773064216328753265963237930998706891042679105987175588970202082466871461192706070321938250462103821558100761330890228135620208935801286878657384108721268761878694436895194628411397454202904351577771506916746612289964053490210990342857409030179406810634136188751670648983222653319056818302012063874664196648868156305696644664362171542503665321455971335955948698828939948786720193132672749776162913092000667953299803216404664087988046584107737900256954976744353601826341965438148646041640662195744770544094748295945844184507459808803114917301124088082458306086473490516969815873631',10),this._parseLicense()}return e.prototype.v=function(){return this._sigValid()&&!this.isExp()},e.prototype._hostnameValid=function(){if('undefined'==typeof window)return!0;if(!this._decLic[h(m)].length)return!0;var e=window.location.hostname,t=!1;return this._decLic[h(m)].forEach(function(o){d.default.wildCardMatch(e,o)&&(t=!0)}),t},e.prototype.c=function(){var e=this;return new Promise(function(t,o){if(!e._sigValid()){var r=new Error;return r.code='ELICINV',o(r)}if(!e._hostnameValid()){var a=new Error;return a.code='ELICINVHOST',o(a)}if(e.isExp()){var i=new Error;return i.code='ELICEXP',o(i)}t()})},e.prototype.isToolAllowed=function(e){return-1!==this._decLic[h('ZmVhdHVyZXM=')].indexOf(e)},e.prototype.t=function(){if(this._decLic.enterprise_license)return Promise.resolve();var e=this._decLic[h('ZG9tYWlucw==')][0]+h(h('TDNSeVlXTnJQMkZ3YVV0bGVUMD0='))+this._decLic[h('YXBpX3Rva2Vu')],t=new g.default(e);return t.load()},e.prototype.isENT=function(){return this._decLic[h('ZW50ZXJwcmlzZV9saWNlbnNl')]},e.prototype._sigValid=function(){return this._verify(this._message,this._sig)},e.prototype.exp=function(){return!!this._decLic[h(x)]},e.prototype.dl=function(){return l((this._expAt()-Date.now())/86400000)},e.prototype.isExp=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:Date.now();return null!==this._decLic[h(x)]&&e>this._expAt()},e.prototype._expAt=function(){return 1e3*this._decLic[h(x)]},e.prototype._verify=function(e,t){var o,r;r=this._encodeMessage(e),o=this._decodeSignature(t),o=o.substr(-64);var a=r===o;return a},e.prototype._encodeMessage=function(e){var t=(0,y.sha256)(e);return t},e.prototype._decodeSignature=function(e){var t;return e=f.default.decode(e),e=a(e),e=this._parseBigInt(e,16),t=e.modPowInt(this._e,this._n),t=t.toString(16),t},e.prototype._parseBigInt=function(e,t){return new u.default(e,t)},e.prototype._parseLicense=function(){this._decLic=JSON.parse(this._l),this._sig=this._decLic[h(T)],delete this._decLic[h(T)],this._sig=this._sig.replace(/[^A-Za-z0-9+/=]/g,''),this._message=this._l.replace(new RegExp(',"'+h(T)+'":"([^"]*)"'),'')},e}();t.default=v},function(t,o){'use strict';function l(e,t,o){null!=e&&('number'==typeof e?this.fromNumber(e,t,o):null==t&&'string'!=typeof e?this.fromString(e,256):this.fromString(e,t))}function s(){return new l(null)}function a(e){return E.charAt(e)}function r(e,t){var o=S[e.charCodeAt(t)];return null==o?-1:o}function _(e){var t=s();return t.fromInt(e),t}function f(e){var o=1,r;return 0!=(r=e>>>16)&&(e=r,o+=16),0!=(r=e>>8)&&(e=r,o+=8),0!=(r=e>>4)&&(e=r,o+=4),0!=(r=e>>2)&&(e=r,o+=2),0!=(r=e>>1)&&(e=r,o+=1),o}function c(e){this.m=e}function y(e){this.m=e,this.mp=e.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<e.DB-15)-1,this.mt2=2*e.t}function i(e,t){return e&t}function g(e,t){return e|t}function h(e,t){return e^t}function m(e,t){return e&~t}function n(e){if(0==e)return-1;var t=0;return 0==(65535&e)&&(e>>=16,t+=16),0==(255&e)&&(e>>=8,t+=8),0==(15&e)&&(e>>=4,t+=4),0==(3&e)&&(e>>=2,t+=2),0==(1&e)&&++t,t}function T(e){for(var t=0;0!=e;)e&=e-1,++t;return t}function x(){}function v(e){return e}function b(e){this.r2=s(),this.q3=s(),l.ONE.dlShiftTo(2*e.t,this.r2),this.mu=this.r2.divide(e),this.m=e}Object.defineProperty(o,'__esModule',{value:!0});/*!
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */var C=C||{},R;'Microsoft Internet Explorer'==C.appName?(l.prototype.am=function(e,t,o,r,a,i){for(var n=32767&t,s=t>>15;0<=--i;){var d=32767&this[e],l=this[e++]>>15,p=s*d+l*n;d=n*d+((32767&p)<<15)+o[r]+(1073741823&a),a=(d>>>30)+(p>>>15)+s*l+(a>>>30),o[r++]=1073741823&d}return a},R=30):'Netscape'!=C.appName?(l.prototype.am=function(e,t,o,r,a,i){for(;0<=--i;){var n=t*this[e++]+o[r]+a;a=d(n/67108864),o[r++]=67108863&n}return a},R=26):(l.prototype.am=function(e,t,o,r,a,i){for(var n=16383&t,s=t>>14;0<=--i;){var d=16383&this[e],l=this[e++]>>14,p=s*d+l*n;d=n*d+((16383&p)<<14)+o[r]+a,a=(d>>28)+(p>>14)+s*l,o[r++]=268435455&d}return a},R=28),l.prototype.DB=R,l.prototype.DM=(1<<R)-1,l.prototype.DV=1<<R;var O=52;l.prototype.FV=4503599627370496,l.prototype.F1=O-R,l.prototype.F2=2*R-O;var E='0123456789abcdefghijklmnopqrstuvwxyz',S=[],F,M;for(F=48,M=0;9>=M;++M)S[F++]=M;for(F=97,M=10;36>M;++M)S[F++]=M;for(F=65,M=10;36>M;++M)S[F++]=M;c.prototype.convert=function(e){return 0>e.s||0<=e.compareTo(this.m)?e.mod(this.m):e},c.prototype.revert=function(e){return e},c.prototype.reduce=function(e){e.divRemTo(this.m,null,e)},c.prototype.mulTo=function(e,t,o){e.multiplyTo(t,o),this.reduce(o)},c.prototype.sqrTo=function(e,t){e.squareTo(t),this.reduce(t)},y.prototype.convert=function(e){var t=s();return e.abs().dlShiftTo(this.m.t,t),t.divRemTo(this.m,null,t),0>e.s&&0<t.compareTo(l.ZERO)&&this.m.subTo(t,t),t},y.prototype.revert=function(e){var t=s();return e.copyTo(t),this.reduce(t),t},y.prototype.reduce=function(e){for(;e.t<=this.mt2;)e[e.t++]=0;for(var t=0;t<this.m.t;++t){var o=32767&e[t],r=o*this.mpl+((o*this.mph+(e[t]>>15)*this.mpl&this.um)<<15)&e.DM;for(o=t+this.m.t,e[o]+=this.m.am(0,r,e,t,0,this.m.t);e[o]>=e.DV;)e[o]-=e.DV,e[++o]++}e.clamp(),e.drShiftTo(this.m.t,e),0<=e.compareTo(this.m)&&e.subTo(this.m,e)},y.prototype.mulTo=function(e,t,o){e.multiplyTo(t,o),this.reduce(o)},y.prototype.sqrTo=function(e,t){e.squareTo(t),this.reduce(t)},l.prototype.copyTo=function(e){for(var t=this.t-1;0<=t;--t)e[t]=this[t];e.t=this.t,e.s=this.s},l.prototype.fromInt=function(e){this.t=1,this.s=0>e?-1:0,0<e?this[0]=e:-1>e?this[0]=e+this.DV:this.t=0},l.prototype.fromString=function(e,t){var o;if(16==t)o=4;else if(8==t)o=3;else if(256==t)o=8;else if(2==t)o=1;else if(32==t)o=5;else if(4==t)o=2;else return void this.fromRadix(e,t);this.t=0,this.s=0;for(var a=e.length,i=!1,n=0;0<=--a;){var s=8==o?255&e[a]:r(e,a);if(0>s){'-'==e.charAt(a)&&(i=!0);continue}i=!1,0==n?this[this.t++]=s:n+o>this.DB?(this[this.t-1]|=(s&(1<<this.DB-n)-1)<<n,this[this.t++]=s>>this.DB-n):this[this.t-1]|=s<<n,n+=o,n>=this.DB&&(n-=this.DB)}8==o&&0!=(128&e[0])&&(this.s=-1,0<n&&(this[this.t-1]|=(1<<this.DB-n)-1<<n)),this.clamp(),i&&l.ZERO.subTo(this,this)},l.prototype.clamp=function(){for(var e=this.s&this.DM;0<this.t&&this[this.t-1]==e;)--this.t},l.prototype.dlShiftTo=function(e,t){var o;for(o=this.t-1;0<=o;--o)t[o+e]=this[o];for(o=e-1;0<=o;--o)t[o]=0;t.t=this.t+e,t.s=this.s},l.prototype.drShiftTo=function(e,t){for(var o=e;o<this.t;++o)t[o-e]=this[o];t.t=u(this.t-e,0),t.s=this.s},l.prototype.lShiftTo=function(e,t){var o=e%this.DB,r=this.DB-o,a=d(e/this.DB),n=this.s<<o&this.DM,l;for(l=this.t-1;0<=l;--l)t[l+a+1]=this[l]>>r|n,n=(this[l]&(1<<r)-1)<<o;for(l=a-1;0<=l;--l)t[l]=0;t[a]=n,t.t=this.t+a+1,t.s=this.s,t.clamp()},l.prototype.rShiftTo=function(e,t){t.s=this.s;var o=d(e/this.DB);if(o>=this.t)return void(t.t=0);var r=e%this.DB,a=this.DB-r,n=(1<<r)-1;t[0]=this[o]>>r;for(var l=o+1;l<this.t;++l)t[l-o-1]|=(this[l]&n)<<a,t[l-o]=this[l]>>r;0<r&&(t[this.t-o-1]|=(this.s&n)<<a),t.t=this.t-o,t.clamp()},l.prototype.subTo=function(e,t){for(var o=0,r=0,a=p(e.t,this.t);o<a;)r+=this[o]-e[o],t[o++]=r&this.DM,r>>=this.DB;if(e.t<this.t){for(r-=e.s;o<this.t;)r+=this[o],t[o++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;o<e.t;)r-=e[o],t[o++]=r&this.DM,r>>=this.DB;r-=e.s}t.s=0>r?-1:0,-1>r?t[o++]=this.DV+r:0<r&&(t[o++]=r),t.t=o,t.clamp()},l.prototype.multiplyTo=function(e,t){var o=this.abs(),r=e.abs(),a=o.t;for(t.t=a+r.t;0<=--a;)t[a]=0;for(a=0;a<r.t;++a)t[a+o.t]=o.am(0,r[a],t,a,0,o.t);t.s=0,t.clamp(),this.s!=e.s&&l.ZERO.subTo(t,t)},l.prototype.squareTo=function(e){for(var t=this.abs(),o=e.t=2*t.t;0<=--o;)e[o]=0;for(o=0;o<t.t-1;++o){var r=t.am(o,t[o],e,2*o,0,1);(e[o+t.t]+=t.am(o+1,2*t[o],e,2*o+1,r,t.t-o-1))>=t.DV&&(e[o+t.t]-=t.DV,e[o+t.t+1]=1)}0<e.t&&(e[e.t-1]+=t.am(o,t[o],e,2*o,0,1)),e.s=0,e.clamp()},l.prototype.divRemTo=function(o,a,n){var r=o.abs();if(!(0>=r.t)){var p=this.abs();if(p.t<r.t)return null!=a&&a.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=s());var u=s(),_=this.s,c=o.s,g=this.DB-f(r[r.t-1]);0<g?(r.lShiftTo(g,u),p.lShiftTo(g,n)):(r.copyTo(u),p.copyTo(n));var y=u.t,h=u[y-1];if(0!=h){var m=h*(1<<this.F1)+(1<y?u[y-2]>>this.F2:0),x=this.FV/m,T=(1<<this.F1)/m,v=1<<this.F2,e=n.t,i=e-y,b=null==a?s():a;for(u.dlShiftTo(i,b),0<=n.compareTo(b)&&(n[n.t++]=1,n.subTo(b,n)),l.ONE.dlShiftTo(y,b),b.subTo(u,u);u.t<y;)u[u.t++]=0;for(;0<=--i;){var t=n[--e]==h?this.DM:d(n[e]*x+(n[e-1]+v)*T);if((n[e]+=u.am(0,t,n,i,0,y))<t)for(u.dlShiftTo(i,b),n.subTo(b,n);n[e]<--t;)n.subTo(b,n)}null!=a&&(n.drShiftTo(y,a),_!=c&&l.ZERO.subTo(a,a)),n.t=y,n.clamp(),0<g&&n.rShiftTo(g,n),0>_&&l.ZERO.subTo(n,n)}}},l.prototype.invDigit=function(){if(1>this.t)return 0;var e=this[0];if(0==(1&e))return 0;var t=3&e;return t=15&t*(2-(15&e)*t),t=255&t*(2-(255&e)*t),t=65535&t*(2-(65535&(65535&e)*t)),t=t*(2-e*t%this.DV)%this.DV,0<t?this.DV-t:-t},l.prototype.isEven=function(){return 0==(0<this.t?1&this[0]:this.s)},l.prototype.exp=function(o,e){if(4294967295<o||1>o)return l.ONE;var a=s(),r=s(),n=e.convert(this),d=f(o)-1;for(n.copyTo(a);0<=--d;)if(e.sqrTo(a,r),0<(o&1<<d))e.mulTo(r,n,a);else{var i=a;a=r,r=i}return e.revert(a)},l.prototype.toString=function(e){if(0>this.s)return'-'+this.negate().toString(e);var t;if(16==e)t=4;else if(8==e)t=3;else if(2==e)t=1;else if(32==e)t=5;else if(4==e)t=2;else return this.toRadix(e);var o=(1<<t)-1,n=!1,l='',r=this.t,i=this.DB-r*this.DB%t,s;if(0<r--)for(i<this.DB&&0<(s=this[r]>>i)&&(n=!0,l=a(s));0<=r;)i<t?(s=(this[r]&(1<<i)-1)<<t-i,s|=this[--r]>>(i+=this.DB-t)):(s=this[r]>>(i-=t)&o,0>=i&&(i+=this.DB,--r)),0<s&&(n=!0),n&&(l+=a(s));return n?l:'0'},l.prototype.negate=function(){var e=s();return l.ZERO.subTo(this,e),e},l.prototype.abs=function(){return 0>this.s?this.negate():this},l.prototype.compareTo=function(e){var t=this.s-e.s;if(0!=t)return t;var o=this.t;if(t=o-e.t,0!=t)return 0>this.s?-t:t;for(;0<=--o;)if(0!=(t=this[o]-e[o]))return t;return 0},l.prototype.bitLength=function(){return 0>=this.t?0:this.DB*(this.t-1)+f(this[this.t-1]^this.s&this.DM)},l.prototype.mod=function(e){var t=s();return this.abs().divRemTo(e,null,t),0>this.s&&0<t.compareTo(l.ZERO)&&e.subTo(t,t),t},l.prototype.modPowInt=function(t,e){var o;return o=256>t||e.isEven()?new c(e):new y(e),this.exp(t,o)},l.ZERO=_(0),l.ONE=_(1),x.prototype.convert=v,x.prototype.revert=v,x.prototype.mulTo=function(e,t,o){e.multiplyTo(t,o)},x.prototype.sqrTo=function(e,t){e.squareTo(t)},b.prototype.convert=function(e){if(0>e.s||e.t>2*this.m.t)return e.mod(this.m);if(0>e.compareTo(this.m))return e;var t=s();return e.copyTo(t),this.reduce(t),t},b.prototype.revert=function(e){return e},b.prototype.reduce=function(e){for(e.drShiftTo(this.m.t-1,this.r2),e.t>this.m.t+1&&(e.t=this.m.t+1,e.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);0>e.compareTo(this.r2);)e.dAddOffset(1,this.m.t+1);for(e.subTo(this.r2,e);0<=e.compareTo(this.m);)e.subTo(this.m,e)},b.prototype.mulTo=function(e,t,o){e.multiplyTo(t,o),this.reduce(o)},b.prototype.sqrTo=function(e,t){e.squareTo(t),this.reduce(t)};var P=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],k=67108864/P[P.length-1];l.prototype.chunkSize=function(e){return d(Math.LN2*this.DB/Math.log(e))},l.prototype.toRadix=function(t){if(null==t&&(t=10),0==this.signum()||2>t||36<t)return'0';var o=this.chunkSize(t),i=e(t,o),a=_(i),n=s(),l=s(),d='';for(this.divRemTo(a,n,l);0<n.signum();)d=(i+l.intValue()).toString(t).substr(1)+d,n.divRemTo(a,n,l);return l.intValue().toString(t)+d},l.prototype.fromRadix=function(t,o){this.fromInt(0),null==o&&(o=10);for(var a=this.chunkSize(o),n=e(o,a),s=!1,d=0,p=0,u=0,i;u<t.length;++u){if(i=r(t,u),0>i){'-'==t.charAt(u)&&0==this.signum()&&(s=!0);continue}p=o*p+i,++d>=a&&(this.dMultiply(n),this.dAddOffset(p,0),d=0,p=0)}0<d&&(this.dMultiply(e(o,d)),this.dAddOffset(p,0)),s&&l.ZERO.subTo(this,this)},l.prototype.fromNumber=function(e,o,r){if(!('number'==typeof o)){var a=[],i=7&e;a.length=(e>>3)+1,o.nextBytes(a),0<i?a[0]&=(1<<i)-1:a[0]=0,this.fromString(a,256)}else if(2>e)this.fromInt(1);else for(this.fromNumber(e,r),this.testBit(e-1)||this.bitwiseTo(l.ONE.shiftLeft(e-1),g,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(o);)this.dAddOffset(2,0),this.bitLength()>e&&this.subTo(l.ONE.shiftLeft(e-1),this)},l.prototype.bitwiseTo=function(e,t,o){var r=p(e.t,this.t),a,i;for(a=0;a<r;++a)o[a]=t(this[a],e[a]);if(e.t<this.t){for(i=e.s&this.DM,a=r;a<this.t;++a)o[a]=t(this[a],i);o.t=this.t}else{for(i=this.s&this.DM,a=r;a<e.t;++a)o[a]=t(i,e[a]);o.t=e.t}o.s=t(this.s,e.s),o.clamp()},l.prototype.changeBit=function(e,t){var o=l.ONE.shiftLeft(e);return this.bitwiseTo(o,t,o),o},l.prototype.addTo=function(e,t){for(var o=0,r=0,a=p(e.t,this.t);o<a;)r+=this[o]+e[o],t[o++]=r&this.DM,r>>=this.DB;if(e.t<this.t){for(r+=e.s;o<this.t;)r+=this[o],t[o++]=r&this.DM,r>>=this.DB;r+=this.s}else{for(r+=this.s;o<e.t;)r+=e[o],t[o++]=r&this.DM,r>>=this.DB;r+=e.s}t.s=0>r?-1:0,0<r?t[o++]=r:-1>r&&(t[o++]=this.DV+r),t.t=o,t.clamp()},l.prototype.dMultiply=function(e){this[this.t]=this.am(0,e-1,this,0,0,this.t),++this.t,this.clamp()},l.prototype.dAddOffset=function(e,t){if(0!=e){for(;this.t<=t;)this[this.t++]=0;for(this[t]+=e;this[t]>=this.DV;)this[t]-=this.DV,++t>=this.t&&(this[this.t++]=0),++this[t]}},l.prototype.multiplyLowerTo=function(e,t,o){var r=p(this.t+e.t,t);for(o.s=0,o.t=r;0<r;)o[--r]=0;var a;for(a=o.t-this.t;r<a;++r)o[r+this.t]=this.am(0,e[r],o,r,0,this.t);for(a=p(e.t,t);r<a;++r)this.am(0,e[r],o,r,0,t-r);o.clamp()},l.prototype.multiplyUpperTo=function(e,t,o){--t;var r=o.t=this.t+e.t-t;for(o.s=0;0<=--r;)o[r]=0;for(r=u(t-this.t,0);r<e.t;++r)o[this.t+r-t]=this.am(t-r,e[r],o,0,0,this.t+r-t);o.clamp(),o.drShiftTo(1,o)},l.prototype.modInt=function(e){if(0>=e)return 0;var t=this.DV%e,o=0>this.s?e-1:0;if(0<this.t)if(0==t)o=this[0]%e;else for(var r=this.t-1;0<=r;--r)o=(t*o+this[r])%e;return o},l.prototype.millerRabin=function(e){var t=this.subtract(l.ONE),o=t.getLowestSetBit();if(0>=o)return!1;var n=t.shiftRight(o);e=e+1>>1,e>P.length&&(e=P.length);for(var r=s(),a=0;a<e;++a){r.fromInt(P[d(Math.random()*P.length)]);var i=r.modPow(n,this);if(0!=i.compareTo(l.ONE)&&0!=i.compareTo(t)){for(var p=1;p++<o&&0!=i.compareTo(t);)if(i=i.modPowInt(2,this),0==i.compareTo(l.ONE))return!1;if(0!=i.compareTo(t))return!1}}return!0},l.prototype.clone=function(){var e=s();return this.copyTo(e),e},l.prototype.intValue=function(){if(0>this.s){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},l.prototype.byteValue=function(){return 0==this.t?this.s:this[0]<<24>>24},l.prototype.shortValue=function(){return 0==this.t?this.s:this[0]<<16>>16},l.prototype.signum=function(){return 0>this.s?-1:0>=this.t||1==this.t&&0>=this[0]?0:1},l.prototype.toByteArray=function(){var e=this.t,t=[];t[0]=this.s;var o=this.DB-e*this.DB%8,r=0,a;if(0<e--)for(o<this.DB&&(a=this[e]>>o)!=(this.s&this.DM)>>o&&(t[r++]=a|this.s<<this.DB-o);0<=e;)8>o?(a=(this[e]&(1<<o)-1)<<8-o,a|=this[--e]>>(o+=this.DB-8)):(a=255&this[e]>>(o-=8),0>=o&&(o+=this.DB,--e)),0!=(128&a)&&(a|=-256),0==r&&(128&this.s)!=(128&a)&&++r,(0<r||a!=this.s)&&(t[r++]=a);return t},l.prototype.equals=function(e){return 0==this.compareTo(e)},l.prototype.min=function(e){return 0>this.compareTo(e)?this:e},l.prototype.max=function(e){return 0<this.compareTo(e)?this:e},l.prototype.and=function(e){var t=s();return this.bitwiseTo(e,i,t),t},l.prototype.or=function(e){var t=s();return this.bitwiseTo(e,g,t),t},l.prototype.xor=function(e){var t=s();return this.bitwiseTo(e,h,t),t},l.prototype.andNot=function(e){var t=s();return this.bitwiseTo(e,m,t),t},l.prototype.not=function(){for(var e=s(),t=0;t<this.t;++t)e[t]=this.DM&~this[t];return e.t=this.t,e.s=~this.s,e},l.prototype.shiftLeft=function(e){var t=s();return 0>e?this.rShiftTo(-e,t):this.lShiftTo(e,t),t},l.prototype.shiftRight=function(e){var t=s();return 0>e?this.lShiftTo(-e,t):this.rShiftTo(e,t),t},l.prototype.getLowestSetBit=function(){for(var e=0;e<this.t;++e)if(0!=this[e])return e*this.DB+n(this[e]);return 0>this.s?this.t*this.DB:-1},l.prototype.bitCount=function(){for(var e=0,t=this.s&this.DM,o=0;o<this.t;++o)e+=T(this[o]^t);return e},l.prototype.testBit=function(e){var t=d(e/this.DB);return t>=this.t?0!=this.s:0!=(this[t]&1<<e%this.DB)},l.prototype.setBit=function(e){return this.changeBit(e,g)},l.prototype.clearBit=function(e){return this.changeBit(e,m)},l.prototype.flipBit=function(e){return this.changeBit(e,h)},l.prototype.add=function(e){var t=s();return this.addTo(e,t),t},l.prototype.subtract=function(e){var t=s();return this.subTo(e,t),t},l.prototype.multiply=function(e){var t=s();return this.multiplyTo(e,t),t},l.prototype.divide=function(e){var t=s();return this.divRemTo(e,t,null),t},l.prototype.remainder=function(e){var t=s();return this.divRemTo(e,null,t),t},l.prototype.divideAndRemainder=function(e){var t=s(),o=s();return this.divRemTo(e,t,o),[t,o]},l.prototype.modPow=function(o,e){var a=o.bitLength(),i=_(1),r,l;if(0>=a)return i;r=18>a?1:48>a?3:144>a?4:768>a?5:6,l=8>a?new c(e):e.isEven()?new b(e):new y(e);var d=[],p=3,n=r-1,u=(1<<r)-1;if(d[1]=l.convert(this),1<r){var g=s();for(l.sqrTo(d[1],g);p<=u;)d[p]=s(),l.mulTo(g,d[p-2],d[p]),p+=2}var h=o.t-1,m=!0,x=s(),T,v;for(a=f(o[h])-1;0<=h;){for(a>=n?T=o[h]>>a-n&u:(T=(o[h]&(1<<a+1)-1)<<n-a,0<h&&(T|=o[h-1]>>this.DB+a-n)),p=r;0==(1&T);)T>>=1,--p;if(0>(a-=p)&&(a+=this.DB,--h),m)d[T].copyTo(i),m=!1;else{for(;1<p;)l.sqrTo(i,x),l.sqrTo(x,i),p-=2;0<p?l.sqrTo(i,x):(v=i,i=x,x=v),l.mulTo(x,d[T],i)}for(;0<=h&&0==(o[h]&1<<a);)l.sqrTo(i,x),v=i,i=x,x=v,0>--a&&(a=this.DB-1,--h)}return l.revert(i)},l.prototype.modInverse=function(e){var t=e.isEven();if(this.isEven()&&t||0==e.signum())return l.ZERO;for(var o=e.clone(),r=this.clone(),i=_(1),a=_(0),n=_(0),s=_(1);0!=o.signum();){for(;o.isEven();)o.rShiftTo(1,o),t?((!i.isEven()||!a.isEven())&&(i.addTo(this,i),a.subTo(e,a)),i.rShiftTo(1,i)):!a.isEven()&&a.subTo(e,a),a.rShiftTo(1,a);for(;r.isEven();)r.rShiftTo(1,r),t?((!n.isEven()||!s.isEven())&&(n.addTo(this,n),s.subTo(e,s)),n.rShiftTo(1,n)):!s.isEven()&&s.subTo(e,s),s.rShiftTo(1,s);0<=o.compareTo(r)?(o.subTo(r,o),t&&i.subTo(n,i),a.subTo(s,a)):(r.subTo(o,r),t&&n.subTo(i,n),s.subTo(a,s))}if(0!=r.compareTo(l.ONE))return l.ZERO;if(0<=s.compareTo(e))return s.subtract(e);if(0>s.signum())s.addTo(e,s);else return s;return 0>s.signum()?s.add(e):s},l.prototype.pow=function(t){return this.exp(t,new x)},l.prototype.gcd=function(e){var o=0>this.s?this.negate():this.clone(),r=0>e.s?e.negate():e.clone();if(0>o.compareTo(r)){var a=o;o=r,r=a}var t=o.getLowestSetBit(),i=r.getLowestSetBit();if(0>i)return o;for(t<i&&(i=t),0<i&&(o.rShiftTo(i,o),r.rShiftTo(i,r));0<o.signum();)0<(t=o.getLowestSetBit())&&o.rShiftTo(t,o),0<(t=r.getLowestSetBit())&&r.rShiftTo(t,r),0<=o.compareTo(r)?(o.subTo(r,o),o.rShiftTo(1,o)):(r.subTo(o,r),r.rShiftTo(1,r));return 0<i&&r.lShiftTo(i,r),r},l.prototype.isProbablePrime=function(e){var t=this.abs(),o;if(1==t.t&&t[0]<=P[P.length-1]){for(o=0;o<P.length;++o)if(t[0]==P[o])return!0;return!1}if(t.isEven())return!1;for(o=1;o<P.length;){for(var r=P[o],a=o+1;a<P.length&&r<k;)r*=P[a++];for(r=t.modInt(r);o<a;)if(0==r%P[o++])return!1}return t.millerRabin(e)},l.prototype.square=function(){var e=s();return this.squareTo(e),e},o.int2char=a,o.default=l},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(7),l=r(n),d=o(174),p=r(d),u=function(){function e(t){(0,i.default)(this,e),this._url=t,this._parsedUrl=p.default.parse(this._url,!0)}return e.prototype._isJSONPRequest=function(){var e=this._parsedUrl.query;for(var t in e){var o=e[t];if('?'===o)return!0}return!1},e.prototype.load=function(){return this._isJSONPRequest()?this._loadJSONP():this._loadJSON()},e.prototype._loadJSON=function(){var e=this;return new l.default(function(t,o){var r;window.XDomainRequest?(r=new window.XDomainRequest,r.onload=function(){var e=JSON.parse(r.responseText);t(e)},r.onerror=function(t){o(t)}):window.XMLHttpRequest&&(r=new XMLHttpRequest,r.onreadystatechange=function(){if(4===r.readyState)if(200===r.status){var e=JSON.parse(r.responseText);t(e)}else o(new Error('HTTP Status '+r.status))}),r.open('GET',e._url,!0),r.send()})},e.prototype._loadJSONP=function(){var e=this,t=!1,o=!1,r='pesdk'+s(99999999999999*Math.random());return new l.default(function(a,i){var n=e._createJSONPNode(r);window[r]=function(r){e._removeJSONPNode(n),t||(o=!0,a(r))},window.setTimeout(function(){o||(e._removeJSONPNode(n),t=!0,i(new Error('Timeout of 5 seconds exceeded.')))},5e3)})},e.prototype._createJSONPNode=function(e){var t=this._buildJSONPUrl(e),o=document.querySelector('head'),r=document.createElement('script');return r.src=t,o.appendChild(r),r},e.prototype._removeJSONPNode=function(e){e.parentNode.removeChild(e)},e.prototype._buildJSONPUrl=function(e){var t=this._parsedUrl.query,o=null;for(var r in t)if('?'===t[r]){o=r;break}return delete this._parsedUrl.search,t[o]=e,p.default.format(this._parsedUrl)},e}();t.default=u},function(e,t,o){'use strict';function r(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function a(e,t,o){if(e&&d.isObject(e)&&e instanceof r)return e;var a=new r;return a.parse(e,t,o),a}var n=o(175),d=o(177);t.parse=a,t.resolve=function(e,t){return a(e,!1,!0).resolve(t)},t.resolveObject=function(e,t){return e?a(e,!1,!0).resolveObject(t):t},t.format=function(e){return d.isString(e)&&(e=a(e)),e instanceof r?e.format():r.prototype.format.call(e)},t.Url=r;var u=/^([a-z0-9.+-]+:)/i,i=/:[0-9]*$/,l=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,s=['{','}','|','\\','^','`'].concat(['<','>','"','`',' ','\r','\n','\t']),p=['\''].concat(s),_=['%','/','?',';','#'].concat(p),f=['/','?','#'],c=/^[+a-z0-9A-Z_-]{0,63}$/,g=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,y={javascript:!0,"javascript:":!0},m={javascript:!0,"javascript:":!0},x={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},T=o(178);r.prototype.parse=function(e,t,o){if(!d.isString(e))throw new TypeError('Parameter \'url\' must be a string, not '+typeof e);var r=e.indexOf('?'),a=-1!==r&&r<e.indexOf('#')?'?':'#',v=e.split(a),b=/\\/g;v[0]=v[0].replace(b,'/'),e=v.join(a);var C=e;if(C=C.trim(),!o&&1===e.split('#').length){var R=l.exec(C);if(R)return this.path=C,this.href=C,this.pathname=R[1],R[2]?(this.search=R[2],this.query=t?T.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search='',this.query={}),this}var O=u.exec(C);if(O){O=O[0];var E=O.toLowerCase();this.protocol=E,C=C.substr(O.length)}if(o||O||C.match(/^\/\/[^@\/]+@[^@\/]+/)){var S='//'===C.substr(0,2);S&&!(O&&m[O])&&(C=C.substr(2),this.slashes=!0)}if(!m[O]&&(S||O&&!x[O])){for(var F=-1,M=0,i;M<f.length;M++)i=C.indexOf(f[M]),-1!==i&&(-1==F||i<F)&&(F=i);var P,D;D=-1===F?C.lastIndexOf('@'):C.lastIndexOf('@',F),-1!==D&&(P=C.slice(0,D),C=C.slice(D+1),this.auth=decodeURIComponent(P)),F=-1;for(var M=0,i;M<_.length;M++)i=C.indexOf(_[M]),-1!==i&&(-1===F||i<F)&&(F=i);-1===F&&(F=C.length),this.host=C.slice(0,F),C=C.slice(F),this.parseHost(),this.hostname=this.hostname||'';var B='['===this.hostname[0]&&']'===this.hostname[this.hostname.length-1];if(!B)for(var I=this.hostname.split(/\./),M=0,w=I.length,L;M<w;M++)if(L=I[M],L&&!L.match(c)){for(var A='',N=0,U=L.length;N<U;N++)A+=127<L.charCodeAt(N)?'x':L[N];if(!A.match(c)){var k=I.slice(0,M),G=I.slice(M+1),z=L.match(g);z&&(k.push(z[1]),G.unshift(z[2])),G.length&&(C='/'+G.join('.')+C),this.hostname=k.join('.');break}}this.hostname=this.hostname.length>255?'':this.hostname.toLowerCase(),B||(this.hostname=n.toASCII(this.hostname));var V=this.port?':'+this.port:'',j=this.hostname||'';this.host=j+V,this.href+=this.host,B&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),'/'!==C[0]&&(C='/'+C))}if(!y[E])for(var M=0,w=p.length,h;M<w;M++)if(h=p[M],-1!==C.indexOf(h)){var W=encodeURIComponent(h);W===h&&(W=escape(h)),C=C.split(h).join(W)}var H=C.indexOf('#');-1!==H&&(this.hash=C.substr(H),C=C.slice(0,H));var q=C.indexOf('?');if(-1===q?t&&(this.search='',this.query={}):(this.search=C.substr(q),this.query=C.substr(q+1),t&&(this.query=T.parse(this.query)),C=C.slice(0,q)),C&&(this.pathname=C),x[E]&&this.hostname&&!this.pathname&&(this.pathname='/'),this.pathname||this.search){var V=this.pathname||'',Y=this.search||'';this.path=V+Y}return this.href=this.format(),this},r.prototype.format=function(){var e=this.auth||'';e&&(e=encodeURIComponent(e),e=e.replace(/%3A/i,':'),e+='@');var t=this.protocol||'',o=this.pathname||'',r=this.hash||'',a=!1,i='';this.host?a=e+this.host:this.hostname&&(a=e+(-1===this.hostname.indexOf(':')?this.hostname:'['+this.hostname+']'),this.port&&(a+=':'+this.port)),this.query&&d.isObject(this.query)&&Object.keys(this.query).length&&(i=T.stringify(this.query));var n=this.search||i&&'?'+i||'';return t&&':'!==t.substr(-1)&&(t+=':'),this.slashes||(!t||x[t])&&!1!==a?(a='//'+(a||''),o&&'/'!==o.charAt(0)&&(o='/'+o)):!a&&(a=''),r&&'#'!==r.charAt(0)&&(r='#'+r),n&&'?'!==n.charAt(0)&&(n='?'+n),o=o.replace(/[?#]/g,function(e){return encodeURIComponent(e)}),n=n.replace('#','%23'),t+a+o+n+r},r.prototype.resolve=function(e){return this.resolveObject(a(e,!1,!0)).format()},r.prototype.resolveObject=function(e){if(d.isString(e)){var t=new r;t.parse(e,!1,!0),e=t}for(var o=new r,a=Object.keys(this),n=0,l;n<a.length;n++)l=a[n],o[l]=this[l];if(o.hash=e.hash,''===e.href)return o.href=o.format(),o;if(e.slashes&&!e.protocol){for(var u=Object.keys(e),_=0,f;_<u.length;_++)f=u[_],'protocol'!==f&&(o[f]=e[f]);return x[o.protocol]&&o.hostname&&!o.pathname&&(o.path=o.pathname='/'),o.href=o.format(),o}if(e.protocol&&e.protocol!==o.protocol){if(!x[e.protocol]){for(var c=Object.keys(e),g=0,y;g<c.length;g++)y=c[g],o[y]=e[y];return o.href=o.format(),o}if(o.protocol=e.protocol,!e.host&&!m[e.protocol]){for(var h=(e.pathname||'').split('/');h.length&&!(e.host=h.shift()););e.host||(e.host=''),e.hostname||(e.hostname=''),''!==h[0]&&h.unshift(''),2>h.length&&h.unshift(''),o.pathname=h.join('/')}else o.pathname=e.pathname;if(o.search=e.search,o.query=e.query,o.host=e.host||'',o.auth=e.auth,o.hostname=e.hostname||e.host,o.port=e.port,o.pathname||o.search){var T=o.pathname||'',p=o.search||'';o.path=T+p}return o.slashes=o.slashes||e.slashes,o.href=o.format(),o}var s=o.pathname&&'/'===o.pathname.charAt(0),v=e.host||e.pathname&&'/'===e.pathname.charAt(0),b=v||s||o.host&&e.pathname,C=b,R=o.pathname&&o.pathname.split('/')||[],h=e.pathname&&e.pathname.split('/')||[],O=o.protocol&&!x[o.protocol];if(O&&(o.hostname='',o.port=null,o.host&&(''===R[0]?R[0]=o.host:R.unshift(o.host)),o.host='',e.protocol&&(e.hostname=null,e.port=null,e.host&&(''===h[0]?h[0]=e.host:h.unshift(e.host)),e.host=null),b=b&&(''===h[0]||''===R[0])),v)o.host=e.host||''===e.host?e.host:o.host,o.hostname=e.hostname||''===e.hostname?e.hostname:o.hostname,o.search=e.search,o.query=e.query,R=h;else if(h.length)R||(R=[]),R.pop(),R=R.concat(h),o.search=e.search,o.query=e.query;else if(!d.isNullOrUndefined(e.search)){if(O){o.hostname=o.host=R.shift();var E=o.host&&0<o.host.indexOf('@')&&o.host.split('@');E&&(o.auth=E.shift(),o.host=o.hostname=E.shift())}return o.search=e.search,o.query=e.query,d.isNull(o.pathname)&&d.isNull(o.search)||(o.path=(o.pathname?o.pathname:'')+(o.search?o.search:'')),o.href=o.format(),o}if(!R.length)return o.pathname=null,o.path=o.search?'/'+o.search:null,o.href=o.format(),o;for(var S=R.slice(-1)[0],F=(o.host||e.host||1<R.length)&&('.'===S||'..'===S)||''===S,M=0,k=R.length;0<=k;k--)S=R[k],'.'===S?R.splice(k,1):'..'===S?(R.splice(k,1),M++):M&&(R.splice(k,1),M--);if(!b&&!C)for(;M--;M)R.unshift('..');b&&''!==R[0]&&(!R[0]||'/'!==R[0].charAt(0))&&R.unshift(''),F&&'/'!==R.join('/').substr(-1)&&R.push('');var i=''===R[0]||R[0]&&'/'===R[0].charAt(0);if(O){o.hostname=o.host=i?'':R.length?R.shift():'';var E=o.host&&0<o.host.indexOf('@')&&o.host.split('@');E&&(o.auth=E.shift(),o.host=o.hostname=E.shift())}return b=b||o.host&&R.length,b&&!i&&R.unshift(''),R.length?o.pathname=R.join('/'):(o.pathname=null,o.path=null),d.isNull(o.pathname)&&d.isNull(o.search)||(o.path=(o.pathname?o.pathname:'')+(o.search?o.search:'')),o.auth=e.auth||o.auth,o.slashes=o.slashes||e.slashes,o.href=o.format(),o},r.prototype.parseHost=function(){var e=this.host,t=i.exec(e);t&&(t=t[0],':'!==t&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,o){(function(e,r){var i;/*! https://mths.be/punycode v1.4.1 by @mathias */(function(n){function l(e){throw new RangeError(B[e])}function s(e,t){for(var o=e.length,r=[];o--;)r[o]=t(e[o]);return r}function p(e,t){var o=e.split('@'),r='';1<o.length&&(r=o[0]+'@',e=o[1]),e=e.replace(D,'.');var a=e.split('.'),i=s(a,t).join('.');return r+i}function u(e){for(var t=[],o=0,r=e.length,a,i;o<r;)a=e.charCodeAt(o++),55296<=a&&56319>=a&&o<r?(i=e.charCodeAt(o++),56320==(64512&i)?t.push(((1023&a)<<10)+(1023&i)+65536):(t.push(a),o--)):t.push(a);return t}function _(e){return s(e,function(e){var t='';return 65535<e&&(e-=65536,t+=w(55296|1023&e>>>10),e=56320|1023&e),t+=w(e),t}).join('')}function f(e){return 10>e-48?e-22:26>e-65?e-65:26>e-97?e-97:b}function c(e,t){return e+22+75*(26>e)-((0!=t)<<5)}function g(e,t,o){var r=0;for(e=o?L(e/E):e>>1,e+=L(e/t);e>I*R>>1;r+=b)e=L(e/I);return L(r+(I+1)*e/(e+O))}function y(e){var o=[],r=e.length,a=0,i=F,n=S,s,d,p,u,c,y,h,m,x,t;for(d=e.lastIndexOf(M),0>d&&(d=0),p=0;p<d;++p)128<=e.charCodeAt(p)&&l('not-basic'),o.push(e.charCodeAt(p));for(u=0<d?d+1:0;u<r;){for(c=a,y=1,h=b;;h+=b){if(u>=r&&l('invalid-input'),m=f(e.charCodeAt(u++)),(m>=b||m>L((v-a)/y))&&l('overflow'),a+=m*y,x=h<=n?C:h>=n+R?R:h-n,m<x)break;t=b-x,y>L(v/t)&&l('overflow'),y*=t}s=o.length+1,n=g(a-c,s,0==c),L(a/s)>v-i&&l('overflow'),i+=L(a/s),a%=s,o.splice(a++,0,i)}return _(o)}function h(e){var o=[],r,a,i,n,s,d,p,_,f,y,t,h,m,x,T;for(e=u(e),h=e.length,r=F,a=0,s=S,d=0;d<h;++d)t=e[d],128>t&&o.push(w(t));for(i=n=o.length,n&&o.push(M);i<h;){for(p=v,d=0;d<h;++d)t=e[d],t>=r&&t<p&&(p=t);for(m=i+1,p-r>L((v-a)/m)&&l('overflow'),a+=(p-r)*m,r=p,d=0;d<h;++d)if(t=e[d],t<r&&++a>v&&l('overflow'),t==r){for(_=a,f=b;;f+=b){if(y=f<=s?C:f>=s+R?R:f-s,_<y)break;T=_-y,x=b-y,o.push(w(c(y+T%x,0))),_=L(T/x)}o.push(w(c(_,0))),s=g(a,m,i==n),a=0,++i}++a,++r}return o.join('')}var m='object'==typeof t&&t&&!t.nodeType&&t,x='object'==typeof e&&e&&!e.nodeType&&e,T='object'==typeof r&&r;(T.global===T||T.window===T||T.self===T)&&(n=T);var v=2147483647,b=36,C=1,R=26,O=38,E=700,S=72,F=128,M='-',k=/^xn--/,P=/[^\x20-\x7E]/,D=/[\x2E\u3002\uFF0E\uFF61]/g,B={overflow:'Overflow: input needs wider integers to process',"not-basic":'Illegal input >= 0x80 (not a basic code point)',"invalid-input":'Invalid input'},I=b-C,L=d,w=a,A;A={version:'1.4.1',ucs2:{decode:u,encode:_},decode:y,encode:h,toASCII:function(e){return p(e,function(e){return P.test(e)?'xn--'+h(e):e})},toUnicode:function(e){return p(e,function(e){return k.test(e)?y(e.slice(4).toLowerCase()):e})}};i=function(){return A}.call(t,o,t,e),!(void 0!==i&&(e.exports=i))})(this)}).call(t,o(176)(e),o(39))},function(e){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],!e.children&&(e.children=[]),Object.defineProperty(e,'loaded',{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,'id',{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e){'use strict';e.exports={isString:function(e){return'string'==typeof e},isObject:function(e){return'object'==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,o){'use strict';t.decode=t.parse=o(179),t.encode=t.stringify=o(180)},function(e){'use strict';function t(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,r,a,n){r=r||'&',a=a||'=';var l={};if('string'!=typeof e||0===e.length)return l;var s=/\+/g;e=e.split(r);var d=1e3;n&&'number'==typeof n.maxKeys&&(d=n.maxKeys);var p=e.length;0<d&&p>d&&(p=d);for(var u=0;u<p;++u){var i=e[u].replace(s,'%20'),_=i.indexOf(a),f,c,g,y;0<=_?(f=i.substr(0,_),c=i.substr(_+1)):(f=i,c=''),g=decodeURIComponent(f),y=decodeURIComponent(c),t(l,g)?o(l[g])?l[g].push(y):l[g]=[l[g],y]:l[g]=y}return l};var o=Array.isArray||function(e){return'[object Array]'===Object.prototype.toString.call(e)}},function(e){'use strict';function t(e,t){if(e.map)return e.map(t);for(var o=[],r=0;r<e.length;r++)o.push(t(e[r],r));return o}var o=function(e){switch(typeof e){case'string':return e;case'boolean':return e?'true':'false';case'number':return isFinite(e)?e:'';default:return'';}};e.exports=function(e,i,n,l){return i=i||'&',n=n||'=',null===e&&(e=void 0),'object'==typeof e?t(a(e),function(a){var l=encodeURIComponent(o(a))+n;return r(e[a])?t(e[a],function(e){return l+encodeURIComponent(o(e))}).join(i):l+encodeURIComponent(o(e[a]))}).join(i):l?encodeURIComponent(o(l))+n+encodeURIComponent(o(e)):''};var r=Array.isArray||function(e){return'[object Array]'===Object.prototype.toString.call(e)},a=Object.keys||function(e){var t=[];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.push(o);return t}},function(e,t){'use strict';Object.defineProperty(t,'__esModule',{value:!0}),t.sha256=/*!
 *  Secure Hash Algorithm (SHA256)
 *  http://www.webtoolkit.info/
 *
 *  Original code by Angel Marin, Paul Johnston.
 */function(e){function t(e,t){var o=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(o>>16)<<16|65535&o}function o(e,t){return e>>>t|e<<32-t}function r(e,t){return e>>>t}function n(e,t,o){return e&t^~e&o}function l(e,t,o){return e&t^e&o^t&o}function s(e){return o(e,2)^o(e,13)^o(e,22)}function p(e){return o(e,6)^o(e,11)^o(e,25)}function u(e){return o(e,7)^o(e,18)^r(e,3)}function _(e){return o(e,17)^o(e,19)^r(e,10)}var d=8;return e=function(e){e=e.replace(/\r\n/g,'\n');for(var t='',o=0,r;o<e.length;o++)r=e.charCodeAt(o),128>r?t+=a(r):127<r&&2048>r?(t+=a(192|r>>6),t+=a(128|63&r)):(t+=a(224|r>>12),t+=a(128|63&r>>6),t+=a(128|63&r));return t}(e),function(e){for(var t='0123456789abcdef',o='',r=0;r<4*e.length;r++)o+=t.charAt(15&e[r>>2]>>8*(3-r%4)+4)+t.charAt(15&e[r>>2]>>8*(3-r%4));return o}(function(o,r){var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],m=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],x=Array(64),T,a,v,c,d,e,f,g,h,i,b,C;o[r>>5]|=128<<24-r%32,o[(r+64>>9<<4)+15]=r;for(var h=0;h<o.length;h+=16){T=m[0],a=m[1],v=m[2],c=m[3],d=m[4],e=m[5],f=m[6],g=m[7];for(var i=0;64>i;i++)x[i]=16>i?o[i+h]:t(t(t(_(x[i-2]),x[i-7]),u(x[i-15])),x[i-16]),b=t(t(t(t(g,p(d)),n(d,e,f)),y[i]),x[i]),C=t(s(T),l(T,a,v)),g=f,f=e,e=d,d=t(c,b),c=v,v=a,a=T,T=t(b,C);m[0]=t(T,m[0]),m[1]=t(a,m[1]),m[2]=t(v,m[2]),m[3]=t(c,m[3]),m[4]=t(d,m[4]),m[5]=t(e,m[5]),m[6]=t(f,m[6]),m[7]=t(g,m[7])}return m}(function(e){for(var t=[],o=0;o<e.length*d;o+=d)t[o>>5]|=(e.charCodeAt(o/d)&(1<<d)-1)<<24-o%32;return t}(e),e.length*d))}},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(92),c=r(f),g=p.Constants.OptionType,y=function(e){function t(){return(0,i.default)(this,t),(0,l.default)(this,e.apply(this,arguments))}return(0,d.default)(t,e),t.prototype._render=function(e){return this._selectedFilter.render(this._sdk,e,this._renderTexture)},t.prototype.render=function(t){return this._selectedFilter.getDirty()&&this.setDirty(!0),!this.getEnabled()||this._selectedFilter.constructor.isIdentity?p.Promise.resolve(t):e.prototype.render.call(this,t)},t.prototype.setDirtyForRenderer=function(t,o){e.prototype.setDirtyForRenderer.call(this,t,o),this._selectedFilter.setDirtyForRenderer(t,o)},t.prototype.disposeRenderTextures=function(){e.prototype.disposeRenderTextures.call(this),this._selectedFilter&&this._selectedFilter.disposeRenderTextures()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._selectedFilter&&this._selectedFilter.dispose()},t}(_.default);y.identifier='filter',y.prototype.availableOptions={identifier:{type:g.STRING,default:'identity'},intensity:{type:g.NUMBER,default:1,setter:function(e){return this._selectedFilter&&this._selectedFilter.setIntensity(e),e}},filter:{type:g.OBJECT,default:new c.default,setter:function(e){return this._selectedFilter&&(this._selectedFilter.dispose(),this._selectedFilter=null),this._selectedFilter=e,'undefined'!=typeof this._options.intensity&&this._selectedFilter.set({intensity:this._options.intensity}),e}}},t.default=y},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(7),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=p.Constants.RendererType,y=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(184),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=o.getContext(),n=this._options.filteredCanvas;i.save(),i.drawImage(a,0,0),i.globalAlpha=this._options.intensity,i.drawImage(n,0,0),i.restore()},t}(p.Engine.Filter);y.prototype.availableOptions={filteredImage:{type:f.NUMBER,default:1,uniformType:c.INT},filteredCanvas:{type:f.OBJECT,default:null},intensity:{type:f.NUMBER,default:1,uniformType:c.FLOAT}};var h=function(){function e(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:1;(0,i.default)(this,e),this._intensity=t,this._stack=[],this._dirtiness={},this._renderTextures={},this._container=new p.Engine.Container,this._sprite=new p.Engine.Sprite,this._container.addChild(this._sprite),this._blendFilter=new y}return e.prototype.push=function(e){this._stack.push(e)},e.prototype.clear=function(){this._stack=[]},e.prototype.render=function(e,t,o){if(0===this._stack.length)return _.default.resolve();var r=e.getRenderer();this._sprite.setTexture(t);var a=this._renderTextures[r.id];if(!a){var i=e.getSprite().getTexture().getFrame();a=new p.Engine.RenderTexture(e.getRenderer(),i.width,i.height),this._renderTextures[r.id]=a}var n=o.getDimensions();a.resizeTo(n);var l=this.isDirtyForRenderer(r);if(l){this._stack.forEach(function(t){t.update(e)});var s=this._stack.map(function(e){return e.getFilter()});this._sprite.setFilters(s),a.render(this._container),this.setDirtyForRenderer(!1,r)}if(this._blendFilter.setIntensity(this._intensity),r.isOfType(g.CANVAS))this._blendFilter.setFilteredCanvas(a.getRenderTarget().getCanvas());else if(r.isOfType(g.WEBGL)){var d=a.getBaseTexture();d.setGLUnit(this._blendFilter.getFilteredImage()),r.updateTexture(d,!1)}return this._sprite.setFilters([this._blendFilter]),o.clear(p.Color.TRANSPARENT),o.render(this._container),l&&this.disposeRenderTextures(),_.default.resolve(o)},e.prototype.setIntensity=function(e){this._intensity=e},e.prototype.isDirtyForRenderer=function(e){return e.id in this._dirtiness||(this._dirtiness[e.id]=!0),this._dirtiness[e.id]},e.prototype.setDirtyForRenderer=function(e,t){this._dirtiness[t.id]=e},e.prototype.setDirty=function(e){for(var t in this._dirtiness)this._dirtiness[t]=e},e.prototype.disposeRenderTextures=function(){for(var e in this._renderTextures)this._renderTextures[e].dispose(),delete this._renderTextures[e]},e.prototype.dispose=function(){this.disposeRenderTextures(),this._stack.forEach(function(e){return e.dispose()}),this._stack=[],this._blendFilter.dispose(),this._sprite.dispose()},e}();t.default=h},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_filteredImage;\nuniform float u_intensity;\n\nvoid main() {\n  vec4 color0 = texture2D(u_image, v_texCoord);\n  vec4 color1 = texture2D(u_filteredImage, v_texCoord);\n  gl_FragColor = mix(color0, color1, u_intensity);\n}\n'},function(e,r,a){'use strict';function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(r,'__esModule',{value:!0});var l=a(0),s=n(l),p=a(1),u=n(p),_=a(2),f=n(_),c=a(3),g=a(8),y=n(g),h=a(7),m=n(h),x=a(186),T=n(x),v=c.Constants.OptionType,b=function(e){function r(){return(0,s.default)(this,r),(0,u.default)(this,e.apply(this,arguments))}return(0,f.default)(r,e),r.prototype._render=function(e){this._sprite.setRotation(0);var t=e.getDimensions(),o=this._options,r=o.start,a=o.end,i=o.rotation,n=o.textureScale,l=r.clone().add(a.clone().subtract(r).divide(2)),s=this.calculateScale(),d=s*n,p=this.getNewDimensions(t);return this._sprite.setAnchor(l),this._sprite.setRotation(i),this._sprite.setScale(d,d),this._sprite.setPosition(p.clone().multiply(0.5)),this._renderTexture.render(this._container),m.default.resolve()},r.prototype.calculateScale=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:this._options.rotation,r=this.getInputDimensions(!1),a=new c.Vector2(i(r.x*o(e))+i(r.y*t(e)),i(r.x*t(e))+i(r.y*o(e))),n=r.clone().multiply(0.5);n.subtract(a.clone().divide(2)),n.abs();var l=1;return l=n.y>n.x?2*n.y/r.y+1:2*n.x/r.x+1,l},r.prototype.getNewDimensions=function(e){var t=this._options,o=t.start,r=t.end,a=t.textureScale,i=this.calculateScale();return e.clone().multiply(a*i).multiply(r.clone().subtract(o)).round()},r.prototype.flip=function(e){var t=this._options,o=t.start,r=t.end,a=o.clone();'horizontal'===e?(o.set(1-r.x,o.y),r.set(1-a.x,r.y)):'vertical'===e&&(o.set(o.x,1-r.y),r.set(r.x,1-a.y))},r.prototype.rotate=function(e){for(var t=this._options,o=t.start,r=t.end,a=d((e+360)%360/90),n=0,i;n<a;n++)i=o.clone(),o.set(1-r.y,i.x),r.set(1-i.y,r.x)},r}(y.default);b.identifier='transform',b.prototype.availableOptions={start:{type:v.VECTOR2,default:new c.Vector2(0,0)},end:{type:v.VECTOR2,default:new c.Vector2(1,1)},textureScale:{type:v.NUMBER,default:1},rotation:{type:v.NUMBER,default:0}},b.TransformChange=T.default,r.default=b},function(e,a,i){'use strict';Object.defineProperty(a,'__esModule',{value:!0});var n=i(0),l=function(e){return e&&e.__esModule?e:{default:e}}(n),s=i(3),d=function(){function e(r,a){(0,l.default)(this,e),this._operation=r,this._options=a,this._inputDimensions=this._operation.getInputDimensions(!1),this._rotationDelta=a.rotation-this._operation.getRotation(),this._deltaCos=o(this._rotationDelta),this._deltaSin=t(this._rotationDelta),this._oldAbsoluteSize=this._operation.getEnd().clone().subtract(this._operation.getStart()).multiply(this._inputDimensions),this._newAbsoluteSize=a.end.clone().subtract(a.start).multiply(this._inputDimensions),this._absoluteStartDiff=this._operation.getStart().clone().subtract(a.start).multiply(this._inputDimensions),this._scaleRatio=this._operation.calculateScale(a.rotation)/this._operation.calculateScale(),this._absoluteStart=this._operation.getStart().clone().multiply(this._inputDimensions),this._sizeFactor=this._newAbsoluteSize.clone().divide(this._oldAbsoluteSize),this._textureScaleFactor=this._options.textureScale/this._operation.getTextureScale()}return e.prototype.applyToRelativePoint=function(e){var t=this._operation.getStart(),o=this._operation.getEnd(),r=t.clone().add(o.clone().subtract(t).divide(2)),a=r.multiply(this._inputDimensions),i=e.clone().multiply(this._oldAbsoluteSize).subtract(this._oldAbsoluteSize.clone().divide(2)),n=a.clone().add(i),l=n.clone().subtract(this._inputDimensions.clone().divide(2)),d=new s.Vector2(l.x*this._deltaCos-l.y*this._deltaSin,l.x*this._deltaSin+l.y*this._deltaCos),p=this._inputDimensions.clone().divide(2).add(d),u=this._options.start.clone().multiply(this._inputDimensions);return p.clone().subtract(u).divide(this._newAbsoluteSize)},e.prototype.applyToRelativeSize=function(e){return e*this._oldAbsoluteSize.min()/this._newAbsoluteSize.min()},e.prototype.applyToDimensions=function(e){return e=e.clone().multiply(this._scaleRatio),this._options.textureScale&&e.multiply(this._textureScaleFactor),e},e.prototype.scaleSize=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:'y';return e/this._sizeFactor[t]},e.prototype.applyToRotation=function(e){return(e+this._rotationDelta)%(2*r)},e}();a.default=d},function(e,t,o){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(0),n=a(i),l=o(1),s=a(l),d=o(2),p=a(d),u=o(3),_=o(7),f=a(_),c=o(21),g=a(c),y=o(8),h=a(y),m=u.Constants.OptionType,x=function(e){function t(){return(0,n.default)(this,t),(0,s.default)(this,e.apply(this,arguments))}return(0,p.default)(t,e),t.prototype._render=function(){var e=this._options.rotation%360;this._sprite.setScale(this._options.flipHorizontally?-1:1,this._options.flipVertically?-1:1),this._sprite.setRotation(e*(r/180)),this._sprite.setAnchor(0.5,0.5),this._sprite.updateTransform();var t=this._sprite.getBounds();return this._renderTexture.resizeTo(new g.default(t.width,t.height)),this._sprite.setPosition(this._renderTexture.getDimensions().divide(2).round()),this._renderTexture.render(this._container),f.default.resolve()},t.prototype.getNewDimensions=function(e){return e=e.clone(),this._options.rotation%180&&e.flip(),e},t.prototype.flip=function(e){var t=this._options.rotation;(90===t||270===t)&&('vertical'===e?e='horizontal':e='vertical'),'vertical'===e?this.setFlipVertically(!this.getFlipVertically()):'horizontal'===e?this.setFlipHorizontally(!this.getFlipHorizontally()):void 0},t}(h.default);x.identifier='orientation',x.prototype.availableOptions={rotation:{type:m.NUMBER,default:0,validation:function(e){if(0!=e%90)throw new Error('OrientationOperation: `rotation` has to be a multiple of 90.')},setter:function(e){return(e+360)%360}},flipVertically:{type:m.BOOLEAN,default:!1},flipHorizontally:{type:m.BOOLEAN,default:!1}},t.default=x},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(7),_=r(u),f=o(8),c=r(f),g=o(93),y=r(g),h=o(190),m=r(h),x=o(10),T=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._clarityFilter=new m.default,n._filter=new y.default,n._sprite.setFilters([n._clarityFilter,n._filter]),n}return(0,d.default)(t,e),t.prototype._render=function(e){var t=e.getDimensions();t.x=1/t.x,t.y=1/t.y,this._clarityFilter.set({clarity:this._options.clarity,texSize:t});var o=new p.ColorMatrix;return o.multiply(p.ColorMatrix.createExposureMatrix(this._options.exposure)),o.multiply(p.ColorMatrix.createSaturationMatrix(this._options.saturation+1)),o.multiply(p.ColorMatrix.createContrastMatrix(this._options.contrast+1)),o.multiply(p.ColorMatrix.createBrightnessMatrix(this._options.brightness)),this._filter.set({gamma:this._options.gamma,shadows:this._options.shadows,highlights:this._options.highlights,colorMatrix:o,colorOffset:o.getOffsets()}),0===this._options.clarity?this._sprite.setFilters([this._filter]):this._sprite.setFilters([this._clarityFilter,this._filter]),this._renderTexture.render(this._container),_.default.resolve()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._filter.dispose(),this._clarityFilter.dispose()},t}(c.default);T.identifier='adjustments',T.prototype.availableOptions={brightness:{type:x.OptionType.NUMBER,default:0,minValue:-1,midValue:0,maxValue:1},saturation:{type:x.OptionType.NUMBER,default:0,minValue:-1,midValue:0,maxValue:1},contrast:{type:x.OptionType.NUMBER,default:0,minValue:-1,midValue:0,maxValue:1},gamma:{type:x.OptionType.NUMBER,default:1,minValue:0.5,midValue:1,maxValue:2},exposure:{type:x.OptionType.NUMBER,default:0,minValue:-1,midValue:0,maxValue:1},shadows:{type:x.OptionType.NUMBER,default:0,minValue:-2,midValue:0,maxValue:2},highlights:{type:x.OptionType.NUMBER,default:0,minValue:-1,midValue:0,maxValue:1},clarity:{type:x.OptionType.NUMBER,default:0,minValue:-1,midValue:0,maxValue:1}},t.default=T},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nuniform float u_gamma;\nuniform float u_shadows;\nuniform float u_highlights;\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorOffset;\n\nconst float EPSILON = 0.0000001;\nconst vec3 luminanceWeighting = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec4 color = texColor;\n\n  // Apply gamma\n  if (u_gamma != 1.0) {\n    color.rgb = pow(color.rgb, vec3(1.0 / max(u_gamma, EPSILON)));\n  }\n\n  // Apply shadows and highlights\n  float luminance = dot(color.rgb, luminanceWeighting);\n  float shadow = u_shadows >= 0.0\n      ? clamp(\n            pow(luminance, 1.0 / (u_shadows + 1.0))\n            + pow(luminance, 2.0 / (u_shadows + 1.0)) * -0.76\n            - luminance\n      , 0.0, max(u_shadows, 1.0))\n      : -clamp(\n            pow(luminance, 1.0 / (-u_shadows + 1.0))\n            + pow(luminance, 2.0 / (-u_shadows + 1.0)) * -0.76\n            - luminance\n      , 0.0, max(-u_shadows, 1.0));\n\n    float highlight = u_highlights < 0.0\n      ? clamp(\n            1.0\n            - pow(1.0 - luminance, 1.0 / (1.0 - u_highlights))\n            - pow(1.0 - luminance, 2.0 / (1.0 - u_highlights)) * -0.8\n            - luminance\n       , -1.0, 0.0)\n      : -clamp(\n            1.0\n            - pow(1.0 - luminance, 1.0 / (1.0 + u_highlights))\n            - pow(1.0 - luminance, 2.0 / (1.0 + u_highlights)) * -0.8\n            - luminance\n       , -1.0, 0.0);\n\n  // Bright color need more contrast and dark color need more brightness.\n  // This is to keep saturatation because the color information of a dark colors is lost.\n  float shadowContrast   = shadow * luminance * luminance;\n  float shadowBrightness = shadow - shadowContrast;\n  color.rgb = clamp((luminance + highlight + shadowContrast) * ((color.rgb + shadowBrightness) / max(luminance, EPSILON)), 0.0, 1.0);\n\n  // Apply Color Matrix\n  color = clamp(color * u_colorMatrix + u_colorOffset, 0.0, 1.0);\n\n  // Apply alpha\n  color = vec4(color.rgb * texColor.a, texColor.a);\n\n  gl_FragColor = color;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),_=o(34),f=r(_),c=p.Constants.OptionType,g=p.Constants.UniformType,y=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(191),r._lastClarity=null,r._blurredRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getDimensions(),i=!this._blurredRenderTarget.getDimensions().equals(a);this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()),this._blurredRenderTarget.resizeTo(t.getDimensions()),i&&this._blurImage(t),this._applyClarity(t,o)},t.prototype._blurImage=function(e){var t=e.getCanvas(),o=e.getContext(),r=o.getImageData(0,0,t.width,t.height);f.default.stackBlurCanvasRGBA(r,0,0,t.width,t.height,1);var a=this._blurredRenderTarget.getContext();a.putImageData(r,0,0)},t.prototype._applyClarity=function(e,t){for(var o=t.getContext(),a=e.getCanvas(),n=e.getContext(),l=this._blurredRenderTarget.getContext(),s=this._options.clarity,d=n.getImageData(0,0,a.width,a.height),p=d.data,_=l.getImageData(0,0,a.width,a.height).data,f=u(0.2*this._options.clarity,0),c=1-f,y=1+s,h=1-(1+s),m=0;m<4*(a.width*a.height);m+=4){var i=_[m]*h+p[m]*y,r=_[m+1]*h+p[m+1]*y,g=_[m+2]*h+p[m+2]*y,x=(0.2125*i+0.7154*r+0.0721*g)*f;p[m]=i*c+x,p[m+1]=r*c+x,p[m+2]=g*c+x}o.putImageData(d,0,0)},t}(p.Engine.Filter);y.prototype.availableOptions={clarity:{type:c.NUMBER,default:0,uniformType:g.FLOAT},texSize:{type:c.VECTOR2,default:new p.Vector2(100,100),uniformType:g.FLOAT2}},t.default=y},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_clarity;\nuniform vec2 u_texSize;\n\nfloat random(vec3 scale, float seed) {\n  return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);\n}\n\nvoid main() {\n  vec4 original = texture2D(u_image, v_texCoord);\n\n  vec4 color = texture2D(u_image, v_texCoord);\n  color +=  texture2D(u_image, v_texCoord + vec2(-1.0, 0.0) * u_texSize);\n  color +=  texture2D(u_image, v_texCoord + vec2(1.0, 0.0) * u_texSize);\n\n  color +=  texture2D(u_image, v_texCoord + vec2(0.0, 1.0) * u_texSize);\n  color +=  texture2D(u_image, v_texCoord + vec2(-1.0, 1.0) * u_texSize);\n  color +=  texture2D(u_image, v_texCoord + vec2(1.0, 1.0) * u_texSize);\n\n  color +=  texture2D(u_image, v_texCoord + vec2(0.0, -1.0) * u_texSize);\n  color +=  texture2D(u_image, v_texCoord + vec2(-1.0, -1.0) * u_texSize);\n  color +=  texture2D(u_image, v_texCoord + vec2(1.0, -1.0) * u_texSize);\n\n  // apply unsharp mask\n  vec4 blurred = color / 9.0;\n  color = mix(blurred, original, 1.0 + u_clarity);\n\n  // desaturation, to emphesize the effect\n  vec3 grayXfer = vec3(0.3, 0.59, 0.11);\n  vec3 gray = vec3(dot(grayXfer, color.xyz));\n  float desaturation = clamp(u_clarity * 0.13, 0.0, 1.0);\n  gl_FragColor = vec4(mix(color.xyz, gray, desaturation) * color.a, color.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(7),c=r(f),g=o(193),y=r(g),h=p.Constants.OptionType,m=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._lastBlurRadius=n._options.blurRadius,n._lastSize=n._options.size,n._lastGradientSize=n._options.gradientSize,n._horizontalFilter=new y.default,n._verticalFilter=new y.default,n._sprite.setFilters([n._horizontalFilter,n._verticalFilter]),n._horizontalFilter.setDelta(new p.Vector2(1,1)),n._verticalFilter.setDelta(new p.Vector2(-1,1)),n._filter=new y.default,n}return(0,d.default)(t,e),t.prototype.rotate=function(e){var t=this._options.start,o=this._options.end;90===e?(t.flip(),t.x=1-t.x,o.flip(),o.x=1-o.x):-90===e&&(t.flip(),t.y=1-t.y,o.flip(),o.y=1-o.y),this.set({start:t,end:o})},t.prototype.flip=function(e){var t=this._options.start,o=this._options.end;'horizontal'===e?(t.x=1-t.x,o.x=1-o.x):'vertical'===e?(t.y=1-t.y,o.y=1-o.y):void 0,this.set({start:t,end:o})},t.prototype.transform=function(e){var t=this,o={};['start','end'].forEach(function(r){var a=t.getOption(r);o[r]=e.applyToRelativePoint(a)}),['blurRadius','size','gradientSize'].forEach(function(r){var a=t.getOption(r);o[r]=e.applyToRelativeSize(a)}),this.set(o,!1)},t.prototype._renderWebGL=function(e){var t=e.getDimensions(),o=t.min(),r=this._options.start.clone(),a=this._options.end.clone(),i=this._options,n=i.blurRadius,l=i.size,s=i.gradientSize,d={blurRadius:n*o,size:l*o,gradientSize:s*o,start:r.clone().multiply(t),end:a.clone().multiply(t),texSize:t};return this._horizontalFilter.set(d),this._verticalFilter.set(d),this._renderTexture.render(this._container),c.default.resolve()},t.prototype._renderCanvas=function(e){var t=e.getDimensions(),o=this._options,r=o.blurRadius,a=o.size,i=o.gradientSize,n=o.start,l=o.end;return this._filter.set({blurRadius:r,gradientSize:i,size:a,start:n.clone(),end:l.clone(),texSize:t}),this._sprite.setFilters([this._filter]),this._renderTexture.render(this._container),c.default.resolve()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._filter.dispose(),this._verticalFilter.dispose(),this._horizontalFilter.dispose()},t}(_.default);m.identifier='mirrored-focus',m.prototype.availableOptions={start:{type:h.VECTOR2,default:new p.Vector2(0,0.5)},end:{type:h.VECTOR2,default:new p.Vector2(1,0.5)},blurRadius:{type:h.NUMBER,default:0.025},size:{type:h.NUMBER,default:0.1},gradientSize:{type:h.NUMBER,default:0.1}},t.default=m},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(34),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(194),s._lastBlurRadius=null,s._lastGradientRadius=null,s._lastStart=new p.Vector2,s._lastEnd=new p.Vector2,s._blurredRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s._maskRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getDimensions(),i=!this._blurredRenderTarget.getDimensions().equals(a);this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()),this._blurredRenderTarget.resizeTo(t.getDimensions()),this._maskRenderTarget.setPixelRatio(t.getPixelRatio()),this._maskRenderTarget.resizeTo(t.getDimensions()),this._lastStart.equals(this._options.start)&&this._lastEnd.equals(this._options.end)&&this._lastGradientRadius===this._options.size&&!i||(this._renderMask(),this._lastStart=this._options.start.clone(),this._lastEnd=this._options.end.clone(),this._lastGradientRadius=this._options.size),(this._lastBlurRadius!==this._options.blurRadius||i)&&(this._blurImage(t),this._lastBlurRadius=this._options.blurRadius),this._applyMask(t,o)},t.prototype._blurImage=function(e){var t=e.getCanvas(),o=e.getContext(),r=new p.Vector2(t.width,t.height),a=o.getImageData(0,0,t.width,t.height);_.default.stackBlurCanvasRGBA(a,0,0,t.width,t.height,this._options.blurRadius*r.min());var i=this._blurredRenderTarget.getContext();i.putImageData(a,0,0)},t.prototype._renderMask=function(){var e=this._maskRenderTarget.getCanvas(),t=this._maskRenderTarget.getContext(),o=this._maskRenderTarget.getPixelRatio(),r=new p.Vector2(e.width,e.height),a=this._options.size*r.min()*o,i=this._options.gradientSize*r.min()*o,n=this._options.start.clone().multiply(r),l=this._options.end.clone().multiply(r),s=l.clone().subtract(n),d=n.clone().add(s.clone().divide(2)),u=s.len(),_=s.clone().divide(u),f=d.clone().add((a+i)*_.y,-(a+i)*_.x),c=d.clone().add(-(a+i)*_.y,(a+i)*_.x),g=t.createLinearGradient(f.x,f.y,c.x,c.y),y=c.clone().subtract(f).len();g.addColorStop(0,'#000000'),g.addColorStop(i/2/y,'#FFFFFF'),g.addColorStop(1-i/2/y,'#FFFFFF'),g.addColorStop(1,'#000000'),t.fillStyle=g,t.fillRect(0,0,e.width,e.height)},t.prototype._applyMask=function(e,t){for(var o=t.getContext(),r=e.getCanvas(),a=e.getContext(),n=this._blurredRenderTarget.getContext(),l=this._maskRenderTarget.getContext(),s=a.getImageData(0,0,r.width,r.height),d=s.data,p=n.getImageData(0,0,r.width,r.height).data,u=l.getImageData(0,0,r.width,r.height).data,_=void 0,f=0;f<4*(r.width*r.height);f+=4)_=u[f]/255,d[f]=_*d[f]+(1-_)*p[f],d[f+1]=_*d[f+1]+(1-_)*p[f+1],d[f+2]=_*d[f+2]+(1-_)*p[f+2];o.putImageData(s,0,0)},t}(p.Engine.Filter);g.prototype.availableOptions={blurRadius:{type:f.NUMBER,default:30,uniformType:c.FLOAT},size:{type:f.NUMBER,default:50,uniformType:c.FLOAT},gradientSize:{type:f.NUMBER,default:50,uniformType:c.FLOAT},start:{type:f.VECTOR2,default:new p.Vector2(0,0.5),uniformType:c.FLOAT2},end:{type:f.VECTOR2,default:new p.Vector2(1,0.5),uniformType:c.FLOAT2},delta:{type:f.VECTOR2,default:new p.Vector2(1,1),uniformType:c.FLOAT2},texSize:{type:f.VECTOR2,default:new p.Vector2(100,100),uniformType:c.FLOAT2}},t.default=g},function(e){e.exports='/*\n * Based on evanw\'s glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform float u_gradientSize;\nuniform float u_size;\nuniform vec2 u_start;\nuniform vec2 u_end;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    vec2 normal = normalize(vec2(u_start.y - u_end.y, u_end.x - u_start.x));\n    float radius = smoothstep(0.0, 1.0,\n      (abs(\n        dot(v_texCoord * u_texSize - u_start, normal)\n      ) - u_size) / u_gradientSize\n    ) * u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n        float percent = (t + offset - 0.5) / 30.0;\n        float weight = 1.0 - abs(percent);\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        _sample.rgb *= _sample.a;\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n    gl_FragColor.rgb /= gl_FragColor.a + 0.00001;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(7),c=r(f),g=o(196),y=r(g),h=p.Constants.OptionType,m=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._lastBlurRadius=n._options.blurRadius,n._lastGradientRadius=n._options.gradientRadius,n._horizontalFilter=new y.default,n._verticalFilter=new y.default,n._sprite.setFilters([n._horizontalFilter,n._verticalFilter]),n._horizontalFilter.setDelta(new p.Vector2(1,1)),n._verticalFilter.setDelta(new p.Vector2(-1,1)),n._filter=new y.default,n}return(0,d.default)(t,e),t.prototype.rotate=function(e){var t=this._options.position;90===e?(t.flip(),t.x=1-t.x):-90===e&&(t.flip(),t.y=1-t.y),this.set({position:t})},t.prototype.flip=function(e){var t=this._options.position;'horizontal'===e?t.x=1-t.x:'vertical'===e?t.y=1-t.y:void 0,this.set({position:t})},t.prototype.transform=function(e){var t=this,o={},r=this.getPosition();o.position=e.applyToRelativePoint(r),['radius','blurRadius','gradientRadius'].forEach(function(r){var a=t.getOption(r);o[r]=e.applyToRelativeSize(a)}),this.set(o,!1)},t.prototype._renderWebGL=function(e){var t=e.getDimensions(),o=t.min(),r=this._options,a=r.position,i=r.blurRadius,n=r.radius,l=r.gradientRadius,s={blurRadius:i*o,radius:n*o,gradientRadius:l*o,position:a.clone().multiply(t),texSize:t};return this._horizontalFilter.set(s),this._verticalFilter.set(s),this._renderTexture.render(this._container),c.default.resolve()},t.prototype._renderCanvas=function(e){var t=this._options,o=t.blurRadius,r=t.radius,a=t.gradientRadius,i=t.position,n=e.getDimensions();return this._filter.set({blurRadius:o,radius:r,gradientRadius:a,position:i,texSize:n}),this._sprite.setFilters([this._filter]),this._renderTexture.render(this._container),c.default.resolve()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._filter.dispose(),this._verticalFilter.dispose(),this._horizontalFilter.dispose()},t}(_.default);m.identifier='radial-focus',m.prototype.availableOptions={position:{type:h.VECTOR2,default:new p.Vector2(0.5,0.5)},radius:{type:h.NUMBER,default:0.25},gradientRadius:{type:h.NUMBER,default:0.125},blurRadius:{type:h.NUMBER,default:0.025}},t.default=m},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(34),_=r(u),f=p.Constants.UniformType,c=p.Constants.OptionType,g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(197),s._lastBlurRadius=null,s._lastGradientRadius=null,s._lastPosition=new p.Vector2,s._blurredRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s._maskRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getDimensions(),i=!this._blurredRenderTarget.getDimensions().equals(a);this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()),this._blurredRenderTarget.resizeTo(t.getDimensions()),this._maskRenderTarget.setPixelRatio(t.getPixelRatio()),this._maskRenderTarget.resizeTo(t.getDimensions()),(!this._lastPosition.equals(this._options.position)||this._lastGradientRadius!==this._options.gradientRadius||i)&&(this._renderMask(),this._lastPosition=this._options.position.clone(),this._lastGradientRadius=this._options.gradientRadius),(this._lastBlurRadius!==this._options.blurRadius||i)&&(this._blurImage(t),this._lastBlurRadius=this._options.blurRadius),this._applyMask(t,o)},t.prototype._blurImage=function(e){var t=e.getCanvas(),o=e.getContext(),r=new p.Vector2(t.width,t.height),a=o.getImageData(0,0,t.width,t.height);_.default.stackBlurCanvasRGBA(a,0,0,t.width,t.height,this._options.blurRadius*r.min());var i=this._blurredRenderTarget.getContext();i.putImageData(a,0,0)},t.prototype._renderMask=function(){var e=this._maskRenderTarget.getCanvas(),t=this._maskRenderTarget.getContext(),o=new p.Vector2(e.width,e.height),r=this._maskRenderTarget.getPixelRatio(),a=this._options.position.clone().multiply(o),i=this._options,n=i.radius,l=i.gradientRadius;n*=e.height,l*=e.height;var s=t.createRadialGradient(a.x,a.y,0,a.x,a.y,(n+l)*r);s.addColorStop(0,'#FFFFFF'),s.addColorStop(n/(n+l),'#FFFFFF'),s.addColorStop(1,'#000000'),t.fillStyle=s,t.fillRect(0,0,o.x,o.y)},t.prototype._applyMask=function(e,t){for(var o=t.getContext(),r=e.getCanvas(),a=e.getContext(),n=this._blurredRenderTarget.getContext(),l=this._maskRenderTarget.getContext(),s=a.getImageData(0,0,r.width,r.height),d=s.data,p=n.getImageData(0,0,r.width,r.height).data,u=l.getImageData(0,0,r.width,r.height).data,_=void 0,f=0;f<4*(r.width*r.height);f+=4)_=u[f]/255,d[f]=_*d[f]+(1-_)*p[f],d[f+1]=_*d[f+1]+(1-_)*p[f+1],d[f+2]=_*d[f+2]+(1-_)*p[f+2];o.putImageData(s,0,0)},t}(p.Engine.Filter);g.prototype.availableOptions={blurRadius:{type:c.NUMBER,default:30,uniformType:f.FLOAT},radius:{type:c.NUMBER,default:50,uniformType:f.FLOAT},gradientRadius:{type:c.NUMBER,default:25,uniformType:f.FLOAT},position:{type:c.VECTOR2,default:new p.Vector2(0.5,0.5),uniformType:f.FLOAT2},delta:{type:c.VECTOR2,default:new p.Vector2(1,1),uniformType:f.FLOAT2},texSize:{type:c.VECTOR2,default:new p.Vector2(100,100),uniformType:f.FLOAT2}},t.default=g},function(e){e.exports='/*\n * Based on evanw\'s glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_radius;\nuniform float u_blurRadius;\nuniform float u_gradientRadius;\nuniform vec2 u_position;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n    float radius = smoothstep(\n      0.0, 1.0,\n      (abs(\n        distance(v_texCoord * u_texSize, u_position)\n      ) - u_radius) / (u_gradientRadius * 2.0)\n    ) * u_blurRadius;\n    for (float t = -30.0; t <= 30.0; t++) {\n        float percent = (t + offset - 0.5) / 30.0;\n        float weight = 1.0 - abs(percent);\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        _sample.rgb *= _sample.a;\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n    gl_FragColor.rgb /= gl_FragColor.a + 0.00001;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(7),c=r(f),g=o(199),y=r(g),h=p.Constants.OptionType,m=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._lastBlurRadius=n._options.blurRadius,n._lastControlPoint1=n._options.controlPoint1.clone(),n._lastControlPoint2=n._options.controlPoint2.clone(),n._horizontalFilter=new y.default,n._verticalFilter=new y.default,n._sprite.setFilters([n._horizontalFilter,n._verticalFilter]),n._horizontalFilter.setDelta(new p.Vector2(1,1)),n._verticalFilter.setDelta(new p.Vector2(-1,1)),n._filter=new y.default,n}return(0,d.default)(t,e),t.prototype.rotate=function(e){var t=this._options.controlPoint1,o=this._options.controlPoint2;90===e?(t.flip(),t.x=1-t.x,o.flip(),o.x=1-o.x):-90===e&&(t.flip(),t.y=1-t.y,o.flip(),o.y=1-o.y),this.set({controlPoint1:t,controlPoint2:o})},t.prototype.flip=function(e){var t=this._options.controlPoint1,o=this._options.controlPoint2;'horizontal'===e?(t.x=1-t.x,o.x=1-o.x):'vertical'===e?(t.y=1-t.y,o.y=1-o.y):void 0,this.set({controlPoint1:t,controlPoint2:o})},t.prototype.transform=function(e){var t=this,o={};['controlPoint1','controlPoint2'].forEach(function(r){var a=t.getOption(r);o[r]=e.applyToRelativePoint(a)}),['blurRadius'].forEach(function(r){var a=t.getOption(r);o[r]=e.applyToRelativeSize(a)}),this.set(o,!1)},t.prototype._renderWebGL=function(e){var t=e.getDimensions(),o=t.min(),r=this._options,a=r.blurRadius,i=r.controlPoint1,n=r.controlPoint2,l={blurRadius:a*o,controlPoint1:i,controlPoint2:n,texSize:t};return this._horizontalFilter.set(l),this._verticalFilter.set(l),this._renderTexture.render(this._container),c.default.resolve()},t.prototype._renderCanvas=function(e){var t=e.getDimensions(),o=this._options,r=o.blurRadius,a=o.controlPoint1,i=o.controlPoint2;return this._filter.set({blurRadius:r,controlPoint1:a.clone(),controlPoint2:i.clone(),texSize:t}),this._sprite.setFilters([this._filter]),this._renderTexture.render(this._container),c.default.resolve()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._filter.dispose(),this._verticalFilter.dispose(),this._horizontalFilter.dispose()},t}(_.default);m.identifier='linear-focus',m.prototype.availableOptions={controlPoint1:{type:h.VECTOR2,default:new p.Vector2(0,0.5)},controlPoint2:{type:h.VECTOR2,default:new p.Vector2(1,0.5)},blurRadius:{type:h.NUMBER,default:0.025}},t.default=m},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(34),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);for(var r=arguments.length,a=Array(r),n=0;n<r;n++)a[n]=arguments[n];var s=(0,l.default)(this,e.call.apply(e,[this].concat(a)));return s._fragmentSource=o(200),s._lastBlurRadius=null,s._lastControlPoint1=new p.Vector2,s._lastControlPoint2=new p.Vector2,s._blurredRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s._maskRenderTarget=new p.Engine.CanvasRenderTarget(100,100,1),s}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getDimensions(),i=!this._blurredRenderTarget.getDimensions().equals(a);this._blurredRenderTarget.setPixelRatio(t.getPixelRatio()),this._blurredRenderTarget.resizeTo(t.getDimensions()),this._maskRenderTarget.setPixelRatio(t.getPixelRatio()),this._maskRenderTarget.resizeTo(t.getDimensions()),this._lastControlPoint1.equals(this._options.controlPoint1)&&this._lastControlPoint2.equals(this._options.controlPoint2)&&!i||(this._renderMask(),this._lastControlPoint1=this._options.controlPoint1.clone(),this._lastControlPoint2=this._options.controlPoint2.clone()),(this._lastBlurRadius!==this._options.blurRadius||i)&&(this._blurImage(t),this._lastBlurRadius=this._options.blurRadius),this._applyMask(t,o)},t.prototype._blurImage=function(e){var t=e.getCanvas(),o=e.getContext(),r=new p.Vector2(t.width,t.height),a=o.getImageData(0,0,t.width,t.height);_.default.stackBlurCanvasRGBA(a,0,0,t.width,t.height,this._options.blurRadius*r.min());var i=this._blurredRenderTarget.getContext();i.putImageData(a,0,0)},t.prototype._renderMask=function(){var e=this._maskRenderTarget.getCanvas(),t=this._maskRenderTarget.getContext(),o=new p.Vector2(e.width,e.height),r=this._options.controlPoint1.clone().multiply(o),a=this._options.controlPoint2.clone().multiply(o),i=t.createLinearGradient(r.x,r.y,a.x,a.y);i.addColorStop(0,'#FFFFFF'),i.addColorStop(1,'#000000'),t.fillStyle=i,t.fillRect(0,0,e.width,e.height)},t.prototype._applyMask=function(e,t){for(var o=t.getContext(),r=e.getCanvas(),a=e.getContext(),n=this._blurredRenderTarget.getContext(),l=this._maskRenderTarget.getContext(),s=a.getImageData(0,0,r.width,r.height),d=s.data,p=n.getImageData(0,0,r.width,r.height).data,u=l.getImageData(0,0,r.width,r.height).data,_=void 0,f=0;f<4*(r.width*r.height);f+=4)_=u[f]/255,d[f]=_*d[f]+(1-_)*p[f],d[f+1]=_*d[f+1]+(1-_)*p[f+1],d[f+2]=_*d[f+2]+(1-_)*p[f+2];o.putImageData(s,0,0)},t}(p.Engine.Filter);g.prototype.availableOptions={blurRadius:{type:f.NUMBER,default:30,uniformType:c.FLOAT},controlPoint1:{type:f.VECTOR2,default:new p.Vector2(0,0.5),uniformType:c.FLOAT2},controlPoint2:{type:f.VECTOR2,default:new p.Vector2(1,0.5),uniformType:c.FLOAT2},delta:{type:f.VECTOR2,default:new p.Vector2(1,1),uniformType:c.FLOAT2},texSize:{type:f.VECTOR2,default:new p.Vector2(100,100),uniformType:c.FLOAT2}},t.default=g},function(e){e.exports='/*!\n * Based on evanw\'s glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform vec2 u_controlPoint1;\nuniform vec2 u_controlPoint2;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    vec2 vector = u_controlPoint2 - u_controlPoint1;\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n\n    float radius = smoothstep(0.0, 1.0,\n      abs(\n        clamp(dot(v_texCoord - u_controlPoint1, vector) / dot(vector, vector), 0.0, 1.0)\n      )\n    ) * u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n      float percent = (t + offset - 0.5) / 30.0;\n      float weight = 1.0 - abs(percent);\n      vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n      _sample.rgb *= _sample.a;\n\n      color += _sample * weight;\n      total += weight;\n    }\n\n    gl_FragColor = color / total;\n    gl_FragColor.rgb /= gl_FragColor.a + 0.00001;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(23),i=r(a),n=o(0),p=r(n),u=o(1),_=r(u),f=o(2),c=r(f),g=o(3),y=o(8),h=r(y),m=g.Constants.OptionType,x;x=window.Image;var T=function(e){function t(){(0,p.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var i=(0,_.default)(this,e.call.apply(e,[this].concat(r)));return i._colorOverlayFilter=new g.Engine.Filters.ColorOverlayFilter({color:i.getTintColor()}),i._frameContainer=new g.Engine.Container,i._resetSprites(),i._options.frame&&i._createSpritesForFrame(i._options.frame),i}return(0,c.default)(t,e),t.prototype._resetSprites=function(){this._spriteGroups={top:{},left:{},right:{},bottom:{}},this._sprites=[],this._repeatSprites={top:[],left:[],right:[],bottom:[]}},t.prototype._createSpritesForFrame=function(e){var t=this;if(!e)return this._disposeSprites();var o=e.imageGroups,r=e.layoutMode;this._layoutMode=r||'horizontal-inside',this._disposeSprites(),['top','left','right','bottom'].forEach(function(e){'undefined'==typeof o[e]||['start','mid','end'].forEach(function(r){if('undefined'!=typeof o[e][r]){var a=o[e][r];'image'in a&&(a=a.image);var i=g.Engine.Texture.fromImage(a),n=new g.Engine.Sprite(i);t._spriteGroups[e][r]=n,t._sprites.push(n),t._frameContainer.addChild(n)}})})},t.prototype._render=function(e){var t=this._renderTexture.getDimensions();return this._options.frame&&(this._colorOverlayFilter.setColor(this.getTintColor()),this._updateSprites(e)),this._frameRenderTexture?this._frameRenderTexture.resizeTo(t):(this._frameRenderTexture=new g.Engine.RenderTexture(this._sdk.getRenderer(),t.x,t.y),this._frameSprite=new g.Engine.Sprite(this._frameRenderTexture),this._container.addChild(this._frameSprite)),this._frameSprite.setAlpha(this._options.alpha),this._options.frame&&this._options.frame.tintable?this._frameSprite.setFilters([this._colorOverlayFilter]):this._frameSprite.setFilters([]),this._frameRenderTexture.clear(),this._frameRenderTexture.render(this._frameContainer),this._renderTexture.render(this._container),g.Promise.resolve(this._renderTexture)},t.prototype._updateSprites=function(e){var t=e.getDimensions();this._frameWidth=l(e.getDimensions().min()*this._options.scale),this._updateHorizontalSpriteGroup(e,'top',0),this._updateHorizontalSpriteGroup(e,'bottom',t.y-this._frameWidth),this._updateVerticalSpriteGroup(e,'left',0),this._updateVerticalSpriteGroup(e,'right',t.x-this._frameWidth)},t.prototype._updateHorizontalSpriteGroup=function(e,t){var o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,r=e.getDimensions(),a='vertical-inside'===this._layoutMode,n=this._spriteGroups[t].start,p=this._spriteGroups[t].mid,u=this._spriteGroups[t].end,_=0,f=0,c,y;if(n){c=n.getTexture().getDimensions(),y=c.y/c.x,_=d(this._frameWidth/y);var h=new g.Vector2(0,o);h.x=a?this._frameWidth:0,n.setPosition(h),n.setHeight(this._frameWidth),n.setWidth(_)}if(u){c=u.getTexture().getDimensions(),y=c.y/c.x,f=d(this._frameWidth*y);var m=new g.Vector2(r.x-f,o);m.x-=a?this._frameWidth:0,u.setPosition(m),u.setHeight(this._frameWidth),u.setWidth(f)}if(p){c=p.getTexture().getDimensions(),y=c.y/c.x;var x=new g.Vector2(_,o),T=r.x-_-f;if(a&&(x.x+=this._frameWidth,T-=2*this._frameWidth),p.setPosition(x),p.setWidth(T),p.setHeight(this._frameWidth),'repeat'===this._options.frame.imageGroups[t].mid.mode){var v=this._frameWidth/y,b=l(T/v),C=0;if(-1!==b){var R=s(T/b);p.setWidth(R),C+=R,this._ensureRepeatSpritesExist(b-1,t,p);for(var O=0;O<b-1;O++){R=s((T-C)/(b-O-1));var i=this._repeatSprites[t][O],E=x.clone().add(C,0).floor();i.setPosition(E),i.setWidth(R),i.setHeight(this._frameWidth),C+=R}}}}},t.prototype._ensureRepeatSpritesExist=function(e,t,o){var r=this;o.getTexture().setMaxListeners(e+1);var a=this._repeatSprites[t].length;if(e>a)for(var n=0,i;n<e-a;n++)i=new g.Engine.Sprite(o.getTexture()),this._repeatSprites[t].push(i),this._frameContainer.addChild(i),this._sprites.push(i);else if(e<a){var l=this._repeatSprites[t].splice(e);l.forEach(function(e){var t=r._sprites.indexOf(e);-1===t||(r._sprites.splice(t,1),r._frameContainer.removeChild(e),e.dispose())})}},t.prototype._updateVerticalSpriteGroup=function(e,t){var o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0,r=e.getDimensions(),a='horizontal-inside'===this._layoutMode,n=this._spriteGroups[t].start,p=this._spriteGroups[t].mid,u=this._spriteGroups[t].end,_=0,f=0,c,y;if(n){c=n.getTexture().getDimensions(),y=c.y/c.x,_=d(this._frameWidth*y);var h=new g.Vector2(o,0);h.y=a?this._frameWidth:0,n.setPosition(h),n.setWidth(this._frameWidth),n.setHeight(_)}if(u){c=u.getTexture().getDimensions(),y=c.y/c.x,f=d(this._frameWidth*y);var m=new g.Vector2(o,r.y-f);m.y-=a?this._frameWidth:0,u.setPosition(m),u.setWidth(this._frameWidth),u.setHeight(f)}if(p){c=p.getTexture().getDimensions(),y=c.y/c.x;var x=new g.Vector2(o,_),T=r.y-_-f;if(a&&(x.y+=this._frameWidth,T-=2*this._frameWidth),p.setPosition(x),p.setHeight(T),p.setWidth(this._frameWidth),'repeat'===this._options.frame.imageGroups[t].mid.mode){var v=this._frameWidth*y,b=l(T/v),C=0;if(-1!==b){var R=s(T/b);p.setHeight(R),C+=R,this._ensureRepeatSpritesExist(b-1,t,p);for(var O=0;O<b-1;O++){R=s((T-C)/(b-O-1));var i=this._repeatSprites[t][O],E=x.clone().add(0,C).floor();i.setPosition(E),i.setHeight(R),i.setWidth(this._frameWidth),C+=R}}}}},t.prototype._disposeSprites=function(){var e=this;this._sprites.forEach(function(t){e._frameContainer.removeChild(t);var o=t.getTexture().getBaseTexture();o.dispose(),t.dispose()}),this._resetSprites()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._disposeSprites()},t.validateFrame=function(e){if(e){var t=e.imageGroups,o=e.layoutMode;if('string'!=typeof e.identifier)throw new Error('Frame needs a property `identifier` of type String.');if('object'!==(0,i.default)(e.imageGroups))throw new Error('Frame needs a property `imageGroups` of type Object.');var r=function(e){var o=t[e],r=o.start,a=o.end,n=o.mid;if('undefined'!=typeof t[e]){if('object'!==(0,i.default)(t[e]))throw new Error('Frame: `imageGroups.'+e+'` needs to be of type Object.');if('undefined'!=typeof r&&!(r instanceof x||'undefined'!=typeof HTMLImageElement&&r instanceof HTMLImageElement))throw new Error('Frame: `imageGroups.'+e+'.start` needs to be of type Image.');if('undefined'!=typeof n&&!(r instanceof x||'undefined'!=typeof HTMLImageElement&&r instanceof HTMLImageElement)&&'object'!==('undefined'==typeof n?'undefined':(0,i.default)(n)))throw new Error('Frame: `imageGroups.'+e+'.mid` needs to be of type Image or Object.');if('undefined'!=typeof a&&!(a instanceof x||'undefined'!=typeof HTMLImageElement&&a instanceof HTMLImageElement))throw new Error('Frame: `imageGroups.'+e+'.end` needs to be of type Image.')}};if('undefined'!=typeof o&&-1===['vertical-inside','horizontal-inside'].indexOf(o))throw new Error('Frame: `layoutMode` must be one of vertical-inside, horizontal-inside');if('undefined'!=typeof tintable&&'boolean'!=typeof tintable)throw new Error('Frame: `tintable` needs to be of type Boolean.');r('top'),r('left'),r('right'),r('bottom')}},t}(h.default);T.identifier='frame',T.prototype.availableOptions={frame:{type:m.OBJECT,validation:T.validateFrame,setter:function(e,t){return t||this._createSpritesForFrame(e),e}},alpha:{type:m.NUMBER,default:1},tintColor:{type:m.COLOR,default:new g.Color(1,1,1,0)},scale:{type:m.NUMBER,default:0.1}},t.default=T},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(43),c=r(f),g=o(203),y=r(g),h=o(204),m=r(h),x=o(94),T=r(x),v=p.Constants.OptionType,b=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));n._onSpriteUpdate=n._onSpriteUpdate.bind(n);var s=n._options.sprites.slice();return s.forEach(function(e){n.removeSprite(e),n.addSprite(e)}),n}return(0,d.default)(t,e),t.prototype.getSpritesOfType=function(e){return this._options.sprites.filter(function(t){return t instanceof e})},t.prototype.rotate=function(e){this._options.sprites.forEach(function(t){t.applyRotation(e)})},t.prototype.flip=function(e){this._options.sprites.forEach(function(t){t.applyFlip(e)})},t.prototype._onSpriteUpdate=function(){this.setDirty(!0)},t.prototype._applyRotation=function(e,t){this._options.sprites.forEach(function(o){return o.applyRotation(e,t)})},t.prototype.transform=function(e){this._options.sprites.forEach(function(t){return t.applyTransform(e)})},t.prototype.scale=function(e){this._options.sprites.forEach(function(t){return t.applyScale(e)})},t.prototype.serializeOption=function(t){var o=1<arguments.length&&void 0!==arguments[1]&&arguments[1];return'sprites'===t?this._options.sprites.map(function(e){return e.serializeOptions(void 0,o)}):e.prototype.serializeOption.call(this,t,o)},t.prototype.createSticker=function(e){return new y.default(this,e)},t.prototype.createText=function(e){return new m.default(this,e)},t.prototype.createBrush=function(e){return new T.default(this,e)},t.prototype.addSprite=function(e){this._options.sprites.push(e),this._container.addChild(e.getDisplayObject()),this.setDirty(!0),e.on('update',this._onSpriteUpdate)},t.prototype.removeSprite=function(e){var t=this._options.sprites,o=t.indexOf(e);return-1!==o&&(e.off('update',this._onSpriteUpdate),this._container.removeChild(e.getDisplayObject()),t.splice(o,1),this.setDirty(!0),!0)},t.prototype._render=function(e){var t=this,o=this._container,r=this._options.sprites,a=e.getDimensions().clone().floor();return p.Promise.all(r.map(function(e){return e.validateSettings()})).then(function(){r.forEach(function(e){return e.update(t._sdk,a)})}).then(function(){t._renderTexture.clear(),t._renderTexture.render(o)})},t.prototype.takeSpriteToFront=function(e){var t=this._options.sprites,o=t.indexOf(e);if(-1!==o){p.Utils.moveArrayItem(t,o,t.length-1);var r=e.getDisplayObject();this._container.removeChild(r),this._container.addChild(r),this.setDirty(!0)}},t.prototype.getSpritesAtPosition=function(e,t){var o=this,r=[];this._options.sprites.forEach(function(e){return e.update(o._sdk,t)});var a=this._sdk.getSprite(),n=a.getWorldTransform().applyInverseToVector(e),l=a.getTexture().getFrame(),s=l.width,d=l.height,p=a.getAnchor().clone().multiply(-s,-d);n.subtract(p);for(var u=this._options.sprites.slice(0).reverse(),_=0,i=u.length,f;_<i;_++)f=u[_],f.getHitTestDisplayObject().isAtPosition(n)&&r.push(f);return r},t.prototype.setDirtyForRenderer=function(t,o,r){e.prototype.setDirtyForRenderer.call(this,t,o,r),this._options.sprites.forEach(function(e){e.setDirtyForRenderer(t,o,r)})},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._options.sprites.forEach(function(e){e.dispose()})},t}(_.default);b.StickerSprite=y.default,b.TextSprite=m.default,b.BrushSprite=T.default,b.identifier='sprite',b.prototype.availableOptions={sprites:{type:v.ARRAY,default:[],setter:function(e,t){var o=this;if(e=e.map(function(e){if(e instanceof c.default)return e;var t=e.type;switch(delete e.type,t){case'text':return new m.default(o,e);case'sticker':return new y.default(o,e);case'brush':return new T.default(o,e);default:p.Log.error(o.constructor.name,'Invalid sprite type: '+e.type);}}),!t){if(this._options.sprites){var r=this._options.sprites.slice();r.forEach(function(e){e.dispose(),o.removeSprite(e)})}e.forEach(function(e){o.addSprite(e)})}return e}}},t.default=b},function(e,t,o){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(0),n=a(i),l=o(1),s=a(l),d=o(2),p=a(d),u=o(3),_=o(43),f=a(_),c=o(93),g=a(c),y=u.Constants.OptionType,h=u.Constants.RendererType,m=function(e){function t(){(0,n.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var i=(0,s.default)(this,e.call.apply(e,[this].concat(r))),l=i._options.image;return i._isSVG=l.src&&!!l.src.match(/\w+\.svg(?=\?|$)/i),i._isSVG&&(i._canvas=u.Utils.createCanvas(),i._context=i._canvas.getContext('2d')),l&&i._onImageUpdate(),i._tintFilter=new u.Engine.Filters.TintFilter,i._adjustmentsFilter=new g.default,i._lastRenderedDimensions=u.Vector2.NULL,i._lastRenderedInputDimensions=u.Vector2.NULL,i._onOptionsChange=i._onOptionsChange.bind(i),i._options.adjustments.on('updated',i._onOptionsChange),i._isSVG=l.src&&!!l.src.match(/\w+\.svg(?=\?|$)/i),i}return(0,p.default)(t,e),t.prototype.applyScale=function(e){this.setDimensions(this.getDimensions().multiply(e))},t.prototype.serializeOptions=function(t){var o=1<arguments.length&&void 0!==arguments[1]&&arguments[1],r=e.prototype.serializeOptions.call(this,t,o);return t||(r.type='sticker'),r},t.prototype._rendersToRenderTexture=function(e){var t=this._options.smoothDownscaling&&!this._isSVG&&e.getRenderer().isOfType(h.WEBGL);return t||this._hasAdjustments()||'none'!==this._options.tintMode},t.prototype._getTexture=function(){return this._inputTexture},t.prototype.update=function(e,t){var o=this._options,r=o.dimensions,a=o.image;r.equals(u.Vector2.NULL)&&r.set(a.width,a.height);var i=!this._lastRenderedInputDimensions.equals(t)||!this._lastRenderedDimensions.equals(r)||this._lastRenderedImage!==a;if(i&&this._isSVG&&e.getRenderer().isOfType(h.WEBGL)){var n=e.getOutputDimensions();if(r.x>n.x||r.y>n.y){var l=u.Utils.resizeVectorToFit(r,n);a.width=l.x,a.height=l.y}else a.width=r.x,a.height=r.y;this._canvas.width=a.width,this._canvas.height=a.height,this._context.clearRect(0,0,a.width,a.height),this._context.drawImage(a,0,0,a.width,a.height),this._inputTexture.getBaseTexture().update()}this._rendersToRenderTexture(e)&&this._prepareRenderTexture(e);var s=[];if(this._rendersToRenderTexture(e)){if(this._hasAdjustments()){s.push(this._adjustmentsFilter);var d=this._options.adjustments,p=new u.ColorMatrix;p.multiply(u.ColorMatrix.createBrightnessMatrix(d.getBrightness())),p.multiply(u.ColorMatrix.createSaturationMatrix(d.getSaturation())),p.multiply(u.ColorMatrix.createContrastMatrix(d.getContrast())),this._adjustmentsFilter.set({colorMatrix:p})}this._options.tintMode&&'none'!==this._options.tintMode&&(s.push(this._tintFilter),this._tintFilter.set({mode:u.Engine.Filters.TintFilter.MODES[this._options.tintMode.toUpperCase()],color:this._options.tintColor})),this._renderTextureSprite.setFilters(s)}this._rendersToRenderTexture(e)?this._renderToRenderTexture(e):this._sprite.setTexture(this._inputTexture),this._updateSprite(t),this._applyFlip(),this._lastRenderedDimensions.copy(r),this._lastRenderedInputDimensions.copy(t),this._lastRenderedImage=a},t.prototype._applyFlip=function(){var e=this._sprite.getScale();this._options.flipVertically&&(e.y*=-1),this._options.flipHorizontally&&(e.x*=-1),this._sprite.setScale(e)},t.prototype.applyFlip=function(t){e.prototype.applyFlip.call(this,t);var o={rotation:this._options.rotation},a=180*(o.rotation/r);o.rotation=-1*a*r/180,'horizontal'===t?(o.flipHorizontally=!this._options.flipHorizontally,this.set(o)):'vertical'===t?(o.flipVertically=!this._options.flipVertically,this.set(o)):void 0},t.prototype._hasAdjustments=function(){var e=this._options.adjustments;return 0!==e.getBrightness()||1!==e.getSaturation()||1!==e.getContrast()},t.prototype._onImageUpdate=function(){var e=this._options.image,t=this._operation.getSDK().getRenderer();this._isSVG&&t.isOfType(h.WEBGL)&&(e=this._canvas),this._inputTexture=u.Engine.Texture.fromImage(e),this._identitySprite.setTexture(this._inputTexture),this._sprite.setTexture(this._inputTexture),this._renderTexture&&(this._renderTextureSprite.setTexture(this._inputTexture),this._renderTexture.resizeTo(this._inputTexture.getDimensions())),this.setDirty(!0)},t.prototype.setOption=function(t,o){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;e.prototype.setOption.call(this,t,o,r),'image'===t&&this._identitySprite&&this._onImageUpdate()},t.prototype._onOptionsChange=function(){var e=this._dirtiness;for(var t in e)e[t]=!0},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._inputTexture.getBaseTexture().dispose(),this._inputTexture=null,this._options.adjustments.off('updated',this._onOptionsChange)},t}(f.default);m.prototype.availableOptions={id:{type:y.STRING,default:function(){return u.Utils.getUUID()}},identifier:{type:y.STRING,default:''},image:{type:y.IMAGE,required:!0},position:{type:y.VECTOR2,default:u.Vector2.NULL},dimensions:{type:y.VECTOR2,default:u.Vector2.NULL},anchor:{type:y.VECTOR2,default:new u.Vector2(0,0)},pivot:{type:y.VECTOR2,default:new u.Vector2(0.5,0.5)},rotation:{type:y.NUMBER,default:0},flipHorizontally:{type:y.BOOLEAN,default:!1},flipVertically:{type:y.BOOLEAN,default:!1},smoothDownscaling:{type:y.BOOLEAN,default:!1},tintColor:{type:y.COLOR,default:u.Color.WHITE},tintMode:{type:y.STRING,default:'none',available:['none','solid','colorized']},alpha:{type:y.NUMBER,default:1},adjustments:{type:y.CONFIGURABLE,structure:{brightness:{type:y.NUMBER,default:0},saturation:{type:y.NUMBER,default:1},contrast:{type:y.NUMBER,default:1}}}},m.type='sticker',t.default=m},function(e,t,o){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(0),n=a(i),l=o(1),d=a(l),p=o(2),u=a(p),_=o(3),f=o(43),c=a(f),g=o(205),y=a(g),h=_.Constants.OptionType,m=_.Constants.RendererType,x=function(e){function t(){(0,n.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var i=(0,d.default)(this,e.call.apply(e,[this].concat(r)));return i._textRenderer=new y.default(i,i._operation),i._textRenderer.rotation=i.getRotation(),i._sprite.setTexture(i._textRenderer.getFinalTexture()),i._hitTestSprite.setTexture(i._textRenderer.getTexture()),i}return(0,u.default)(t,e),t.prototype.serializeOptions=function(t){var o=1<arguments.length&&void 0!==arguments[1]&&arguments[1],r=e.prototype.serializeOptions.call(this,t,o);return t||(r.type='text'),r},t.prototype.getDOMStyle=function(e,t){var o=this.getFontSize()*t.y;return{fontWeight:this._options.fontWeight,fontSize:o+'px',fontStyle:this._options.fontStyle,fontFamily:this._options.fontFamily,lineHeight:s(o*this.getLineHeight())+'px',color:this._options.color.toRGBA(),backgroundColor:this._options.backgroundColor.toRGBA(),textAlign:this._options.alignment}},t.prototype.getDimensions=function(e,t){return this._textRenderer.getDimensions(e,t)},t.prototype.applyFlip=function(t){e.prototype.applyFlip.call(this,t);var o=this._options.rotation;'horizontal'===t?(o+=2*(r-o),this.setRotation(o)):'vertical'===t?(o+=2*(r/2-o),this.setRotation(o)):void 0},t.prototype.applyTransform=function(t){e.prototype.applyTransform.call(this,t),this.set({fontSize:t.scaleSize(this.getFontSize(),'y'),maxWidth:t.scaleSize(this.getMaxWidth(),'x')},!1)},t.prototype.applyRotation=function(t){e.prototype.applyRotation.call(this,t);var o=(t+360)%360,r=this._operation.getInputDimensions();(90==o||270==o)&&(this.setMaxWidth(this.getMaxWidth()/r.x*r.y),this.setFontSize(this.getFontSize()/r.y*r.x))},t.prototype.setOption=function(t,o){return'rotation'===t?(this._options.rotation=o,this._textRenderer&&(this._textRenderer.rotation=o),void(this._rotation=o)):void e.prototype.setOption.call(this,t,o)},t.prototype.getOption=function(t){return'rotation'===t?this._rotation:e.prototype.getOption.call(this,t)},t.prototype.getHitTestDisplayObject=function(){return this._hitTestSprite},t.prototype.update=function(t,o){this._textRenderer.update(t,o);var r=this._textRenderer.getFinalTexture(),a=r.getBaseTexture();a.update();var i=t.getRenderer();i.isOfType(m.WEBGL)&&i.updateTexture(r.getBaseTexture()),e.prototype.update.call(this,t,o),this._sprite.setRotation(0),this._textRenderer.getTexture().getBaseTexture().update(),this._hitTestSprite.setRotation(this._rotation),this._hitTestSprite.updateTransform()},t.prototype._getTexture=function(){return this._textRenderer.getFinalTexture()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._textRenderer.dispose()},t}(c.default);x.prototype.availableOptions={id:{type:h.STRING,default:function(){return _.Utils.getUUID()}},fontSize:{type:h.NUMBER,default:0.1},characterSpacing:{type:h.NUMBER,default:0},lineHeight:{type:h.NUMBER,default:1.1},fontIdentifier:{type:h.STRING},fontFamily:{type:h.STRING,default:'Times New Roman'},fontWeight:{type:h.ALL,default:'normal'},fontStyle:{type:h.STRING,default:'normal'},outlineWidth:{type:h.NUMBER,default:0},outlineColor:{type:h.COLOR,default:_.Color.BLACK},alignment:{type:h.STRING,default:'left',available:['left','center','right']},verticalAlignment:{type:h.STRING,default:'top',available:['top','center','bottom']},color:{type:h.COLOR,default:new _.Color(1,0,0,1)},backgroundColor:{type:h.COLOR,default:_.Color.TRANSPARENT},position:{type:h.VECTOR2,default:new _.Vector2(0.5,0.5)},anchor:{type:h.VECTOR2,default:new _.Vector2(0,0)},pivot:{type:h.VECTOR2,default:new _.Vector2(0.5,0.5)},rotation:{type:h.NUMBER,default:0},text:{type:h.STRING,required:!0},maxWidth:{type:h.NUMBER,default:0.5},maxHeight:{type:h.NUMBER,default:0}},x.type='text',t.default=x},function(e,r,a){'use strict';function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(r,'__esModule',{value:!0});var l=a(0),d=n(l),_=a(3),f=a(206),c=n(f),g=function(){function e(t,o){(0,d.default)(this,e),this._text=t,this._operation=o,this._textOptions={},this.rotation=0,this._createCanvas(),this._createMeasurementElement(),this._createTexture()}return e.prototype._createCanvas=function(){this._canvas=_.Utils.createCanvas(),this._context=this._canvas.getContext('2d'),this._textSplitter=new c.default(this._context),this._finalCanvas=_.Utils.createCanvas(),this._finalContext=this._finalCanvas.getContext('2d')},e.prototype._createMeasurementCanvas=function(){this._measurementCanvas=_.Utils.createCanvas(),this._measurementContext=this._measurementCanvas.getContext('2d')},e.prototype._createMeasurementElement=function(){var e=document.createElement('span');e.style.position='absolute',e.style.left='-9999px',e.style.top='-9999px',e.style.whiteSpace='nowrap',e.dataset&&(e.dataset.description='Measurement element for PhotoEditorSDK'),document.body.appendChild(e),this._measurementElement=e},e.prototype._createTexture=function(){this._texture=_.Engine.Texture.fromCanvas(this._canvas),this._finalTexture=_.Engine.Texture.fromCanvas(this._finalCanvas)},e.prototype._applyTextOptions=function(e,t){t.font=this._text.getFontStyle()+' '+this._text.getFontWeight()+' '+e.fontSize+'px '+this._text.getFontFamily(),t.textBaseline='top',t.textAlign=this._text.getAlignment(),t.fillStyle=this._text.getColor().toRGBA(),t.strokeStyle=this._text.getOutlineColor().toRGBA();var o=this._text.getOutlineWidth();0<o&&(t.lineWidth=o)},e.prototype._buildOutputLines=function(e){return this._textSplitter.setText(this._text.getText()),this._textSplitter.setMaxWidth(e),this._textSplitter.getLines()},e.prototype._renderTextLine=function(e,t){var o=this._text.getAlignment(),r=this._textOptions,a=r.lineHeight,i=r.fontSize,n=new _.Vector2(0,t+a/2-i/2);'center'===o?n.x=this._canvas.width/2:'right'===o?n.x=this._canvas.width:void 0,this._context.fillText(e,n.x,n.y);var l=this._text.getOutlineWidth();0<l&&(this._context.miterLimit=2,this._context.strokeText(e,n.x,n.y))},e.prototype.update=function(e,t){var o=this.calculateFontStyles(e,t),r=this._calculateText(e,o,t),a=r.dimensions,i=r.lines;this._renderText(e,a,i,o,t),this._updateFinalTexture()},e.prototype._updateFinalTexture=function(){var e=this._canvas,r=e.width,a=e.height,n=this.rotation,l=o(n),s=t(n),d=new _.Vector2(i(r*l)+i(a*s),i(r*s)+i(a*l));this._finalCanvas.width=d.x,this._finalCanvas.height=d.y,this._finalContext.save(),this._finalContext.translate(this._finalCanvas.width/2,this._finalCanvas.height/2),this._finalContext.rotate(n),this._finalContext.drawImage(this._canvas,-r/2,-a/2),this._finalContext.restore()},e.prototype._renderText=function(e,t,o,r,a){this._canvas.width=t.x,this._canvas.height=t.y,this._text.getMaxHeight()&&(this._canvas.height=p(this._text.getMaxHeight()*a.y,this._canvas.height)),this._context=this._canvas.getContext('2d'),this._context.fillStyle=this._text.getBackgroundColor().toRGBA(),this._context.fillRect(0,0,t.x,t.y),this._applyTextOptions(r,this._context);for(var i=0,n;i<o.length;i++)n=o[i],this._renderTextLine(n,r.lineHeight*i)},e.prototype.calculateFontStyles=function(e,t){var o=this._text.getFontFamily(),r=this._text.getFontSize()*t.y,a=s(this._text.getLineHeight()*r),i={fontFamily:o,fontSize:r,lineHeight:a};return(this._textOptions.fontFamily!==o||this._textOptions.fontSize!==r||this._textOptions.lineHeight!==a)&&(this._maxTextHeight=null,this._textOptions=i),i},e.prototype._calculateText=function(e,t,o){var r=this._text.getMaxWidth()*o.x;this._applyTextOptions(t,this._context);var a=new _.Vector2,i=this._text.getText().split('\n');if('undefined'!=typeof r)a.x=r,i=this._buildOutputLines(r);else for(var n=0,l;n<i.length;n++)l=i[n],a.x=u(a.x,this._context.measureText(l).width);var s=t.lineHeight,d=1.1*this._getMaxTextHeight(e,t,o);return a.y+=i.length*s+u(0,d-s),{dimensions:a,lines:i}},e.prototype._getMaxTextHeight=function(e,t,o){return this._maxTextHeight?this._maxTextHeight:(this._maxTextHeight=this._getMaxTextHeightUsingDOM(e,t,o),this._maxTextHeight)},e.prototype._getMaxTextHeightUsingDOM=function(e,t,o){var r=this._text.getDOMStyle(e,o),a=this._measurementElement,i=['lineHeight'];for(var n in r)-1===i.indexOf(n)&&(a.style[n]=r[n]);return a.innerHTML='!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~',a.offsetHeight},e.prototype._getMaxTextHeightUsingCanvas=function(e,t){var o=this._measurementCanvas,r=this._measurementContext,a=t.fontSize;o.width=10*a,o.height=2*a,this._applyTextOptions(t,this._measurementContext),r.textBaseline='middle',r.textAlign='center',r.fillStyle='black',r.clearRect(0,0,o.width,o.height);for(var i='!"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~',n=i.length,l=0,s;l<n;)s=i.substr(l,5),l+=5,r.fillText(s,o.width/2,o.height/2);var d=r.getImageData(0,0,o.width,o.height),p=d.data,u=null,_;for(_=0;_<o.height;_++){for(var f=!1,c=0;c<o.width;c++){var g=4*(_*o.width+c),y=p[g]+p[g+1]+p[g+2]+p[g+3];if(0<y){f=!0;break}}if(!f){u++;continue}break}var h=o.height;for(_=o.height-1;0<=_;_--){for(var m=!1,x=0;x<o.width;x++){var T=4*(_*o.width+x),v=p[T]+p[T+1]+p[T+2]+p[T+3];if(0<v){m=!0;break}}if(!m){h--;continue}break}return this._maxTextHeight=h-u,this._maxTextHeight},e.prototype.getTexture=function(){return this._texture},e.prototype.getFinalTexture=function(){return this._finalTexture},e.prototype.getDimensions=function(e,t){var o=this.calculateFontStyles(e,t),r=this._calculateText(e,o,t),a=r.dimensions;return a},e.prototype.dispose=function(){this._measurementElement&&document.body.removeChild(this._measurementElement),this._texture.getBaseTexture().dispose(),this._texture=null,this._finalTexture.getBaseTexture().dispose(),this._finalTexture=null},e}();r.default=g},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=function(){function e(t){(0,a.default)(this,e),this._context=t,this._lastFontStyle={}}return e.prototype.getLines=function(){for(var e=[],t=[],o=this._lines.length,r=0;r<o;r++){for(var a=this._lines[r],i=this._buildWords(a),n=i.length,l=0;l<n;l++){var s=i[l],d=t.concat(s).join('').replace(/\s+$/i,''),p=this._getWidth(d);if(p>this._maxWidth){0<t.length&&(e.push(t.join('')),t=[s]);var u=s.replace(/\s+$/i,'');if(this._getWidth(u)>this._maxWidth){var _=this._splitWord(s);e=e.concat(_.lines),_.rest&&(t=[_.rest])}}else t.push(s)}e.push(t.join('')),t=[]}return e},e.prototype._buildWords=function(e){for(var t=[],o='',r=e.length,a=0,i;a<r;a++)i=e[a],o+=i,(' '===i||'-'===i||a===r-1)&&(t.push(o),o='');return t},e.prototype._splitWord=function(e){for(var t={lines:[],rest:null},o=e.length,r=[],a=0,i;a<o;a++)i=e[a],this._getWidth(r.concat(i).join(''))>this._maxWidth?(0<r.length&&t.lines.push(r.join('')),r=[i]):r.push(i),a===o-1&&0<r.length&&(t.rest=r.join(''));return t},e.prototype._fontStyleChanged=function(){return this._context.font!==this._lastFontStyle&&(this._lastFontStyle=this._context.font,!0)},e.prototype._getWidth=function(e){return this._context.measureText(e).width},e.prototype.setText=function(e){this._text=e,this._lines=e.split('\n')},e.prototype.setMaxWidth=function(e){this._maxWidth=e},e}();t.default=i},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),s=r(n),d=o(2),u=r(d),_=o(3),f=o(208),c=r(f),g=_.Constants.OptionType,y=function(e){function t(o,r,a){(0,i.default)(this,t);var n=(0,s.default)(this,e.call(this,r));return n._operation=o,n._canvas=a||_.Utils.createCanvas(),n._context=n._canvas.getContext('2d'),n}return(0,u.default)(t,e),t.prototype.serializeOption=function(t){var o=1<arguments.length&&void 0!==arguments[1]&&arguments[1];return'controlPoints'===t?this._options.controlPoints.map(function(e){var t=e.getPosition();return o?t.toObject():t.clone()}):e.prototype.serializeOption.call(this,t,o)},t.prototype._optionEquals=function(t,o){if('controlPoints'===t){for(var r=this._options.controlPoints,a=0,i=r.length;a<i;a++)if(!r[a].getPosition().equals(o[a]))return!1;return!0}return e.prototype._optionEquals.call(this,t,o)},t.prototype.render=function(e){var t=this._options,o=t.controlPoints,r=t.size;if(!(2>o.length)){_.Utils.ensureCanvasDimensions(this._canvas,e),this._brush&&this._lastBrushSize===r&&e.equals(this._brushInputDimensions)||(this._brushInputDimensions=e.clone(),this._lastBrushSize=r);for(var a=o[0],n=a,l=1;l<o.length;l++)n=o[l],n.renderToCanvas(this._options.brush.getBrushImage(e),this._canvas,a),a=n}},t.prototype._createBrush=function(e){var t=this._options,o=t.size,r=t.hardness,a=t.color,i=_.Utils.createCanvas();i.width=i.height=l(o*e.min());var n=i.getContext('2d');if(a=a.clone(),a.a=1,1===i.width)n.fillStyle=a.toRGBA(),n.fillRect(0,0,1,1);else{var s=n.createRadialGradient(i.width/2,i.height/2,p(i.width/2-1,i.width/2*r),i.width/2,i.height/2,i.width/2);s.addColorStop(0,a.toRGBA());var d=a.clone();d.a=0,s.addColorStop(1,d.toRGBA()),n.fillStyle=s,n.fillRect(0,0,i.width,i.height)}return i},t.prototype.addControlPoint=function(e){var t=new c.default(this,e);this._options.controlPoints.push(t),this.emit('update',this)},t.prototype.getCanvas=function(){return this._canvas},t.prototype.setCanvas=function(e){this._canvas=e,this._context=e.getContext('2d')},t.prototype.setDirty=function(){this._context.clearRect(0,0,this._canvas.width,this._canvas.height),this._options.controlPoints.forEach(function(e){e.setDirty()})},t.prototype.forEachControlPoint=function(e){this._options.controlPoints.forEach(e)},t.prototype.renderToCanvas=function(e){var t=e.getContext('2d');t.save(),t.globalAlpha=this._options.brush.getColor().a,t.drawImage(this._canvas,0,0),t.restore()},t.prototype.getCanvasDimensions=function(){return this._canvasDimensions},t}(_.Configurable);y.prototype.availableOptions={id:{type:g.STRING,default:function(){return _.Utils.getUUID()}},brush:{type:g.OBJECT,required:!0},controlPoints:{type:g.ARRAY,default:[]},closed:{type:g.BOOLEAN,default:!1}},t.default=y},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),n=o(3),i=function(){function e(t,o){(0,a.default)(this,e),this._path=t,this._drawnCanvases=[],this._position=o}return e.prototype.renderToCanvas=function(e,o,r){if(-1===this._drawnCanvases.indexOf(o)){for(var a=new n.Vector2(o.width,o.height),l=o.getContext('2d'),s=this._position.clone().multiply(a),d=r.getPosition().clone().multiply(a),_=s.clone().subtract(d).len(),f=e.width/10,c=0;c<=_;){var i=u(0,p(1,c/_)),t=d.x+(s.x-d.x)*i,g=d.y+(s.y-d.y)*i;l.drawImage(e,t-e.width/2,g-e.height/2,e.width,e.height),c+=f}this._drawnCanvases.push(o)}},e.prototype.setPosition=function(e){this._position=e},e.prototype.getPosition=function(){return this._position.clone()},e.prototype.setDirty=function(){this._drawnCanvases=[]},e}();t.default=i},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),s=r(n),d=o(2),u=r(d),_=o(3),f=o(95),c=r(f),g=_.Constants.OptionType,y=function(e){function t(){return(0,i.default)(this,t),(0,s.default)(this,e.apply(this,arguments))}return(0,u.default)(t,e),t.prototype.getBrushImage=function(e){if(this._brush&&this.optionsEqual(this._lastOptions)&&e.equals(this._lastInputDimensions))return this._brush;var t=this._options,o=t.size,r=t.hardness,a=t.color,i=_.Utils.createCanvas();i.width=i.height=l(o*e.min());var n=i.getContext('2d');if(a=a.clone(),a.a=1,1===i.width)n.fillStyle=a.toRGBA(),n.fillRect(0,0,1,1);else{var s=n.createRadialGradient(i.width/2,i.height/2,p(i.width/2-1,i.width/2*r),i.width/2,i.height/2,i.width/2);s.addColorStop(0,a.toRGBA());var d=a.clone();d.a=0,s.addColorStop(1,d.toRGBA()),n.fillStyle=s,n.fillRect(0,0,i.width,i.height)}return this._lastOptions=this.serializeOptions(['size','color','hardness']),this._brush=i,this._lastInputDimensions=e.clone(),i},t}(c.default);t.default=y,y.identifier='imgly_brush_radial',y.prototype.availableOptions=_.Utils.extend(c.default.prototype.availableOptions,{hardness:{type:g.NUMBER,default:1}})},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=p.Constants.OptionType,c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._watermarkSprite=new p.Engine.Sprite,n._watermarkSprite.setAnchor(0.5,0.5),n._container.addChild(n._watermarkSprite),n}return(0,d.default)(t,e),t.prototype._render=function(e){this._watermarkTexture||(this._watermarkTexture=p.Engine.Texture.fromImage(this._options.image),this._watermarkSprite.setTexture(this._watermarkTexture));var t=e.getDimensions(),o=this._options.image,r=o.width,a=o.height,i=p.Utils.resizeVectorToFit(new p.Vector2(r,a),t);return this._watermarkSprite.setPosition(t.clone().divide(2)),this._watermarkSprite.setWidth(i.x),this._watermarkSprite.setHeight(i.y),this._renderTexture.render(this._container),p.Promise.resolve()},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._watermarkSprite.dispose()},t}(_.default);c.identifier='watermark',c.prototype.availableOptions={image:{type:f.OBJECT,required:!0}},t.default=c},function(e,t,o){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var i=o(0),n=a(i),l=o(1),s=a(l),d=o(2),p=a(d),u=o(3),_=o(7),f=a(_),c=o(21),g=a(c),y=o(8),h=a(y),m=u.Constants.OptionType,x=function(e){function t(){return(0,n.default)(this,t),(0,s.default)(this,e.apply(this,arguments))}return(0,p.default)(t,e),t.prototype._getRotation=function(){var e=0;switch(this.getTags().Orientation){case 7:case 8:e=-90;break;case 3:case 4:e=-180;break;case 5:case 6:e=90;}return e},t.prototype._getFlipVertically=function(){var e=this.getTags(),t=e.Orientation;return-1!==[5,7].indexOf(t)},t.prototype._getFlipHorizontally=function(){var e=this.getTags(),t=e.Orientation;return-1!==[2,4].indexOf(t)},t.prototype._getFinalOptions=function(){return{rotation:this._getRotation(),flipVertically:this._getFlipVertically(),flipHorizontally:this._getFlipHorizontally()}},t.prototype._render=function(){var e=this._getFinalOptions(),t=e.rotation%360;this._sprite.setScale(e.flipHorizontally?-1:1,e.flipVertically?-1:1),this._sprite.setRotation(t*(r/180)),this._sprite.setAnchor(0.5,0.5),this._sprite.updateTransform();var o=this._sprite.getBounds();return this._renderTexture.resizeTo(new g.default(o.width,o.height)),this._sprite.setPosition(this._renderTexture.getDimensions().divide(2)),this._renderTexture.render(this._container),f.default.resolve()},t.prototype.getNewDimensions=function(e){var t=this._getFinalOptions();return e=e.clone(),t.rotation%180&&e.flip(),e},t}(h.default);x.identifier='exif-orientation',x.prototype.availableOptions={tags:{type:m.OBJECT,default:{}}},t.default=x},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(94),c=r(f),g=o(7),y=r(g),h=o(96),m=r(h),x=o(214),T=r(x),v=p.Constants.OptionType,b=p.Constants.RendererType,C=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r))),s=n._sdk.getRenderer();n._lastBlurRadius=null,n._blurredRenderTexture=new p.Engine.RenderTexture(s,100,100,1),n._maskRenderTexture=new p.Engine.RenderTexture(s,100,100,1),n._brushSprite=new c.default(n),n._brushSpriteContainer=new p.Engine.Container;var d=n._brushSprite.getDisplayObject();if(n._brushSpriteContainer.addChild(d),n._outputSprite=new p.Engine.Sprite,n._outputContainer=new p.Engine.Container,n._outputContainer.addChild(n._outputSprite),n._maskFilter=new T.default,s.isOfType(b.WEBGL)){n._horizontalFilter=new m.default,n._verticalFilter=new m.default,n._sprite.setFilters([n._horizontalFilter,n._verticalFilter]),n._horizontalFilter.setDelta(new p.Vector2(1,1)),n._verticalFilter.setDelta(new p.Vector2(-1,1));var u=n._maskRenderTexture.getBaseTexture();u.setGLUnit(n._maskFilter.getMaskImage()),s.updateTexture(u,!1),u=n._blurredRenderTexture.getBaseTexture(),u.setGLUnit(n._maskFilter.getFilterImage()),s.updateTexture(u,!1)}else s.isOfType(b.CANVAS)&&(n._blurFilter=new m.default,n._sprite.setFilters([n._blurFilter]),n._maskFilter.setMaskCanvas(n._maskRenderTexture.getRenderTarget().getCanvas()),n._maskFilter.setFilterCanvas(n._blurredRenderTexture.getRenderTarget().getCanvas()));return n._outputSprite.setFilters([n._maskFilter]),n}return(0,d.default)(t,e),t.prototype.flip=function(e){this._brushSprite.applyFlip(e),this.setDirty(!0,!0),this._lastBlurRadius=null},t.prototype.rotate=function(e){this._brushSprite.applyRotation(e),this.setDirty(!0,!0),this._lastBlurRadius=null},t.prototype.transform=function(e,t){this._brushSprite.applyTransform(e,t),this.setDirty(!0,!0),this._lastBlurRadius=null},t.prototype._render=function(e){return this._renderBlur(e),this._renderMask(e),this._outputSprite.setTexture(e),this._renderTexture.render(this._outputContainer),y.default.resolve()},t.prototype._renderMask=function(e){var t=e.getDimensions(),o=this._maskRenderTexture.getDimensions();o.equals(t)||this._maskRenderTexture.resizeTo(t),this._brushSprite.update(this._sdk,t),this._maskRenderTexture.clear(p.Color.BLACK),this._maskRenderTexture.render(this._brushSpriteContainer);var r=this._sdk.getRenderer();r.isOfType(b.WEBGL)&&r.updateTexture(this._maskRenderTexture.getBaseTexture(),!1)},t.prototype._renderBlur=function(e){var t=e.getDimensions(),o=this._blurredRenderTexture.getDimensions();o.equals(t)||this._blurredRenderTexture.resizeTo(t);var r=this._options.blurRadius;if(this._lastBlurRadius!==r||!o.equals(t)){var a=this._sdk.getRenderer(),i;if(a.isOfType(b.WEBGL)){var n=t.min();i={blurRadius:r*n,texSize:t},this._horizontalFilter.set(i),this._verticalFilter.set(i)}else a.isOfType(b.CANVAS)&&(i={blurRadius:r},this._blurFilter.set(i));this._blurredRenderTexture.render(this._container),this._lastBlurRadius=r}},t.prototype.getBrush=function(){return this._brushSprite},t.prototype.createPath=function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:1,o=new c.default.Brushes.RadialBrush({size:e,hardness:t,color:p.Color.WHITE}),r=this._brushSprite.createPath(o);return this._options.paths.push(r),this.setDirty(!0),r},t.prototype.setDirtyForRenderer=function(t,o,r){e.prototype.setDirtyForRenderer.call(this,t,o,r),this._brushSprite.setDirtyForRenderer(t,o,r)},t.prototype.dispose=function(){e.prototype.dispose.call(this);var t=this._sdk.getRenderer();t.isOfType(b.WEBGL)?(this._verticalFilter.dispose(),this._horizontalFilter.dispose()):this._blurFilter.dispose(),this._brushSprite.dispose(),this._maskFilter.dispose(),this._blurredRenderTexture.dispose(),this._maskRenderTexture.dispose()},t}(_.default);C.identifier='selective-blur',C.prototype.availableOptions={blurRadius:{type:v.NUMBER,default:0.05},paths:{type:v.ARRAY,default:[],setter:function(e){return this._brushSprite&&this._brushSprite.setPaths(e),e}}},t.default=C},function(e){e.exports='/*\n * Based on evanw\'s glfx.js tilt shift shader:\n * https://github.com/evanw/glfx.js/blob/master/src/filters/blur/tiltshift.js\n * @license\n */\n\nuniform sampler2D u_image;\nuniform float u_blurRadius;\nuniform vec2 u_delta;\nuniform vec2 u_texSize;\nvarying vec2 v_texCoord;\n\nfloat random(vec2 co)\n{\n    highp float a = 12.9898;\n    highp float b = 78.233;\n    highp float c = 43758.5453;\n    highp float dt = dot(co.xy,vec2(a,b));\n    highp float sn = mod(dt, 3.14);\n    return fract(sin(sn) * c);\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    float total = 0.0;\n\n    float offset = random(gl_FragCoord.xy / u_texSize.xy);\n    float radius = u_blurRadius;\n\n    for (float t = -30.0; t <= 30.0; t++) {\n        float percent = (t + offset - 0.5) / 30.0;\n        float weight = 1.0 - abs(percent);\n\n        // Somehow `sample` is a keyword in headless-gl\n        vec4 _sample = texture2D(u_image, v_texCoord + u_delta * percent * radius / u_texSize);\n\n        _sample.rgb *= _sample.a;\n\n        color += _sample * weight;\n        total += weight;\n    }\n\n    gl_FragColor = color / total;\n    gl_FragColor.rgb /= gl_FragColor.a + 0.00001;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=p.Constants.OptionType,_=p.Constants.UniformType,f=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(215),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),n=t.getContext(),l=o.getContext(),s=this._options,d=s.maskCanvas,p=s.filterCanvas,u=d.getContext('2d'),_=p.getContext('2d'),f=u.getImageData(0,0,a.width,a.height).data,c=n.getImageData(0,0,a.width,a.height),g=c.data,y=_.getImageData(0,0,a.width,a.height).data,h=void 0,m=0;m<4*(a.width*a.height);m+=4)h=f[m]/255,g[m]=h*y[m]+(1-h)*g[m],g[m+1]=h*y[m+1]+(1-h)*g[m+1],g[m+2]=h*y[m+2]+(1-h)*g[m+2];l.putImageData(c,0,0)},t}(p.Engine.Filter);f.prototype.availableOptions={maskImage:{type:u.NUMBER,default:1,uniformType:_.INT},maskCanvas:{type:u.OBJECT,default:null},filterImage:{type:u.NUMBER,default:2,uniformType:_.INT},filterCanvas:{type:u.OBJECT,default:null}},t.default=f},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_filterImage;\nuniform sampler2D u_maskImage;\n\nvoid main() {\n  vec4 color0 = texture2D(u_image, v_texCoord);\n  vec4 color1 = texture2D(u_filterImage, v_texCoord);\n  vec4 mask = texture2D(u_maskImage, v_texCoord);\n  gl_FragColor = mix(color0, color1, mask);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=o(7),c=r(f),g=o(96),y=r(g),h=p.Constants.OptionType,m=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._lastBlurRadius=n._options.blurRadius,n._horizontalFilter=new y.default,n._verticalFilter=new y.default,n._sprite.setFilters([n._horizontalFilter,n._verticalFilter]),n._horizontalFilter.setDelta(new p.Vector2(1,1)),n._verticalFilter.setDelta(new p.Vector2(-1,1)),n._filter=new y.default,n}return(0,d.default)(t,e),t.prototype._renderWebGL=function(e){var t=e.getDimensions(),o=t.min(),r=this._options.blurRadius,a={blurRadius:r*o,texSize:t};return this._horizontalFilter.set(a),this._verticalFilter.set(a),this._renderTexture.render(this._container),c.default.resolve()},t.prototype._renderCanvas=function(e){var t=this._options.blurRadius,o=e.getDimensions();return this._filter.set({blurRadius:t,texSize:o}),this._sprite.setFilters([this._filter]),this._renderTexture.render(this._container),c.default.resolve()},t.prototype.transform=function(e){var t=this.getBlurRadius(),o=e.applyToRelativeSize(t);this.set({blurRadius:o},!1)},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._filter.dispose(),this._verticalFilter.dispose(),this._horizontalFilter.dispose()},t}(_.default);m.identifier='blur',m.prototype.availableOptions={blurRadius:{type:h.NUMBER,default:0.025}},t.default=m},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(8),_=r(u),f=p.Engine.Filters.OverlayFilter,c=p.Constants.OptionType,g=p.Constants.RendererType,y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._overlayTexture=p.Engine.Texture.fromImage(n._options.image),n._overlayContainer=new p.Engine.Container,n._overlaySprite=new p.Engine.Sprite,n._overlaySprite.setTexture(n._overlayTexture),n._overlaySprite.setAnchor(0,0),n._overlayContainer.addChild(n._overlaySprite),n._overlayFilter=new p.Engine.Filters.OverlayFilter({overlayImage:n._overlayTexture.getBaseTexture().getGLUnit(),overlayTexture:n._overlayTexture}),n._sprite.setFilters([n._overlayFilter]),n._renderedOverlaySprite=new p.Engine.Sprite,n._renderedOverlayContainer=new p.Engine.Container,n._renderedOverlayContainer.addChild(n._renderedOverlaySprite),n._overlayRendered=!1,n._lastInputDimensions=new p.Vector2(0,0),n}return(0,d.default)(t,e),t.prototype.setOption=function(t,o){if(e.prototype.setOption.call(this,t,o),'image'===t&&o&&this._sdk){var r=this._sdk.getRenderer(),a=this._overlayTexture.getBaseTexture();a.setSource(o),r.isOfType(g.WEBGL)&&r.updateTexture(a),this._overlayRendered=!1}},t.prototype._render=function(e){var t=e.getDimensions(),o=this._options,r=o.image,a=o.alpha,i=o.blendMode;return r?(this._overlayRendered&&this._lastInputDimensions.equals(t)||(this._renderOverlayToRenderTexture(e),this._overlayRendered=!0,this._lastInputDimensions.copy(t)),this._overlayFilter.set({blendMode:i,overlayImage:this._overlayRenderTexture.getBaseTexture().getGLUnit(),overlayTexture:this._overlayRenderTexture,alpha:a}),this._sprite.setFilters([this._overlayFilter]),this._renderTexture.render(this._container),p.Promise.resolve(this._renderTexture)):(this._sprite.setFilters([]),this._renderTexture.render(this._container),p.Promise.resolve())},t.prototype._renderOverlayToRenderTexture=function(e){var t=this._sdk.getRenderer(),o=e.getDimensions();this._overlayRenderTexture||(this._overlayRenderTexture=new p.Engine.RenderTexture(t,o.x,o.y),this._renderedOverlaySprite.setTexture(this._overlayRenderTexture));var r=this._options.image,a=r.width,i=r.height,n=p.Utils.resizeVectorToFill(new p.Vector2(a,i),o);this._overlaySprite.setWidth(n.x),this._overlaySprite.setHeight(n.y);var l=this._overlayRenderTexture.getBaseTexture();t.isOfType(g.WEBGL)&&(l.setGLUnit(4),t.updateTexture(l,!1)),this._overlayRenderTexture.resizeTo(o),this._overlayRenderTexture.render(this._overlayContainer)},t.prototype.dispose=function(){e.prototype.dispose.call(this),this._overlaySprite.dispose()},t}(_.default);y.identifier='overlay',y.BLEND_MODES=f.BLEND_MODES,y.prototype.availableOptions={identifier:{type:c.STRING},image:{type:c.IMAGE},blendMode:{type:c.NUMBER,default:f.BLEND_MODES.MULTIPLY,available:Object.keys(f.BLEND_MODES).map(function(e){return f.BLEND_MODES[e]})},alpha:{type:c.NUMBER,default:1}},t.default=y},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=o(3),n='imglySDKVersionCallback',l=function(){function e(t){(0,a.default)(this,e),this._version=t,this._check()}return e.prototype._check=function(){var e=this;if('undefined'==typeof document)return i.Log.info(this.constructor.name,'Not in browser environment. Version check skipped.');var t=this;window[n]=function(o){o.outdated&&i.Log.warn(e.constructor.name,'Your Version '+t._version+' is outdated. Current version is '+o.version+'.')};var o=document.createElement('script');o.src='https://www.photoeditorsdk.com/version.json?sdk=html5&jsoncallback='+n+'&version='+this._version,o.async=!0,document.getElementsByTagName('head')[0].appendChild(o)},e}();t.default=l},function(e,t,o){'use strict';Object.defineProperty(t,'__esModule',{value:!0});var r=o(0),i=function(e){return e&&e.__esModule?e:{default:e}}(r),n=function(){function e(t){(0,i.default)(this,e),this._head=0,this._buf=t}return e.prototype.peekInt8=function(){return this._buf[this._head]},e.prototype.peekInt16=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this._buf[this._head],o=this._buf[this._head+1];return e?(o<<8)+t:(t<<8)+o},e.prototype.peekInt24=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this._buf[this._head],o=this._buf[this._head+1],r=this._buf[this._head+2];return e?(r<<16)+(o<<8)+t:(t<<16)+(o<<8)+r},e.prototype.peekInt32=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this._buf[this._head],o=this._buf[this._head+1],r=this._buf[this._head+2],a=this._buf[this._head+3];return e?(a<<32)+(r<<16)+(o<<8)+t:(t<<32)+(o<<16)+(r<<8)+a},e.prototype.writeInt16=function(e){this._buf[this._head]=e>>8,this._buf[this._head+1]=255&e},e.prototype.readInt8=function(){var e=this.peekInt8();return this._head+=1,e},e.prototype.readInt16=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this.peekInt16(e);return this._head+=2,t},e.prototype.readInt24=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this.peekInt24(e);return this._head+=3,t},e.prototype.readInt32=function(){var e=0<arguments.length&&void 0!==arguments[0]&&arguments[0],t=this.peekInt32(e);return this._head+=4,t},e.prototype.readString=function(e){for(var t='',o=0,r;o<e;o++)r=this.readInt8(),t+=a(r);return t},e.prototype.getHead=function(){return this._head},e.prototype.setHead=function(e){this._head=e},e}();t.default=n},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(10),u=o(11),_=r(u),f=o(26),c=r(f),g=o(66),y=r(g),h=o(16),m=r(h),x=function(e){function t(o){var r=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};(0,i.default)(this,t);var a=(0,l.default)(this,e.call(this,r));return a._sdk=o,a}return(0,d.default)(t,e),t.prototype.export=function(){var e=this,t=this._sdk.getRenderer(),o=this._options,r=o.renderType,a=o.imageFormat,i=o.quality;return this.validateSettings().then(function(){return e._prepareSDK()}).then(function(o){var n=t.getCanvas();t.isOfType(p.RendererType.WEBGL)&&(n=e._createCanvasFromTexture(o));var l;if(r===p.RenderType.IMAGE||r===p.RenderType.DATAURL){l='undefined'==typeof window?n.toDataURL(a):n.toDataURL(a,i);var s=e._sdk.getImage();if(y.default.isJPEG(s.src)&&y.default.isJPEG(l)){var d=e._sdk.getExif();d&&(l=d.restoreExifTags(l))}}if(r===p.RenderType.IMAGE){var u;return u=new Image,u.src=l,u}return r===p.RenderType.DATAURL?l:r===p.RenderType.BUFFER?n.toBuffer():r===p.RenderType.MSBLOB?n.msToBlob():r===p.RenderType.BLOB?new Promise(function(e){n.toBlob(function(t){e(t)},a,i)}):void 0}).then(function(t){return e._restoreSDK().then(function(){return t})})},t.prototype._prepareSDK=function(){var e=this._sdk.getRenderer();this._sdkSettings={dimensions:e.getDimensions().clone(),textureQuality:this._sdk.getTextureQuality(),pixelRatio:this._sdk.getPixelRatio(),renderMode:this._sdk.getRenderMode()},this._sdk.setRenderMode('export'),this._sdk.setTextureQuality(1);var t=e.isOfType(p.RendererType.CANVAS);e.setPixelRatio(1),e.resizeTo(this._sdk.getFinalDimensions(),t),this._sdk.setAllOperationsToDirty(!0);var o=this._sdk.getOperationsStack();return o.forEach(function(e){e.disposeRenderTextures()}),o.disableCache(),this._sdk.render()},t.prototype._restoreSDK=function(){var e=this._sdk.getOperationsStack();e.enableCache(),this._sdk.setRenderMode(this._sdkSettings.renderMode);var t=this._sdk.getRenderer(),o=t.isOfType(p.RendererType.CANVAS);return t.setPixelRatio(this._sdkSettings.pixelRatio),t.resizeTo(this._sdkSettings.dimensions,o),this._sdk.setTextureQuality(this._sdkSettings.textureQuality),this._sdk.setAllOperationsToDirty(!0),this._sdk.render()},t.prototype._createCanvasFromTexture=function(e){var t=this._sdk.getRenderer(),o=this._sdk.getFinalDimensions(),r=this._sdk.getRenderer().getContext(),a=r.createFramebuffer();r.bindFramebuffer(r.FRAMEBUFFER,a);var i=e.getBaseTexture().getGLTextureForRenderer(t);r.framebufferTexture2D(r.FRAMEBUFFER,r.COLOR_ATTACHMENT0,r.TEXTURE_2D,i,0);var n=new Uint8Array(4*(o.x*o.y));r.readPixels(0,0,o.x,o.y,r.RGBA,r.UNSIGNED_BYTE,n);var l=this._checkPixelsForTransparency(n),s;if(l){var d=new _.default.Sprite(e);d.setFilters([new _.default.Filters.UnpremultiplyFilter]);var p=new _.default.Container;p.addChild(d),s=new _.default.RenderTexture(t,o.x,o.y),s.render(p);var u=s.getBaseTexture().getGLTextureForRenderer(t);r.framebufferTexture2D(r.FRAMEBUFFER,r.COLOR_ATTACHMENT0,r.TEXTURE_2D,u,0),r.readPixels(0,0,o.x,o.y,r.RGBA,r.UNSIGNED_BYTE,n),t.setRenderTarget(),s.dispose()}var f=c.default.createCanvas();f.width=o.x,f.height=o.y;var g=f.getContext('2d'),y=g.createImageData(o.x,o.y);return y.data.set(n),g.putImageData(y,0,0),r.deleteFramebuffer(a),f},t.prototype._checkPixelsForTransparency=function(e){for(var t=this._sdk.getFinalDimensions(),o=4*(t.x*t.y),r=void 0,a=3;a<o;a+=4)if(r=e[a],255!==r)return!0;return!1},t}(m.default);x.prototype.availableOptions={renderType:{type:p.OptionType.STRING,available:c.default.values(p.RenderType),default:p.RenderType.IMAGE},imageFormat:{type:p.OptionType.STRING,available:c.default.values(p.ImageFormat),default:p.ImageFormat.PNG},quality:{type:p.OptionType.NUMBER,default:0.8}},t.default=x},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(92);Object.defineProperty(t,'IdentityFilter',{enumerable:!0,get:function(){return r(a).default}});var i=o(222);Object.defineProperty(t,'A15Filter',{enumerable:!0,get:function(){return r(i).default}});var n=o(251);Object.defineProperty(t,'BreezeFilter',{enumerable:!0,get:function(){return r(n).default}});var l=o(252);Object.defineProperty(t,'BWFilter',{enumerable:!0,get:function(){return r(l).default}});var s=o(253);Object.defineProperty(t,'BWHardFilter',{enumerable:!0,get:function(){return r(s).default}});var d=o(254);Object.defineProperty(t,'CelsiusFilter',{enumerable:!0,get:function(){return r(d).default}});var p=o(255);Object.defineProperty(t,'ChestFilter',{enumerable:!0,get:function(){return r(p).default}});var u=o(256);Object.defineProperty(t,'FixieFilter',{enumerable:!0,get:function(){return r(u).default}});var _=o(257);Object.defineProperty(t,'FoodFilter',{enumerable:!0,get:function(){return r(_).default}});var f=o(258);Object.defineProperty(t,'FridgeFilter',{enumerable:!0,get:function(){return r(f).default}});var c=o(259);Object.defineProperty(t,'FrontFilter',{enumerable:!0,get:function(){return r(c).default}});var g=o(260);Object.defineProperty(t,'GlamFilter',{enumerable:!0,get:function(){return r(g).default}});var y=o(261);Object.defineProperty(t,'GobblinFilter',{enumerable:!0,get:function(){return r(y).default}});var h=o(262);Object.defineProperty(t,'K1Filter',{enumerable:!0,get:function(){return r(h).default}});var m=o(263);Object.defineProperty(t,'K2Filter',{enumerable:!0,get:function(){return r(m).default}});var x=o(264);Object.defineProperty(t,'K6Filter',{enumerable:!0,get:function(){return r(x).default}});var T=o(265);Object.defineProperty(t,'KDynamicFilter',{enumerable:!0,get:function(){return r(T).default}});var v=o(266);Object.defineProperty(t,'LeninFilter',{enumerable:!0,get:function(){return r(v).default}});var b=o(267);Object.defineProperty(t,'LomoFilter',{enumerable:!0,get:function(){return r(b).default}});var C=o(268);Object.defineProperty(t,'MellowFilter',{enumerable:!0,get:function(){return r(C).default}});var R=o(269);Object.defineProperty(t,'MetalFilter',{enumerable:!0,get:function(){return r(R).default}});var O=o(270);Object.defineProperty(t,'MorningFilter',{enumerable:!0,get:function(){return r(O).default}});var E=o(271);Object.defineProperty(t,'OrchidFilter',{enumerable:!0,get:function(){return r(E).default}});var S=o(272);Object.defineProperty(t,'PolaFilter',{enumerable:!0,get:function(){return r(S).default}});var F=o(273);Object.defineProperty(t,'Pola669Filter',{enumerable:!0,get:function(){return r(F).default}});var M=o(274);Object.defineProperty(t,'QuoziFilter',{enumerable:!0,get:function(){return r(M).default}});var k=o(275);Object.defineProperty(t,'SemiredFilter',{enumerable:!0,get:function(){return r(k).default}});var P=o(276);Object.defineProperty(t,'SunnyFilter',{enumerable:!0,get:function(){return r(P).default}});var D=o(277);Object.defineProperty(t,'TexasFilter',{enumerable:!0,get:function(){return r(D).default}});var B=o(278);Object.defineProperty(t,'X400Filter',{enumerable:!0,get:function(){return r(B).default}});var I=o(279);Object.defineProperty(t,'LUTFilter',{enumerable:!0,get:function(){return r(I).default}});var w=o(280);Object.defineProperty(t,'ThreeDLUTFilter',{enumerable:!0,get:function(){return r(w).default}})},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Contrast({contrast:0.63})),n._stack.push(new f.Brightness({brightness:0.12})),n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,38],[94,94],[148,142],[175,187],[255,255]],green:[[0,0],[77,53],[171,190],[255,255]],blue:[[0,10],[48,85],[174,228],[255,255]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='a15',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(9),_=r(u),f=o(10),c=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(224),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),n=t.getContext(),l=o.getContext(),s=n.getImageData(0,0,a.width,a.height),d=this._options.brightness;if(0!==d){d*=255;for(var p=0,i;p<a.width*a.height;p++)i=4*p,s.data[i]+=d,s.data[i+1]+=d,s.data[i+2]+=d;l.putImageData(s,0,0)}},t}(p.Engine.Filter);c.prototype.availableOptions={brightness:{type:f.OptionType.NUMBER,default:0,uniformType:f.UniformType.FLOAT}};var g=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new c,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setBrightness(this._options.brightness)},t}(_.default);g.prototype.availableOptions=c.prototype.availableOptions,t.default=g},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_brightness;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4((texColor.rgb + vec3(u_brightness) * texColor.a), texColor.a);;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(9),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(226),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),n=t.getContext(),l=o.getContext(),s=n.getImageData(0,0,a.width,a.height),d=this._options.contrast;if(1!==d){for(var p=0,i;p<a.width*a.height;p++)i=4*p,s.data[i]=(s.data[i]-127)*d+127,s.data[i+1]=(s.data[i+1]-127)*d+127,s.data[i+2]=(s.data[i+2]-127)*d+127;l.putImageData(s,0,0)}},t}(p.Engine.Filter);g.prototype.availableOptions={contrast:{type:f.NUMBER,default:1,uniformType:c.FLOAT}};var y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new g,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setContrast(this._options.contrast)},t}(_.default);y.prototype.availableOptions=g.prototype.availableOptions,t.default=y},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_contrast;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = vec4(((texColor.rgb - vec3(0.5)) * u_contrast + vec3(0.5) * texColor.a), texColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(9),_=r(u),f=p.Constants.OptionType,c=p.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(228),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),n=t.getContext(),l=o.getContext(),s=n.getImageData(0,0,a.width,a.height),d=this._options.colorMatrix,u=new p.Color(0,0,0,0),_=0,i;_<a.width*a.height;_++)i=4*_,u.r=s.data[i]/255,u.g=s.data[i+1]/255,u.b=s.data[i+2]/255,u=d.apply(u),s.data[i]=255*u.r,s.data[i+1]=255*u.g,s.data[i+2]=255*u.b;l.putImageData(s,0,0)},t}(p.Engine.Filter);g.prototype.availableOptions={colorMatrix:{type:f.COLOR_MATRIX,default:new p.ColorMatrix,uniformType:c.MAT4},colorMatrixOffset:{type:f.ARRAY,default:[],uniformType:c.FLOAT4}};var y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new g,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setColorMatrix(this._options.colorMatrix)},t}(_.default);y.prototype.availableOptions=g.prototype.availableOptions,t.default=y},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform mat4 u_colorMatrix;\nuniform vec4 u_colorMatrixOffset;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  gl_FragColor = texColor * u_colorMatrix + u_colorMatrixOffset;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(11),u=r(p),_=o(9),f=r(_),c=o(10),g=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(230),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),n=t.getContext(),l=o.getContext(),s=n.getImageData(0,0,a.width,a.height),d=[0.3,0.59,0.11],p=this._options.desaturation,u=0;u<a.width*a.height;u++){var i=4*u,_=d[0]*s.data[i]/255+d[1]*s.data[i+1]/255+d[2]*s.data[i+2]/255;s.data[i]+=(255*_-s.data[i])*p,s.data[i+1]+=(255*_-s.data[i+1])*p,s.data[i+2]+=(255*_-s.data[i+2])*p}l.putImageData(s,0,0)},t}(u.default.Filter);g.prototype.availableOptions={desaturation:{type:c.OptionType.NUMBER,default:1,uniformType:c.UniformType.FLOAT}};var y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new g,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setDesaturation(this._options.desaturation)},t}(f.default);y.prototype.availableOptions=g.prototype.availableOptions,t.default=y},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_desaturation;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec3 grayXfer = vec3(0.3, 0.59, 0.11);\n  vec3 gray = vec3(dot(grayXfer, texColor.xyz));\n  gl_FragColor = vec4(mix(texColor.xyz, gray, u_desaturation) * texColor.a, texColor.a);\n}\n'},function(t,o,r){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(o,'__esModule',{value:!0});var i=r(0),n=a(i),l=r(1),s=a(l),d=r(2),p=a(d),u=r(3),_=r(9),f=a(_),c=r(12),g=a(c),y=u.Constants.OptionType,h=u.Constants.UniformType,m=function(t){function o(){(0,n.default)(this,o);var e=(0,s.default)(this,t.call(this));return e._fragmentSource=r(232),e}return(0,p.default)(o,t),o.prototype._applyCanvas=function(t,o,r){for(var a=3<arguments.length&&void 0!==arguments[3]&&arguments[3],n=o.getCanvas(),l=o.getContext(),s=r.getContext(),d=l.getImageData(0,0,n.width,n.height),p=this._options.gamma,u=new Float32Array(256),_=0;256>_;_++)u[_]=255*e(_/255,p.r);for(var i=new Float32Array(256),f=0;256>f;f++)i[f]=255*e(f/255,p.g);for(var c=new Float32Array(256),g=0;256>g;g++)c[g]=255*e(g/255,p.b);for(var y=0,h;y<n.width*n.height;y++)h=4*y,d.data[h]=u[d.data[h]],d.data[h+1]=i[d.data[h+1]],d.data[h+2]=c[d.data[h+2]];s.putImageData(d,0,0)},o}(u.Engine.Filter);m.prototype.availableOptions={gamma:{type:y.COLOR,default:g.default.WHITE,uniformType:h.FLOAT3}};var x=function(e){function t(){(0,n.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var i=(0,s.default)(this,e.call.apply(e,[this].concat(r)));return i._filter=new m,i}return(0,p.default)(t,e),t.prototype.update=function(){this._filter.setGamma(this._options.gamma)},t}(f.default);x.prototype.availableOptions=m.prototype.availableOptions,o.default=x},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec3 u_gamma;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec3 rgb = vec3(texColor.r, texColor.g, texColor.b);\n  rgb = pow(rgb, u_gamma);\n  gl_FragColor = vec4(rgb * texColor.a, texColor.a);;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),_=o(9),f=r(_),c=o(12),g=r(c),y=o(3),h=y.Constants.OptionType,m=y.Constants.UniformType,x=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(234),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=t.getContext(),n=o.getContext(),l=i.getImageData(0,0,a.width,a.height),s=this._options.color,_=0,f;_<a.width;_++)for(var d=0;d<a.height;d++){var c=4*(a.width*d+_),g=_/a.width,y=d/a.height,h=(g-0.5)/0.75,m=(y-0.5)/0.75;f=1-(h*h+m*m),f=p(u(f,0.1),1),l.data[c]*=f*s.r,l.data[c+1]=l.data[c+1]*(f*s.g),l.data[c+2]=l.data[c+2]*(f*s.b),l.data[c+3]=255}n.putImageData(l,0,0)},t}(y.Engine.Filter);x.prototype.availableOptions={color:{type:h.COLOR,default:g.default.WHITE,uniformType:m.FLOAT3}};var T=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new x,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setColor(this._options.color)},t}(f.default);T.prototype.availableOptions=x.prototype.availableOptions,t.default=T},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nuniform vec3 u_color;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n\n  vec2 textureCoord = v_texCoord - vec2(0.5, 0.5);\n  textureCoord /= 0.75;\n\n  float d = 1.0 - dot(textureCoord, textureCoord);\n  d = clamp(d, 0.2, 1.0);\n  vec3 newColor = texColor.rgb * d * u_color.rgb;\n  gl_FragColor = vec4(vec3(newColor) * texColor.a, texColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(11),u=r(p),_=o(9),f=r(_),c=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(236),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=t.getContext(),n=o.getContext(),l=i.getImageData(0,0,a.width,a.height),s=0;s<a.width;s++)for(var d=0,p;d<a.height;d++)p=4*(a.width*d+s),l.data[p+2]=0.33*l.data[p+1],l.data[p]*=0.6,l.data[p+2]+=0.33*l.data[p],l.data[p+1]=0.7*l.data[p+1],l.data[p+3]=255;n.putImageData(l,0,0)},t}(u.default.Filter),g=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new c,n}return(0,d.default)(t,e),t}(f.default);t.default=g},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  texColor.b = texColor.g * 0.33;\n  texColor.r = texColor.r * 0.6;\n  texColor.b += texColor.r * 0.33;\n  texColor.g = texColor.g * 0.7;\n  gl_FragColor = texColor;\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(11),u=r(p),_=o(9),f=r(_),c=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(238),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=t.getContext(),n=o.getContext(),l=i.getImageData(0,0,a.width,a.height),s=0;s<a.width;s++)for(var d=0;d<a.height;d++){var p=4*(a.width*d+s),u=0.2125*l.data[p]+0.7154*l.data[p+1]+0.0721*l.data[p+2];l.data[p]=u,l.data[p+1]=u,l.data[p+2]=u}n.putImageData(l,0,0)},t}(u.default.Filter),g=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new c,n}return(0,d.default)(t,e),t}(f.default);t.default=g},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nvec3 W = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float luminance = dot(texColor.rgb, W);\n  gl_FragColor = vec4(vec3(luminance) * texColor.a, texColor.a);\n}\n'},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_lookupTable;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float r = texture2D(u_lookupTable, vec2(texColor.r, 0.0)).r;\n  float g = texture2D(u_lookupTable, vec2(texColor.g, 0.0)).g;\n  float b = texture2D(u_lookupTable, vec2(texColor.b, 0.0)).b;\n\n  gl_FragColor = vec4(vec3(r, g, b) * texColor.a, texColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),p=r(s),u=o(3),_=o(11),f=r(_),c=o(9),g=r(c),y=o(10),h=3,m=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._precomputeQuads(),r._fragmentSource=o(241),r}return(0,p.default)(t,e),t.prototype._precomputeQuads=function(){this._quads=[];for(var e=0;256>e;e++){var t=63*(e/255),o=new u.Vector2;o.y=0|0.125*(0|t),o.x=(0|t)-8*o.y,this._quads.push(o)}},t.prototype._applyCanvas=function(e,t,o){for(var i=3<arguments.length&&void 0!==arguments[3]&&arguments[3],n=t.getCanvas(),l=t.getContext(),s=o.getContext(),p=this._options.lookupTableImage,_=this._createImageCanvas(p),f=_.getContext('2d'),c=l.getImageData(0,0,n.width,n.height),y=f.getImageData(0,0,p.width,p.height),h=new u.Vector2,m=0;m<4*(n.width*n.height);m+=4){var x=c.data[m],r=c.data[m+1],g=c.data[m+2],T=c.data[m+3]/255,a=this._quads[g],v=64;h.x=a.x*v,h.y=a.y*v,h.x+=d(x/4),h.y+=d(r/4);var b=0|4*(p.width*h.y+h.x),C=y.data[b];C=x*(1-T)+C*T;var R=y.data[b+1];R=r*(1-T)+R*T;var O=y.data[b+2];O=g*(1-T)+O*T,c.data[m]=C,c.data[m+1]=R,c.data[m+2]=O}s.putImageData(c,0,0)},t.prototype._createImageCanvas=function(e){var t=u.Utils.createCanvas();t.width=e.width,t.height=e.height;var o=t.getContext('2d');return o.drawImage(e,0,0),t},t}(f.default.Filter);m.prototype.availableOptions={lookupTable:{type:y.OptionType.NUMBER,default:h,uniformType:y.UniformType.INT},lookupTableImage:{type:y.OptionType.IMAGE,uniformType:null}};var x=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new m,n._textures={},n}return(0,p.default)(t,e),t.prototype.update=function(e){var t=e.getRenderer();t.isOfType(y.RendererType.WEBGL)?this._updateWebGLTexture(e):t.isOfType(y.RendererType.CANVAS)&&this._filter.setLookupTableImage(this._options.image)},t.prototype._updateWebGLTexture=function(e){var t=e.getRenderer(),o=t.id;this._textures[o]||(this._textures[o]=new f.default.BaseTexture);var r=this._textures[o];r.setSource(this._options.image),r.setGLUnit(h),t.updateTexture(r)},t.prototype.dispose=function(){for(var t in e.prototype.dispose.call(this),this._textures)delete this._textures[t]},t}(g.default);x.prototype.availableOptions={image:{type:y.OptionType.IMAGE}},t.default=x},function(e){e.exports='/**\n * Based off of GPUImage\'s LookupFilter:\n * https://github.com/BradLarson/GPUImage/blob/master/framework/Source/GPUImageLookupFilter.m\n */\n\nvarying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform sampler2D u_lookupTable;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float blueColor = texColor.b * 63.0;\n\n  vec2 quad1;\n  quad1.y = floor(floor(blueColor) / 8.0);\n  quad1.x = floor(blueColor) - (quad1.y * 8.0);\n\n  vec2 quad2;\n  quad2.y = floor(ceil(blueColor) / 8.0);\n  quad2.x = ceil(blueColor) - (quad2.y * 8.0);\n\n  vec2 texCoord1;\n  texCoord1.x = (quad1.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.r);\n  texCoord1.y = (quad1.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.g);\n\n  vec2 texCoord2;\n  texCoord2.x = (quad2.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.r);\n  texCoord2.y = (quad2.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * texColor.g);\n\n  vec4 newColor1 = texture2D(u_lookupTable, texCoord1);\n  vec4 newColor2 = texture2D(u_lookupTable, texCoord2);\n\n  vec4 newColor = mix(newColor1, newColor2, fract(blueColor));\n  gl_FragColor = mix(texColor, vec4(newColor.rgb, texColor.w), texColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(9),u=r(p),_=o(3),f=_.Constants.OptionType,c=_.Constants.UniformType,g=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(243),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=t.getContext(),n=o.getContext(),l=i.getImageData(0,0,a.width,a.height),s=this._options.saturation,d=0;d<a.width;d++)for(var p=0;p<a.height;p++){var u=4*(a.width*p+d),_=0.2125*l.data[u]+0.7154*l.data[u+1]+0.0721*l.data[u+2];l.data[u]=_*(1-s)+l.data[u]*s,l.data[u+1]=_*(1-s)+l.data[u+1]*s,l.data[u+2]=_*(1-s)+l.data[u+2]*s}n.putImageData(l,0,0)},t}(_.Engine.Filter);g.prototype.availableOptions={saturation:{type:f.NUMBER,default:0,uniformType:c.FLOAT}};var y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new g,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setSaturation(this._options.saturation)},t}(u.default);y.prototype.availableOptions=g.prototype.availableOptions,t.default=y},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform float u_saturation;\n\nconst vec3 luminanceWeighting = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float luminance = dot(texColor.rgb, luminanceWeighting);\n\n  vec3 greyScaleColor = vec3(luminance);\n\n  gl_FragColor = vec4(mix(greyScaleColor, texColor.rgb, u_saturation) * texColor.a, texColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(9),_=r(p),f=o(12),c=r(f),g=o(3),y=g.Constants.OptionType,h=g.Constants.UniformType,m=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(245),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=t.getContext(),n=o.getContext(),l=i.getImageData(0,0,a.width,a.height),s=0;s<a.width;s++)for(var d=0,p;d<a.height;d++)p=4*(a.width*d+s),l.data[p]=u(255*this._options.color.r,l.data[p]),l.data[p+1]=u(255*this._options.color.g,l.data[p+1]),l.data[p+2]=u(255*this._options.color.b,l.data[p+2]);n.putImageData(l,0,0)},t}(g.Engine.Filter);m.prototype.availableOptions={color:{type:y.COLOR,default:c.default.WHITE,uniformType:h.FLOAT3}};var x=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new m,n}return(0,d.default)(t,e),t.prototype.update=function(){this._filter.setColor(this._options.color)},t}(_.default);x.prototype.availableOptions=m.prototype.availableOptions,t.default=x},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\nuniform vec3 u_color;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  vec4 overlayVec4 = vec4(u_color, texColor.a);\n  gl_FragColor = max(overlayVec4 * texColor.a, texColor);\n}\n'},function(t,o,r){'use strict';function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(o,'__esModule',{value:!0});var i=r(0),l=a(i),s=r(1),d=a(s),_=r(2),f=a(_),c=r(99),g=a(c),y=r(3),h=y.Constants.OptionType,m=function(t){function o(){(0,l.default)(this,o);for(var e=arguments.length,r=Array(e),a=0;a<e;a++)r[a]=arguments[a];var i=(0,d.default)(this,t.call.apply(t,[this].concat(r)));return i._options.rgbControlPoints||(i._options.rgbControlPoints={red:i._options.controlPoints,green:i._options.controlPoints,blue:i._options.controlPoints}),i._updateLookupTable(),i}return(0,f.default)(o,t),o.prototype._updateLookupTable=function(){var e=this._calculateSplineCurve(this._options.rgbControlPoints.red),t=this._calculateSplineCurve(this._options.rgbControlPoints.green),o=this._calculateSplineCurve(this._options.rgbControlPoints.blue);this._options.data=this._buildLookupTable(e,t,o)},o.prototype._buildLookupTable=function(e,t,o){for(var r=[],a=0;256>a;a++)r.push(p(u(a+e[a],0),255)),r.push(p(u(a+t[a],0),255)),r.push(p(u(a+o[a],0),255)),r.push(255);return r},o.prototype._calculateSplineCurve=function(t){t=t.sort(function(e,t){return e[0]>t[0]});var o=this._getSplineCurve(t),r=o[0],a;if(0<r[0])for(a=0;a<r[0];a++)o.unshift([0,0]);var i=[];for(a=0;a<o.length;a++){var l=o[a],s=[l[0],l[0]],d=n(e(s[0]-l[0],2)+e(s[1]-l[1],2));s[1]>l[1]&&(d=-d),i.push(d)}return i},o.prototype._getSplineCurve=function(e){var o=this._secondDerivative(e),r=o.length,n=[],l;for(l=0;l<r;l++)n[l]=o[l];var i=[];for(l=0;l<r-1;l++)for(var s=e[l],d=e[l+1],p=s[0];p<d[0];p++){var u=(p-s[0])/(d[0]-s[0]),t=1-u,a=u,_=d[0]-s[0],f=t*s[1]+a*d[1]+_*_/6*((t*t*t-t)*n[l]+(a*a*a-a)*n[l+1]);255<f?f=255:0>f&&(f=0),i.push([p,f])}return 255===i.length&&i.push(e[e.length-1]),i},o.prototype._secondDerivative=function(e){var t=e.length;if(0>=t||1===t)return null;var o=[],r=[],a,i;for(o[0]=[0,1,0],a=1;a<t-1;a++){var n=e[a-1],l=e[a],s=e[a+1];o[a]=o[a]||[],o[a][0]=(l[0]-n[0])/6,o[a][1]=(s[0]-n[0])/3,o[a][2]=(s[0]-l[0])/6,r[a]=(s[1]-l[1])/(s[0]-l[0])-(l[1]-n[1])/(l[0]-n[0])}for(r[0]=0,r[t-1]=0,o[t-1]=[0,1,0],a=1;a<t;a++)i=o[1][0]/o[a-1][1],o[a][1]-=i*o[a-1][2],o[a][0]=0,r[a]-=i*r[a-1];for(a=t-2;0<a;a--)i=o[a][2]/o[a+1][1],o[a][1]-=i*o[a+1][0],o[a][2]=0,r[a]-=i*r[a+1];var d=[];for(a=0;a<t;a++)d[a]=r[a]/o[a][1];return d},o}(g.default);m.prototype.availableOptions={rgbControlPoints:{type:h.OBJECT},controlPoints:{type:h.ARRAY,default:[]},textureGLUnit:{type:h.NUMBER,default:1}},o.default=m},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),_=o(11),f=r(_),c=o(9),g=r(c),y=function(e){function t(){(0,i.default)(this,t);var r=(0,l.default)(this,e.call(this));return r._fragmentSource=o(248),r}return(0,d.default)(t,e),t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=t.getCanvas(),i=t.getContext(),n=o.getContext(),l=i.getImageData(0,0,a.width,a.height),s=0;s<a.width;s++)for(var d=0;d<a.height;d++){var _=4*(a.width*d+s),f=0.3*(l.data[_]/255)+0.3*(l.data[_+1]/255)+0.3*(l.data[_+2]/255);f-=0.2,f=u(0,p(1,f)),f+=0.15,f*=1.4,f*=255,l.data[_]=f,l.data[_+1]=f,l.data[_+2]=f}n.putImageData(l,0,0)},t}(f.default.Filter),h=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new y,n}return(0,d.default)(t,e),t}(g.default);t.default=h},function(e){e.exports='varying vec2 v_texCoord;\nuniform sampler2D u_image;\n\nvoid main() {\n  vec4 texColor = texture2D(u_image, v_texCoord);\n  float gray = texColor.r * 0.3 + texColor.g * 0.3 + texColor.b * 0.3;\n  gray -= 0.2;\n  gray = clamp(gray, 0.0, 1.0);\n  gray += 0.15;\n  gray *= 1.4;\n  gl_FragColor = vec4(vec3(gray) * texColor.a, texColor.a);\n}\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),s=r(n),p=o(2),u=r(p),_=o(3),f=o(11),c=r(f),g=o(9),y=r(g),h=o(10),m=3,x=function(e){function t(){(0,i.default)(this,t);var r=(0,s.default)(this,e.call(this));return r._precomputeQuads(),r._fragmentSource=o(250),r}return(0,u.default)(t,e),t.prototype._precomputeQuads=function(){this._quads=[];for(var e=0;256>e;e++){var t=63*(e/255),o=new _.Vector2;o.y=0|0.125*(0|t),o.x=(0|t)-8*o.y,this._quads.push(o)}},t.prototype._applyCanvas=function(e,t,o){for(var r=3<arguments.length&&void 0!==arguments[3]&&arguments[3],a=this._options,i=a.resolution,n=a.horizontalTileCount,s=a.verticalTileCount,p=t.getCanvas(),u=t.getContext(),f=o.getContext(),c=this._options.lookupTableImage,g=this._createImageCanvas(c),y=g.getContext('2d'),h=u.getImageData(0,0,p.width,p.height),m=y.getImageData(0,0,c.width,c.height),x=d(i/n-1),T=d(i/s-1),v=d(n*s-1),b=void 0,C=void 0,R=void 0,O=void 0,E=void 0,S=void 0,F=new _.Color,M=new _.Color,k=new _.Color,P=new _.Color,D=new _.Color,B=new _.Color,I=new _.Color,w=new _.Color,L=new _.Vector2,A=new _.Vector2,N=function(e,t,o,r){e.r=t.r+r*(o.r-t.r),e.g=t.g+r*(o.g-t.g),e.b=t.b+r*(o.b-t.b)},U=function(e,t,o){var r=4*(d(o)*c.width+d(t));e.r=m.data[r]/255,e.g=m.data[r+1]/255,e.b=m.data[r+2]/255,e.a=m.data[r+3]/255},G=new _.Color,z=new _.Color,V=function(e){U(D,L.x+b,L.y+C),U(B,L.x+b,L.y+E),U(I,L.x+O,L.y+C),U(w,L.x+O,L.y+E),N(G,D,I,F.r*x%1),N(z,I,w,F.r*x%1),N(e,G,z,F.g*T%1)},j=new _.Vector2(i,i).divide(n,s).floor(),W=0;W<4*(p.width*p.height);W+=4)F.set(h.data[W]/255,h.data[W+1]/255,h.data[W+2]/255,h.data[W+3]/255),b=0|F.r*x,C=0|F.g*T,R=0|F.b*v,O=l(F.r*x),E=l(F.g*T),S=l(F.b*v),L.y=0|R/n,L.x=0|R/(L.y*n),A.y=0|S/n,A.x=0|S-A.y*n,L.multiply(j),A.multiply(j),V(k,L,A),V(P,A,A),N(M,k,P,F.b*v%1),h.data[W]=255*M.r,h.data[W+1]=255*M.g,h.data[W+2]=255*M.b;f.putImageData(h,0,0)},t.prototype._createImageCanvas=function(e){var t=_.Utils.createCanvas();t.width=e.width,t.height=e.height;var o=t.getContext('2d');return o.drawImage(e,0,0),t},t}(c.default.Filter);x.prototype.availableOptions={lookupTable:{type:h.OptionType.NUMBER,default:m,uniformType:h.UniformType.INT},lookupTableImage:{type:h.OptionType.IMAGE,uniformType:null},resolution:{type:h.OptionType.NUMBER,default:128,uniformType:h.UniformType.FLOAT},horizontalTileCount:{type:h.OptionType.NUMBER,default:5,uniformType:h.UniformType.FLOAT},verticalTileCount:{type:h.OptionType.NUMBER,default:5,uniformType:h.UniformType.FLOAT}};var T=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,s.default)(this,e.call.apply(e,[this].concat(r)));return n._filter=new x,n._textures={},n}return(0,u.default)(t,e),t.prototype.update=function(e){var t=e.getRenderer();t.isOfType(h.RendererType.WEBGL)?this._updateWebGLTexture(e):t.isOfType(h.RendererType.CANVAS)&&this._filter.setLookupTableImage(this._options.image);var o=this._options,r=o.resolution,a=o.verticalTileCount,i=o.horizontalTileCount;this._filter.set({resolution:r,verticalTileCount:a,horizontalTileCount:i})},t.prototype._updateWebGLTexture=function(e){var t=e.getRenderer(),o=t.id;this._textures[o]||(this._textures[o]=new c.default.BaseTexture);var r=this._textures[o];r.setSource(this._options.image),r.setGLUnit(m),r.setMinFilter(c.default.BaseTexture.NearestFilter),t.updateTexture(r)},t.prototype.dispose=function(){for(var t in e.prototype.dispose.call(this),this._textures)delete this._textures[t]},t}(y.default);T.prototype.availableOptions={image:{type:h.OptionType.IMAGE},resolution:{type:h.OptionType.NUMBER,default:128},horizontalTileCount:{type:h.OptionType.NUMBER,default:5},verticalTileCount:{type:h.OptionType.NUMBER,default:5}},t.default=T},function(e){e.exports='uniform sampler2D u_image;\n\nuniform sampler2D u_lookupTable;\n\nuniform float u_resolution;     // Texture-Resolution, must be power of 2: 64, 128, 256, 512, 1024, 2048, 4096\nuniform float u_horizontalTileCount; // Horizontal Blue Tiles\nuniform float u_verticalTileCount; // Vertical Blue Tiles\n\nvarying vec2 v_texCoord;\n\nconst float EPSILON = 0.000001;\n\n// Try to get the exact pixel of the lut map image\nvec3 lutColor(int texPosX, int texPosY) {\n    return texture2D(u_lookupTable, (0.5 / u_resolution) + vec2(float(texPosX), float(texPosY)) / u_resolution).rgb;\n}\n\nvec3 belinearInterpolate(vec3 cRfGf, vec3 cRfGc, vec3 cRcGf, vec3 cRcGc, float redFract, float greenFract) {\n    return mix(mix(cRfGf, cRcGf, redFract), mix(cRfGc, cRcGc, redFract), greenFract);\n}\n\nvoid main() {\n    vec4 inputColor = clamp(texture2D(u_image, v_texCoord), 0.0, 1.0);\n\n    vec3 sourceColor = vec3(inputColor.rgb / max(inputColor.a, EPSILON));\n\n    float rRange = floor(u_resolution / u_horizontalTileCount - 1.0);\n    float gRange = floor(u_resolution / u_verticalTileCount - 1.0);\n    float bRange = floor(u_horizontalTileCount * u_horizontalTileCount - 1.0);\n\n    int rFloor = int(sourceColor.r * rRange);\n    int gFloor = int(sourceColor.g * gRange);\n    int bFloor = int(sourceColor.b * bRange);\n\n    int rCeil = int(ceil(sourceColor.r * rRange));\n    int gCeil = int(ceil(sourceColor.g * gRange));\n    int bCeil = int(ceil(sourceColor.b * bRange));\n\n    ivec2 tileFloor; // Blue tile index\n    tileFloor.y = bFloor / int(u_horizontalTileCount);\n    tileFloor.x = bFloor - (tileFloor.y * int(u_horizontalTileCount));\n\n    ivec2 tileCeil; // Blue tile index\n    tileCeil.y = bCeil / int(u_horizontalTileCount);\n    tileCeil.x = bCeil - (tileCeil.y * int(u_horizontalTileCount));\n\n    // Map tile index to tile pixel pos.\n    tileFloor *= int(u_resolution / u_horizontalTileCount);\n    tileCeil  *= int(u_resolution / u_verticalTileCount);\n\n    // Interpolate between red and green\n    vec3 lutColorFB = belinearInterpolate(\n        lutColor(tileFloor.x + rFloor, tileFloor.y + gFloor),\n        lutColor(tileFloor.x + rFloor, tileFloor.y + gCeil),\n        lutColor(tileFloor.x + rCeil,  tileFloor.y + gFloor),\n        lutColor(tileFloor.x + rCeil,  tileFloor.y + gCeil),\n        fract(sourceColor.r * rRange), fract(sourceColor.g * gRange)\n    );\n    vec3 lutColorCB = belinearInterpolate(\n        lutColor(tileCeil.x + rFloor, tileCeil.y + gFloor),\n        lutColor(tileCeil.x + rFloor, tileCeil.y + gCeil),\n        lutColor(tileCeil.x + rCeil,  tileCeil.y + gFloor),\n        lutColor(tileCeil.x + rCeil,  tileCeil.y + gCeil),\n        fract(sourceColor.r * rRange), fract(sourceColor.g * gRange)\n    );\n\n    // Interpolate between the blue values\n    vec3 interpolation = mix(lutColorFB, lutColorCB, fract(sourceColor.b * bRange));\n\n    // Round Color Values to prevent that for ex. 254.999999 is cutting to 254 instead of 255;\n    interpolation = clamp(floor(interpolation * 255. + .5) / 255., 0.0, 1.0);\n\n    gl_FragColor = vec4(interpolation.rgb * inputColor.a, inputColor.a);\n}\n\n\n\n'},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Desaturation({desaturation:0.5})),n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[170,170],[212,219],[234,242],[255,255]],green:[[0,0],[170,168],[234,231],[255,255]],blue:[[0,0],[170,170],[212,208],[255,255]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='breeze',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Grayscale),n}return(0,d.default)(t,e),t}(u.default);c.identifier='bw',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Grayscale),n._stack.push(new f.Contrast({contrast:1.5})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='bwhard',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,69],[55,110],[202,230],[255,255]],green:[[0,44],[89,93],[185,141],[255,189]],blue:[[0,76],[39,82],[218,138],[255,171]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='celsius',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[44,44],[124,143],[221,204],[255,255]],green:[[0,0],[130,127],[213,199],[255,255]],blue:[[0,0],[51,52],[219,204],[255,255]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='chest',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[44,28],[63,48],[128,132],[235,248],[255,255]],green:[[0,0],[20,10],[60,45],[190,209],[211,231],[255,255]],blue:[[0,31],[41,62],[150,142],[234,212],[255,224]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='fixie',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Saturation({saturation:1.35})),n._stack.push(new f.Contrast({contrast:1.1})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='food',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,9],[21,11],[45,24],[255,220]],green:[[0,12],[21,21],[42,42],[150,150],[170,173],[255,210]],blue:[[0,28],[43,72],[128,185],[255,220]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='fridge',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,65],[28,67],[67,113],[125,183],[187,217],[255,229]],green:[[0,52],[42,59],[104,134],[169,209],[255,240]],blue:[[0,52],[65,68],[93,104],[150,153],[255,198]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='front',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Contrast({contrast:1.1})),n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[94,74],[181,205],[255,255]],green:[[0,0],[127,127],[255,255]],blue:[[0,0],[102,73],[227,213],[255,255]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='glam',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Gobblin),n}return(0,d.default)(t,e),t}(u.default);c.identifier='gobblin',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({controlPoints:[[0,0],[53,32],[91,80],[176,205],[255,255]]})),n._stack.push(new f.Saturation({saturation:0.9})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='k1',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=o(12),g=r(c),y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({controlPoints:[[0,0],[54,33],[77,82],[94,103],[122,126],[177,193],[229,232],[255,255]]})),n._stack.push(new f.SoftColorOverlay({color:new g.default(40/255,40/255,40/255)})),n}return(0,d.default)(t,e),t}(u.default);y.identifier='k2',t.default=y},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Saturation({saturation:0.5})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='k6',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({controlPoints:[[0,0],[17,27],[46,69],[90,112],[156,200],[203,243],[255,255]]})),n._stack.push(new f.Saturation({saturation:0.7})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='kdynamic',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Desaturation({desaturation:0.4})),n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,20],[40,20],[106,111],[129,153],[190,223],[255,255]],green:[[0,20],[40,20],[62,41],[106,108],[132,159],[203,237],[255,255]],blue:[[0,40],[40,40],[73,60],[133,160],[191,297],[203,237],[237,239],[255,255]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='lenin',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({controlPoints:[[0,0],[87,20],[131,156],[183,205],[255,200]]})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='lomo',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[41,84],[87,134],[255,255]],green:[[0,0],[255,216]],blue:[[0,0],[255,131]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='mellow',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=o(59),g=r(c),y=o(12),h=r(y),m=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r))),s=new g.default(0.8158218291630716,0,0,0,-0.01779810181190647,0,0.8098360655737704,0,0,0.0916393442622953,0,0,0.4596336773932402,0,0.12760574782432707,0,0,0,1,0);n._stack.push(new f.ColorMatrixPrimitive({colorMatrix:s}));var d=new h.default(0.8,0.6,0.9);return n._stack.push(new f.Gamma({gamma:d})),n}return(0,d.default)(t,e),t}(u.default);m.identifier='metal',t.default=m},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,40],[255,230]],green:[[0,10],[255,225]],blue:[[0,20],[255,181]]}})),n._stack.push(new f.Glow),n}return(0,d.default)(t,e),t}(u.default);c.identifier='morning',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[115,130],[195,215],[255,255]],green:[[0,0],[148,153],[172,215],[255,255]],blue:[[0,46],[58,75],[178,205],[255,255]]},textureGLUnit:2})),n._stack.push(new f.ToneCurve({controlPoints:[[0,0],[117,151],[189,217],[255,255]],textureGLUnit:3})),n._stack.push(new f.Desaturation({desaturation:0.65})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='orchid',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[94,74],[181,205],[255,255]],green:[[0,0],[34,34],[99,76],[176,190],[255,255]],blue:[[0,0],[102,73],[227,213],[255,255]]}})),n._stack.push(new f.Saturation({saturation:0.8})),n._stack.push(new f.Contrast({contrast:1.5})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='pola',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[56,18],[196,209],[255,255]],green:[[0,38],[71,84],[255,255]],blue:[[0,0],[131,133],[204,211],[255,255]]}})),n._stack.push(new f.Saturation({saturation:0.8})),n._stack.push(new f.Contrast({contrast:1.5})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='pola669',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.Desaturation({desaturation:0.65})),n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,50],[40,78],[118,170],[181,211],[255,255]],green:[[0,27],[28,45],[109,157],[157,195],[179,208],[206,212],[255,240]],blue:[[0,50],[12,55],[46,103],[103,162],[194,182],[241,201],[255,219]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='quozi',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,129],[75,153],[181,227],[255,255]],green:[[0,8],[111,85],[212,158],[255,226]],blue:[[0,5],[75,22],[193,90],[255,229]]}})),n._stack.push(new f.Glow),n}return(0,d.default)(t,e),t}(u.default);c.identifier='semired',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,0],[62,82],[141,154],[255,255]],green:[[0,39],[56,96],[192,176],[255,255]],blue:[[0,0],[174,99],[255,235]]},textureGLUnit:2})),n._stack.push(new f.ToneCurve({controlPoints:[[0,0],[55,20],[158,191],[255,255]],textureGLUnit:3})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='sunny',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.ToneCurve({rgbControlPoints:{red:[[0,72],[89,99],[176,212],[255,237]],green:[[0,49],[255,192]],blue:[[0,72],[255,151]]}})),n}return(0,d.default)(t,e),t}(u.default);c.identifier='texas',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(4),u=r(p),_=o(5),f=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(_),c=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._stack.push(new f.X400),n}return(0,d.default)(t,e),t}(u.default);c.identifier='x400',t.default=c},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(4),_=r(u),f=o(5),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(f),g=p.Constants.OptionType,y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r)));return n._lutPrimitive=new c.LookupTableImage({image:n._options.image}),n._stack.push(n._lutPrimitive),n}return(0,d.default)(t,e),t}(_.default);y.prototype.availableOptions={image:{type:g.IMAGE,required:!0,setter:function(e){return this._lutPrimitive&&this._lutPrimitive.setImage(e),this.setDirty(!0),e}}},y.identifier='lut',t.default=y},function(e,t,o){'use strict';function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,'__esModule',{value:!0});var a=o(0),i=r(a),n=o(1),l=r(n),s=o(2),d=r(s),p=o(3),u=o(4),_=r(u),f=o(5),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(f),g=p.Constants.OptionType,y=function(e){function t(){(0,i.default)(this,t);for(var o=arguments.length,r=Array(o),a=0;a<o;a++)r[a]=arguments[a];var n=(0,l.default)(this,e.call.apply(e,[this].concat(r))),s=n._options,d=s.image,p=s.resolution,u=s.verticalTileCount,_=s.horizontalTileCount;return n._lutPrimitive=new c.ThreeDLookupTableImage({image:d,resolution:p,verticalTileCount:u,horizontalTileCount:_}),n._stack.push(n._lutPrimitive),n}return(0,d.default)(t,e),t}(_.default);y.prototype.availableOptions={image:{type:g.IMAGE,required:!0,setter:function(e){return this._lutPrimitive&&this._lutPrimitive.setImage(e),this.setDirty(!0),e}},resolution:{type:g.NUMBER,default:128},horizontalTileCount:{type:g.NUMBER,default:5},verticalTileCount:{type:g.NUMBER,default:5}},y.identifier='3d-lut',t.default=y}])});
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var PhotoEditorLanguageObject = null;
function blobToFile(blobFile, fileName) {
    if (fileName === void 0) { fileName = "NewFile"; }
    var newFile = blobFile;
    newFile.lastModifiedDate = new Date();
    newFile.name = fileName;
    return newFile;
}
var PhotoEditorSettings = /** @class */ (function () {
    function PhotoEditorSettings(init) {
        this.container = null;
        this.isPopup = true;
        this.onExport = null;
        this.onImmediateExport = null;
        this.onShow = null;
        this.onLoad = null;
        this.allFeaturesAvailable = true;
        this.featuresToExclude = null;
        this.baseLanguageFile = null;
        this.currentLanguageFile = null;
        this.currentLanguage = null;
        this.isMobile = false;
        Object.assign(this, init);
    }
    return PhotoEditorSettings;
}());
var photoStart = function (settings) {
    if (!settings.baseLanguageFile || !settings.currentLanguageFile) {
        Logger.info("Language file not found");
        return;
    }
    if (!PhotoEditorLanguageObject)
        PhotoEditorLanguageObject = photoStartLanguageMapper(settings).baseLanguageFile;
    if (!PhotoEditorLanguageObject) {
        Logger.info("Language file mapping error");
        return;
    }
    if (!settings.imgUrl) {
        throw "Image url not found!";
    }
    if (!settings.container)
        settings.container = $("#photoFilterContainer");
    function closeEditor() {
        settings.container.children().remove();
        if (settings.isPopup)
            settings.container.parent().removeClass("opened");
    }
    var image = new Image;
    image.crossOrigin = "anonymous";
    image.onload = function () {
        continueStart();
    };
    image.src = settings.imgUrl;
    function continueStart() {
        settings.container.children().remove();
        var availableTools;
        if (settings.allFeaturesAvailable)
            availableTools = ["transform", "filter", "adjustments", "focus", "brush", "frame", "overlay"];
        else
            availableTools = ["filter"];
        if (settings.featuresToExclude) {
            availableTools = availableTools.filter(function (x) { return settings.featuresToExclude.indexOf(x) === -1; });
        }
        if (settings.isMobile && availableTools.find(function (x) { return x == "transform"; })) {
            availableTools = __spreadArray(__spreadArray([], availableTools, true), ["rotation", "flip"], false);
        }
        if (settings.isMobile && availableTools.find(function (x) { return x == "adjustments"; })) {
            availableTools = __spreadArray(__spreadArray([], availableTools.filter(function (x) { return x != "adjustments"; }), true), ["brightness", "saturation", "contrast", "clarity", "exposure", "shadows", "highlights", "gamma"], false);
        }
        if (settings.isMobile && availableTools.find(function (x) { return x == "focus"; })) {
            availableTools = __spreadArray(__spreadArray([], availableTools.filter(function (x) { return x != "focus"; }), true), ["radial-focus", "mirrored-focus"], false);
        }
        var sdkOptions = {
            container: settings.container[0],
            license: '{"api_token":"3E6cgLhU8te8FzHQ-magxQ","app_identifiers":["*.zakeke.com","*.zakeke.workers.dev","zakekewebapp-test.azurewebsites.net","zakeke-testing-ext-mvc.azurewebsites.net","proud-desert-0b947e303.2.azurestaticapps.net","192.168.220.130","127.0.0.1","localhost","proud-desert-0b947e303-35.westeurope.2.azurestaticapps.net","zakeke-pre-prod-bis-webapp.azurewebsites.net","blue-island-018958403.2.azurestaticapps.net"],"available_actions":[],"domains":["https://api.photoeditorsdk.com"],"enterprise_license":false,"expires_at":null,"features":["camera","library","export","customassets","whitelabel","adjustment","brush","filter","focus","frame","overlay","sticker","text","transform"],"issued_at":1754124854,"minimum_sdk_version":"1.0","owner":"Futurenext Srl","platform":"HTML5","products":["pesdk"],"version":"2.4","signature":"lTs/yoqbRbIYCzogdT5uTV2tEkzp0bXhQu++6bbEzh3Q3wS+HgArDD/HdrJ5gWETg8qxxVKgMvYp0tExnYO1VZ/PckVPibLi2Oiugf3b2UqCqETYQKM2h9q/vOccstqiBG0KumO0EjhEcvl6iJ7MLca8G5pEjfxoafP4aCAm05LRQYEj1X9mz9nw3tqf3NdcMPStRZmqid9JKQeg+IZlDdloaptggS1fdjRx7u/DEKuNMAAKapNdSyVSKq4vMRNqg/Yff6klrT0oUNMBC6eZuw0+dWeUQ/9Y0aZof50H9yn7SHKxezoI+bEzXo3x7Hb41n3ZyIkqXz7j8/ACNPTDabELGSTsoj/3fymTborCamnSOaABV/t5bwXfqwG4z2foYZhnSKnGgrXhBEyru/Bctm56Vkk0sZX5TqYTqkbpHpXH9zd1rvq33WmT1/b+dhBCjwX2wrP/KWsZGdJdU+Yj31bm9W+UofOUizlbhCxPacgWX7ziPSNOoXUK/kHw1j+L7BJAZRF4hVSIdumFAM+p0Qypn67fT3QSDqaSmcqVSzd7eFdk/2w07pZbCXIAYGIwGQl5CAOJ1LTc9MnBV8Y7LtLz4Shw7vQi7I7WX9PuhAFCs08UfytqA629RAnYynVam5K1wyDq/zEPBdzY48VZohSNINIEWk/dgTYgYUQJ6FU="}',
            logLevel: 'error',
            responsive: true,
            assets: {
                baseUrl: Zakeke.config.baseUrl + 'assets/customizer/Scripts/libs/photoEditorSdk/assets'
                //baseUrl: 'https://cdn.zakeke.com/cdn/production/assets/customizer/Scripts/libs/photoEditorSdk/assets'
            },
            crossOrigin: 'anonymous',
            editor: {
                image: image,
                displayCloseButton: true,
                maxMegaPixels: {
                    desktop: 20,
                    mobile: 20
                },
                export: {
                    type: PhotoEditorSDK.RenderType.BLOB,
                    fileBasename: 'NewImage',
                    download: false,
                    quality: 1
                },
                tools: availableTools,
                controlsOptions: {
                    frame: {
                        categories: [
                            {
                                identifier: 'imgly_frame_generic',
                                defaultName: 'Generic',
                                metaData: {
                                    backgroundImage: 'frames/generic.png' // Not used yet
                                },
                                frames: [
                                    {
                                        identifier: 'white_frame',
                                        defaultName: T._('White frame', 'Customizer'),
                                        layoutMode: 'horizontal-inside',
                                        thumbnail: 'frames/simple_white/icon.png',
                                        imageGroups: {
                                            top: {
                                                mid: {
                                                    image: 'frames/simple_white/white_pattern.png',
                                                    mode: 'repeat'
                                                }
                                            },
                                            left: {
                                                start: 'frames/simple_white/white_pattern.png',
                                                mid: 'frames/simple_white/white_pattern.png',
                                                end: 'frames/simple_white/white_pattern.png'
                                            },
                                            right: {
                                                start: 'frames/simple_white/white_pattern.png',
                                                mid: 'frames/simple_white/white_pattern.png',
                                                end: 'frames/simple_white/white_pattern.png'
                                            },
                                            bottom: {
                                                mid: {
                                                    image: 'frames/simple_white/white_pattern.png',
                                                    mode: 'repeat'
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ],
                        replaceCategories: false
                        //availableFrames: ['dia']
                    }
                }
            },
            extensions: {
                languages: {}
            },
            language: ''
        };
        sdkOptions["extensions"]["languages"][settings.currentLanguage] = PhotoEditorLanguageObject;
        sdkOptions["language"] = settings.currentLanguage;
        var photoEditor = settings.isMobile ? new PhotoEditorSDK.UI.ReactUI(sdkOptions) : new PhotoEditorSDK.UI.ReactUI(sdkOptions);
        photoEditor.on("close", closeEditor);
        settings.container.parent().on("click", function (e) { if (e.target.id == settings.container.parent()[0].id)
            closeEditor(); });
        settings.container.prepend('<i class="material-icons">close</i>').find(".material-icons").first().on("click", closeEditor);
        settings.container.parent().addClass("opened");
        if (settings.onShow)
            settings.onShow();
        if (settings.onLoad)
            photoEditor.on("load", settings.onLoad);
        if (settings.onImmediateExport) {
            var buttonChecker = setInterval(function () {
                var exportButton = settings.isMobile ? $(".pesdk-react-topBar__right").children().first() : $(".pesdk-CanvasHeaderButtonComponent-12r6rxb").first();
                if (exportButton.length > 0) {
                    exportButton.on("click", function () {
                        var popupChecker = setInterval(function () {
                            if (!settings.container.parent().hasClass("opened")) {
                                settings.onImmediateExport();
                                clearInterval(popupChecker);
                            }
                        }, 100);
                        settings.onImmediateExport;
                    });
                    clearInterval(buttonChecker);
                }
            }, 100);
        }
        if (settings.onExport) {
            photoEditor.on("export", function (t) {
                settings.onExport(t);
                closeEditor();
            });
        }
        else {
            photoEditor.on("export", closeEditor);
        }
    }
};
var photoStartLanguageMapper = function (settings) {
    finder(settings.baseLanguageFile);
    function finder(objectFile) {
        for (var key in objectFile) {
            if (objectFile.hasOwnProperty(key)) {
                if (objectFile[key] && typeof objectFile[key] === 'object')
                    finder(objectFile[key]);
                else if (settings.currentLanguageFile.hasOwnProperty(objectFile[key]))
                    objectFile[key] = settings.currentLanguageFile[objectFile[key]];
            }
        }
    }
    return settings;
};

;
function startWizardry(wizardData, wizardName, isProgressManual) {
    $(window).on("resize", updateWizardPosition);
    if (wizardData.length < 1)
        throw new Error("Could not found any content");
    if (localStorage.getItem("wizard-" + wizardName) == "false")
        return;
    var nextWizardryStep = function () {
        if (wizardData.length > 1) {
            var next = wizardData.slice(1);
            return startWizardry(next, wizardName, isProgressManual);
        }
        else {
            stopWizardry(true);
            return null;
        }
    };
    var stopWizardry = function (smooth) {
        if (smooth === void 0) { smooth = false; }
        if (smooth)
            popup.fadeOut(500, function () { popup.remove(); });
        else
            popup.remove();
        $(window).off("resize", updateWizardPosition);
    };
    var popup = $("#wizard-popup").clone();
    popup.find(">h1").html('<i class="material-icons">assistant_photo</i>' + wizardData[0].content.find(">h1").html());
    popup.find("#wizard-content").html(wizardData[0].content.find(">div").html());
    popup.find("#wizard-tools").find(">a").on("click", function () {
        popup.fadeOut(500, function () {
            popup.remove();
            localStorage.setItem("wizard-" + wizardName, "false");
        });
    }).children("span").text(T._("Dismiss", "Admin"));
    var arrow = popup.find(".arrow");
    arrow.attr("class", "arrow " + ((wizardData[0].position.startsWith("bottom") || wizardData[0].position.endsWith("top") || popup.data("fixed")) ? "arrow-dark" : "arrow-light"));
    arrow.attr("style", "");
    arrow = popup.find(".arrow-border");
    arrow.attr("class", "arrow-border");
    arrow.attr("style", "");
    popup.addClass("opened");
    wizardData[0].parent.append(popup);
    popup.find("#wizard-tools").find(">button").on("click", function () {
        if (!isProgressManual)
            nextWizardryStep();
        else
            stopWizardry(true);
    });
    popup.data("target", wizardData[0].anchor);
    popup.data("parent", wizardData[0].parent);
    popup.data("position", wizardData[0].position);
    popup.data("scrollBar", wizardData[0].scrollBar);
    popup.data("fixed", false);
    updateWizardPosition();
    return {
        next: nextWizardryStep,
        stop: stopWizardry
    };
}
function updateWizardPosition() {
    var currentPopup = $(document).find("#wizard-popup.opened");
    var newTopPosition, newLeftPosition;
    if (currentPopup.length > 0 && !currentPopup.data("fixed")) {
        newTopPosition = currentPopup.data("target").get(0).offsetTop;
        newLeftPosition = currentPopup.data("target").get(0).offsetLeft;
        if (currentPopup.data("position").startsWith("top")) {
            newTopPosition = newTopPosition - currentPopup.get(0).offsetHeight - 10;
            currentPopup.find(".arrow").first().addClass("arrow-bottom");
            currentPopup.find(".arrow-border").first().addClass("arrow-bottom");
        }
        else if (currentPopup.data("position").startsWith("bottom")) {
            newTopPosition += currentPopup.data("target").get(0).offsetHeight + 10;
            currentPopup.find(".arrow").first().addClass("arrow-top");
            currentPopup.find(".arrow-border").first().addClass("arrow-top");
        }
        else if (currentPopup.data("position").startsWith("left")) {
            newLeftPosition = newLeftPosition - currentPopup.get(0).offsetWidth - 10;
            currentPopup.find(".arrow").first().addClass("arrow-right");
            currentPopup.find(".arrow-border").first().addClass("arrow-right");
        }
        else {
            newLeftPosition += currentPopup.data("target").get(0).offsetWidth + 10;
            currentPopup.find(".arrow").first().addClass("arrow-left");
            currentPopup.find(".arrow-border").first().addClass("arrow-left");
        }
        //---------
        if (currentPopup.data("position").endsWith("top")) {
            currentPopup.find(".arrow").first().css("top", "calc(10% - 10px)");
            currentPopup.find(".arrow-border").first().css("top", "calc(10% - 11px)");
        }
        else if (currentPopup.data("position").endsWith("bottom")) {
            newTopPosition += currentPopup.data("target").get(0).offsetHeight - currentPopup.get(0).offsetHeight;
            currentPopup.find(".arrow").first().css("top", "calc(90% - 10px)");
            currentPopup.find(".arrow-border").first().css("top", "calc(90% - 11px)");
        }
        else if (currentPopup.data("position").endsWith("left")) {
            currentPopup.find(".arrow").first().css("left", "calc(10% - 10px)");
            currentPopup.find(".arrow-border").first().css("left", "calc(10% - 11px)");
        }
        else if (currentPopup.data("position").endsWith("right")) {
            newLeftPosition += currentPopup.data("target").get(0).offsetWidth - currentPopup.get(0).offsetWidth;
            currentPopup.find(".arrow").first().css("left", "calc(90% - 10px)");
            currentPopup.find(".arrow-border").first().css("left", "calc(90% - 11px)");
        }
        else if (currentPopup.data("position").endsWith("center")) {
            if (currentPopup.data("position").startsWith("top") || currentPopup.data("position").startsWith("bottom")) {
                newLeftPosition += currentPopup.data("target").get(0).offsetWidth / 2 - currentPopup.get(0).offsetWidth / 2;
                currentPopup.find(".arrow").first().css("left", "calc(50% - 10px)");
                currentPopup.find(".arrow-border").first().css("left", "calc(50% - 11px)");
            }
            else if (currentPopup.data("position").startsWith("left") || currentPopup.data("position").startsWith("right")) {
                newTopPosition += currentPopup.data("target").get(0).offsetHeight / 2 - currentPopup.get(0).offsetHeight / 2;
                currentPopup.find(".arrow").first().css("top", "calc(50% - 10px)");
                currentPopup.find(".arrow-border").first().css("top", "calc(50% - 11px)");
            }
        }
        //---------------
        //Check if out of bounds
        var requiredSpace = currentPopup.width() + currentPopup.data("target").get(0).offsetLeft + currentPopup.data("target").outerWidth();
        if ((currentPopup.data("position").startsWith("left") || currentPopup.data("position").startsWith("right")) &&
            (parseFloat(currentPopup.data("parent").width()) < parseFloat(requiredSpace))) {
            currentPopup.data("fixed", true);
            var arrow = currentPopup.find(".arrow");
            arrow.attr("class", "arrow arrow-dark");
            arrow.attr("style", "");
            arrow = currentPopup.find(".arrow-border");
            arrow.attr("class", "arrow-border");
            arrow.attr("style", "");
            updateWizardPosition();
            return;
        }
        //---------------
    }
    else if (currentPopup.data("fixed")) {
        //Check if it's back to normal
        var requiredSpace = currentPopup.width() + currentPopup.data("target").get(0).offsetLeft + currentPopup.data("target").outerWidth();
        if (parseFloat(currentPopup.data("parent").width()) > parseFloat(requiredSpace)) {
            currentPopup.data("fixed", false);
            var arrow = currentPopup.find(".arrow");
            arrow.attr("class", "arrow " + ((currentPopup.data("position").startsWith("bottom") || currentPopup.data("position").endsWith("top")) ? "arrow-dark" : "arrow-light"));
            arrow.attr("style", "");
            arrow = currentPopup.find(".arrow-border");
            arrow.attr("class", "arrow-border");
            arrow.attr("style", "");
            updateWizardPosition();
            return;
        }
        //---------------
        newTopPosition = currentPopup.data("target").get(0).offsetTop + currentPopup.data("target").get(0).offsetHeight + 10;
        newLeftPosition = currentPopup.data("target").get(0).offsetLeft + currentPopup.data("target").get(0).offsetWidth / 2 - currentPopup.get(0).offsetWidth / 2;
        currentPopup.find(".arrow").first().addClass("arrow-top").css("left", "calc(50% - 10px)");
        currentPopup.find(".arrow-border").first().addClass("arrow-top").css("left", "calc(50% - 11px)");
    }
    currentPopup.css("left", newLeftPosition < 0 ? "0" : newLeftPosition + "px");
    currentPopup.css("top", newTopPosition + "px");
    //Check if can use scroll
    if (currentPopup.data("scrollBar")) {
        var pos = currentPopup.data("scrollBar").css("top");
        var posN = Number.parseInt(pos.slice(0, pos.indexOf("px")));
        newTopPosition -= posN;
        currentPopup.css("top", newTopPosition + "px");
    }
}
/*Follow this template to build your popup*/
/*
    <div class="wizard-container">
        <div id="wizard-popup">
            <div class="arrow"></div>
            <div class="arrow-border"></div>
            <h1></h1>
            <div id="wizard-content"></div>
            <div id="wizard-tools">
                <a href="#"><i class="material-icons">cancel</i> @T._("Dismiss", "Admin")</a>
                <button class="btn btn-primary">@T._("Next", "Admin")</button>
            </div>
        </div>
        <div id="wizard-filters-0">
            <div><h1>@T._("Title", "Admin")</h1><div>@T._("Content text", "Admin")</div></div>
        </div>
    </div>
*/

(function(a){function e(b,c){var d=b.data("balloon")&&b.data("balloon").get(0);return!(d&&(d==c.relatedTarget||a.contains(d,c.relatedTarget)))}function d(d,e,f){function n(a,b,c,d,e){var f=Math.round(d/1.7320508);b.inactive()["setBorder"+c.camel.pos.f](d)["setBorder"+c.camel.pos.c1](f)["setBorder"+c.camel.pos.c2](f)["set"+c.camel.pos.p1](c.isTopLeft?-d:a.inner[c.size.p])["set"+c.camel.pos.c1](a.inner[c.size.c]/2-f).active().$.css("border-"+c.pos.f+"-color",e)}e.stop(true,true);var g,h,i={position:"absolute",height:"0",width:"0",border:"solid 0 transparent"},j=new c(d),k=new c(e);k.setTop(-f.offsetY+(f.position&&f.position.indexOf("top")>=0?j.top-k.height:f.position&&f.position.indexOf("bottom")>=0?j.bottom:j.center.top-k.height/2));k.setLeft(f.offsetX+(f.position&&f.position.indexOf("left")>=0?j.left-k.width:f.position&&f.position.indexOf("right")>=0?j.right:j.center.left-k.width/2));if(f.tipSize>0){if(e.data("outerTip")){e.data("outerTip").remove();e.removeData("outerTip")}if(e.data("innerTip")){e.data("innerTip").remove();e.removeData("innerTip")}g=new c(a("<div>").css(i).appendTo(e));h=new c(a("<div>").css(i).appendTo(e));var l;for(var m=0;m<b.pos.length;m++){l=b.getRelativeNames(m);if(k.center[l.pos.c1]>=j[l.pos.c1]&&k.center[l.pos.c1]<=j[l.pos.c2]){if(m%2==0){if(k[l.pos.o]>=j[l.pos.o]&&k[l.pos.f]>=j[l.pos.f])break}else{if(k[l.pos.o]<=j[l.pos.o]&&k[l.pos.f]<=j[l.pos.f])break}}l=null}if(l){k["set"+l.camel.pos.p1](k[l.pos.p1]+(l.isTopLeft?1:-1)*(f.tipSize-k["border"+l.camel.pos.o]));n(k,g,l,f.tipSize,e.css("border-"+l.pos.o+"-color"));n(k,h,l,f.tipSize-2*k["border"+l.camel.pos.o],e.css("background-color"));e.data("outerTip",g.$).data("innerTip",h.$)}else{a.each([g.$,h.$],function(){this.remove()})}}}function c(){this.initialize.apply(this,arguments)}var b={};b.pos=a.extend(["top","bottom","left","right"],{camel:["Top","Bottom","Left","Right"]});b.size=a.extend(["height","width"],{camel:["Height","Width"]});b.getRelativeNames=function(a){var c={pos:{o:a,f:a%2==0?a+1:a-1,p1:a%2==0?a:a-1,p2:a%2==0?a+1:a,c1:a<2?2:0,c2:a<2?3:1},size:{p:a<2?0:1,c:a<2?1:0}};var d={};for(var e in c){if(!d[e])d[e]={};for(var f in c[e]){d[e][f]=b[e][c[e][f]];if(!d.camel)d.camel={};if(!d.camel[e])d.camel[e]={};d.camel[e][f]=b[e].camel[c[e][f]]}}d.isTopLeft=d.pos.o==d.pos.p1;return d};(function(){function f(a,c){if(c==undefined){f(a,true);return f(a,false)}var d=b.getRelativeNames(c?0:2);a[d.size.p]=a.$["outer"+d.camel.size.p]();a[d.pos.f]=a[d.pos.o]+a[d.size.p];a.center[d.pos.o]=a[d.pos.o]+a[d.size.p]/2;a.inner[d.pos.o]=a[d.pos.o]+a["border"+d.camel.pos.o];a.inner[d.size.p]=a.$["inner"+d.camel.size.p]();a.inner[d.pos.f]=a.inner[d.pos.o]+a.inner[d.size.p];a.inner.center[d.pos.o]=a.inner[d.pos.f]+a.inner[d.size.p]/2;return a}var d={setBorder:function(a,b){return function(c){this.$.css("border-"+a.toLowerCase()+"-width",c+"px");this["border"+a]=c;return this.isActive?f(this,b):this}},setPosition:function(a,b){return function(c){this.$.css(a.toLowerCase(),c+"px");this[a.toLowerCase()]=c;return this.isActive?f(this,b):this}}};c.prototype={initialize:function(c){this.$=c;a.extend(true,this,this.$.offset(),{center:{},inner:{center:{}}});for(var d=0;d<b.pos.length;d++){this["border"+b.pos.camel[d]]=parseInt(this.$.css("border-"+b.pos[d]+"-width"))||0}this.active()},active:function(){this.isActive=true;f(this);return this},inactive:function(){this.isActive=false;return this}};for(var e=0;e<b.pos.length;e++){c.prototype["setBorder"+b.pos.camel[e]]=d.setBorder(b.pos.camel[e],e<2);if(e%2==0)c.prototype["set"+b.pos.camel[e]]=d.setPosition(b.pos.camel[e],e<2)}})();a.fn.balloon=function(b){b=a.extend(true,{},a.balloon.defaults,b);return this.one("mouseenter",function(c){var d=a(this),f=this;var g=d.unbind("mouseenter",arguments.callee).showBalloon(b).mouseenter(function(a){e(d,a)&&d.showBalloon()}).data("balloon");if(g){g.mouseleave(function(b){if(f==b.relatedTarget||a.contains(f,b.relatedTarget))return;d.hideBalloon()}).mouseenter(function(a){d.showBalloon()})}}).mouseleave(function(b){var c=a(this);e(c,b)&&c.hideBalloon()})};a.fn.showBalloon=function(b){var c,e,f;if(!a.balloon.defaults.css)a.balloon.defaults.css={};if(b||!this.data("options"))this.data("options",a.extend(true,{},a.balloon.defaults,b));b=this.data("options");return this.each(function(){c=a(this);(f=c.data("offTimer"))&&clearTimeout(f);var g=a.isFunction(b.contents)?b.contents():b.contents||c.attr("title");var h=!(e=c.data("balloon"));if(h)e=a("<div>").append(g);if(!b.url&&(!e||e.html()==""))return;if(!h&&g&&g!=e.html())e.empty().append(g);c.removeAttr("title");if(b.url){e.load(a.isFunction(b.url)?b.url(this):b.url,function(a,f,g){if(b.ajaxComplete)b.ajaxComplete(a,f,g);d(c,e,b)})}if(h){e.addClass(b.classname).css(b.css).css({visibility:"hidden",position:"absolute"}).appendTo("body");c.data("balloon",e);d(c,e,b);e.hide().css("visibility","visible")}else{d(c,e,b)}c.data("onTimer",setTimeout(function(){if(b.showAnimation){b.showAnimation.apply(e.stop(true,true),[b.showDuration])}else{e.show(b.showDuration,function(){if(this.style.removeAttribute){this.style.removeAttribute("filter")}})}},b.delay))})};a.fn.hideBalloon=function(){var b=this.data("options"),c,d;return this.each(function(){var e=a(this);(c=e.data("onTimer"))&&clearTimeout(c);(d=e.data("offTimer"))&&clearTimeout(d);e.data("offTimer",setTimeout(function(){var a=e.data("balloon");if(b.hideAnimation){a&&b.hideAnimation.apply(a.stop(true,true),[b.hideDuration])}else{a&&a.stop(true,true).hide(b.hideDuration)}},b.minLifetime))})};a.balloon={defaults:{contents:null,url:null,ajaxComplete:null,classname:null,position:"top",offsetX:0,offsetY:0,tipSize:12,delay:0,minLifetime:200,showDuration:100,showAnimation:null,hideDuration:80,hideAnimation:function(a){this.fadeOut(a)},css:{minWidth:"20px",padding:"5px",borderRadius:"6px",border:"solid 1px #777",boxShadow:"4px 4px 4px #555",color:"#666",backgroundColor:"#efefef",opacity:a.support.opacity?"0.85":null,zIndex:"32767",textAlign:"left"}}}})(jQuery)

"use strict";!function(a){function n(t,e){if(!t)return console.warn("Tagify: ","invalid input element ",t),this;if(this.settings=this.extend({},this.DEFAULTS,e),this.settings.readonly=t.hasAttribute("readonly"),this.isIE&&(this.settings.autoComplete=!1),t.pattern)try{this.settings.pattern=new RegExp(t.pattern)}catch(t){}if(this.settings&&this.settings.delimiters)try{this.settings.delimiters=new RegExp("["+this.settings.delimiters+"]","g")}catch(t){}this.value=[],this.stringValue="",this.listeners={},this.DOM={},this.extend(this,new this.EventDispatcher(this)),this.build(t),this.loadOriginalValues(),this.events.customBinding.call(this),this.events.binding.call(this)}a.fn.tagify=function(){var i=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return this.each(function(){var t,e=a(this);if(e.data("tagify"))return this;i.isJQueryPlugin=!0,t=new n(e[0],i),e.data("tagify",t)})},n.prototype={isIE:window.document.documentMode,TEXTS:{empty:"empty",exceed:"number of tags exceeded",pattern:"pattern mismatch",duplicate:"already exists",notAllowed:"not allowed"},DEFAULTS:{delimiters:",",pattern:null,maxTags:1/0,callbacks:{},addTagOnBlur:!0,duplicates:!1,whitelist:[],blacklist:[],enforceWhitelist:!1,keepInvalidTags:!1,autoComplete:!0,mapValueToProp:"",dropdown:{classname:"",enabled:2,maxItems:10}},customEventsList:["add","remove","invalid"],parseHTML:function(t){return(new DOMParser).parseFromString(t.trim(),"text/html").body.firstElementChild},escapeHtml:function(t){var e=document.createTextNode(t),i=document.createElement("p");return i.appendChild(e),i.innerHTML},build:function(t){var e=this.DOM,i='<tags class="tagify '+t.className+'" '+(this.settings.readonly?"readonly":"")+'>\n                            <div contenteditable data-placeholder="'+t.placeholder+'" class="tagify__input"></div>\n                        </tags>';e.originalInput=t,e.scope=this.parseHTML(i),e.input=e.scope.querySelector("[contenteditable]"),t.parentNode.insertBefore(e.scope,t),this.settings.dropdown.enabled&&this.settings.whitelist.length&&this.dropdown.init.call(this),t.autofocus&&e.input.focus()},destroy:function(){this.DOM.scope.parentNode.removeChild(this.DOM.scope)},extend:function(t,e,i){function n(t){var e=Object.prototype.toString.call(t).split(" ")[1].slice(0,-1);return t===Object(t)&&"Array"!=e&&"Function"!=e&&"RegExp"!=e&&"HTMLUnknownElement"!=e}function s(t,e){for(var i in e)e.hasOwnProperty(i)&&(n(e[i])?n(t[i])?s(t[i],e[i]):t[i]=Object.assign({},e[i]):t[i]=e[i])}return t instanceof Object||(t={}),s(t,e),i&&s(t,i),t},EventDispatcher:function(n){var s=document.createTextNode("");this.off=function(t,e){return e&&s.removeEventListener.call(s,t,e),this},this.on=function(t,e){return e&&s.addEventListener.call(s,t,e),this},this.trigger=function(t,e){var i;if(t)if(n.settings.isJQueryPlugin)a(n.DOM.originalInput).triggerHandler(t,[e]);else{try{i=new CustomEvent(t,{detail:e})}catch(t){console.warn(t)}s.dispatchEvent(i)}}},events:{customBinding:function(){var e=this;this.customEventsList.forEach(function(t){e.on(t,e.settings.callbacks[t])})},binding:function(){var t=!(0<arguments.length&&void 0!==arguments[0])||arguments[0],e=this.events.callbacks,i=this.listeners.main=this.listeners.main||{paste:["input",e.onPaste.bind(this)],focus:["input",e.onFocusBlur.bind(this)],blur:["input",e.onFocusBlur.bind(this)],keydown:["input",e.onKeydown.bind(this)],click:["scope",e.onClickScope.bind(this)]},n=t?"addEventListener":"removeEventListener";for(var s in i)this.DOM[i[s][0]][n](s,i[s][1]);t&&(this.DOM.input.addEventListener(this.isIE?"keydown":"input",e[this.isIE?"onInputIE":"onInput"].bind(this)),this.settings.isJQueryPlugin&&a(this.DOM.originalInput).on("tagify.removeAllTags",this.removeAllTags.bind(this)))},callbacks:{onFocusBlur:function(t){var e=t.target.textContent.trim();"focus"==t.type||("blur"==t.type&&e?this.settings.addTagOnBlur&&this.addTags(e,!0).length:(this.DOM.input.removeAttribute("style"),this.dropdown.hide.call(this)))},onKeydown:function(t){var e,i=t.target.textContent;"Backspace"!=t.key||""!=i&&8203!=i.charCodeAt(0)?"Escape"==t.key?(this.input.set.call(this),t.target.blur()):"Enter"==t.key?(t.preventDefault(),this.addTags(this.input.value,!0)):"ArrowRight"==t.key&&this.input.autocomplete.set.call(this):(e=(e=this.DOM.scope.querySelectorAll("tag:not(.tagify--hide)"))[e.length-1],this.removeTag(e))},onInput:function(t){var e=this.input.normalize.call(this),i=e.length>=this.settings.dropdown.enabled;e?this.input.value!=e&&(this.input.set.call(this,e,!1),-1!=e.search(this.settings.delimiters)?this.addTags(e).length&&this.input.set.call(this):this.settings.dropdown.enabled&&this.settings.whitelist.length&&this.dropdown[i?"show":"hide"].call(this,e)):this.input.set.call(this,"")},onInputIE:function(t){var e=this;setTimeout(function(){e.events.callbacks.onInput.call(e,t)})},onPaste:function(t){},onClickScope:function(t){"TAGS"==t.target.tagName?this.DOM.input.focus():"X"==t.target.tagName&&this.removeTag(t.target.parentNode)}}},loadOriginalValues:function(){var t=this.DOM.originalInput.value;t&&this.addTags(t).forEach(function(t){t&&t.classList.add("tagify--noAnim")})},input:{value:"",set:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"",e=!(1<arguments.length&&void 0!==arguments[1])||arguments[1];this.input.value=t,e&&(this.DOM.input.innerHTML=t),t.length<2&&this.input.autocomplete.suggest.call(this,""),this.input.validate.call(this)},validate:function(){var t=!this.input.value||this.validateTag.call(this,this.input.value);this.DOM.input.classList.toggle("tagify__input--invalid",!0!==t)},normalize:function(){for(var t=this.DOM.input.cloneNode(!0),e=t.textContent.replace(/\s/g," ");t.firstElementChild;)e+=t.firstElementChild.textContent,t.removeChild(t.firstElementChild);return e.replace(/^\s+/,"")},autocomplete:{suggest:function(t){t?this.DOM.input.setAttribute("data-suggest",t.substring(this.input.value.length)):this.DOM.input.removeAttribute("data-suggest")},set:function(){var t=this.DOM.input.getAttribute("data-suggest");t&&this.addTags(this.input.value+t).length&&(this.input.set.call(this),this.dropdown.hide.call(this))}}},getNodeIndex:function(t){for(var e=0;t=t.previousSibling;)3==t.nodeType&&/^\s*$/.test(t.data)||e++;return e},isTagDuplicate:function(e){return this.value.findIndex(function(t){return e.toLowerCase()===t.value.toLowerCase()})},markTagByValue:function(t,e){var i;return e||(i=this.isTagDuplicate.call(this,t),e=this.DOM.scope.querySelectorAll("tag")[i]),!!e&&(e.classList.add("tagify--mark"),setTimeout(function(){e.classList.remove("tagify--mark")},100),e)},isTagBlacklisted:function(e){return e=e.split(" "),this.settings.blacklist.filter(function(t){return-1!=e.indexOf(t)}).length},isTagWhitelisted:function(e){return this.settings.whitelist.some(function(t){if((t.value?t.value:t).toLowerCase()===e.toLowerCase())return!0})},validateTag:function(t){var e=t.trim(),i=this.value.length>=this.settings.maxTags,n=!0;return e?i?n=this.TEXTS.exceed:this.settings.pattern&&!this.settings.pattern.test(e)?n=this.TEXTS.pattern:this.settings.duplicates||-1===this.isTagDuplicate(e)?(this.isTagBlacklisted(e)||this.settings.enforceWhitelist&&!this.isTagWhitelisted(e))&&(n=this.TEXTS.notAllowed):n=this.TEXTS.duplicate:n=this.TEXTS.empty,n},normalizeTags:function(t){var i=this,e=this.settings.whitelist[0]instanceof Object,n=t instanceof Array&&"value"in t[0],s=[];if(n)return t;if(!n){if(!t.trim())return[];t=t.split(this.settings.delimiters).filter(function(t){return t}).map(function(t){return{value:t.trim()}})}return!n&&e&&(t.forEach(function(e){var t=i.settings.whitelist.filter(function(t){return t.value.toLowerCase()==e.value.toLowerCase()});t[0]?s.push(t[0]):s.push(e)}),t=s),t},addTags:function(t,e){var n=this,s=[];return this.DOM.input.removeAttribute("style"),(t=this.normalizeTags.call(this,t)).forEach(function(t){var e,i;!0!==(e=n.validateTag.call(n,t.value))&&(t.class=t.class?t.class+" tagify--notAllowed":"tagify--notAllowed",t.title=e,n.markTagByValue.call(n,t.value),n.trigger("invalid",{value:t.value,index:n.value.length,message:e})),i=n.createTagElem(t),s.push(i),function(t){this.DOM.scope.insertBefore(t,this.DOM.input)}.call(n,i),!0===e?(n.value.push(t),n.update(),n.trigger("add",n.extend({},{index:n.value.length,tag:i},t))):n.settings.keepInvalidTags||setTimeout(function(){n.removeTag(i,!0)},1e3)}),t.length&&e&&this.input.set.call(this),s},createTagElem:function(t){var e,i=this.escapeHtml(t.value),n="<tag title='"+i+"'>\n                            <x title=''></x><div><span>"+i+"</span></div>\n                        </tag>";return function(t,e){var i,n=Object.keys(e);for(i=n.length;i--;){var s=n[i];if(!e.hasOwnProperty(s))return;t.setAttribute(s,e[s])}}(e=this.parseHTML(n),t),e},removeTag:function(t,e,i){if(t){var n,s=this.getNodeIndex(t);t&&(i&&i<10?(t.style.width=parseFloat(window.getComputedStyle(t).width)+"px",document.body.clientTop,t.classList.add("tagify--hide"),setTimeout(a,400)):a(),e||(n=this.value.splice(s,1)[0],this.update(),this.trigger("remove",this.extend({},{index:s,tag:t},n))))}function a(){t.parentNode.removeChild(t)}},removeAllTags:function(){this.value=[],this.update(),Array.prototype.slice.call(this.DOM.scope.querySelectorAll("tag")).forEach(function(t){return t.parentNode.removeChild(t)})},update:function(){var e=this,t=this.value.map(function(t){return t[e.settings.mapValueToProp||"value"]||t.value});this.DOM.originalInput.value=JSON.stringify(t)},dropdown:{init:function(){this.DOM.dropdown=this.dropdown.build.call(this)},build:function(){var t='<div class="'+("tagify__dropdown "+this.settings.dropdown.classname).trim()+'"></div>';return this.parseHTML(t)},show:function(t){var e=this.dropdown.filterListItems.call(this,t),i=this.dropdown.createListHTML(e);this.settings.autoComplete&&this.input.autocomplete.suggest.call(this,e.length?e[0].value:""),!i||e.length<2?this.dropdown.hide.call(this):(this.DOM.dropdown.innerHTML=i,this.dropdown.position.call(this),!this.DOM.dropdown.parentNode!=document.body&&(document.body.appendChild(this.DOM.dropdown),this.events.binding.call(this,!1),this.dropdown.events.binding.call(this)))},hide:function(){this.DOM.dropdown&&this.DOM.dropdown.parentNode==document.body&&(document.body.removeChild(this.DOM.dropdown),window.removeEventListener("resize",this.dropdown.position),this.dropdown.events.binding.call(this,!1),this.events.binding.call(this))},position:function(){var t=this.DOM.scope.getBoundingClientRect();this.DOM.dropdown.style.cssText="left: "+(t.left+window.pageXOffset)+"px;                                                top: "+(t.top+t.height-1+window.pageYOffset)+"px;                                                width: "+t.width+"px"},events:{binding:function(){var t=!(0<arguments.length&&void 0!==arguments[0])||arguments[0],e=this.listeners.dropdown=this.listeners.dropdown||{position:this.dropdown.position.bind(this),onKeyDown:this.dropdown.events.callbacks.onKeyDown.bind(this),onMouseOver:this.dropdown.events.callbacks.onMouseOver.bind(this),onClick:this.dropdown.events.callbacks.onClick.bind(this)},i=t?"addEventListener":"removeEventListener";window[i]("resize",e.position),window[i]("keydown",e.onKeyDown),window[i]("click",e.onClick),this.DOM.dropdown[i]("mouseover",e.onMouseOver)},callbacks:{onKeyDown:function(t){var e=this.DOM.dropdown.querySelectorAll("[class$='--active']")[0],i="";switch(t.key){case"ArrowDown":case"ArrowUp":case"Down":case"Up":t.preventDefault(),e=e?e["ArrowUp"==t.key||"Up"==t.key?"previousElementSibling":"nextElementSibling"]:this.DOM.dropdown.children["ArrowUp"==t.key||"Up"==t.key?this.DOM.dropdown.children.length-1:0],this.dropdown.highlightOption.call(this,e);break;case"Escape":this.dropdown.hide.call(this);break;case"Enter":t.preventDefault(),i=e?e.textContent:this.input.value,this.addTags(i,!0),this.dropdown.hide.call(this);break;case"ArrowRight":this.input.autocomplete.set.call(this)}},onMouseOver:function(t){t.target.className.includes("__item")&&this.dropdown.highlightOption.call(this,t.target)},onClick:function(t){t.target.className.includes("tagify__dropdown__item")&&(this.input.set.call(this),this.addTags(t.target.textContent)),this.dropdown.hide.call(this)}}},highlightOption:function(t){if(t){var e="tagify__dropdown__item--active";[].forEach.call(this.DOM.dropdown.querySelectorAll("[class$='--active']"),function(t){t.classList.remove(e)}),t.classList.add(e)}},filterListItems:function(t){if(!t)return"";for(var e,i=[],n=this.settings.whitelist,s=this.settings.dropdown.maxItems||1/0,a=0;a<n.length&&(0==(e=n[a]instanceof Object?n[a]:{value:n[a]}).value.toLowerCase().replace(/\s/g,"").indexOf(t.toLowerCase().replace(/\s/g,""))&&-1==this.isTagDuplicate(e.value)&&s--&&i.push(e),0!=s);a++);return i},createListHTML:function(t){return t.map(function(t){return"<div class='tagify__dropdown__item "+(t.class?t.class:"")+"' "+function(t){var e,i=Object.keys(t),n="";for(e=i.length;e--;){var s=i[e];if("class"!=s&&!t.hasOwnProperty(s))return;n+=" "+s+(t[s]?"="+t[s]:"")}return n}(t)+">"+t.value+"</div>"}).join("")}}}}(jQuery);
/*! tooltipster v4.2.7 */!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(a){return b(a)}):"object"==typeof exports?module.exports=b(require("jquery")):b(jQuery)}(this,function(a){function b(a){this.$container,this.constraints=null,this.__$tooltip,this.__init(a)}function c(b,c){var d=!0;return a.each(b,function(a,e){return void 0===c[a]||b[a]!==c[a]?(d=!1,!1):void 0}),d}function d(b){var c=b.attr("id"),d=c?h.window.document.getElementById(c):null;return d?d===b[0]:a.contains(h.window.document.body,b[0])}function e(){if(!g)return!1;var a=g.document.body||g.document.documentElement,b=a.style,c="transition",d=["Moz","Webkit","Khtml","O","ms"];if("string"==typeof b[c])return!0;c=c.charAt(0).toUpperCase()+c.substr(1);for(var e=0;e<d.length;e++)if("string"==typeof b[d[e]+c])return!0;return!1}var f={animation:"fade",animationDuration:350,content:null,contentAsHTML:!1,contentCloning:!1,debug:!0,delay:300,delayTouch:[300,500],functionInit:null,functionBefore:null,functionReady:null,functionAfter:null,functionFormat:null,IEmin:6,interactive:!1,multiple:!1,parent:null,plugins:["sideTip"],repositionOnScroll:!1,restoration:"none",selfDestruction:!0,theme:[],timer:0,trackerInterval:500,trackOrigin:!1,trackTooltip:!1,trigger:"hover",triggerClose:{click:!1,mouseleave:!1,originClick:!1,scroll:!1,tap:!1,touchleave:!1},triggerOpen:{click:!1,mouseenter:!1,tap:!1,touchstart:!1},updateAnimation:"rotate",zIndex:9999999},g="undefined"!=typeof window?window:null,h={hasTouchCapability:!(!g||!("ontouchstart"in g||g.DocumentTouch&&g.document instanceof g.DocumentTouch||g.navigator.maxTouchPoints)),hasTransitions:e(),IE:!1,semVer:"4.2.7",window:g},i=function(){this.__$emitterPrivate=a({}),this.__$emitterPublic=a({}),this.__instancesLatestArr=[],this.__plugins={},this._env=h};i.prototype={__bridge:function(b,c,d){if(!c[d]){var e=function(){};e.prototype=b;var g=new e;g.__init&&g.__init(c),a.each(b,function(a,b){0!=a.indexOf("__")&&(c[a]?f.debug&&console.log("The "+a+" method of the "+d+" plugin conflicts with another plugin or native methods"):(c[a]=function(){return g[a].apply(g,Array.prototype.slice.apply(arguments))},c[a].bridged=g))}),c[d]=g}return this},__setWindow:function(a){return h.window=a,this},_getRuler:function(a){return new b(a)},_off:function(){return this.__$emitterPrivate.off.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_on:function(){return this.__$emitterPrivate.on.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_one:function(){return this.__$emitterPrivate.one.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_plugin:function(b){var c=this;if("string"==typeof b){var d=b,e=null;return d.indexOf(".")>0?e=c.__plugins[d]:a.each(c.__plugins,function(a,b){return b.name.substring(b.name.length-d.length-1)=="."+d?(e=b,!1):void 0}),e}if(b.name.indexOf(".")<0)throw new Error("Plugins must be namespaced");return c.__plugins[b.name]=b,b.core&&c.__bridge(b.core,c,b.name),this},_trigger:function(){var a=Array.prototype.slice.apply(arguments);return"string"==typeof a[0]&&(a[0]={type:a[0]}),this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate,a),this.__$emitterPublic.trigger.apply(this.__$emitterPublic,a),this},instances:function(b){var c=[],d=b||".tooltipstered";return a(d).each(function(){var b=a(this),d=b.data("tooltipster-ns");d&&a.each(d,function(a,d){c.push(b.data(d))})}),c},instancesLatest:function(){return this.__instancesLatestArr},off:function(){return this.__$emitterPublic.off.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},on:function(){return this.__$emitterPublic.on.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},one:function(){return this.__$emitterPublic.one.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},origins:function(b){var c=b?b+" ":"";return a(c+".tooltipstered").toArray()},setDefaults:function(b){return a.extend(f,b),this},triggerHandler:function(){return this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this}},a.tooltipster=new i,a.Tooltipster=function(b,c){this.__callbacks={close:[],open:[]},this.__closingTime,this.__Content,this.__contentBcr,this.__destroyed=!1,this.__$emitterPrivate=a({}),this.__$emitterPublic=a({}),this.__enabled=!0,this.__garbageCollector,this.__Geometry,this.__lastPosition,this.__namespace="tooltipster-"+Math.round(1e6*Math.random()),this.__options,this.__$originParents,this.__pointerIsOverOrigin=!1,this.__previousThemes=[],this.__state="closed",this.__timeouts={close:[],open:null},this.__touchEvents=[],this.__tracker=null,this._$origin,this._$tooltip,this.__init(b,c)},a.Tooltipster.prototype={__init:function(b,c){var d=this;if(d._$origin=a(b),d.__options=a.extend(!0,{},f,c),d.__optionsFormat(),!h.IE||h.IE>=d.__options.IEmin){var e=null;if(void 0===d._$origin.data("tooltipster-initialTitle")&&(e=d._$origin.attr("title"),void 0===e&&(e=null),d._$origin.data("tooltipster-initialTitle",e)),null!==d.__options.content)d.__contentSet(d.__options.content);else{var g,i=d._$origin.attr("data-tooltip-content");i&&(g=a(i)),g&&g[0]?d.__contentSet(g.first()):d.__contentSet(e)}d._$origin.removeAttr("title").addClass("tooltipstered"),d.__prepareOrigin(),d.__prepareGC(),a.each(d.__options.plugins,function(a,b){d._plug(b)}),h.hasTouchCapability&&a(h.window.document.body).on("touchmove."+d.__namespace+"-triggerOpen",function(a){d._touchRecordEvent(a)}),d._on("created",function(){d.__prepareTooltip()})._on("repositioned",function(a){d.__lastPosition=a.position})}else d.__options.disabled=!0},__contentInsert:function(){var a=this,b=a._$tooltip.find(".tooltipster-content"),c=a.__Content,d=function(a){c=a};return a._trigger({type:"format",content:a.__Content,format:d}),a.__options.functionFormat&&(c=a.__options.functionFormat.call(a,a,{origin:a._$origin[0]},a.__Content)),"string"!=typeof c||a.__options.contentAsHTML?b.empty().append(c):b.text(c),a},__contentSet:function(b){return b instanceof a&&this.__options.contentCloning&&(b=b.clone(!0)),this.__Content=b,this._trigger({type:"updated",content:b}),this},__destroyError:function(){throw new Error("This tooltip has been destroyed and cannot execute your method call.")},__geometry:function(){var b=this,c=b._$origin,d=b._$origin.is("area");if(d){var e=b._$origin.parent().attr("name");c=a('img[usemap="#'+e+'"]')}var f=c[0].getBoundingClientRect(),g=a(h.window.document),i=a(h.window),j=c,k={available:{document:null,window:null},document:{size:{height:g.height(),width:g.width()}},window:{scroll:{left:h.window.scrollX||h.window.document.documentElement.scrollLeft,top:h.window.scrollY||h.window.document.documentElement.scrollTop},size:{height:i.height(),width:i.width()}},origin:{fixedLineage:!1,offset:{},size:{height:f.bottom-f.top,width:f.right-f.left},usemapImage:d?c[0]:null,windowOffset:{bottom:f.bottom,left:f.left,right:f.right,top:f.top}}};if(d){var l=b._$origin.attr("shape"),m=b._$origin.attr("coords");if(m&&(m=m.split(","),a.map(m,function(a,b){m[b]=parseInt(a)})),"default"!=l)switch(l){case"circle":var n=m[0],o=m[1],p=m[2],q=o-p,r=n-p;k.origin.size.height=2*p,k.origin.size.width=k.origin.size.height,k.origin.windowOffset.left+=r,k.origin.windowOffset.top+=q;break;case"rect":var s=m[0],t=m[1],u=m[2],v=m[3];k.origin.size.height=v-t,k.origin.size.width=u-s,k.origin.windowOffset.left+=s,k.origin.windowOffset.top+=t;break;case"poly":for(var w=0,x=0,y=0,z=0,A="even",B=0;B<m.length;B++){var C=m[B];"even"==A?(C>y&&(y=C,0===B&&(w=y)),w>C&&(w=C),A="odd"):(C>z&&(z=C,1==B&&(x=z)),x>C&&(x=C),A="even")}k.origin.size.height=z-x,k.origin.size.width=y-w,k.origin.windowOffset.left+=w,k.origin.windowOffset.top+=x}}var D=function(a){k.origin.size.height=a.height,k.origin.windowOffset.left=a.left,k.origin.windowOffset.top=a.top,k.origin.size.width=a.width};for(b._trigger({type:"geometry",edit:D,geometry:{height:k.origin.size.height,left:k.origin.windowOffset.left,top:k.origin.windowOffset.top,width:k.origin.size.width}}),k.origin.windowOffset.right=k.origin.windowOffset.left+k.origin.size.width,k.origin.windowOffset.bottom=k.origin.windowOffset.top+k.origin.size.height,k.origin.offset.left=k.origin.windowOffset.left+k.window.scroll.left,k.origin.offset.top=k.origin.windowOffset.top+k.window.scroll.top,k.origin.offset.bottom=k.origin.offset.top+k.origin.size.height,k.origin.offset.right=k.origin.offset.left+k.origin.size.width,k.available.document={bottom:{height:k.document.size.height-k.origin.offset.bottom,width:k.document.size.width},left:{height:k.document.size.height,width:k.origin.offset.left},right:{height:k.document.size.height,width:k.document.size.width-k.origin.offset.right},top:{height:k.origin.offset.top,width:k.document.size.width}},k.available.window={bottom:{height:Math.max(k.window.size.height-Math.max(k.origin.windowOffset.bottom,0),0),width:k.window.size.width},left:{height:k.window.size.height,width:Math.max(k.origin.windowOffset.left,0)},right:{height:k.window.size.height,width:Math.max(k.window.size.width-Math.max(k.origin.windowOffset.right,0),0)},top:{height:Math.max(k.origin.windowOffset.top,0),width:k.window.size.width}};"html"!=j[0].tagName.toLowerCase();){if("fixed"==j.css("position")){k.origin.fixedLineage=!0;break}j=j.parent()}return k},__optionsFormat:function(){return"number"==typeof this.__options.animationDuration&&(this.__options.animationDuration=[this.__options.animationDuration,this.__options.animationDuration]),"number"==typeof this.__options.delay&&(this.__options.delay=[this.__options.delay,this.__options.delay]),"number"==typeof this.__options.delayTouch&&(this.__options.delayTouch=[this.__options.delayTouch,this.__options.delayTouch]),"string"==typeof this.__options.theme&&(this.__options.theme=[this.__options.theme]),null===this.__options.parent?this.__options.parent=a(h.window.document.body):"string"==typeof this.__options.parent&&(this.__options.parent=a(this.__options.parent)),"hover"==this.__options.trigger?(this.__options.triggerOpen={mouseenter:!0,touchstart:!0},this.__options.triggerClose={mouseleave:!0,originClick:!0,touchleave:!0}):"click"==this.__options.trigger&&(this.__options.triggerOpen={click:!0,tap:!0},this.__options.triggerClose={click:!0,tap:!0}),this._trigger("options"),this},__prepareGC:function(){var b=this;return b.__options.selfDestruction?b.__garbageCollector=setInterval(function(){var c=(new Date).getTime();b.__touchEvents=a.grep(b.__touchEvents,function(a,b){return c-a.time>6e4}),d(b._$origin)||b.close(function(){b.destroy()})},2e4):clearInterval(b.__garbageCollector),b},__prepareOrigin:function(){var a=this;if(a._$origin.off("."+a.__namespace+"-triggerOpen"),h.hasTouchCapability&&a._$origin.on("touchstart."+a.__namespace+"-triggerOpen touchend."+a.__namespace+"-triggerOpen touchcancel."+a.__namespace+"-triggerOpen",function(b){a._touchRecordEvent(b)}),a.__options.triggerOpen.click||a.__options.triggerOpen.tap&&h.hasTouchCapability){var b="";a.__options.triggerOpen.click&&(b+="click."+a.__namespace+"-triggerOpen "),a.__options.triggerOpen.tap&&h.hasTouchCapability&&(b+="touchend."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){a._touchIsMeaningfulEvent(b)&&a._open(b)})}if(a.__options.triggerOpen.mouseenter||a.__options.triggerOpen.touchstart&&h.hasTouchCapability){var b="";a.__options.triggerOpen.mouseenter&&(b+="mouseenter."+a.__namespace+"-triggerOpen "),a.__options.triggerOpen.touchstart&&h.hasTouchCapability&&(b+="touchstart."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){!a._touchIsTouchEvent(b)&&a._touchIsEmulatedEvent(b)||(a.__pointerIsOverOrigin=!0,a._openShortly(b))})}if(a.__options.triggerClose.mouseleave||a.__options.triggerClose.touchleave&&h.hasTouchCapability){var b="";a.__options.triggerClose.mouseleave&&(b+="mouseleave."+a.__namespace+"-triggerOpen "),a.__options.triggerClose.touchleave&&h.hasTouchCapability&&(b+="touchend."+a.__namespace+"-triggerOpen touchcancel."+a.__namespace+"-triggerOpen"),a._$origin.on(b,function(b){a._touchIsMeaningfulEvent(b)&&(a.__pointerIsOverOrigin=!1)})}return a},__prepareTooltip:function(){var b=this,c=b.__options.interactive?"auto":"";return b._$tooltip.attr("id",b.__namespace).css({"pointer-events":c,zIndex:b.__options.zIndex}),a.each(b.__previousThemes,function(a,c){b._$tooltip.removeClass(c)}),a.each(b.__options.theme,function(a,c){b._$tooltip.addClass(c)}),b.__previousThemes=a.merge([],b.__options.theme),b},__scrollHandler:function(b){var c=this;if(c.__options.triggerClose.scroll)c._close(b);else if(d(c._$origin)&&d(c._$tooltip)){var e=null;if(b.target===h.window.document)c.__Geometry.origin.fixedLineage||c.__options.repositionOnScroll&&c.reposition(b);else{e=c.__geometry();var f=!1;if("fixed"!=c._$origin.css("position")&&c.__$originParents.each(function(b,c){var d=a(c),g=d.css("overflow-x"),h=d.css("overflow-y");if("visible"!=g||"visible"!=h){var i=c.getBoundingClientRect();if("visible"!=g&&(e.origin.windowOffset.left<i.left||e.origin.windowOffset.right>i.right))return f=!0,!1;if("visible"!=h&&(e.origin.windowOffset.top<i.top||e.origin.windowOffset.bottom>i.bottom))return f=!0,!1}return"fixed"==d.css("position")?!1:void 0}),f)c._$tooltip.css("visibility","hidden");else if(c._$tooltip.css("visibility","visible"),c.__options.repositionOnScroll)c.reposition(b);else{var g=e.origin.offset.left-c.__Geometry.origin.offset.left,i=e.origin.offset.top-c.__Geometry.origin.offset.top;c._$tooltip.css({left:c.__lastPosition.coord.left+g,top:c.__lastPosition.coord.top+i})}}c._trigger({type:"scroll",event:b,geo:e})}return c},__stateSet:function(a){return this.__state=a,this._trigger({type:"state",state:a}),this},__timeoutsClear:function(){return clearTimeout(this.__timeouts.open),this.__timeouts.open=null,a.each(this.__timeouts.close,function(a,b){clearTimeout(b)}),this.__timeouts.close=[],this},__trackerStart:function(){var a=this,b=a._$tooltip.find(".tooltipster-content");return a.__options.trackTooltip&&(a.__contentBcr=b[0].getBoundingClientRect()),a.__tracker=setInterval(function(){if(d(a._$origin)&&d(a._$tooltip)){if(a.__options.trackOrigin){var e=a.__geometry(),f=!1;c(e.origin.size,a.__Geometry.origin.size)&&(a.__Geometry.origin.fixedLineage?c(e.origin.windowOffset,a.__Geometry.origin.windowOffset)&&(f=!0):c(e.origin.offset,a.__Geometry.origin.offset)&&(f=!0)),f||(a.__options.triggerClose.mouseleave?a._close():a.reposition())}if(a.__options.trackTooltip){var g=b[0].getBoundingClientRect();g.height===a.__contentBcr.height&&g.width===a.__contentBcr.width||(a.reposition(),a.__contentBcr=g)}}else a._close()},a.__options.trackerInterval),a},_close:function(b,c,d){var e=this,f=!0;if(e._trigger({type:"close",event:b,stop:function(){f=!1}}),f||d){c&&e.__callbacks.close.push(c),e.__callbacks.open=[],e.__timeoutsClear();var g=function(){a.each(e.__callbacks.close,function(a,c){c.call(e,e,{event:b,origin:e._$origin[0]})}),e.__callbacks.close=[]};if("closed"!=e.__state){var i=!0,j=new Date,k=j.getTime(),l=k+e.__options.animationDuration[1];if("disappearing"==e.__state&&l>e.__closingTime&&e.__options.animationDuration[1]>0&&(i=!1),i){e.__closingTime=l,"disappearing"!=e.__state&&e.__stateSet("disappearing");var m=function(){clearInterval(e.__tracker),e._trigger({type:"closing",event:b}),e._$tooltip.off("."+e.__namespace+"-triggerClose").removeClass("tooltipster-dying"),a(h.window).off("."+e.__namespace+"-triggerClose"),e.__$originParents.each(function(b,c){a(c).off("scroll."+e.__namespace+"-triggerClose")}),e.__$originParents=null,a(h.window.document.body).off("."+e.__namespace+"-triggerClose"),e._$origin.off("."+e.__namespace+"-triggerClose"),e._off("dismissable"),e.__stateSet("closed"),e._trigger({type:"after",event:b}),e.__options.functionAfter&&e.__options.functionAfter.call(e,e,{event:b,origin:e._$origin[0]}),g()};h.hasTransitions?(e._$tooltip.css({"-moz-animation-duration":e.__options.animationDuration[1]+"ms","-ms-animation-duration":e.__options.animationDuration[1]+"ms","-o-animation-duration":e.__options.animationDuration[1]+"ms","-webkit-animation-duration":e.__options.animationDuration[1]+"ms","animation-duration":e.__options.animationDuration[1]+"ms","transition-duration":e.__options.animationDuration[1]+"ms"}),e._$tooltip.clearQueue().removeClass("tooltipster-show").addClass("tooltipster-dying"),e.__options.animationDuration[1]>0&&e._$tooltip.delay(e.__options.animationDuration[1]),e._$tooltip.queue(m)):e._$tooltip.stop().fadeOut(e.__options.animationDuration[1],m)}}else g()}return e},_off:function(){return this.__$emitterPrivate.off.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_on:function(){return this.__$emitterPrivate.on.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_one:function(){return this.__$emitterPrivate.one.apply(this.__$emitterPrivate,Array.prototype.slice.apply(arguments)),this},_open:function(b,c){var e=this;if(!e.__destroying&&d(e._$origin)&&e.__enabled){var f=!0;if("closed"==e.__state&&(e._trigger({type:"before",event:b,stop:function(){f=!1}}),f&&e.__options.functionBefore&&(f=e.__options.functionBefore.call(e,e,{event:b,origin:e._$origin[0]}))),f!==!1&&null!==e.__Content){c&&e.__callbacks.open.push(c),e.__callbacks.close=[],e.__timeoutsClear();var g,i=function(){"stable"!=e.__state&&e.__stateSet("stable"),a.each(e.__callbacks.open,function(a,b){b.call(e,e,{origin:e._$origin[0],tooltip:e._$tooltip[0]})}),e.__callbacks.open=[]};if("closed"!==e.__state)g=0,"disappearing"===e.__state?(e.__stateSet("appearing"),h.hasTransitions?(e._$tooltip.clearQueue().removeClass("tooltipster-dying").addClass("tooltipster-show"),e.__options.animationDuration[0]>0&&e._$tooltip.delay(e.__options.animationDuration[0]),e._$tooltip.queue(i)):e._$tooltip.stop().fadeIn(i)):"stable"==e.__state&&i();else{if(e.__stateSet("appearing"),g=e.__options.animationDuration[0],e.__contentInsert(),e.reposition(b,!0),h.hasTransitions?(e._$tooltip.addClass("tooltipster-"+e.__options.animation).addClass("tooltipster-initial").css({"-moz-animation-duration":e.__options.animationDuration[0]+"ms","-ms-animation-duration":e.__options.animationDuration[0]+"ms","-o-animation-duration":e.__options.animationDuration[0]+"ms","-webkit-animation-duration":e.__options.animationDuration[0]+"ms","animation-duration":e.__options.animationDuration[0]+"ms","transition-duration":e.__options.animationDuration[0]+"ms"}),setTimeout(function(){"closed"!=e.__state&&(e._$tooltip.addClass("tooltipster-show").removeClass("tooltipster-initial"),e.__options.animationDuration[0]>0&&e._$tooltip.delay(e.__options.animationDuration[0]),e._$tooltip.queue(i))},0)):e._$tooltip.css("display","none").fadeIn(e.__options.animationDuration[0],i),e.__trackerStart(),a(h.window).on("resize."+e.__namespace+"-triggerClose",function(b){var c=a(document.activeElement);(c.is("input")||c.is("textarea"))&&a.contains(e._$tooltip[0],c[0])||e.reposition(b)}).on("scroll."+e.__namespace+"-triggerClose",function(a){e.__scrollHandler(a)}),e.__$originParents=e._$origin.parents(),e.__$originParents.each(function(b,c){a(c).on("scroll."+e.__namespace+"-triggerClose",function(a){e.__scrollHandler(a)})}),e.__options.triggerClose.mouseleave||e.__options.triggerClose.touchleave&&h.hasTouchCapability){e._on("dismissable",function(a){a.dismissable?a.delay?(m=setTimeout(function(){e._close(a.event)},a.delay),e.__timeouts.close.push(m)):e._close(a):clearTimeout(m)});var j=e._$origin,k="",l="",m=null;e.__options.interactive&&(j=j.add(e._$tooltip)),e.__options.triggerClose.mouseleave&&(k+="mouseenter."+e.__namespace+"-triggerClose ",l+="mouseleave."+e.__namespace+"-triggerClose "),e.__options.triggerClose.touchleave&&h.hasTouchCapability&&(k+="touchstart."+e.__namespace+"-triggerClose",l+="touchend."+e.__namespace+"-triggerClose touchcancel."+e.__namespace+"-triggerClose"),j.on(l,function(a){if(e._touchIsTouchEvent(a)||!e._touchIsEmulatedEvent(a)){var b="mouseleave"==a.type?e.__options.delay:e.__options.delayTouch;e._trigger({delay:b[1],dismissable:!0,event:a,type:"dismissable"})}}).on(k,function(a){!e._touchIsTouchEvent(a)&&e._touchIsEmulatedEvent(a)||e._trigger({dismissable:!1,event:a,type:"dismissable"})})}e.__options.triggerClose.originClick&&e._$origin.on("click."+e.__namespace+"-triggerClose",function(a){e._touchIsTouchEvent(a)||e._touchIsEmulatedEvent(a)||e._close(a)}),(e.__options.triggerClose.click||e.__options.triggerClose.tap&&h.hasTouchCapability)&&setTimeout(function(){if("closed"!=e.__state){var b="",c=a(h.window.document.body);e.__options.triggerClose.click&&(b+="click."+e.__namespace+"-triggerClose "),e.__options.triggerClose.tap&&h.hasTouchCapability&&(b+="touchend."+e.__namespace+"-triggerClose"),c.on(b,function(b){e._touchIsMeaningfulEvent(b)&&(e._touchRecordEvent(b),e.__options.interactive&&a.contains(e._$tooltip[0],b.target)||e._close(b))}),e.__options.triggerClose.tap&&h.hasTouchCapability&&c.on("touchstart."+e.__namespace+"-triggerClose",function(a){e._touchRecordEvent(a)})}},0),e._trigger("ready"),e.__options.functionReady&&e.__options.functionReady.call(e,e,{origin:e._$origin[0],tooltip:e._$tooltip[0]})}if(e.__options.timer>0){var m=setTimeout(function(){e._close()},e.__options.timer+g);e.__timeouts.close.push(m)}}}return e},_openShortly:function(a){var b=this,c=!0;if("stable"!=b.__state&&"appearing"!=b.__state&&!b.__timeouts.open&&(b._trigger({type:"start",event:a,stop:function(){c=!1}}),c)){var d=0==a.type.indexOf("touch")?b.__options.delayTouch:b.__options.delay;d[0]?b.__timeouts.open=setTimeout(function(){b.__timeouts.open=null,b.__pointerIsOverOrigin&&b._touchIsMeaningfulEvent(a)?(b._trigger("startend"),b._open(a)):b._trigger("startcancel")},d[0]):(b._trigger("startend"),b._open(a))}return b},_optionsExtract:function(b,c){var d=this,e=a.extend(!0,{},c),f=d.__options[b];return f||(f={},a.each(c,function(a,b){var c=d.__options[a];void 0!==c&&(f[a]=c)})),a.each(e,function(b,c){void 0!==f[b]&&("object"!=typeof c||c instanceof Array||null==c||"object"!=typeof f[b]||f[b]instanceof Array||null==f[b]?e[b]=f[b]:a.extend(e[b],f[b]))}),e},_plug:function(b){var c=a.tooltipster._plugin(b);if(!c)throw new Error('The "'+b+'" plugin is not defined');return c.instance&&a.tooltipster.__bridge(c.instance,this,c.name),this},_touchIsEmulatedEvent:function(a){for(var b=!1,c=(new Date).getTime(),d=this.__touchEvents.length-1;d>=0;d--){var e=this.__touchEvents[d];if(!(c-e.time<500))break;e.target===a.target&&(b=!0)}return b},_touchIsMeaningfulEvent:function(a){return this._touchIsTouchEvent(a)&&!this._touchSwiped(a.target)||!this._touchIsTouchEvent(a)&&!this._touchIsEmulatedEvent(a)},_touchIsTouchEvent:function(a){return 0==a.type.indexOf("touch")},_touchRecordEvent:function(a){return this._touchIsTouchEvent(a)&&(a.time=(new Date).getTime(),this.__touchEvents.push(a)),this},_touchSwiped:function(a){for(var b=!1,c=this.__touchEvents.length-1;c>=0;c--){var d=this.__touchEvents[c];if("touchmove"==d.type){b=!0;break}if("touchstart"==d.type&&a===d.target)break}return b},_trigger:function(){var b=Array.prototype.slice.apply(arguments);return"string"==typeof b[0]&&(b[0]={type:b[0]}),b[0].instance=this,b[0].origin=this._$origin?this._$origin[0]:null,b[0].tooltip=this._$tooltip?this._$tooltip[0]:null,this.__$emitterPrivate.trigger.apply(this.__$emitterPrivate,b),a.tooltipster._trigger.apply(a.tooltipster,b),this.__$emitterPublic.trigger.apply(this.__$emitterPublic,b),this},_unplug:function(b){var c=this;if(c[b]){var d=a.tooltipster._plugin(b);d.instance&&a.each(d.instance,function(a,d){c[a]&&c[a].bridged===c[b]&&delete c[a]}),c[b].__destroy&&c[b].__destroy(),delete c[b]}return c},close:function(a){return this.__destroyed?this.__destroyError():this._close(null,a),this},content:function(a){var b=this;if(void 0===a)return b.__Content;if(b.__destroyed)b.__destroyError();else if(b.__contentSet(a),null!==b.__Content){if("closed"!==b.__state&&(b.__contentInsert(),b.reposition(),b.__options.updateAnimation))if(h.hasTransitions){var c=b.__options.updateAnimation;b._$tooltip.addClass("tooltipster-update-"+c),setTimeout(function(){"closed"!=b.__state&&b._$tooltip.removeClass("tooltipster-update-"+c)},1e3)}else b._$tooltip.fadeTo(200,.5,function(){"closed"!=b.__state&&b._$tooltip.fadeTo(200,1)})}else b._close();return b},destroy:function(){var b=this;if(b.__destroyed)b.__destroyError();else{"closed"!=b.__state?b.option("animationDuration",0)._close(null,null,!0):b.__timeoutsClear(),b._trigger("destroy"),b.__destroyed=!0,b._$origin.removeData(b.__namespace).off("."+b.__namespace+"-triggerOpen"),a(h.window.document.body).off("."+b.__namespace+"-triggerOpen");var c=b._$origin.data("tooltipster-ns");if(c)if(1===c.length){var d=null;"previous"==b.__options.restoration?d=b._$origin.data("tooltipster-initialTitle"):"current"==b.__options.restoration&&(d="string"==typeof b.__Content?b.__Content:a("<div></div>").append(b.__Content).html()),d&&b._$origin.attr("title",d),b._$origin.removeClass("tooltipstered"),b._$origin.removeData("tooltipster-ns").removeData("tooltipster-initialTitle")}else c=a.grep(c,function(a,c){return a!==b.__namespace}),b._$origin.data("tooltipster-ns",c);b._trigger("destroyed"),b._off(),b.off(),b.__Content=null,b.__$emitterPrivate=null,b.__$emitterPublic=null,b.__options.parent=null,b._$origin=null,b._$tooltip=null,a.tooltipster.__instancesLatestArr=a.grep(a.tooltipster.__instancesLatestArr,function(a,c){return b!==a}),clearInterval(b.__garbageCollector)}return b},disable:function(){return this.__destroyed?(this.__destroyError(),this):(this._close(),this.__enabled=!1,this)},elementOrigin:function(){return this.__destroyed?void this.__destroyError():this._$origin[0]},elementTooltip:function(){return this._$tooltip?this._$tooltip[0]:null},enable:function(){return this.__enabled=!0,this},hide:function(a){return this.close(a)},instance:function(){return this},off:function(){return this.__destroyed||this.__$emitterPublic.off.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},on:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.on.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},one:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.one.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this},open:function(a){return this.__destroyed?this.__destroyError():this._open(null,a),this},option:function(b,c){return void 0===c?this.__options[b]:(this.__destroyed?this.__destroyError():(this.__options[b]=c,this.__optionsFormat(),a.inArray(b,["trigger","triggerClose","triggerOpen"])>=0&&this.__prepareOrigin(),"selfDestruction"===b&&this.__prepareGC()),this)},reposition:function(a,b){var c=this;return c.__destroyed?c.__destroyError():"closed"!=c.__state&&d(c._$origin)&&(b||d(c._$tooltip))&&(b||c._$tooltip.detach(),c.__Geometry=c.__geometry(),c._trigger({type:"reposition",event:a,helper:{geo:c.__Geometry}})),c},show:function(a){return this.open(a)},status:function(){return{destroyed:this.__destroyed,enabled:this.__enabled,open:"closed"!==this.__state,state:this.__state}},triggerHandler:function(){return this.__destroyed?this.__destroyError():this.__$emitterPublic.triggerHandler.apply(this.__$emitterPublic,Array.prototype.slice.apply(arguments)),this}},a.fn.tooltipster=function(){var b=Array.prototype.slice.apply(arguments),c="You are using a single HTML element as content for several tooltips. You probably want to set the contentCloning option to TRUE.";if(0===this.length)return this;if("string"==typeof b[0]){var d="#*$~&";return this.each(function(){var e=a(this).data("tooltipster-ns"),f=e?a(this).data(e[0]):null;if(!f)throw new Error("You called Tooltipster's \""+b[0]+'" method on an uninitialized element');if("function"!=typeof f[b[0]])throw new Error('Unknown method "'+b[0]+'"');this.length>1&&"content"==b[0]&&(b[1]instanceof a||"object"==typeof b[1]&&null!=b[1]&&b[1].tagName)&&!f.__options.contentCloning&&f.__options.debug&&console.log(c);var g=f[b[0]](b[1],b[2]);return g!==f||"instance"===b[0]?(d=g,!1):void 0}),"#*$~&"!==d?d:this}a.tooltipster.__instancesLatestArr=[];var e=b[0]&&void 0!==b[0].multiple,g=e&&b[0].multiple||!e&&f.multiple,h=b[0]&&void 0!==b[0].content,i=h&&b[0].content||!h&&f.content,j=b[0]&&void 0!==b[0].contentCloning,k=j&&b[0].contentCloning||!j&&f.contentCloning,l=b[0]&&void 0!==b[0].debug,m=l&&b[0].debug||!l&&f.debug;return this.length>1&&(i instanceof a||"object"==typeof i&&null!=i&&i.tagName)&&!k&&m&&console.log(c),this.each(function(){var c=!1,d=a(this),e=d.data("tooltipster-ns"),f=null;e?g?c=!0:m&&(console.log("Tooltipster: one or more tooltips are already attached to the element below. Ignoring."),console.log(this)):c=!0,c&&(f=new a.Tooltipster(this,b[0]),e||(e=[]),e.push(f.__namespace),d.data("tooltipster-ns",e),d.data(f.__namespace,f),f.__options.functionInit&&f.__options.functionInit.call(f,f,{origin:this}),f._trigger("init")),a.tooltipster.__instancesLatestArr.push(f)}),this},b.prototype={__init:function(b){this.__$tooltip=b,this.__$tooltip.css({left:0,overflow:"hidden",position:"absolute",top:0}).find(".tooltipster-content").css("overflow","auto"),this.$container=a('<div class="tooltipster-ruler"></div>').append(this.__$tooltip).appendTo(h.window.document.body)},__forceRedraw:function(){var a=this.__$tooltip.parent();this.__$tooltip.detach(),this.__$tooltip.appendTo(a)},constrain:function(a,b){return this.constraints={width:a,height:b},this.__$tooltip.css({display:"block",height:"",overflow:"auto",width:a}),this},destroy:function(){this.__$tooltip.detach().find(".tooltipster-content").css({display:"",overflow:""}),this.$container.remove()},free:function(){return this.constraints=null,this.__$tooltip.css({display:"",height:"",overflow:"visible",width:""}),this},measure:function(){this.__forceRedraw();var a=this.__$tooltip[0].getBoundingClientRect(),b={size:{height:a.height||a.bottom-a.top,width:a.width||a.right-a.left}};if(this.constraints){var c=this.__$tooltip.find(".tooltipster-content"),d=this.__$tooltip.outerHeight(),e=c[0].getBoundingClientRect(),f={height:d<=this.constraints.height,width:a.width<=this.constraints.width&&e.width>=c[0].scrollWidth-1};b.fits=f.height&&f.width}return h.IE&&h.IE<=11&&b.size.width!==h.window.document.documentElement.clientWidth&&(b.size.width=Math.ceil(b.size.width)+1),b}};var j=navigator.userAgent.toLowerCase();-1!=j.indexOf("msie")?h.IE=parseInt(j.split("msie")[1]):-1!==j.toLowerCase().indexOf("trident")&&-1!==j.indexOf(" rv:11")?h.IE=11:-1!=j.toLowerCase().indexOf("edge/")&&(h.IE=parseInt(j.toLowerCase().split("edge/")[1]));var k="tooltipster.sideTip";return a.tooltipster._plugin({name:k,instance:{__defaults:function(){return{arrow:!0,distance:6,functionPosition:null,maxWidth:null,minIntersection:16,minWidth:0,position:null,side:"top",viewportAware:!0}},__init:function(a){var b=this;b.__instance=a,b.__namespace="tooltipster-sideTip-"+Math.round(1e6*Math.random()),b.__previousState="closed",b.__options,b.__optionsFormat(),b.__instance._on("state."+b.__namespace,function(a){"closed"==a.state?b.__close():"appearing"==a.state&&"closed"==b.__previousState&&b.__create(),b.__previousState=a.state}),b.__instance._on("options."+b.__namespace,function(){b.__optionsFormat()}),b.__instance._on("reposition."+b.__namespace,function(a){b.__reposition(a.event,a.helper)})},__close:function(){this.__instance.content()instanceof a&&this.__instance.content().detach(),this.__instance._$tooltip.remove(),this.__instance._$tooltip=null},__create:function(){var b=a('<div class="tooltipster-base tooltipster-sidetip"><div class="tooltipster-box"><div class="tooltipster-content"></div></div><div class="tooltipster-arrow"><div class="tooltipster-arrow-uncropped"><div class="tooltipster-arrow-border"></div><div class="tooltipster-arrow-background"></div></div></div></div>');this.__options.arrow||b.find(".tooltipster-box").css("margin",0).end().find(".tooltipster-arrow").hide(),this.__options.minWidth&&b.css("min-width",this.__options.minWidth+"px"),this.__options.maxWidth&&b.css("max-width",this.__options.maxWidth+"px"),
this.__instance._$tooltip=b,this.__instance._trigger("created")},__destroy:function(){this.__instance._off("."+self.__namespace)},__optionsFormat:function(){var b=this;if(b.__options=b.__instance._optionsExtract(k,b.__defaults()),b.__options.position&&(b.__options.side=b.__options.position),"object"!=typeof b.__options.distance&&(b.__options.distance=[b.__options.distance]),b.__options.distance.length<4&&(void 0===b.__options.distance[1]&&(b.__options.distance[1]=b.__options.distance[0]),void 0===b.__options.distance[2]&&(b.__options.distance[2]=b.__options.distance[0]),void 0===b.__options.distance[3]&&(b.__options.distance[3]=b.__options.distance[1]),b.__options.distance={top:b.__options.distance[0],right:b.__options.distance[1],bottom:b.__options.distance[2],left:b.__options.distance[3]}),"string"==typeof b.__options.side){var c={top:"bottom",right:"left",bottom:"top",left:"right"};b.__options.side=[b.__options.side,c[b.__options.side]],"left"==b.__options.side[0]||"right"==b.__options.side[0]?b.__options.side.push("top","bottom"):b.__options.side.push("right","left")}6===a.tooltipster._env.IE&&b.__options.arrow!==!0&&(b.__options.arrow=!1)},__reposition:function(b,c){var d,e=this,f=e.__targetFind(c),g=[];e.__instance._$tooltip.detach();var h=e.__instance._$tooltip.clone(),i=a.tooltipster._getRuler(h),j=!1,k=e.__instance.option("animation");switch(k&&h.removeClass("tooltipster-"+k),a.each(["window","document"],function(d,k){var l=null;if(e.__instance._trigger({container:k,helper:c,satisfied:j,takeTest:function(a){l=a},results:g,type:"positionTest"}),1==l||0!=l&&0==j&&("window"!=k||e.__options.viewportAware))for(var d=0;d<e.__options.side.length;d++){var m={horizontal:0,vertical:0},n=e.__options.side[d];"top"==n||"bottom"==n?m.vertical=e.__options.distance[n]:m.horizontal=e.__options.distance[n],e.__sideChange(h,n),a.each(["natural","constrained"],function(a,d){if(l=null,e.__instance._trigger({container:k,event:b,helper:c,mode:d,results:g,satisfied:j,side:n,takeTest:function(a){l=a},type:"positionTest"}),1==l||0!=l&&0==j){var h={container:k,distance:m,fits:null,mode:d,outerSize:null,side:n,size:null,target:f[n],whole:null},o="natural"==d?i.free():i.constrain(c.geo.available[k][n].width-m.horizontal,c.geo.available[k][n].height-m.vertical),p=o.measure();if(h.size=p.size,h.outerSize={height:p.size.height+m.vertical,width:p.size.width+m.horizontal},"natural"==d?c.geo.available[k][n].width>=h.outerSize.width&&c.geo.available[k][n].height>=h.outerSize.height?h.fits=!0:h.fits=!1:h.fits=p.fits,"window"==k&&(h.fits?"top"==n||"bottom"==n?h.whole=c.geo.origin.windowOffset.right>=e.__options.minIntersection&&c.geo.window.size.width-c.geo.origin.windowOffset.left>=e.__options.minIntersection:h.whole=c.geo.origin.windowOffset.bottom>=e.__options.minIntersection&&c.geo.window.size.height-c.geo.origin.windowOffset.top>=e.__options.minIntersection:h.whole=!1),g.push(h),h.whole)j=!0;else if("natural"==h.mode&&(h.fits||h.size.width<=c.geo.available[k][n].width))return!1}})}}),e.__instance._trigger({edit:function(a){g=a},event:b,helper:c,results:g,type:"positionTested"}),g.sort(function(a,b){if(a.whole&&!b.whole)return-1;if(!a.whole&&b.whole)return 1;if(a.whole&&b.whole){var c=e.__options.side.indexOf(a.side),d=e.__options.side.indexOf(b.side);return d>c?-1:c>d?1:"natural"==a.mode?-1:1}if(a.fits&&!b.fits)return-1;if(!a.fits&&b.fits)return 1;if(a.fits&&b.fits){var c=e.__options.side.indexOf(a.side),d=e.__options.side.indexOf(b.side);return d>c?-1:c>d?1:"natural"==a.mode?-1:1}return"document"==a.container&&"bottom"==a.side&&"natural"==a.mode?-1:1}),d=g[0],d.coord={},d.side){case"left":case"right":d.coord.top=Math.floor(d.target-d.size.height/2);break;case"bottom":case"top":d.coord.left=Math.floor(d.target-d.size.width/2)}switch(d.side){case"left":d.coord.left=c.geo.origin.windowOffset.left-d.outerSize.width;break;case"right":d.coord.left=c.geo.origin.windowOffset.right+d.distance.horizontal;break;case"top":d.coord.top=c.geo.origin.windowOffset.top-d.outerSize.height;break;case"bottom":d.coord.top=c.geo.origin.windowOffset.bottom+d.distance.vertical}"window"==d.container?"top"==d.side||"bottom"==d.side?d.coord.left<0?c.geo.origin.windowOffset.right-this.__options.minIntersection>=0?d.coord.left=0:d.coord.left=c.geo.origin.windowOffset.right-this.__options.minIntersection-1:d.coord.left>c.geo.window.size.width-d.size.width&&(c.geo.origin.windowOffset.left+this.__options.minIntersection<=c.geo.window.size.width?d.coord.left=c.geo.window.size.width-d.size.width:d.coord.left=c.geo.origin.windowOffset.left+this.__options.minIntersection+1-d.size.width):d.coord.top<0?c.geo.origin.windowOffset.bottom-this.__options.minIntersection>=0?d.coord.top=0:d.coord.top=c.geo.origin.windowOffset.bottom-this.__options.minIntersection-1:d.coord.top>c.geo.window.size.height-d.size.height&&(c.geo.origin.windowOffset.top+this.__options.minIntersection<=c.geo.window.size.height?d.coord.top=c.geo.window.size.height-d.size.height:d.coord.top=c.geo.origin.windowOffset.top+this.__options.minIntersection+1-d.size.height):(d.coord.left>c.geo.window.size.width-d.size.width&&(d.coord.left=c.geo.window.size.width-d.size.width),d.coord.left<0&&(d.coord.left=0)),e.__sideChange(h,d.side),c.tooltipClone=h[0],c.tooltipParent=e.__instance.option("parent").parent[0],c.mode=d.mode,c.whole=d.whole,c.origin=e.__instance._$origin[0],c.tooltip=e.__instance._$tooltip[0],delete d.container,delete d.fits,delete d.mode,delete d.outerSize,delete d.whole,d.distance=d.distance.horizontal||d.distance.vertical;var l=a.extend(!0,{},d);if(e.__instance._trigger({edit:function(a){d=a},event:b,helper:c,position:l,type:"position"}),e.__options.functionPosition){var m=e.__options.functionPosition.call(e,e.__instance,c,l);m&&(d=m)}i.destroy();var n,o;"top"==d.side||"bottom"==d.side?(n={prop:"left",val:d.target-d.coord.left},o=d.size.width-this.__options.minIntersection):(n={prop:"top",val:d.target-d.coord.top},o=d.size.height-this.__options.minIntersection),n.val<this.__options.minIntersection?n.val=this.__options.minIntersection:n.val>o&&(n.val=o);var p;p=c.geo.origin.fixedLineage?c.geo.origin.windowOffset:{left:c.geo.origin.windowOffset.left+c.geo.window.scroll.left,top:c.geo.origin.windowOffset.top+c.geo.window.scroll.top},d.coord={left:p.left+(d.coord.left-c.geo.origin.windowOffset.left),top:p.top+(d.coord.top-c.geo.origin.windowOffset.top)},e.__sideChange(e.__instance._$tooltip,d.side),c.geo.origin.fixedLineage?e.__instance._$tooltip.css("position","fixed"):e.__instance._$tooltip.css("position",""),e.__instance._$tooltip.css({left:d.coord.left,top:d.coord.top,height:d.size.height,width:d.size.width}).find(".tooltipster-arrow").css({left:"",top:""}).css(n.prop,n.val),e.__instance._$tooltip.appendTo(e.__instance.option("parent")),e.__instance._trigger({type:"repositioned",event:b,position:d})},__sideChange:function(a,b){a.removeClass("tooltipster-bottom").removeClass("tooltipster-left").removeClass("tooltipster-right").removeClass("tooltipster-top").addClass("tooltipster-"+b)},__targetFind:function(a){var b={},c=this.__instance._$origin[0].getClientRects();if(c.length>1){var d=this.__instance._$origin.css("opacity");1==d&&(this.__instance._$origin.css("opacity",.99),c=this.__instance._$origin[0].getClientRects(),this.__instance._$origin.css("opacity",1))}if(c.length<2)b.top=Math.floor(a.geo.origin.windowOffset.left+a.geo.origin.size.width/2),b.bottom=b.top,b.left=Math.floor(a.geo.origin.windowOffset.top+a.geo.origin.size.height/2),b.right=b.left;else{var e=c[0];b.top=Math.floor(e.left+(e.right-e.left)/2),e=c.length>2?c[Math.ceil(c.length/2)-1]:c[0],b.right=Math.floor(e.top+(e.bottom-e.top)/2),e=c[c.length-1],b.bottom=Math.floor(e.left+(e.right-e.left)/2),e=c.length>2?c[Math.ceil((c.length+1)/2)-1]:c[c.length-1],b.left=Math.floor(e.top+(e.bottom-e.top)/2)}return b}}}),a});
var QRCode;!function(){function t(t){this.mode=r.MODE_8BIT_BYTE,this.data=t,this.parsedData=[];for(var e=0,o=this.data.length;e<o;e++){var i=[],n=this.data.charCodeAt(e);n>65536?(i[0]=240|(1835008&n)>>>18,i[1]=128|(258048&n)>>>12,i[2]=128|(4032&n)>>>6,i[3]=128|63&n):n>2048?(i[0]=224|(61440&n)>>>12,i[1]=128|(4032&n)>>>6,i[2]=128|63&n):n>128?(i[0]=192|(1984&n)>>>6,i[1]=128|63&n):i[0]=n,this.parsedData.push(i)}this.parsedData=Array.prototype.concat.apply([],this.parsedData),this.parsedData.length!=this.data.length&&(this.parsedData.unshift(191),this.parsedData.unshift(187),this.parsedData.unshift(239))}function e(t,e){this.typeNumber=t,this.errorCorrectLevel=e,this.modules=null,this.moduleCount=0,this.dataCache=null,this.dataList=[]}t.prototype={getLength:function(t){return this.parsedData.length},write:function(t){for(var e=0,r=this.parsedData.length;e<r;e++)t.put(this.parsedData[e],8)}},e.prototype={addData:function(e){var r=new t(e);this.dataList.push(r),this.dataCache=null},isDark:function(t,e){if(t<0||this.moduleCount<=t||e<0||this.moduleCount<=e)throw new Error(t+","+e);return this.modules[t][e]},getModuleCount:function(){return this.moduleCount},make:function(){this.makeImpl(!1,this.getBestMaskPattern())},makeImpl:function(t,r){this.moduleCount=4*this.typeNumber+17,this.modules=new Array(this.moduleCount);for(var o=0;o<this.moduleCount;o++){this.modules[o]=new Array(this.moduleCount);for(var i=0;i<this.moduleCount;i++)this.modules[o][i]=null}this.setupPositionProbePattern(0,0),this.setupPositionProbePattern(this.moduleCount-7,0),this.setupPositionProbePattern(0,this.moduleCount-7),this.setupPositionAdjustPattern(),this.setupTimingPattern(),this.setupTypeInfo(t,r),this.typeNumber>=7&&this.setupTypeNumber(t),null==this.dataCache&&(this.dataCache=e.createData(this.typeNumber,this.errorCorrectLevel,this.dataList)),this.mapData(this.dataCache,r)},setupPositionProbePattern:function(t,e){for(var r=-1;r<=7;r++)if(!(t+r<=-1||this.moduleCount<=t+r))for(var o=-1;o<=7;o++)e+o<=-1||this.moduleCount<=e+o||(this.modules[t+r][e+o]=0<=r&&r<=6&&(0==o||6==o)||0<=o&&o<=6&&(0==r||6==r)||2<=r&&r<=4&&2<=o&&o<=4)},getBestMaskPattern:function(){for(var t=0,e=0,r=0;r<8;r++){this.makeImpl(!0,r);var o=g.getLostPoint(this);(0==r||t>o)&&(t=o,e=r)}return e},createMovieClip:function(t,e,r){var o=t.createEmptyMovieClip(e,r);this.make();for(var i=0;i<this.modules.length;i++)for(var n=1*i,a=0;a<this.modules[i].length;a++){var s=1*a;this.modules[i][a]&&(o.beginFill(0,100),o.moveTo(s,n),o.lineTo(s+1,n),o.lineTo(s+1,n+1),o.lineTo(s,n+1),o.endFill())}return o},setupTimingPattern:function(){for(var t=8;t<this.moduleCount-8;t++)null==this.modules[t][6]&&(this.modules[t][6]=t%2==0);for(var e=8;e<this.moduleCount-8;e++)null==this.modules[6][e]&&(this.modules[6][e]=e%2==0)},setupPositionAdjustPattern:function(){for(var t=g.getPatternPosition(this.typeNumber),e=0;e<t.length;e++)for(var r=0;r<t.length;r++){var o=t[e],i=t[r];if(null==this.modules[o][i])for(var n=-2;n<=2;n++)for(var a=-2;a<=2;a++)this.modules[o+n][i+a]=-2==n||2==n||-2==a||2==a||0==n&&0==a}},setupTypeNumber:function(t){for(var e=g.getBCHTypeNumber(this.typeNumber),r=0;r<18;r++){var o=!t&&1==(e>>r&1);this.modules[Math.floor(r/3)][r%3+this.moduleCount-8-3]=o}for(r=0;r<18;r++){o=!t&&1==(e>>r&1);this.modules[r%3+this.moduleCount-8-3][Math.floor(r/3)]=o}},setupTypeInfo:function(t,e){for(var r=this.errorCorrectLevel<<3|e,o=g.getBCHTypeInfo(r),i=0;i<15;i++){var n=!t&&1==(o>>i&1);i<6?this.modules[i][8]=n:i<8?this.modules[i+1][8]=n:this.modules[this.moduleCount-15+i][8]=n}for(i=0;i<15;i++){n=!t&&1==(o>>i&1);i<8?this.modules[8][this.moduleCount-i-1]=n:i<9?this.modules[8][15-i-1+1]=n:this.modules[8][15-i-1]=n}this.modules[this.moduleCount-8][8]=!t},mapData:function(t,e){for(var r=-1,o=this.moduleCount-1,i=7,n=0,a=this.moduleCount-1;a>0;a-=2)for(6==a&&a--;;){for(var s=0;s<2;s++)if(null==this.modules[o][a-s]){var h=!1;n<t.length&&(h=1==(t[n]>>>i&1)),g.getMask(e,o,a-s)&&(h=!h),this.modules[o][a-s]=h,-1==--i&&(n++,i=7)}if((o+=r)<0||this.moduleCount<=o){o-=r,r=-r;break}}}},e.PAD0=236,e.PAD1=17,e.createData=function(t,r,o){for(var i=m.getRSBlocks(t,r),n=new _,a=0;a<o.length;a++){var s=o[a];n.put(s.mode,4),n.put(s.getLength(),g.getLengthInBits(s.mode,t)),s.write(n)}var h=0;for(a=0;a<i.length;a++)h+=i[a].dataCount;if(n.getLengthInBits()>8*h)throw new Error("code length overflow. ("+n.getLengthInBits()+">"+8*h+")");for(n.getLengthInBits()+4<=8*h&&n.put(0,4);n.getLengthInBits()%8!=0;)n.putBit(!1);for(;!(n.getLengthInBits()>=8*h||(n.put(e.PAD0,8),n.getLengthInBits()>=8*h));)n.put(e.PAD1,8);return e.createBytes(n,i)},e.createBytes=function(t,e){for(var r=0,o=0,i=0,n=new Array(e.length),a=new Array(e.length),s=0;s<e.length;s++){var h=e[s].dataCount,l=e[s].totalCount-h;o=Math.max(o,h),i=Math.max(i,l),n[s]=new Array(h);for(var u=0;u<n[s].length;u++)n[s][u]=255&t.buffer[u+r];r+=h;var f=g.getErrorCorrectPolynomial(l),d=new p(n[s],f.getLength()-1).mod(f);a[s]=new Array(f.getLength()-1);for(u=0;u<a[s].length;u++){var c=u+d.getLength()-a[s].length;a[s][u]=c>=0?d.get(c):0}}var m=0;for(u=0;u<e.length;u++)m+=e[u].totalCount;var _=new Array(m),v=0;for(u=0;u<o;u++)for(s=0;s<e.length;s++)u<n[s].length&&(_[v++]=n[s][u]);for(u=0;u<i;u++)for(s=0;s<e.length;s++)u<a[s].length&&(_[v++]=a[s][u]);return _};for(var r={MODE_NUMBER:1,MODE_ALPHA_NUM:2,MODE_8BIT_BYTE:4,MODE_KANJI:8},o={L:1,M:0,Q:3,H:2},i=0,n=1,a=2,s=3,h=4,l=5,u=6,f=7,g={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:1335,G18:7973,G15_MASK:21522,getBCHTypeInfo:function(t){for(var e=t<<10;g.getBCHDigit(e)-g.getBCHDigit(g.G15)>=0;)e^=g.G15<<g.getBCHDigit(e)-g.getBCHDigit(g.G15);return(t<<10|e)^g.G15_MASK},getBCHTypeNumber:function(t){for(var e=t<<12;g.getBCHDigit(e)-g.getBCHDigit(g.G18)>=0;)e^=g.G18<<g.getBCHDigit(e)-g.getBCHDigit(g.G18);return t<<12|e},getBCHDigit:function(t){for(var e=0;0!=t;)e++,t>>>=1;return e},getPatternPosition:function(t){return g.PATTERN_POSITION_TABLE[t-1]},getMask:function(t,e,r){switch(t){case i:return(e+r)%2==0;case n:return e%2==0;case a:return r%3==0;case s:return(e+r)%3==0;case h:return(Math.floor(e/2)+Math.floor(r/3))%2==0;case l:return e*r%2+e*r%3==0;case u:return(e*r%2+e*r%3)%2==0;case f:return(e*r%3+(e+r)%2)%2==0;default:throw new Error("bad maskPattern:"+t)}},getErrorCorrectPolynomial:function(t){for(var e=new p([1],0),r=0;r<t;r++)e=e.multiply(new p([1,d.gexp(r)],0));return e},getLengthInBits:function(t,e){if(1<=e&&e<10)switch(t){case r.MODE_NUMBER:return 10;case r.MODE_ALPHA_NUM:return 9;case r.MODE_8BIT_BYTE:case r.MODE_KANJI:return 8;default:throw new Error("mode:"+t)}else if(e<27)switch(t){case r.MODE_NUMBER:return 12;case r.MODE_ALPHA_NUM:return 11;case r.MODE_8BIT_BYTE:return 16;case r.MODE_KANJI:return 10;default:throw new Error("mode:"+t)}else{if(!(e<41))throw new Error("type:"+e);switch(t){case r.MODE_NUMBER:return 14;case r.MODE_ALPHA_NUM:return 13;case r.MODE_8BIT_BYTE:return 16;case r.MODE_KANJI:return 12;default:throw new Error("mode:"+t)}}},getLostPoint:function(t){for(var e=t.getModuleCount(),r=0,o=0;o<e;o++)for(var i=0;i<e;i++){for(var n=0,a=t.isDark(o,i),s=-1;s<=1;s++)if(!(o+s<0||e<=o+s))for(var h=-1;h<=1;h++)i+h<0||e<=i+h||0==s&&0==h||a==t.isDark(o+s,i+h)&&n++;n>5&&(r+=3+n-5)}for(o=0;o<e-1;o++)for(i=0;i<e-1;i++){var l=0;t.isDark(o,i)&&l++,t.isDark(o+1,i)&&l++,t.isDark(o,i+1)&&l++,t.isDark(o+1,i+1)&&l++,0!=l&&4!=l||(r+=3)}for(o=0;o<e;o++)for(i=0;i<e-6;i++)t.isDark(o,i)&&!t.isDark(o,i+1)&&t.isDark(o,i+2)&&t.isDark(o,i+3)&&t.isDark(o,i+4)&&!t.isDark(o,i+5)&&t.isDark(o,i+6)&&(r+=40);for(i=0;i<e;i++)for(o=0;o<e-6;o++)t.isDark(o,i)&&!t.isDark(o+1,i)&&t.isDark(o+2,i)&&t.isDark(o+3,i)&&t.isDark(o+4,i)&&!t.isDark(o+5,i)&&t.isDark(o+6,i)&&(r+=40);var u=0;for(i=0;i<e;i++)for(o=0;o<e;o++)t.isDark(o,i)&&u++;return r+=10*(Math.abs(100*u/e/e-50)/5)}},d={glog:function(t){if(t<1)throw new Error("glog("+t+")");return d.LOG_TABLE[t]},gexp:function(t){for(;t<0;)t+=255;for(;t>=256;)t-=255;return d.EXP_TABLE[t]},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)},c=0;c<8;c++)d.EXP_TABLE[c]=1<<c;for(c=8;c<256;c++)d.EXP_TABLE[c]=d.EXP_TABLE[c-4]^d.EXP_TABLE[c-5]^d.EXP_TABLE[c-6]^d.EXP_TABLE[c-8];for(c=0;c<255;c++)d.LOG_TABLE[d.EXP_TABLE[c]]=c;function p(t,e){if(void 0==t.length)throw new Error(t.length+"/"+e);for(var r=0;r<t.length&&0==t[r];)r++;this.num=new Array(t.length-r+e);for(var o=0;o<t.length-r;o++)this.num[o]=t[o+r]}function m(t,e){this.totalCount=t,this.dataCount=e}function _(){this.buffer=[],this.length=0}p.prototype={get:function(t){return this.num[t]},getLength:function(){return this.num.length},multiply:function(t){for(var e=new Array(this.getLength()+t.getLength()-1),r=0;r<this.getLength();r++)for(var o=0;o<t.getLength();o++)e[r+o]^=d.gexp(d.glog(this.get(r))+d.glog(t.get(o)));return new p(e,0)},mod:function(t){if(this.getLength()-t.getLength()<0)return this;for(var e=d.glog(this.get(0))-d.glog(t.get(0)),r=new Array(this.getLength()),o=0;o<this.getLength();o++)r[o]=this.get(o);for(o=0;o<t.getLength();o++)r[o]^=d.gexp(d.glog(t.get(o))+e);return new p(r,0).mod(t)}},m.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12,7,37,13],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]],m.getRSBlocks=function(t,e){var r=m.getRsBlockTable(t,e);if(void 0==r)throw new Error("bad rs block @ typeNumber:"+t+"/errorCorrectLevel:"+e);for(var o=r.length/3,i=[],n=0;n<o;n++)for(var a=r[3*n+0],s=r[3*n+1],h=r[3*n+2],l=0;l<a;l++)i.push(new m(s,h));return i},m.getRsBlockTable=function(t,e){switch(e){case o.L:return m.RS_BLOCK_TABLE[4*(t-1)+0];case o.M:return m.RS_BLOCK_TABLE[4*(t-1)+1];case o.Q:return m.RS_BLOCK_TABLE[4*(t-1)+2];case o.H:return m.RS_BLOCK_TABLE[4*(t-1)+3];default:return}},_.prototype={get:function(t){var e=Math.floor(t/8);return 1==(this.buffer[e]>>>7-t%8&1)},put:function(t,e){for(var r=0;r<e;r++)this.putBit(1==(t>>>e-r-1&1))},getLengthInBits:function(){return this.length},putBit:function(t){var e=Math.floor(this.length/8);this.buffer.length<=e&&this.buffer.push(0),t&&(this.buffer[e]|=128>>>this.length%8),this.length++}};var v=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];function C(){var t=!1,e=navigator.userAgent;if(/android/i.test(e)){t=!0;var r=e.toString().match(/android ([0-9]\.[0-9])/i);r&&r[1]&&(t=parseFloat(r[1]))}return t}var w=function(){var t=function(t,e){this._el=t,this._htOption=e};return t.prototype.draw=function(t){var e=this._htOption,r=this._el,o=t.getModuleCount();Math.floor(e.width/o),Math.floor(e.height/o);function i(t,e){var r=document.createElementNS("http://www.w3.org/2000/svg",t);for(var o in e)e.hasOwnProperty(o)&&r.setAttribute(o,e[o]);return r}this.clear();var n=i("svg",{viewBox:"0 0 "+String(o)+" "+String(o),width:"100%",height:"100%",fill:e.colorLight});n.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xlink","http://www.w3.org/1999/xlink"),r.appendChild(n),n.appendChild(i("rect",{fill:e.colorLight,width:"100%",height:"100%"})),n.appendChild(i("rect",{fill:e.colorDark,width:"1",height:"1",id:"template"}));for(var a=0;a<o;a++)for(var s=0;s<o;s++)if(t.isDark(a,s)){var h=i("use",{x:String(s),y:String(a)});h.setAttributeNS("http://www.w3.org/1999/xlink","href","#template"),n.appendChild(h)}},t.prototype.clear=function(){for(;this._el.hasChildNodes();)this._el.removeChild(this._el.lastChild)},t}(),D="svg"===document.documentElement.tagName.toLowerCase()?w:"undefined"==typeof CanvasRenderingContext2D?function(){var t=function(t,e){this._el=t,this._htOption=e};return t.prototype.draw=function(t){for(var e=this._htOption,r=this._el,o=t.getModuleCount(),i=Math.floor(e.width/o),n=Math.floor(e.height/o),a=['<table style="border:0;border-collapse:collapse;">'],s=0;s<o;s++){a.push("<tr>");for(var h=0;h<o;h++)a.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:'+i+"px;height:"+n+"px;background-color:"+(t.isDark(s,h)?e.colorDark:e.colorLight)+';"></td>');a.push("</tr>")}a.push("</table>"),r.innerHTML=a.join("");var l=r.childNodes[0],u=(e.width-l.offsetWidth)/2,f=(e.height-l.offsetHeight)/2;u>0&&f>0&&(l.style.margin=f+"px "+u+"px")},t.prototype.clear=function(){this._el.innerHTML=""},t}():function(){function t(){this._elImage.src=this._elCanvas.toDataURL("image/png"),this._elImage.style.display="block",this._elCanvas.style.display="none"}if(this._android&&this._android<=2.1){var e=1/window.devicePixelRatio,r=CanvasRenderingContext2D.prototype.drawImage;CanvasRenderingContext2D.prototype.drawImage=function(t,o,i,n,a,s,h,l,u){if("nodeName"in t&&/img/i.test(t.nodeName))for(var f=arguments.length-1;f>=1;f--)arguments[f]=arguments[f]*e;else void 0===l&&(arguments[1]*=e,arguments[2]*=e,arguments[3]*=e,arguments[4]*=e);r.apply(this,arguments)}}var o=function(t,e){this._bIsPainted=!1,this._android=C(),this._htOption=e,this._elCanvas=document.createElement("canvas"),this._elCanvas.width=e.width,this._elCanvas.height=e.height,t.appendChild(this._elCanvas),this._el=t,this._oContext=this._elCanvas.getContext("2d"),this._bIsPainted=!1,this._elImage=document.createElement("img"),this._elImage.alt="Scan me!",this._elImage.style.display="none",this._el.appendChild(this._elImage),this._bSupportDataURI=null};return o.prototype.draw=function(t){var e=this._elImage,r=this._oContext,o=this._htOption,i=t.getModuleCount(),n=o.width/i,a=o.height/i,s=Math.round(n),h=Math.round(a);e.style.display="none",this.clear();for(var l=0;l<i;l++)for(var u=0;u<i;u++){var f=t.isDark(l,u),g=u*n,d=l*a;r.strokeStyle=f?o.colorDark:o.colorLight,r.lineWidth=1,r.fillStyle=f?o.colorDark:o.colorLight,r.fillRect(g,d,n,a),r.strokeRect(Math.floor(g)+.5,Math.floor(d)+.5,s,h),r.strokeRect(Math.ceil(g)-.5,Math.ceil(d)-.5,s,h)}this._bIsPainted=!0},o.prototype.makeImage=function(){this._bIsPainted&&function(t,e){var r=this;if(r._fFail=e,r._fSuccess=t,null===r._bSupportDataURI){var o=document.createElement("img"),i=function(){r._bSupportDataURI=!1,r._fFail&&r._fFail.call(r)};return o.onabort=i,o.onerror=i,o.onload=function(){r._bSupportDataURI=!0,r._fSuccess&&r._fSuccess.call(r)},void(o.src="data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==")}!0===r._bSupportDataURI&&r._fSuccess?r._fSuccess.call(r):!1===r._bSupportDataURI&&r._fFail&&r._fFail.call(r)}.call(this,t)},o.prototype.isPainted=function(){return this._bIsPainted},o.prototype.clear=function(){this._oContext.clearRect(0,0,this._elCanvas.width,this._elCanvas.height),this._bIsPainted=!1},o.prototype.round=function(t){return t?Math.floor(1e3*t)/1e3:t},o}();function A(t,e){for(var r=1,i=function(t){var e=encodeURI(t).toString().replace(/\%[0-9a-fA-F]{2}/g,"a");return e.length+(e.length!=t?3:0)}(t),n=0,a=v.length;n<=a;n++){var s=0;switch(e){case o.L:s=v[n][0];break;case o.M:s=v[n][1];break;case o.Q:s=v[n][2];break;case o.H:s=v[n][3]}if(i<=s)break;r++}if(r>v.length)throw new Error("Too long data");return r}(QRCode=function(t,e){if(this._htOption={width:256,height:256,typeNumber:4,colorDark:"#000000",colorLight:"#ffffff",correctLevel:o.H},"string"==typeof e&&(e={text:e}),e)for(var r in e)this._htOption[r]=e[r];"string"==typeof t&&(t=document.getElementById(t)),this._htOption.useSVG&&(D=w),this._android=C(),this._el=t,this._oQRCode=null,this._oDrawing=new D(this._el,this._htOption),this._htOption.text&&this.makeCode(this._htOption.text)}).prototype.makeCode=function(t){this._oQRCode=new e(A(t,this._htOption.correctLevel),this._htOption.correctLevel),this._oQRCode.addData(t),this._oQRCode.make(),this._el.title=t,this._oDrawing.draw(this._oQRCode),this.makeImage()},QRCode.prototype.makeImage=function(){"function"==typeof this._oDrawing.makeImage&&(!this._android||this._android>=3)&&this._oDrawing.makeImage()},QRCode.prototype.clear=function(){this._oDrawing.clear()},QRCode.CorrectLevel=o}(),"undefined"!=typeof module&&(module.exports=QRCode);
